webpackJsonp([35783957827783],{

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Autolinker.js
	 * 0.28.1
	 *
	 * Copyright(c) 2016 Gregory Jacobs <greg@greg-jacobs.com>
	 * MIT License
	 *
	 * https://github.com/gregjacobs/Autolinker.js
	 */
	;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.Autolinker = factory();
	  }
	}(this, function() {
	/**
	 * @class Autolinker
	 * @extends Object
	 *
	 * Utility class used to process a given string of text, and wrap the matches in
	 * the appropriate anchor (&lt;a&gt;) tags to turn them into links.
	 *
	 * Any of the configuration options may be provided in an Object (map) provided
	 * to the Autolinker constructor, which will configure how the {@link #link link()}
	 * method will process the links.
	 *
	 * For example:
	 *
	 *     var autolinker = new Autolinker( {
	 *         newWindow : false,
	 *         truncate  : 30
	 *     } );
	 *
	 *     var html = autolinker.link( "Joe went to www.yahoo.com" );
	 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
	 *
	 *
	 * The {@link #static-link static link()} method may also be used to inline
	 * options into a single call, which may be more convenient for one-off uses.
	 * For example:
	 *
	 *     var html = Autolinker.link( "Joe went to www.yahoo.com", {
	 *         newWindow : false,
	 *         truncate  : 30
	 *     } );
	 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
	 *
	 *
	 * ## Custom Replacements of Links
	 *
	 * If the configuration options do not provide enough flexibility, a {@link #replaceFn}
	 * may be provided to fully customize the output of Autolinker. This function is
	 * called once for each URL/Email/Phone#/Twitter Handle/Hashtag match that is
	 * encountered.
	 *
	 * For example:
	 *
	 *     var input = "...";  // string with URLs, Email Addresses, Phone #s, Twitter Handles, and Hashtags
	 *
	 *     var linkedText = Autolinker.link( input, {
	 *         replaceFn : function( autolinker, match ) {
	 *             console.log( "href = ", match.getAnchorHref() );
	 *             console.log( "text = ", match.getAnchorText() );
	 *
	 *             switch( match.getType() ) {
	 *                 case 'url' :
	 *                     console.log( "url: ", match.getUrl() );
	 *
	 *                     if( match.getUrl().indexOf( 'mysite.com' ) === -1 ) {
	 *                         var tag = autolinker.getTagBuilder().build( match );  // returns an `Autolinker.HtmlTag` instance, which provides mutator methods for easy changes
	 *                         tag.setAttr( 'rel', 'nofollow' );
	 *                         tag.addClass( 'external-link' );
	 *
	 *                         return tag;
	 *
	 *                     } else {
	 *                         return true;  // let Autolinker perform its normal anchor tag replacement
	 *                     }
	 *
	 *                 case 'email' :
	 *                     var email = match.getEmail();
	 *                     console.log( "email: ", email );
	 *
	 *                     if( email === "my@own.address" ) {
	 *                         return false;  // don't auto-link this particular email address; leave as-is
	 *                     } else {
	 *                         return;  // no return value will have Autolinker perform its normal anchor tag replacement (same as returning `true`)
	 *                     }
	 *
	 *                 case 'phone' :
	 *                     var phoneNumber = match.getPhoneNumber();
	 *                     console.log( phoneNumber );
	 *
	 *                     return '<a href="http://newplace.to.link.phone.numbers.to/">' + phoneNumber + '</a>';
	 *
	 *                 case 'twitter' :
	 *                     var twitterHandle = match.getTwitterHandle();
	 *                     console.log( twitterHandle );
	 *
	 *                     return '<a href="http://newplace.to.link.twitter.handles.to/">' + twitterHandle + '</a>';
	 *
	 *                 case 'hashtag' :
	 *                     var hashtag = match.getHashtag();
	 *                     console.log( hashtag );
	 *
	 *                     return '<a href="http://newplace.to.link.hashtag.handles.to/">' + hashtag + '</a>';
	 *             }
	 *         }
	 *     } );
	 *
	 *
	 * The function may return the following values:
	 *
	 * - `true` (Boolean): Allow Autolinker to replace the match as it normally
	 *   would.
	 * - `false` (Boolean): Do not replace the current match at all - leave as-is.
	 * - Any String: If a string is returned from the function, the string will be
	 *   used directly as the replacement HTML for the match.
	 * - An {@link Autolinker.HtmlTag} instance, which can be used to build/modify
	 *   an HTML tag before writing out its HTML text.
	 *
	 * @constructor
	 * @param {Object} [cfg] The configuration options for the Autolinker instance,
	 *   specified in an Object (map).
	 */
	var Autolinker = function( cfg ) {
		cfg = cfg || {};
	
		this.version = Autolinker.version;
	
		this.urls = this.normalizeUrlsCfg( cfg.urls );
		this.email = typeof cfg.email === 'boolean' ? cfg.email : true;
		this.twitter = typeof cfg.twitter === 'boolean' ? cfg.twitter : true;
		this.phone = typeof cfg.phone === 'boolean' ? cfg.phone : true;
		this.hashtag = cfg.hashtag || false;
		this.newWindow = typeof cfg.newWindow === 'boolean' ? cfg.newWindow : true;
		this.stripPrefix = typeof cfg.stripPrefix === 'boolean' ? cfg.stripPrefix : true;
	
		// Validate the value of the `hashtag` cfg.
		var hashtag = this.hashtag;
		if( hashtag !== false && hashtag !== 'twitter' && hashtag !== 'facebook' && hashtag !== 'instagram' ) {
			throw new Error( "invalid `hashtag` cfg - see docs" );
		}
	
		this.truncate = this.normalizeTruncateCfg( cfg.truncate );
		this.className = cfg.className || '';
		this.replaceFn = cfg.replaceFn || null;
	
		this.htmlParser = null;
		this.matchers = null;
		this.tagBuilder = null;
	};
	
	
	
	/**
	 * Automatically links URLs, Email addresses, Phone Numbers, Twitter handles,
	 * and Hashtags found in the given chunk of HTML. Does not link URLs found
	 * within HTML tags.
	 *
	 * For instance, if given the text: `You should go to http://www.yahoo.com`,
	 * then the result will be `You should go to &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
	 *
	 * Example:
	 *
	 *     var linkedText = Autolinker.link( "Go to google.com", { newWindow: false } );
	 *     // Produces: "Go to <a href="http://google.com">google.com</a>"
	 *
	 * @static
	 * @param {String} textOrHtml The HTML or text to find matches within (depending
	 *   on if the {@link #urls}, {@link #email}, {@link #phone}, {@link #twitter},
	 *   and {@link #hashtag} options are enabled).
	 * @param {Object} [options] Any of the configuration options for the Autolinker
	 *   class, specified in an Object (map). See the class description for an
	 *   example call.
	 * @return {String} The HTML text, with matches automatically linked.
	 */
	Autolinker.link = function( textOrHtml, options ) {
		var autolinker = new Autolinker( options );
		return autolinker.link( textOrHtml );
	};
	
	
	/**
	 * @static
	 * @property {String} version (readonly)
	 *
	 * The Autolinker version number in the form major.minor.patch
	 *
	 * Ex: 0.25.1
	 */
	Autolinker.version = '0.28.1';
	
	
	Autolinker.prototype = {
		constructor : Autolinker,  // fix constructor property
	
		/**
		 * @cfg {Boolean/Object} [urls=true]
		 *
		 * `true` if URLs should be automatically linked, `false` if they should not
		 * be.
		 *
		 * This option also accepts an Object form with 3 properties, to allow for
		 * more customization of what exactly gets linked. All default to `true`:
		 *
		 * @param {Boolean} schemeMatches `true` to match URLs found prefixed with a
		 *   scheme, i.e. `http://google.com`, or `other+scheme://google.com`,
		 *   `false` to prevent these types of matches.
		 * @param {Boolean} wwwMatches `true` to match urls found prefixed with
		 *   `'www.'`, i.e. `www.google.com`. `false` to prevent these types of
		 *   matches. Note that if the URL had a prefixed scheme, and
		 *   `schemeMatches` is true, it will still be linked.
		 * @param {Boolean} tldMatches `true` to match URLs with known top level
		 *   domains (.com, .net, etc.) that are not prefixed with a scheme or
		 *   `'www.'`. This option attempts to match anything that looks like a URL
		 *   in the given text. Ex: `google.com`, `asdf.org/?page=1`, etc. `false`
		 *   to prevent these types of matches.
		 */
	
		/**
		 * @cfg {Boolean} [email=true]
		 *
		 * `true` if email addresses should be automatically linked, `false` if they
		 * should not be.
		 */
	
		/**
		 * @cfg {Boolean} [twitter=true]
		 *
		 * `true` if Twitter handles ("@example") should be automatically linked,
		 * `false` if they should not be.
		 */
	
		/**
		 * @cfg {Boolean} [phone=true]
		 *
		 * `true` if Phone numbers ("(555)555-5555") should be automatically linked,
		 * `false` if they should not be.
		 */
	
		/**
		 * @cfg {Boolean/String} [hashtag=false]
		 *
		 * A string for the service name to have hashtags (ex: "#myHashtag")
		 * auto-linked to. The currently-supported values are:
		 *
		 * - 'twitter'
		 * - 'facebook'
		 * - 'instagram'
		 *
		 * Pass `false` to skip auto-linking of hashtags.
		 */
	
		/**
		 * @cfg {Boolean} [newWindow=true]
		 *
		 * `true` if the links should open in a new window, `false` otherwise.
		 */
	
		/**
		 * @cfg {Boolean} [stripPrefix=true]
		 *
		 * `true` if 'http://' or 'https://' and/or the 'www.' should be stripped
		 * from the beginning of URL links' text, `false` otherwise.
		 */
	
		/**
		 * @cfg {Number/Object} [truncate=0]
		 *
		 * ## Number Form
		 *
		 * A number for how many characters matched text should be truncated to
		 * inside the text of a link. If the matched text is over this number of
		 * characters, it will be truncated to this length by adding a two period
		 * ellipsis ('..') to the end of the string.
		 *
		 * For example: A url like 'http://www.yahoo.com/some/long/path/to/a/file'
		 * truncated to 25 characters might look something like this:
		 * 'yahoo.com/some/long/pat..'
		 *
		 * Example Usage:
		 *
		 *     truncate: 25
		 *
		 *
		 *  Defaults to `0` for "no truncation."
		 *
		 *
		 * ## Object Form
		 *
		 * An Object may also be provided with two properties: `length` (Number) and
		 * `location` (String). `location` may be one of the following: 'end'
		 * (default), 'middle', or 'smart'.
		 *
		 * Example Usage:
		 *
		 *     truncate: { length: 25, location: 'middle' }
		 *
		 * @cfg {Number} [truncate.length=0] How many characters to allow before
		 *   truncation will occur. Defaults to `0` for "no truncation."
		 * @cfg {"end"/"middle"/"smart"} [truncate.location="end"]
		 *
		 * - 'end' (default): will truncate up to the number of characters, and then
		 *   add an ellipsis at the end. Ex: 'yahoo.com/some/long/pat..'
		 * - 'middle': will truncate and add the ellipsis in the middle. Ex:
		 *   'yahoo.com/s..th/to/a/file'
		 * - 'smart': for URLs where the algorithm attempts to strip out unnecessary
		 *   parts first (such as the 'www.', then URL scheme, hash, etc.),
		 *   attempting to make the URL human-readable before looking for a good
		 *   point to insert the ellipsis if it is still too long. Ex:
		 *   'yahoo.com/some..to/a/file'. For more details, see
		 *   {@link Autolinker.truncate.TruncateSmart}.
		 */
	
		/**
		 * @cfg {String} className
		 *
		 * A CSS class name to add to the generated links. This class will be added
		 * to all links, as well as this class plus match suffixes for styling
		 * url/email/phone/twitter/hashtag links differently.
		 *
		 * For example, if this config is provided as "myLink", then:
		 *
		 * - URL links will have the CSS classes: "myLink myLink-url"
		 * - Email links will have the CSS classes: "myLink myLink-email", and
		 * - Twitter links will have the CSS classes: "myLink myLink-twitter"
		 * - Phone links will have the CSS classes: "myLink myLink-phone"
		 * - Hashtag links will have the CSS classes: "myLink myLink-hashtag"
		 */
	
		/**
		 * @cfg {Function} replaceFn
		 *
		 * A function to individually process each match found in the input string.
		 *
		 * See the class's description for usage.
		 *
		 * This function is called with the following parameters:
		 *
		 * @cfg {Autolinker} replaceFn.autolinker The Autolinker instance, which may
		 *   be used to retrieve child objects from (such as the instance's
		 *   {@link #getTagBuilder tag builder}).
		 * @cfg {Autolinker.match.Match} replaceFn.match The Match instance which
		 *   can be used to retrieve information about the match that the `replaceFn`
		 *   is currently processing. See {@link Autolinker.match.Match} subclasses
		 *   for details.
		 */
	
	
		/**
		 * @property {String} version (readonly)
		 *
		 * The Autolinker version number in the form major.minor.patch
		 *
		 * Ex: 0.25.1
		 */
	
		/**
		 * @private
		 * @property {Autolinker.htmlParser.HtmlParser} htmlParser
		 *
		 * The HtmlParser instance used to skip over HTML tags, while finding text
		 * nodes to process. This is lazily instantiated in the {@link #getHtmlParser}
		 * method.
		 */
	
		/**
		 * @private
		 * @property {Autolinker.matcher.Matcher[]} matchers
		 *
		 * The {@link Autolinker.matcher.Matcher} instances for this Autolinker
		 * instance.
		 *
		 * This is lazily created in {@link #getMatchers}.
		 */
	
		/**
		 * @private
		 * @property {Autolinker.AnchorTagBuilder} tagBuilder
		 *
		 * The AnchorTagBuilder instance used to build match replacement anchor tags.
		 * Note: this is lazily instantiated in the {@link #getTagBuilder} method.
		 */
	
	
		/**
		 * Normalizes the {@link #urls} config into an Object with 3 properties:
		 * `schemeMatches`, `wwwMatches`, and `tldMatches`, all Booleans.
		 *
		 * See {@link #urls} config for details.
		 *
		 * @private
		 * @param {Boolean/Object} urls
		 * @return {Object}
		 */
		normalizeUrlsCfg : function( urls ) {
			if( urls == null ) urls = true;  // default to `true`
	
			if( typeof urls === 'boolean' ) {
				return { schemeMatches: urls, wwwMatches: urls, tldMatches: urls };
	
			} else {  // object form
				return {
					schemeMatches : typeof urls.schemeMatches === 'boolean' ? urls.schemeMatches : true,
					wwwMatches    : typeof urls.wwwMatches === 'boolean'    ? urls.wwwMatches    : true,
					tldMatches    : typeof urls.tldMatches === 'boolean'    ? urls.tldMatches    : true
				};
			}
		},
	
	
		/**
		 * Normalizes the {@link #truncate} config into an Object with 2 properties:
		 * `length` (Number), and `location` (String).
		 *
		 * See {@link #truncate} config for details.
		 *
		 * @private
		 * @param {Number/Object} truncate
		 * @return {Object}
		 */
		normalizeTruncateCfg : function( truncate ) {
			if( typeof truncate === 'number' ) {
				return { length: truncate, location: 'end' };
	
			} else {  // object, or undefined/null
				return Autolinker.Util.defaults( truncate || {}, {
					length   : Number.POSITIVE_INFINITY,
					location : 'end'
				} );
			}
		},
	
	
		/**
		 * Parses the input `textOrHtml` looking for URLs, email addresses, phone
		 * numbers, username handles, and hashtags (depending on the configuration
		 * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
		 * objects describing those matches.
		 *
		 * This method is used by the {@link #link} method, but can also be used to
		 * simply do parsing of the input in order to discover what kinds of links
		 * there are and how many.
		 *
		 * @param {String} textOrHtml The HTML or text to find matches within
		 *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
		 *   {@link #twitter}, and {@link #hashtag} options are enabled).
		 * @return {Autolinker.match.Match[]} The array of Matches found in the
		 *   given input `textOrHtml`.
		 */
		parse : function( textOrHtml ) {
			var htmlParser = this.getHtmlParser(),
			    htmlNodes = htmlParser.parse( textOrHtml ),
			    anchorTagStackCount = 0,  // used to only process text around anchor tags, and any inner text/html they may have;
			    matches = [];
	
			// Find all matches within the `textOrHtml` (but not matches that are
			// already nested within <a> tags)
			for( var i = 0, len = htmlNodes.length; i < len; i++ ) {
				var node = htmlNodes[ i ],
				    nodeType = node.getType();
	
				if( nodeType === 'element' && node.getTagName() === 'a' ) {  // Process HTML anchor element nodes in the input `textOrHtml` to find out when we're within an <a> tag
					if( !node.isClosing() ) {  // it's the start <a> tag
						anchorTagStackCount++;
					} else {  // it's the end </a> tag
						anchorTagStackCount = Math.max( anchorTagStackCount - 1, 0 );  // attempt to handle extraneous </a> tags by making sure the stack count never goes below 0
					}
	
				} else if( nodeType === 'text' && anchorTagStackCount === 0 ) {  // Process text nodes that are not within an <a> tag
					var textNodeMatches = this.parseText( node.getText(), node.getOffset() );
	
					matches.push.apply( matches, textNodeMatches );
				}
			}
	
	
			// After we have found all matches, remove subsequent matches that
			// overlap with a previous match. This can happen for instance with URLs,
			// where the url 'google.com/#link' would match '#link' as a hashtag.
			matches = this.compactMatches( matches );
	
			// And finally, remove matches for match types that have been turned
			// off. We needed to have all match types turned on initially so that
			// things like hashtags could be filtered out if they were really just
			// part of a URL match (for instance, as a named anchor).
			matches = this.removeUnwantedMatches( matches );
	
			return matches;
		},
	
	
		/**
		 * After we have found all matches, we need to remove subsequent matches
		 * that overlap with a previous match. This can happen for instance with
		 * URLs, where the url 'google.com/#link' would match '#link' as a hashtag.
		 *
		 * @private
		 * @param {Autolinker.match.Match[]} matches
		 * @return {Autolinker.match.Match[]}
		 */
		compactMatches : function( matches ) {
			// First, the matches need to be sorted in order of offset
			matches.sort( function( a, b ) { return a.getOffset() - b.getOffset(); } );
	
			for( var i = 0; i < matches.length - 1; i++ ) {
				var match = matches[ i ],
				    endIdx = match.getOffset() + match.getMatchedText().length;
	
				// Remove subsequent matches that overlap with the current match
				while( i + 1 < matches.length && matches[ i + 1 ].getOffset() <= endIdx ) {
					matches.splice( i + 1, 1 );
				}
			}
	
			return matches;
		},
	
	
		/**
		 * Removes matches for matchers that were turned off in the options. For
		 * example, if {@link #hashtag hashtags} were not to be matched, we'll
		 * remove them from the `matches` array here.
		 *
		 * @private
		 * @param {Autolinker.match.Match[]} matches The array of matches to remove
		 *   the unwanted matches from. Note: this array is mutated for the
		 *   removals.
		 * @return {Autolinker.match.Match[]} The mutated input `matches` array.
		 */
		removeUnwantedMatches : function( matches ) {
			var remove = Autolinker.Util.remove;
	
			if( !this.hashtag ) remove( matches, function( match ) { return match.getType() === 'hashtag'; } );
			if( !this.email )   remove( matches, function( match ) { return match.getType() === 'email'; } );
			if( !this.phone )   remove( matches, function( match ) { return match.getType() === 'phone'; } );
			if( !this.twitter ) remove( matches, function( match ) { return match.getType() === 'twitter'; } );
			if( !this.urls.schemeMatches ) {
				remove( matches, function( m ) { return m.getType() === 'url' && m.getUrlMatchType() === 'scheme'; } );
			}
			if( !this.urls.wwwMatches ) {
				remove( matches, function( m ) { return m.getType() === 'url' && m.getUrlMatchType() === 'www'; } );
			}
			if( !this.urls.tldMatches ) {
				remove( matches, function( m ) { return m.getType() === 'url' && m.getUrlMatchType() === 'tld'; } );
			}
	
			return matches;
		},
	
	
		/**
		 * Parses the input `text` looking for URLs, email addresses, phone
		 * numbers, username handles, and hashtags (depending on the configuration
		 * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
		 * objects describing those matches.
		 *
		 * This method processes a **non-HTML string**, and is used to parse and
		 * match within the text nodes of an HTML string. This method is used
		 * internally by {@link #parse}.
		 *
		 * @private
		 * @param {String} text The text to find matches within (depending on if the
		 *   {@link #urls}, {@link #email}, {@link #phone}, {@link #twitter}, and
		 *   {@link #hashtag} options are enabled). This must be a non-HTML string.
		 * @param {Number} [offset=0] The offset of the text node within the
		 *   original string. This is used when parsing with the {@link #parse}
		 *   method to generate correct offsets within the {@link Autolinker.match.Match}
		 *   instances, but may be omitted if calling this method publicly.
		 * @return {Autolinker.match.Match[]} The array of Matches found in the
		 *   given input `text`.
		 */
		parseText : function( text, offset ) {
			offset = offset || 0;
			var matchers = this.getMatchers(),
			    matches = [];
	
			for( var i = 0, numMatchers = matchers.length; i < numMatchers; i++ ) {
				var textMatches = matchers[ i ].parseMatches( text );
	
				// Correct the offset of each of the matches. They are originally
				// the offset of the match within the provided text node, but we
				// need to correct them to be relative to the original HTML input
				// string (i.e. the one provided to #parse).
				for( var j = 0, numTextMatches = textMatches.length; j < numTextMatches; j++ ) {
					textMatches[ j ].setOffset( offset + textMatches[ j ].getOffset() );
				}
	
				matches.push.apply( matches, textMatches );
			}
			return matches;
		},
	
	
		/**
		 * Automatically links URLs, Email addresses, Phone numbers, Twitter
		 * handles, and Hashtags found in the given chunk of HTML. Does not link
		 * URLs found within HTML tags.
		 *
		 * For instance, if given the text: `You should go to http://www.yahoo.com`,
		 * then the result will be `You should go to
		 * &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
		 *
		 * This method finds the text around any HTML elements in the input
		 * `textOrHtml`, which will be the text that is processed. Any original HTML
		 * elements will be left as-is, as well as the text that is already wrapped
		 * in anchor (&lt;a&gt;) tags.
		 *
		 * @param {String} textOrHtml The HTML or text to autolink matches within
		 *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
		 *   {@link #twitter}, and {@link #hashtag} options are enabled).
		 * @return {String} The HTML, with matches automatically linked.
		 */
		link : function( textOrHtml ) {
			if( !textOrHtml ) { return ""; }  // handle `null` and `undefined`
	
			var matches = this.parse( textOrHtml ),
				newHtml = [],
				lastIndex = 0;
	
			for( var i = 0, len = matches.length; i < len; i++ ) {
				var match = matches[ i ];
	
				newHtml.push( textOrHtml.substring( lastIndex, match.getOffset() ) );
				newHtml.push( this.createMatchReturnVal( match ) );
	
				lastIndex = match.getOffset() + match.getMatchedText().length;
			}
			newHtml.push( textOrHtml.substring( lastIndex ) );  // handle the text after the last match
	
			return newHtml.join( '' );
		},
	
	
		/**
		 * Creates the return string value for a given match in the input string.
		 *
		 * This method handles the {@link #replaceFn}, if one was provided.
		 *
		 * @private
		 * @param {Autolinker.match.Match} match The Match object that represents
		 *   the match.
		 * @return {String} The string that the `match` should be replaced with.
		 *   This is usually the anchor tag string, but may be the `matchStr` itself
		 *   if the match is not to be replaced.
		 */
		createMatchReturnVal : function( match ) {
			// Handle a custom `replaceFn` being provided
			var replaceFnResult;
			if( this.replaceFn ) {
				replaceFnResult = this.replaceFn.call( this, this, match );  // Autolinker instance is the context, and the first arg
			}
	
			if( typeof replaceFnResult === 'string' ) {
				return replaceFnResult;  // `replaceFn` returned a string, use that
	
			} else if( replaceFnResult === false ) {
				return match.getMatchedText();  // no replacement for the match
	
			} else if( replaceFnResult instanceof Autolinker.HtmlTag ) {
				return replaceFnResult.toAnchorString();
	
			} else {  // replaceFnResult === true, or no/unknown return value from function
				// Perform Autolinker's default anchor tag generation
				var anchorTag = match.buildTag();  // returns an Autolinker.HtmlTag instance
	
				return anchorTag.toAnchorString();
			}
		},
	
	
		/**
		 * Lazily instantiates and returns the {@link #htmlParser} instance for this
		 * Autolinker instance.
		 *
		 * @protected
		 * @return {Autolinker.htmlParser.HtmlParser}
		 */
		getHtmlParser : function() {
			var htmlParser = this.htmlParser;
	
			if( !htmlParser ) {
				htmlParser = this.htmlParser = new Autolinker.htmlParser.HtmlParser();
			}
	
			return htmlParser;
		},
	
	
		/**
		 * Lazily instantiates and returns the {@link Autolinker.matcher.Matcher}
		 * instances for this Autolinker instance.
		 *
		 * @protected
		 * @return {Autolinker.matcher.Matcher[]}
		 */
		getMatchers : function() {
			if( !this.matchers ) {
				var matchersNs = Autolinker.matcher,
				    tagBuilder = this.getTagBuilder();
	
				var matchers = [
					new matchersNs.Hashtag( { tagBuilder: tagBuilder, serviceName: this.hashtag } ),
					new matchersNs.Email( { tagBuilder: tagBuilder } ),
					new matchersNs.Phone( { tagBuilder: tagBuilder } ),
					new matchersNs.Twitter( { tagBuilder: tagBuilder } ),
					new matchersNs.Url( { tagBuilder: tagBuilder, stripPrefix: this.stripPrefix } )
				];
	
				return ( this.matchers = matchers );
	
			} else {
				return this.matchers;
			}
		},
	
	
		/**
		 * Returns the {@link #tagBuilder} instance for this Autolinker instance, lazily instantiating it
		 * if it does not yet exist.
		 *
		 * This method may be used in a {@link #replaceFn} to generate the {@link Autolinker.HtmlTag HtmlTag} instance that
		 * Autolinker would normally generate, and then allow for modifications before returning it. For example:
		 *
		 *     var html = Autolinker.link( "Test google.com", {
		 *         replaceFn : function( autolinker, match ) {
		 *             var tag = autolinker.getTagBuilder().build( match );  // returns an {@link Autolinker.HtmlTag} instance
		 *             tag.setAttr( 'rel', 'nofollow' );
		 *
		 *             return tag;
		 *         }
		 *     } );
		 *
		 *     // generated html:
		 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
		 *
		 * @return {Autolinker.AnchorTagBuilder}
		 */
		getTagBuilder : function() {
			var tagBuilder = this.tagBuilder;
	
			if( !tagBuilder ) {
				tagBuilder = this.tagBuilder = new Autolinker.AnchorTagBuilder( {
					newWindow   : this.newWindow,
					truncate    : this.truncate,
					className   : this.className
				} );
			}
	
			return tagBuilder;
		}
	
	};
	
	
	// Autolinker Namespaces
	
	Autolinker.match = {};
	Autolinker.matcher = {};
	Autolinker.htmlParser = {};
	Autolinker.truncate = {};
	
	/*global Autolinker */
	/*jshint eqnull:true, boss:true */
	/**
	 * @class Autolinker.Util
	 * @singleton
	 *
	 * A few utility methods for Autolinker.
	 */
	Autolinker.Util = {
	
		/**
		 * @property {Function} abstractMethod
		 *
		 * A function object which represents an abstract method.
		 */
		abstractMethod : function() { throw "abstract"; },
	
	
		/**
		 * @private
		 * @property {RegExp} trimRegex
		 *
		 * The regular expression used to trim the leading and trailing whitespace
		 * from a string.
		 */
		trimRegex : /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
	
		/**
		 * Assigns (shallow copies) the properties of `src` onto `dest`.
		 *
		 * @param {Object} dest The destination object.
		 * @param {Object} src The source object.
		 * @return {Object} The destination object (`dest`)
		 */
		assign : function( dest, src ) {
			for( var prop in src ) {
				if( src.hasOwnProperty( prop ) ) {
					dest[ prop ] = src[ prop ];
				}
			}
	
			return dest;
		},
	
	
		/**
		 * Assigns (shallow copies) the properties of `src` onto `dest`, if the
		 * corresponding property on `dest` === `undefined`.
		 *
		 * @param {Object} dest The destination object.
		 * @param {Object} src The source object.
		 * @return {Object} The destination object (`dest`)
		 */
		defaults : function( dest, src ) {
			for( var prop in src ) {
				if( src.hasOwnProperty( prop ) && dest[ prop ] === undefined ) {
					dest[ prop ] = src[ prop ];
				}
			}
	
			return dest;
		},
	
	
		/**
		 * Extends `superclass` to create a new subclass, adding the `protoProps` to the new subclass's prototype.
		 *
		 * @param {Function} superclass The constructor function for the superclass.
		 * @param {Object} protoProps The methods/properties to add to the subclass's prototype. This may contain the
		 *   special property `constructor`, which will be used as the new subclass's constructor function.
		 * @return {Function} The new subclass function.
		 */
		extend : function( superclass, protoProps ) {
			var superclassProto = superclass.prototype;
	
			var F = function() {};
			F.prototype = superclassProto;
	
			var subclass;
			if( protoProps.hasOwnProperty( 'constructor' ) ) {
				subclass = protoProps.constructor;
			} else {
				subclass = function() { superclassProto.constructor.apply( this, arguments ); };
			}
	
			var subclassProto = subclass.prototype = new F();  // set up prototype chain
			subclassProto.constructor = subclass;  // fix constructor property
			subclassProto.superclass = superclassProto;
	
			delete protoProps.constructor;  // don't re-assign constructor property to the prototype, since a new function may have been created (`subclass`), which is now already there
			Autolinker.Util.assign( subclassProto, protoProps );
	
			return subclass;
		},
	
	
		/**
		 * Truncates the `str` at `len - ellipsisChars.length`, and adds the `ellipsisChars` to the
		 * end of the string (by default, two periods: '..'). If the `str` length does not exceed
		 * `len`, the string will be returned unchanged.
		 *
		 * @param {String} str The string to truncate and add an ellipsis to.
		 * @param {Number} truncateLen The length to truncate the string at.
		 * @param {String} [ellipsisChars=..] The ellipsis character(s) to add to the end of `str`
		 *   when truncated. Defaults to '..'
		 */
		ellipsis : function( str, truncateLen, ellipsisChars ) {
			if( str.length > truncateLen ) {
				ellipsisChars = ( ellipsisChars == null ) ? '..' : ellipsisChars;
				str = str.substring( 0, truncateLen - ellipsisChars.length ) + ellipsisChars;
			}
			return str;
		},
	
	
		/**
		 * Supports `Array.prototype.indexOf()` functionality for old IE (IE8 and below).
		 *
		 * @param {Array} arr The array to find an element of.
		 * @param {*} element The element to find in the array, and return the index of.
		 * @return {Number} The index of the `element`, or -1 if it was not found.
		 */
		indexOf : function( arr, element ) {
			if( Array.prototype.indexOf ) {
				return arr.indexOf( element );
	
			} else {
				for( var i = 0, len = arr.length; i < len; i++ ) {
					if( arr[ i ] === element ) return i;
				}
				return -1;
			}
		},
	
	
		/**
		 * Removes array elements based on a filtering function. Mutates the input
		 * array.
		 *
		 * Using this instead of the ES5 Array.prototype.filter() function, to allow
		 * Autolinker compatibility with IE8, and also to prevent creating many new
		 * arrays in memory for filtering.
		 *
		 * @param {Array} arr The array to remove elements from. This array is
		 *   mutated.
		 * @param {Function} fn A function which should return `true` to
		 *   remove an element.
		 * @return {Array} The mutated input `arr`.
		 */
		remove : function( arr, fn ) {
			for( var i = arr.length - 1; i >= 0; i-- ) {
				if( fn( arr[ i ] ) === true ) {
					arr.splice( i, 1 );
				}
			}
		},
	
	
		/**
		 * Performs the functionality of what modern browsers do when `String.prototype.split()` is called
		 * with a regular expression that contains capturing parenthesis.
		 *
		 * For example:
		 *
		 *     // Modern browsers:
		 *     "a,b,c".split( /(,)/ );  // --> [ 'a', ',', 'b', ',', 'c' ]
		 *
		 *     // Old IE (including IE8):
		 *     "a,b,c".split( /(,)/ );  // --> [ 'a', 'b', 'c' ]
		 *
		 * This method emulates the functionality of modern browsers for the old IE case.
		 *
		 * @param {String} str The string to split.
		 * @param {RegExp} splitRegex The regular expression to split the input `str` on. The splitting
		 *   character(s) will be spliced into the array, as in the "modern browsers" example in the
		 *   description of this method.
		 *   Note #1: the supplied regular expression **must** have the 'g' flag specified.
		 *   Note #2: for simplicity's sake, the regular expression does not need
		 *   to contain capturing parenthesis - it will be assumed that any match has them.
		 * @return {String[]} The split array of strings, with the splitting character(s) included.
		 */
		splitAndCapture : function( str, splitRegex ) {
			if( !splitRegex.global ) throw new Error( "`splitRegex` must have the 'g' flag set" );
	
			var result = [],
			    lastIdx = 0,
			    match;
	
			while( match = splitRegex.exec( str ) ) {
				result.push( str.substring( lastIdx, match.index ) );
				result.push( match[ 0 ] );  // push the splitting char(s)
	
				lastIdx = match.index + match[ 0 ].length;
			}
			result.push( str.substring( lastIdx ) );
	
			return result;
		},
	
	
		/**
		 * Trims the leading and trailing whitespace from a string.
		 *
		 * @param {String} str The string to trim.
		 * @return {String}
		 */
		trim : function( str ) {
			return str.replace( this.trimRegex, '' );
		}
	
	};
	/*global Autolinker */
	/*jshint boss:true */
	/**
	 * @class Autolinker.HtmlTag
	 * @extends Object
	 *
	 * Represents an HTML tag, which can be used to easily build/modify HTML tags programmatically.
	 *
	 * Autolinker uses this abstraction to create HTML tags, and then write them out as strings. You may also use
	 * this class in your code, especially within a {@link Autolinker#replaceFn replaceFn}.
	 *
	 * ## Examples
	 *
	 * Example instantiation:
	 *
	 *     var tag = new Autolinker.HtmlTag( {
	 *         tagName : 'a',
	 *         attrs   : { 'href': 'http://google.com', 'class': 'external-link' },
	 *         innerHtml : 'Google'
	 *     } );
	 *
	 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
	 *
	 *     // Individual accessor methods
	 *     tag.getTagName();                 // 'a'
	 *     tag.getAttr( 'href' );            // 'http://google.com'
	 *     tag.hasClass( 'external-link' );  // true
	 *
	 *
	 * Using mutator methods (which may be used in combination with instantiation config properties):
	 *
	 *     var tag = new Autolinker.HtmlTag();
	 *     tag.setTagName( 'a' );
	 *     tag.setAttr( 'href', 'http://google.com' );
	 *     tag.addClass( 'external-link' );
	 *     tag.setInnerHtml( 'Google' );
	 *
	 *     tag.getTagName();                 // 'a'
	 *     tag.getAttr( 'href' );            // 'http://google.com'
	 *     tag.hasClass( 'external-link' );  // true
	 *
	 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
	 *
	 *
	 * ## Example use within a {@link Autolinker#replaceFn replaceFn}
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( autolinker, match ) {
	 *             var tag = match.buildTag();  // returns an {@link Autolinker.HtmlTag} instance, configured with the Match's href and anchor text
	 *             tag.setAttr( 'rel', 'nofollow' );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
	 *
	 *
	 * ## Example use with a new tag for the replacement
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( autolinker, match ) {
	 *             var tag = new Autolinker.HtmlTag( {
	 *                 tagName : 'button',
	 *                 attrs   : { 'title': 'Load URL: ' + match.getAnchorHref() },
	 *                 innerHtml : 'Load URL: ' + match.getAnchorText()
	 *             } );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <button title="Load URL: http://google.com">Load URL: google.com</button>
	 */
	Autolinker.HtmlTag = Autolinker.Util.extend( Object, {
	
		/**
		 * @cfg {String} tagName
		 *
		 * The tag name. Ex: 'a', 'button', etc.
		 *
		 * Not required at instantiation time, but should be set using {@link #setTagName} before {@link #toAnchorString}
		 * is executed.
		 */
	
		/**
		 * @cfg {Object.<String, String>} attrs
		 *
		 * An key/value Object (map) of attributes to create the tag with. The keys are the attribute names, and the
		 * values are the attribute values.
		 */
	
		/**
		 * @cfg {String} innerHtml
		 *
		 * The inner HTML for the tag.
		 *
		 * Note the camel case name on `innerHtml`. Acronyms are camelCased in this utility (such as not to run into the acronym
		 * naming inconsistency that the DOM developers created with `XMLHttpRequest`). You may alternatively use {@link #innerHTML}
		 * if you prefer, but this one is recommended.
		 */
	
		/**
		 * @cfg {String} innerHTML
		 *
		 * Alias of {@link #innerHtml}, accepted for consistency with the browser DOM api, but prefer the camelCased version
		 * for acronym names.
		 */
	
	
		/**
		 * @protected
		 * @property {RegExp} whitespaceRegex
		 *
		 * Regular expression used to match whitespace in a string of CSS classes.
		 */
		whitespaceRegex : /\s+/,
	
	
		/**
		 * @constructor
		 * @param {Object} [cfg] The configuration properties for this class, in an Object (map)
		 */
		constructor : function( cfg ) {
			Autolinker.Util.assign( this, cfg );
	
			this.innerHtml = this.innerHtml || this.innerHTML;  // accept either the camelCased form or the fully capitalized acronym
		},
	
	
		/**
		 * Sets the tag name that will be used to generate the tag with.
		 *
		 * @param {String} tagName
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setTagName : function( tagName ) {
			this.tagName = tagName;
			return this;
		},
	
	
		/**
		 * Retrieves the tag name.
		 *
		 * @return {String}
		 */
		getTagName : function() {
			return this.tagName || "";
		},
	
	
		/**
		 * Sets an attribute on the HtmlTag.
		 *
		 * @param {String} attrName The attribute name to set.
		 * @param {String} attrValue The attribute value to set.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setAttr : function( attrName, attrValue ) {
			var tagAttrs = this.getAttrs();
			tagAttrs[ attrName ] = attrValue;
	
			return this;
		},
	
	
		/**
		 * Retrieves an attribute from the HtmlTag. If the attribute does not exist, returns `undefined`.
		 *
		 * @param {String} attrName The attribute name to retrieve.
		 * @return {String} The attribute's value, or `undefined` if it does not exist on the HtmlTag.
		 */
		getAttr : function( attrName ) {
			return this.getAttrs()[ attrName ];
		},
	
	
		/**
		 * Sets one or more attributes on the HtmlTag.
		 *
		 * @param {Object.<String, String>} attrs A key/value Object (map) of the attributes to set.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setAttrs : function( attrs ) {
			var tagAttrs = this.getAttrs();
			Autolinker.Util.assign( tagAttrs, attrs );
	
			return this;
		},
	
	
		/**
		 * Retrieves the attributes Object (map) for the HtmlTag.
		 *
		 * @return {Object.<String, String>} A key/value object of the attributes for the HtmlTag.
		 */
		getAttrs : function() {
			return this.attrs || ( this.attrs = {} );
		},
	
	
		/**
		 * Sets the provided `cssClass`, overwriting any current CSS classes on the HtmlTag.
		 *
		 * @param {String} cssClass One or more space-separated CSS classes to set (overwrite).
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setClass : function( cssClass ) {
			return this.setAttr( 'class', cssClass );
		},
	
	
		/**
		 * Convenience method to add one or more CSS classes to the HtmlTag. Will not add duplicate CSS classes.
		 *
		 * @param {String} cssClass One or more space-separated CSS classes to add.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		addClass : function( cssClass ) {
			var classAttr = this.getClass(),
			    whitespaceRegex = this.whitespaceRegex,
			    indexOf = Autolinker.Util.indexOf,  // to support IE8 and below
			    classes = ( !classAttr ) ? [] : classAttr.split( whitespaceRegex ),
			    newClasses = cssClass.split( whitespaceRegex ),
			    newClass;
	
			while( newClass = newClasses.shift() ) {
				if( indexOf( classes, newClass ) === -1 ) {
					classes.push( newClass );
				}
			}
	
			this.getAttrs()[ 'class' ] = classes.join( " " );
			return this;
		},
	
	
		/**
		 * Convenience method to remove one or more CSS classes from the HtmlTag.
		 *
		 * @param {String} cssClass One or more space-separated CSS classes to remove.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		removeClass : function( cssClass ) {
			var classAttr = this.getClass(),
			    whitespaceRegex = this.whitespaceRegex,
			    indexOf = Autolinker.Util.indexOf,  // to support IE8 and below
			    classes = ( !classAttr ) ? [] : classAttr.split( whitespaceRegex ),
			    removeClasses = cssClass.split( whitespaceRegex ),
			    removeClass;
	
			while( classes.length && ( removeClass = removeClasses.shift() ) ) {
				var idx = indexOf( classes, removeClass );
				if( idx !== -1 ) {
					classes.splice( idx, 1 );
				}
			}
	
			this.getAttrs()[ 'class' ] = classes.join( " " );
			return this;
		},
	
	
		/**
		 * Convenience method to retrieve the CSS class(es) for the HtmlTag, which will each be separated by spaces when
		 * there are multiple.
		 *
		 * @return {String}
		 */
		getClass : function() {
			return this.getAttrs()[ 'class' ] || "";
		},
	
	
		/**
		 * Convenience method to check if the tag has a CSS class or not.
		 *
		 * @param {String} cssClass The CSS class to check for.
		 * @return {Boolean} `true` if the HtmlTag has the CSS class, `false` otherwise.
		 */
		hasClass : function( cssClass ) {
			return ( ' ' + this.getClass() + ' ' ).indexOf( ' ' + cssClass + ' ' ) !== -1;
		},
	
	
		/**
		 * Sets the inner HTML for the tag.
		 *
		 * @param {String} html The inner HTML to set.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setInnerHtml : function( html ) {
			this.innerHtml = html;
	
			return this;
		},
	
	
		/**
		 * Retrieves the inner HTML for the tag.
		 *
		 * @return {String}
		 */
		getInnerHtml : function() {
			return this.innerHtml || "";
		},
	
	
		/**
		 * Override of superclass method used to generate the HTML string for the tag.
		 *
		 * @return {String}
		 */
		toAnchorString : function() {
			var tagName = this.getTagName(),
			    attrsStr = this.buildAttrsStr();
	
			attrsStr = ( attrsStr ) ? ' ' + attrsStr : '';  // prepend a space if there are actually attributes
	
			return [ '<', tagName, attrsStr, '>', this.getInnerHtml(), '</', tagName, '>' ].join( "" );
		},
	
	
		/**
		 * Support method for {@link #toAnchorString}, returns the string space-separated key="value" pairs, used to populate
		 * the stringified HtmlTag.
		 *
		 * @protected
		 * @return {String} Example return: `attr1="value1" attr2="value2"`
		 */
		buildAttrsStr : function() {
			if( !this.attrs ) return "";  // no `attrs` Object (map) has been set, return empty string
	
			var attrs = this.getAttrs(),
			    attrsArr = [];
	
			for( var prop in attrs ) {
				if( attrs.hasOwnProperty( prop ) ) {
					attrsArr.push( prop + '="' + attrs[ prop ] + '"' );
				}
			}
			return attrsArr.join( " " );
		}
	
	} );
	
	/*global Autolinker */
	/**
	 * @class Autolinker.RegexLib
	 * @singleton
	 *
	 * Builds and stores a library of the common regular expressions used by the
	 * Autolinker utility.
	 *
	 * Other regular expressions may exist ad-hoc, but these are generally the
	 * regular expressions that are shared between source files.
	 */
	Autolinker.RegexLib = (function() {
	
		/**
		 * The string form of a regular expression that would match all of the
		 * alphabetic ("letter") chars in the unicode character set when placed in a
		 * RegExp character class (`[]`). This includes all international alphabetic
		 * characters.
		 *
		 * These would be the characters matched by unicode regex engines `\p{L}`
		 * escape ("all letters").
		 *
		 * Taken from the XRegExp library: http://xregexp.com/
		 * Specifically: http://xregexp.com/v/3.0.0/unicode-categories.js
		 *
		 * @private
		 * @type {String}
		 */
		var alphaCharsStr = 'A-Za-z\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC';
	
		/**
		 * The string form of a regular expression that would match all of the
		 * decimal number chars in the unicode character set when placed in a RegExp
		 * character class (`[]`).
		 *
		 * These would be the characters matched by unicode regex engines `\p{Nd}`
		 * escape ("all decimal numbers")
		 *
		 * Taken from the XRegExp library: http://xregexp.com/
		 * Specifically: http://xregexp.com/v/3.0.0/unicode-categories.js
		 *
		 * @private
		 * @type {String}
		 */
		var decimalNumbersStr = '0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19';
	
	
		// See documentation below
		var alphaNumericCharsStr = alphaCharsStr + decimalNumbersStr;
	
	
		// See documentation below
		var domainNameRegex = new RegExp( '[' + alphaNumericCharsStr + '.\\-]*[' + alphaNumericCharsStr + '\\-]' );
	
	
		// See documentation below
		var tldRegex = /(?:travelersinsurance|sandvikcoromant|kerryproperties|cancerresearch|weatherchannel|kerrylogistics|spreadbetting|international|wolterskluwer|lifeinsurance|construction|pamperedchef|scholarships|versicherung|bridgestone|creditunion|kerryhotels|investments|productions|blackfriday|enterprises|lamborghini|photography|motorcycles|williamhill|playstation|contractors|barclaycard|accountants|redumbrella|engineering|management|telefonica|protection|consulting|tatamotors|creditcard|vlaanderen|schaeffler|associates|properties|foundation|republican|bnpparibas|boehringer|eurovision|extraspace|industries|immobilien|university|technology|volkswagen|healthcare|restaurant|cuisinella|vistaprint|apartments|accountant|travelers|homedepot|institute|vacations|furniture|fresenius|insurance|christmas|bloomberg|solutions|barcelona|firestone|financial|kuokgroup|fairwinds|community|passagens|goldpoint|equipment|lifestyle|yodobashi|aquarelle|marketing|analytics|education|amsterdam|statefarm|melbourne|allfinanz|directory|microsoft|stockholm|montblanc|accenture|lancaster|landrover|everbank|istanbul|graphics|grainger|ipiranga|softbank|attorney|pharmacy|saarland|catering|airforce|yokohama|mortgage|frontier|mutuelle|stcgroup|memorial|pictures|football|symantec|cipriani|ventures|telecity|cityeats|verisign|flsmidth|boutique|cleaning|firmdale|clinique|clothing|redstone|infiniti|deloitte|feedback|services|broadway|plumbing|commbank|training|barclays|exchange|computer|brussels|software|delivery|barefoot|builders|business|bargains|engineer|holdings|download|security|helsinki|lighting|movistar|discount|hdfcbank|supplies|marriott|property|diamonds|capetown|partners|democrat|jpmorgan|bradesco|budapest|rexroth|zuerich|shriram|academy|science|support|youtube|singles|surgery|alibaba|statoil|dentist|schwarz|android|cruises|cricket|digital|markets|starhub|systems|courses|coupons|netbank|country|domains|corsica|network|neustar|realtor|lincoln|limited|schmidt|yamaxun|cooking|contact|auction|spiegel|liaison|leclerc|latrobe|lasalle|abogado|compare|lanxess|exposed|express|company|cologne|college|avianca|lacaixa|fashion|recipes|ferrero|komatsu|storage|wanggou|clubmed|sandvik|fishing|fitness|bauhaus|kitchen|flights|florist|flowers|watches|weather|temasek|samsung|bentley|forsale|channel|theater|frogans|theatre|okinawa|website|tickets|jewelry|gallery|tiffany|iselect|shiksha|brother|organic|wedding|genting|toshiba|origins|philips|hyundai|hotmail|hoteles|hosting|rentals|windows|cartier|bugatti|holiday|careers|whoswho|hitachi|panerai|caravan|reviews|guitars|capital|trading|hamburg|hangout|finance|stream|family|abbott|health|review|travel|report|hermes|hiphop|gratis|career|toyota|hockey|dating|repair|google|social|soccer|reisen|global|otsuka|giving|unicom|casino|photos|center|broker|rocher|orange|bostik|garden|insure|ryukyu|bharti|safety|physio|sakura|oracle|online|jaguar|gallup|piaget|tienda|futbol|pictet|joburg|webcam|berlin|office|juegos|kaufen|chanel|chrome|xihuan|church|tennis|circle|kinder|flickr|bayern|claims|clinic|viajes|nowruz|xperia|norton|yachts|studio|coffee|camera|sanofi|nissan|author|expert|events|comsec|lawyer|tattoo|viking|estate|villas|condos|realty|yandex|energy|emerck|virgin|vision|durban|living|school|coupon|london|taobao|natura|taipei|nagoya|luxury|walter|aramco|sydney|madrid|credit|maison|makeup|schule|market|anquan|direct|design|swatch|suzuki|alsace|vuelos|dental|alipay|voyage|shouji|voting|airtel|mutual|degree|supply|agency|museum|mobily|dealer|monash|select|mormon|active|moscow|racing|datsun|quebec|nissay|rodeo|email|gifts|works|photo|chloe|edeka|cheap|earth|vista|tushu|koeln|glass|shoes|globo|tunes|gmail|nokia|space|kyoto|black|ricoh|seven|lamer|sener|epson|cisco|praxi|trust|citic|crown|shell|lease|green|legal|lexus|ninja|tatar|gripe|nikon|group|video|wales|autos|gucci|party|nexus|guide|linde|adult|parts|amica|lixil|boats|azure|loans|locus|cymru|lotte|lotto|stada|click|poker|quest|dabur|lupin|nadex|paris|faith|dance|canon|place|gives|trade|skype|rocks|mango|cloud|boots|smile|final|swiss|homes|honda|media|horse|cards|deals|watch|bosch|house|pizza|miami|osaka|tours|total|xerox|coach|sucks|style|delta|toray|iinet|tools|money|codes|beats|tokyo|salon|archi|movie|baidu|study|actor|yahoo|store|apple|world|forex|today|bible|tmall|tirol|irish|tires|forum|reise|vegas|vodka|sharp|omega|weber|jetzt|audio|promo|build|bingo|chase|gallo|drive|dubai|rehab|press|solar|sale|beer|bbva|bank|band|auto|sapo|sarl|saxo|audi|asia|arte|arpa|army|yoga|ally|zara|scor|scot|sexy|seat|zero|seek|aero|adac|zone|aarp|maif|meet|meme|menu|surf|mini|mobi|mtpc|porn|desi|star|ltda|name|talk|navy|love|loan|live|link|news|limo|like|spot|life|nico|lidl|lgbt|land|taxi|team|tech|kred|kpmg|sony|song|kiwi|kddi|jprs|jobs|sohu|java|itau|tips|info|immo|icbc|hsbc|town|host|page|toys|here|help|pars|haus|guru|guge|tube|goog|golf|gold|sncf|gmbh|gift|ggee|gent|gbiz|game|vana|pics|fund|ford|ping|pink|fish|film|fast|farm|play|fans|fail|plus|skin|pohl|fage|moda|post|erni|dvag|prod|doha|prof|docs|viva|diet|luxe|site|dell|sina|dclk|show|qpon|date|vote|cyou|voto|read|coop|cool|wang|club|city|chat|cern|cash|reit|rent|casa|cars|care|camp|rest|call|cafe|weir|wien|rich|wiki|buzz|wine|book|bond|room|work|rsvp|shia|ruhr|blue|bing|shaw|bike|safe|xbox|best|pwc|mtn|lds|aig|boo|fyi|nra|nrw|ntt|car|gal|obi|zip|aeg|vin|how|one|ong|onl|dad|ooo|bet|esq|org|htc|bar|uol|ibm|ovh|gdn|ice|icu|uno|gea|ifm|bot|top|wtf|lol|day|pet|eus|wtc|ubs|tvs|aco|ing|ltd|ink|tab|abb|afl|cat|int|pid|pin|bid|cba|gle|com|cbn|ads|man|wed|ceb|gmo|sky|ist|gmx|tui|mba|fan|ski|iwc|app|pro|med|ceo|jcb|jcp|goo|dev|men|aaa|meo|pub|jlc|bom|jll|gop|jmp|mil|got|gov|win|jot|mma|joy|trv|red|cfa|cfd|bio|moe|moi|mom|ren|biz|aws|xin|bbc|dnp|buy|kfh|mov|thd|xyz|fit|kia|rio|rip|kim|dog|vet|nyc|bcg|mtr|bcn|bms|bmw|run|bzh|rwe|tel|stc|axa|kpn|fly|krd|cab|bnl|foo|crs|eat|tci|sap|srl|nec|sas|net|cal|sbs|sfr|sca|scb|csc|edu|new|xxx|hiv|fox|wme|ngo|nhk|vip|sex|frl|lat|yun|law|you|tax|soy|sew|om|ac|hu|se|sc|sg|sh|sb|sa|rw|ru|rs|ro|re|qa|py|si|pw|pt|ps|sj|sk|pr|pn|pm|pl|sl|sm|pk|sn|ph|so|pg|pf|pe|pa|zw|nz|nu|nr|np|no|nl|ni|ng|nf|sr|ne|st|nc|na|mz|my|mx|mw|mv|mu|mt|ms|mr|mq|mp|mo|su|mn|mm|ml|mk|mh|mg|me|sv|md|mc|sx|sy|ma|ly|lv|sz|lu|lt|ls|lr|lk|li|lc|lb|la|tc|kz|td|ky|kw|kr|kp|kn|km|ki|kh|tf|tg|th|kg|ke|jp|jo|jm|je|it|is|ir|tj|tk|tl|tm|iq|tn|to|io|in|im|il|ie|ad|sd|ht|hr|hn|hm|tr|hk|gy|gw|gu|gt|gs|gr|gq|tt|gp|gn|gm|gl|tv|gi|tw|tz|ua|gh|ug|uk|gg|gf|ge|gd|us|uy|uz|va|gb|ga|vc|ve|fr|fo|fm|fk|fj|vg|vi|fi|eu|et|es|er|eg|ee|ec|dz|do|dm|dk|vn|dj|de|cz|cy|cx|cw|vu|cv|cu|cr|co|cn|cm|cl|ck|ci|ch|cg|cf|cd|cc|ca|wf|bz|by|bw|bv|bt|bs|br|bo|bn|bm|bj|bi|ws|bh|bg|bf|be|bd|bb|ba|az|ax|aw|au|at|as|ye|ar|aq|ao|am|al|yt|ai|za|ag|af|ae|zm|id)\b/;
	
	
		return {
	
			/**
			 * The string form of a regular expression that would match all of the
			 * letters and decimal number chars in the unicode character set when placed
			 * in a RegExp character class (`[]`).
			 *
			 * These would be the characters matched by unicode regex engines `[\p{L}\p{Nd}]`
			 * escape ("all letters and decimal numbers")
			 *
			 * @property {String} alphaNumericCharsStr
			 */
			alphaNumericCharsStr : alphaNumericCharsStr,
	
			/**
			 * A regular expression to match domain names of a URL or email address.
			 * Ex: 'google', 'yahoo', 'some-other-company', etc.
			 *
			 * @property {RegExp} domainNameRegex
			 */
			domainNameRegex : domainNameRegex,
	
			/**
			 * A regular expression to match top level domains (TLDs) for a URL or
			 * email address. Ex: 'com', 'org', 'net', etc.
			 *
			 * @property {RegExp} tldRegex
			 */
			tldRegex : tldRegex
	
		};
	
	
	}() );
	/*global Autolinker */
	/*jshint sub:true */
	/**
	 * @protected
	 * @class Autolinker.AnchorTagBuilder
	 * @extends Object
	 *
	 * Builds anchor (&lt;a&gt;) tags for the Autolinker utility when a match is
	 * found.
	 *
	 * Normally this class is instantiated, configured, and used internally by an
	 * {@link Autolinker} instance, but may actually be retrieved in a {@link Autolinker#replaceFn replaceFn}
	 * to create {@link Autolinker.HtmlTag HtmlTag} instances which may be modified
	 * before returning from the {@link Autolinker#replaceFn replaceFn}. For
	 * example:
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( autolinker, match ) {
	 *             var tag = autolinker.getTagBuilder().build( match );  // returns an {@link Autolinker.HtmlTag} instance
	 *             tag.setAttr( 'rel', 'nofollow' );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
	 */
	Autolinker.AnchorTagBuilder = Autolinker.Util.extend( Object, {
	
		/**
		 * @cfg {Boolean} newWindow
		 * @inheritdoc Autolinker#newWindow
		 */
	
		/**
		 * @cfg {Object} truncate
		 * @inheritdoc Autolinker#truncate
		 */
	
		/**
		 * @cfg {String} className
		 * @inheritdoc Autolinker#className
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} [cfg] The configuration options for the AnchorTagBuilder instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.Util.assign( this, cfg );
		},
	
	
		/**
		 * Generates the actual anchor (&lt;a&gt;) tag to use in place of the
		 * matched text, via its `match` object.
		 *
		 * @param {Autolinker.match.Match} match The Match instance to generate an
		 *   anchor tag from.
		 * @return {Autolinker.HtmlTag} The HtmlTag instance for the anchor tag.
		 */
		build : function( match ) {
			return new Autolinker.HtmlTag( {
				tagName   : 'a',
				attrs     : this.createAttrs( match.getType(), match.getAnchorHref() ),
				innerHtml : this.processAnchorText( match.getAnchorText() )
			} );
		},
	
	
		/**
		 * Creates the Object (map) of the HTML attributes for the anchor (&lt;a&gt;)
		 *   tag being generated.
		 *
		 * @protected
		 * @param {"url"/"email"/"phone"/"twitter"/"hashtag"} matchType The type of
		 *   match that an anchor tag is being generated for.
		 * @param {String} anchorHref The href for the anchor tag.
		 * @return {Object} A key/value Object (map) of the anchor tag's attributes.
		 */
		createAttrs : function( matchType, anchorHref ) {
			var attrs = {
				'href' : anchorHref  // we'll always have the `href` attribute
			};
	
			var cssClass = this.createCssClass( matchType );
			if( cssClass ) {
				attrs[ 'class' ] = cssClass;
			}
			if( this.newWindow ) {
				attrs[ 'target' ] = "_blank";
				attrs[ 'rel' ] = "noopener noreferrer";
			}
	
			return attrs;
		},
	
	
		/**
		 * Creates the CSS class that will be used for a given anchor tag, based on
		 * the `matchType` and the {@link #className} config.
		 *
		 * @private
		 * @param {"url"/"email"/"phone"/"twitter"/"hashtag"} matchType The type of
		 *   match that an anchor tag is being generated for.
		 * @return {String} The CSS class string for the link. Example return:
		 *   "myLink myLink-url". If no {@link #className} was configured, returns
		 *   an empty string.
		 */
		createCssClass : function( matchType ) {
			var className = this.className;
	
			if( !className )
				return "";
			else
				return className + " " + className + "-" + matchType;  // ex: "myLink myLink-url", "myLink myLink-email", "myLink myLink-phone", "myLink myLink-twitter", or "myLink myLink-hashtag"
		},
	
	
		/**
		 * Processes the `anchorText` by truncating the text according to the
		 * {@link #truncate} config.
		 *
		 * @private
		 * @param {String} anchorText The anchor tag's text (i.e. what will be
		 *   displayed).
		 * @return {String} The processed `anchorText`.
		 */
		processAnchorText : function( anchorText ) {
			anchorText = this.doTruncate( anchorText );
	
			return anchorText;
		},
	
	
		/**
		 * Performs the truncation of the `anchorText` based on the {@link #truncate}
		 * option. If the `anchorText` is longer than the length specified by the
		 * {@link #truncate} option, the truncation is performed based on the
		 * `location` property. See {@link #truncate} for details.
		 *
		 * @private
		 * @param {String} anchorText The anchor tag's text (i.e. what will be
		 *   displayed).
		 * @return {String} The truncated anchor text.
		 */
		doTruncate : function( anchorText ) {
			var truncate = this.truncate;
			if( !truncate || !truncate.length ) return anchorText;
	
			var truncateLength = truncate.length,
				truncateLocation = truncate.location;
	
			if( truncateLocation === 'smart' ) {
				return Autolinker.truncate.TruncateSmart( anchorText, truncateLength, '..' );
	
			} else if( truncateLocation === 'middle' ) {
				return Autolinker.truncate.TruncateMiddle( anchorText, truncateLength, '..' );
	
			} else {
				return Autolinker.truncate.TruncateEnd( anchorText, truncateLength, '..' );
			}
		}
	
	} );
	
	/*global Autolinker */
	/**
	 * @class Autolinker.htmlParser.HtmlParser
	 * @extends Object
	 *
	 * An HTML parser implementation which simply walks an HTML string and returns an array of
	 * {@link Autolinker.htmlParser.HtmlNode HtmlNodes} that represent the basic HTML structure of the input string.
	 *
	 * Autolinker uses this to only link URLs/emails/Twitter handles within text nodes, effectively ignoring / "walking
	 * around" HTML tags.
	 */
	Autolinker.htmlParser.HtmlParser = Autolinker.Util.extend( Object, {
	
		/**
		 * @private
		 * @property {RegExp} htmlRegex
		 *
		 * The regular expression used to pull out HTML tags from a string. Handles namespaced HTML tags and
		 * attribute names, as specified by http://www.w3.org/TR/html-markup/syntax.html.
		 *
		 * Capturing groups:
		 *
		 * 1. The "!DOCTYPE" tag name, if a tag is a &lt;!DOCTYPE&gt; tag.
		 * 2. If it is an end tag, this group will have the '/'.
		 * 3. If it is a comment tag, this group will hold the comment text (i.e.
		 *    the text inside the `&lt;!--` and `--&gt;`.
		 * 4. The tag name for all tags (other than the &lt;!DOCTYPE&gt; tag)
		 */
		htmlRegex : (function() {
			var commentTagRegex = /!--([\s\S]+?)--/,
			    tagNameRegex = /[0-9a-zA-Z][0-9a-zA-Z:]*/,
			    attrNameRegex = /[^\s"'>\/=\x00-\x1F\x7F]+/,   // the unicode range accounts for excluding control chars, and the delete char
			    attrValueRegex = /(?:"[^"]*?"|'[^']*?'|[^'"=<>`\s]+)/, // double quoted, single quoted, or unquoted attribute values
			    nameEqualsValueRegex = attrNameRegex.source + '(?:\\s*=\\s*' + attrValueRegex.source + ')?';  // optional '=[value]'
	
			return new RegExp( [
				// for <!DOCTYPE> tag. Ex: <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">)
				'(?:',
					'<(!DOCTYPE)',  // *** Capturing Group 1 - If it's a doctype tag
	
						// Zero or more attributes following the tag name
						'(?:',
							'\\s+',  // one or more whitespace chars before an attribute
	
							// Either:
							// A. attr="value", or
							// B. "value" alone (To cover example doctype tag: <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">)
							'(?:', nameEqualsValueRegex, '|', attrValueRegex.source + ')',
						')*',
					'>',
				')',
	
				'|',
	
				// All other HTML tags (i.e. tags that are not <!DOCTYPE>)
				'(?:',
					'<(/)?',  // Beginning of a tag or comment. Either '<' for a start tag, or '</' for an end tag.
					          // *** Capturing Group 2: The slash or an empty string. Slash ('/') for end tag, empty string for start or self-closing tag.
	
						'(?:',
							commentTagRegex.source,  // *** Capturing Group 3 - A Comment Tag's Text
	
							'|',
	
							'(?:',
	
								// *** Capturing Group 4 - The tag name
								'(' + tagNameRegex.source + ')',
	
								// Zero or more attributes following the tag name
								'(?:',
									'(?:\\s+|\\b)',        // any number of whitespace chars before an attribute. NOTE: Using \s* here throws Chrome into an infinite loop for some reason, so using \s+|\b instead
									nameEqualsValueRegex,  // attr="value" (with optional ="value" part)
								')*',
	
								'\\s*/?',  // any trailing spaces and optional '/' before the closing '>'
	
							')',
						')',
					'>',
				')'
			].join( "" ), 'gi' );
		} )(),
	
		/**
		 * @private
		 * @property {RegExp} htmlCharacterEntitiesRegex
		 *
		 * The regular expression that matches common HTML character entities.
		 *
		 * Ignoring &amp; as it could be part of a query string -- handling it separately.
		 */
		htmlCharacterEntitiesRegex: /(&nbsp;|&#160;|&lt;|&#60;|&gt;|&#62;|&quot;|&#34;|&#39;)/gi,
	
	
		/**
		 * Parses an HTML string and returns a simple array of {@link Autolinker.htmlParser.HtmlNode HtmlNodes}
		 * to represent the HTML structure of the input string.
		 *
		 * @param {String} html The HTML to parse.
		 * @return {Autolinker.htmlParser.HtmlNode[]}
		 */
		parse : function( html ) {
			var htmlRegex = this.htmlRegex,
			    currentResult,
			    lastIndex = 0,
			    textAndEntityNodes,
			    nodes = [];  // will be the result of the method
	
			while( ( currentResult = htmlRegex.exec( html ) ) !== null ) {
				var tagText = currentResult[ 0 ],
				    commentText = currentResult[ 3 ], // if we've matched a comment
				    tagName = currentResult[ 1 ] || currentResult[ 4 ],  // The <!DOCTYPE> tag (ex: "!DOCTYPE"), or another tag (ex: "a" or "img")
				    isClosingTag = !!currentResult[ 2 ],
				    offset = currentResult.index,
				    inBetweenTagsText = html.substring( lastIndex, offset );
	
				// Push TextNodes and EntityNodes for any text found between tags
				if( inBetweenTagsText ) {
					textAndEntityNodes = this.parseTextAndEntityNodes( lastIndex, inBetweenTagsText );
					nodes.push.apply( nodes, textAndEntityNodes );
				}
	
				// Push the CommentNode or ElementNode
				if( commentText ) {
					nodes.push( this.createCommentNode( offset, tagText, commentText ) );
				} else {
					nodes.push( this.createElementNode( offset, tagText, tagName, isClosingTag ) );
				}
	
				lastIndex = offset + tagText.length;
			}
	
			// Process any remaining text after the last HTML element. Will process all of the text if there were no HTML elements.
			if( lastIndex < html.length ) {
				var text = html.substring( lastIndex );
	
				// Push TextNodes and EntityNodes for any text found between tags
				if( text ) {
					textAndEntityNodes = this.parseTextAndEntityNodes( lastIndex, text );
					nodes.push.apply( nodes, textAndEntityNodes );
				}
			}
	
			return nodes;
		},
	
	
		/**
		 * Parses text and HTML entity nodes from a given string. The input string
		 * should not have any HTML tags (elements) within it.
		 *
		 * @private
		 * @param {Number} offset The offset of the text node match within the
		 *   original HTML string.
		 * @param {String} text The string of text to parse. This is from an HTML
		 *   text node.
		 * @return {Autolinker.htmlParser.HtmlNode[]} An array of HtmlNodes to
		 *   represent the {@link Autolinker.htmlParser.TextNode TextNodes} and
		 *   {@link Autolinker.htmlParser.EntityNode EntityNodes} found.
		 */
		parseTextAndEntityNodes : function( offset, text ) {
			var nodes = [],
			    textAndEntityTokens = Autolinker.Util.splitAndCapture( text, this.htmlCharacterEntitiesRegex );  // split at HTML entities, but include the HTML entities in the results array
	
			// Every even numbered token is a TextNode, and every odd numbered token is an EntityNode
			// For example: an input `text` of "Test &quot;this&quot; today" would turn into the
			//   `textAndEntityTokens`: [ 'Test ', '&quot;', 'this', '&quot;', ' today' ]
			for( var i = 0, len = textAndEntityTokens.length; i < len; i += 2 ) {
				var textToken = textAndEntityTokens[ i ],
				    entityToken = textAndEntityTokens[ i + 1 ];
	
				if( textToken ) {
					nodes.push( this.createTextNode( offset, textToken ) );
					offset += textToken.length;
				}
				if( entityToken ) {
					nodes.push( this.createEntityNode( offset, entityToken ) );
					offset += entityToken.length;
				}
			}
			return nodes;
		},
	
	
		/**
		 * Factory method to create an {@link Autolinker.htmlParser.CommentNode CommentNode}.
		 *
		 * @private
		 * @param {Number} offset The offset of the match within the original HTML
		 *   string.
		 * @param {String} tagText The full text of the tag (comment) that was
		 *   matched, including its &lt;!-- and --&gt;.
		 * @param {String} commentText The full text of the comment that was matched.
		 */
		createCommentNode : function( offset, tagText, commentText ) {
			return new Autolinker.htmlParser.CommentNode( {
				offset : offset,
				text   : tagText,
				comment: Autolinker.Util.trim( commentText )
			} );
		},
	
	
		/**
		 * Factory method to create an {@link Autolinker.htmlParser.ElementNode ElementNode}.
		 *
		 * @private
		 * @param {Number} offset The offset of the match within the original HTML
		 *   string.
		 * @param {String} tagText The full text of the tag (element) that was
		 *   matched, including its attributes.
		 * @param {String} tagName The name of the tag. Ex: An &lt;img&gt; tag would
		 *   be passed to this method as "img".
		 * @param {Boolean} isClosingTag `true` if it's a closing tag, false
		 *   otherwise.
		 * @return {Autolinker.htmlParser.ElementNode}
		 */
		createElementNode : function( offset, tagText, tagName, isClosingTag ) {
			return new Autolinker.htmlParser.ElementNode( {
				offset  : offset,
				text    : tagText,
				tagName : tagName.toLowerCase(),
				closing : isClosingTag
			} );
		},
	
	
		/**
		 * Factory method to create a {@link Autolinker.htmlParser.EntityNode EntityNode}.
		 *
		 * @private
		 * @param {Number} offset The offset of the match within the original HTML
		 *   string.
		 * @param {String} text The text that was matched for the HTML entity (such
		 *   as '&amp;nbsp;').
		 * @return {Autolinker.htmlParser.EntityNode}
		 */
		createEntityNode : function( offset, text ) {
			return new Autolinker.htmlParser.EntityNode( { offset: offset, text: text } );
		},
	
	
		/**
		 * Factory method to create a {@link Autolinker.htmlParser.TextNode TextNode}.
		 *
		 * @private
		 * @param {Number} offset The offset of the match within the original HTML
		 *   string.
		 * @param {String} text The text that was matched.
		 * @return {Autolinker.htmlParser.TextNode}
		 */
		createTextNode : function( offset, text ) {
			return new Autolinker.htmlParser.TextNode( { offset: offset, text: text } );
		}
	
	} );
	/*global Autolinker */
	/**
	 * @abstract
	 * @class Autolinker.htmlParser.HtmlNode
	 *
	 * Represents an HTML node found in an input string. An HTML node is one of the
	 * following:
	 *
	 * 1. An {@link Autolinker.htmlParser.ElementNode ElementNode}, which represents
	 *    HTML tags.
	 * 2. A {@link Autolinker.htmlParser.CommentNode CommentNode}, which represents
	 *    HTML comments.
	 * 3. A {@link Autolinker.htmlParser.TextNode TextNode}, which represents text
	 *    outside or within HTML tags.
	 * 4. A {@link Autolinker.htmlParser.EntityNode EntityNode}, which represents
	 *    one of the known HTML entities that Autolinker looks for. This includes
	 *    common ones such as &amp;quot; and &amp;nbsp;
	 */
	Autolinker.htmlParser.HtmlNode = Autolinker.Util.extend( Object, {
	
		/**
		 * @cfg {Number} offset (required)
		 *
		 * The offset of the HTML node in the original text that was parsed.
		 */
		offset : undefined,
	
		/**
		 * @cfg {String} text (required)
		 *
		 * The text that was matched for the HtmlNode.
		 *
		 * - In the case of an {@link Autolinker.htmlParser.ElementNode ElementNode},
		 *   this will be the tag's text.
		 * - In the case of an {@link Autolinker.htmlParser.CommentNode CommentNode},
		 *   this will be the comment's text.
		 * - In the case of a {@link Autolinker.htmlParser.TextNode TextNode}, this
		 *   will be the text itself.
		 * - In the case of a {@link Autolinker.htmlParser.EntityNode EntityNode},
		 *   this will be the text of the HTML entity.
		 */
		text : undefined,
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match instance,
		 * specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.Util.assign( this, cfg );
	
			if( this.offset == null ) throw new Error( '`offset` cfg required' );
			if( this.text == null ) throw new Error( '`text` cfg required' );
		},
	
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @abstract
		 * @return {String}
		 */
		getType : Autolinker.Util.abstractMethod,
	
	
		/**
		 * Retrieves the {@link #offset} of the HtmlNode. This is the offset of the
		 * HTML node in the original string that was parsed.
		 *
		 * @return {Number}
		 */
		getOffset : function() {
			return this.offset;
		},
	
	
		/**
		 * Retrieves the {@link #text} for the HtmlNode.
		 *
		 * @return {String}
		 */
		getText : function() {
			return this.text;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.htmlParser.CommentNode
	 * @extends Autolinker.htmlParser.HtmlNode
	 *
	 * Represents an HTML comment node that has been parsed by the
	 * {@link Autolinker.htmlParser.HtmlParser}.
	 *
	 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
	 * details.
	 */
	Autolinker.htmlParser.CommentNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {
	
		/**
		 * @cfg {String} comment (required)
		 *
		 * The text inside the comment tag. This text is stripped of any leading or
		 * trailing whitespace.
		 */
		comment : '',
	
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'comment';
		},
	
	
		/**
		 * Returns the comment inside the comment tag.
		 *
		 * @return {String}
		 */
		getComment : function() {
			return this.comment;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.htmlParser.ElementNode
	 * @extends Autolinker.htmlParser.HtmlNode
	 *
	 * Represents an HTML element node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
	 *
	 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
	 * details.
	 */
	Autolinker.htmlParser.ElementNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {
	
		/**
		 * @cfg {String} tagName (required)
		 *
		 * The name of the tag that was matched.
		 */
		tagName : '',
	
		/**
		 * @cfg {Boolean} closing (required)
		 *
		 * `true` if the element (tag) is a closing tag, `false` if its an opening
		 * tag.
		 */
		closing : false,
	
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'element';
		},
	
	
		/**
		 * Returns the HTML element's (tag's) name. Ex: for an &lt;img&gt; tag,
		 * returns "img".
		 *
		 * @return {String}
		 */
		getTagName : function() {
			return this.tagName;
		},
	
	
		/**
		 * Determines if the HTML element (tag) is a closing tag. Ex: &lt;div&gt;
		 * returns `false`, while &lt;/div&gt; returns `true`.
		 *
		 * @return {Boolean}
		 */
		isClosing : function() {
			return this.closing;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.htmlParser.EntityNode
	 * @extends Autolinker.htmlParser.HtmlNode
	 *
	 * Represents a known HTML entity node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
	 * Ex: '&amp;nbsp;', or '&amp#160;' (which will be retrievable from the {@link #getText}
	 * method.
	 *
	 * Note that this class will only be returned from the HtmlParser for the set of
	 * checked HTML entity nodes  defined by the {@link Autolinker.htmlParser.HtmlParser#htmlCharacterEntitiesRegex}.
	 *
	 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
	 * details.
	 */
	Autolinker.htmlParser.EntityNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'entity';
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.htmlParser.TextNode
	 * @extends Autolinker.htmlParser.HtmlNode
	 *
	 * Represents a text node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
	 *
	 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
	 * details.
	 */
	Autolinker.htmlParser.TextNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'text';
		}
	
	} );
	/*global Autolinker */
	/**
	 * @abstract
	 * @class Autolinker.match.Match
	 *
	 * Represents a match found in an input string which should be Autolinked. A Match object is what is provided in a
	 * {@link Autolinker#replaceFn replaceFn}, and may be used to query for details about the match.
	 *
	 * For example:
	 *
	 *     var input = "...";  // string with URLs, Email Addresses, and Twitter Handles
	 *
	 *     var linkedText = Autolinker.link( input, {
	 *         replaceFn : function( autolinker, match ) {
	 *             console.log( "href = ", match.getAnchorHref() );
	 *             console.log( "text = ", match.getAnchorText() );
	 *
	 *             switch( match.getType() ) {
	 *                 case 'url' :
	 *                     console.log( "url: ", match.getUrl() );
	 *
	 *                 case 'email' :
	 *                     console.log( "email: ", match.getEmail() );
	 *
	 *                 case 'twitter' :
	 *                     console.log( "twitter: ", match.getTwitterHandle() );
	 *             }
	 *         }
	 *     } );
	 *
	 * See the {@link Autolinker} class for more details on using the {@link Autolinker#replaceFn replaceFn}.
	 */
	Autolinker.match.Match = Autolinker.Util.extend( Object, {
	
		/**
		 * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
		 *
		 * Reference to the AnchorTagBuilder instance to use to generate an anchor
		 * tag for the Match.
		 */
	
		/**
		 * @cfg {String} matchedText (required)
		 *
		 * The original text that was matched by the {@link Autolinker.matcher.Matcher}.
		 */
	
		/**
		 * @cfg {Number} offset (required)
		 *
		 * The offset of where the match was made in the input string.
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match
		 *   instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			if( cfg.tagBuilder == null ) throw new Error( '`tagBuilder` cfg required' );
			if( cfg.matchedText == null ) throw new Error( '`matchedText` cfg required' );
			if( cfg.offset == null ) throw new Error( '`offset` cfg required' );
	
			this.tagBuilder = cfg.tagBuilder;
			this.matchedText = cfg.matchedText;
			this.offset = cfg.offset;
		},
	
	
		/**
		 * Returns a string name for the type of match that this class represents.
		 *
		 * @abstract
		 * @return {String}
		 */
		getType : Autolinker.Util.abstractMethod,
	
	
		/**
		 * Returns the original text that was matched.
		 *
		 * @return {String}
		 */
		getMatchedText : function() {
			return this.matchedText;
		},
	
	
		/**
		 * Sets the {@link #offset} of where the match was made in the input string.
		 *
		 * A {@link Autolinker.matcher.Matcher} will be fed only HTML text nodes,
		 * and will therefore set an original offset that is relative to the HTML
		 * text node itself. However, we want this offset to be relative to the full
		 * HTML input string, and thus if using {@link Autolinker#parse} (rather
		 * than calling a {@link Autolinker.matcher.Matcher} directly), then this
		 * offset is corrected after the Matcher itself has done its job.
		 *
		 * @param {Number} offset
		 */
		setOffset : function( offset ) {
			this.offset = offset;
		},
	
	
		/**
		 * Returns the offset of where the match was made in the input string. This
		 * is the 0-based index of the match.
		 *
		 * @return {Number}
		 */
		getOffset : function() {
			return this.offset;
		},
	
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 *
		 * @abstract
		 * @return {String}
		 */
		getAnchorHref : Autolinker.Util.abstractMethod,
	
	
		/**
		 * Returns the anchor text that should be generated for the match.
		 *
		 * @abstract
		 * @return {String}
		 */
		getAnchorText : Autolinker.Util.abstractMethod,
	
	
		/**
		 * Builds and returns an {@link Autolinker.HtmlTag} instance based on the
		 * Match.
		 *
		 * This can be used to easily generate anchor tags from matches, and either
		 * return their HTML string, or modify them before doing so.
		 *
		 * Example Usage:
		 *
		 *     var tag = match.buildTag();
		 *     tag.addClass( 'cordova-link' );
		 *     tag.setAttr( 'target', '_system' );
		 *
		 *     tag.toAnchorString();  // <a href="http://google.com" class="cordova-link" target="_system">Google</a>
		 */
		buildTag : function() {
			return this.tagBuilder.build( this );
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Email
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Email match found in an input string which should be Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
	 */
	Autolinker.match.Email = Autolinker.Util.extend( Autolinker.match.Match, {
	
		/**
		 * @cfg {String} email (required)
		 *
		 * The email address that was matched.
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match
		 *   instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.match.Match.prototype.constructor.call( this, cfg );
	
			if( !cfg.email ) throw new Error( '`email` cfg required' );
	
			this.email = cfg.email;
		},
	
	
		/**
		 * Returns a string name for the type of match that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'email';
		},
	
	
		/**
		 * Returns the email address that was matched.
		 *
		 * @return {String}
		 */
		getEmail : function() {
			return this.email;
		},
	
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorHref : function() {
			return 'mailto:' + this.email;
		},
	
	
		/**
		 * Returns the anchor text that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorText : function() {
			return this.email;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Hashtag
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Hashtag match found in an input string which should be
	 * Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more
	 * details.
	 */
	Autolinker.match.Hashtag = Autolinker.Util.extend( Autolinker.match.Match, {
	
		/**
		 * @cfg {String} serviceName
		 *
		 * The service to point hashtag matches to. See {@link Autolinker#hashtag}
		 * for available values.
		 */
	
		/**
		 * @cfg {String} hashtag (required)
		 *
		 * The Hashtag that was matched, without the '#'.
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match
		 *   instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.match.Match.prototype.constructor.call( this, cfg );
	
			// TODO: if( !serviceName ) throw new Error( '`serviceName` cfg required' );
			if( !cfg.hashtag ) throw new Error( '`hashtag` cfg required' );
	
			this.serviceName = cfg.serviceName;
			this.hashtag = cfg.hashtag;
		},
	
	
		/**
		 * Returns the type of match that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'hashtag';
		},
	
	
		/**
		 * Returns the configured {@link #serviceName} to point the Hashtag to.
		 * Ex: 'facebook', 'twitter'.
		 *
		 * @return {String}
		 */
		getServiceName : function() {
			return this.serviceName;
		},
	
	
		/**
		 * Returns the matched hashtag, without the '#' character.
		 *
		 * @return {String}
		 */
		getHashtag : function() {
			return this.hashtag;
		},
	
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorHref : function() {
			var serviceName = this.serviceName,
			    hashtag = this.hashtag;
	
			switch( serviceName ) {
				case 'twitter' :
					return 'https://twitter.com/hashtag/' + hashtag;
				case 'facebook' :
					return 'https://www.facebook.com/hashtag/' + hashtag;
				case 'instagram' :
					return 'https://instagram.com/explore/tags/' + hashtag;
	
				default :  // Shouldn't happen because Autolinker's constructor should block any invalid values, but just in case.
					throw new Error( 'Unknown service name to point hashtag to: ', serviceName );
			}
		},
	
	
		/**
		 * Returns the anchor text that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorText : function() {
			return '#' + this.hashtag;
		}
	
	} );
	
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Phone
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Phone number match found in an input string which should be
	 * Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more
	 * details.
	 */
	Autolinker.match.Phone = Autolinker.Util.extend( Autolinker.match.Match, {
	
		/**
		 * @protected
		 * @property {String} number (required)
		 *
		 * The phone number that was matched, without any delimiter characters.
		 *
		 * Note: This is a string to allow for prefixed 0's.
		 */
	
		/**
		 * @protected
		 * @property  {Boolean} plusSign (required)
		 *
		 * `true` if the matched phone number started with a '+' sign. We'll include
		 * it in the `tel:` URL if so, as this is needed for international numbers.
		 *
		 * Ex: '+1 (123) 456 7879'
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match
		 *   instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.match.Match.prototype.constructor.call( this, cfg );
	
			if( !cfg.number ) throw new Error( '`number` cfg required' );
			if( cfg.plusSign == null ) throw new Error( '`plusSign` cfg required' );
	
			this.number = cfg.number;
			this.plusSign = cfg.plusSign;
		},
	
	
		/**
		 * Returns a string name for the type of match that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'phone';
		},
	
	
		/**
		 * Returns the phone number that was matched as a string, without any
		 * delimiter characters.
		 *
		 * Note: This is a string to allow for prefixed 0's.
		 *
		 * @return {String}
		 */
		getNumber: function() {
			return this.number;
		},
	
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorHref : function() {
			return 'tel:' + ( this.plusSign ? '+' : '' ) + this.number;
		},
	
	
		/**
		 * Returns the anchor text that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorText : function() {
			return this.matchedText;
		}
	
	} );
	
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Twitter
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Twitter match found in an input string which should be Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
	 */
	Autolinker.match.Twitter = Autolinker.Util.extend( Autolinker.match.Match, {
	
		/**
		 * @cfg {String} twitterHandle (required)
		 *
		 * The Twitter handle that was matched, without the '@' character.
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match
		 *   instance, specified in an Object (map).
		 */
		constructor : function( cfg) {
			Autolinker.match.Match.prototype.constructor.call( this, cfg );
	
			if( !cfg.twitterHandle ) throw new Error( '`twitterHandle` cfg required' );
	
			this.twitterHandle = cfg.twitterHandle;
		},
	
	
		/**
		 * Returns the type of match that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'twitter';
		},
	
	
		/**
		 * Returns the twitter handle, without the '@' character.
		 *
		 * @return {String}
		 */
		getTwitterHandle : function() {
			return this.twitterHandle;
		},
	
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorHref : function() {
			return 'https://twitter.com/' + this.twitterHandle;
		},
	
	
		/**
		 * Returns the anchor text that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorText : function() {
			return '@' + this.twitterHandle;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Url
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Url match found in an input string which should be Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
	 */
	Autolinker.match.Url = Autolinker.Util.extend( Autolinker.match.Match, {
	
		/**
		 * @cfg {String} url (required)
		 *
		 * The url that was matched.
		 */
	
		/**
		 * @cfg {"scheme"/"www"/"tld"} urlMatchType (required)
		 *
		 * The type of URL match that this class represents. This helps to determine
		 * if the match was made in the original text with a prefixed scheme (ex:
		 * 'http://www.google.com'), a prefixed 'www' (ex: 'www.google.com'), or
		 * was matched by a known top-level domain (ex: 'google.com').
		 */
	
		/**
		 * @cfg {Boolean} protocolUrlMatch (required)
		 *
		 * `true` if the URL is a match which already has a protocol (i.e.
		 * 'http://'), `false` if the match was from a 'www' or known TLD match.
		 */
	
		/**
		 * @cfg {Boolean} protocolRelativeMatch (required)
		 *
		 * `true` if the URL is a protocol-relative match. A protocol-relative match
		 * is a URL that starts with '//', and will be either http:// or https://
		 * based on the protocol that the site is loaded under.
		 */
	
		/**
		 * @cfg {Boolean} stripPrefix (required)
		 * @inheritdoc Autolinker#cfg-stripPrefix
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match
		 *   instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.match.Match.prototype.constructor.call( this, cfg );
	
			if( cfg.urlMatchType !== 'scheme' && cfg.urlMatchType !== 'www' && cfg.urlMatchType !== 'tld' ) throw new Error( '`urlMatchType` cfg must be one of: "scheme", "www", or "tld"' );
			if( !cfg.url ) throw new Error( '`url` cfg required' );
			if( cfg.protocolUrlMatch == null ) throw new Error( '`protocolUrlMatch` cfg required' );
			if( cfg.protocolRelativeMatch == null ) throw new Error( '`protocolRelativeMatch` cfg required' );
			if( cfg.stripPrefix == null ) throw new Error( '`stripPrefix` cfg required' );
	
			this.urlMatchType = cfg.urlMatchType;
			this.url = cfg.url;
			this.protocolUrlMatch = cfg.protocolUrlMatch;
			this.protocolRelativeMatch = cfg.protocolRelativeMatch;
			this.stripPrefix = cfg.stripPrefix;
		},
	
	
		/**
		 * @private
		 * @property {RegExp} urlPrefixRegex
		 *
		 * A regular expression used to remove the 'http://' or 'https://' and/or the 'www.' from URLs.
		 */
		urlPrefixRegex: /^(https?:\/\/)?(www\.)?/i,
	
		/**
		 * @private
		 * @property {RegExp} protocolRelativeRegex
		 *
		 * The regular expression used to remove the protocol-relative '//' from the {@link #url} string, for purposes
		 * of {@link #getAnchorText}. A protocol-relative URL is, for example, "//yahoo.com"
		 */
		protocolRelativeRegex : /^\/\//,
	
		/**
		 * @private
		 * @property {Boolean} protocolPrepended
		 *
		 * Will be set to `true` if the 'http://' protocol has been prepended to the {@link #url} (because the
		 * {@link #url} did not have a protocol)
		 */
		protocolPrepended : false,
	
	
		/**
		 * Returns a string name for the type of match that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'url';
		},
	
	
		/**
		 * Returns a string name for the type of URL match that this class
		 * represents.
		 *
		 * This helps to determine if the match was made in the original text with a
		 * prefixed scheme (ex: 'http://www.google.com'), a prefixed 'www' (ex:
		 * 'www.google.com'), or was matched by a known top-level domain (ex:
		 * 'google.com').
		 *
		 * @return {"scheme"/"www"/"tld"}
		 */
		getUrlMatchType : function() {
			return this.urlMatchType;
		},
	
	
		/**
		 * Returns the url that was matched, assuming the protocol to be 'http://' if the original
		 * match was missing a protocol.
		 *
		 * @return {String}
		 */
		getUrl : function() {
			var url = this.url;
	
			// if the url string doesn't begin with a protocol, assume 'http://'
			if( !this.protocolRelativeMatch && !this.protocolUrlMatch && !this.protocolPrepended ) {
				url = this.url = 'http://' + url;
	
				this.protocolPrepended = true;
			}
	
			return url;
		},
	
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorHref : function() {
			var url = this.getUrl();
	
			return url.replace( /&amp;/g, '&' );  // any &amp;'s in the URL should be converted back to '&' if they were displayed as &amp; in the source html
		},
	
	
		/**
		 * Returns the anchor text that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorText : function() {
			var anchorText = this.getMatchedText();
	
			if( this.protocolRelativeMatch ) {
				// Strip off any protocol-relative '//' from the anchor text
				anchorText = this.stripProtocolRelativePrefix( anchorText );
			}
			if( this.stripPrefix ) {
				anchorText = this.stripUrlPrefix( anchorText );
			}
			anchorText = this.removeTrailingSlash( anchorText );  // remove trailing slash, if there is one
	
			return anchorText;
		},
	
	
		// ---------------------------------------
	
		// Utility Functionality
	
		/**
		 * Strips the URL prefix (such as "http://" or "https://") from the given text.
		 *
		 * @private
		 * @param {String} text The text of the anchor that is being generated, for which to strip off the
		 *   url prefix (such as stripping off "http://")
		 * @return {String} The `anchorText`, with the prefix stripped.
		 */
		stripUrlPrefix : function( text ) {
			return text.replace( this.urlPrefixRegex, '' );
		},
	
	
		/**
		 * Strips any protocol-relative '//' from the anchor text.
		 *
		 * @private
		 * @param {String} text The text of the anchor that is being generated, for which to strip off the
		 *   protocol-relative prefix (such as stripping off "//")
		 * @return {String} The `anchorText`, with the protocol-relative prefix stripped.
		 */
		stripProtocolRelativePrefix : function( text ) {
			return text.replace( this.protocolRelativeRegex, '' );
		},
	
	
		/**
		 * Removes any trailing slash from the given `anchorText`, in preparation for the text to be displayed.
		 *
		 * @private
		 * @param {String} anchorText The text of the anchor that is being generated, for which to remove any trailing
		 *   slash ('/') that may exist.
		 * @return {String} The `anchorText`, with the trailing slash removed.
		 */
		removeTrailingSlash : function( anchorText ) {
			if( anchorText.charAt( anchorText.length - 1 ) === '/' ) {
				anchorText = anchorText.slice( 0, -1 );
			}
			return anchorText;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @abstract
	 * @class Autolinker.matcher.Matcher
	 *
	 * An abstract class and interface for individual matchers to find matches in
	 * an input string with linkified versions of them.
	 *
	 * Note that Matchers do not take HTML into account - they must be fed the text
	 * nodes of any HTML string, which is handled by {@link Autolinker#parse}.
	 */
	Autolinker.matcher.Matcher = Autolinker.Util.extend( Object, {
	
		/**
		 * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
		 *
		 * Reference to the AnchorTagBuilder instance to use to generate HTML tags
		 * for {@link Autolinker.match.Match Matches}.
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Matcher
		 *   instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			if( !cfg.tagBuilder ) throw new Error( '`tagBuilder` cfg required' );
	
			this.tagBuilder = cfg.tagBuilder;
		},
	
	
		/**
		 * Parses the input `text` and returns the array of {@link Autolinker.match.Match Matches}
		 * for the matcher.
		 *
		 * @abstract
		 * @param {String} text The text to scan and replace matches in.
		 * @return {Autolinker.match.Match[]}
		 */
		parseMatches : Autolinker.Util.abstractMethod
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.matcher.Email
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find email matches in an input string.
	 *
	 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more details.
	 */
	Autolinker.matcher.Email = Autolinker.Util.extend( Autolinker.matcher.Matcher, {
	
		/**
		 * The regular expression to match email addresses. Example match:
		 *
		 *     person@place.com
		 *
		 * @private
		 * @property {RegExp} matcherRegex
		 */
		matcherRegex : (function() {
			var alphaNumericChars = Autolinker.RegexLib.alphaNumericCharsStr,
			    emailRegex = new RegExp( '[' + alphaNumericChars + '\\-_\';:&=+$.,]+@' ),  // something@ for email addresses (a.k.a. local-part)
				domainNameRegex = Autolinker.RegexLib.domainNameRegex,
				tldRegex = Autolinker.RegexLib.tldRegex;  // match our known top level domains (TLDs)
	
			return new RegExp( [
				emailRegex.source,
				domainNameRegex.source,
				'\\.', tldRegex.source   // '.com', '.net', etc
			].join( "" ), 'gi' );
		} )(),
	
	
		/**
		 * @inheritdoc
		 */
		parseMatches : function( text ) {
			var matcherRegex = this.matcherRegex,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;
	
			while( ( match = matcherRegex.exec( text ) ) !== null ) {
				var matchedText = match[ 0 ];
	
				matches.push( new Autolinker.match.Email( {
					tagBuilder  : tagBuilder,
					matchedText : matchedText,
					offset      : match.index,
					email       : matchedText
				} ) );
			}
	
			return matches;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.matcher.Hashtag
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find Hashtag matches in an input string.
	 */
	Autolinker.matcher.Hashtag = Autolinker.Util.extend( Autolinker.matcher.Matcher, {
	
		/**
		 * @cfg {String} serviceName
		 *
		 * The service to point hashtag matches to. See {@link Autolinker#hashtag}
		 * for available values.
		 */
	
	
		/**
		 * The regular expression to match Hashtags. Example match:
		 *
		 *     #asdf
		 *
		 * @private
		 * @property {RegExp} matcherRegex
		 */
		matcherRegex : new RegExp( '#[_' + Autolinker.RegexLib.alphaNumericCharsStr + ']{1,139}', 'g' ),
	
		/**
		 * The regular expression to use to check the character before a username match to
		 * make sure we didn't accidentally match an email address.
		 *
		 * For example, the string "asdf@asdf.com" should not match "@asdf" as a username.
		 *
		 * @private
		 * @property {RegExp} nonWordCharRegex
		 */
		nonWordCharRegex : new RegExp( '[^' + Autolinker.RegexLib.alphaNumericCharsStr + ']' ),
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match instance,
		 *   specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.matcher.Matcher.prototype.constructor.call( this, cfg );
	
			this.serviceName = cfg.serviceName;
		},
	
	
		/**
		 * @inheritdoc
		 */
		parseMatches : function( text ) {
			var matcherRegex = this.matcherRegex,
			    nonWordCharRegex = this.nonWordCharRegex,
			    serviceName = this.serviceName,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;
	
			while( ( match = matcherRegex.exec( text ) ) !== null ) {
				var offset = match.index,
				    prevChar = text.charAt( offset - 1 );
	
				// If we found the match at the beginning of the string, or we found the match
				// and there is a whitespace char in front of it (meaning it is not a '#' char
				// in the middle of a word), then it is a hashtag match.
				if( offset === 0 || nonWordCharRegex.test( prevChar ) ) {
					var matchedText = match[ 0 ],
					    hashtag = match[ 0 ].slice( 1 );  // strip off the '#' character at the beginning
	
					matches.push( new Autolinker.match.Hashtag( {
						tagBuilder  : tagBuilder,
						matchedText : matchedText,
						offset      : offset,
						serviceName : serviceName,
						hashtag     : hashtag
					} ) );
				}
			}
	
			return matches;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.matcher.Phone
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find Phone number matches in an input string.
	 *
	 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more
	 * details.
	 */
	Autolinker.matcher.Phone = Autolinker.Util.extend( Autolinker.matcher.Matcher, {
	
		/**
		 * The regular expression to match Phone numbers. Example match:
		 *
		 *     (123) 456-7890
		 *
		 * This regular expression has the following capturing groups:
		 *
		 * 1. The prefixed '+' sign, if there is one.
		 *
		 * @private
		 * @property {RegExp} matcherRegex
		 */
		matcherRegex : /(?:(\+)?\d{1,3}[-\040.])?\(?\d{3}\)?[-\040.]?\d{3}[-\040.]\d{4}/g,  // ex: (123) 456-7890, 123 456 7890, 123-456-7890, etc.
	
		/**
		 * @inheritdoc
		 */
		parseMatches : function( text ) {
			var matcherRegex = this.matcherRegex,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;
	
			while( ( match = matcherRegex.exec( text ) ) !== null ) {
				// Remove non-numeric values from phone number string
				var matchedText = match[ 0 ],
				    cleanNumber = matchedText.replace( /\D/g, '' ),  // strip out non-digit characters
				    plusSign = !!match[ 1 ];  // match[ 1 ] is the prefixed plus sign, if there is one
	
				matches.push( new Autolinker.match.Phone( {
					tagBuilder  : tagBuilder,
					matchedText : matchedText,
					offset      : match.index,
					number      : cleanNumber,
					plusSign    : plusSign
				} ) );
			}
	
			return matches;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.matcher.Twitter
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find/replace username matches in an input string.
	 */
	Autolinker.matcher.Twitter = Autolinker.Util.extend( Autolinker.matcher.Matcher, {
	
		/**
		 * The regular expression to match username handles. Example match:
		 *
		 *     @asdf
		 *
		 * @private
		 * @property {RegExp} matcherRegex
		 */
		matcherRegex : new RegExp( '@[_' + Autolinker.RegexLib.alphaNumericCharsStr + ']{1,20}', 'g' ),
	
		/**
		 * The regular expression to use to check the character before a username match to
		 * make sure we didn't accidentally match an email address.
		 *
		 * For example, the string "asdf@asdf.com" should not match "@asdf" as a username.
		 *
		 * @private
		 * @property {RegExp} nonWordCharRegex
		 */
		nonWordCharRegex : new RegExp( '[^' + Autolinker.RegexLib.alphaNumericCharsStr + ']' ),
	
	
		/**
		 * @inheritdoc
		 */
		parseMatches : function( text ) {
			var matcherRegex = this.matcherRegex,
			    nonWordCharRegex = this.nonWordCharRegex,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;
	
			while( ( match = matcherRegex.exec( text ) ) !== null ) {
				var offset = match.index,
				    prevChar = text.charAt( offset - 1 );
	
				// If we found the match at the beginning of the string, or we found the match
				// and there is a whitespace char in front of it (meaning it is not an email
				// address), then it is a username match.
				if( offset === 0 || nonWordCharRegex.test( prevChar ) ) {
					var matchedText = match[ 0 ],
					    twitterHandle = match[ 0 ].slice( 1 );  // strip off the '@' character at the beginning
	
					matches.push( new Autolinker.match.Twitter( {
						tagBuilder    : tagBuilder,
						matchedText   : matchedText,
						offset        : offset,
						twitterHandle : twitterHandle
					} ) );
				}
			}
	
			return matches;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.matcher.Url
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find URL matches in an input string.
	 *
	 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more details.
	 */
	Autolinker.matcher.Url = Autolinker.Util.extend( Autolinker.matcher.Matcher, {
	
		/**
		 * @cfg {Boolean} stripPrefix (required)
		 * @inheritdoc Autolinker#stripPrefix
		 */
	
	
		/**
		 * @private
		 * @property {RegExp} matcherRegex
		 *
		 * The regular expression to match URLs with an optional scheme, port
		 * number, path, query string, and hash anchor.
		 *
		 * Example matches:
		 *
		 *     http://google.com
		 *     www.google.com
		 *     google.com/path/to/file?q1=1&q2=2#myAnchor
		 *
		 *
		 * This regular expression will have the following capturing groups:
		 *
		 * 1.  Group that matches a scheme-prefixed URL (i.e. 'http://google.com').
		 *     This is used to match scheme URLs with just a single word, such as
		 *     'http://localhost', where we won't double check that the domain name
		 *     has at least one dot ('.') in it.
		 * 2.  Group that matches a 'www.' prefixed URL. This is only matched if the
		 *     'www.' text was not prefixed by a scheme (i.e.: not prefixed by
		 *     'http://', 'ftp:', etc.)
		 * 3.  A protocol-relative ('//') match for the case of a 'www.' prefixed
		 *     URL. Will be an empty string if it is not a protocol-relative match.
		 *     We need to know the character before the '//' in order to determine
		 *     if it is a valid match or the // was in a string we don't want to
		 *     auto-link.
		 * 4.  Group that matches a known TLD (top level domain), when a scheme
		 *     or 'www.'-prefixed domain is not matched.
		 * 5.  A protocol-relative ('//') match for the case of a known TLD prefixed
		 *     URL. Will be an empty string if it is not a protocol-relative match.
		 *     See #3 for more info.
		 */
		matcherRegex : (function() {
			var schemeRegex = /(?:[A-Za-z][-.+A-Za-z0-9]*:(?![A-Za-z][-.+A-Za-z0-9]*:\/\/)(?!\d+\/?)(?:\/\/)?)/,  // match protocol, allow in format "http://" or "mailto:". However, do not match the first part of something like 'link:http://www.google.com' (i.e. don't match "link:"). Also, make sure we don't interpret 'google.com:8000' as if 'google.com' was a protocol here (i.e. ignore a trailing port number in this regex)
			    wwwRegex = /(?:www\.)/,                  // starting with 'www.'
			    domainNameRegex = Autolinker.RegexLib.domainNameRegex,
			    tldRegex = Autolinker.RegexLib.tldRegex,  // match our known top level domains (TLDs)
			    alphaNumericCharsStr = Autolinker.RegexLib.alphaNumericCharsStr,
	
			    // Allow optional path, query string, and hash anchor, not ending in the following characters: "?!:,.;"
			    // http://blog.codinghorror.com/the-problem-with-urls/
			    urlSuffixRegex = new RegExp( '[' + alphaNumericCharsStr + '\\-+&@#/%=~_()|\'$*\\[\\]?!:,.;]*[' + alphaNumericCharsStr + '\\-+&@#/%=~_()|\'$*\\[\\]]' );
	
			return new RegExp( [
				'(?:', // parens to cover match for scheme (optional), and domain
					'(',  // *** Capturing group $1, for a scheme-prefixed url (ex: http://google.com)
						schemeRegex.source,
						domainNameRegex.source,
					')',
	
					'|',
	
					'(',  // *** Capturing group $2, for a 'www.' prefixed url (ex: www.google.com)
						'(//)?',  // *** Capturing group $3 for an optional protocol-relative URL. Must be at the beginning of the string or start with a non-word character (handled later)
						wwwRegex.source,
						domainNameRegex.source,
					')',
	
					'|',
	
					'(',  // *** Capturing group $4, for known a TLD url (ex: google.com)
						'(//)?',  // *** Capturing group $5 for an optional protocol-relative URL. Must be at the beginning of the string or start with a non-word character (handled later)
						domainNameRegex.source + '\\.',
						tldRegex.source,
					')',
				')',
	
				'(?:' + urlSuffixRegex.source + ')?'  // match for path, query string, and/or hash anchor - optional
			].join( "" ), 'gi' );
		} )(),
	
	
		/**
		 * A regular expression to use to check the character before a protocol-relative
		 * URL match. We don't want to match a protocol-relative URL if it is part
		 * of another word.
		 *
		 * For example, we want to match something like "Go to: //google.com",
		 * but we don't want to match something like "abc//google.com"
		 *
		 * This regular expression is used to test the character before the '//'.
		 *
		 * @private
		 * @type {RegExp} wordCharRegExp
		 */
		wordCharRegExp : /\w/,
	
	
		/**
		 * The regular expression to match opening parenthesis in a URL match.
		 *
		 * This is to determine if we have unbalanced parenthesis in the URL, and to
		 * drop the final parenthesis that was matched if so.
		 *
		 * Ex: The text "(check out: wikipedia.com/something_(disambiguation))"
		 * should only autolink the inner "wikipedia.com/something_(disambiguation)"
		 * part, so if we find that we have unbalanced parenthesis, we will drop the
		 * last one for the match.
		 *
		 * @private
		 * @property {RegExp}
		 */
		openParensRe : /\(/g,
	
		/**
		 * The regular expression to match closing parenthesis in a URL match. See
		 * {@link #openParensRe} for more information.
		 *
		 * @private
		 * @property {RegExp}
		 */
		closeParensRe : /\)/g,
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match instance,
		 *   specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.matcher.Matcher.prototype.constructor.call( this, cfg );
	
			this.stripPrefix = cfg.stripPrefix;
	
			if( this.stripPrefix == null ) throw new Error( '`stripPrefix` cfg required' );
		},
	
	
		/**
		 * @inheritdoc
		 */
		parseMatches : function( text ) {
			var matcherRegex = this.matcherRegex,
			    stripPrefix = this.stripPrefix,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;
	
			while( ( match = matcherRegex.exec( text ) ) !== null ) {
				var matchStr = match[ 0 ],
				    schemeUrlMatch = match[ 1 ],
				    wwwUrlMatch = match[ 2 ],
				    wwwProtocolRelativeMatch = match[ 3 ],
				    //tldUrlMatch = match[ 4 ],  -- not needed at the moment
				    tldProtocolRelativeMatch = match[ 5 ],
				    offset = match.index,
				    protocolRelativeMatch = wwwProtocolRelativeMatch || tldProtocolRelativeMatch,
					prevChar = text.charAt( offset - 1 );
	
				if( !Autolinker.matcher.UrlMatchValidator.isValid( matchStr, schemeUrlMatch ) ) {
					continue;
				}
	
				// If the match is preceded by an '@' character, then it is either
				// an email address or a username. Skip these types of matches.
				if( offset > 0 && prevChar === '@' ) {
					continue;
				}
	
				// If it's a protocol-relative '//' match, but the character before the '//'
				// was a word character (i.e. a letter/number), then we found the '//' in the
				// middle of another word (such as "asdf//asdf.com"). In this case, skip the
				// match.
				if( offset > 0 && protocolRelativeMatch && this.wordCharRegExp.test( prevChar ) ) {
					continue;
				}
	
				// Handle a closing parenthesis at the end of the match, and exclude
				// it if there is not a matching open parenthesis in the match
				// itself.
				if( this.matchHasUnbalancedClosingParen( matchStr ) ) {
					matchStr = matchStr.substr( 0, matchStr.length - 1 );  // remove the trailing ")"
				} else {
					// Handle an invalid character after the TLD
					var pos = this.matchHasInvalidCharAfterTld( matchStr, schemeUrlMatch );
					if( pos > -1 ) {
						matchStr = matchStr.substr( 0, pos ); // remove the trailing invalid chars
					}
				}
	
				var urlMatchType = schemeUrlMatch ? 'scheme' : ( wwwUrlMatch ? 'www' : 'tld' ),
				    protocolUrlMatch = !!schemeUrlMatch;
	
				matches.push( new Autolinker.match.Url( {
					tagBuilder            : tagBuilder,
					matchedText           : matchStr,
					offset                : offset,
					urlMatchType          : urlMatchType,
					url                   : matchStr,
					protocolUrlMatch      : protocolUrlMatch,
					protocolRelativeMatch : !!protocolRelativeMatch,
					stripPrefix           : stripPrefix
				} ) );
			}
	
			return matches;
		},
	
	
		/**
		 * Determines if a match found has an unmatched closing parenthesis. If so,
		 * this parenthesis will be removed from the match itself, and appended
		 * after the generated anchor tag.
		 *
		 * A match may have an extra closing parenthesis at the end of the match
		 * because the regular expression must include parenthesis for URLs such as
		 * "wikipedia.com/something_(disambiguation)", which should be auto-linked.
		 *
		 * However, an extra parenthesis *will* be included when the URL itself is
		 * wrapped in parenthesis, such as in the case of "(wikipedia.com/something_(disambiguation))".
		 * In this case, the last closing parenthesis should *not* be part of the
		 * URL itself, and this method will return `true`.
		 *
		 * @private
		 * @param {String} matchStr The full match string from the {@link #matcherRegex}.
		 * @return {Boolean} `true` if there is an unbalanced closing parenthesis at
		 *   the end of the `matchStr`, `false` otherwise.
		 */
		matchHasUnbalancedClosingParen : function( matchStr ) {
			var lastChar = matchStr.charAt( matchStr.length - 1 );
	
			if( lastChar === ')' ) {
				var openParensMatch = matchStr.match( this.openParensRe ),
				    closeParensMatch = matchStr.match( this.closeParensRe ),
				    numOpenParens = ( openParensMatch && openParensMatch.length ) || 0,
				    numCloseParens = ( closeParensMatch && closeParensMatch.length ) || 0;
	
				if( numOpenParens < numCloseParens ) {
					return true;
				}
			}
	
			return false;
		},
	
	
		/**
		 * Determine if there's an invalid character after the TLD in a URL. Valid
		 * characters after TLD are ':/?#'. Exclude scheme matched URLs from this
		 * check.
		 *
		 * @private
		 * @param {String} urlMatch The matched URL, if there was one. Will be an
		 *   empty string if the match is not a URL match.
		 * @param {String} schemeUrlMatch The match URL string for a scheme
		 *   match. Ex: 'http://yahoo.com'. This is used to match something like
		 *   'http://localhost', where we won't double check that the domain name
		 *   has at least one '.' in it.
		 * @return {Number} the position where the invalid character was found. If
		 *   no such character was found, returns -1
		 */
		matchHasInvalidCharAfterTld : function( urlMatch, schemeUrlMatch ) {
			if( !urlMatch ) {
				return -1;
			}
	
			var offset = 0;
			if ( schemeUrlMatch ) {
				offset = urlMatch.indexOf(':');
				urlMatch = urlMatch.slice(offset);
			}
	
			var re = /^((.?\/\/)?[A-Za-z0-9\u00C0-\u017F\.\-]*[A-Za-z0-9\u00C0-\u017F\-]\.[A-Za-z]+)/;
			var res = re.exec( urlMatch );
			if ( res === null ) {
				return -1;
			}
	
			offset += res[1].length;
			urlMatch = urlMatch.slice(res[1].length);
			if (/^[^.A-Za-z:\/?#]/.test(urlMatch)) {
				return offset;
			}
	
			return -1;
		}
	
	} );
	/*global Autolinker */
	/*jshint scripturl:true */
	/**
	 * @private
	 * @class Autolinker.matcher.UrlMatchValidator
	 * @singleton
	 *
	 * Used by Autolinker to filter out false URL positives from the
	 * {@link Autolinker.matcher.Url UrlMatcher}.
	 *
	 * Due to the limitations of regular expressions (including the missing feature
	 * of look-behinds in JS regular expressions), we cannot always determine the
	 * validity of a given match. This class applies a bit of additional logic to
	 * filter out any false positives that have been matched by the
	 * {@link Autolinker.matcher.Url UrlMatcher}.
	 */
	Autolinker.matcher.UrlMatchValidator = {
	
		/**
		 * Regex to test for a full protocol, with the two trailing slashes. Ex: 'http://'
		 *
		 * @private
		 * @property {RegExp} hasFullProtocolRegex
		 */
		hasFullProtocolRegex : /^[A-Za-z][-.+A-Za-z0-9]*:\/\//,
	
		/**
		 * Regex to find the URI scheme, such as 'mailto:'.
		 *
		 * This is used to filter out 'javascript:' and 'vbscript:' schemes.
		 *
		 * @private
		 * @property {RegExp} uriSchemeRegex
		 */
		uriSchemeRegex : /^[A-Za-z][-.+A-Za-z0-9]*:/,
	
		/**
		 * Regex to determine if at least one word char exists after the protocol (i.e. after the ':')
		 *
		 * @private
		 * @property {RegExp} hasWordCharAfterProtocolRegex
		 */
		hasWordCharAfterProtocolRegex : /:[^\s]*?[A-Za-z\u00C0-\u017F]/,
	
		/**
		 * Regex to determine if the string is a valid IP address
		 *
		 * @private
		 * @property {RegExp} ipRegex
		 */
		ipRegex: /[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?(:[0-9]*)?\/?$/,
	
		/**
		 * Determines if a given URL match found by the {@link Autolinker.matcher.Url UrlMatcher}
		 * is valid. Will return `false` for:
		 *
		 * 1) URL matches which do not have at least have one period ('.') in the
		 *    domain name (effectively skipping over matches like "abc:def").
		 *    However, URL matches with a protocol will be allowed (ex: 'http://localhost')
		 * 2) URL matches which do not have at least one word character in the
		 *    domain name (effectively skipping over matches like "git:1.0").
		 * 3) A protocol-relative url match (a URL beginning with '//') whose
		 *    previous character is a word character (effectively skipping over
		 *    strings like "abc//google.com")
		 *
		 * Otherwise, returns `true`.
		 *
		 * @param {String} urlMatch The matched URL, if there was one. Will be an
		 *   empty string if the match is not a URL match.
		 * @param {String} protocolUrlMatch The match URL string for a protocol
		 *   match. Ex: 'http://yahoo.com'. This is used to match something like
		 *   'http://localhost', where we won't double check that the domain name
		 *   has at least one '.' in it.
		 * @return {Boolean} `true` if the match given is valid and should be
		 *   processed, or `false` if the match is invalid and/or should just not be
		 *   processed.
		 */
		isValid : function( urlMatch, protocolUrlMatch ) {
			if(
				( protocolUrlMatch && !this.isValidUriScheme( protocolUrlMatch ) ) ||
				this.urlMatchDoesNotHaveProtocolOrDot( urlMatch, protocolUrlMatch ) ||    // At least one period ('.') must exist in the URL match for us to consider it an actual URL, *unless* it was a full protocol match (like 'http://localhost')
				(this.urlMatchDoesNotHaveAtLeastOneWordChar( urlMatch, protocolUrlMatch ) && // At least one letter character must exist in the domain name after a protocol match. Ex: skip over something like "git:1.0"
				 !this.isValidIpAddress( urlMatch ) // Except if it's an IP address
				)
			) {
				return false;
			}
	
			return true;
		},
	
	
		isValidIpAddress : function ( uriSchemeMatch ) {
			var newRegex = new RegExp(this.hasFullProtocolRegex.source + this.ipRegex.source);
			var uriScheme = uriSchemeMatch.match( newRegex );
	
			return uriScheme !== null;
		},
	
		/**
		 * Determines if the URI scheme is a valid scheme to be autolinked. Returns
		 * `false` if the scheme is 'javascript:' or 'vbscript:'
		 *
		 * @private
		 * @param {String} uriSchemeMatch The match URL string for a full URI scheme
		 *   match. Ex: 'http://yahoo.com' or 'mailto:a@a.com'.
		 * @return {Boolean} `true` if the scheme is a valid one, `false` otherwise.
		 */
		isValidUriScheme : function( uriSchemeMatch ) {
			var uriScheme = uriSchemeMatch.match( this.uriSchemeRegex )[ 0 ].toLowerCase();
	
			return ( uriScheme !== 'javascript:' && uriScheme !== 'vbscript:' );
		},
	
	
		/**
		 * Determines if a URL match does not have either:
		 *
		 * a) a full protocol (i.e. 'http://'), or
		 * b) at least one dot ('.') in the domain name (for a non-full-protocol
		 *    match).
		 *
		 * Either situation is considered an invalid URL (ex: 'git:d' does not have
		 * either the '://' part, or at least one dot in the domain name. If the
		 * match was 'git:abc.com', we would consider this valid.)
		 *
		 * @private
		 * @param {String} urlMatch The matched URL, if there was one. Will be an
		 *   empty string if the match is not a URL match.
		 * @param {String} protocolUrlMatch The match URL string for a protocol
		 *   match. Ex: 'http://yahoo.com'. This is used to match something like
		 *   'http://localhost', where we won't double check that the domain name
		 *   has at least one '.' in it.
		 * @return {Boolean} `true` if the URL match does not have a full protocol,
		 *   or at least one dot ('.') in a non-full-protocol match.
		 */
		urlMatchDoesNotHaveProtocolOrDot : function( urlMatch, protocolUrlMatch ) {
			return ( !!urlMatch && ( !protocolUrlMatch || !this.hasFullProtocolRegex.test( protocolUrlMatch ) ) && urlMatch.indexOf( '.' ) === -1 );
		},
	
	
		/**
		 * Determines if a URL match does not have at least one word character after
		 * the protocol (i.e. in the domain name).
		 *
		 * At least one letter character must exist in the domain name after a
		 * protocol match. Ex: skip over something like "git:1.0"
		 *
		 * @private
		 * @param {String} urlMatch The matched URL, if there was one. Will be an
		 *   empty string if the match is not a URL match.
		 * @param {String} protocolUrlMatch The match URL string for a protocol
		 *   match. Ex: 'http://yahoo.com'. This is used to know whether or not we
		 *   have a protocol in the URL string, in order to check for a word
		 *   character after the protocol separator (':').
		 * @return {Boolean} `true` if the URL match does not have at least one word
		 *   character in it after the protocol, `false` otherwise.
		 */
		urlMatchDoesNotHaveAtLeastOneWordChar : function( urlMatch, protocolUrlMatch ) {
			if( urlMatch && protocolUrlMatch ) {
				return !this.hasWordCharAfterProtocolRegex.test( urlMatch );
			} else {
				return false;
			}
		}
	
	};
	/*global Autolinker */
	/**
	 * A truncation feature where the ellipsis will be placed at the end of the URL.
	 *
	 * @param {String} anchorText
	 * @param {Number} truncateLen The maximum length of the truncated output URL string.
	 * @param {String} ellipsisChars The characters to place within the url, e.g. "..".
	 * @return {String} The truncated URL.
	 */
	Autolinker.truncate.TruncateEnd = function(anchorText, truncateLen, ellipsisChars){
		return Autolinker.Util.ellipsis( anchorText, truncateLen, ellipsisChars );
	};
	
	/*global Autolinker */
	/**
	 * Date: 2015-10-05
	 * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
	 *
	 * A truncation feature, where the ellipsis will be placed in the dead-center of the URL.
	 *
	 * @param {String} url             A URL.
	 * @param {Number} truncateLen     The maximum length of the truncated output URL string.
	 * @param {String} ellipsisChars   The characters to place within the url, e.g. "..".
	 * @return {String} The truncated URL.
	 */
	Autolinker.truncate.TruncateMiddle = function(url, truncateLen, ellipsisChars){
	  if (url.length <= truncateLen) {
	    return url;
	  }
	  var availableLength = truncateLen - ellipsisChars.length;
	  var end = "";
	  if (availableLength > 0) {
	    end = url.substr((-1)*Math.floor(availableLength/2));
	  }
	  return (url.substr(0, Math.ceil(availableLength/2)) + ellipsisChars + end).substr(0, truncateLen);
	};
	
	/*global Autolinker */
	/**
	 * Date: 2015-10-05
	 * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
	 *
	 * A truncation feature, where the ellipsis will be placed at a section within
	 * the URL making it still somewhat human readable.
	 *
	 * @param {String} url						 A URL.
	 * @param {Number} truncateLen		 The maximum length of the truncated output URL string.
	 * @param {String} ellipsisChars	 The characters to place within the url, e.g. "..".
	 * @return {String} The truncated URL.
	 */
	Autolinker.truncate.TruncateSmart = function(url, truncateLen, ellipsisChars){
		var parse_url = function(url){ // Functionality inspired by PHP function of same name
			var urlObj = {};
			var urlSub = url;
			var match = urlSub.match(/^([a-z]+):\/\//i);
			if (match) {
				urlObj.scheme = match[1];
				urlSub = urlSub.substr(match[0].length);
			}
			match = urlSub.match(/^(.*?)(?=(\?|#|\/|$))/i);
			if (match) {
				urlObj.host = match[1];
				urlSub = urlSub.substr(match[0].length);
			}
			match = urlSub.match(/^\/(.*?)(?=(\?|#|$))/i);
			if (match) {
				urlObj.path = match[1];
				urlSub = urlSub.substr(match[0].length);
			}
			match = urlSub.match(/^\?(.*?)(?=(#|$))/i);
			if (match) {
				urlObj.query = match[1];
				urlSub = urlSub.substr(match[0].length);
			}
			match = urlSub.match(/^#(.*?)$/i);
			if (match) {
				urlObj.fragment = match[1];
				//urlSub = urlSub.substr(match[0].length);  -- not used. Uncomment if adding another block.
			}
			return urlObj;
		};
	
		var buildUrl = function(urlObj){
			var url = "";
			if (urlObj.scheme && urlObj.host) {
				url += urlObj.scheme + "://";
			}
			if (urlObj.host) {
				url += urlObj.host;
			}
			if (urlObj.path) {
				url += "/" + urlObj.path;
			}
			if (urlObj.query) {
				url += "?" + urlObj.query;
			}
			if (urlObj.fragment) {
				url += "#" + urlObj.fragment;
			}
			return url;
		};
	
		var buildSegment = function(segment, remainingAvailableLength){
			var remainingAvailableLengthHalf = remainingAvailableLength/ 2,
					startOffset = Math.ceil(remainingAvailableLengthHalf),
					endOffset = (-1)*Math.floor(remainingAvailableLengthHalf),
					end = "";
			if (endOffset < 0) {
				end = segment.substr(endOffset);
			}
			return segment.substr(0, startOffset) + ellipsisChars + end;
		};
		if (url.length <= truncateLen) {
			return url;
		}
		var availableLength = truncateLen - ellipsisChars.length;
		var urlObj = parse_url(url);
		// Clean up the URL
		if (urlObj.query) {
			var matchQuery = urlObj.query.match(/^(.*?)(?=(\?|\#))(.*?)$/i);
			if (matchQuery) {
				// Malformed URL; two or more "?". Removed any content behind the 2nd.
				urlObj.query = urlObj.query.substr(0, matchQuery[1].length);
				url = buildUrl(urlObj);
			}
		}
		if (url.length <= truncateLen) {
			return url;
		}
		if (urlObj.host) {
			urlObj.host = urlObj.host.replace(/^www\./, "");
			url = buildUrl(urlObj);
		}
		if (url.length <= truncateLen) {
			return url;
		}
		// Process and build the URL
		var str = "";
		if (urlObj.host) {
			str += urlObj.host;
		}
		if (str.length >= availableLength) {
			if (urlObj.host.length == truncateLen) {
				return (urlObj.host.substr(0, (truncateLen - ellipsisChars.length)) + ellipsisChars).substr(0, truncateLen);
			}
			return buildSegment(str, availableLength).substr(0, truncateLen);
		}
		var pathAndQuery = "";
		if (urlObj.path) {
			pathAndQuery += "/" + urlObj.path;
		}
		if (urlObj.query) {
			pathAndQuery += "?" + urlObj.query;
		}
		if (pathAndQuery) {
			if ((str+pathAndQuery).length >= availableLength) {
				if ((str+pathAndQuery).length == truncateLen) {
					return (str + pathAndQuery).substr(0, truncateLen);
				}
				var remainingAvailableLength = availableLength - str.length;
				return (str + buildSegment(pathAndQuery, remainingAvailableLength)).substr(0, truncateLen);
			} else {
				str += pathAndQuery;
			}
		}
		if (urlObj.fragment) {
			var fragment = "#"+urlObj.fragment;
			if ((str+fragment).length >= availableLength) {
				if ((str+fragment).length == truncateLen) {
					return (str + fragment).substr(0, truncateLen);
				}
				var remainingAvailableLength2 = availableLength - str.length;
				return (str + buildSegment(fragment, remainingAvailableLength2)).substr(0, truncateLen);
			} else {
				str += fragment;
			}
		}
		if (urlObj.scheme && urlObj.host) {
			var scheme = urlObj.scheme + "://";
			if ((str+scheme).length < availableLength) {
				return (scheme + str).substr(0, truncateLen);
			}
		}
		if (str.length <= truncateLen) {
			return str;
		}
		var end = "";
		if (availableLength > 0) {
			end = str.substr((-1)*Math.floor(availableLength/2));
		}
		return (str.substr(0, Math.ceil(availableLength/2)) + ellipsisChars + end).substr(0, truncateLen);
	};
	
	return Autolinker;
	}));


/***/ }),

/***/ 217:
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.buble = global.buble || {})));
	}(this, function (exports) { 'use strict';
	
	  var __commonjs_global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : this;
	  function __commonjs(fn, module) { return module = { exports: {} }, fn(module, module.exports, __commonjs_global), module.exports; }
	
	  var acorn = __commonjs(function (module, exports, global) {
	  (function (global, factory) {
	    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	     true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) :
	    (factory((global.acorn = global.acorn || {})));
	  }(__commonjs_global, function (exports) { 'use strict';
	
	    // Reserved word lists for various dialects of the language
	
	    var reservedWords = {
	      3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
	      5: "class enum extends super const export import",
	      6: "enum",
	      7: "enum",
	      strict: "implements interface let package private protected public static yield",
	      strictBind: "eval arguments"
	    }
	
	    // And the keywords
	
	    var ecma5AndLessKeywords = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"
	
	    var keywords = {
	      5: ecma5AndLessKeywords,
	      6: ecma5AndLessKeywords + " const class extends export import super"
	    }
	
	    // ## Character categories
	
	    // Big ugly regular expressions that match characters in the
	    // whitespace, identifier, and identifier-start categories. These
	    // are only applied when a character is found to actually have a
	    // code point above 128.
	    // Generated by `bin/generate-identifier-regex.js`.
	
	    var nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u037f\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u052f\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0-\u08b4\u08b6-\u08bd\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0af9\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c39\u0c3d\u0c58-\u0c5a\u0c60\u0c61\u0c80\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d54-\u0d56\u0d5f-\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f5\u13f8-\u13fd\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f8\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191e\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19b0-\u19c9\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1c80-\u1c88\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2118-\u211d\u2124\u2126\u2128\u212a-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309b-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fd5\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua69d\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua7ae\ua7b0-\ua7b7\ua7f7-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua8fd\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\ua9e0-\ua9e4\ua9e6-\ua9ef\ua9fa-\ua9fe\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa7e-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uab30-\uab5a\uab5c-\uab65\uab70-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc"
	    var nonASCIIidentifierChars = "\u200c\u200d\xb7\u0300-\u036f\u0387\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u0669\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7\u06e8\u06ea-\u06ed\u06f0-\u06f9\u0711\u0730-\u074a\u07a6-\u07b0\u07c0-\u07c9\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u08d4-\u08e1\u08e3-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09cb-\u09cd\u09d7\u09e2\u09e3\u09e6-\u09ef\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c00-\u0c03\u0c3e-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0c66-\u0c6f\u0c81-\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0ce6-\u0cef\u0d01-\u0d03\u0d3e-\u0d44\u0d46-\u0d48\u0d4a-\u0d4d\u0d57\u0d62\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0de6-\u0def\u0df2\u0df3\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0e50-\u0e59\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f3e\u0f3f\u0f71-\u0f84\u0f86\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u102b-\u103e\u1040-\u1049\u1056-\u1059\u105e-\u1060\u1062-\u1064\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u1369-\u1371\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b4-\u17d3\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u18a9\u1920-\u192b\u1930-\u193b\u1946-\u194f\u19d0-\u19da\u1a17-\u1a1b\u1a55-\u1a5e\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1ab0-\u1abd\u1b00-\u1b04\u1b34-\u1b44\u1b50-\u1b59\u1b6b-\u1b73\u1b80-\u1b82\u1ba1-\u1bad\u1bb0-\u1bb9\u1be6-\u1bf3\u1c24-\u1c37\u1c40-\u1c49\u1c50-\u1c59\u1cd0-\u1cd2\u1cd4-\u1ce8\u1ced\u1cf2-\u1cf4\u1cf8\u1cf9\u1dc0-\u1df5\u1dfb-\u1dff\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2cef-\u2cf1\u2d7f\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua620-\ua629\ua66f\ua674-\ua67d\ua69e\ua69f\ua6f0\ua6f1\ua802\ua806\ua80b\ua823-\ua827\ua880\ua881\ua8b4-\ua8c5\ua8d0-\ua8d9\ua8e0-\ua8f1\ua900-\ua909\ua926-\ua92d\ua947-\ua953\ua980-\ua983\ua9b3-\ua9c0\ua9d0-\ua9d9\ua9e5\ua9f0-\ua9f9\uaa29-\uaa36\uaa43\uaa4c\uaa4d\uaa50-\uaa59\uaa7b-\uaa7d\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uaaeb-\uaaef\uaaf5\uaaf6\uabe3-\uabea\uabec\uabed\uabf0-\uabf9\ufb1e\ufe00-\ufe0f\ufe20-\ufe2f\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f"
	
	    var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]")
	    var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]")
	
	    nonASCIIidentifierStartChars = nonASCIIidentifierChars = null
	
	    // These are a run-length and offset encoded representation of the
	    // >0xffff code points that are a valid part of identifiers. The
	    // offset starts at 0x10000, and each pair of numbers represents an
	    // offset to the next range, and then a size of the range. They were
	    // generated by bin/generate-identifier-regex.js
	    var astralIdentifierStartCodes = [0,11,2,25,2,18,2,1,2,14,3,13,35,122,70,52,268,28,4,48,48,31,17,26,6,37,11,29,3,35,5,7,2,4,43,157,19,35,5,35,5,39,9,51,157,310,10,21,11,7,153,5,3,0,2,43,2,1,4,0,3,22,11,22,10,30,66,18,2,1,11,21,11,25,71,55,7,1,65,0,16,3,2,2,2,26,45,28,4,28,36,7,2,27,28,53,11,21,11,18,14,17,111,72,56,50,14,50,785,52,76,44,33,24,27,35,42,34,4,0,13,47,15,3,22,0,2,0,36,17,2,24,85,6,2,0,2,3,2,14,2,9,8,46,39,7,3,1,3,21,2,6,2,1,2,4,4,0,19,0,13,4,159,52,19,3,54,47,21,1,2,0,185,46,42,3,37,47,21,0,60,42,86,25,391,63,32,0,449,56,264,8,2,36,18,0,50,29,881,921,103,110,18,195,2749,1070,4050,582,8634,568,8,30,114,29,19,47,17,3,32,20,6,18,881,68,12,0,67,12,65,0,32,6124,20,754,9486,1,3071,106,6,12,4,8,8,9,5991,84,2,70,2,1,3,0,3,1,3,3,2,11,2,0,2,6,2,64,2,3,3,7,2,6,2,27,2,3,2,4,2,0,4,6,2,339,3,24,2,24,2,30,2,24,2,30,2,24,2,30,2,24,2,30,2,24,2,7,4149,196,60,67,1213,3,2,26,2,1,2,0,3,0,2,9,2,3,2,0,2,0,7,0,5,0,2,0,2,0,2,2,2,1,2,0,3,0,2,0,2,0,2,0,2,0,2,1,2,0,3,3,2,6,2,3,2,3,2,0,2,9,2,16,6,2,2,4,2,16,4421,42710,42,4148,12,221,3,5761,10591,541]
	    var astralIdentifierCodes = [509,0,227,0,150,4,294,9,1368,2,2,1,6,3,41,2,5,0,166,1,1306,2,54,14,32,9,16,3,46,10,54,9,7,2,37,13,2,9,52,0,13,2,49,13,10,2,4,9,83,11,7,0,161,11,6,9,7,3,57,0,2,6,3,1,3,2,10,0,11,1,3,6,4,4,193,17,10,9,87,19,13,9,214,6,3,8,28,1,83,16,16,9,82,12,9,9,84,14,5,9,423,9,838,7,2,7,17,9,57,21,2,13,19882,9,135,4,60,6,26,9,1016,45,17,3,19723,1,5319,4,4,5,9,7,3,6,31,3,149,2,1418,49,513,54,5,49,9,0,15,0,23,4,2,14,1361,6,2,16,3,6,2,1,2,4,2214,6,110,6,6,9,792487,239]
	
	    // This has a complexity linear to the value of the code. The
	    // assumption is that looking up astral identifier characters is
	    // rare.
	    function isInAstralSet(code, set) {
	      var pos = 0x10000
	      for (var i = 0; i < set.length; i += 2) {
	        pos += set[i]
	        if (pos > code) return false
	        pos += set[i + 1]
	        if (pos >= code) return true
	      }
	    }
	
	    // Test whether a given character code starts an identifier.
	
	    function isIdentifierStart(code, astral) {
	      if (code < 65) return code === 36
	      if (code < 91) return true
	      if (code < 97) return code === 95
	      if (code < 123) return true
	      if (code <= 0xffff) return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code))
	      if (astral === false) return false
	      return isInAstralSet(code, astralIdentifierStartCodes)
	    }
	
	    // Test whether a given character is part of an identifier.
	
	    function isIdentifierChar(code, astral) {
	      if (code < 48) return code === 36
	      if (code < 58) return true
	      if (code < 65) return false
	      if (code < 91) return true
	      if (code < 97) return code === 95
	      if (code < 123) return true
	      if (code <= 0xffff) return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code))
	      if (astral === false) return false
	      return isInAstralSet(code, astralIdentifierStartCodes) || isInAstralSet(code, astralIdentifierCodes)
	    }
	
	    // ## Token types
	
	    // The assignment of fine-grained, information-carrying type objects
	    // allows the tokenizer to store the information it has about a
	    // token in a way that is very cheap for the parser to look up.
	
	    // All token type variables start with an underscore, to make them
	    // easy to recognize.
	
	    // The `beforeExpr` property is used to disambiguate between regular
	    // expressions and divisions. It is set on all token types that can
	    // be followed by an expression (thus, a slash after them would be a
	    // regular expression).
	    //
	    // The `startsExpr` property is used to check if the token ends a
	    // `yield` expression. It is set on all token types that either can
	    // directly start an expression (like a quotation mark) or can
	    // continue an expression (like the body of a string).
	    //
	    // `isLoop` marks a keyword as starting a loop, which is important
	    // to know when parsing a label, in order to allow or disallow
	    // continue jumps to that label.
	
	    var TokenType = function TokenType(label, conf) {
	      if ( conf === void 0 ) conf = {};
	
	      this.label = label
	      this.keyword = conf.keyword
	      this.beforeExpr = !!conf.beforeExpr
	      this.startsExpr = !!conf.startsExpr
	      this.isLoop = !!conf.isLoop
	      this.isAssign = !!conf.isAssign
	      this.prefix = !!conf.prefix
	      this.postfix = !!conf.postfix
	      this.binop = conf.binop || null
	      this.updateContext = null
	    };
	
	    function binop(name, prec) {
	      return new TokenType(name, {beforeExpr: true, binop: prec})
	    }
	    var beforeExpr = {beforeExpr: true};
	    var startsExpr = {startsExpr: true};
	    // Map keyword names to token types.
	
	    var keywordTypes = {}
	
	    // Succinct definitions of keyword token types
	    function kw(name, options) {
	      if ( options === void 0 ) options = {};
	
	      options.keyword = name
	      return keywordTypes[name] = new TokenType(name, options)
	    }
	
	    var tt = {
	      num: new TokenType("num", startsExpr),
	      regexp: new TokenType("regexp", startsExpr),
	      string: new TokenType("string", startsExpr),
	      name: new TokenType("name", startsExpr),
	      eof: new TokenType("eof"),
	
	      // Punctuation token types.
	      bracketL: new TokenType("[", {beforeExpr: true, startsExpr: true}),
	      bracketR: new TokenType("]"),
	      braceL: new TokenType("{", {beforeExpr: true, startsExpr: true}),
	      braceR: new TokenType("}"),
	      parenL: new TokenType("(", {beforeExpr: true, startsExpr: true}),
	      parenR: new TokenType(")"),
	      comma: new TokenType(",", beforeExpr),
	      semi: new TokenType(";", beforeExpr),
	      colon: new TokenType(":", beforeExpr),
	      dot: new TokenType("."),
	      question: new TokenType("?", beforeExpr),
	      arrow: new TokenType("=>", beforeExpr),
	      template: new TokenType("template"),
	      ellipsis: new TokenType("...", beforeExpr),
	      backQuote: new TokenType("`", startsExpr),
	      dollarBraceL: new TokenType("${", {beforeExpr: true, startsExpr: true}),
	
	      // Operators. These carry several kinds of properties to help the
	      // parser use them properly (the presence of these properties is
	      // what categorizes them as operators).
	      //
	      // `binop`, when present, specifies that this operator is a binary
	      // operator, and will refer to its precedence.
	      //
	      // `prefix` and `postfix` mark the operator as a prefix or postfix
	      // unary operator.
	      //
	      // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
	      // binary operators with a very low precedence, that should result
	      // in AssignmentExpression nodes.
	
	      eq: new TokenType("=", {beforeExpr: true, isAssign: true}),
	      assign: new TokenType("_=", {beforeExpr: true, isAssign: true}),
	      incDec: new TokenType("++/--", {prefix: true, postfix: true, startsExpr: true}),
	      prefix: new TokenType("prefix", {beforeExpr: true, prefix: true, startsExpr: true}),
	      logicalOR: binop("||", 1),
	      logicalAND: binop("&&", 2),
	      bitwiseOR: binop("|", 3),
	      bitwiseXOR: binop("^", 4),
	      bitwiseAND: binop("&", 5),
	      equality: binop("==/!=", 6),
	      relational: binop("</>", 7),
	      bitShift: binop("<</>>", 8),
	      plusMin: new TokenType("+/-", {beforeExpr: true, binop: 9, prefix: true, startsExpr: true}),
	      modulo: binop("%", 10),
	      star: binop("*", 10),
	      slash: binop("/", 10),
	      starstar: new TokenType("**", {beforeExpr: true}),
	
	      // Keyword token types.
	      _break: kw("break"),
	      _case: kw("case", beforeExpr),
	      _catch: kw("catch"),
	      _continue: kw("continue"),
	      _debugger: kw("debugger"),
	      _default: kw("default", beforeExpr),
	      _do: kw("do", {isLoop: true, beforeExpr: true}),
	      _else: kw("else", beforeExpr),
	      _finally: kw("finally"),
	      _for: kw("for", {isLoop: true}),
	      _function: kw("function", startsExpr),
	      _if: kw("if"),
	      _return: kw("return", beforeExpr),
	      _switch: kw("switch"),
	      _throw: kw("throw", beforeExpr),
	      _try: kw("try"),
	      _var: kw("var"),
	      _const: kw("const"),
	      _while: kw("while", {isLoop: true}),
	      _with: kw("with"),
	      _new: kw("new", {beforeExpr: true, startsExpr: true}),
	      _this: kw("this", startsExpr),
	      _super: kw("super", startsExpr),
	      _class: kw("class"),
	      _extends: kw("extends", beforeExpr),
	      _export: kw("export"),
	      _import: kw("import"),
	      _null: kw("null", startsExpr),
	      _true: kw("true", startsExpr),
	      _false: kw("false", startsExpr),
	      _in: kw("in", {beforeExpr: true, binop: 7}),
	      _instanceof: kw("instanceof", {beforeExpr: true, binop: 7}),
	      _typeof: kw("typeof", {beforeExpr: true, prefix: true, startsExpr: true}),
	      _void: kw("void", {beforeExpr: true, prefix: true, startsExpr: true}),
	      _delete: kw("delete", {beforeExpr: true, prefix: true, startsExpr: true})
	    }
	
	    // Matches a whole line break (where CRLF is considered a single
	    // line break). Used to count lines.
	
	    var lineBreak = /\r\n?|\n|\u2028|\u2029/
	    var lineBreakG = new RegExp(lineBreak.source, "g")
	
	    function isNewLine(code) {
	      return code === 10 || code === 13 || code === 0x2028 || code == 0x2029
	    }
	
	    var nonASCIIwhitespace = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/
	
	    var skipWhiteSpace = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g
	
	    function isArray(obj) {
	      return Object.prototype.toString.call(obj) === "[object Array]"
	    }
	
	    // Checks if an object has a property.
	
	    function has(obj, propName) {
	      return Object.prototype.hasOwnProperty.call(obj, propName)
	    }
	
	    // These are used when `options.locations` is on, for the
	    // `startLoc` and `endLoc` properties.
	
	    var Position = function Position(line, col) {
	      this.line = line
	      this.column = col
	    };
	
	    Position.prototype.offset = function offset (n) {
	      return new Position(this.line, this.column + n)
	    };
	
	    var SourceLocation = function SourceLocation(p, start, end) {
	      this.start = start
	      this.end = end
	      if (p.sourceFile !== null) this.source = p.sourceFile
	    };
	
	    // The `getLineInfo` function is mostly useful when the
	    // `locations` option is off (for performance reasons) and you
	    // want to find the line/column position for a given character
	    // offset. `input` should be the code string that the offset refers
	    // into.
	
	    function getLineInfo(input, offset) {
	      for (var line = 1, cur = 0;;) {
	        lineBreakG.lastIndex = cur
	        var match = lineBreakG.exec(input)
	        if (match && match.index < offset) {
	          ++line
	          cur = match.index + match[0].length
	        } else {
	          return new Position(line, offset - cur)
	        }
	      }
	    }
	
	    // A second optional argument can be given to further configure
	    // the parser process. These options are recognized:
	
	    var defaultOptions = {
	      // `ecmaVersion` indicates the ECMAScript version to parse. Must
	      // be either 3, or 5, or 6. This influences support for strict
	      // mode, the set of reserved words, support for getters and
	      // setters and other features. The default is 6.
	      ecmaVersion: 6,
	      // Source type ("script" or "module") for different semantics
	      sourceType: "script",
	      // `onInsertedSemicolon` can be a callback that will be called
	      // when a semicolon is automatically inserted. It will be passed
	      // th position of the comma as an offset, and if `locations` is
	      // enabled, it is given the location as a `{line, column}` object
	      // as second argument.
	      onInsertedSemicolon: null,
	      // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
	      // trailing commas.
	      onTrailingComma: null,
	      // By default, reserved words are only enforced if ecmaVersion >= 5.
	      // Set `allowReserved` to a boolean value to explicitly turn this on
	      // an off. When this option has the value "never", reserved words
	      // and keywords can also not be used as property names.
	      allowReserved: null,
	      // When enabled, a return at the top level is not considered an
	      // error.
	      allowReturnOutsideFunction: false,
	      // When enabled, import/export statements are not constrained to
	      // appearing at the top of the program.
	      allowImportExportEverywhere: false,
	      // When enabled, hashbang directive in the beginning of file
	      // is allowed and treated as a line comment.
	      allowHashBang: false,
	      // When `locations` is on, `loc` properties holding objects with
	      // `start` and `end` properties in `{line, column}` form (with
	      // line being 1-based and column 0-based) will be attached to the
	      // nodes.
	      locations: false,
	      // A function can be passed as `onToken` option, which will
	      // cause Acorn to call that function with object in the same
	      // format as tokens returned from `tokenizer().getToken()`. Note
	      // that you are not allowed to call the parser from the
	      // callback—that will corrupt its internal state.
	      onToken: null,
	      // A function can be passed as `onComment` option, which will
	      // cause Acorn to call that function with `(block, text, start,
	      // end)` parameters whenever a comment is skipped. `block` is a
	      // boolean indicating whether this is a block (`/* */`) comment,
	      // `text` is the content of the comment, and `start` and `end` are
	      // character offsets that denote the start and end of the comment.
	      // When the `locations` option is on, two more parameters are
	      // passed, the full `{line, column}` locations of the start and
	      // end of the comments. Note that you are not allowed to call the
	      // parser from the callback—that will corrupt its internal state.
	      onComment: null,
	      // Nodes have their start and end characters offsets recorded in
	      // `start` and `end` properties (directly on the node, rather than
	      // the `loc` object, which holds line/column data. To also add a
	      // [semi-standardized][range] `range` property holding a `[start,
	      // end]` array with the same numbers, set the `ranges` option to
	      // `true`.
	      //
	      // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
	      ranges: false,
	      // It is possible to parse multiple files into a single AST by
	      // passing the tree produced by parsing the first file as
	      // `program` option in subsequent parses. This will add the
	      // toplevel forms of the parsed file to the `Program` (top) node
	      // of an existing parse tree.
	      program: null,
	      // When `locations` is on, you can pass this to record the source
	      // file in every node's `loc` object.
	      sourceFile: null,
	      // This value, if given, is stored in every node, whether
	      // `locations` is on or off.
	      directSourceFile: null,
	      // When enabled, parenthesized expressions are represented by
	      // (non-standard) ParenthesizedExpression nodes
	      preserveParens: false,
	      plugins: {}
	    }
	
	    // Interpret and default an options object
	
	    function getOptions(opts) {
	      var options = {}
	      for (var opt in defaultOptions)
	        options[opt] = opts && has(opts, opt) ? opts[opt] : defaultOptions[opt]
	      if (options.allowReserved == null)
	        options.allowReserved = options.ecmaVersion < 5
	
	      if (isArray(options.onToken)) {
	        var tokens = options.onToken
	        options.onToken = function (token) { return tokens.push(token); }
	      }
	      if (isArray(options.onComment))
	        options.onComment = pushComment(options, options.onComment)
	
	      return options
	    }
	
	    function pushComment(options, array) {
	      return function (block, text, start, end, startLoc, endLoc) {
	        var comment = {
	          type: block ? 'Block' : 'Line',
	          value: text,
	          start: start,
	          end: end
	        }
	        if (options.locations)
	          comment.loc = new SourceLocation(this, startLoc, endLoc)
	        if (options.ranges)
	          comment.range = [start, end]
	        array.push(comment)
	      }
	    }
	
	    // Registered plugins
	    var plugins = {}
	
	    function keywordRegexp(words) {
	      return new RegExp("^(" + words.replace(/ /g, "|") + ")$")
	    }
	
	    var Parser = function Parser(options, input, startPos) {
	      this.options = options = getOptions(options)
	      this.sourceFile = options.sourceFile
	      this.keywords = keywordRegexp(keywords[options.ecmaVersion >= 6 ? 6 : 5])
	      var reserved = options.allowReserved ? "" :
	          reservedWords[options.ecmaVersion] + (options.sourceType == "module" ? " await" : "")
	      this.reservedWords = keywordRegexp(reserved)
	      var reservedStrict = (reserved ? reserved + " " : "") + reservedWords.strict
	      this.reservedWordsStrict = keywordRegexp(reservedStrict)
	      this.reservedWordsStrictBind = keywordRegexp(reservedStrict + " " + reservedWords.strictBind)
	      this.input = String(input)
	
	      // Used to signal to callers of `readWord1` whether the word
	      // contained any escape sequences. This is needed because words with
	      // escape sequences must not be interpreted as keywords.
	      this.containsEsc = false
	
	      // Load plugins
	      this.loadPlugins(options.plugins)
	
	      // Set up token state
	
	      // The current position of the tokenizer in the input.
	      if (startPos) {
	        this.pos = startPos
	        this.lineStart = Math.max(0, this.input.lastIndexOf("\n", startPos))
	        this.curLine = this.input.slice(0, this.lineStart).split(lineBreak).length
	      } else {
	        this.pos = this.lineStart = 0
	        this.curLine = 1
	      }
	
	      // Properties of the current token:
	      // Its type
	      this.type = tt.eof
	      // For tokens that include more information than their type, the value
	      this.value = null
	      // Its start and end offset
	      this.start = this.end = this.pos
	      // And, if locations are used, the {line, column} object
	      // corresponding to those offsets
	      this.startLoc = this.endLoc = this.curPosition()
	
	      // Position information for the previous token
	      this.lastTokEndLoc = this.lastTokStartLoc = null
	      this.lastTokStart = this.lastTokEnd = this.pos
	
	      // The context stack is used to superficially track syntactic
	      // context to predict whether a regular expression is allowed in a
	      // given position.
	      this.context = this.initialContext()
	      this.exprAllowed = true
	
	      // Figure out if it's a module code.
	      this.strict = this.inModule = options.sourceType === "module"
	
	      // Used to signify the start of a potential arrow function
	      this.potentialArrowAt = -1
	
	      // Flags to track whether we are in a function, a generator.
	      this.inFunction = this.inGenerator = false
	      // Labels in scope.
	      this.labels = []
	
	      // If enabled, skip leading hashbang line.
	      if (this.pos === 0 && options.allowHashBang && this.input.slice(0, 2) === '#!')
	        this.skipLineComment(2)
	    };
	
	    // DEPRECATED Kept for backwards compatibility until 3.0 in case a plugin uses them
	    Parser.prototype.isKeyword = function isKeyword (word) { return this.keywords.test(word) };
	    Parser.prototype.isReservedWord = function isReservedWord (word) { return this.reservedWords.test(word) };
	
	    Parser.prototype.extend = function extend (name, f) {
	      this[name] = f(this[name])
	    };
	
	    Parser.prototype.loadPlugins = function loadPlugins (pluginConfigs) {
	        var this$1 = this;
	
	      for (var name in pluginConfigs) {
	        var plugin = plugins[name]
	        if (!plugin) throw new Error("Plugin '" + name + "' not found")
	        plugin(this$1, pluginConfigs[name])
	      }
	    };
	
	    Parser.prototype.parse = function parse () {
	      var node = this.options.program || this.startNode()
	      this.nextToken()
	      return this.parseTopLevel(node)
	    };
	
	    var pp = Parser.prototype
	
	    // ## Parser utilities
	
	    // Test whether a statement node is the string literal `"use strict"`.
	
	    pp.isUseStrict = function(stmt) {
	      return this.options.ecmaVersion >= 5 && stmt.type === "ExpressionStatement" &&
	        stmt.expression.type === "Literal" &&
	        stmt.expression.raw.slice(1, -1) === "use strict"
	    }
	
	    // Predicate that tests whether the next token is of the given
	    // type, and if yes, consumes it as a side effect.
	
	    pp.eat = function(type) {
	      if (this.type === type) {
	        this.next()
	        return true
	      } else {
	        return false
	      }
	    }
	
	    // Tests whether parsed token is a contextual keyword.
	
	    pp.isContextual = function(name) {
	      return this.type === tt.name && this.value === name
	    }
	
	    // Consumes contextual keyword if possible.
	
	    pp.eatContextual = function(name) {
	      return this.value === name && this.eat(tt.name)
	    }
	
	    // Asserts that following token is given contextual keyword.
	
	    pp.expectContextual = function(name) {
	      if (!this.eatContextual(name)) this.unexpected()
	    }
	
	    // Test whether a semicolon can be inserted at the current position.
	
	    pp.canInsertSemicolon = function() {
	      return this.type === tt.eof ||
	        this.type === tt.braceR ||
	        lineBreak.test(this.input.slice(this.lastTokEnd, this.start))
	    }
	
	    pp.insertSemicolon = function() {
	      if (this.canInsertSemicolon()) {
	        if (this.options.onInsertedSemicolon)
	          this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc)
	        return true
	      }
	    }
	
	    // Consume a semicolon, or, failing that, see if we are allowed to
	    // pretend that there is a semicolon at this position.
	
	    pp.semicolon = function() {
	      if (!this.eat(tt.semi) && !this.insertSemicolon()) this.unexpected()
	    }
	
	    pp.afterTrailingComma = function(tokType) {
	      if (this.type == tokType) {
	        if (this.options.onTrailingComma)
	          this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc)
	        this.next()
	        return true
	      }
	    }
	
	    // Expect a token of a given type. If found, consume it, otherwise,
	    // raise an unexpected token error.
	
	    pp.expect = function(type) {
	      this.eat(type) || this.unexpected()
	    }
	
	    // Raise an unexpected token error.
	
	    pp.unexpected = function(pos) {
	      this.raise(pos != null ? pos : this.start, "Unexpected token")
	    }
	
	    var DestructuringErrors = function DestructuringErrors() {
	      this.shorthandAssign = 0
	      this.trailingComma = 0
	    };
	
	    pp.checkPatternErrors = function(refDestructuringErrors, andThrow) {
	      var trailing = refDestructuringErrors && refDestructuringErrors.trailingComma
	      if (!andThrow) return !!trailing
	      if (trailing) this.raise(trailing, "Comma is not permitted after the rest element")
	    }
	
	    pp.checkExpressionErrors = function(refDestructuringErrors, andThrow) {
	      var pos = refDestructuringErrors && refDestructuringErrors.shorthandAssign
	      if (!andThrow) return !!pos
	      if (pos) this.raise(pos, "Shorthand property assignments are valid only in destructuring patterns")
	    }
	
	    var pp$1 = Parser.prototype
	
	    // ### Statement parsing
	
	    // Parse a program. Initializes the parser, reads any number of
	    // statements, and wraps them in a Program node.  Optionally takes a
	    // `program` argument.  If present, the statements will be appended
	    // to its body instead of creating a new node.
	
	    pp$1.parseTopLevel = function(node) {
	      var this$1 = this;
	
	      var first = true
	      if (!node.body) node.body = []
	      while (this.type !== tt.eof) {
	        var stmt = this$1.parseStatement(true, true)
	        node.body.push(stmt)
	        if (first) {
	          if (this$1.isUseStrict(stmt)) this$1.setStrict(true)
	          first = false
	        }
	      }
	      this.next()
	      if (this.options.ecmaVersion >= 6) {
	        node.sourceType = this.options.sourceType
	      }
	      return this.finishNode(node, "Program")
	    }
	
	    var loopLabel = {kind: "loop"};
	    var switchLabel = {kind: "switch"};
	    pp$1.isLet = function() {
	      if (this.type !== tt.name || this.options.ecmaVersion < 6 || this.value != "let") return false
	      skipWhiteSpace.lastIndex = this.pos
	      var skip = skipWhiteSpace.exec(this.input)
	      var next = this.pos + skip[0].length, nextCh = this.input.charCodeAt(next)
	      if (nextCh === 91 || nextCh == 123) return true // '{' and '['
	      if (isIdentifierStart(nextCh, true)) {
	        for (var pos = next + 1; isIdentifierChar(this.input.charCodeAt(pos), true); ++pos) {}
	        var ident = this.input.slice(next, pos)
	        if (!this.isKeyword(ident)) return true
	      }
	      return false
	    }
	
	    // Parse a single statement.
	    //
	    // If expecting a statement and finding a slash operator, parse a
	    // regular expression literal. This is to handle cases like
	    // `if (foo) /blah/.exec(foo)`, where looking at the previous token
	    // does not help.
	
	    pp$1.parseStatement = function(declaration, topLevel) {
	      var starttype = this.type, node = this.startNode(), kind
	
	      if (this.isLet()) {
	        starttype = tt._var
	        kind = "let"
	      }
	
	      // Most types of statements are recognized by the keyword they
	      // start with. Many are trivial to parse, some require a bit of
	      // complexity.
	
	      switch (starttype) {
	      case tt._break: case tt._continue: return this.parseBreakContinueStatement(node, starttype.keyword)
	      case tt._debugger: return this.parseDebuggerStatement(node)
	      case tt._do: return this.parseDoStatement(node)
	      case tt._for: return this.parseForStatement(node)
	      case tt._function:
	        if (!declaration && this.options.ecmaVersion >= 6) this.unexpected()
	        return this.parseFunctionStatement(node)
	      case tt._class:
	        if (!declaration) this.unexpected()
	        return this.parseClass(node, true)
	      case tt._if: return this.parseIfStatement(node)
	      case tt._return: return this.parseReturnStatement(node)
	      case tt._switch: return this.parseSwitchStatement(node)
	      case tt._throw: return this.parseThrowStatement(node)
	      case tt._try: return this.parseTryStatement(node)
	      case tt._const: case tt._var:
	        kind = kind || this.value
	        if (!declaration && kind != "var") this.unexpected()
	        return this.parseVarStatement(node, kind)
	      case tt._while: return this.parseWhileStatement(node)
	      case tt._with: return this.parseWithStatement(node)
	      case tt.braceL: return this.parseBlock()
	      case tt.semi: return this.parseEmptyStatement(node)
	      case tt._export:
	      case tt._import:
	        if (!this.options.allowImportExportEverywhere) {
	          if (!topLevel)
	            this.raise(this.start, "'import' and 'export' may only appear at the top level")
	          if (!this.inModule)
	            this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")
	        }
	        return starttype === tt._import ? this.parseImport(node) : this.parseExport(node)
	
	        // If the statement does not start with a statement keyword or a
	        // brace, it's an ExpressionStatement or LabeledStatement. We
	        // simply start parsing an expression, and afterwards, if the
	        // next token is a colon and the expression was a simple
	        // Identifier node, we switch to interpreting it as a label.
	      default:
	        var maybeName = this.value, expr = this.parseExpression()
	        if (starttype === tt.name && expr.type === "Identifier" && this.eat(tt.colon))
	          return this.parseLabeledStatement(node, maybeName, expr)
	        else return this.parseExpressionStatement(node, expr)
	      }
	    }
	
	    pp$1.parseBreakContinueStatement = function(node, keyword) {
	      var this$1 = this;
	
	      var isBreak = keyword == "break"
	      this.next()
	      if (this.eat(tt.semi) || this.insertSemicolon()) node.label = null
	      else if (this.type !== tt.name) this.unexpected()
	      else {
	        node.label = this.parseIdent()
	        this.semicolon()
	      }
	
	      // Verify that there is an actual destination to break or
	      // continue to.
	      for (var i = 0; i < this.labels.length; ++i) {
	        var lab = this$1.labels[i]
	        if (node.label == null || lab.name === node.label.name) {
	          if (lab.kind != null && (isBreak || lab.kind === "loop")) break
	          if (node.label && isBreak) break
	        }
	      }
	      if (i === this.labels.length) this.raise(node.start, "Unsyntactic " + keyword)
	      return this.finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement")
	    }
	
	    pp$1.parseDebuggerStatement = function(node) {
	      this.next()
	      this.semicolon()
	      return this.finishNode(node, "DebuggerStatement")
	    }
	
	    pp$1.parseDoStatement = function(node) {
	      this.next()
	      this.labels.push(loopLabel)
	      node.body = this.parseStatement(false)
	      this.labels.pop()
	      this.expect(tt._while)
	      node.test = this.parseParenExpression()
	      if (this.options.ecmaVersion >= 6)
	        this.eat(tt.semi)
	      else
	        this.semicolon()
	      return this.finishNode(node, "DoWhileStatement")
	    }
	
	    // Disambiguating between a `for` and a `for`/`in` or `for`/`of`
	    // loop is non-trivial. Basically, we have to parse the init `var`
	    // statement or expression, disallowing the `in` operator (see
	    // the second parameter to `parseExpression`), and then check
	    // whether the next token is `in` or `of`. When there is no init
	    // part (semicolon immediately after the opening parenthesis), it
	    // is a regular `for` loop.
	
	    pp$1.parseForStatement = function(node) {
	      this.next()
	      this.labels.push(loopLabel)
	      this.expect(tt.parenL)
	      if (this.type === tt.semi) return this.parseFor(node, null)
	      var isLet = this.isLet()
	      if (this.type === tt._var || this.type === tt._const || isLet) {
	        var init$1 = this.startNode(), kind = isLet ? "let" : this.value
	        this.next()
	        this.parseVar(init$1, true, kind)
	        this.finishNode(init$1, "VariableDeclaration")
	        if ((this.type === tt._in || (this.options.ecmaVersion >= 6 && this.isContextual("of"))) && init$1.declarations.length === 1 &&
	            !(kind !== "var" && init$1.declarations[0].init))
	          return this.parseForIn(node, init$1)
	        return this.parseFor(node, init$1)
	      }
	      var refDestructuringErrors = new DestructuringErrors
	      var init = this.parseExpression(true, refDestructuringErrors)
	      if (this.type === tt._in || (this.options.ecmaVersion >= 6 && this.isContextual("of"))) {
	        this.checkPatternErrors(refDestructuringErrors, true)
	        this.toAssignable(init)
	        this.checkLVal(init)
	        return this.parseForIn(node, init)
	      } else {
	        this.checkExpressionErrors(refDestructuringErrors, true)
	      }
	      return this.parseFor(node, init)
	    }
	
	    pp$1.parseFunctionStatement = function(node) {
	      this.next()
	      return this.parseFunction(node, true)
	    }
	
	    pp$1.parseIfStatement = function(node) {
	      this.next()
	      node.test = this.parseParenExpression()
	      node.consequent = this.parseStatement(false)
	      node.alternate = this.eat(tt._else) ? this.parseStatement(false) : null
	      return this.finishNode(node, "IfStatement")
	    }
	
	    pp$1.parseReturnStatement = function(node) {
	      if (!this.inFunction && !this.options.allowReturnOutsideFunction)
	        this.raise(this.start, "'return' outside of function")
	      this.next()
	
	      // In `return` (and `break`/`continue`), the keywords with
	      // optional arguments, we eagerly look for a semicolon or the
	      // possibility to insert one.
	
	      if (this.eat(tt.semi) || this.insertSemicolon()) node.argument = null
	      else { node.argument = this.parseExpression(); this.semicolon() }
	      return this.finishNode(node, "ReturnStatement")
	    }
	
	    pp$1.parseSwitchStatement = function(node) {
	      var this$1 = this;
	
	      this.next()
	      node.discriminant = this.parseParenExpression()
	      node.cases = []
	      this.expect(tt.braceL)
	      this.labels.push(switchLabel)
	
	      // Statements under must be grouped (by label) in SwitchCase
	      // nodes. `cur` is used to keep the node that we are currently
	      // adding statements to.
	
	      for (var cur, sawDefault = false; this.type != tt.braceR;) {
	        if (this$1.type === tt._case || this$1.type === tt._default) {
	          var isCase = this$1.type === tt._case
	          if (cur) this$1.finishNode(cur, "SwitchCase")
	          node.cases.push(cur = this$1.startNode())
	          cur.consequent = []
	          this$1.next()
	          if (isCase) {
	            cur.test = this$1.parseExpression()
	          } else {
	            if (sawDefault) this$1.raiseRecoverable(this$1.lastTokStart, "Multiple default clauses")
	            sawDefault = true
	            cur.test = null
	          }
	          this$1.expect(tt.colon)
	        } else {
	          if (!cur) this$1.unexpected()
	          cur.consequent.push(this$1.parseStatement(true))
	        }
	      }
	      if (cur) this.finishNode(cur, "SwitchCase")
	      this.next() // Closing brace
	      this.labels.pop()
	      return this.finishNode(node, "SwitchStatement")
	    }
	
	    pp$1.parseThrowStatement = function(node) {
	      this.next()
	      if (lineBreak.test(this.input.slice(this.lastTokEnd, this.start)))
	        this.raise(this.lastTokEnd, "Illegal newline after throw")
	      node.argument = this.parseExpression()
	      this.semicolon()
	      return this.finishNode(node, "ThrowStatement")
	    }
	
	    // Reused empty array added for node fields that are always empty.
	
	    var empty = []
	
	    pp$1.parseTryStatement = function(node) {
	      this.next()
	      node.block = this.parseBlock()
	      node.handler = null
	      if (this.type === tt._catch) {
	        var clause = this.startNode()
	        this.next()
	        this.expect(tt.parenL)
	        clause.param = this.parseBindingAtom()
	        this.checkLVal(clause.param, true)
	        this.expect(tt.parenR)
	        clause.body = this.parseBlock()
	        node.handler = this.finishNode(clause, "CatchClause")
	      }
	      node.finalizer = this.eat(tt._finally) ? this.parseBlock() : null
	      if (!node.handler && !node.finalizer)
	        this.raise(node.start, "Missing catch or finally clause")
	      return this.finishNode(node, "TryStatement")
	    }
	
	    pp$1.parseVarStatement = function(node, kind) {
	      this.next()
	      this.parseVar(node, false, kind)
	      this.semicolon()
	      return this.finishNode(node, "VariableDeclaration")
	    }
	
	    pp$1.parseWhileStatement = function(node) {
	      this.next()
	      node.test = this.parseParenExpression()
	      this.labels.push(loopLabel)
	      node.body = this.parseStatement(false)
	      this.labels.pop()
	      return this.finishNode(node, "WhileStatement")
	    }
	
	    pp$1.parseWithStatement = function(node) {
	      if (this.strict) this.raise(this.start, "'with' in strict mode")
	      this.next()
	      node.object = this.parseParenExpression()
	      node.body = this.parseStatement(false)
	      return this.finishNode(node, "WithStatement")
	    }
	
	    pp$1.parseEmptyStatement = function(node) {
	      this.next()
	      return this.finishNode(node, "EmptyStatement")
	    }
	
	    pp$1.parseLabeledStatement = function(node, maybeName, expr) {
	      var this$1 = this;
	
	      for (var i = 0; i < this.labels.length; ++i)
	        if (this$1.labels[i].name === maybeName) this$1.raise(expr.start, "Label '" + maybeName + "' is already declared")
	      var kind = this.type.isLoop ? "loop" : this.type === tt._switch ? "switch" : null
	      for (var i$1 = this.labels.length - 1; i$1 >= 0; i$1--) {
	        var label = this$1.labels[i$1]
	        if (label.statementStart == node.start) {
	          label.statementStart = this$1.start
	          label.kind = kind
	        } else break
	      }
	      this.labels.push({name: maybeName, kind: kind, statementStart: this.start})
	      node.body = this.parseStatement(true)
	      this.labels.pop()
	      node.label = expr
	      return this.finishNode(node, "LabeledStatement")
	    }
	
	    pp$1.parseExpressionStatement = function(node, expr) {
	      node.expression = expr
	      this.semicolon()
	      return this.finishNode(node, "ExpressionStatement")
	    }
	
	    // Parse a semicolon-enclosed block of statements, handling `"use
	    // strict"` declarations when `allowStrict` is true (used for
	    // function bodies).
	
	    pp$1.parseBlock = function(allowStrict) {
	      var this$1 = this;
	
	      var node = this.startNode(), first = true, oldStrict
	      node.body = []
	      this.expect(tt.braceL)
	      while (!this.eat(tt.braceR)) {
	        var stmt = this$1.parseStatement(true)
	        node.body.push(stmt)
	        if (first && allowStrict && this$1.isUseStrict(stmt)) {
	          oldStrict = this$1.strict
	          this$1.setStrict(this$1.strict = true)
	        }
	        first = false
	      }
	      if (oldStrict === false) this.setStrict(false)
	      return this.finishNode(node, "BlockStatement")
	    }
	
	    // Parse a regular `for` loop. The disambiguation code in
	    // `parseStatement` will already have parsed the init statement or
	    // expression.
	
	    pp$1.parseFor = function(node, init) {
	      node.init = init
	      this.expect(tt.semi)
	      node.test = this.type === tt.semi ? null : this.parseExpression()
	      this.expect(tt.semi)
	      node.update = this.type === tt.parenR ? null : this.parseExpression()
	      this.expect(tt.parenR)
	      node.body = this.parseStatement(false)
	      this.labels.pop()
	      return this.finishNode(node, "ForStatement")
	    }
	
	    // Parse a `for`/`in` and `for`/`of` loop, which are almost
	    // same from parser's perspective.
	
	    pp$1.parseForIn = function(node, init) {
	      var type = this.type === tt._in ? "ForInStatement" : "ForOfStatement"
	      this.next()
	      node.left = init
	      node.right = this.parseExpression()
	      this.expect(tt.parenR)
	      node.body = this.parseStatement(false)
	      this.labels.pop()
	      return this.finishNode(node, type)
	    }
	
	    // Parse a list of variable declarations.
	
	    pp$1.parseVar = function(node, isFor, kind) {
	      var this$1 = this;
	
	      node.declarations = []
	      node.kind = kind
	      for (;;) {
	        var decl = this$1.startNode()
	        this$1.parseVarId(decl)
	        if (this$1.eat(tt.eq)) {
	          decl.init = this$1.parseMaybeAssign(isFor)
	        } else if (kind === "const" && !(this$1.type === tt._in || (this$1.options.ecmaVersion >= 6 && this$1.isContextual("of")))) {
	          this$1.unexpected()
	        } else if (decl.id.type != "Identifier" && !(isFor && (this$1.type === tt._in || this$1.isContextual("of")))) {
	          this$1.raise(this$1.lastTokEnd, "Complex binding patterns require an initialization value")
	        } else {
	          decl.init = null
	        }
	        node.declarations.push(this$1.finishNode(decl, "VariableDeclarator"))
	        if (!this$1.eat(tt.comma)) break
	      }
	      return node
	    }
	
	    pp$1.parseVarId = function(decl) {
	      decl.id = this.parseBindingAtom()
	      this.checkLVal(decl.id, true)
	    }
	
	    // Parse a function declaration or literal (depending on the
	    // `isStatement` parameter).
	
	    pp$1.parseFunction = function(node, isStatement, allowExpressionBody) {
	      this.initFunction(node)
	      if (this.options.ecmaVersion >= 6)
	        node.generator = this.eat(tt.star)
	      var oldInGen = this.inGenerator
	      this.inGenerator = node.generator
	      if (isStatement || this.type === tt.name)
	        node.id = this.parseIdent()
	      this.parseFunctionParams(node)
	      this.parseFunctionBody(node, allowExpressionBody)
	      this.inGenerator = oldInGen
	      return this.finishNode(node, isStatement ? "FunctionDeclaration" : "FunctionExpression")
	    }
	
	    pp$1.parseFunctionParams = function(node) {
	      this.expect(tt.parenL)
	      node.params = this.parseBindingList(tt.parenR, false, false, true)
	    }
	
	    // Parse a class declaration or literal (depending on the
	    // `isStatement` parameter).
	
	    pp$1.parseClass = function(node, isStatement) {
	      var this$1 = this;
	
	      this.next()
	      this.parseClassId(node, isStatement)
	      this.parseClassSuper(node)
	      var classBody = this.startNode()
	      var hadConstructor = false
	      classBody.body = []
	      this.expect(tt.braceL)
	      while (!this.eat(tt.braceR)) {
	        if (this$1.eat(tt.semi)) continue
	        var method = this$1.startNode()
	        var isGenerator = this$1.eat(tt.star)
	        var isMaybeStatic = this$1.type === tt.name && this$1.value === "static"
	        this$1.parsePropertyName(method)
	        method.static = isMaybeStatic && this$1.type !== tt.parenL
	        if (method.static) {
	          if (isGenerator) this$1.unexpected()
	          isGenerator = this$1.eat(tt.star)
	          this$1.parsePropertyName(method)
	        }
	        method.kind = "method"
	        var isGetSet = false
	        if (!method.computed) {
	          var key = method.key;
	          if (!isGenerator && key.type === "Identifier" && this$1.type !== tt.parenL && (key.name === "get" || key.name === "set")) {
	            isGetSet = true
	            method.kind = key.name
	            key = this$1.parsePropertyName(method)
	          }
	          if (!method.static && (key.type === "Identifier" && key.name === "constructor" ||
	              key.type === "Literal" && key.value === "constructor")) {
	            if (hadConstructor) this$1.raise(key.start, "Duplicate constructor in the same class")
	            if (isGetSet) this$1.raise(key.start, "Constructor can't have get/set modifier")
	            if (isGenerator) this$1.raise(key.start, "Constructor can't be a generator")
	            method.kind = "constructor"
	            hadConstructor = true
	          }
	        }
	        this$1.parseClassMethod(classBody, method, isGenerator)
	        if (isGetSet) {
	          var paramCount = method.kind === "get" ? 0 : 1
	          if (method.value.params.length !== paramCount) {
	            var start = method.value.start
	            if (method.kind === "get")
	              this$1.raiseRecoverable(start, "getter should have no params")
	            else
	              this$1.raiseRecoverable(start, "setter should have exactly one param")
	          }
	          if (method.kind === "set" && method.value.params[0].type === "RestElement")
	            this$1.raise(method.value.params[0].start, "Setter cannot use rest params")
	        }
	      }
	      node.body = this.finishNode(classBody, "ClassBody")
	      return this.finishNode(node, isStatement ? "ClassDeclaration" : "ClassExpression")
	    }
	
	    pp$1.parseClassMethod = function(classBody, method, isGenerator) {
	      method.value = this.parseMethod(isGenerator)
	      classBody.body.push(this.finishNode(method, "MethodDefinition"))
	    }
	
	    pp$1.parseClassId = function(node, isStatement) {
	      node.id = this.type === tt.name ? this.parseIdent() : isStatement ? this.unexpected() : null
	    }
	
	    pp$1.parseClassSuper = function(node) {
	      node.superClass = this.eat(tt._extends) ? this.parseExprSubscripts() : null
	    }
	
	    // Parses module export declaration.
	
	    pp$1.parseExport = function(node) {
	      var this$1 = this;
	
	      this.next()
	      // export * from '...'
	      if (this.eat(tt.star)) {
	        this.expectContextual("from")
	        node.source = this.type === tt.string ? this.parseExprAtom() : this.unexpected()
	        this.semicolon()
	        return this.finishNode(node, "ExportAllDeclaration")
	      }
	      if (this.eat(tt._default)) { // export default ...
	        var parens = this.type == tt.parenL
	        var expr = this.parseMaybeAssign()
	        var needsSemi = true
	        if (!parens && (expr.type == "FunctionExpression" ||
	                        expr.type == "ClassExpression")) {
	          needsSemi = false
	          if (expr.id) {
	            expr.type = expr.type == "FunctionExpression"
	              ? "FunctionDeclaration"
	              : "ClassDeclaration"
	          }
	        }
	        node.declaration = expr
	        if (needsSemi) this.semicolon()
	        return this.finishNode(node, "ExportDefaultDeclaration")
	      }
	      // export var|const|let|function|class ...
	      if (this.shouldParseExportStatement()) {
	        node.declaration = this.parseStatement(true)
	        node.specifiers = []
	        node.source = null
	      } else { // export { x, y as z } [from '...']
	        node.declaration = null
	        node.specifiers = this.parseExportSpecifiers()
	        if (this.eatContextual("from")) {
	          node.source = this.type === tt.string ? this.parseExprAtom() : this.unexpected()
	        } else {
	          // check for keywords used as local names
	          for (var i = 0; i < node.specifiers.length; i++) {
	            if (this$1.keywords.test(node.specifiers[i].local.name) || this$1.reservedWords.test(node.specifiers[i].local.name)) {
	              this$1.unexpected(node.specifiers[i].local.start)
	            }
	          }
	
	          node.source = null
	        }
	        this.semicolon()
	      }
	      return this.finishNode(node, "ExportNamedDeclaration")
	    }
	
	    pp$1.shouldParseExportStatement = function() {
	      return this.type.keyword || this.isLet()
	    }
	
	    // Parses a comma-separated list of module exports.
	
	    pp$1.parseExportSpecifiers = function() {
	      var this$1 = this;
	
	      var nodes = [], first = true
	      // export { x, y as z } [from '...']
	      this.expect(tt.braceL)
	      while (!this.eat(tt.braceR)) {
	        if (!first) {
	          this$1.expect(tt.comma)
	          if (this$1.afterTrailingComma(tt.braceR)) break
	        } else first = false
	
	        var node = this$1.startNode()
	        node.local = this$1.parseIdent(this$1.type === tt._default)
	        node.exported = this$1.eatContextual("as") ? this$1.parseIdent(true) : node.local
	        nodes.push(this$1.finishNode(node, "ExportSpecifier"))
	      }
	      return nodes
	    }
	
	    // Parses import declaration.
	
	    pp$1.parseImport = function(node) {
	      this.next()
	      // import '...'
	      if (this.type === tt.string) {
	        node.specifiers = empty
	        node.source = this.parseExprAtom()
	      } else {
	        node.specifiers = this.parseImportSpecifiers()
	        this.expectContextual("from")
	        node.source = this.type === tt.string ? this.parseExprAtom() : this.unexpected()
	      }
	      this.semicolon()
	      return this.finishNode(node, "ImportDeclaration")
	    }
	
	    // Parses a comma-separated list of module imports.
	
	    pp$1.parseImportSpecifiers = function() {
	      var this$1 = this;
	
	      var nodes = [], first = true
	      if (this.type === tt.name) {
	        // import defaultObj, { x, y as z } from '...'
	        var node = this.startNode()
	        node.local = this.parseIdent()
	        this.checkLVal(node.local, true)
	        nodes.push(this.finishNode(node, "ImportDefaultSpecifier"))
	        if (!this.eat(tt.comma)) return nodes
	      }
	      if (this.type === tt.star) {
	        var node$1 = this.startNode()
	        this.next()
	        this.expectContextual("as")
	        node$1.local = this.parseIdent()
	        this.checkLVal(node$1.local, true)
	        nodes.push(this.finishNode(node$1, "ImportNamespaceSpecifier"))
	        return nodes
	      }
	      this.expect(tt.braceL)
	      while (!this.eat(tt.braceR)) {
	        if (!first) {
	          this$1.expect(tt.comma)
	          if (this$1.afterTrailingComma(tt.braceR)) break
	        } else first = false
	
	        var node$2 = this$1.startNode()
	        node$2.imported = this$1.parseIdent(true)
	        if (this$1.eatContextual("as")) {
	          node$2.local = this$1.parseIdent()
	        } else {
	          node$2.local = node$2.imported
	          if (this$1.isKeyword(node$2.local.name)) this$1.unexpected(node$2.local.start)
	          if (this$1.reservedWordsStrict.test(node$2.local.name)) this$1.raise(node$2.local.start, "The keyword '" + node$2.local.name + "' is reserved")
	        }
	        this$1.checkLVal(node$2.local, true)
	        nodes.push(this$1.finishNode(node$2, "ImportSpecifier"))
	      }
	      return nodes
	    }
	
	    var pp$2 = Parser.prototype
	
	    // Convert existing expression atom to assignable pattern
	    // if possible.
	
	    pp$2.toAssignable = function(node, isBinding) {
	      var this$1 = this;
	
	      if (this.options.ecmaVersion >= 6 && node) {
	        switch (node.type) {
	        case "Identifier":
	        case "ObjectPattern":
	        case "ArrayPattern":
	          break
	
	        case "ObjectExpression":
	          node.type = "ObjectPattern"
	          for (var i = 0; i < node.properties.length; i++) {
	            var prop = node.properties[i]
	            if (prop.kind !== "init") this$1.raise(prop.key.start, "Object pattern can't contain getter or setter")
	            this$1.toAssignable(prop.value, isBinding)
	          }
	          break
	
	        case "ArrayExpression":
	          node.type = "ArrayPattern"
	          this.toAssignableList(node.elements, isBinding)
	          break
	
	        case "AssignmentExpression":
	          if (node.operator === "=") {
	            node.type = "AssignmentPattern"
	            delete node.operator
	            // falls through to AssignmentPattern
	          } else {
	            this.raise(node.left.end, "Only '=' operator can be used for specifying default value.")
	            break
	          }
	
	        case "AssignmentPattern":
	          if (node.right.type === "YieldExpression")
	            this.raise(node.right.start, "Yield expression cannot be a default value")
	          break
	
	        case "ParenthesizedExpression":
	          node.expression = this.toAssignable(node.expression, isBinding)
	          break
	
	        case "MemberExpression":
	          if (!isBinding) break
	
	        default:
	          this.raise(node.start, "Assigning to rvalue")
	        }
	      }
	      return node
	    }
	
	    // Convert list of expression atoms to binding list.
	
	    pp$2.toAssignableList = function(exprList, isBinding) {
	      var this$1 = this;
	
	      var end = exprList.length
	      if (end) {
	        var last = exprList[end - 1]
	        if (last && last.type == "RestElement") {
	          --end
	        } else if (last && last.type == "SpreadElement") {
	          last.type = "RestElement"
	          var arg = last.argument
	          this.toAssignable(arg, isBinding)
	          if (arg.type !== "Identifier" && arg.type !== "MemberExpression" && arg.type !== "ArrayPattern")
	            this.unexpected(arg.start)
	          --end
	        }
	
	        if (isBinding && last && last.type === "RestElement" && last.argument.type !== "Identifier")
	          this.unexpected(last.argument.start)
	      }
	      for (var i = 0; i < end; i++) {
	        var elt = exprList[i]
	        if (elt) this$1.toAssignable(elt, isBinding)
	      }
	      return exprList
	    }
	
	    // Parses spread element.
	
	    pp$2.parseSpread = function(refDestructuringErrors) {
	      var node = this.startNode()
	      this.next()
	      node.argument = this.parseMaybeAssign(false, refDestructuringErrors)
	      return this.finishNode(node, "SpreadElement")
	    }
	
	    pp$2.parseRest = function(allowNonIdent) {
	      var node = this.startNode()
	      this.next()
	
	      // RestElement inside of a function parameter must be an identifier
	      if (allowNonIdent) node.argument = this.type === tt.name ? this.parseIdent() : this.unexpected()
	      else node.argument = this.type === tt.name || this.type === tt.bracketL ? this.parseBindingAtom() : this.unexpected()
	
	      return this.finishNode(node, "RestElement")
	    }
	
	    // Parses lvalue (assignable) atom.
	
	    pp$2.parseBindingAtom = function() {
	      if (this.options.ecmaVersion < 6) return this.parseIdent()
	      switch (this.type) {
	      case tt.name:
	        return this.parseIdent()
	
	      case tt.bracketL:
	        var node = this.startNode()
	        this.next()
	        node.elements = this.parseBindingList(tt.bracketR, true, true)
	        return this.finishNode(node, "ArrayPattern")
	
	      case tt.braceL:
	        return this.parseObj(true)
	
	      default:
	        this.unexpected()
	      }
	    }
	
	    pp$2.parseBindingList = function(close, allowEmpty, allowTrailingComma, allowNonIdent) {
	      var this$1 = this;
	
	      var elts = [], first = true
	      while (!this.eat(close)) {
	        if (first) first = false
	        else this$1.expect(tt.comma)
	        if (allowEmpty && this$1.type === tt.comma) {
	          elts.push(null)
	        } else if (allowTrailingComma && this$1.afterTrailingComma(close)) {
	          break
	        } else if (this$1.type === tt.ellipsis) {
	          var rest = this$1.parseRest(allowNonIdent)
	          this$1.parseBindingListItem(rest)
	          elts.push(rest)
	          if (this$1.type === tt.comma) this$1.raise(this$1.start, "Comma is not permitted after the rest element")
	          this$1.expect(close)
	          break
	        } else {
	          var elem = this$1.parseMaybeDefault(this$1.start, this$1.startLoc)
	          this$1.parseBindingListItem(elem)
	          elts.push(elem)
	        }
	      }
	      return elts
	    }
	
	    pp$2.parseBindingListItem = function(param) {
	      return param
	    }
	
	    // Parses assignment pattern around given atom if possible.
	
	    pp$2.parseMaybeDefault = function(startPos, startLoc, left) {
	      left = left || this.parseBindingAtom()
	      if (this.options.ecmaVersion < 6 || !this.eat(tt.eq)) return left
	      var node = this.startNodeAt(startPos, startLoc)
	      node.left = left
	      node.right = this.parseMaybeAssign()
	      return this.finishNode(node, "AssignmentPattern")
	    }
	
	    // Verify that a node is an lval — something that can be assigned
	    // to.
	
	    pp$2.checkLVal = function(expr, isBinding, checkClashes) {
	      var this$1 = this;
	
	      switch (expr.type) {
	      case "Identifier":
	        if (this.strict && this.reservedWordsStrictBind.test(expr.name))
	          this.raiseRecoverable(expr.start, (isBinding ? "Binding " : "Assigning to ") + expr.name + " in strict mode")
	        if (checkClashes) {
	          if (has(checkClashes, expr.name))
	            this.raiseRecoverable(expr.start, "Argument name clash")
	          checkClashes[expr.name] = true
	        }
	        break
	
	      case "MemberExpression":
	        if (isBinding) this.raiseRecoverable(expr.start, (isBinding ? "Binding" : "Assigning to") + " member expression")
	        break
	
	      case "ObjectPattern":
	        for (var i = 0; i < expr.properties.length; i++)
	          this$1.checkLVal(expr.properties[i].value, isBinding, checkClashes)
	        break
	
	      case "ArrayPattern":
	        for (var i$1 = 0; i$1 < expr.elements.length; i$1++) {
	          var elem = expr.elements[i$1]
	          if (elem) this$1.checkLVal(elem, isBinding, checkClashes)
	        }
	        break
	
	      case "AssignmentPattern":
	        this.checkLVal(expr.left, isBinding, checkClashes)
	        break
	
	      case "RestElement":
	        this.checkLVal(expr.argument, isBinding, checkClashes)
	        break
	
	      case "ParenthesizedExpression":
	        this.checkLVal(expr.expression, isBinding, checkClashes)
	        break
	
	      default:
	        this.raise(expr.start, (isBinding ? "Binding" : "Assigning to") + " rvalue")
	      }
	    }
	
	    var pp$3 = Parser.prototype
	
	    // Check if property name clashes with already added.
	    // Object/class getters and setters are not allowed to clash —
	    // either with each other or with an init property — and in
	    // strict mode, init properties are also not allowed to be repeated.
	
	    pp$3.checkPropClash = function(prop, propHash) {
	      if (this.options.ecmaVersion >= 6 && (prop.computed || prop.method || prop.shorthand))
	        return
	      var key = prop.key;
	      var name
	      switch (key.type) {
	      case "Identifier": name = key.name; break
	      case "Literal": name = String(key.value); break
	      default: return
	      }
	      var kind = prop.kind;
	      if (this.options.ecmaVersion >= 6) {
	        if (name === "__proto__" && kind === "init") {
	          if (propHash.proto) this.raiseRecoverable(key.start, "Redefinition of __proto__ property")
	          propHash.proto = true
	        }
	        return
	      }
	      name = "$" + name
	      var other = propHash[name]
	      if (other) {
	        var isGetSet = kind !== "init"
	        if ((this.strict || isGetSet) && other[kind] || !(isGetSet ^ other.init))
	          this.raiseRecoverable(key.start, "Redefinition of property")
	      } else {
	        other = propHash[name] = {
	          init: false,
	          get: false,
	          set: false
	        }
	      }
	      other[kind] = true
	    }
	
	    // ### Expression parsing
	
	    // These nest, from the most general expression type at the top to
	    // 'atomic', nondivisible expression types at the bottom. Most of
	    // the functions will simply let the function(s) below them parse,
	    // and, *if* the syntactic construct they handle is present, wrap
	    // the AST node that the inner parser gave them in another node.
	
	    // Parse a full expression. The optional arguments are used to
	    // forbid the `in` operator (in for loops initalization expressions)
	    // and provide reference for storing '=' operator inside shorthand
	    // property assignment in contexts where both object expression
	    // and object pattern might appear (so it's possible to raise
	    // delayed syntax error at correct position).
	
	    pp$3.parseExpression = function(noIn, refDestructuringErrors) {
	      var this$1 = this;
	
	      var startPos = this.start, startLoc = this.startLoc
	      var expr = this.parseMaybeAssign(noIn, refDestructuringErrors)
	      if (this.type === tt.comma) {
	        var node = this.startNodeAt(startPos, startLoc)
	        node.expressions = [expr]
	        while (this.eat(tt.comma)) node.expressions.push(this$1.parseMaybeAssign(noIn, refDestructuringErrors))
	        return this.finishNode(node, "SequenceExpression")
	      }
	      return expr
	    }
	
	    // Parse an assignment expression. This includes applications of
	    // operators like `+=`.
	
	    pp$3.parseMaybeAssign = function(noIn, refDestructuringErrors, afterLeftParse) {
	      if (this.inGenerator && this.isContextual("yield")) return this.parseYield()
	
	      var ownDestructuringErrors = false
	      if (!refDestructuringErrors) {
	        refDestructuringErrors = new DestructuringErrors
	        ownDestructuringErrors = true
	      }
	      var startPos = this.start, startLoc = this.startLoc
	      if (this.type == tt.parenL || this.type == tt.name)
	        this.potentialArrowAt = this.start
	      var left = this.parseMaybeConditional(noIn, refDestructuringErrors)
	      if (afterLeftParse) left = afterLeftParse.call(this, left, startPos, startLoc)
	      if (this.type.isAssign) {
	        this.checkPatternErrors(refDestructuringErrors, true)
	        if (!ownDestructuringErrors) DestructuringErrors.call(refDestructuringErrors)
	        var node = this.startNodeAt(startPos, startLoc)
	        node.operator = this.value
	        node.left = this.type === tt.eq ? this.toAssignable(left) : left
	        refDestructuringErrors.shorthandAssign = 0 // reset because shorthand default was used correctly
	        this.checkLVal(left)
	        this.next()
	        node.right = this.parseMaybeAssign(noIn)
	        return this.finishNode(node, "AssignmentExpression")
	      } else {
	        if (ownDestructuringErrors) this.checkExpressionErrors(refDestructuringErrors, true)
	      }
	      return left
	    }
	
	    // Parse a ternary conditional (`?:`) operator.
	
	    pp$3.parseMaybeConditional = function(noIn, refDestructuringErrors) {
	      var startPos = this.start, startLoc = this.startLoc
	      var expr = this.parseExprOps(noIn, refDestructuringErrors)
	      if (this.checkExpressionErrors(refDestructuringErrors)) return expr
	      if (this.eat(tt.question)) {
	        var node = this.startNodeAt(startPos, startLoc)
	        node.test = expr
	        node.consequent = this.parseMaybeAssign()
	        this.expect(tt.colon)
	        node.alternate = this.parseMaybeAssign(noIn)
	        return this.finishNode(node, "ConditionalExpression")
	      }
	      return expr
	    }
	
	    // Start the precedence parser.
	
	    pp$3.parseExprOps = function(noIn, refDestructuringErrors) {
	      var startPos = this.start, startLoc = this.startLoc
	      var expr = this.parseMaybeUnary(refDestructuringErrors, false)
	      if (this.checkExpressionErrors(refDestructuringErrors)) return expr
	      return this.parseExprOp(expr, startPos, startLoc, -1, noIn)
	    }
	
	    // Parse binary operators with the operator precedence parsing
	    // algorithm. `left` is the left-hand side of the operator.
	    // `minPrec` provides context that allows the function to stop and
	    // defer further parser to one of its callers when it encounters an
	    // operator that has a lower precedence than the set it is parsing.
	
	    pp$3.parseExprOp = function(left, leftStartPos, leftStartLoc, minPrec, noIn) {
	      var prec = this.type.binop
	      if (prec != null && (!noIn || this.type !== tt._in)) {
	        if (prec > minPrec) {
	          var logical = this.type === tt.logicalOR || this.type === tt.logicalAND
	          var op = this.value
	          this.next()
	          var startPos = this.start, startLoc = this.startLoc
	          var right = this.parseExprOp(this.parseMaybeUnary(null, false), startPos, startLoc, prec, noIn)
	          var node = this.buildBinary(leftStartPos, leftStartLoc, left, right, op, logical)
	          return this.parseExprOp(node, leftStartPos, leftStartLoc, minPrec, noIn)
	        }
	      }
	      return left
	    }
	
	    pp$3.buildBinary = function(startPos, startLoc, left, right, op, logical) {
	      var node = this.startNodeAt(startPos, startLoc)
	      node.left = left
	      node.operator = op
	      node.right = right
	      return this.finishNode(node, logical ? "LogicalExpression" : "BinaryExpression")
	    }
	
	    // Parse unary operators, both prefix and postfix.
	
	    pp$3.parseMaybeUnary = function(refDestructuringErrors, sawUnary) {
	      var this$1 = this;
	
	      var startPos = this.start, startLoc = this.startLoc, expr
	      if (this.type.prefix) {
	        var node = this.startNode(), update = this.type === tt.incDec
	        node.operator = this.value
	        node.prefix = true
	        this.next()
	        node.argument = this.parseMaybeUnary(null, true)
	        this.checkExpressionErrors(refDestructuringErrors, true)
	        if (update) this.checkLVal(node.argument)
	        else if (this.strict && node.operator === "delete" &&
	                 node.argument.type === "Identifier")
	          this.raiseRecoverable(node.start, "Deleting local variable in strict mode")
	        else sawUnary = true
	        expr = this.finishNode(node, update ? "UpdateExpression" : "UnaryExpression")
	      } else {
	        expr = this.parseExprSubscripts(refDestructuringErrors)
	        if (this.checkExpressionErrors(refDestructuringErrors)) return expr
	        while (this.type.postfix && !this.canInsertSemicolon()) {
	          var node$1 = this$1.startNodeAt(startPos, startLoc)
	          node$1.operator = this$1.value
	          node$1.prefix = false
	          node$1.argument = expr
	          this$1.checkLVal(expr)
	          this$1.next()
	          expr = this$1.finishNode(node$1, "UpdateExpression")
	        }
	      }
	
	      if (!sawUnary && this.eat(tt.starstar))
	        return this.buildBinary(startPos, startLoc, expr, this.parseMaybeUnary(null, false), "**", false)
	      else
	        return expr
	    }
	
	    // Parse call, dot, and `[]`-subscript expressions.
	
	    pp$3.parseExprSubscripts = function(refDestructuringErrors) {
	      var startPos = this.start, startLoc = this.startLoc
	      var expr = this.parseExprAtom(refDestructuringErrors)
	      var skipArrowSubscripts = expr.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")"
	      if (this.checkExpressionErrors(refDestructuringErrors) || skipArrowSubscripts) return expr
	      return this.parseSubscripts(expr, startPos, startLoc)
	    }
	
	    pp$3.parseSubscripts = function(base, startPos, startLoc, noCalls) {
	      var this$1 = this;
	
	      for (;;) {
	        if (this$1.eat(tt.dot)) {
	          var node = this$1.startNodeAt(startPos, startLoc)
	          node.object = base
	          node.property = this$1.parseIdent(true)
	          node.computed = false
	          base = this$1.finishNode(node, "MemberExpression")
	        } else if (this$1.eat(tt.bracketL)) {
	          var node$1 = this$1.startNodeAt(startPos, startLoc)
	          node$1.object = base
	          node$1.property = this$1.parseExpression()
	          node$1.computed = true
	          this$1.expect(tt.bracketR)
	          base = this$1.finishNode(node$1, "MemberExpression")
	        } else if (!noCalls && this$1.eat(tt.parenL)) {
	          var node$2 = this$1.startNodeAt(startPos, startLoc)
	          node$2.callee = base
	          node$2.arguments = this$1.parseExprList(tt.parenR, false)
	          base = this$1.finishNode(node$2, "CallExpression")
	        } else if (this$1.type === tt.backQuote) {
	          var node$3 = this$1.startNodeAt(startPos, startLoc)
	          node$3.tag = base
	          node$3.quasi = this$1.parseTemplate()
	          base = this$1.finishNode(node$3, "TaggedTemplateExpression")
	        } else {
	          return base
	        }
	      }
	    }
	
	    // Parse an atomic expression — either a single token that is an
	    // expression, an expression started by a keyword like `function` or
	    // `new`, or an expression wrapped in punctuation like `()`, `[]`,
	    // or `{}`.
	
	    pp$3.parseExprAtom = function(refDestructuringErrors) {
	      var node, canBeArrow = this.potentialArrowAt == this.start
	      switch (this.type) {
	      case tt._super:
	        if (!this.inFunction)
	          this.raise(this.start, "'super' outside of function or class")
	
	      case tt._this:
	        var type = this.type === tt._this ? "ThisExpression" : "Super"
	        node = this.startNode()
	        this.next()
	        return this.finishNode(node, type)
	
	      case tt.name:
	        var startPos = this.start, startLoc = this.startLoc
	        var id = this.parseIdent(this.type !== tt.name)
	        if (canBeArrow && !this.canInsertSemicolon() && this.eat(tt.arrow))
	          return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [id])
	        return id
	
	      case tt.regexp:
	        var value = this.value
	        node = this.parseLiteral(value.value)
	        node.regex = {pattern: value.pattern, flags: value.flags}
	        return node
	
	      case tt.num: case tt.string:
	        return this.parseLiteral(this.value)
	
	      case tt._null: case tt._true: case tt._false:
	        node = this.startNode()
	        node.value = this.type === tt._null ? null : this.type === tt._true
	        node.raw = this.type.keyword
	        this.next()
	        return this.finishNode(node, "Literal")
	
	      case tt.parenL:
	        return this.parseParenAndDistinguishExpression(canBeArrow)
	
	      case tt.bracketL:
	        node = this.startNode()
	        this.next()
	        node.elements = this.parseExprList(tt.bracketR, true, true, refDestructuringErrors)
	        return this.finishNode(node, "ArrayExpression")
	
	      case tt.braceL:
	        return this.parseObj(false, refDestructuringErrors)
	
	      case tt._function:
	        node = this.startNode()
	        this.next()
	        return this.parseFunction(node, false)
	
	      case tt._class:
	        return this.parseClass(this.startNode(), false)
	
	      case tt._new:
	        return this.parseNew()
	
	      case tt.backQuote:
	        return this.parseTemplate()
	
	      default:
	        this.unexpected()
	      }
	    }
	
	    pp$3.parseLiteral = function(value) {
	      var node = this.startNode()
	      node.value = value
	      node.raw = this.input.slice(this.start, this.end)
	      this.next()
	      return this.finishNode(node, "Literal")
	    }
	
	    pp$3.parseParenExpression = function() {
	      this.expect(tt.parenL)
	      var val = this.parseExpression()
	      this.expect(tt.parenR)
	      return val
	    }
	
	    pp$3.parseParenAndDistinguishExpression = function(canBeArrow) {
	      var this$1 = this;
	
	      var startPos = this.start, startLoc = this.startLoc, val
	      if (this.options.ecmaVersion >= 6) {
	        this.next()
	
	        var innerStartPos = this.start, innerStartLoc = this.startLoc
	        var exprList = [], first = true
	        var refDestructuringErrors = new DestructuringErrors, spreadStart, innerParenStart
	        while (this.type !== tt.parenR) {
	          first ? first = false : this$1.expect(tt.comma)
	          if (this$1.type === tt.ellipsis) {
	            spreadStart = this$1.start
	            exprList.push(this$1.parseParenItem(this$1.parseRest()))
	            break
	          } else {
	            if (this$1.type === tt.parenL && !innerParenStart) {
	              innerParenStart = this$1.start
	            }
	            exprList.push(this$1.parseMaybeAssign(false, refDestructuringErrors, this$1.parseParenItem))
	          }
	        }
	        var innerEndPos = this.start, innerEndLoc = this.startLoc
	        this.expect(tt.parenR)
	
	        if (canBeArrow && !this.canInsertSemicolon() && this.eat(tt.arrow)) {
	          this.checkPatternErrors(refDestructuringErrors, true)
	          if (innerParenStart) this.unexpected(innerParenStart)
	          return this.parseParenArrowList(startPos, startLoc, exprList)
	        }
	
	        if (!exprList.length) this.unexpected(this.lastTokStart)
	        if (spreadStart) this.unexpected(spreadStart)
	        this.checkExpressionErrors(refDestructuringErrors, true)
	
	        if (exprList.length > 1) {
	          val = this.startNodeAt(innerStartPos, innerStartLoc)
	          val.expressions = exprList
	          this.finishNodeAt(val, "SequenceExpression", innerEndPos, innerEndLoc)
	        } else {
	          val = exprList[0]
	        }
	      } else {
	        val = this.parseParenExpression()
	      }
	
	      if (this.options.preserveParens) {
	        var par = this.startNodeAt(startPos, startLoc)
	        par.expression = val
	        return this.finishNode(par, "ParenthesizedExpression")
	      } else {
	        return val
	      }
	    }
	
	    pp$3.parseParenItem = function(item) {
	      return item
	    }
	
	    pp$3.parseParenArrowList = function(startPos, startLoc, exprList) {
	      return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), exprList)
	    }
	
	    // New's precedence is slightly tricky. It must allow its argument to
	    // be a `[]` or dot subscript expression, but not a call — at least,
	    // not without wrapping it in parentheses. Thus, it uses the noCalls
	    // argument to parseSubscripts to prevent it from consuming the
	    // argument list.
	
	    var empty$1 = []
	
	    pp$3.parseNew = function() {
	      var node = this.startNode()
	      var meta = this.parseIdent(true)
	      if (this.options.ecmaVersion >= 6 && this.eat(tt.dot)) {
	        node.meta = meta
	        node.property = this.parseIdent(true)
	        if (node.property.name !== "target")
	          this.raiseRecoverable(node.property.start, "The only valid meta property for new is new.target")
	        if (!this.inFunction)
	          this.raiseRecoverable(node.start, "new.target can only be used in functions")
	        return this.finishNode(node, "MetaProperty")
	      }
	      var startPos = this.start, startLoc = this.startLoc
	      node.callee = this.parseSubscripts(this.parseExprAtom(), startPos, startLoc, true)
	      if (this.eat(tt.parenL)) node.arguments = this.parseExprList(tt.parenR, false)
	      else node.arguments = empty$1
	      return this.finishNode(node, "NewExpression")
	    }
	
	    // Parse template expression.
	
	    pp$3.parseTemplateElement = function() {
	      var elem = this.startNode()
	      elem.value = {
	        raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, '\n'),
	        cooked: this.value
	      }
	      this.next()
	      elem.tail = this.type === tt.backQuote
	      return this.finishNode(elem, "TemplateElement")
	    }
	
	    pp$3.parseTemplate = function() {
	      var this$1 = this;
	
	      var node = this.startNode()
	      this.next()
	      node.expressions = []
	      var curElt = this.parseTemplateElement()
	      node.quasis = [curElt]
	      while (!curElt.tail) {
	        this$1.expect(tt.dollarBraceL)
	        node.expressions.push(this$1.parseExpression())
	        this$1.expect(tt.braceR)
	        node.quasis.push(curElt = this$1.parseTemplateElement())
	      }
	      this.next()
	      return this.finishNode(node, "TemplateLiteral")
	    }
	
	    // Parse an object literal or binding pattern.
	
	    pp$3.parseObj = function(isPattern, refDestructuringErrors) {
	      var this$1 = this;
	
	      var node = this.startNode(), first = true, propHash = {}
	      node.properties = []
	      this.next()
	      while (!this.eat(tt.braceR)) {
	        if (!first) {
	          this$1.expect(tt.comma)
	          if (this$1.afterTrailingComma(tt.braceR)) break
	        } else first = false
	
	        var prop = this$1.startNode(), isGenerator, startPos, startLoc
	        if (this$1.options.ecmaVersion >= 6) {
	          prop.method = false
	          prop.shorthand = false
	          if (isPattern || refDestructuringErrors) {
	            startPos = this$1.start
	            startLoc = this$1.startLoc
	          }
	          if (!isPattern)
	            isGenerator = this$1.eat(tt.star)
	        }
	        this$1.parsePropertyName(prop)
	        this$1.parsePropertyValue(prop, isPattern, isGenerator, startPos, startLoc, refDestructuringErrors)
	        this$1.checkPropClash(prop, propHash)
	        node.properties.push(this$1.finishNode(prop, "Property"))
	      }
	      return this.finishNode(node, isPattern ? "ObjectPattern" : "ObjectExpression")
	    }
	
	    pp$3.parsePropertyValue = function(prop, isPattern, isGenerator, startPos, startLoc, refDestructuringErrors) {
	      if (this.eat(tt.colon)) {
	        prop.value = isPattern ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(false, refDestructuringErrors)
	        prop.kind = "init"
	      } else if (this.options.ecmaVersion >= 6 && this.type === tt.parenL) {
	        if (isPattern) this.unexpected()
	        prop.kind = "init"
	        prop.method = true
	        prop.value = this.parseMethod(isGenerator)
	      } else if (this.options.ecmaVersion >= 5 && !prop.computed && prop.key.type === "Identifier" &&
	                 (prop.key.name === "get" || prop.key.name === "set") &&
	                 (this.type != tt.comma && this.type != tt.braceR)) {
	        if (isGenerator || isPattern) this.unexpected()
	        prop.kind = prop.key.name
	        this.parsePropertyName(prop)
	        prop.value = this.parseMethod(false)
	        var paramCount = prop.kind === "get" ? 0 : 1
	        if (prop.value.params.length !== paramCount) {
	          var start = prop.value.start
	          if (prop.kind === "get")
	            this.raiseRecoverable(start, "getter should have no params")
	          else
	            this.raiseRecoverable(start, "setter should have exactly one param")
	        }
	        if (prop.kind === "set" && prop.value.params[0].type === "RestElement")
	          this.raiseRecoverable(prop.value.params[0].start, "Setter cannot use rest params")
	      } else if (this.options.ecmaVersion >= 6 && !prop.computed && prop.key.type === "Identifier") {
	        if (this.keywords.test(prop.key.name) ||
	            (this.strict ? this.reservedWordsStrictBind : this.reservedWords).test(prop.key.name) ||
	            (this.inGenerator && prop.key.name == "yield"))
	          this.raiseRecoverable(prop.key.start, "'" + prop.key.name + "' can not be used as shorthand property")
	        prop.kind = "init"
	        if (isPattern) {
	          prop.value = this.parseMaybeDefault(startPos, startLoc, prop.key)
	        } else if (this.type === tt.eq && refDestructuringErrors) {
	          if (!refDestructuringErrors.shorthandAssign)
	            refDestructuringErrors.shorthandAssign = this.start
	          prop.value = this.parseMaybeDefault(startPos, startLoc, prop.key)
	        } else {
	          prop.value = prop.key
	        }
	        prop.shorthand = true
	      } else this.unexpected()
	    }
	
	    pp$3.parsePropertyName = function(prop) {
	      if (this.options.ecmaVersion >= 6) {
	        if (this.eat(tt.bracketL)) {
	          prop.computed = true
	          prop.key = this.parseMaybeAssign()
	          this.expect(tt.bracketR)
	          return prop.key
	        } else {
	          prop.computed = false
	        }
	      }
	      return prop.key = this.type === tt.num || this.type === tt.string ? this.parseExprAtom() : this.parseIdent(true)
	    }
	
	    // Initialize empty function node.
	
	    pp$3.initFunction = function(node) {
	      node.id = null
	      if (this.options.ecmaVersion >= 6) {
	        node.generator = false
	        node.expression = false
	      }
	    }
	
	    // Parse object or class method.
	
	    pp$3.parseMethod = function(isGenerator) {
	      var node = this.startNode(), oldInGen = this.inGenerator
	      this.inGenerator = isGenerator
	      this.initFunction(node)
	      this.expect(tt.parenL)
	      node.params = this.parseBindingList(tt.parenR, false, false)
	      if (this.options.ecmaVersion >= 6)
	        node.generator = isGenerator
	      this.parseFunctionBody(node, false)
	      this.inGenerator = oldInGen
	      return this.finishNode(node, "FunctionExpression")
	    }
	
	    // Parse arrow function expression with given parameters.
	
	    pp$3.parseArrowExpression = function(node, params) {
	      var oldInGen = this.inGenerator
	      this.inGenerator = false
	      this.initFunction(node)
	      node.params = this.toAssignableList(params, true)
	      this.parseFunctionBody(node, true)
	      this.inGenerator = oldInGen
	      return this.finishNode(node, "ArrowFunctionExpression")
	    }
	
	    // Parse function body and check parameters.
	
	    pp$3.parseFunctionBody = function(node, isArrowFunction) {
	      var isExpression = isArrowFunction && this.type !== tt.braceL
	
	      if (isExpression) {
	        node.body = this.parseMaybeAssign()
	        node.expression = true
	      } else {
	        // Start a new scope with regard to labels and the `inFunction`
	        // flag (restore them to their old value afterwards).
	        var oldInFunc = this.inFunction, oldLabels = this.labels
	        this.inFunction = true; this.labels = []
	        node.body = this.parseBlock(true)
	        node.expression = false
	        this.inFunction = oldInFunc; this.labels = oldLabels
	      }
	
	      // If this is a strict mode function, verify that argument names
	      // are not repeated, and it does not try to bind the words `eval`
	      // or `arguments`.
	      var useStrict = (!isExpression && node.body.body.length && this.isUseStrict(node.body.body[0])) ? node.body.body[0] : null;
	      if (this.strict || useStrict) {
	        var oldStrict = this.strict
	        this.strict = true
	        if (node.id)
	          this.checkLVal(node.id, true)
	        this.checkParams(node, useStrict)
	        this.strict = oldStrict
	      } else if (isArrowFunction) {
	        this.checkParams(node, useStrict)
	      }
	    }
	
	    // Checks function params for various disallowed patterns such as using "eval"
	    // or "arguments" and duplicate parameters.
	
	    pp$3.checkParams = function(node, useStrict) {
	        var this$1 = this;
	
	        var nameHash = {}
	        for (var i = 0; i < node.params.length; i++) {
	          if (useStrict && this$1.options.ecmaVersion >= 7 && node.params[i].type !== "Identifier")
	            this$1.raiseRecoverable(useStrict.start, "Illegal 'use strict' directive in function with non-simple parameter list");
	          this$1.checkLVal(node.params[i], true, nameHash)
	        }
	    }
	
	    // Parses a comma-separated list of expressions, and returns them as
	    // an array. `close` is the token type that ends the list, and
	    // `allowEmpty` can be turned on to allow subsequent commas with
	    // nothing in between them to be parsed as `null` (which is needed
	    // for array literals).
	
	    pp$3.parseExprList = function(close, allowTrailingComma, allowEmpty, refDestructuringErrors) {
	      var this$1 = this;
	
	      var elts = [], first = true
	      while (!this.eat(close)) {
	        if (!first) {
	          this$1.expect(tt.comma)
	          if (allowTrailingComma && this$1.afterTrailingComma(close)) break
	        } else first = false
	
	        var elt
	        if (allowEmpty && this$1.type === tt.comma)
	          elt = null
	        else if (this$1.type === tt.ellipsis) {
	          elt = this$1.parseSpread(refDestructuringErrors)
	          if (this$1.type === tt.comma && refDestructuringErrors && !refDestructuringErrors.trailingComma) {
	            refDestructuringErrors.trailingComma = this$1.lastTokStart
	          }
	        } else
	          elt = this$1.parseMaybeAssign(false, refDestructuringErrors)
	        elts.push(elt)
	      }
	      return elts
	    }
	
	    // Parse the next token as an identifier. If `liberal` is true (used
	    // when parsing properties), it will also convert keywords into
	    // identifiers.
	
	    pp$3.parseIdent = function(liberal) {
	      var node = this.startNode()
	      if (liberal && this.options.allowReserved == "never") liberal = false
	      if (this.type === tt.name) {
	        if (!liberal && (this.strict ? this.reservedWordsStrict : this.reservedWords).test(this.value) &&
	            (this.options.ecmaVersion >= 6 ||
	             this.input.slice(this.start, this.end).indexOf("\\") == -1))
	          this.raiseRecoverable(this.start, "The keyword '" + this.value + "' is reserved")
	        if (!liberal && this.inGenerator && this.value === "yield")
	          this.raiseRecoverable(this.start, "Can not use 'yield' as identifier inside a generator")
	        node.name = this.value
	      } else if (liberal && this.type.keyword) {
	        node.name = this.type.keyword
	      } else {
	        this.unexpected()
	      }
	      this.next()
	      return this.finishNode(node, "Identifier")
	    }
	
	    // Parses yield expression inside generator.
	
	    pp$3.parseYield = function() {
	      var node = this.startNode()
	      this.next()
	      if (this.type == tt.semi || this.canInsertSemicolon() || (this.type != tt.star && !this.type.startsExpr)) {
	        node.delegate = false
	        node.argument = null
	      } else {
	        node.delegate = this.eat(tt.star)
	        node.argument = this.parseMaybeAssign()
	      }
	      return this.finishNode(node, "YieldExpression")
	    }
	
	    var pp$4 = Parser.prototype
	
	    // This function is used to raise exceptions on parse errors. It
	    // takes an offset integer (into the current `input`) to indicate
	    // the location of the error, attaches the position to the end
	    // of the error message, and then raises a `SyntaxError` with that
	    // message.
	
	    pp$4.raise = function(pos, message) {
	      var loc = getLineInfo(this.input, pos)
	      message += " (" + loc.line + ":" + loc.column + ")"
	      var err = new SyntaxError(message)
	      err.pos = pos; err.loc = loc; err.raisedAt = this.pos
	      throw err
	    }
	
	    pp$4.raiseRecoverable = pp$4.raise
	
	    pp$4.curPosition = function() {
	      if (this.options.locations) {
	        return new Position(this.curLine, this.pos - this.lineStart)
	      }
	    }
	
	    var Node = function Node(parser, pos, loc) {
	      this.type = ""
	      this.start = pos
	      this.end = 0
	      if (parser.options.locations)
	        this.loc = new SourceLocation(parser, loc)
	      if (parser.options.directSourceFile)
	        this.sourceFile = parser.options.directSourceFile
	      if (parser.options.ranges)
	        this.range = [pos, 0]
	    };
	
	    // Start an AST node, attaching a start offset.
	
	    var pp$5 = Parser.prototype
	
	    pp$5.startNode = function() {
	      return new Node(this, this.start, this.startLoc)
	    }
	
	    pp$5.startNodeAt = function(pos, loc) {
	      return new Node(this, pos, loc)
	    }
	
	    // Finish an AST node, adding `type` and `end` properties.
	
	    function finishNodeAt(node, type, pos, loc) {
	      node.type = type
	      node.end = pos
	      if (this.options.locations)
	        node.loc.end = loc
	      if (this.options.ranges)
	        node.range[1] = pos
	      return node
	    }
	
	    pp$5.finishNode = function(node, type) {
	      return finishNodeAt.call(this, node, type, this.lastTokEnd, this.lastTokEndLoc)
	    }
	
	    // Finish node at given position
	
	    pp$5.finishNodeAt = function(node, type, pos, loc) {
	      return finishNodeAt.call(this, node, type, pos, loc)
	    }
	
	    var TokContext = function TokContext(token, isExpr, preserveSpace, override) {
	      this.token = token
	      this.isExpr = !!isExpr
	      this.preserveSpace = !!preserveSpace
	      this.override = override
	    };
	
	    var types = {
	      b_stat: new TokContext("{", false),
	      b_expr: new TokContext("{", true),
	      b_tmpl: new TokContext("${", true),
	      p_stat: new TokContext("(", false),
	      p_expr: new TokContext("(", true),
	      q_tmpl: new TokContext("`", true, true, function (p) { return p.readTmplToken(); }),
	      f_expr: new TokContext("function", true)
	    }
	
	    var pp$6 = Parser.prototype
	
	    pp$6.initialContext = function() {
	      return [types.b_stat]
	    }
	
	    pp$6.braceIsBlock = function(prevType) {
	      if (prevType === tt.colon) {
	        var parent = this.curContext()
	        if (parent === types.b_stat || parent === types.b_expr)
	          return !parent.isExpr
	      }
	      if (prevType === tt._return)
	        return lineBreak.test(this.input.slice(this.lastTokEnd, this.start))
	      if (prevType === tt._else || prevType === tt.semi || prevType === tt.eof || prevType === tt.parenR)
	        return true
	      if (prevType == tt.braceL)
	        return this.curContext() === types.b_stat
	      return !this.exprAllowed
	    }
	
	    pp$6.updateContext = function(prevType) {
	      var update, type = this.type
	      if (type.keyword && prevType == tt.dot)
	        this.exprAllowed = false
	      else if (update = type.updateContext)
	        update.call(this, prevType)
	      else
	        this.exprAllowed = type.beforeExpr
	    }
	
	    // Token-specific context update code
	
	    tt.parenR.updateContext = tt.braceR.updateContext = function() {
	      if (this.context.length == 1) {
	        this.exprAllowed = true
	        return
	      }
	      var out = this.context.pop()
	      if (out === types.b_stat && this.curContext() === types.f_expr) {
	        this.context.pop()
	        this.exprAllowed = false
	      } else if (out === types.b_tmpl) {
	        this.exprAllowed = true
	      } else {
	        this.exprAllowed = !out.isExpr
	      }
	    }
	
	    tt.braceL.updateContext = function(prevType) {
	      this.context.push(this.braceIsBlock(prevType) ? types.b_stat : types.b_expr)
	      this.exprAllowed = true
	    }
	
	    tt.dollarBraceL.updateContext = function() {
	      this.context.push(types.b_tmpl)
	      this.exprAllowed = true
	    }
	
	    tt.parenL.updateContext = function(prevType) {
	      var statementParens = prevType === tt._if || prevType === tt._for || prevType === tt._with || prevType === tt._while
	      this.context.push(statementParens ? types.p_stat : types.p_expr)
	      this.exprAllowed = true
	    }
	
	    tt.incDec.updateContext = function() {
	      // tokExprAllowed stays unchanged
	    }
	
	    tt._function.updateContext = function(prevType) {
	      if (prevType.beforeExpr && prevType !== tt.semi && prevType !== tt._else &&
	          !((prevType === tt.colon || prevType === tt.braceL) && this.curContext() === types.b_stat))
	        this.context.push(types.f_expr)
	      this.exprAllowed = false
	    }
	
	    tt.backQuote.updateContext = function() {
	      if (this.curContext() === types.q_tmpl)
	        this.context.pop()
	      else
	        this.context.push(types.q_tmpl)
	      this.exprAllowed = false
	    }
	
	    // Object type used to represent tokens. Note that normally, tokens
	    // simply exist as properties on the parser object. This is only
	    // used for the onToken callback and the external tokenizer.
	
	    var Token = function Token(p) {
	      this.type = p.type
	      this.value = p.value
	      this.start = p.start
	      this.end = p.end
	      if (p.options.locations)
	        this.loc = new SourceLocation(p, p.startLoc, p.endLoc)
	      if (p.options.ranges)
	        this.range = [p.start, p.end]
	    };
	
	    // ## Tokenizer
	
	    var pp$7 = Parser.prototype
	
	    // Are we running under Rhino?
	    var isRhino = typeof Packages == "object" && Object.prototype.toString.call(Packages) == "[object JavaPackage]"
	
	    // Move to the next token
	
	    pp$7.next = function() {
	      if (this.options.onToken)
	        this.options.onToken(new Token(this))
	
	      this.lastTokEnd = this.end
	      this.lastTokStart = this.start
	      this.lastTokEndLoc = this.endLoc
	      this.lastTokStartLoc = this.startLoc
	      this.nextToken()
	    }
	
	    pp$7.getToken = function() {
	      this.next()
	      return new Token(this)
	    }
	
	    // If we're in an ES6 environment, make parsers iterable
	    if (typeof Symbol !== "undefined")
	      pp$7[Symbol.iterator] = function () {
	        var self = this
	        return {next: function () {
	          var token = self.getToken()
	          return {
	            done: token.type === tt.eof,
	            value: token
	          }
	        }}
	      }
	
	    // Toggle strict mode. Re-reads the next number or string to please
	    // pedantic tests (`"use strict"; 010;` should fail).
	
	    pp$7.setStrict = function(strict) {
	      var this$1 = this;
	
	      this.strict = strict
	      if (this.type !== tt.num && this.type !== tt.string) return
	      this.pos = this.start
	      if (this.options.locations) {
	        while (this.pos < this.lineStart) {
	          this$1.lineStart = this$1.input.lastIndexOf("\n", this$1.lineStart - 2) + 1
	          --this$1.curLine
	        }
	      }
	      this.nextToken()
	    }
	
	    pp$7.curContext = function() {
	      return this.context[this.context.length - 1]
	    }
	
	    // Read a single token, updating the parser object's token-related
	    // properties.
	
	    pp$7.nextToken = function() {
	      var curContext = this.curContext()
	      if (!curContext || !curContext.preserveSpace) this.skipSpace()
	
	      this.start = this.pos
	      if (this.options.locations) this.startLoc = this.curPosition()
	      if (this.pos >= this.input.length) return this.finishToken(tt.eof)
	
	      if (curContext.override) return curContext.override(this)
	      else this.readToken(this.fullCharCodeAtPos())
	    }
	
	    pp$7.readToken = function(code) {
	      // Identifier or keyword. '\uXXXX' sequences are allowed in
	      // identifiers, so '\' also dispatches to that.
	      if (isIdentifierStart(code, this.options.ecmaVersion >= 6) || code === 92 /* '\' */)
	        return this.readWord()
	
	      return this.getTokenFromCode(code)
	    }
	
	    pp$7.fullCharCodeAtPos = function() {
	      var code = this.input.charCodeAt(this.pos)
	      if (code <= 0xd7ff || code >= 0xe000) return code
	      var next = this.input.charCodeAt(this.pos + 1)
	      return (code << 10) + next - 0x35fdc00
	    }
	
	    pp$7.skipBlockComment = function() {
	      var this$1 = this;
	
	      var startLoc = this.options.onComment && this.curPosition()
	      var start = this.pos, end = this.input.indexOf("*/", this.pos += 2)
	      if (end === -1) this.raise(this.pos - 2, "Unterminated comment")
	      this.pos = end + 2
	      if (this.options.locations) {
	        lineBreakG.lastIndex = start
	        var match
	        while ((match = lineBreakG.exec(this.input)) && match.index < this.pos) {
	          ++this$1.curLine
	          this$1.lineStart = match.index + match[0].length
	        }
	      }
	      if (this.options.onComment)
	        this.options.onComment(true, this.input.slice(start + 2, end), start, this.pos,
	                               startLoc, this.curPosition())
	    }
	
	    pp$7.skipLineComment = function(startSkip) {
	      var this$1 = this;
	
	      var start = this.pos
	      var startLoc = this.options.onComment && this.curPosition()
	      var ch = this.input.charCodeAt(this.pos+=startSkip)
	      while (this.pos < this.input.length && ch !== 10 && ch !== 13 && ch !== 8232 && ch !== 8233) {
	        ++this$1.pos
	        ch = this$1.input.charCodeAt(this$1.pos)
	      }
	      if (this.options.onComment)
	        this.options.onComment(false, this.input.slice(start + startSkip, this.pos), start, this.pos,
	                               startLoc, this.curPosition())
	    }
	
	    // Called at the start of the parse and after every token. Skips
	    // whitespace and comments, and.
	
	    pp$7.skipSpace = function() {
	      var this$1 = this;
	
	      loop: while (this.pos < this.input.length) {
	        var ch = this$1.input.charCodeAt(this$1.pos)
	        switch (ch) {
	          case 32: case 160: // ' '
	            ++this$1.pos
	            break
	          case 13:
	            if (this$1.input.charCodeAt(this$1.pos + 1) === 10) {
	              ++this$1.pos
	            }
	          case 10: case 8232: case 8233:
	            ++this$1.pos
	            if (this$1.options.locations) {
	              ++this$1.curLine
	              this$1.lineStart = this$1.pos
	            }
	            break
	          case 47: // '/'
	            switch (this$1.input.charCodeAt(this$1.pos + 1)) {
	              case 42: // '*'
	                this$1.skipBlockComment()
	                break
	              case 47:
	                this$1.skipLineComment(2)
	                break
	              default:
	                break loop
	            }
	            break
	          default:
	            if (ch > 8 && ch < 14 || ch >= 5760 && nonASCIIwhitespace.test(String.fromCharCode(ch))) {
	              ++this$1.pos
	            } else {
	              break loop
	            }
	        }
	      }
	    }
	
	    // Called at the end of every token. Sets `end`, `val`, and
	    // maintains `context` and `exprAllowed`, and skips the space after
	    // the token, so that the next one's `start` will point at the
	    // right position.
	
	    pp$7.finishToken = function(type, val) {
	      this.end = this.pos
	      if (this.options.locations) this.endLoc = this.curPosition()
	      var prevType = this.type
	      this.type = type
	      this.value = val
	
	      this.updateContext(prevType)
	    }
	
	    // ### Token reading
	
	    // This is the function that is called to fetch the next token. It
	    // is somewhat obscure, because it works in character codes rather
	    // than characters, and because operator parsing has been inlined
	    // into it.
	    //
	    // All in the name of speed.
	    //
	    pp$7.readToken_dot = function() {
	      var next = this.input.charCodeAt(this.pos + 1)
	      if (next >= 48 && next <= 57) return this.readNumber(true)
	      var next2 = this.input.charCodeAt(this.pos + 2)
	      if (this.options.ecmaVersion >= 6 && next === 46 && next2 === 46) { // 46 = dot '.'
	        this.pos += 3
	        return this.finishToken(tt.ellipsis)
	      } else {
	        ++this.pos
	        return this.finishToken(tt.dot)
	      }
	    }
	
	    pp$7.readToken_slash = function() { // '/'
	      var next = this.input.charCodeAt(this.pos + 1)
	      if (this.exprAllowed) {++this.pos; return this.readRegexp()}
	      if (next === 61) return this.finishOp(tt.assign, 2)
	      return this.finishOp(tt.slash, 1)
	    }
	
	    pp$7.readToken_mult_modulo_exp = function(code) { // '%*'
	      var next = this.input.charCodeAt(this.pos + 1)
	      var size = 1
	      var tokentype = code === 42 ? tt.star : tt.modulo
	
	      // exponentiation operator ** and **=
	      if (this.options.ecmaVersion >= 7 && next === 42) {
	        ++size
	        tokentype = tt.starstar
	        next = this.input.charCodeAt(this.pos + 2)
	      }
	
	      if (next === 61) return this.finishOp(tt.assign, size + 1)
	      return this.finishOp(tokentype, size)
	    }
	
	    pp$7.readToken_pipe_amp = function(code) { // '|&'
	      var next = this.input.charCodeAt(this.pos + 1)
	      if (next === code) return this.finishOp(code === 124 ? tt.logicalOR : tt.logicalAND, 2)
	      if (next === 61) return this.finishOp(tt.assign, 2)
	      return this.finishOp(code === 124 ? tt.bitwiseOR : tt.bitwiseAND, 1)
	    }
	
	    pp$7.readToken_caret = function() { // '^'
	      var next = this.input.charCodeAt(this.pos + 1)
	      if (next === 61) return this.finishOp(tt.assign, 2)
	      return this.finishOp(tt.bitwiseXOR, 1)
	    }
	
	    pp$7.readToken_plus_min = function(code) { // '+-'
	      var next = this.input.charCodeAt(this.pos + 1)
	      if (next === code) {
	        if (next == 45 && this.input.charCodeAt(this.pos + 2) == 62 &&
	            lineBreak.test(this.input.slice(this.lastTokEnd, this.pos))) {
	          // A `-->` line comment
	          this.skipLineComment(3)
	          this.skipSpace()
	          return this.nextToken()
	        }
	        return this.finishOp(tt.incDec, 2)
	      }
	      if (next === 61) return this.finishOp(tt.assign, 2)
	      return this.finishOp(tt.plusMin, 1)
	    }
	
	    pp$7.readToken_lt_gt = function(code) { // '<>'
	      var next = this.input.charCodeAt(this.pos + 1)
	      var size = 1
	      if (next === code) {
	        size = code === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2
	        if (this.input.charCodeAt(this.pos + size) === 61) return this.finishOp(tt.assign, size + 1)
	        return this.finishOp(tt.bitShift, size)
	      }
	      if (next == 33 && code == 60 && this.input.charCodeAt(this.pos + 2) == 45 &&
	          this.input.charCodeAt(this.pos + 3) == 45) {
	        if (this.inModule) this.unexpected()
	        // `<!--`, an XML-style comment that should be interpreted as a line comment
	        this.skipLineComment(4)
	        this.skipSpace()
	        return this.nextToken()
	      }
	      if (next === 61) size = 2
	      return this.finishOp(tt.relational, size)
	    }
	
	    pp$7.readToken_eq_excl = function(code) { // '=!'
	      var next = this.input.charCodeAt(this.pos + 1)
	      if (next === 61) return this.finishOp(tt.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2)
	      if (code === 61 && next === 62 && this.options.ecmaVersion >= 6) { // '=>'
	        this.pos += 2
	        return this.finishToken(tt.arrow)
	      }
	      return this.finishOp(code === 61 ? tt.eq : tt.prefix, 1)
	    }
	
	    pp$7.getTokenFromCode = function(code) {
	      switch (code) {
	        // The interpretation of a dot depends on whether it is followed
	        // by a digit or another two dots.
	      case 46: // '.'
	        return this.readToken_dot()
	
	        // Punctuation tokens.
	      case 40: ++this.pos; return this.finishToken(tt.parenL)
	      case 41: ++this.pos; return this.finishToken(tt.parenR)
	      case 59: ++this.pos; return this.finishToken(tt.semi)
	      case 44: ++this.pos; return this.finishToken(tt.comma)
	      case 91: ++this.pos; return this.finishToken(tt.bracketL)
	      case 93: ++this.pos; return this.finishToken(tt.bracketR)
	      case 123: ++this.pos; return this.finishToken(tt.braceL)
	      case 125: ++this.pos; return this.finishToken(tt.braceR)
	      case 58: ++this.pos; return this.finishToken(tt.colon)
	      case 63: ++this.pos; return this.finishToken(tt.question)
	
	      case 96: // '`'
	        if (this.options.ecmaVersion < 6) break
	        ++this.pos
	        return this.finishToken(tt.backQuote)
	
	      case 48: // '0'
	        var next = this.input.charCodeAt(this.pos + 1)
	        if (next === 120 || next === 88) return this.readRadixNumber(16) // '0x', '0X' - hex number
	        if (this.options.ecmaVersion >= 6) {
	          if (next === 111 || next === 79) return this.readRadixNumber(8) // '0o', '0O' - octal number
	          if (next === 98 || next === 66) return this.readRadixNumber(2) // '0b', '0B' - binary number
	        }
	        // Anything else beginning with a digit is an integer, octal
	        // number, or float.
	      case 49: case 50: case 51: case 52: case 53: case 54: case 55: case 56: case 57: // 1-9
	        return this.readNumber(false)
	
	        // Quotes produce strings.
	      case 34: case 39: // '"', "'"
	        return this.readString(code)
	
	        // Operators are parsed inline in tiny state machines. '=' (61) is
	        // often referred to. `finishOp` simply skips the amount of
	        // characters it is given as second argument, and returns a token
	        // of the type given by its first argument.
	
	      case 47: // '/'
	        return this.readToken_slash()
	
	      case 37: case 42: // '%*'
	        return this.readToken_mult_modulo_exp(code)
	
	      case 124: case 38: // '|&'
	        return this.readToken_pipe_amp(code)
	
	      case 94: // '^'
	        return this.readToken_caret()
	
	      case 43: case 45: // '+-'
	        return this.readToken_plus_min(code)
	
	      case 60: case 62: // '<>'
	        return this.readToken_lt_gt(code)
	
	      case 61: case 33: // '=!'
	        return this.readToken_eq_excl(code)
	
	      case 126: // '~'
	        return this.finishOp(tt.prefix, 1)
	      }
	
	      this.raise(this.pos, "Unexpected character '" + codePointToString(code) + "'")
	    }
	
	    pp$7.finishOp = function(type, size) {
	      var str = this.input.slice(this.pos, this.pos + size)
	      this.pos += size
	      return this.finishToken(type, str)
	    }
	
	    // Parse a regular expression. Some context-awareness is necessary,
	    // since a '/' inside a '[]' set does not end the expression.
	
	    function tryCreateRegexp(src, flags, throwErrorAt, parser) {
	      try {
	        return new RegExp(src, flags)
	      } catch (e) {
	        if (throwErrorAt !== undefined) {
	          if (e instanceof SyntaxError) parser.raise(throwErrorAt, "Error parsing regular expression: " + e.message)
	          throw e
	        }
	      }
	    }
	
	    var regexpUnicodeSupport = !!tryCreateRegexp("\uffff", "u")
	
	    pp$7.readRegexp = function() {
	      var this$1 = this;
	
	      var escaped, inClass, start = this.pos
	      for (;;) {
	        if (this$1.pos >= this$1.input.length) this$1.raise(start, "Unterminated regular expression")
	        var ch = this$1.input.charAt(this$1.pos)
	        if (lineBreak.test(ch)) this$1.raise(start, "Unterminated regular expression")
	        if (!escaped) {
	          if (ch === "[") inClass = true
	          else if (ch === "]" && inClass) inClass = false
	          else if (ch === "/" && !inClass) break
	          escaped = ch === "\\"
	        } else escaped = false
	        ++this$1.pos
	      }
	      var content = this.input.slice(start, this.pos)
	      ++this.pos
	      // Need to use `readWord1` because '\uXXXX' sequences are allowed
	      // here (don't ask).
	      var mods = this.readWord1()
	      var tmp = content, tmpFlags = ""
	      if (mods) {
	        var validFlags = /^[gim]*$/
	        if (this.options.ecmaVersion >= 6) validFlags = /^[gimuy]*$/
	        if (!validFlags.test(mods)) this.raise(start, "Invalid regular expression flag")
	        if (mods.indexOf("u") >= 0) {
	          if (regexpUnicodeSupport) {
	            tmpFlags = "u"
	          } else {
	            // Replace each astral symbol and every Unicode escape sequence that
	            // possibly represents an astral symbol or a paired surrogate with a
	            // single ASCII symbol to avoid throwing on regular expressions that
	            // are only valid in combination with the `/u` flag.
	            // Note: replacing with the ASCII symbol `x` might cause false
	            // negatives in unlikely scenarios. For example, `[\u{61}-b]` is a
	            // perfectly valid pattern that is equivalent to `[a-b]`, but it would
	            // be replaced by `[x-b]` which throws an error.
	            tmp = tmp.replace(/\\u\{([0-9a-fA-F]+)\}/g, function (_match, code, offset) {
	              code = Number("0x" + code)
	              if (code > 0x10FFFF) this$1.raise(start + offset + 3, "Code point out of bounds")
	              return "x"
	            })
	            tmp = tmp.replace(/\\u([a-fA-F0-9]{4})|[\uD800-\uDBFF][\uDC00-\uDFFF]/g, "x")
	            tmpFlags = tmpFlags.replace("u", "")
	          }
	        }
	      }
	      // Detect invalid regular expressions.
	      var value = null
	      // Rhino's regular expression parser is flaky and throws uncatchable exceptions,
	      // so don't do detection if we are running under Rhino
	      if (!isRhino) {
	        tryCreateRegexp(tmp, tmpFlags, start, this)
	        // Get a regular expression object for this pattern-flag pair, or `null` in
	        // case the current environment doesn't support the flags it uses.
	        value = tryCreateRegexp(content, mods)
	      }
	      return this.finishToken(tt.regexp, {pattern: content, flags: mods, value: value})
	    }
	
	    // Read an integer in the given radix. Return null if zero digits
	    // were read, the integer value otherwise. When `len` is given, this
	    // will return `null` unless the integer has exactly `len` digits.
	
	    pp$7.readInt = function(radix, len) {
	      var this$1 = this;
	
	      var start = this.pos, total = 0
	      for (var i = 0, e = len == null ? Infinity : len; i < e; ++i) {
	        var code = this$1.input.charCodeAt(this$1.pos), val
	        if (code >= 97) val = code - 97 + 10 // a
	        else if (code >= 65) val = code - 65 + 10 // A
	        else if (code >= 48 && code <= 57) val = code - 48 // 0-9
	        else val = Infinity
	        if (val >= radix) break
	        ++this$1.pos
	        total = total * radix + val
	      }
	      if (this.pos === start || len != null && this.pos - start !== len) return null
	
	      return total
	    }
	
	    pp$7.readRadixNumber = function(radix) {
	      this.pos += 2 // 0x
	      var val = this.readInt(radix)
	      if (val == null) this.raise(this.start + 2, "Expected number in radix " + radix)
	      if (isIdentifierStart(this.fullCharCodeAtPos())) this.raise(this.pos, "Identifier directly after number")
	      return this.finishToken(tt.num, val)
	    }
	
	    // Read an integer, octal integer, or floating-point number.
	
	    pp$7.readNumber = function(startsWithDot) {
	      var start = this.pos, isFloat = false, octal = this.input.charCodeAt(this.pos) === 48
	      if (!startsWithDot && this.readInt(10) === null) this.raise(start, "Invalid number")
	      var next = this.input.charCodeAt(this.pos)
	      if (next === 46) { // '.'
	        ++this.pos
	        this.readInt(10)
	        isFloat = true
	        next = this.input.charCodeAt(this.pos)
	      }
	      if (next === 69 || next === 101) { // 'eE'
	        next = this.input.charCodeAt(++this.pos)
	        if (next === 43 || next === 45) ++this.pos // '+-'
	        if (this.readInt(10) === null) this.raise(start, "Invalid number")
	        isFloat = true
	      }
	      if (isIdentifierStart(this.fullCharCodeAtPos())) this.raise(this.pos, "Identifier directly after number")
	
	      var str = this.input.slice(start, this.pos), val
	      if (isFloat) val = parseFloat(str)
	      else if (!octal || str.length === 1) val = parseInt(str, 10)
	      else if (/[89]/.test(str) || this.strict) this.raise(start, "Invalid number")
	      else val = parseInt(str, 8)
	      return this.finishToken(tt.num, val)
	    }
	
	    // Read a string value, interpreting backslash-escapes.
	
	    pp$7.readCodePoint = function() {
	      var ch = this.input.charCodeAt(this.pos), code
	
	      if (ch === 123) {
	        if (this.options.ecmaVersion < 6) this.unexpected()
	        var codePos = ++this.pos
	        code = this.readHexChar(this.input.indexOf('}', this.pos) - this.pos)
	        ++this.pos
	        if (code > 0x10FFFF) this.raise(codePos, "Code point out of bounds")
	      } else {
	        code = this.readHexChar(4)
	      }
	      return code
	    }
	
	    function codePointToString(code) {
	      // UTF-16 Decoding
	      if (code <= 0xFFFF) return String.fromCharCode(code)
	      code -= 0x10000
	      return String.fromCharCode((code >> 10) + 0xD800, (code & 1023) + 0xDC00)
	    }
	
	    pp$7.readString = function(quote) {
	      var this$1 = this;
	
	      var out = "", chunkStart = ++this.pos
	      for (;;) {
	        if (this$1.pos >= this$1.input.length) this$1.raise(this$1.start, "Unterminated string constant")
	        var ch = this$1.input.charCodeAt(this$1.pos)
	        if (ch === quote) break
	        if (ch === 92) { // '\'
	          out += this$1.input.slice(chunkStart, this$1.pos)
	          out += this$1.readEscapedChar(false)
	          chunkStart = this$1.pos
	        } else {
	          if (isNewLine(ch)) this$1.raise(this$1.start, "Unterminated string constant")
	          ++this$1.pos
	        }
	      }
	      out += this.input.slice(chunkStart, this.pos++)
	      return this.finishToken(tt.string, out)
	    }
	
	    // Reads template string tokens.
	
	    pp$7.readTmplToken = function() {
	      var this$1 = this;
	
	      var out = "", chunkStart = this.pos
	      for (;;) {
	        if (this$1.pos >= this$1.input.length) this$1.raise(this$1.start, "Unterminated template")
	        var ch = this$1.input.charCodeAt(this$1.pos)
	        if (ch === 96 || ch === 36 && this$1.input.charCodeAt(this$1.pos + 1) === 123) { // '`', '${'
	          if (this$1.pos === this$1.start && this$1.type === tt.template) {
	            if (ch === 36) {
	              this$1.pos += 2
	              return this$1.finishToken(tt.dollarBraceL)
	            } else {
	              ++this$1.pos
	              return this$1.finishToken(tt.backQuote)
	            }
	          }
	          out += this$1.input.slice(chunkStart, this$1.pos)
	          return this$1.finishToken(tt.template, out)
	        }
	        if (ch === 92) { // '\'
	          out += this$1.input.slice(chunkStart, this$1.pos)
	          out += this$1.readEscapedChar(true)
	          chunkStart = this$1.pos
	        } else if (isNewLine(ch)) {
	          out += this$1.input.slice(chunkStart, this$1.pos)
	          ++this$1.pos
	          switch (ch) {
	            case 13:
	              if (this$1.input.charCodeAt(this$1.pos) === 10) ++this$1.pos
	            case 10:
	              out += "\n"
	              break
	            default:
	              out += String.fromCharCode(ch)
	              break
	          }
	          if (this$1.options.locations) {
	            ++this$1.curLine
	            this$1.lineStart = this$1.pos
	          }
	          chunkStart = this$1.pos
	        } else {
	          ++this$1.pos
	        }
	      }
	    }
	
	    // Used to read escaped characters
	
	    pp$7.readEscapedChar = function(inTemplate) {
	      var ch = this.input.charCodeAt(++this.pos)
	      ++this.pos
	      switch (ch) {
	      case 110: return "\n" // 'n' -> '\n'
	      case 114: return "\r" // 'r' -> '\r'
	      case 120: return String.fromCharCode(this.readHexChar(2)) // 'x'
	      case 117: return codePointToString(this.readCodePoint()) // 'u'
	      case 116: return "\t" // 't' -> '\t'
	      case 98: return "\b" // 'b' -> '\b'
	      case 118: return "\u000b" // 'v' -> '\u000b'
	      case 102: return "\f" // 'f' -> '\f'
	      case 13: if (this.input.charCodeAt(this.pos) === 10) ++this.pos // '\r\n'
	      case 10: // ' \n'
	        if (this.options.locations) { this.lineStart = this.pos; ++this.curLine }
	        return ""
	      default:
	        if (ch >= 48 && ch <= 55) {
	          var octalStr = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0]
	          var octal = parseInt(octalStr, 8)
	          if (octal > 255) {
	            octalStr = octalStr.slice(0, -1)
	            octal = parseInt(octalStr, 8)
	          }
	          if (octalStr !== "0" && (this.strict || inTemplate)) {
	            this.raise(this.pos - 2, "Octal literal in strict mode")
	          }
	          this.pos += octalStr.length - 1
	          return String.fromCharCode(octal)
	        }
	        return String.fromCharCode(ch)
	      }
	    }
	
	    // Used to read character escape sequences ('\x', '\u', '\U').
	
	    pp$7.readHexChar = function(len) {
	      var codePos = this.pos
	      var n = this.readInt(16, len)
	      if (n === null) this.raise(codePos, "Bad character escape sequence")
	      return n
	    }
	
	    // Read an identifier, and return it as a string. Sets `this.containsEsc`
	    // to whether the word contained a '\u' escape.
	    //
	    // Incrementally adds only escaped chars, adding other chunks as-is
	    // as a micro-optimization.
	
	    pp$7.readWord1 = function() {
	      var this$1 = this;
	
	      this.containsEsc = false
	      var word = "", first = true, chunkStart = this.pos
	      var astral = this.options.ecmaVersion >= 6
	      while (this.pos < this.input.length) {
	        var ch = this$1.fullCharCodeAtPos()
	        if (isIdentifierChar(ch, astral)) {
	          this$1.pos += ch <= 0xffff ? 1 : 2
	        } else if (ch === 92) { // "\"
	          this$1.containsEsc = true
	          word += this$1.input.slice(chunkStart, this$1.pos)
	          var escStart = this$1.pos
	          if (this$1.input.charCodeAt(++this$1.pos) != 117) // "u"
	            this$1.raise(this$1.pos, "Expecting Unicode escape sequence \\uXXXX")
	          ++this$1.pos
	          var esc = this$1.readCodePoint()
	          if (!(first ? isIdentifierStart : isIdentifierChar)(esc, astral))
	            this$1.raise(escStart, "Invalid Unicode escape")
	          word += codePointToString(esc)
	          chunkStart = this$1.pos
	        } else {
	          break
	        }
	        first = false
	      }
	      return word + this.input.slice(chunkStart, this.pos)
	    }
	
	    // Read an identifier or keyword token. Will check for reserved
	    // words when necessary.
	
	    pp$7.readWord = function() {
	      var word = this.readWord1()
	      var type = tt.name
	      if ((this.options.ecmaVersion >= 6 || !this.containsEsc) && this.keywords.test(word))
	        type = keywordTypes[word]
	      return this.finishToken(type, word)
	    }
	
	    var version = "3.3.0"
	
	    // The main exported interface (under `self.acorn` when in the
	    // browser) is a `parse` function that takes a code string and
	    // returns an abstract syntax tree as specified by [Mozilla parser
	    // API][api].
	    //
	    // [api]: https://developer.mozilla.org/en-US/docs/SpiderMonkey/Parser_API
	
	    function parse(input, options) {
	      return new Parser(options, input).parse()
	    }
	
	    // This function tries to parse a single expression at a given
	    // offset in a string. Useful for parsing mixed-language formats
	    // that embed JavaScript expressions.
	
	    function parseExpressionAt(input, pos, options) {
	      var p = new Parser(options, input, pos)
	      p.nextToken()
	      return p.parseExpression()
	    }
	
	    // Acorn is organized as a tokenizer and a recursive-descent parser.
	    // The `tokenizer` export provides an interface to the tokenizer.
	
	    function tokenizer(input, options) {
	      return new Parser(options, input)
	    }
	
	    exports.version = version;
	    exports.parse = parse;
	    exports.parseExpressionAt = parseExpressionAt;
	    exports.tokenizer = tokenizer;
	    exports.Parser = Parser;
	    exports.plugins = plugins;
	    exports.defaultOptions = defaultOptions;
	    exports.Position = Position;
	    exports.SourceLocation = SourceLocation;
	    exports.getLineInfo = getLineInfo;
	    exports.Node = Node;
	    exports.TokenType = TokenType;
	    exports.tokTypes = tt;
	    exports.TokContext = TokContext;
	    exports.tokContexts = types;
	    exports.isIdentifierChar = isIdentifierChar;
	    exports.isIdentifierStart = isIdentifierStart;
	    exports.Token = Token;
	    exports.isNewLine = isNewLine;
	    exports.lineBreak = lineBreak;
	    exports.lineBreakG = lineBreakG;
	
	    Object.defineProperty(exports, '__esModule', { value: true });
	
	  }));
	  });
	
	  var acorn$1 = (acorn && typeof acorn === 'object' && 'default' in acorn ? acorn['default'] : acorn);
	
	  var xhtml = __commonjs(function (module) {
	  module.exports = {
	    quot: '\u0022',
	    amp: '&',
	    apos: '\u0027',
	    lt: '<',
	    gt: '>',
	    nbsp: '\u00A0',
	    iexcl: '\u00A1',
	    cent: '\u00A2',
	    pound: '\u00A3',
	    curren: '\u00A4',
	    yen: '\u00A5',
	    brvbar: '\u00A6',
	    sect: '\u00A7',
	    uml: '\u00A8',
	    copy: '\u00A9',
	    ordf: '\u00AA',
	    laquo: '\u00AB',
	    not: '\u00AC',
	    shy: '\u00AD',
	    reg: '\u00AE',
	    macr: '\u00AF',
	    deg: '\u00B0',
	    plusmn: '\u00B1',
	    sup2: '\u00B2',
	    sup3: '\u00B3',
	    acute: '\u00B4',
	    micro: '\u00B5',
	    para: '\u00B6',
	    middot: '\u00B7',
	    cedil: '\u00B8',
	    sup1: '\u00B9',
	    ordm: '\u00BA',
	    raquo: '\u00BB',
	    frac14: '\u00BC',
	    frac12: '\u00BD',
	    frac34: '\u00BE',
	    iquest: '\u00BF',
	    Agrave: '\u00C0',
	    Aacute: '\u00C1',
	    Acirc: '\u00C2',
	    Atilde: '\u00C3',
	    Auml: '\u00C4',
	    Aring: '\u00C5',
	    AElig: '\u00C6',
	    Ccedil: '\u00C7',
	    Egrave: '\u00C8',
	    Eacute: '\u00C9',
	    Ecirc: '\u00CA',
	    Euml: '\u00CB',
	    Igrave: '\u00CC',
	    Iacute: '\u00CD',
	    Icirc: '\u00CE',
	    Iuml: '\u00CF',
	    ETH: '\u00D0',
	    Ntilde: '\u00D1',
	    Ograve: '\u00D2',
	    Oacute: '\u00D3',
	    Ocirc: '\u00D4',
	    Otilde: '\u00D5',
	    Ouml: '\u00D6',
	    times: '\u00D7',
	    Oslash: '\u00D8',
	    Ugrave: '\u00D9',
	    Uacute: '\u00DA',
	    Ucirc: '\u00DB',
	    Uuml: '\u00DC',
	    Yacute: '\u00DD',
	    THORN: '\u00DE',
	    szlig: '\u00DF',
	    agrave: '\u00E0',
	    aacute: '\u00E1',
	    acirc: '\u00E2',
	    atilde: '\u00E3',
	    auml: '\u00E4',
	    aring: '\u00E5',
	    aelig: '\u00E6',
	    ccedil: '\u00E7',
	    egrave: '\u00E8',
	    eacute: '\u00E9',
	    ecirc: '\u00EA',
	    euml: '\u00EB',
	    igrave: '\u00EC',
	    iacute: '\u00ED',
	    icirc: '\u00EE',
	    iuml: '\u00EF',
	    eth: '\u00F0',
	    ntilde: '\u00F1',
	    ograve: '\u00F2',
	    oacute: '\u00F3',
	    ocirc: '\u00F4',
	    otilde: '\u00F5',
	    ouml: '\u00F6',
	    divide: '\u00F7',
	    oslash: '\u00F8',
	    ugrave: '\u00F9',
	    uacute: '\u00FA',
	    ucirc: '\u00FB',
	    uuml: '\u00FC',
	    yacute: '\u00FD',
	    thorn: '\u00FE',
	    yuml: '\u00FF',
	    OElig: '\u0152',
	    oelig: '\u0153',
	    Scaron: '\u0160',
	    scaron: '\u0161',
	    Yuml: '\u0178',
	    fnof: '\u0192',
	    circ: '\u02C6',
	    tilde: '\u02DC',
	    Alpha: '\u0391',
	    Beta: '\u0392',
	    Gamma: '\u0393',
	    Delta: '\u0394',
	    Epsilon: '\u0395',
	    Zeta: '\u0396',
	    Eta: '\u0397',
	    Theta: '\u0398',
	    Iota: '\u0399',
	    Kappa: '\u039A',
	    Lambda: '\u039B',
	    Mu: '\u039C',
	    Nu: '\u039D',
	    Xi: '\u039E',
	    Omicron: '\u039F',
	    Pi: '\u03A0',
	    Rho: '\u03A1',
	    Sigma: '\u03A3',
	    Tau: '\u03A4',
	    Upsilon: '\u03A5',
	    Phi: '\u03A6',
	    Chi: '\u03A7',
	    Psi: '\u03A8',
	    Omega: '\u03A9',
	    alpha: '\u03B1',
	    beta: '\u03B2',
	    gamma: '\u03B3',
	    delta: '\u03B4',
	    epsilon: '\u03B5',
	    zeta: '\u03B6',
	    eta: '\u03B7',
	    theta: '\u03B8',
	    iota: '\u03B9',
	    kappa: '\u03BA',
	    lambda: '\u03BB',
	    mu: '\u03BC',
	    nu: '\u03BD',
	    xi: '\u03BE',
	    omicron: '\u03BF',
	    pi: '\u03C0',
	    rho: '\u03C1',
	    sigmaf: '\u03C2',
	    sigma: '\u03C3',
	    tau: '\u03C4',
	    upsilon: '\u03C5',
	    phi: '\u03C6',
	    chi: '\u03C7',
	    psi: '\u03C8',
	    omega: '\u03C9',
	    thetasym: '\u03D1',
	    upsih: '\u03D2',
	    piv: '\u03D6',
	    ensp: '\u2002',
	    emsp: '\u2003',
	    thinsp: '\u2009',
	    zwnj: '\u200C',
	    zwj: '\u200D',
	    lrm: '\u200E',
	    rlm: '\u200F',
	    ndash: '\u2013',
	    mdash: '\u2014',
	    lsquo: '\u2018',
	    rsquo: '\u2019',
	    sbquo: '\u201A',
	    ldquo: '\u201C',
	    rdquo: '\u201D',
	    bdquo: '\u201E',
	    dagger: '\u2020',
	    Dagger: '\u2021',
	    bull: '\u2022',
	    hellip: '\u2026',
	    permil: '\u2030',
	    prime: '\u2032',
	    Prime: '\u2033',
	    lsaquo: '\u2039',
	    rsaquo: '\u203A',
	    oline: '\u203E',
	    frasl: '\u2044',
	    euro: '\u20AC',
	    image: '\u2111',
	    weierp: '\u2118',
	    real: '\u211C',
	    trade: '\u2122',
	    alefsym: '\u2135',
	    larr: '\u2190',
	    uarr: '\u2191',
	    rarr: '\u2192',
	    darr: '\u2193',
	    harr: '\u2194',
	    crarr: '\u21B5',
	    lArr: '\u21D0',
	    uArr: '\u21D1',
	    rArr: '\u21D2',
	    dArr: '\u21D3',
	    hArr: '\u21D4',
	    forall: '\u2200',
	    part: '\u2202',
	    exist: '\u2203',
	    empty: '\u2205',
	    nabla: '\u2207',
	    isin: '\u2208',
	    notin: '\u2209',
	    ni: '\u220B',
	    prod: '\u220F',
	    sum: '\u2211',
	    minus: '\u2212',
	    lowast: '\u2217',
	    radic: '\u221A',
	    prop: '\u221D',
	    infin: '\u221E',
	    ang: '\u2220',
	    and: '\u2227',
	    or: '\u2228',
	    cap: '\u2229',
	    cup: '\u222A',
	    'int': '\u222B',
	    there4: '\u2234',
	    sim: '\u223C',
	    cong: '\u2245',
	    asymp: '\u2248',
	    ne: '\u2260',
	    equiv: '\u2261',
	    le: '\u2264',
	    ge: '\u2265',
	    sub: '\u2282',
	    sup: '\u2283',
	    nsub: '\u2284',
	    sube: '\u2286',
	    supe: '\u2287',
	    oplus: '\u2295',
	    otimes: '\u2297',
	    perp: '\u22A5',
	    sdot: '\u22C5',
	    lceil: '\u2308',
	    rceil: '\u2309',
	    lfloor: '\u230A',
	    rfloor: '\u230B',
	    lang: '\u2329',
	    rang: '\u232A',
	    loz: '\u25CA',
	    spades: '\u2660',
	    clubs: '\u2663',
	    hearts: '\u2665',
	    diams: '\u2666'
	  };
	  });
	
	  var require$$0 = (xhtml && typeof xhtml === 'object' && 'default' in xhtml ? xhtml['default'] : xhtml);
	
	  var inject = __commonjs(function (module) {
	  'use strict';
	
	  var XHTMLEntities = require$$0;
	
	  var hexNumber = /^[\da-fA-F]+$/;
	  var decimalNumber = /^\d+$/;
	
	  module.exports = function(acorn) {
	    var tt = acorn.tokTypes;
	    var tc = acorn.tokContexts;
	
	    tc.j_oTag = new acorn.TokContext('<tag', false);
	    tc.j_cTag = new acorn.TokContext('</tag', false);
	    tc.j_expr = new acorn.TokContext('<tag>...</tag>', true, true);
	
	    tt.jsxName = new acorn.TokenType('jsxName');
	    tt.jsxText = new acorn.TokenType('jsxText', {beforeExpr: true});
	    tt.jsxTagStart = new acorn.TokenType('jsxTagStart');
	    tt.jsxTagEnd = new acorn.TokenType('jsxTagEnd');
	
	    tt.jsxTagStart.updateContext = function() {
	      this.context.push(tc.j_expr); // treat as beginning of JSX expression
	      this.context.push(tc.j_oTag); // start opening tag context
	      this.exprAllowed = false;
	    };
	    tt.jsxTagEnd.updateContext = function(prevType) {
	      var out = this.context.pop();
	      if (out === tc.j_oTag && prevType === tt.slash || out === tc.j_cTag) {
	        this.context.pop();
	        this.exprAllowed = this.curContext() === tc.j_expr;
	      } else {
	        this.exprAllowed = true;
	      }
	    };
	
	    var pp = acorn.Parser.prototype;
	
	    // Reads inline JSX contents token.
	
	    pp.jsx_readToken = function() {
	      var out = '', chunkStart = this.pos;
	      for (;;) {
	        if (this.pos >= this.input.length)
	          this.raise(this.start, 'Unterminated JSX contents');
	        var ch = this.input.charCodeAt(this.pos);
	
	        switch (ch) {
	        case 60: // '<'
	        case 123: // '{'
	          if (this.pos === this.start) {
	            if (ch === 60 && this.exprAllowed) {
	              ++this.pos;
	              return this.finishToken(tt.jsxTagStart);
	            }
	            return this.getTokenFromCode(ch);
	          }
	          out += this.input.slice(chunkStart, this.pos);
	          return this.finishToken(tt.jsxText, out);
	
	        case 38: // '&'
	          out += this.input.slice(chunkStart, this.pos);
	          out += this.jsx_readEntity();
	          chunkStart = this.pos;
	          break;
	
	        default:
	          if (acorn.isNewLine(ch)) {
	            out += this.input.slice(chunkStart, this.pos);
	            out += this.jsx_readNewLine(true);
	            chunkStart = this.pos;
	          } else {
	            ++this.pos;
	          }
	        }
	      }
	    };
	
	    pp.jsx_readNewLine = function(normalizeCRLF) {
	      var ch = this.input.charCodeAt(this.pos);
	      var out;
	      ++this.pos;
	      if (ch === 13 && this.input.charCodeAt(this.pos) === 10) {
	        ++this.pos;
	        out = normalizeCRLF ? '\n' : '\r\n';
	      } else {
	        out = String.fromCharCode(ch);
	      }
	      if (this.options.locations) {
	        ++this.curLine;
	        this.lineStart = this.pos;
	      }
	
	      return out;
	    };
	
	    pp.jsx_readString = function(quote) {
	      var out = '', chunkStart = ++this.pos;
	      for (;;) {
	        if (this.pos >= this.input.length)
	          this.raise(this.start, 'Unterminated string constant');
	        var ch = this.input.charCodeAt(this.pos);
	        if (ch === quote) break;
	        if (ch === 38) { // '&'
	          out += this.input.slice(chunkStart, this.pos);
	          out += this.jsx_readEntity();
	          chunkStart = this.pos;
	        } else if (acorn.isNewLine(ch)) {
	          out += this.input.slice(chunkStart, this.pos);
	          out += this.jsx_readNewLine(false);
	          chunkStart = this.pos;
	        } else {
	          ++this.pos;
	        }
	      }
	      out += this.input.slice(chunkStart, this.pos++);
	      return this.finishToken(tt.string, out);
	    };
	
	    pp.jsx_readEntity = function() {
	      var str = '', count = 0, entity;
	      var ch = this.input[this.pos];
	      if (ch !== '&')
	        this.raise(this.pos, 'Entity must start with an ampersand');
	      var startPos = ++this.pos;
	      while (this.pos < this.input.length && count++ < 10) {
	        ch = this.input[this.pos++];
	        if (ch === ';') {
	          if (str[0] === '#') {
	            if (str[1] === 'x') {
	              str = str.substr(2);
	              if (hexNumber.test(str))
	                entity = String.fromCharCode(parseInt(str, 16));
	            } else {
	              str = str.substr(1);
	              if (decimalNumber.test(str))
	                entity = String.fromCharCode(parseInt(str, 10));
	            }
	          } else {
	            entity = XHTMLEntities[str];
	          }
	          break;
	        }
	        str += ch;
	      }
	      if (!entity) {
	        this.pos = startPos;
	        return '&';
	      }
	      return entity;
	    };
	
	
	    // Read a JSX identifier (valid tag or attribute name).
	    //
	    // Optimized version since JSX identifiers can't contain
	    // escape characters and so can be read as single slice.
	    // Also assumes that first character was already checked
	    // by isIdentifierStart in readToken.
	
	    pp.jsx_readWord = function() {
	      var ch, start = this.pos;
	      do {
	        ch = this.input.charCodeAt(++this.pos);
	      } while (acorn.isIdentifierChar(ch) || ch === 45); // '-'
	      return this.finishToken(tt.jsxName, this.input.slice(start, this.pos));
	    };
	
	    // Transforms JSX element name to string.
	
	    function getQualifiedJSXName(object) {
	      if (object.type === 'JSXIdentifier')
	        return object.name;
	
	      if (object.type === 'JSXNamespacedName')
	        return object.namespace.name + ':' + object.name.name;
	
	      if (object.type === 'JSXMemberExpression')
	        return getQualifiedJSXName(object.object) + '.' +
	        getQualifiedJSXName(object.property);
	    }
	
	    // Parse next token as JSX identifier
	
	    pp.jsx_parseIdentifier = function() {
	      var node = this.startNode();
	      if (this.type === tt.jsxName)
	        node.name = this.value;
	      else if (this.type.keyword)
	        node.name = this.type.keyword;
	      else
	        this.unexpected();
	      this.next();
	      return this.finishNode(node, 'JSXIdentifier');
	    };
	
	    // Parse namespaced identifier.
	
	    pp.jsx_parseNamespacedName = function() {
	      var startPos = this.start, startLoc = this.startLoc;
	      var name = this.jsx_parseIdentifier();
	      if (!this.options.plugins.jsx.allowNamespaces || !this.eat(tt.colon)) return name;
	      var node = this.startNodeAt(startPos, startLoc);
	      node.namespace = name;
	      node.name = this.jsx_parseIdentifier();
	      return this.finishNode(node, 'JSXNamespacedName');
	    };
	
	    // Parses element name in any form - namespaced, member
	    // or single identifier.
	
	    pp.jsx_parseElementName = function() {
	      var startPos = this.start, startLoc = this.startLoc;
	      var node = this.jsx_parseNamespacedName();
	      if (this.type === tt.dot && node.type === 'JSXNamespacedName' && !this.options.plugins.jsx.allowNamespacedObjects) {
	        this.unexpected();
	      }
	      while (this.eat(tt.dot)) {
	        var newNode = this.startNodeAt(startPos, startLoc);
	        newNode.object = node;
	        newNode.property = this.jsx_parseIdentifier();
	        node = this.finishNode(newNode, 'JSXMemberExpression');
	      }
	      return node;
	    };
	
	    // Parses any type of JSX attribute value.
	
	    pp.jsx_parseAttributeValue = function() {
	      switch (this.type) {
	      case tt.braceL:
	        var node = this.jsx_parseExpressionContainer();
	        if (node.expression.type === 'JSXEmptyExpression')
	          this.raise(node.start, 'JSX attributes must only be assigned a non-empty expression');
	        return node;
	
	      case tt.jsxTagStart:
	      case tt.string:
	        return this.parseExprAtom();
	
	      default:
	        this.raise(this.start, 'JSX value should be either an expression or a quoted JSX text');
	      }
	    };
	
	    // JSXEmptyExpression is unique type since it doesn't actually parse anything,
	    // and so it should start at the end of last read token (left brace) and finish
	    // at the beginning of the next one (right brace).
	
	    pp.jsx_parseEmptyExpression = function() {
	      var node = this.startNodeAt(this.lastTokEnd, this.lastTokEndLoc);
	      return this.finishNodeAt(node, 'JSXEmptyExpression', this.start, this.startLoc);
	    };
	
	    // Parses JSX expression enclosed into curly brackets.
	
	
	    pp.jsx_parseExpressionContainer = function() {
	      var node = this.startNode();
	      this.next();
	      node.expression = this.type === tt.braceR
	        ? this.jsx_parseEmptyExpression()
	        : this.parseExpression();
	      this.expect(tt.braceR);
	      return this.finishNode(node, 'JSXExpressionContainer');
	    };
	
	    // Parses following JSX attribute name-value pair.
	
	    pp.jsx_parseAttribute = function() {
	      var node = this.startNode();
	      if (this.eat(tt.braceL)) {
	        this.expect(tt.ellipsis);
	        node.argument = this.parseMaybeAssign();
	        this.expect(tt.braceR);
	        return this.finishNode(node, 'JSXSpreadAttribute');
	      }
	      node.name = this.jsx_parseNamespacedName();
	      node.value = this.eat(tt.eq) ? this.jsx_parseAttributeValue() : null;
	      return this.finishNode(node, 'JSXAttribute');
	    };
	
	    // Parses JSX opening tag starting after '<'.
	
	    pp.jsx_parseOpeningElementAt = function(startPos, startLoc) {
	      var node = this.startNodeAt(startPos, startLoc);
	      node.attributes = [];
	      node.name = this.jsx_parseElementName();
	      while (this.type !== tt.slash && this.type !== tt.jsxTagEnd)
	        node.attributes.push(this.jsx_parseAttribute());
	      node.selfClosing = this.eat(tt.slash);
	      this.expect(tt.jsxTagEnd);
	      return this.finishNode(node, 'JSXOpeningElement');
	    };
	
	    // Parses JSX closing tag starting after '</'.
	
	    pp.jsx_parseClosingElementAt = function(startPos, startLoc) {
	      var node = this.startNodeAt(startPos, startLoc);
	      node.name = this.jsx_parseElementName();
	      this.expect(tt.jsxTagEnd);
	      return this.finishNode(node, 'JSXClosingElement');
	    };
	
	    // Parses entire JSX element, including it's opening tag
	    // (starting after '<'), attributes, contents and closing tag.
	
	    pp.jsx_parseElementAt = function(startPos, startLoc) {
	      var node = this.startNodeAt(startPos, startLoc);
	      var children = [];
	      var openingElement = this.jsx_parseOpeningElementAt(startPos, startLoc);
	      var closingElement = null;
	
	      if (!openingElement.selfClosing) {
	        contents: for (;;) {
	          switch (this.type) {
	          case tt.jsxTagStart:
	            startPos = this.start; startLoc = this.startLoc;
	            this.next();
	            if (this.eat(tt.slash)) {
	              closingElement = this.jsx_parseClosingElementAt(startPos, startLoc);
	              break contents;
	            }
	            children.push(this.jsx_parseElementAt(startPos, startLoc));
	            break;
	
	          case tt.jsxText:
	            children.push(this.parseExprAtom());
	            break;
	
	          case tt.braceL:
	            children.push(this.jsx_parseExpressionContainer());
	            break;
	
	          default:
	            this.unexpected();
	          }
	        }
	        if (getQualifiedJSXName(closingElement.name) !== getQualifiedJSXName(openingElement.name)) {
	          this.raise(
	            closingElement.start,
	            'Expected corresponding JSX closing tag for <' + getQualifiedJSXName(openingElement.name) + '>');
	        }
	      }
	
	      node.openingElement = openingElement;
	      node.closingElement = closingElement;
	      node.children = children;
	      if (this.type === tt.relational && this.value === "<") {
	        this.raise(this.start, "Adjacent JSX elements must be wrapped in an enclosing tag");
	      }
	      return this.finishNode(node, 'JSXElement');
	    };
	
	    // Parses entire JSX element from current position.
	
	    pp.jsx_parseElement = function() {
	      var startPos = this.start, startLoc = this.startLoc;
	      this.next();
	      return this.jsx_parseElementAt(startPos, startLoc);
	    };
	
	    acorn.plugins.jsx = function(instance, opts) {
	      if (!opts) {
	        return;
	      }
	
	      if (typeof opts !== 'object') {
	        opts = {};
	      }
	
	      instance.options.plugins.jsx = {
	        allowNamespaces: opts.allowNamespaces !== false,
	        allowNamespacedObjects: !!opts.allowNamespacedObjects
	      };
	
	      instance.extend('parseExprAtom', function(inner) {
	        return function(refShortHandDefaultPos) {
	          if (this.type === tt.jsxText)
	            return this.parseLiteral(this.value);
	          else if (this.type === tt.jsxTagStart)
	            return this.jsx_parseElement();
	          else
	            return inner.call(this, refShortHandDefaultPos);
	        };
	      });
	
	      instance.extend('readToken', function(inner) {
	        return function(code) {
	          var context = this.curContext();
	
	          if (context === tc.j_expr) return this.jsx_readToken();
	
	          if (context === tc.j_oTag || context === tc.j_cTag) {
	            if (acorn.isIdentifierStart(code)) return this.jsx_readWord();
	
	            if (code == 62) {
	              ++this.pos;
	              return this.finishToken(tt.jsxTagEnd);
	            }
	
	            if ((code === 34 || code === 39) && context == tc.j_oTag)
	              return this.jsx_readString(code);
	          }
	
	          if (code === 60 && this.exprAllowed) {
	            ++this.pos;
	            return this.finishToken(tt.jsxTagStart);
	          }
	          return inner.call(this, code);
	        };
	      });
	
	      instance.extend('updateContext', function(inner) {
	        return function(prevType) {
	          if (this.type == tt.braceL) {
	            var curContext = this.curContext();
	            if (curContext == tc.j_oTag) this.context.push(tc.b_expr);
	            else if (curContext == tc.j_expr) this.context.push(tc.b_tmpl);
	            else inner.call(this, prevType);
	            this.exprAllowed = true;
	          } else if (this.type === tt.slash && prevType === tt.jsxTagStart) {
	            this.context.length -= 2; // do not consider JSX expr -> JSX open tag -> ... anymore
	            this.context.push(tc.j_cTag); // reconsider as closing tag context
	            this.exprAllowed = false;
	          } else {
	            return inner.call(this, prevType);
	          }
	        };
	      });
	    };
	
	    return acorn;
	  };
	  });
	
	  var acornJsx = (inject && typeof inject === 'object' && 'default' in inject ? inject['default'] : inject);
	
	  var inject$1 = __commonjs(function (module) {
	  'use strict';
	
	  module.exports = function(acorn) {
	    var tt = acorn.tokTypes;
	    var pp = acorn.Parser.prototype;
	
	    // this is the same parseObj that acorn has with...
	    function parseObj(isPattern, refDestructuringErrors) {
	      var this$1 = this;
	
	      var node = this.startNode(), first = true, propHash = {}
	      node.properties = []
	      this.next()
	      while (!this$1.eat(tt.braceR)) {
	        if (!first) {
	          this$1.expect(tt.comma)
	          if (this$1.afterTrailingComma(tt.braceR)) break
	        } else first = false
	
	        var prop = this$1.startNode(), isGenerator, startPos, startLoc
	        if (this$1.options.ecmaVersion >= 6) {
	          // ...the spread logic borrowed from babylon :)
	          if (this$1.type === tt.ellipsis) {
	            prop = this$1.parseSpread()
	            prop.type = isPattern ? "RestProperty" : "SpreadProperty"
	            node.properties.push(prop)
	            continue
	          }
	
	          prop.method = false
	          prop.shorthand = false
	          if (isPattern || refDestructuringErrors) {
	            startPos = this$1.start
	            startLoc = this$1.startLoc
	          }
	          if (!isPattern)
	            isGenerator = this$1.eat(tt.star)
	        }
	        this$1.parsePropertyName(prop)
	        this$1.parsePropertyValue(prop, isPattern, isGenerator, startPos, startLoc, refDestructuringErrors)
	        this$1.checkPropClash(prop, propHash)
	        node.properties.push(this$1.finishNode(prop, "Property"))
	      }
	      return this.finishNode(node, isPattern ? "ObjectPattern" : "ObjectExpression")
	    }
	
	    acorn.plugins.objectSpread = function objectSpreadPlugin(instance) {
	      pp.parseObj = parseObj;
	    };
	
	    return acorn;
	  };
	  });
	
	  var acornObjectSpread = (inject$1 && typeof inject$1 === 'object' && 'default' in inject$1 ? inject$1['default'] : inject$1);
	
	  var charToInteger = {};
	  var integerToChar = {};
	
	  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='.split( '' ).forEach( function ( char, i ) {
	  	charToInteger[ char ] = i;
	  	integerToChar[ i ] = char;
	  });
	
	  function encode ( value ) {
	  	var result, i;
	
	  	if ( typeof value === 'number' ) {
	  		result = encodeInteger( value );
	  	} else {
	  		result = '';
	  		for ( i = 0; i < value.length; i += 1 ) {
	  			result += encodeInteger( value[i] );
	  		}
	  	}
	
	  	return result;
	  }
	
	  function encodeInteger ( num ) {
	  	var result = '', clamped;
	
	  	if ( num < 0 ) {
	  		num = ( -num << 1 ) | 1;
	  	} else {
	  		num <<= 1;
	  	}
	
	  	do {
	  		clamped = num & 31;
	  		num >>= 5;
	
	  		if ( num > 0 ) {
	  			clamped |= 32;
	  		}
	
	  		result += integerToChar[ clamped ];
	  	} while ( num > 0 );
	
	  	return result;
	  }
	
	  function Chunk ( start, end, content ) {
	  	this.start = start;
	  	this.end = end;
	  	this.original = content;
	
	  	this.intro = '';
	  	this.outro = '';
	
	  	this.content = content;
	  	this.storeName = false;
	  	this.edited = false;
	
	  	// we make these non-enumerable, for sanity while debugging
	  	Object.defineProperties( this, {
	  		previous: { writable: true, value: null },
	  		next: { writable: true, value: null }
	  	});
	  }
	
	  Chunk.prototype = {
	  	append: function append ( content ) {
	  		this.outro += content;
	  	},
	
	  	clone: function clone () {
	  		var chunk = new Chunk( this.start, this.end, this.original );
	
	  		chunk.intro = this.intro;
	  		chunk.outro = this.outro;
	  		chunk.content = this.content;
	  		chunk.storeName = this.storeName;
	  		chunk.edited = this.edited;
	
	  		return chunk;
	  	},
	
	  	contains: function contains ( index ) {
	  		return this.start < index && index < this.end;
	  	},
	
	  	eachNext: function eachNext ( fn ) {
	  		var chunk = this;
	  		while ( chunk ) {
	  			fn( chunk );
	  			chunk = chunk.next;
	  		}
	  	},
	
	  	eachPrevious: function eachPrevious ( fn ) {
	  		var chunk = this;
	  		while ( chunk ) {
	  			fn( chunk );
	  			chunk = chunk.previous;
	  		}
	  	},
	
	  	edit: function edit ( content, storeName ) {
	  		this.content = content;
	  		this.storeName = storeName;
	
	  		this.edited = true;
	
	  		return this;
	  	},
	
	  	prepend: function prepend ( content ) {
	  		this.intro = content + this.intro;
	  	},
	
	  	split: function split ( index ) {
	  		var sliceIndex = index - this.start;
	
	  		var originalBefore = this.original.slice( 0, sliceIndex );
	  		var originalAfter = this.original.slice( sliceIndex );
	
	  		this.original = originalBefore;
	
	  		var newChunk = new Chunk( index, this.end, originalAfter );
	  		newChunk.outro = this.outro;
	  		this.outro = '';
	
	  		this.end = index;
	
	  		if ( this.edited ) {
	  			// TODO is this block necessary?...
	  			newChunk.edit( '', false );
	  			this.content = '';
	  		} else {
	  			this.content = originalBefore;
	  		}
	
	  		newChunk.next = this.next;
	  		if ( newChunk.next ) newChunk.next.previous = newChunk;
	  		newChunk.previous = this;
	  		this.next = newChunk;
	
	  		return newChunk;
	  	},
	
	  	toString: function toString () {
	  		return this.intro + this.content + this.outro;
	  	},
	
	  	trimEnd: function trimEnd ( rx ) {
	  		this.outro = this.outro.replace( rx, '' );
	  		if ( this.outro.length ) return true;
	
	  		var trimmed = this.content.replace( rx, '' );
	
	  		if ( trimmed.length ) {
	  			if ( trimmed !== this.content ) {
	  				this.split( this.start + trimmed.length ).edit( '', false );
	  			}
	
	  			return true;
	  		} else {
	  			this.edit( '', false );
	
	  			this.intro = this.intro.replace( rx, '' );
	  			if ( this.intro.length ) return true;
	  		}
	  	},
	
	  	trimStart: function trimStart ( rx ) {
	  		this.intro = this.intro.replace( rx, '' );
	  		if ( this.intro.length ) return true;
	
	  		var trimmed = this.content.replace( rx, '' );
	
	  		if ( trimmed.length ) {
	  			if ( trimmed !== this.content ) {
	  				this.split( this.end - trimmed.length );
	  				this.edit( '', false );
	  			}
	
	  			return true;
	  		} else {
	  			this.edit( '', false );
	
	  			this.outro = this.outro.replace( rx, '' );
	  			if ( this.outro.length ) return true;
	  		}
	  	}
	  };
	
	  var _btoa;
	
	  if ( typeof window !== 'undefined' && typeof window.btoa === 'function' ) {
	  	_btoa = window.btoa;
	  } else if ( typeof Buffer === 'function' ) {
	  	_btoa = function ( str ) { return new Buffer( str ).toString( 'base64' ); };
	  } else {
	  	_btoa = function () {
	  		throw new Error( 'Unsupported environment: `window.btoa` or `Buffer` should be supported.' );
	  	};
	  }
	
	  var btoa = _btoa;
	
	  function SourceMap ( properties ) {
	  	this.version = 3;
	
	  	this.file           = properties.file;
	  	this.sources        = properties.sources;
	  	this.sourcesContent = properties.sourcesContent;
	  	this.names          = properties.names;
	  	this.mappings       = properties.mappings;
	  }
	
	  SourceMap.prototype = {
	  	toString: function toString () {
	  		return JSON.stringify( this );
	  	},
	
	  	toUrl: function toUrl () {
	  		return 'data:application/json;charset=utf-8;base64,' + btoa( this.toString() );
	  	}
	  };
	
	  function guessIndent ( code ) {
	  	var lines = code.split( '\n' );
	
	  	var tabbed = lines.filter( function ( line ) { return /^\t+/.test( line ); } );
	  	var spaced = lines.filter( function ( line ) { return /^ {2,}/.test( line ); } );
	
	  	if ( tabbed.length === 0 && spaced.length === 0 ) {
	  		return null;
	  	}
	
	  	// More lines tabbed than spaced? Assume tabs, and
	  	// default to tabs in the case of a tie (or nothing
	  	// to go on)
	  	if ( tabbed.length >= spaced.length ) {
	  		return '\t';
	  	}
	
	  	// Otherwise, we need to guess the multiple
	  	var min = spaced.reduce( function ( previous, current ) {
	  		var numSpaces = /^ +/.exec( current )[0].length;
	  		return Math.min( numSpaces, previous );
	  	}, Infinity );
	
	  	return new Array( min + 1 ).join( ' ' );
	  }
	
	  function getLocator ( source ) {
	  	var originalLines = source.split( '\n' );
	
	  	var start = 0;
	  	var lineRanges = originalLines.map( function ( line, i ) {
	  		var end = start + line.length + 1;
	  		var range = { start: start, end: end, line: i };
	
	  		start = end;
	  		return range;
	  	});
	
	  	var i = 0;
	
	  	function rangeContains ( range, index ) {
	  		return range.start <= index && index < range.end;
	  	}
	
	  	function getLocation ( range, index ) {
	  		return { line: range.line, column: index - range.start };
	  	}
	
	  	return function locate ( index ) {
	  		var range = lineRanges[i];
	
	  		var d = index >= range.end ? 1 : -1;
	
	  		while ( range ) {
	  			if ( rangeContains( range, index ) ) return getLocation( range, index );
	
	  			i += d;
	  			range = lineRanges[i];
	  		}
	  	};
	  }
	
	  function encodeMappings ( original, intro, chunk, hires, sourcemapLocations, sourceIndex, offsets, names ) {
	  	var rawLines = [];
	
	  	var generatedCodeLine = intro.split( '\n' ).length - 1;
	  	var rawSegments = rawLines[ generatedCodeLine ] = [];
	
	  	var generatedCodeColumn = 0;
	
	  	var locate = getLocator( original );
	
	  	function addEdit ( content, original, loc, nameIndex, i ) {
	  		if ( i || content.length ) {
	  			rawSegments.push({
	  				generatedCodeLine: generatedCodeLine,
	  				generatedCodeColumn: generatedCodeColumn,
	  				sourceCodeLine: loc.line,
	  				sourceCodeColumn: loc.column,
	  				sourceCodeName: nameIndex,
	  				sourceIndex: sourceIndex
	  			});
	  		}
	
	  		var lines = content.split( '\n' );
	  		var lastLine = lines.pop();
	
	  		if ( lines.length ) {
	  			generatedCodeLine += lines.length;
	  			rawLines[ generatedCodeLine ] = rawSegments = [];
	  			generatedCodeColumn = lastLine.length;
	  		} else {
	  			generatedCodeColumn += lastLine.length;
	  		}
	
	  		lines = original.split( '\n' );
	  		lastLine = lines.pop();
	
	  		if ( lines.length ) {
	  			loc.line += lines.length;
	  			loc.column = lastLine.length;
	  		} else {
	  			loc.column += lastLine.length;
	  		}
	  	}
	
	  	function addUneditedChunk ( chunk, loc ) {
	  		var originalCharIndex = chunk.start;
	  		var first = true;
	
	  		while ( originalCharIndex < chunk.end ) {
	  			if ( hires || first || sourcemapLocations[ originalCharIndex ] ) {
	  				rawSegments.push({
	  					generatedCodeLine: generatedCodeLine,
	  					generatedCodeColumn: generatedCodeColumn,
	  					sourceCodeLine: loc.line,
	  					sourceCodeColumn: loc.column,
	  					sourceCodeName: -1,
	  					sourceIndex: sourceIndex
	  				});
	  			}
	
	  			if ( original[ originalCharIndex ] === '\n' ) {
	  				loc.line += 1;
	  				loc.column = 0;
	  				generatedCodeLine += 1;
	  				rawLines[ generatedCodeLine ] = rawSegments = [];
	  				generatedCodeColumn = 0;
	  			} else {
	  				loc.column += 1;
	  				generatedCodeColumn += 1;
	  			}
	
	  			originalCharIndex += 1;
	  			first = false;
	  		}
	  	}
	
	  	while ( chunk ) {
	  		var loc = locate( chunk.start );
	
	  		if ( chunk.intro.length ) {
	  			addEdit( chunk.intro, '', loc, -1, !!chunk.previous );
	  		}
	
	  		if ( chunk.edited ) {
	  			addEdit( chunk.content, chunk.original, loc, chunk.storeName ? names.indexOf( chunk.original ) : -1, !!chunk.previous );
	  		} else {
	  			addUneditedChunk( chunk, loc );
	  		}
	
	  		if ( chunk.outro.length ) {
	  			addEdit( chunk.outro, '', loc, -1, !!chunk.previous );
	  		}
	
	  		var nextChunk = chunk.next;
	  		chunk = nextChunk;
	  	}
	
	  	offsets.sourceIndex = offsets.sourceIndex || 0;
	  	offsets.sourceCodeLine = offsets.sourceCodeLine || 0;
	  	offsets.sourceCodeColumn = offsets.sourceCodeColumn || 0;
	  	offsets.sourceCodeName = offsets.sourceCodeName || 0;
	
	  	var encoded = rawLines.map( function ( segments ) {
	  		var generatedCodeColumn = 0;
	
	  		return segments.map( function ( segment ) {
	  			var arr = [
	  				segment.generatedCodeColumn - generatedCodeColumn,
	  				segment.sourceIndex - offsets.sourceIndex,
	  				segment.sourceCodeLine - offsets.sourceCodeLine,
	  				segment.sourceCodeColumn - offsets.sourceCodeColumn
	  			];
	
	  			generatedCodeColumn = segment.generatedCodeColumn;
	  			offsets.sourceIndex = segment.sourceIndex;
	  			offsets.sourceCodeLine = segment.sourceCodeLine;
	  			offsets.sourceCodeColumn = segment.sourceCodeColumn;
	
	  			if ( ~segment.sourceCodeName ) {
	  				arr.push( segment.sourceCodeName - offsets.sourceCodeName );
	  				offsets.sourceCodeName = segment.sourceCodeName;
	  			}
	
	  			return encode( arr );
	  		}).join( ',' );
	  	}).join( ';' );
	
	  	return encoded;
	  }
	
	  function getRelativePath ( from, to ) {
	  	var fromParts = from.split( /[\/\\]/ );
	  	var toParts = to.split( /[\/\\]/ );
	
	  	fromParts.pop(); // get dirname
	
	  	while ( fromParts[0] === toParts[0] ) {
	  		fromParts.shift();
	  		toParts.shift();
	  	}
	
	  	if ( fromParts.length ) {
	  		var i = fromParts.length;
	  		while ( i-- ) fromParts[i] = '..';
	  	}
	
	  	return fromParts.concat( toParts ).join( '/' );
	  }
	
	  var toString = Object.prototype.toString;
	
	  function isObject ( thing ) {
	  	return toString.call( thing ) === '[object Object]';
	  }
	
	  function MagicString ( string, options ) {
	  	if ( options === void 0 ) options = {};
	
	  	var chunk = new Chunk( 0, string.length, string );
	
	  	Object.defineProperties( this, {
	  		original:              { writable: true, value: string },
	  		outro:                 { writable: true, value: '' },
	  		intro:                 { writable: true, value: '' },
	  		firstChunk:            { writable: true, value: chunk },
	  		lastChunk:             { writable: true, value: chunk },
	  		lastSearchedChunk:     { writable: true, value: chunk },
	  		byStart:               { writable: true, value: {} },
	  		byEnd:                 { writable: true, value: {} },
	  		filename:              { writable: true, value: options.filename },
	  		indentExclusionRanges: { writable: true, value: options.indentExclusionRanges },
	  		sourcemapLocations:    { writable: true, value: {} },
	  		storedNames:           { writable: true, value: {} },
	  		indentStr:             { writable: true, value: guessIndent( string ) }
	  	});
	
	  	if ( false ) {}
	
	  	this.byStart[ 0 ] = chunk;
	  	this.byEnd[ string.length ] = chunk;
	  }
	
	  MagicString.prototype = {
	  	addSourcemapLocation: function addSourcemapLocation ( char ) {
	  		this.sourcemapLocations[ char ] = true;
	  	},
	
	  	append: function append ( content ) {
	  		if ( typeof content !== 'string' ) throw new TypeError( 'outro content must be a string' );
	
	  		this.outro += content;
	  		return this;
	  	},
	
	  	clone: function clone () {
	  		var cloned = new MagicString( this.original, { filename: this.filename });
	
	  		var originalChunk = this.firstChunk;
	  		var clonedChunk = cloned.firstChunk = cloned.lastSearchedChunk = originalChunk.clone();
	
	  		while ( originalChunk ) {
	  			cloned.byStart[ clonedChunk.start ] = clonedChunk;
	  			cloned.byEnd[ clonedChunk.end ] = clonedChunk;
	
	  			var nextOriginalChunk = originalChunk.next;
	  			var nextClonedChunk = nextOriginalChunk && nextOriginalChunk.clone();
	
	  			if ( nextClonedChunk ) {
	  				clonedChunk.next = nextClonedChunk;
	  				nextClonedChunk.previous = clonedChunk;
	
	  				clonedChunk = nextClonedChunk;
	  			}
	
	  			originalChunk = nextOriginalChunk;
	  		}
	
	  		cloned.lastChunk = clonedChunk;
	
	  		if ( this.indentExclusionRanges ) {
	  			cloned.indentExclusionRanges = typeof this.indentExclusionRanges[0] === 'number' ?
	  				[ this.indentExclusionRanges[0], this.indentExclusionRanges[1] ] :
	  				this.indentExclusionRanges.map( function ( range ) { return [ range.start, range.end ]; } );
	  		}
	
	  		Object.keys( this.sourcemapLocations ).forEach( function ( loc ) {
	  			cloned.sourcemapLocations[ loc ] = true;
	  		});
	
	  		return cloned;
	  	},
	
	  	generateMap: function generateMap ( options ) {
	  		options = options || {};
	
	  		var names = Object.keys( this.storedNames );
	
	  		if ( false ) {}
	  		var map = new SourceMap({
	  			file: ( options.file ? options.file.split( /[\/\\]/ ).pop() : null ),
	  			sources: [ options.source ? getRelativePath( options.file || '', options.source ) : null ],
	  			sourcesContent: options.includeContent ? [ this.original ] : [ null ],
	  			names: names,
	  			mappings: this.getMappings( options.hires, 0, {}, names )
	  		});
	  		if ( false ) {}
	
	  		return map;
	  	},
	
	  	getIndentString: function getIndentString () {
	  		return this.indentStr === null ? '\t' : this.indentStr;
	  	},
	
	  	getMappings: function getMappings ( hires, sourceIndex, offsets, names ) {
	  		return encodeMappings( this.original, this.intro, this.firstChunk, hires, this.sourcemapLocations, sourceIndex, offsets, names );
	  	},
	
	  	indent: function indent ( indentStr, options ) {
	  		var this$1 = this;
	
	  		var pattern = /^[^\r\n]/gm;
	
	  		if ( isObject( indentStr ) ) {
	  			options = indentStr;
	  			indentStr = undefined;
	  		}
	
	  		indentStr = indentStr !== undefined ? indentStr : ( this.indentStr || '\t' );
	
	  		if ( indentStr === '' ) return this; // noop
	
	  		options = options || {};
	
	  		// Process exclusion ranges
	  		var isExcluded = {};
	
	  		if ( options.exclude ) {
	  			var exclusions = typeof options.exclude[0] === 'number' ? [ options.exclude ] : options.exclude;
	  			exclusions.forEach( function ( exclusion ) {
	  				for ( var i = exclusion[0]; i < exclusion[1]; i += 1 ) {
	  					isExcluded[i] = true;
	  				}
	  			});
	  		}
	
	  		var shouldIndentNextCharacter = options.indentStart !== false;
	  		var replacer = function ( match ) {
	  			if ( shouldIndentNextCharacter ) return ("" + indentStr + match);
	  			shouldIndentNextCharacter = true;
	  			return match;
	  		};
	
	  		this.intro = this.intro.replace( pattern, replacer );
	
	  		var charIndex = 0;
	
	  		var chunk = this.firstChunk;
	
	  		while ( chunk ) {
	  			var end = chunk.end;
	
	  			if ( chunk.edited ) {
	  				if ( !isExcluded[ charIndex ] ) {
	  					chunk.content = chunk.content.replace( pattern, replacer );
	
	  					if ( chunk.content.length ) {
	  						shouldIndentNextCharacter = chunk.content[ chunk.content.length - 1 ] === '\n';
	  					}
	  				}
	  			} else {
	  				charIndex = chunk.start;
	
	  				while ( charIndex < end ) {
	  					if ( !isExcluded[ charIndex ] ) {
	  						var char = this$1.original[ charIndex ];
	
	  						if ( char === '\n' ) {
	  							shouldIndentNextCharacter = true;
	  						} else if ( char !== '\r' && shouldIndentNextCharacter ) {
	  							shouldIndentNextCharacter = false;
	
	  							if ( charIndex === chunk.start ) {
	  								chunk.prepend( indentStr );
	  							} else {
	  								var rhs = chunk.split( charIndex );
	  								rhs.prepend( indentStr );
	
	  								this$1.byStart[ charIndex ] = rhs;
	  								this$1.byEnd[ charIndex ] = chunk;
	
	  								chunk = rhs;
	  							}
	  						}
	  					}
	
	  					charIndex += 1;
	  				}
	  			}
	
	  			charIndex = chunk.end;
	  			chunk = chunk.next;
	  		}
	
	  		this.outro = this.outro.replace( pattern, replacer );
	
	  		return this;
	  	},
	
	  	insert: function insert () {
	  		throw new Error( 'magicString.insert(...) is deprecated. Use insertRight(...) or insertLeft(...)' );
	  	},
	
	  	insertLeft: function insertLeft ( index, content ) {
	  		if ( typeof content !== 'string' ) throw new TypeError( 'inserted content must be a string' );
	
	  		if ( false ) {}
	
	  		this._split( index );
	
	  		var chunk = this.byEnd[ index ];
	
	  		if ( chunk ) {
	  			chunk.append( content );
	  		} else {
	  			this.intro += content;
	  		}
	
	  		if ( false ) {}
	  		return this;
	  	},
	
	  	insertRight: function insertRight ( index, content ) {
	  		if ( typeof content !== 'string' ) throw new TypeError( 'inserted content must be a string' );
	
	  		if ( false ) {}
	
	  		this._split( index );
	
	  		var chunk = this.byStart[ index ];
	
	  		if ( chunk ) {
	  			chunk.prepend( content );
	  		} else {
	  			this.outro += content;
	  		}
	
	  		if ( false ) {}
	  		return this;
	  	},
	
	  	move: function move ( start, end, index ) {
	  		if ( index >= start && index <= end ) throw new Error( 'Cannot move a selection inside itself' );
	
	  		if ( false ) {}
	
	  		this._split( start );
	  		this._split( end );
	  		this._split( index );
	
	  		var first = this.byStart[ start ];
	  		var last = this.byEnd[ end ];
	
	  		var oldLeft = first.previous;
	  		var oldRight = last.next;
	
	  		var newRight = this.byStart[ index ];
	  		if ( !newRight && last === this.lastChunk ) return this;
	  		var newLeft = newRight ? newRight.previous : this.lastChunk;
	
	  		if ( oldLeft ) oldLeft.next = oldRight;
	  		if ( oldRight ) oldRight.previous = oldLeft;
	
	  		if ( newLeft ) newLeft.next = first;
	  		if ( newRight ) newRight.previous = last;
	
	  		if ( !first.previous ) this.firstChunk = last.next;
	  		if ( !last.next ) {
	  			this.lastChunk = first.previous;
	  			this.lastChunk.next = null;
	  		}
	
	  		first.previous = newLeft;
	  		last.next = newRight;
	
	  		if ( !newLeft ) this.firstChunk = first;
	  		if ( !newRight ) this.lastChunk = last;
	
	  		if ( false ) {}
	  		return this;
	  	},
	
	  	overwrite: function overwrite ( start, end, content, storeName ) {
	  		var this$1 = this;
	
	  		if ( typeof content !== 'string' ) throw new TypeError( 'replacement content must be a string' );
	
	  		while ( start < 0 ) start += this$1.original.length;
	  		while ( end < 0 ) end += this$1.original.length;
	
	  		if ( end > this.original.length ) throw new Error( 'end is out of bounds' );
	  		if ( start === end ) throw new Error( 'Cannot overwrite a zero-length range – use insertLeft or insertRight instead' );
	
	  		if ( false ) {}
	
	  		this._split( start );
	  		this._split( end );
	
	  		if ( storeName ) {
	  			var original = this.original.slice( start, end );
	  			this.storedNames[ original ] = true;
	  		}
	
	  		var first = this.byStart[ start ];
	  		var last = this.byEnd[ end ];
	
	  		if ( first ) {
	  			first.edit( content, storeName );
	
	  			if ( first !== last ) {
	  				first.outro = '';
	
	  				var chunk = first.next;
	  				while ( chunk !== last ) {
	  					chunk.edit( '', false );
	  					chunk.intro = chunk.outro = '';
	  					chunk = chunk.next;
	  				}
	
	  				chunk.edit( '', false );
	  				chunk.intro = '';
	  			}
	  		}
	
	  		else {
	  			// must be inserting at the end
	  			var newChunk = new Chunk( start, end, '' ).edit( content, storeName );
	
	  			// TODO last chunk in the array may not be the last chunk, if it's moved...
	  			last.next = newChunk;
	  			newChunk.previous = last;
	  		}
	
	  		if ( false ) {}
	  		return this;
	  	},
	
	  	prepend: function prepend ( content ) {
	  		if ( typeof content !== 'string' ) throw new TypeError( 'outro content must be a string' );
	
	  		this.intro = content + this.intro;
	  		return this;
	  	},
	
	  	remove: function remove ( start, end ) {
	  		var this$1 = this;
	
	  		while ( start < 0 ) start += this$1.original.length;
	  		while ( end < 0 ) end += this$1.original.length;
	
	  		if ( start === end ) return this;
	
	  		if ( start < 0 || end > this.original.length ) throw new Error( 'Character is out of bounds' );
	  		if ( start > end ) throw new Error( 'end must be greater than start' );
	
	  		return this.overwrite( start, end, '', false );
	  	},
	
	  	slice: function slice ( start, end ) {
	  		var this$1 = this;
	  		if ( start === void 0 ) start = 0;
	  		if ( end === void 0 ) end = this.original.length;
	
	  		while ( start < 0 ) start += this$1.original.length;
	  		while ( end < 0 ) end += this$1.original.length;
	
	  		var result = '';
	
	  		// find start chunk
	  		var chunk = this.firstChunk;
	  		while ( chunk && ( chunk.start > start || chunk.end <= start ) ) {
	
	  			// found end chunk before start
	  			if ( chunk.start < end && chunk.end >= end ) {
	  				return result;
	  			}
	
	  			chunk = chunk.next;
	  		}
	
	  		if ( chunk && chunk.edited && chunk.start !== start ) throw new Error(("Cannot use replaced character " + start + " as slice start anchor."));
	
	  		var startChunk = chunk;
	  		while ( chunk ) {
	  			if ( chunk.intro && ( startChunk !== chunk || chunk.start === start ) ) {
	  				result += chunk.intro;
	  			}
	
	  			var containsEnd = chunk.start < end && chunk.end >= end;
	  			if ( containsEnd && chunk.edited && chunk.end !== end ) throw new Error(("Cannot use replaced character " + end + " as slice end anchor."));
	
	  			var sliceStart = startChunk === chunk ? start - chunk.start : 0;
	  			var sliceEnd = containsEnd ? chunk.content.length + end - chunk.end : chunk.content.length;
	
	  			result += chunk.content.slice( sliceStart, sliceEnd );
	
	  			if ( chunk.outro && ( !containsEnd || chunk.end === end ) ) {
	  				result += chunk.outro;
	  			}
	
	  			if ( containsEnd ) {
	  				break;
	  			}
	
	  			chunk = chunk.next;
	  		}
	
	  		return result;
	  	},
	
	  	// TODO deprecate this? not really very useful
	  	snip: function snip ( start, end ) {
	  		var clone = this.clone();
	  		clone.remove( 0, start );
	  		clone.remove( end, clone.original.length );
	
	  		return clone;
	  	},
	
	  	_split: function _split ( index ) {
	  		var this$1 = this;
	
	  		if ( this.byStart[ index ] || this.byEnd[ index ] ) return;
	
	  		if ( false ) {}
	
	  		var chunk = this.lastSearchedChunk;
	  		var searchForward = index > chunk.end;
	
	  		while ( true ) {
	  			if ( chunk.contains( index ) ) return this$1._splitChunk( chunk, index );
	
	  			chunk = searchForward ?
	  				this$1.byStart[ chunk.end ] :
	  				this$1.byEnd[ chunk.start ];
	  		}
	  	},
	
	  	_splitChunk: function _splitChunk ( chunk, index ) {
	  		if ( chunk.edited && chunk.content.length ) { // zero-length edited chunks are a special case (overlapping replacements)
	  			var loc = getLocator( this.original )( index );
	  			throw new Error( ("Cannot split a chunk that has already been edited (" + (loc.line) + ":" + (loc.column) + " – \"" + (chunk.original) + "\")") );
	  		}
	
	  		var newChunk = chunk.split( index );
	
	  		this.byEnd[ index ] = chunk;
	  		this.byStart[ index ] = newChunk;
	  		this.byEnd[ newChunk.end ] = newChunk;
	
	  		if ( chunk === this.lastChunk ) this.lastChunk = newChunk;
	
	  		this.lastSearchedChunk = chunk;
	  		if ( false ) {}
	  		return true;
	  	},
	
	  	toString: function toString () {
	  		var str = this.intro;
	
	  		var chunk = this.firstChunk;
	  		while ( chunk ) {
	  			str += chunk.toString();
	  			chunk = chunk.next;
	  		}
	
	  		return str + this.outro;
	  	},
	
	  	trimLines: function trimLines () {
	  		return this.trim('[\\r\\n]');
	  	},
	
	  	trim: function trim ( charType ) {
	  		return this.trimStart( charType ).trimEnd( charType );
	  	},
	
	  	trimEnd: function trimEnd ( charType ) {
	  		var this$1 = this;
	
	  		var rx = new RegExp( ( charType || '\\s' ) + '+$' );
	
	  		this.outro = this.outro.replace( rx, '' );
	  		if ( this.outro.length ) return this;
	
	  		var chunk = this.lastChunk;
	
	  		do {
	  			var end = chunk.end;
	  			var aborted = chunk.trimEnd( rx );
	
	  			// if chunk was trimmed, we have a new lastChunk
	  			if ( chunk.end !== end ) {
	  				this$1.lastChunk = chunk.next;
	
	  				this$1.byEnd[ chunk.end ] = chunk;
	  				this$1.byStart[ chunk.next.start ] = chunk.next;
	  			}
	
	  			if ( aborted ) return this$1;
	  			chunk = chunk.previous;
	  		} while ( chunk );
	
	  		return this;
	  	},
	
	  	trimStart: function trimStart ( charType ) {
	  		var this$1 = this;
	
	  		var rx = new RegExp( '^' + ( charType || '\\s' ) + '+' );
	
	  		this.intro = this.intro.replace( rx, '' );
	  		if ( this.intro.length ) return this;
	
	  		var chunk = this.firstChunk;
	
	  		do {
	  			var end = chunk.end;
	  			var aborted = chunk.trimStart( rx );
	
	  			if ( chunk.end !== end ) {
	  				// special case...
	  				if ( chunk === this$1.lastChunk ) this$1.lastChunk = chunk.next;
	
	  				this$1.byEnd[ chunk.end ] = chunk;
	  				this$1.byStart[ chunk.next.start ] = chunk.next;
	  			}
	
	  			if ( aborted ) return this$1;
	  			chunk = chunk.next;
	  		} while ( chunk );
	
	  		return this;
	  	}
	  };
	
	  var hasOwnProp = Object.prototype.hasOwnProperty;
	
	  function Bundle ( options ) {
	  	if ( options === void 0 ) options = {};
	
	  	this.intro = options.intro || '';
	  	this.separator = options.separator !== undefined ? options.separator : '\n';
	
	  	this.sources = [];
	
	  	this.uniqueSources = [];
	  	this.uniqueSourceIndexByFilename = {};
	  }
	
	  Bundle.prototype = {
	  	addSource: function addSource ( source ) {
	  		if ( source instanceof MagicString ) {
	  			return this.addSource({
	  				content: source,
	  				filename: source.filename,
	  				separator: this.separator
	  			});
	  		}
	
	  		if ( !isObject( source ) || !source.content ) {
	  			throw new Error( 'bundle.addSource() takes an object with a `content` property, which should be an instance of MagicString, and an optional `filename`' );
	  		}
	
	  		[ 'filename', 'indentExclusionRanges', 'separator' ].forEach( function ( option ) {
	  			if ( !hasOwnProp.call( source, option ) ) source[ option ] = source.content[ option ];
	  		});
	
	  		if ( source.separator === undefined ) { // TODO there's a bunch of this sort of thing, needs cleaning up
	  			source.separator = this.separator;
	  		}
	
	  		if ( source.filename ) {
	  			if ( !hasOwnProp.call( this.uniqueSourceIndexByFilename, source.filename ) ) {
	  				this.uniqueSourceIndexByFilename[ source.filename ] = this.uniqueSources.length;
	  				this.uniqueSources.push({ filename: source.filename, content: source.content.original });
	  			} else {
	  				var uniqueSource = this.uniqueSources[ this.uniqueSourceIndexByFilename[ source.filename ] ];
	  				if ( source.content.original !== uniqueSource.content ) {
	  					throw new Error( ("Illegal source: same filename (" + (source.filename) + "), different contents") );
	  				}
	  			}
	  		}
	
	  		this.sources.push( source );
	  		return this;
	  	},
	
	  	append: function append ( str, options ) {
	  		this.addSource({
	  			content: new MagicString( str ),
	  			separator: ( options && options.separator ) || ''
	  		});
	
	  		return this;
	  	},
	
	  	clone: function clone () {
	  		var bundle = new Bundle({
	  			intro: this.intro,
	  			separator: this.separator
	  		});
	
	  		this.sources.forEach( function ( source ) {
	  			bundle.addSource({
	  				filename: source.filename,
	  				content: source.content.clone(),
	  				separator: source.separator
	  			});
	  		});
	
	  		return bundle;
	  	},
	
	  	generateMap: function generateMap ( options ) {
	  		var this$1 = this;
	
	  		var offsets = {};
	
	  		var names = [];
	  		this.sources.forEach( function ( source ) {
	  			Object.keys( source.content.storedNames ).forEach( function ( name ) {
	  				if ( !~names.indexOf( name ) ) names.push( name );
	  			});
	  		});
	
	  		var encoded = (
	  			getSemis( this.intro ) +
	  			this.sources.map( function ( source, i ) {
	  				var prefix = ( i > 0 ) ? ( getSemis( source.separator ) || ',' ) : '';
	  				var mappings;
	
	  				// we don't bother encoding sources without a filename
	  				if ( !source.filename ) {
	  					mappings = getSemis( source.content.toString() );
	  				} else {
	  					var sourceIndex = this$1.uniqueSourceIndexByFilename[ source.filename ];
	  					mappings = source.content.getMappings( options.hires, sourceIndex, offsets, names );
	  				}
	
	  				return prefix + mappings;
	  			}).join( '' )
	  		);
	
	  		return new SourceMap({
	  			file: ( options.file ? options.file.split( /[\/\\]/ ).pop() : null ),
	  			sources: this.uniqueSources.map( function ( source ) {
	  				return options.file ? getRelativePath( options.file, source.filename ) : source.filename;
	  			}),
	  			sourcesContent: this.uniqueSources.map( function ( source ) {
	  				return options.includeContent ? source.content : null;
	  			}),
	  			names: names,
	  			mappings: encoded
	  		});
	  	},
	
	  	getIndentString: function getIndentString () {
	  		var indentStringCounts = {};
	
	  		this.sources.forEach( function ( source ) {
	  			var indentStr = source.content.indentStr;
	
	  			if ( indentStr === null ) return;
	
	  			if ( !indentStringCounts[ indentStr ] ) indentStringCounts[ indentStr ] = 0;
	  			indentStringCounts[ indentStr ] += 1;
	  		});
	
	  		return ( Object.keys( indentStringCounts ).sort( function ( a, b ) {
	  			return indentStringCounts[a] - indentStringCounts[b];
	  		})[0] ) || '\t';
	  	},
	
	  	indent: function indent ( indentStr ) {
	  		var this$1 = this;
	
	  		if ( !arguments.length ) {
	  			indentStr = this.getIndentString();
	  		}
	
	  		if ( indentStr === '' ) return this; // noop
	
	  		var trailingNewline = !this.intro || this.intro.slice( -1 ) === '\n';
	
	  		this.sources.forEach( function ( source, i ) {
	  			var separator = source.separator !== undefined ? source.separator : this$1.separator;
	  			var indentStart = trailingNewline || ( i > 0 && /\r?\n$/.test( separator ) );
	
	  			source.content.indent( indentStr, {
	  				exclude: source.indentExclusionRanges,
	  				indentStart: indentStart//: trailingNewline || /\r?\n$/.test( separator )  //true///\r?\n/.test( separator )
	  			});
	
	  			// TODO this is a very slow way to determine this
	  			trailingNewline = source.content.toString().slice( 0, -1 ) === '\n';
	  		});
	
	  		if ( this.intro ) {
	  			this.intro = indentStr + this.intro.replace( /^[^\n]/gm, function ( match, index ) {
	  				return index > 0 ? indentStr + match : match;
	  			});
	  		}
	
	  		return this;
	  	},
	
	  	prepend: function prepend ( str ) {
	  		this.intro = str + this.intro;
	  		return this;
	  	},
	
	  	toString: function toString () {
	  		var this$1 = this;
	
	  		var body = this.sources.map( function ( source, i ) {
	  			var separator = source.separator !== undefined ? source.separator : this$1.separator;
	  			var str = ( i > 0 ? separator : '' ) + source.content.toString();
	
	  			return str;
	  		}).join( '' );
	
	  		return this.intro + body;
	  	},
	
	  	trimLines: function trimLines () {
	  		return this.trim('[\\r\\n]');
	  	},
	
	  	trim: function trim ( charType ) {
	  		return this.trimStart( charType ).trimEnd( charType );
	  	},
	
	  	trimStart: function trimStart ( charType ) {
	  		var this$1 = this;
	
	  		var rx = new RegExp( '^' + ( charType || '\\s' ) + '+' );
	  		this.intro = this.intro.replace( rx, '' );
	
	  		if ( !this.intro ) {
	  			var source;
	  			var i = 0;
	
	  			do {
	  				source = this$1.sources[i];
	
	  				if ( !source ) {
	  					break;
	  				}
	
	  				source.content.trimStart( charType );
	  				i += 1;
	  			} while ( source.content.toString() === '' ); // TODO faster way to determine non-empty source?
	  		}
	
	  		return this;
	  	},
	
	  	trimEnd: function trimEnd ( charType ) {
	  		var this$1 = this;
	
	  		var rx = new RegExp( ( charType || '\\s' ) + '+$' );
	
	  		var source;
	  		var i = this.sources.length - 1;
	
	  		do {
	  			source = this$1.sources[i];
	
	  			if ( !source ) {
	  				this$1.intro = this$1.intro.replace( rx, '' );
	  				break;
	  			}
	
	  			source.content.trimEnd( charType );
	  			i -= 1;
	  		} while ( source.content.toString() === '' ); // TODO faster way to determine non-empty source?
	
	  		return this;
	  	}
	  };
	
	  function getSemis ( str ) {
	  	return new Array( str.split( '\n' ).length ).join( ';' );
	  }
	
	  MagicString.Bundle = Bundle;
	
	  var keys = {
	  	Program: [ 'body' ],
	  	Literal: []
	  };
	
	  // used for debugging, without the noise created by
	  // circular references
	  function toJSON ( node ) {
	  	var obj = {};
	
	  	Object.keys( node ).forEach( function ( key ) {
	  		if ( key === 'parent' || key === 'program' || key === 'keys' || key === '__wrapped' ) return;
	
	  		if ( Array.isArray( node[ key ] ) ) {
	  			obj[ key ] = node[ key ].map( toJSON );
	  		} else if ( node[ key ] && node[ key ].toJSON ) {
	  			obj[ key ] = node[ key ].toJSON();
	  		} else {
	  			obj[ key ] = node[ key ];
	  		}
	  	});
	
	  	return obj;
	  }
	
	  var Node = function Node ( raw, parent ) {
	  	raw.parent = parent;
	  	raw.program = parent.program || parent;
	  	raw.depth = parent.depth + 1;
	  	raw.keys = keys[ raw.type ];
	  	raw.indentation = undefined;
	
	  	for ( var i = 0, list = keys[ raw.type ]; i < list.length; i += 1 ) {
	  		var key = list[i];
	
	  			wrap( raw[ key ], raw );
	  	}
	
	  	raw.program.magicString.addSourcemapLocation( raw.start );
	  	raw.program.magicString.addSourcemapLocation( raw.end );
	  };
	
	  Node.prototype.ancestor = function ancestor ( level ) {
	  	var node = this;
	  	while ( level-- ) {
	  		node = node.parent;
	  		if ( !node ) return null;
	  	}
	
	  	return node;
	  };
	
	  Node.prototype.contains = function contains ( node ) {
	  		var this$1 = this;
	
	  	while ( node ) {
	  		if ( node === this$1 ) return true;
	  		node = node.parent;
	  	}
	
	  	return false;
	  };
	
	  Node.prototype.findLexicalBoundary = function findLexicalBoundary () {
	  	return this.parent.findLexicalBoundary();
	  };
	
	  Node.prototype.findNearest = function findNearest ( type ) {
	  	if ( typeof type === 'string' ) type = new RegExp( ("^" + type + "$") );
	  	if ( type.test( this.type ) ) return this;
	  	return this.parent.findNearest( type );
	  };
	
	  Node.prototype.unparenthesizedParent = function unparenthesizedParent () {
	  	var node = this.parent;
	  	while ( node && node.type === 'ParenthesizedExpression' ) {
	  		node = node.parent;
	  	}
	  	return node;
	  };
	
	  Node.prototype.unparenthesize = function unparenthesize () {
	  	var node = this;
	  	while ( node.type === 'ParenthesizedExpression' ) {
	  		node = node.expression;
	  	}
	  	return node;
	  };
	
	  Node.prototype.findScope = function findScope ( functionScope ) {
	  	return this.parent.findScope( functionScope );
	  };
	
	  Node.prototype.getIndentation = function getIndentation () {
	  	return this.parent.getIndentation();
	  };
	
	  Node.prototype.initialise = function initialise ( transforms ) {
	  	for ( var i = 0, list = this.keys; i < list.length; i += 1 ) {
	  		var key = list[i];
	
	  			var value = this[ key ];
	
	  		if ( Array.isArray( value ) ) {
	  			value.forEach( function ( node ) { return node && node.initialise( transforms ); } );
	  		} else if ( value && typeof value === 'object' ) {
	  			value.initialise( transforms );
	  		}
	  	}
	  };
	
	  Node.prototype.toJSON = function toJSON$1 () {
	  	return toJSON( this );
	  };
	
	  Node.prototype.toString = function toString () {
	  	return this.program.magicString.original.slice( this.start, this.end );
	  };
	
	  Node.prototype.transpile = function transpile ( code, transforms ) {
	  	for ( var i = 0, list = this.keys; i < list.length; i += 1 ) {
	  		var key = list[i];
	
	  			var value = this[ key ];
	
	  		if ( Array.isArray( value ) ) {
	  			value.forEach( function ( node ) { return node && node.transpile( code, transforms ); } );
	  		} else if ( value && typeof value === 'object' ) {
	  			value.transpile( code, transforms );
	  		}
	  	}
	  };
	
	  function isArguments ( node ) {
	  	return node.type === 'Identifier' && node.name === 'arguments';
	  }
	
	  function spread ( code, elements, start, argumentsArrayAlias, isNew ) {
	  	var i = elements.length;
	  	var firstSpreadIndex = -1;
	
	  	while ( i-- ) {
	  		var element$1 = elements[i];
	  		if ( element$1 && element$1.type === 'SpreadElement' ) {
	  			if ( isArguments( element$1.argument ) ) {
	  				code.overwrite( element$1.argument.start, element$1.argument.end, argumentsArrayAlias );
	  			}
	
	  			firstSpreadIndex = i;
	  		}
	  	}
	
	  	if ( firstSpreadIndex === -1 ) return false; // false indicates no spread elements
	
	  	if (isNew) {
	  		for ( i = 0; i < elements.length; i += 1 ) {
	  			var element$2 = elements[i];
	  			if ( element$2.type === 'SpreadElement' ) {
	  				code.remove( element$2.start, element$2.argument.start );
	  			} else {
	  				code.insertRight( element$2.start, '[' );
	  				code.insertRight( element$2.end, ']' );
	  			}
	  		}
	
	  		return true; // true indicates some spread elements
	  	}
	
	  	var element = elements[ firstSpreadIndex ];
	  	var previousElement = elements[ firstSpreadIndex - 1 ];
	
	  	if ( !previousElement ) {
	  		code.remove( start, element.start );
	  		code.overwrite( element.end, elements[1].start, '.concat( ' );
	  	} else {
	  		code.overwrite( previousElement.end, element.start, ' ].concat( ' );
	  	}
	
	  	for ( i = firstSpreadIndex; i < elements.length; i += 1 ) {
	  		element = elements[i];
	
	  		if ( element ) {
	  			if ( element.type === 'SpreadElement' ) {
	  				code.remove( element.start, element.argument.start );
	  			} else {
	  				code.insertLeft( element.start, '[' );
	  				code.insertLeft( element.end, ']' );
	  			}
	  		}
	  	}
	
	  	return true; // true indicates some spread elements
	  }
	
	  var ArrayExpression = (function (Node) {
	  	function ArrayExpression () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) ArrayExpression.__proto__ = Node;
	  	ArrayExpression.prototype = Object.create( Node && Node.prototype );
	  	ArrayExpression.prototype.constructor = ArrayExpression;
	
	  	ArrayExpression.prototype.initialise = function initialise ( transforms ) {
	  		var this$1 = this;
	
	  		if ( transforms.spreadRest && this.elements.length ) {
	  			var lexicalBoundary = this.findLexicalBoundary();
	
	  			var i = this.elements.length;
	  			while ( i-- ) {
	  				var element = this$1.elements[i];
	  				if ( element && element.type === 'SpreadElement' && isArguments( element.argument ) ) {
	  					this$1.argumentsArrayAlias = lexicalBoundary.getArgumentsArrayAlias();
	  				}
	  			}
	  		}
	
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	ArrayExpression.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( transforms.spreadRest ) {
	  			// erase trailing comma after last array element if not an array hole
	  			if ( this.elements.length ) {
	  				var lastElement = this.elements[ this.elements.length - 1 ];
	  				if ( lastElement && /\s*,/.test( code.original.slice( lastElement.end, this.end ) ) ) {
	  					code.overwrite( lastElement.end, this.end - 1, ' ' );
	  				}
	  			}
	
	  			if ( this.elements.length === 1 ) {
	  				var element = this.elements[0];
	
	  				if ( element && element.type === 'SpreadElement' ) {
	  					// special case – [ ...arguments ]
	  					if ( isArguments( element.argument ) ) {
	  						code.overwrite( this.start, this.end, ("[].concat( " + (this.argumentsArrayAlias) + " )") ); // TODO if this is the only use of argsArray, don't bother concating
	  					} else {
	  						code.overwrite( this.start, element.argument.start, '[].concat( ' );
	  						code.overwrite( element.end, this.end, ' )' );
	  					}
	  				}
	  			}
	  			else {
	  				var hasSpreadElements = spread( code, this.elements, this.start, this.argumentsArrayAlias );
	
	  				if ( hasSpreadElements ) {
	  					code.overwrite( this.end - 1, this.end, ')' );
	  				}
	  			}
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return ArrayExpression;
	  }(Node));
	
	  var ArrowFunctionExpression = (function (Node) {
	  	function ArrowFunctionExpression () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) ArrowFunctionExpression.__proto__ = Node;
	  	ArrowFunctionExpression.prototype = Object.create( Node && Node.prototype );
	  	ArrowFunctionExpression.prototype.constructor = ArrowFunctionExpression;
	
	  	ArrowFunctionExpression.prototype.initialise = function initialise ( transforms ) {
	  		this.body.createScope();
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	ArrowFunctionExpression.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( transforms.arrow ) {
	  			// remove arrow
	  			var charIndex = this.body.start;
	  			while ( code.original[ charIndex ] !== '=' ) {
	  				charIndex -= 1;
	  			}
	  			code.remove( charIndex, this.body.start );
	
	  			// wrap naked parameter
	  			if ( this.params.length === 1 && this.start === this.params[0].start ) {
	  				code.insertRight( this.params[0].start, '(' );
	  				code.insertLeft( this.params[0].end, ')' );
	  			}
	
	  			// add function
	  			if ( this.parent && this.parent.type === 'ExpressionStatement' ) {
	  				// standalone expression statement
	  				code.insertRight( this.start, '(function' );
	  				code.insertRight( this.end, ')' );
	  			} else {
	  				code.insertRight( this.start, 'function ' );
	  			}
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return ArrowFunctionExpression;
	  }(Node));
	
	  function locate ( source, index ) {
	  	var lines = source.split( '\n' );
	  	var len = lines.length;
	
	  	var lineStart = 0;
	  	var i;
	
	  	for ( i = 0; i < len; i += 1 ) {
	  		var line = lines[i];
	  		var lineEnd =  lineStart + line.length + 1; // +1 for newline
	
	  		if ( lineEnd > index ) {
	  			return { line: i + 1, column: index - lineStart, char: i };
	  		}
	
	  		lineStart = lineEnd;
	  	}
	
	  	throw new Error( 'Could not determine location of character' );
	  }
	
	  function pad ( num, len ) {
	  	var result = String( num );
	  	return result + repeat( ' ', len - result.length );
	  }
	
	  function repeat ( str, times ) {
	  	var result = '';
	  	while ( times-- ) result += str;
	  	return result;
	  }
	
	  function getSnippet ( source, loc, length ) {
	  	if ( length === void 0 ) length = 1;
	
	  	var first = Math.max( loc.line - 5, 0 );
	  	var last = loc.line;
	
	  	var numDigits = String( last ).length;
	
	  	var lines = source.split( '\n' ).slice( first, last );
	
	  	var lastLine = lines[ lines.length - 1 ];
	  	var offset = lastLine.slice( 0, loc.column ).replace( /\t/g, '  ' ).length;
	
	  	var snippet = lines
	  		.map( function ( line, i ) { return ((pad( i + first + 1, numDigits )) + " : " + (line.replace( /\t/g, '  '))); } )
	  		.join( '\n' );
	
	  	snippet += '\n' + repeat( ' ', numDigits + 3 + offset ) + repeat( '^', length );
	
	  	return snippet;
	  }
	
	  var CompileError = (function (Error) {
	  	function CompileError ( node, message ) {
	  		Error.call(this);
	
	  		var source = node.program.magicString.original;
	  		var loc = locate( source, node.start );
	
	  		this.name = 'CompileError';
	  		this.message = message + " (" + (loc.line) + ":" + (loc.column) + ")";
	
	  		this.stack = new Error().stack.replace( new RegExp( (".+new " + (this.name) + ".+\\n"), 'm' ), '' );
	
	  		this.loc = loc;
	  		this.snippet = getSnippet( source, loc, node.end - node.start );
	  	}
	
	  	if ( Error ) CompileError.__proto__ = Error;
	  	CompileError.prototype = Object.create( Error && Error.prototype );
	  	CompileError.prototype.constructor = CompileError;
	
	  	CompileError.prototype.toString = function toString () {
	  		return ((this.name) + ": " + (this.message) + "\n" + (this.snippet));
	  	};
	
	  	return CompileError;
	  }(Error));
	
	  var AssignmentExpression = (function (Node) {
	  	function AssignmentExpression () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) AssignmentExpression.__proto__ = Node;
	  	AssignmentExpression.prototype = Object.create( Node && Node.prototype );
	  	AssignmentExpression.prototype.constructor = AssignmentExpression;
	
	  	AssignmentExpression.prototype.initialise = function initialise ( transforms ) {
	  		if ( this.left.type === 'Identifier' ) {
	  			var declaration = this.findScope( false ).findDeclaration( this.left.name );
	  			if ( declaration && declaration.kind === 'const' ) {
	  				throw new CompileError( this.left, ((this.left.name) + " is read-only") );
	  			}
	
	  			// special case – https://gitlab.com/Rich-Harris/buble/issues/11
	  			var statement = declaration && declaration.node.ancestor( 3 );
	  			if ( statement && statement.type === 'ForStatement' && statement.body.contains( this ) ) {
	  				statement.reassigned[ this.left.name ] = true;
	  			}
	  		}
	
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	AssignmentExpression.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( this.operator === '**=' && transforms.exponentiation ) {
	  			this.transpileExponentiation( code, transforms );
	  		}
	
	  		else if ( /Pattern/.test( this.left.type ) && transforms.destructuring ) {
	  			this.transpileDestructuring( code, transforms );
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	AssignmentExpression.prototype.transpileDestructuring = function transpileDestructuring ( code ) {
	  		var scope = this.findScope( true );
	  		var assign = scope.createIdentifier( 'assign' );
	  		var temporaries = [ assign ];
	
	  		var start = this.start;
	
	  		// We need to pick out some elements from the original code,
	  		// interleaved with generated code. These helpers are used to
	  		// easily do that while keeping the order of the output
	  		// predictable.
	  		var text = '';
	  		function use ( node ) {
	  			code.insertRight( node.start, text );
	  			code.move( node.start, node.end, start );
	  			text = '';
	  		}
	  		function write ( string ) {
	  			text += string;
	  		}
	
	  		write( ("(" + assign + " = ") );
	  		use( this.right );
	
	  		// Walk `pattern`, generating code that assigns the value in
	  		// `ref` to it. When `mayDuplicate` is false, the function
	  		// must take care to only output `ref` once.
	  		function destructure ( pattern, ref, mayDuplicate ) {
	  			if ( pattern.type === 'Identifier' || pattern.type === 'MemberExpression' ) {
	  				write( ', ' );
	  				use( pattern );
	  				write( (" = " + ref) );
	  			}
	
	  			else if ( pattern.type === 'AssignmentPattern' ) {
	  				if ( pattern.left.type === 'Identifier' ) {
	  					var target = pattern.left.name;
	  					var source = ref;
	  					if ( !mayDuplicate ) {
	  						write( (", " + target + " = " + ref) );
	  						source = target;
	  					}
	  					write( (", " + target + " = " + source + " === void 0 ? ") );
	  					use( pattern.right );
	  					write( (" : " + source) );
	  				}
	  				else {
	  					var target$1 = scope.createIdentifier( 'temp' );
	  					var source$1 = ref;
	  					temporaries.push( target$1 );
	  					if ( !mayDuplicate ) {
	  						write( (", " + target$1 + " = " + ref) );
	  						source$1 = target$1;
	  					}
	  					write( (", " + target$1 + " = " + source$1 + " === void 0 ? ") );
	  					use( pattern.right );
	  					write( (" : " + source$1) );
	  					destructure( pattern.left, target$1, true );
	  				}
	  			}
	
	  			else if ( pattern.type === 'ArrayPattern' ) {
	  				var elements = pattern.elements;
	  				if ( elements.length === 1 ) {
	  					destructure( elements[0], (ref + "[0]"), false );
	  				}
	  				else {
	  					if ( !mayDuplicate ) {
	  						var temp = scope.createIdentifier( 'array' );
	  						temporaries.push( temp );
	  						write( (", " + temp + " = " + ref) );
	  						ref = temp;
	  					}
	  					elements.forEach( function ( element, i ) {
	  						if ( element ) {
	  							if ( element.type === 'RestElement' ) {
	  								destructure( element.argument, (ref + ".slice(" + i + ")"), false );
	  							} else {
	  								destructure( element, (ref + "[" + i + "]"), false );
	  							}
	  						}
	  					} );
	  				}
	  			}
	
	  			else if ( pattern.type === 'ObjectPattern' ) {
	  				var props = pattern.properties;
	  				if ( props.length == 1 ) {
	  					var prop = props[0];
	  					var value = prop.computed || prop.key.type !== 'Identifier' ? (ref + "[" + (code.slice(prop.key.start, prop.key.end)) + "]") : (ref + "." + (prop.key.name));
	  					destructure( prop.value, value, false );
	  				}
	  				else {
	  					if ( !mayDuplicate ) {
	  						var temp$1 = scope.createIdentifier( 'obj' );
	  						temporaries.push( temp$1 );
	  						write( (", " + temp$1 + " = " + ref) );
	  						ref = temp$1;
	  					}
	  					props.forEach( function ( prop ) {
	  						var value = prop.computed || prop.key.type !== 'Identifier' ? (ref + "[" + (code.slice(prop.key.start, prop.key.end)) + "]") : (ref + "." + (prop.key.name));
	  						destructure( prop.value, value, false );
	  					} );
	  				}
	  			}
	
	  			else {
	  				throw new Error( ("Unexpected node type in destructuring assignment (" + (pattern.type) + ")") );
	  			}
	  		}
	  		destructure( this.left, assign, true );
	
	  		if ( this.unparenthesizedParent().type === 'ExpressionStatement' ) {
	  			// no rvalue needed for expression statement
	  			code.insertRight( start, (text + ")") );
	  		} else {
	  			// destructuring is part of an expression - need an rvalue
	  			code.insertRight( start, (text + ", " + assign + ")") );
	  		}
	
	  		code.remove( start, this.right.start );
	
	  		var statement = this.findNearest( /(?:Statement|Declaration)$/ );
	  		code.insertLeft( statement.start, ("var " + (temporaries.join( ', ' )) + ";\n" + (statement.getIndentation())) );
	  	};
	
	  	AssignmentExpression.prototype.transpileExponentiation = function transpileExponentiation ( code ) {
	  		var scope = this.findScope( false );
	  		var getAlias = function ( name ) {
	  			var declaration = scope.findDeclaration( name );
	  			return declaration ? declaration.name : name;
	  		};
	
	  		// first, the easy part – `**=` -> `=`
	  		var charIndex = this.left.end;
	  		while ( code.original[ charIndex ] !== '*' ) charIndex += 1;
	  		code.remove( charIndex, charIndex + 2 );
	
	  		// how we do the next part depends on a number of factors – whether
	  		// this is a top-level statement, and whether we're updating a
	  		// simple or complex reference
	  		var base;
	
	  		var left = this.left.unparenthesize();
	
	  		if ( left.type === 'Identifier' ) {
	  			base = getAlias( left.name );
	  		} else if ( left.type === 'MemberExpression' ) {
	  			var object;
	  			var needsObjectVar = false;
	  			var property;
	  			var needsPropertyVar = false;
	
	  			var statement = this.findNearest( /(?:Statement|Declaration)$/ );
	  			var i0 = statement.getIndentation();
	
	  			if ( left.property.type === 'Identifier' ) {
	  				property = left.computed ? getAlias( left.property.name ) : left.property.name;
	  			} else {
	  				property = scope.createIdentifier( 'property' );
	  				needsPropertyVar = true;
	  			}
	
	  			if ( left.object.type === 'Identifier' ) {
	  				object = getAlias( left.object.name );
	  			} else {
	  				object = scope.createIdentifier( 'object' );
	  				needsObjectVar = true;
	  			}
	
	  			if ( left.start === statement.start ) {
	  				if ( needsObjectVar && needsPropertyVar ) {
	  					code.insertRight( statement.start, ("var " + object + " = ") );
	  					code.overwrite( left.object.end, left.property.start, (";\n" + i0 + "var " + property + " = ") );
	  					code.overwrite( left.property.end, left.end, (";\n" + i0 + object + "[" + property + "]") );
	  				}
	
	  				else if ( needsObjectVar ) {
	  					code.insertRight( statement.start, ("var " + object + " = ") );
	  					code.insertLeft( left.object.end, (";\n" + i0) );
	  					code.insertLeft( left.object.end, object );
	  				}
	
	  				else if ( needsPropertyVar ) {
	  					code.insertRight( left.property.start, ("var " + property + " = ") );
	  					code.insertLeft( left.property.end, (";\n" + i0) );
	  					code.move( left.property.start, left.property.end, this.start );
	
	  					code.insertLeft( left.object.end, ("[" + property + "]") );
	  					code.remove( left.object.end, left.property.start );
	  					code.remove( left.property.end, left.end );
	  				}
	  			}
	
	  			else {
	  				var declarators = [];
	  				if ( needsObjectVar ) declarators.push( object );
	  				if ( needsPropertyVar ) declarators.push( property );
	
	  				if ( declarators.length ) {
	  					code.insertRight( statement.start, ("var " + (declarators.join( ', ' )) + ";\n" + i0) );
	  				}
	
	  				if ( needsObjectVar && needsPropertyVar ) {
	  					code.insertRight( left.start, ("( " + object + " = ") );
	  					code.overwrite( left.object.end, left.property.start, (", " + property + " = ") );
	  					code.overwrite( left.property.end, left.end, (", " + object + "[" + property + "]") );
	  				}
	
	  				else if ( needsObjectVar ) {
	  					code.insertRight( left.start, ("( " + object + " = ") );
	  					code.insertLeft( left.object.end, (", " + object) );
	  				}
	
	  				else if ( needsPropertyVar ) {
	  					code.insertRight( left.property.start, ("( " + property + " = ") );
	  					code.insertLeft( left.property.end, ", " );
	  					code.move( left.property.start, left.property.end, left.start );
	
	  					code.overwrite( left.object.end, left.property.start, ("[" + property + "]") );
	  					code.remove( left.property.end, left.end );
	  				}
	
	  				if ( needsPropertyVar ) {
	  					code.insertLeft( this.end, " )" );
	  				}
	  			}
	
	  			base = object + ( left.computed || needsPropertyVar ? ("[" + property + "]") : ("." + property) );
	  		}
	
	  		code.insertRight( this.right.start, ("Math.pow( " + base + ", ") );
	  		code.insertLeft( this.right.end, " )" );
	  	};
	
	  	return AssignmentExpression;
	  }(Node));
	
	  var BinaryExpression = (function (Node) {
	  	function BinaryExpression () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) BinaryExpression.__proto__ = Node;
	  	BinaryExpression.prototype = Object.create( Node && Node.prototype );
	  	BinaryExpression.prototype.constructor = BinaryExpression;
	
	  	BinaryExpression.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( this.operator === '**' && transforms.exponentiation ) {
	  			code.insertRight( this.start, "Math.pow( " );
	  			code.overwrite( this.left.end, this.right.start, ", " );
	  			code.insertLeft( this.end, " )" );
	  		}
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return BinaryExpression;
	  }(Node));
	
	  var loopStatement = /(?:For(?:In|Of)?|While)Statement/;
	
	  var BreakStatement = (function (Node) {
	  	function BreakStatement () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) BreakStatement.__proto__ = Node;
	  	BreakStatement.prototype = Object.create( Node && Node.prototype );
	  	BreakStatement.prototype.constructor = BreakStatement;
	
	  	BreakStatement.prototype.initialise = function initialise () {
	  		var loop = this.findNearest( loopStatement );
	  		var switchCase = this.findNearest( 'SwitchCase' );
	
	  		if ( loop && ( !switchCase || loop.depth > switchCase.depth ) ) {
	  			loop.canBreak = true;
	  			this.loop = loop;
	  		}
	  	};
	
	  	BreakStatement.prototype.transpile = function transpile ( code ) {
	  		if ( this.loop && this.loop.shouldRewriteAsFunction ) {
	  			if ( this.label ) throw new CompileError( this, 'Labels are not currently supported in a loop with locally-scoped variables' );
	  			code.overwrite( this.start, this.start + 5, "return 'break'" );
	  		}
	  	};
	
	  	return BreakStatement;
	  }(Node));
	
	  var CallExpression = (function (Node) {
	  	function CallExpression () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) CallExpression.__proto__ = Node;
	  	CallExpression.prototype = Object.create( Node && Node.prototype );
	  	CallExpression.prototype.constructor = CallExpression;
	
	  	CallExpression.prototype.initialise = function initialise ( transforms ) {
	  		var this$1 = this;
	
	  		if ( transforms.spreadRest && this.arguments.length > 1 ) {
	  			var lexicalBoundary = this.findLexicalBoundary();
	
	  			var i = this.arguments.length;
	  			while ( i-- ) {
	  				var arg = this$1.arguments[i];
	  				if ( arg.type === 'SpreadElement' && isArguments( arg.argument ) ) {
	  					this$1.argumentsArrayAlias = lexicalBoundary.getArgumentsArrayAlias();
	  				}
	  			}
	  		}
	
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	CallExpression.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( transforms.spreadRest && this.arguments.length ) {
	  			var hasSpreadElements = false;
	  			var context;
	
	  			var firstArgument = this.arguments[0];
	
	  			if ( this.arguments.length === 1 ) {
	  				if ( firstArgument.type === 'SpreadElement' ) {
	  					code.remove( firstArgument.start, firstArgument.argument.start );
	  					hasSpreadElements = true;
	  				}
	  			} else {
	  				hasSpreadElements = spread( code, this.arguments, firstArgument.start, this.argumentsArrayAlias );
	  			}
	
	  			if ( hasSpreadElements ) {
	
	  				// we need to handle super() and super.method() differently
	  				// due to its instance
	  				var _super = null;
	  				if ( this.callee.type === 'Super' ) {
	  					_super = this.callee;
	  				}
	  				else if ( this.callee.type === 'MemberExpression' && this.callee.object.type === 'Super' ) {
	  					_super = this.callee.object;
	  				}
	
	  				if ( !_super && this.callee.type === 'MemberExpression' ) {
	  					if ( this.callee.object.type === 'Identifier' ) {
	  						context = this.callee.object.name;
	  					} else {
	  						context = this.findScope( true ).createIdentifier( 'ref' );
	  						var callExpression = this.callee.object;
	  						var enclosure = callExpression.findNearest( /Function/ );
	  						var block = enclosure ? enclosure.body.body
	  							: callExpression.findNearest( /^Program$/ ).body;
	  						var lastStatementInBlock = block[ block.length - 1 ];
	  						var i0 = lastStatementInBlock.getIndentation();
	  						code.insertRight( callExpression.start, ("(" + context + " = ") );
	  						code.insertLeft( callExpression.end, ")" );
	  						code.insertLeft( lastStatementInBlock.end, ("\n" + i0 + "var " + context + ";") );
	  					}
	  				} else {
	  					context = 'void 0';
	  				}
	
	  				code.insertLeft( this.callee.end, '.apply' );
	
	  				if ( _super ) {
	  					_super.noCall = true; // bit hacky...
	
	  					if ( this.arguments.length > 1 ) {
	  						if ( firstArgument.type !== 'SpreadElement' ) {
	  							code.insertRight( firstArgument.start, "[ " );
	  						}
	
	  						code.insertLeft( this.arguments[ this.arguments.length - 1 ].end, ' )' );
	  					}
	  				}
	
	  				else if ( this.arguments.length === 1 ) {
	  					code.insertRight( firstArgument.start, (context + ", ") );
	  				} else {
	  					if ( firstArgument.type === 'SpreadElement' ) {
	  						code.insertLeft( firstArgument.start, (context + ", ") );
	  					} else {
	  						code.insertLeft( firstArgument.start, (context + ", [ ") );
	  					}
	
	  					code.insertLeft( this.arguments[ this.arguments.length - 1 ].end, ' )' );
	  				}
	  			}
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return CallExpression;
	  }(Node));
	
	  function findIndex ( array, fn ) {
	  	for ( var i = 0; i < array.length; i += 1 ) {
	  		if ( fn( array[i], i ) ) return i;
	  	}
	
	  	return -1;
	  }
	
	  var reserved = Object.create( null );
	  'do if in for let new try var case else enum eval null this true void with await break catch class const false super throw while yield delete export import public return static switch typeof default extends finally package private continue debugger function arguments interface protected implements instanceof'.split( ' ' )
	  	.forEach( function ( word ) { return reserved[ word ] = true; } );
	
	  // TODO this code is pretty wild, tidy it up
	  var ClassBody = (function (Node) {
	  	function ClassBody () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) ClassBody.__proto__ = Node;
	  	ClassBody.prototype = Object.create( Node && Node.prototype );
	  	ClassBody.prototype.constructor = ClassBody;
	
	  	ClassBody.prototype.transpile = function transpile ( code, transforms, inFunctionExpression, superName ) {
	  		var this$1 = this;
	
	  		if ( transforms.classes ) {
	  			var name = this.parent.name;
	
	  			var indentStr = code.getIndentString();
	  			var i0 = this.getIndentation() + ( inFunctionExpression ? indentStr : '' );
	  			var i1 = i0 + indentStr;
	
	  			var constructorIndex = findIndex( this.body, function ( node ) { return node.kind === 'constructor'; } );
	  			var constructor = this.body[ constructorIndex ];
	
	  			var introBlock = '';
	  			var outroBlock = '';
	
	  			if ( this.body.length ) {
	  				code.remove( this.start, this.body[0].start );
	  				code.remove( this.body[ this.body.length - 1 ].end, this.end );
	  			} else {
	  				code.remove( this.start, this.end );
	  			}
	
	  			if ( constructor ) {
	  				constructor.value.body.isConstructorBody = true;
	
	  				var previousMethod = this.body[ constructorIndex - 1 ];
	  				var nextMethod = this.body[ constructorIndex + 1 ];
	
	  				// ensure constructor is first
	  				if ( constructorIndex > 0 ) {
	  					code.remove( previousMethod.end, constructor.start );
	  					code.move( constructor.start, nextMethod ? nextMethod.start : this.end - 1, this.body[0].start );
	  				}
	
	  				if ( !inFunctionExpression ) code.insertLeft( constructor.end, ';' );
	  			}
	
	  			var namedFunctions = this.program.options.namedFunctionExpressions !== false;
	  			var namedConstructor = namedFunctions || this.parent.superClass || this.parent.type !== 'ClassDeclaration';
	  			if ( this.parent.superClass ) {
	  				var inheritanceBlock = "if ( " + superName + " ) " + name + ".__proto__ = " + superName + ";\n" + i0 + name + ".prototype = Object.create( " + superName + " && " + superName + ".prototype );\n" + i0 + name + ".prototype.constructor = " + name + ";";
	
	  				if ( constructor ) {
	  					introBlock += "\n\n" + i0 + inheritanceBlock;
	  				} else {
	  					var fn = "function " + name + " () {" + ( superName ?
	  						("\n" + i1 + superName + ".apply(this, arguments);\n" + i0 + "}") :
	  						"}" ) + ( inFunctionExpression ? '' : ';' ) + ( this.body.length ? ("\n\n" + i0) : '' );
	
	  					inheritanceBlock = fn + inheritanceBlock;
	  					introBlock += inheritanceBlock + "\n\n" + i0;
	  				}
	  			} else if ( !constructor ) {
	  				var fn$1 = 'function ' + (namedConstructor ? name + ' ' : '') + '() {}';
	  				if ( this.parent.type === 'ClassDeclaration' ) fn$1 += ';';
	  				if ( this.body.length ) fn$1 += "\n\n" + i0;
	
	  				introBlock += fn$1;
	  			}
	
	  			var scope = this.findScope( false );
	
	  			var prototypeGettersAndSetters = [];
	  			var staticGettersAndSetters = [];
	  			var prototypeAccessors;
	  			var staticAccessors;
	
	  			this.body.forEach( function ( method, i ) {
	  				if ( method.kind === 'constructor' ) {
	  					var constructorName = namedConstructor ? ' ' + name : '';
	  					code.overwrite( method.key.start, method.key.end, ("function" + constructorName) );
	  					return;
	  				}
	
	  				if ( method.static ) {
	  					var len = code.original[ method.start + 6 ] == ' ' ? 7 : 6;
	  					code.remove( method.start, method.start + len );
	  				}
	
	  				var isAccessor = method.kind !== 'method';
	  				var lhs;
	
	  				var methodName = method.key.name;
	  				if ( reserved[ methodName ] || method.value.body.scope.references[methodName] ) {
	  					methodName = scope.createIdentifier( methodName );
	  				}
	
	  				// when method name is a string or a number let's pretend it's a computed method
	
	  				var fake_computed = false;
	  				if ( ! method.computed && method.key.type === 'Literal' ) {
	  					fake_computed = true;
	  					method.computed = true;
	  				}
	
	  				if ( isAccessor ) {
	  					if ( method.computed ) {
	  						throw new Error( 'Computed accessor properties are not currently supported' );
	  					}
	
	  					code.remove( method.start, method.key.start );
	
	  					if ( method.static ) {
	  						if ( !~staticGettersAndSetters.indexOf( method.key.name ) ) staticGettersAndSetters.push( method.key.name );
	  						if ( !staticAccessors ) staticAccessors = scope.createIdentifier( 'staticAccessors' );
	
	  						lhs = "" + staticAccessors;
	  					} else {
	  						if ( !~prototypeGettersAndSetters.indexOf( method.key.name ) ) prototypeGettersAndSetters.push( method.key.name );
	  						if ( !prototypeAccessors ) prototypeAccessors = scope.createIdentifier( 'prototypeAccessors' );
	
	  						lhs = "" + prototypeAccessors;
	  					}
	  				} else {
	  					lhs = method.static ?
	  						("" + name) :
	  						(name + ".prototype");
	  				}
	
	  				if ( !method.computed ) lhs += '.';
	
	  				var insertNewlines = ( constructorIndex > 0 && i === constructorIndex + 1 ) ||
	  				                       ( i === 0 && constructorIndex === this$1.body.length - 1 );
	
	  				if ( insertNewlines ) lhs = "\n\n" + i0 + lhs;
	
	  				var c = method.key.end;
	  				if ( method.computed ) {
	  					if ( fake_computed ) {
	  						code.insertRight( method.key.start, '[' );
	  						code.insertLeft( method.key.end, ']' );
	  					} else {
	  						while ( code.original[c] !== ']' ) c += 1;
	  						c += 1;
	  					}
	  				}
	
	  				code.insertRight( method.start, lhs );
	
	  				var funcName = method.computed || isAccessor || !namedFunctions ? '' : (methodName + " ");
	  				var rhs = ( isAccessor ? ("." + (method.kind)) : '' ) + " = function" + ( method.value.generator ? '* ' : ' ' ) + funcName;
	  				code.remove( c, method.value.start );
	  				code.insertRight( method.value.start, rhs );
	  				code.insertLeft( method.end, ';' );
	
	  				if ( method.value.generator ) code.remove( method.start, method.key.start );
	  			});
	
	  			if ( prototypeGettersAndSetters.length || staticGettersAndSetters.length ) {
	  				var intro = [];
	  				var outro = [];
	
	  				if ( prototypeGettersAndSetters.length ) {
	  					intro.push( ("var " + prototypeAccessors + " = { " + (prototypeGettersAndSetters.map( function ( name ) { return (name + ": {}"); } ).join( ',' )) + " };") );
	  					outro.push( ("Object.defineProperties( " + name + ".prototype, " + prototypeAccessors + " );") );
	  				}
	
	  				if ( staticGettersAndSetters.length ) {
	  					intro.push( ("var " + staticAccessors + " = { " + (staticGettersAndSetters.map( function ( name ) { return (name + ": {}"); } ).join( ',' )) + " };") );
	  					outro.push( ("Object.defineProperties( " + name + ", " + staticAccessors + " );") );
	  				}
	
	  				if ( constructor ) introBlock += "\n\n" + i0;
	  				introBlock += intro.join( ("\n" + i0) );
	  				if ( !constructor ) introBlock += "\n\n" + i0;
	
	  				outroBlock += "\n\n" + i0 + outro.join( ("\n" + i0) );
	  			}
	
	  			if ( constructor ) {
	  				code.insertLeft( constructor.end, introBlock );
	  			} else {
	  				code.insertRight( this.start, introBlock );
	  			}
	
	  			code.insertLeft( this.end, outroBlock );
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return ClassBody;
	  }(Node));
	
	  // TODO this function is slightly flawed – it works on the original string,
	  // not its current edited state.
	  // That's not a problem for the way that it's currently used, but it could
	  // be in future...
	  function deindent ( node, code ) {
	  	var start = node.start;
	  	var end = node.end;
	
	  	var indentStr = code.getIndentString();
	  	var indentStrLen = indentStr.length;
	  	var indentStart = start - indentStrLen;
	
	  	if ( !node.program.indentExclusions[ indentStart ]
	  	&& code.original.slice( indentStart, start ) === indentStr ) {
	  		code.remove( indentStart, start );
	  	}
	
	  	var pattern = new RegExp( indentStr + '\\S', 'g' );
	  	var slice = code.original.slice( start, end );
	  	var match;
	
	  	while ( match = pattern.exec( slice ) ) {
	  		var removeStart = start + match.index;
	  		if ( !node.program.indentExclusions[ removeStart ] ) {
	  			code.remove( removeStart, removeStart + indentStrLen );
	  		}
	  	}
	  }
	
	  var ClassDeclaration = (function (Node) {
	  	function ClassDeclaration () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) ClassDeclaration.__proto__ = Node;
	  	ClassDeclaration.prototype = Object.create( Node && Node.prototype );
	  	ClassDeclaration.prototype.constructor = ClassDeclaration;
	
	  	ClassDeclaration.prototype.initialise = function initialise ( transforms ) {
	  		this.name = this.id.name;
	  		this.findScope( true ).addDeclaration( this.id, 'class' );
	
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	ClassDeclaration.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( transforms.classes ) {
	  			if ( !this.superClass ) deindent( this.body, code );
	
	  			var superName = this.superClass && ( this.superClass.name || 'superclass' );
	
	  			var i0 = this.getIndentation();
	  			var i1 = i0 + code.getIndentString();
	
	  			// if this is an export default statement, we have to move the export to
	  			// after the declaration, because `export default var Foo = ...` is illegal
	  			var syntheticDefaultExport = this.parent.type === 'ExportDefaultDeclaration' ?
	  				("\n\n" + i0 + "export default " + (this.id.name) + ";") :
	  				'';
	
	  			if ( syntheticDefaultExport ) code.remove( this.parent.start, this.start );
	
	  			code.overwrite( this.start, this.id.start, 'var ' );
	
	  			if ( this.superClass ) {
	  				if ( this.superClass.end === this.body.start ) {
	  					code.remove( this.id.end, this.superClass.start );
	  					code.insertLeft( this.id.end, (" = (function (" + superName + ") {\n" + i1) );
	  				} else {
	  					code.overwrite( this.id.end, this.superClass.start, ' = ' );
	  					code.overwrite( this.superClass.end, this.body.start, ("(function (" + superName + ") {\n" + i1) );
	  				}
	  			} else {
	  				if ( this.id.end === this.body.start ) {
	  					code.insertLeft( this.id.end, ' = ' );
	  				} else {
	  					code.overwrite( this.id.end, this.body.start, ' = ' );
	  				}
	  			}
	
	  			this.body.transpile( code, transforms, !!this.superClass, superName );
	
	  			if ( this.superClass ) {
	  				code.insertLeft( this.end, ("\n\n" + i1 + "return " + (this.name) + ";\n" + i0 + "}(") );
	  				code.move( this.superClass.start, this.superClass.end, this.end );
	  				code.insertRight( this.end, ("));" + syntheticDefaultExport) );
	  			} else if ( syntheticDefaultExport ) {
	  				code.insertRight( this.end, syntheticDefaultExport );
	  			}
	  		}
	
	  		else {
	  			this.body.transpile( code, transforms, false, null );
	  		}
	  	};
	
	  	return ClassDeclaration;
	  }(Node));
	
	  var ClassExpression = (function (Node) {
	  	function ClassExpression () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) ClassExpression.__proto__ = Node;
	  	ClassExpression.prototype = Object.create( Node && Node.prototype );
	  	ClassExpression.prototype.constructor = ClassExpression;
	
	  	ClassExpression.prototype.initialise = function initialise ( transforms ) {
	  		this.name = this.id ? this.id.name :
	  		            this.parent.type === 'VariableDeclarator' ? this.parent.id.name :
	  		            this.parent.type === 'AssignmentExpression' ? this.parent.left.name :
	  		            this.findScope( true ).createIdentifier( 'anonymous' );
	
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	ClassExpression.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( transforms.classes ) {
	  			var superName = this.superClass && ( this.superClass.name || 'superclass' );
	
	  			var i0 = this.getIndentation();
	  			var i1 = i0 + code.getIndentString();
	
	  			if ( this.superClass ) {
	  				code.remove( this.start, this.superClass.start );
	  				code.remove( this.superClass.end, this.body.start );
	  				code.insertLeft( this.start, ("(function (" + superName + ") {\n" + i1) );
	  			} else {
	  				code.overwrite( this.start, this.body.start, ("(function () {\n" + i1) );
	  			}
	
	  			this.body.transpile( code, transforms, true, superName );
	
	  			var outro = "\n\n" + i1 + "return " + (this.name) + ";\n" + i0 + "}(";
	
	  			if ( this.superClass ) {
	  				code.insertLeft( this.end, outro );
	  				code.move( this.superClass.start, this.superClass.end, this.end );
	  				code.insertRight( this.end, '))' );
	  			} else {
	  				code.insertLeft( this.end, ("\n\n" + i1 + "return " + (this.name) + ";\n" + i0 + "}())") );
	  			}
	  		}
	
	  		else {
	  			this.body.transpile( code, transforms, false );
	  		}
	  	};
	
	  	return ClassExpression;
	  }(Node));
	
	  var ContinueStatement = (function (Node) {
	  	function ContinueStatement () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) ContinueStatement.__proto__ = Node;
	  	ContinueStatement.prototype = Object.create( Node && Node.prototype );
	  	ContinueStatement.prototype.constructor = ContinueStatement;
	
	  	ContinueStatement.prototype.transpile = function transpile ( code ) {
	  		var loop = this.findNearest( loopStatement );
	  		if ( loop.shouldRewriteAsFunction ) {
	  			if ( this.label ) throw new CompileError( this, 'Labels are not currently supported in a loop with locally-scoped variables' );
	  			code.overwrite( this.start, this.start + 8, 'return' );
	  		}
	  	};
	
	  	return ContinueStatement;
	  }(Node));
	
	  var ExportDefaultDeclaration = (function (Node) {
	  	function ExportDefaultDeclaration () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) ExportDefaultDeclaration.__proto__ = Node;
	  	ExportDefaultDeclaration.prototype = Object.create( Node && Node.prototype );
	  	ExportDefaultDeclaration.prototype.constructor = ExportDefaultDeclaration;
	
	  	ExportDefaultDeclaration.prototype.initialise = function initialise ( transforms ) {
	  		if ( transforms.moduleExport ) throw new CompileError( this, 'export is not supported' );
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	return ExportDefaultDeclaration;
	  }(Node));
	
	  var ExportNamedDeclaration = (function (Node) {
	  	function ExportNamedDeclaration () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) ExportNamedDeclaration.__proto__ = Node;
	  	ExportNamedDeclaration.prototype = Object.create( Node && Node.prototype );
	  	ExportNamedDeclaration.prototype.constructor = ExportNamedDeclaration;
	
	  	ExportNamedDeclaration.prototype.initialise = function initialise ( transforms ) {
	  		if ( transforms.moduleExport ) throw new CompileError( this, 'export is not supported' );
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	return ExportNamedDeclaration;
	  }(Node));
	
	  var LoopStatement = (function (Node) {
	  	function LoopStatement () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) LoopStatement.__proto__ = Node;
	  	LoopStatement.prototype = Object.create( Node && Node.prototype );
	  	LoopStatement.prototype.constructor = LoopStatement;
	
	  	LoopStatement.prototype.findScope = function findScope ( functionScope ) {
	  		return functionScope || !this.createdScope ? this.parent.findScope( functionScope ) : this.body.scope;
	  	};
	
	  	LoopStatement.prototype.initialise = function initialise ( transforms ) {
	  		var this$1 = this;
	
	  		this.body.createScope();
	  		this.createdScope = true;
	
	  		// this is populated as and when reassignments occur
	  		this.reassigned = Object.create( null );
	  		this.aliases = Object.create( null );
	
	  		Node.prototype.initialise.call( this, transforms );
	
	  		if ( transforms.letConst ) {
	  			// see if any block-scoped declarations are referenced
	  			// inside function expressions
	  			var names = Object.keys( this.body.scope.declarations );
	
	  			var i = names.length;
	  			while ( i-- ) {
	  				var name = names[i];
	  				var declaration = this$1.body.scope.declarations[ name ];
	
	  				var j = declaration.instances.length;
	  				while ( j-- ) {
	  					var instance = declaration.instances[j];
	  					var nearestFunctionExpression = instance.findNearest( /Function/ );
	
	  					if ( nearestFunctionExpression && nearestFunctionExpression.depth > this$1.depth ) {
	  						this$1.shouldRewriteAsFunction = true;
	  						break;
	  					}
	  				}
	
	  				if ( this$1.shouldRewriteAsFunction ) break;
	  			}
	  		}
	  	};
	
	  	LoopStatement.prototype.transpile = function transpile ( code, transforms ) {
	  		var needsBlock = this.type != 'ForOfStatement' && (
	  			this.body.type !== 'BlockStatement'
	  			|| this.body.type === 'BlockStatement' && this.body.synthetic );
	
	  		if ( this.shouldRewriteAsFunction ) {
	  			var i0 = this.getIndentation();
	  			var i1 = i0 + code.getIndentString();
	
	  			var argString = this.args ? (" " + (this.args.join( ', ' )) + " ") : '';
	  			var paramString = this.params ? (" " + (this.params.join( ', ' )) + " ") : '';
	
	  			var functionScope = this.findScope( true );
	  			var loop = functionScope.createIdentifier( 'loop' );
	
	  			var before = "var " + loop + " = function (" + paramString + ") " + ( this.body.synthetic ? ("{\n" + i0 + (code.getIndentString())) : '' );
	  			var after = ( this.body.synthetic ? ("\n" + i0 + "}") : '' ) + ";\n\n" + i0;
	
	  			code.insertRight( this.body.start, before );
	  			code.insertLeft( this.body.end, after );
	  			code.move( this.start, this.body.start, this.body.end );
	
	  			if ( this.canBreak || this.canReturn ) {
	  				var returned = functionScope.createIdentifier( 'returned' );
	
	  				var insert = "{\n" + i1 + "var " + returned + " = " + loop + "(" + argString + ");\n";
	  				if ( this.canBreak ) insert += "\n" + i1 + "if ( " + returned + " === 'break' ) break;";
	  				if ( this.canReturn ) insert += "\n" + i1 + "if ( " + returned + " ) return " + returned + ".v;";
	  				insert += "\n" + i0 + "}";
	
	  				code.insertRight( this.body.end, insert );
	  			} else {
	  				var callExpression = loop + "(" + argString + ");";
	
	  				if ( this.type === 'DoWhileStatement' ) {
	  					code.overwrite( this.start, this.body.start, ("do {\n" + i1 + callExpression + "\n" + i0 + "}") );
	  				} else {
	  					code.insertRight( this.body.end, callExpression );
	  				}
	  			}
	  		} else if ( needsBlock ) {
	  			code.insertLeft( this.body.start, '{ ' );
	  			code.insertRight( this.body.end, ' }' );
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return LoopStatement;
	  }(Node));
	
	  function extractNames ( node ) {
	  	var names = [];
	  	extractors[ node.type ]( names, node );
	  	return names;
	  }
	
	  var extractors = {
	  	Identifier: function Identifier ( names, node ) {
	  		names.push( node );
	  	},
	
	  	ObjectPattern: function ObjectPattern ( names, node ) {
	  		for ( var i = 0, list = node.properties; i < list.length; i += 1 ) {
	  			var prop = list[i];
	
	  			extractors[ prop.value.type ]( names, prop.value );
	  		}
	  	},
	
	  	ArrayPattern: function ArrayPattern ( names, node ) {
	  		for ( var i = 0, list = node.elements; i < list.length; i += 1 )  {
	  			var element = list[i];
	
	  			if ( element ) extractors[ element.type ]( names, element );
	  		}
	  	},
	
	  	RestElement: function RestElement ( names, node ) {
	  		extractors[ node.argument.type ]( names, node.argument );
	  	},
	
	  	AssignmentPattern: function AssignmentPattern ( names, node ) {
	  		extractors[ node.left.type ]( names, node.left );
	  	}
	  };
	
	  var ForStatement = (function (LoopStatement) {
	  	function ForStatement () {
	  		LoopStatement.apply(this, arguments);
	  	}
	
	  	if ( LoopStatement ) ForStatement.__proto__ = LoopStatement;
	  	ForStatement.prototype = Object.create( LoopStatement && LoopStatement.prototype );
	  	ForStatement.prototype.constructor = ForStatement;
	
	  	ForStatement.prototype.findScope = function findScope ( functionScope ) {
	  		return functionScope || !this.createdScope ? this.parent.findScope( functionScope ) : this.body.scope;
	  	};
	
	  	ForStatement.prototype.transpile = function transpile ( code, transforms ) {
	  		var this$1 = this;
	
	  		var i1 = this.getIndentation() + code.getIndentString();
	
	  		if ( this.shouldRewriteAsFunction ) {
	  			// which variables are declared in the init statement?
	  			var names = this.init.type === 'VariableDeclaration' ?
	  				[].concat.apply( [], this.init.declarations.map( function ( declarator ) { return extractNames( declarator.id ); } ) ) :
	  				[];
	
	  			var aliases = this.aliases;
	
	  			this.args = names.map( function ( name ) { return name in this$1.aliases ? this$1.aliases[ name ].outer : name; } );
	  			this.params = names.map( function ( name ) { return name in this$1.aliases ? this$1.aliases[ name ].inner : name; } );
	
	  			var updates = Object.keys( this.reassigned )
	  				.map( function ( name ) { return ((aliases[ name ].outer) + " = " + (aliases[ name ].inner) + ";"); } );
	
	  			if ( updates.length ) {
	  				if ( this.body.synthetic ) {
	  					code.insertLeft( this.body.body[0].end, ("; " + (updates.join(" "))) );
	  				} else {
	  					var lastStatement = this.body.body[ this.body.body.length - 1 ];
	  					code.insertLeft( lastStatement.end, ("\n\n" + i1 + (updates.join(("\n" + i1)))) );
	  				}
	  			}
	  		}
	
	  		LoopStatement.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return ForStatement;
	  }(LoopStatement));
	
	  var ForInStatement = (function (LoopStatement) {
	  	function ForInStatement () {
	  		LoopStatement.apply(this, arguments);
	  	}
	
	  	if ( LoopStatement ) ForInStatement.__proto__ = LoopStatement;
	  	ForInStatement.prototype = Object.create( LoopStatement && LoopStatement.prototype );
	  	ForInStatement.prototype.constructor = ForInStatement;
	
	  	ForInStatement.prototype.findScope = function findScope ( functionScope ) {
	  		return functionScope || !this.createdScope ? this.parent.findScope( functionScope ) : this.body.scope;
	  	};
	
	  	ForInStatement.prototype.transpile = function transpile ( code, transforms ) {
	  		var this$1 = this;
	
	  		if ( this.shouldRewriteAsFunction ) {
	  			// which variables are declared in the init statement?
	  			var names = this.left.type === 'VariableDeclaration' ?
	  				[].concat.apply( [], this.left.declarations.map( function ( declarator ) { return extractNames( declarator.id ); } ) ) :
	  				[];
	
	  			this.args = names.map( function ( name ) { return name in this$1.aliases ? this$1.aliases[ name ].outer : name; } );
	  			this.params = names.map( function ( name ) { return name in this$1.aliases ? this$1.aliases[ name ].inner : name; } );
	  		}
	
	  		LoopStatement.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return ForInStatement;
	  }(LoopStatement));
	
	  var handlers = {
	  	Identifier: destructureIdentifier,
	  	AssignmentPattern: destructureAssignmentPattern,
	  	ArrayPattern: destructureArrayPattern,
	  	ObjectPattern: destructureObjectPattern
	  };
	
	  function destructure ( code, scope, node, ref, inline, statementGenerators ) {
	  	handlers[ node.type ]( code, scope, node, ref, inline, statementGenerators );
	  }
	
	  function destructureIdentifier ( code, scope, node, ref, inline, statementGenerators ) {
	  	statementGenerators.push( function ( start, prefix, suffix ) {
	  		code.insertRight( node.start, inline ? prefix : (prefix + "var ") );
	  		code.insertLeft( node.end, (" = " + ref + suffix) );
	  		code.move( node.start, node.end, start );
	  	});
	  }
	
	  function destructureAssignmentPattern ( code, scope, node, ref, inline, statementGenerators ) {
	  	var isIdentifier = node.left.type === 'Identifier';
	  	var name = isIdentifier ? node.left.name : ref;
	
	  	if ( !inline ) {
	  		statementGenerators.push( function ( start, prefix, suffix ) {
	  			code.insertRight( node.left.end, (prefix + "if ( " + name + " === void 0 ) " + name) );
	  			code.move( node.left.end, node.right.end, start );
	  			code.insertLeft( node.right.end, suffix );
	  		});
	  	}
	
	  	if ( !isIdentifier ) {
	  		destructure( code, scope, node.left, ref, inline, statementGenerators );
	  	}
	  }
	
	  function destructureArrayPattern ( code, scope, node, ref, inline, statementGenerators ) {
	  	var c = node.start;
	
	  	node.elements.forEach( function ( element, i ) {
	  		if ( !element ) return;
	
	  		if ( element.type === 'RestElement' ) {
	  			handleProperty( code, scope, c, element.argument, (ref + ".slice(" + i + ")"), inline, statementGenerators );
	  		} else {
	  			handleProperty( code, scope, c, element, (ref + "[" + i + "]"), inline, statementGenerators );
	  		}
	  		c = element.end;
	  	});
	
	  	code.remove( c, node.end );
	  }
	
	  function destructureObjectPattern ( code, scope, node, ref, inline, statementGenerators ) {
	  	var c = node.start;
	
	  	node.properties.forEach( function ( prop ) {
	  		var value = prop.computed || prop.key.type !== 'Identifier' ? (ref + "[" + (code.slice(prop.key.start, prop.key.end)) + "]") : (ref + "." + (prop.key.name));
	  		handleProperty( code, scope, c, prop.value, value, inline, statementGenerators );
	  		c = prop.end;
	  	});
	
	  	code.remove( c, node.end );
	  }
	
	  function handleProperty ( code, scope, c, node, value, inline, statementGenerators ) {
	  	switch ( node.type ) {
	  		case 'Identifier': {
	  			code.remove( c, node.start );
	  			destructureIdentifier( code, scope, node, value, inline, statementGenerators );
	  			break;
	  		}
	
	  		case 'AssignmentPattern': {
	  			var name;
	
	  			var isIdentifier = node.left.type === 'Identifier';
	
	  			if ( isIdentifier ) {
	  				name = node.left.name;
	  				var declaration = scope.findDeclaration( name );
	  				if ( declaration ) name = declaration.name;
	  			} else {
	  				name = scope.createIdentifier( value );
	  			}
	
	  			statementGenerators.push( function ( start, prefix, suffix ) {
	  				if ( inline ) {
	  					code.insertRight( node.right.start, (name + " = " + value + " === undefined ? ") );
	  					code.insertLeft( node.right.end, (" : " + value) );
	  				} else {
	  					code.insertRight( node.right.start, (prefix + "var " + name + " = " + value + "; if ( " + name + " === void 0 ) " + name + " = ") );
	  					code.insertLeft( node.right.end, suffix );
	  				}
	
	  				code.move( node.right.start, node.right.end, start );
	  			});
	
	  			if ( isIdentifier ) {
	  				code.remove( c, node.right.start );
	  			} else {
	  				code.remove( c, node.left.start );
	  				code.remove( node.left.end, node.right.start );
	  				handleProperty( code, scope, c, node.left, name, inline, statementGenerators );
	  			}
	
	  			break;
	  		}
	
	  		case 'ObjectPattern': {
	  			code.remove( c, c = node.start );
	
	  			if ( node.properties.length > 1 ) {
	  				var ref = scope.createIdentifier( value );
	
	  				statementGenerators.push( function ( start, prefix, suffix ) {
	  					// this feels a tiny bit hacky, but we can't do a
	  					// straightforward insertLeft and keep correct order...
	  					code.insertRight( node.start, (prefix + "var " + ref + " = ") );
	  					code.overwrite( node.start, c = node.start + 1, value );
	  					code.insertLeft( c, suffix );
	
	  					code.move( node.start, c, start );
	  				});
	
	  				node.properties.forEach( function ( prop ) {
	  					var value = prop.computed || prop.key.type !== 'Identifier' ? (ref + "[" + (code.slice(prop.key.start, prop.key.end)) + "]") : (ref + "." + (prop.key.name));
	  					handleProperty( code, scope, c, prop.value, value, inline, statementGenerators );
	  					c = prop.end;
	  				});
	  			} else {
	  				var prop = node.properties[0];
	  				var value_suffix = prop.computed || prop.key.type !== 'Identifier' ? ("[" + (code.slice(prop.key.start, prop.key.end)) + "]") : ("." + (prop.key.name));
	  				handleProperty( code, scope, c, prop.value, ("" + value + value_suffix), inline, statementGenerators );
	  				c = prop.end;
	  			}
	
	  			code.remove( c, node.end );
	  			break;
	  		}
	
	  		case 'ArrayPattern': {
	  			code.remove( c, c = node.start );
	
	  			if ( node.elements.filter( Boolean ).length > 1 ) {
	  				var ref$1 = scope.createIdentifier( value );
	
	  				statementGenerators.push( function ( start, prefix, suffix ) {
	  					code.insertRight( node.start, (prefix + "var " + ref$1 + " = ") );
	  					code.overwrite( node.start, c = node.start + 1, value );
	  					code.insertLeft( c, suffix );
	
	  					code.move( node.start, c, start );
	  				});
	
	  				node.elements.forEach( function ( element, i ) {
	  					if ( !element ) return;
	
	  					if ( element.type === 'RestElement' ) {
	  						handleProperty( code, scope, c, element.argument, (ref$1 + ".slice(" + i + ")"), inline, statementGenerators );
	  					} else {
	  						handleProperty( code, scope, c, element, (ref$1 + "[" + i + "]"), inline, statementGenerators );
	  					}
	  					c = element.end;
	  				});
	  			} else {
	  				var index = findIndex( node.elements, Boolean );
	  				var element = node.elements[ index ];
	  				if ( element.type === 'RestElement' ) {
	  					handleProperty( code, scope, c, element.argument, (value + ".slice(" + index + ")"), inline, statementGenerators );
	  				} else {
	  					handleProperty( code, scope, c, element, (value + "[" + index + "]"), inline, statementGenerators );
	  				}
	  				c = element.end;
	  			}
	
	  			code.remove( c, node.end );
	  			break;
	  		}
	
	  		default: {
	  			throw new Error( ("Unexpected node type in destructuring (" + (node.type) + ")") );
	  		}
	  	}
	  }
	
	  var ForOfStatement = (function (LoopStatement) {
	  	function ForOfStatement () {
	  		LoopStatement.apply(this, arguments);
	  	}
	
	  	if ( LoopStatement ) ForOfStatement.__proto__ = LoopStatement;
	  	ForOfStatement.prototype = Object.create( LoopStatement && LoopStatement.prototype );
	  	ForOfStatement.prototype.constructor = ForOfStatement;
	
	  	ForOfStatement.prototype.initialise = function initialise ( transforms ) {
	  		if ( transforms.forOf && !transforms.dangerousForOf ) throw new CompileError( this, 'for...of statements are not supported. Use `transforms: { forOf: false }` to skip transformation and disable this error, or `transforms: { dangerousForOf: true }` if you know what you\'re doing' );
	  		LoopStatement.prototype.initialise.call( this, transforms );
	  	};
	
	  	ForOfStatement.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( !transforms.dangerousForOf ) {
	  			LoopStatement.prototype.transpile.call( this, code, transforms );
	  			return;
	  		}
	
	  		// edge case (#80)
	  		if ( !this.body.body[0] ) {
	  			if ( this.left.type === 'VariableDeclaration' && this.left.kind === 'var' ) {
	  				code.remove( this.start, this.left.start );
	  				code.insertLeft( this.left.end, ';' );
	  				code.remove( this.left.end, this.end );
	  			} else {
	  				code.remove( this.start, this.end );
	  			}
	
	  			return;
	  		}
	
	  		var scope = this.findScope( true );
	  		var i0 = this.getIndentation();
	  		var i1 = i0 + code.getIndentString();
	
	  		var key = scope.createIdentifier( 'i' );
	  		var list = scope.createIdentifier( 'list' );
	
	  		if ( this.body.synthetic ) {
	  			code.insertRight( this.left.start, ("{\n" + i1) );
	  			code.insertLeft( this.body.body[0].end, ("\n" + i0 + "}") );
	  		}
	
	  		var bodyStart = this.body.body[0].start;
	
	  		code.remove( this.left.end, this.right.start );
	  		code.move( this.left.start, this.left.end, bodyStart );
	
	
	  		code.insertRight( this.right.start, ("var " + key + " = 0, " + list + " = ") );
	  		code.insertLeft( this.right.end, ("; " + key + " < " + list + ".length; " + key + " += 1") );
	
	  		// destructuring. TODO non declaration destructuring
	  		var declarator = this.left.type === 'VariableDeclaration' && this.left.declarations[0];
	  		if ( declarator && declarator.id.type !== 'Identifier' ) {
	  			var statementGenerators = [];
	  			var ref = scope.createIdentifier( 'ref' );
	  			destructure( code, scope, declarator.id, ref, false, statementGenerators );
	
	  			var suffix = ";\n" + i1;
	  			statementGenerators.forEach( function ( fn, i ) {
	  				if ( i === statementGenerators.length - 1 ) {
	  					suffix = ";\n\n" + i1;
	  				}
	
	  				fn( bodyStart, '', suffix );
	  			});
	
	  			code.insertLeft( this.left.start + this.left.kind.length + 1, ref );
	  			code.insertLeft( this.left.end, (" = " + list + "[" + key + "];\n" + i1) );
	  		} else {
	  			code.insertLeft( this.left.end, (" = " + list + "[" + key + "];\n\n" + i1) );
	  		}
	
	  		LoopStatement.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return ForOfStatement;
	  }(LoopStatement));
	
	  var FunctionDeclaration = (function (Node) {
	  	function FunctionDeclaration () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) FunctionDeclaration.__proto__ = Node;
	  	FunctionDeclaration.prototype = Object.create( Node && Node.prototype );
	  	FunctionDeclaration.prototype.constructor = FunctionDeclaration;
	
	  	FunctionDeclaration.prototype.initialise = function initialise ( transforms ) {
	  		if ( this.generator && transforms.generator ) {
	  			throw new CompileError( this, 'Generators are not supported' );
	  		}
	
	  		this.body.createScope();
	
	  		this.findScope( true ).addDeclaration( this.id, 'function' );
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	return FunctionDeclaration;
	  }(Node));
	
	  var FunctionExpression = (function (Node) {
	  	function FunctionExpression () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) FunctionExpression.__proto__ = Node;
	  	FunctionExpression.prototype = Object.create( Node && Node.prototype );
	  	FunctionExpression.prototype.constructor = FunctionExpression;
	
	  	FunctionExpression.prototype.initialise = function initialise ( transforms ) {
	  		if ( this.generator && transforms.generator ) {
	  			throw new CompileError( this, 'Generators are not supported' );
	  		}
	
	  		this.body.createScope();
	
	  		if ( this.id ) {
	  			// function expression IDs belong to the child scope...
	  			this.body.scope.addDeclaration( this.id, 'function' );
	  		}
	
	  		Node.prototype.initialise.call( this, transforms );
	
	  		var parent = this.parent;
	  		var methodName;
	
	  		if ( transforms.conciseMethodProperty
	  				&& parent.type === 'Property'
	  				&& parent.kind === 'init'
	  				&& parent.method
	  				&& parent.key.type === 'Identifier' ) {
	  			// object literal concise method
	  			methodName = parent.key.name;
	  		}
	  		else if ( transforms.classes
	  				&& parent.type === 'MethodDefinition'
	  				&& parent.kind === 'method'
	  				&& parent.key.type === 'Identifier' ) {
	  			// method definition in a class
	  			methodName = parent.key.name;
	  		}
	  		else if ( this.id && this.id.type === 'Identifier' ) {
	  			// naked function expression
	  			methodName = this.id.alias || this.id.name;
	  		}
	
	  		if ( methodName ) {
	  			for ( var i = 0, list = this.params; i < list.length; i += 1 ) {
	  				var param = list[i];
	
	  				if ( param.type === 'Identifier' && methodName === param.name ) {
	  					// workaround for Safari 9/WebKit bug:
	  					// https://gitlab.com/Rich-Harris/buble/issues/154
	  					// change parameter name when same as method name
	
	  					var scope = this.body.scope;
	  					var declaration = scope.declarations[ methodName ];
	
	  					var alias = scope.createIdentifier( methodName );
	  					param.alias = alias;
	
	  					for ( var i$1 = 0, list$1 = declaration.instances; i$1 < list$1.length; i$1 += 1 ) {
	  						var identifier = list$1[i$1];
	
	  						identifier.alias = alias;
	  					}
	
	  					break;
	  				}
	  			}
	  		}
	  	};
	
	  	return FunctionExpression;
	  }(Node));
	
	  function isReference ( node, parent ) {
	  	if ( node.type === 'MemberExpression' ) {
	  		return !node.computed && isReference( node.object, node );
	  	}
	
	  	if ( node.type === 'Identifier' ) {
	  		// the only time we could have an identifier node without a parent is
	  		// if it's the entire body of a function without a block statement –
	  		// i.e. an arrow function expression like `a => a`
	  		if ( !parent ) return true;
	
	  		if ( /(Function|Class)Expression/.test( parent.type ) ) return false;
	
	  		if ( parent.type === 'VariableDeclarator' ) return node === parent.init;
	
	  		// TODO is this right?
	  		if ( parent.type === 'MemberExpression' || parent.type === 'MethodDefinition' ) {
	  			return parent.computed || node === parent.object;
	  		}
	
	  		if ( parent.type === 'ArrayPattern' ) return false;
	
	  		// disregard the `bar` in `{ bar: foo }`, but keep it in `{ [bar]: foo }`
	  		if ( parent.type === 'Property' ) {
	  			if ( parent.parent.type === 'ObjectPattern' ) return false;
	  			return parent.computed || node === parent.value;
	  		}
	
	  		// disregard the `bar` in `class Foo { bar () {...} }`
	  		if ( parent.type === 'MethodDefinition' ) return false;
	
	  		// disregard the `bar` in `export { foo as bar }`
	  		if ( parent.type === 'ExportSpecifier' && node !== parent.local ) return false;
	
	  		return true;
	  	}
	  }
	
	  var Identifier = (function (Node) {
	  	function Identifier () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) Identifier.__proto__ = Node;
	  	Identifier.prototype = Object.create( Node && Node.prototype );
	  	Identifier.prototype.constructor = Identifier;
	
	  	Identifier.prototype.findScope = function findScope ( functionScope ) {
	  		if ( this.parent.params && ~this.parent.params.indexOf( this ) ) {
	  			return this.parent.body.scope;
	  		}
	
	  		if ( this.parent.type === 'FunctionExpression' && this === this.parent.id ) {
	  			return this.parent.body.scope;
	  		}
	
	  		return this.parent.findScope( functionScope	);
	  	};
	
	  	Identifier.prototype.initialise = function initialise ( transforms ) {
	  		if ( transforms.arrow && isReference( this, this.parent ) ) {
	  			if ( this.name === 'arguments' && !this.findScope( false ).contains( this.name ) ) {
	  				var lexicalBoundary = this.findLexicalBoundary();
	  				var arrowFunction = this.findNearest( 'ArrowFunctionExpression' );
	  				var loop = this.findNearest( loopStatement );
	
	  				if ( arrowFunction && arrowFunction.depth > lexicalBoundary.depth ) {
	  					this.alias = lexicalBoundary.getArgumentsAlias();
	  				}
	
	  				if ( loop && loop.body.contains( this ) && loop.depth > lexicalBoundary.depth ) {
	  					this.alias = lexicalBoundary.getArgumentsAlias();
	  				}
	  			}
	
	  			this.findScope( false ).addReference( this );
	  		}
	  	};
	
	  	Identifier.prototype.transpile = function transpile ( code ) {
	  		if ( this.alias ) {
	  			code.overwrite( this.start, this.end, this.alias, true );
	  		}
	  	};
	
	  	return Identifier;
	  }(Node));
	
	  var IfStatement = (function (Node) {
	  	function IfStatement () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) IfStatement.__proto__ = Node;
	  	IfStatement.prototype = Object.create( Node && Node.prototype );
	  	IfStatement.prototype.constructor = IfStatement;
	
	  	IfStatement.prototype.initialise = function initialise ( transforms ) {
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	IfStatement.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( this.consequent.type !== 'BlockStatement'
	  				|| this.consequent.type === 'BlockStatement' && this.consequent.synthetic ) {
	  			code.insertLeft( this.consequent.start, '{ ' );
	  			code.insertRight( this.consequent.end, ' }' );
	  		}
	
	  		if ( this.alternate && this.alternate.type !== 'IfStatement' && (
	  				this.alternate.type !== 'BlockStatement'
	  				|| this.alternate.type === 'BlockStatement' && this.alternate.synthetic ) ) {
	  			code.insertLeft( this.alternate.start, '{ ' );
	  			code.insertRight( this.alternate.end, ' }' );
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return IfStatement;
	  }(Node));
	
	  var ImportDeclaration = (function (Node) {
	  	function ImportDeclaration () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) ImportDeclaration.__proto__ = Node;
	  	ImportDeclaration.prototype = Object.create( Node && Node.prototype );
	  	ImportDeclaration.prototype.constructor = ImportDeclaration;
	
	  	ImportDeclaration.prototype.initialise = function initialise ( transforms ) {
	  		if ( transforms.moduleImport ) throw new CompileError( this, 'import is not supported' );
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	return ImportDeclaration;
	  }(Node));
	
	  var ImportDefaultSpecifier = (function (Node) {
	  	function ImportDefaultSpecifier () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) ImportDefaultSpecifier.__proto__ = Node;
	  	ImportDefaultSpecifier.prototype = Object.create( Node && Node.prototype );
	  	ImportDefaultSpecifier.prototype.constructor = ImportDefaultSpecifier;
	
	  	ImportDefaultSpecifier.prototype.initialise = function initialise ( transforms ) {
	  		this.findScope( true ).addDeclaration( this.local, 'import' );
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	return ImportDefaultSpecifier;
	  }(Node));
	
	  var ImportSpecifier = (function (Node) {
	  	function ImportSpecifier () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) ImportSpecifier.__proto__ = Node;
	  	ImportSpecifier.prototype = Object.create( Node && Node.prototype );
	  	ImportSpecifier.prototype.constructor = ImportSpecifier;
	
	  	ImportSpecifier.prototype.initialise = function initialise ( transforms ) {
	  		this.findScope( true ).addDeclaration( this.local, 'import' );
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	return ImportSpecifier;
	  }(Node));
	
	  var IS_DATA_ATTRIBUTE = /-/;
	
	  var JSXAttribute = (function (Node) {
	  	function JSXAttribute () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) JSXAttribute.__proto__ = Node;
	  	JSXAttribute.prototype = Object.create( Node && Node.prototype );
	  	JSXAttribute.prototype.constructor = JSXAttribute;
	
	  	JSXAttribute.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( this.value ) {
	  			code.overwrite( this.name.end, this.value.start, ': ' );
	  		} else {
	  			// tag without value
	  			code.overwrite( this.name.start, this.name.end, ((this.name.name) + ": true") );
	  		}
	
	  		if ( IS_DATA_ATTRIBUTE.test( this.name.name ) ) {
	  			code.overwrite( this.name.start, this.name.end, ("'" + (this.name.name) + "'") );
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return JSXAttribute;
	  }(Node));
	
	  function containsNewLine ( node ) {
	  	return node.type === 'Literal' && !/\S/.test( node.value ) && /\n/.test( node.value );
	  }
	
	  var JSXClosingElement = (function (Node) {
	  	function JSXClosingElement () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) JSXClosingElement.__proto__ = Node;
	  	JSXClosingElement.prototype = Object.create( Node && Node.prototype );
	  	JSXClosingElement.prototype.constructor = JSXClosingElement;
	
	  	JSXClosingElement.prototype.transpile = function transpile ( code ) {
	  		var spaceBeforeParen = true;
	
	  		var lastChild = this.parent.children[ this.parent.children.length - 1 ];
	
	  		// omit space before closing paren if
	  		//   a) this is on a separate line, or
	  		//   b) there are no children but there are attributes
	  		if ( ( lastChild && containsNewLine( lastChild ) ) || ( this.parent.openingElement.attributes.length ) ) {
	  			spaceBeforeParen = false;
	  		}
	
	  		code.overwrite( this.start, this.end, spaceBeforeParen ? ' )' : ')' );
	  	};
	
	  	return JSXClosingElement;
	  }(Node));
	
	  function normalise ( str, removeTrailingWhitespace ) {
	  	if ( removeTrailingWhitespace && /\n/.test( str ) ) {
	  		str = str.replace( /\s+$/, '' );
	  	}
	
	  	str = str
	  		.replace( /^\n\r?\s+/, '' )       // remove leading newline + space
	  		.replace( /\s*\n\r?\s*/gm, ' ' ); // replace newlines with spaces
	
	  	// TODO prefer single quotes?
	  	return JSON.stringify( str );
	  }
	
	  var JSXElement = (function (Node) {
	  	function JSXElement () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) JSXElement.__proto__ = Node;
	  	JSXElement.prototype = Object.create( Node && Node.prototype );
	  	JSXElement.prototype.constructor = JSXElement;
	
	  	JSXElement.prototype.transpile = function transpile ( code, transforms ) {
	  		Node.prototype.transpile.call( this, code, transforms );
	
	  		var children = this.children.filter( function ( child ) {
	  			if ( child.type !== 'Literal' ) return true;
	
	  			// remove whitespace-only literals, unless on a single line
	  			return /\S/.test( child.value ) || !/\n/.test( child.value );
	  		});
	
	  		if ( children.length ) {
	  			var c = this.openingElement.end;
	
	  			var i;
	  			for ( i = 0; i < children.length; i += 1 ) {
	  				var child = children[i];
	
	  				if ( child.type === 'JSXExpressionContainer' && child.expression.type === 'JSXEmptyExpression' ) {
	  					// empty block is a no op
	  				} else {
	  					var tail = code.original[ c ] === '\n' && child.type !== 'Literal' ? '' : ' ';
	  					code.insertLeft( c, ("," + tail) );
	  				}
	
	  				if ( child.type === 'Literal' ) {
	  					var str = normalise( child.value, i === children.length - 1 );
	  					code.overwrite( child.start, child.end, str );
	  				}
	
	  				c = child.end;
	  			}
	  		}
	  	};
	
	  	return JSXElement;
	  }(Node));
	
	  var JSXExpressionContainer = (function (Node) {
	  	function JSXExpressionContainer () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) JSXExpressionContainer.__proto__ = Node;
	  	JSXExpressionContainer.prototype = Object.create( Node && Node.prototype );
	  	JSXExpressionContainer.prototype.constructor = JSXExpressionContainer;
	
	  	JSXExpressionContainer.prototype.transpile = function transpile ( code, transforms ) {
	  		code.remove( this.start, this.expression.start );
	  		code.remove( this.expression.end, this.end );
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return JSXExpressionContainer;
	  }(Node));
	
	  var JSXOpeningElement = (function (Node) {
	  	function JSXOpeningElement () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) JSXOpeningElement.__proto__ = Node;
	  	JSXOpeningElement.prototype = Object.create( Node && Node.prototype );
	  	JSXOpeningElement.prototype.constructor = JSXOpeningElement;
	
	  	JSXOpeningElement.prototype.transpile = function transpile ( code, transforms ) {
	  		var this$1 = this;
	
	  		code.overwrite( this.start, this.name.start, ((this.program.jsx) + "( ") );
	
	  		var html = this.name.type === 'JSXIdentifier' && this.name.name[0] === this.name.name[0].toLowerCase();
	  		if ( html ) code.insertRight( this.name.start, "'" );
	
	  		var len = this.attributes.length;
	  		var c = this.name.end;
	
	  		if ( len ) {
	  			var i;
	
	  			var hasSpread = false;
	  			for ( i = 0; i < len; i += 1 ) {
	  				if ( this$1.attributes[i].type === 'JSXSpreadAttribute' ) {
	  					hasSpread = true;
	  					break;
	  				}
	  			}
	
	  			c = this.attributes[0].end;
	
	  			for ( i = 0; i < len; i += 1 ) {
	  				var attr = this$1.attributes[i];
	
	  				if ( i > 0 ) {
	  					code.overwrite( c, attr.start, ', ' );
	  				}
	
	  				if ( hasSpread && attr.type !== 'JSXSpreadAttribute' ) {
	  					var lastAttr = this$1.attributes[ i - 1 ];
	  					var nextAttr = this$1.attributes[ i + 1 ];
	
	  					if ( !lastAttr || lastAttr.type === 'JSXSpreadAttribute' ) {
	  						code.insertRight( attr.start, '{ ' );
	  					}
	
	  					if ( !nextAttr || nextAttr.type === 'JSXSpreadAttribute' ) {
	  						code.insertLeft( attr.end, ' }' );
	  					}
	  				}
	
	  				c = attr.end;
	  			}
	
	  			var after;
	  			var before;
	  			if ( hasSpread ) {
	  				if ( len === 1 ) {
	  					before = html ? "'," : ',';
	  				} else {
	  					if (!this.program.options.objectAssign) {
	  						throw new CompileError( this, 'Mixed JSX attributes ending in spread requires specified objectAssign option with \'Object.assign\' or polyfill helper.' );
	  					}
	  					before = html ? ("', " + (this.program.options.objectAssign) + "({},") : (", " + (this.program.options.objectAssign) + "({},");
	  					after = ')';
	  				}
	  			} else {
	  				before = html ? "', {" : ', {';
	  				after = ' }';
	  			}
	
	  			code.insertRight( this.name.end, before );
	
	  			if ( after ) {
	  				code.insertLeft( this.attributes[ len - 1 ].end, after );
	  			}
	  		} else {
	  			code.insertLeft( this.name.end, html ? "', null" : ", null" );
	  			c = this.name.end;
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	
	  		if ( this.selfClosing ) {
	  			code.overwrite( c, this.end, this.attributes.length ? ")" : " )" );
	  		} else {
	  			code.remove( c, this.end );
	  		}
	  	};
	
	  	return JSXOpeningElement;
	  }(Node));
	
	  var JSXSpreadAttribute = (function (Node) {
	  	function JSXSpreadAttribute () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) JSXSpreadAttribute.__proto__ = Node;
	  	JSXSpreadAttribute.prototype = Object.create( Node && Node.prototype );
	  	JSXSpreadAttribute.prototype.constructor = JSXSpreadAttribute;
	
	  	JSXSpreadAttribute.prototype.transpile = function transpile ( code, transforms ) {
	  		code.remove( this.start, this.argument.start );
	  		code.remove( this.argument.end, this.end );
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return JSXSpreadAttribute;
	  }(Node));
	
	  var regenerate = __commonjs(function (module, exports, global) {
	  /*! https://mths.be/regenerate v1.3.1 by @mathias | MIT license */
	  ;(function(root) {
	
	  	// Detect free variables `exports`.
	  	var freeExports = typeof exports == 'object' && exports;
	
	  	// Detect free variable `module`.
	  	var freeModule = typeof module == 'object' && module &&
	  		module.exports == freeExports && module;
	
	  	// Detect free variable `global`, from Node.js/io.js or Browserified code,
	  	// and use it as `root`.
	  	var freeGlobal = typeof global == 'object' && global;
	  	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
	  		root = freeGlobal;
	  	}
	
	  	/*--------------------------------------------------------------------------*/
	
	  	var ERRORS = {
	  		'rangeOrder': 'A range\u2019s `stop` value must be greater than or equal ' +
	  			'to the `start` value.',
	  		'codePointRange': 'Invalid code point value. Code points range from ' +
	  			'U+000000 to U+10FFFF.'
	  	};
	
	  	// https://mathiasbynens.be/notes/javascript-encoding#surrogate-pairs
	  	var HIGH_SURROGATE_MIN = 0xD800;
	  	var HIGH_SURROGATE_MAX = 0xDBFF;
	  	var LOW_SURROGATE_MIN = 0xDC00;
	  	var LOW_SURROGATE_MAX = 0xDFFF;
	
	  	// In Regenerate output, `\0` is never preceded by `\` because we sort by
	  	// code point value, so let’s keep this regular expression simple.
	  	var regexNull = /\\x00([^0123456789]|$)/g;
	
	  	var object = {};
	  	var hasOwnProperty = object.hasOwnProperty;
	  	var extend = function(destination, source) {
	  		var key;
	  		for (key in source) {
	  			if (hasOwnProperty.call(source, key)) {
	  				destination[key] = source[key];
	  			}
	  		}
	  		return destination;
	  	};
	
	  	var forEach = function(array, callback) {
	  		var index = -1;
	  		var length = array.length;
	  		while (++index < length) {
	  			callback(array[index], index);
	  		}
	  	};
	
	  	var toString = object.toString;
	  	var isArray = function(value) {
	  		return toString.call(value) == '[object Array]';
	  	};
	  	var isNumber = function(value) {
	  		return typeof value == 'number' ||
	  			toString.call(value) == '[object Number]';
	  	};
	
	  	// This assumes that `number` is a positive integer that `toString()`s nicely
	  	// (which is the case for all code point values).
	  	var zeroes = '0000';
	  	var pad = function(number, totalCharacters) {
	  		var string = String(number);
	  		return string.length < totalCharacters
	  			? (zeroes + string).slice(-totalCharacters)
	  			: string;
	  	};
	
	  	var hex = function(number) {
	  		return Number(number).toString(16).toUpperCase();
	  	};
	
	  	var slice = [].slice;
	
	  	/*--------------------------------------------------------------------------*/
	
	  	var dataFromCodePoints = function(codePoints) {
	  		var index = -1;
	  		var length = codePoints.length;
	  		var max = length - 1;
	  		var result = [];
	  		var isStart = true;
	  		var tmp;
	  		var previous = 0;
	  		while (++index < length) {
	  			tmp = codePoints[index];
	  			if (isStart) {
	  				result.push(tmp);
	  				previous = tmp;
	  				isStart = false;
	  			} else {
	  				if (tmp == previous + 1) {
	  					if (index != max) {
	  						previous = tmp;
	  						continue;
	  					} else {
	  						isStart = true;
	  						result.push(tmp + 1);
	  					}
	  				} else {
	  					// End the previous range and start a new one.
	  					result.push(previous + 1, tmp);
	  					previous = tmp;
	  				}
	  			}
	  		}
	  		if (!isStart) {
	  			result.push(tmp + 1);
	  		}
	  		return result;
	  	};
	
	  	var dataRemove = function(data, codePoint) {
	  		// Iterate over the data per `(start, end)` pair.
	  		var index = 0;
	  		var start;
	  		var end;
	  		var length = data.length;
	  		while (index < length) {
	  			start = data[index];
	  			end = data[index + 1];
	  			if (codePoint >= start && codePoint < end) {
	  				// Modify this pair.
	  				if (codePoint == start) {
	  					if (end == start + 1) {
	  						// Just remove `start` and `end`.
	  						data.splice(index, 2);
	  						return data;
	  					} else {
	  						// Just replace `start` with a new value.
	  						data[index] = codePoint + 1;
	  						return data;
	  					}
	  				} else if (codePoint == end - 1) {
	  					// Just replace `end` with a new value.
	  					data[index + 1] = codePoint;
	  					return data;
	  				} else {
	  					// Replace `[start, end]` with `[startA, endA, startB, endB]`.
	  					data.splice(index, 2, start, codePoint, codePoint + 1, end);
	  					return data;
	  				}
	  			}
	  			index += 2;
	  		}
	  		return data;
	  	};
	
	  	var dataRemoveRange = function(data, rangeStart, rangeEnd) {
	  		if (rangeEnd < rangeStart) {
	  			throw Error(ERRORS.rangeOrder);
	  		}
	  		// Iterate over the data per `(start, end)` pair.
	  		var index = 0;
	  		var start;
	  		var end;
	  		while (index < data.length) {
	  			start = data[index];
	  			end = data[index + 1] - 1; // Note: the `- 1` makes `end` inclusive.
	
	  			// Exit as soon as no more matching pairs can be found.
	  			if (start > rangeEnd) {
	  				return data;
	  			}
	
	  			// Check if this range pair is equal to, or forms a subset of, the range
	  			// to be removed.
	  			// E.g. we have `[0, 11, 40, 51]` and want to remove 0-10 → `[40, 51]`.
	  			// E.g. we have `[40, 51]` and want to remove 0-100 → `[]`.
	  			if (rangeStart <= start && rangeEnd >= end) {
	  				// Remove this pair.
	  				data.splice(index, 2);
	  				continue;
	  			}
	
	  			// Check if both `rangeStart` and `rangeEnd` are within the bounds of
	  			// this pair.
	  			// E.g. we have `[0, 11]` and want to remove 4-6 → `[0, 4, 7, 11]`.
	  			if (rangeStart >= start && rangeEnd < end) {
	  				if (rangeStart == start) {
	  					// Replace `[start, end]` with `[startB, endB]`.
	  					data[index] = rangeEnd + 1;
	  					data[index + 1] = end + 1;
	  					return data;
	  				}
	  				// Replace `[start, end]` with `[startA, endA, startB, endB]`.
	  				data.splice(index, 2, start, rangeStart, rangeEnd + 1, end + 1);
	  				return data;
	  			}
	
	  			// Check if only `rangeStart` is within the bounds of this pair.
	  			// E.g. we have `[0, 11]` and want to remove 4-20 → `[0, 4]`.
	  			if (rangeStart >= start && rangeStart <= end) {
	  				// Replace `end` with `rangeStart`.
	  				data[index + 1] = rangeStart;
	  				// Note: we cannot `return` just yet, in case any following pairs still
	  				// contain matching code points.
	  				// E.g. we have `[0, 11, 14, 31]` and want to remove 4-20
	  				// → `[0, 4, 21, 31]`.
	  			}
	
	  			// Check if only `rangeEnd` is within the bounds of this pair.
	  			// E.g. we have `[14, 31]` and want to remove 4-20 → `[21, 31]`.
	  			else if (rangeEnd >= start && rangeEnd <= end) {
	  				// Just replace `start`.
	  				data[index] = rangeEnd + 1;
	  				return data;
	  			}
	
	  			index += 2;
	  		}
	  		return data;
	  	};
	
	  	 var dataAdd = function(data, codePoint) {
	  		// Iterate over the data per `(start, end)` pair.
	  		var index = 0;
	  		var start;
	  		var end;
	  		var lastIndex = null;
	  		var length = data.length;
	  		if (codePoint < 0x0 || codePoint > 0x10FFFF) {
	  			throw RangeError(ERRORS.codePointRange);
	  		}
	  		while (index < length) {
	  			start = data[index];
	  			end = data[index + 1];
	
	  			// Check if the code point is already in the set.
	  			if (codePoint >= start && codePoint < end) {
	  				return data;
	  			}
	
	  			if (codePoint == start - 1) {
	  				// Just replace `start` with a new value.
	  				data[index] = codePoint;
	  				return data;
	  			}
	
	  			// At this point, if `start` is `greater` than `codePoint`, insert a new
	  			// `[start, end]` pair before the current pair, or after the current pair
	  			// if there is a known `lastIndex`.
	  			if (start > codePoint) {
	  				data.splice(
	  					lastIndex != null ? lastIndex + 2 : 0,
	  					0,
	  					codePoint,
	  					codePoint + 1
	  				);
	  				return data;
	  			}
	
	  			if (codePoint == end) {
	  				// Check if adding this code point causes two separate ranges to become
	  				// a single range, e.g. `dataAdd([0, 4, 5, 10], 4)` → `[0, 10]`.
	  				if (codePoint + 1 == data[index + 2]) {
	  					data.splice(index, 4, start, data[index + 3]);
	  					return data;
	  				}
	  				// Else, just replace `end` with a new value.
	  				data[index + 1] = codePoint + 1;
	  				return data;
	  			}
	  			lastIndex = index;
	  			index += 2;
	  		}
	  		// The loop has finished; add the new pair to the end of the data set.
	  		data.push(codePoint, codePoint + 1);
	  		return data;
	  	};
	
	  	var dataAddData = function(dataA, dataB) {
	  		// Iterate over the data per `(start, end)` pair.
	  		var index = 0;
	  		var start;
	  		var end;
	  		var data = dataA.slice();
	  		var length = dataB.length;
	  		while (index < length) {
	  			start = dataB[index];
	  			end = dataB[index + 1] - 1;
	  			if (start == end) {
	  				data = dataAdd(data, start);
	  			} else {
	  				data = dataAddRange(data, start, end);
	  			}
	  			index += 2;
	  		}
	  		return data;
	  	};
	
	  	var dataRemoveData = function(dataA, dataB) {
	  		// Iterate over the data per `(start, end)` pair.
	  		var index = 0;
	  		var start;
	  		var end;
	  		var data = dataA.slice();
	  		var length = dataB.length;
	  		while (index < length) {
	  			start = dataB[index];
	  			end = dataB[index + 1] - 1;
	  			if (start == end) {
	  				data = dataRemove(data, start);
	  			} else {
	  				data = dataRemoveRange(data, start, end);
	  			}
	  			index += 2;
	  		}
	  		return data;
	  	};
	
	  	var dataAddRange = function(data, rangeStart, rangeEnd) {
	  		if (rangeEnd < rangeStart) {
	  			throw Error(ERRORS.rangeOrder);
	  		}
	  		if (
	  			rangeStart < 0x0 || rangeStart > 0x10FFFF ||
	  			rangeEnd < 0x0 || rangeEnd > 0x10FFFF
	  		) {
	  			throw RangeError(ERRORS.codePointRange);
	  		}
	  		// Iterate over the data per `(start, end)` pair.
	  		var index = 0;
	  		var start;
	  		var end;
	  		var added = false;
	  		var length = data.length;
	  		while (index < length) {
	  			start = data[index];
	  			end = data[index + 1];
	
	  			if (added) {
	  				// The range has already been added to the set; at this point, we just
	  				// need to get rid of the following ranges in case they overlap.
	
	  				// Check if this range can be combined with the previous range.
	  				if (start == rangeEnd + 1) {
	  					data.splice(index - 1, 2);
	  					return data;
	  				}
	
	  				// Exit as soon as no more possibly overlapping pairs can be found.
	  				if (start > rangeEnd) {
	  					return data;
	  				}
	
	  				// E.g. `[0, 11, 12, 16]` and we’ve added 5-15, so we now have
	  				// `[0, 16, 12, 16]`. Remove the `12,16` part, as it lies within the
	  				// `0,16` range that was previously added.
	  				if (start >= rangeStart && start <= rangeEnd) {
	  					// `start` lies within the range that was previously added.
	
	  					if (end > rangeStart && end - 1 <= rangeEnd) {
	  						// `end` lies within the range that was previously added as well,
	  						// so remove this pair.
	  						data.splice(index, 2);
	  						index -= 2;
	  						// Note: we cannot `return` just yet, as there may still be other
	  						// overlapping pairs.
	  					} else {
	  						// `start` lies within the range that was previously added, but
	  						// `end` doesn’t. E.g. `[0, 11, 12, 31]` and we’ve added 5-15, so
	  						// now we have `[0, 16, 12, 31]`. This must be written as `[0, 31]`.
	  						// Remove the previously added `end` and the current `start`.
	  						data.splice(index - 1, 2);
	  						index -= 2;
	  					}
	
	  					// Note: we cannot return yet.
	  				}
	
	  			}
	
	  			else if (start == rangeEnd + 1) {
	  				data[index] = rangeStart;
	  				return data;
	  			}
	
	  			// Check if a new pair must be inserted *before* the current one.
	  			else if (start > rangeEnd) {
	  				data.splice(index, 0, rangeStart, rangeEnd + 1);
	  				return data;
	  			}
	
	  			else if (rangeStart >= start && rangeStart < end && rangeEnd + 1 <= end) {
	  				// The new range lies entirely within an existing range pair. No action
	  				// needed.
	  				return data;
	  			}
	
	  			else if (
	  				// E.g. `[0, 11]` and you add 5-15 → `[0, 16]`.
	  				(rangeStart >= start && rangeStart < end) ||
	  				// E.g. `[0, 3]` and you add 3-6 → `[0, 7]`.
	  				end == rangeStart
	  			) {
	  				// Replace `end` with the new value.
	  				data[index + 1] = rangeEnd + 1;
	  				// Make sure the next range pair doesn’t overlap, e.g. `[0, 11, 12, 14]`
	  				// and you add 5-15 → `[0, 16]`, i.e. remove the `12,14` part.
	  				added = true;
	  				// Note: we cannot `return` just yet.
	  			}
	
	  			else if (rangeStart <= start && rangeEnd + 1 >= end) {
	  				// The new range is a superset of the old range.
	  				data[index] = rangeStart;
	  				data[index + 1] = rangeEnd + 1;
	  				added = true;
	  			}
	
	  			index += 2;
	  		}
	  		// The loop has finished without doing anything; add the new pair to the end
	  		// of the data set.
	  		if (!added) {
	  			data.push(rangeStart, rangeEnd + 1);
	  		}
	  		return data;
	  	};
	
	  	var dataContains = function(data, codePoint) {
	  		var index = 0;
	  		var length = data.length;
	  		// Exit early if `codePoint` is not within `data`’s overall range.
	  		var start = data[index];
	  		var end = data[length - 1];
	  		if (length >= 2) {
	  			if (codePoint < start || codePoint > end) {
	  				return false;
	  			}
	  		}
	  		// Iterate over the data per `(start, end)` pair.
	  		while (index < length) {
	  			start = data[index];
	  			end = data[index + 1];
	  			if (codePoint >= start && codePoint < end) {
	  				return true;
	  			}
	  			index += 2;
	  		}
	  		return false;
	  	};
	
	  	var dataIntersection = function(data, codePoints) {
	  		var index = 0;
	  		var length = codePoints.length;
	  		var codePoint;
	  		var result = [];
	  		while (index < length) {
	  			codePoint = codePoints[index];
	  			if (dataContains(data, codePoint)) {
	  				result.push(codePoint);
	  			}
	  			++index;
	  		}
	  		return dataFromCodePoints(result);
	  	};
	
	  	var dataIsEmpty = function(data) {
	  		return !data.length;
	  	};
	
	  	var dataIsSingleton = function(data) {
	  		// Check if the set only represents a single code point.
	  		return data.length == 2 && data[0] + 1 == data[1];
	  	};
	
	  	var dataToArray = function(data) {
	  		// Iterate over the data per `(start, end)` pair.
	  		var index = 0;
	  		var start;
	  		var end;
	  		var result = [];
	  		var length = data.length;
	  		while (index < length) {
	  			start = data[index];
	  			end = data[index + 1];
	  			while (start < end) {
	  				result.push(start);
	  				++start;
	  			}
	  			index += 2;
	  		}
	  		return result;
	  	};
	
	  	/*--------------------------------------------------------------------------*/
	
	  	// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	  	var floor = Math.floor;
	  	var highSurrogate = function(codePoint) {
	  		return parseInt(
	  			floor((codePoint - 0x10000) / 0x400) + HIGH_SURROGATE_MIN,
	  			10
	  		);
	  	};
	
	  	var lowSurrogate = function(codePoint) {
	  		return parseInt(
	  			(codePoint - 0x10000) % 0x400 + LOW_SURROGATE_MIN,
	  			10
	  		);
	  	};
	
	  	var stringFromCharCode = String.fromCharCode;
	  	var codePointToString = function(codePoint) {
	  		var string;
	  		// https://mathiasbynens.be/notes/javascript-escapes#single
	  		// Note: the `\b` escape sequence for U+0008 BACKSPACE in strings has a
	  		// different meaning in regular expressions (word boundary), so it cannot
	  		// be used here.
	  		if (codePoint == 0x09) {
	  			string = '\\t';
	  		}
	  		// Note: IE < 9 treats `'\v'` as `'v'`, so avoid using it.
	  		// else if (codePoint == 0x0B) {
	  		// 	string = '\\v';
	  		// }
	  		else if (codePoint == 0x0A) {
	  			string = '\\n';
	  		}
	  		else if (codePoint == 0x0C) {
	  			string = '\\f';
	  		}
	  		else if (codePoint == 0x0D) {
	  			string = '\\r';
	  		}
	  		else if (codePoint == 0x5C) {
	  			string = '\\\\';
	  		}
	  		else if (
	  			codePoint == 0x24 ||
	  			(codePoint >= 0x28 && codePoint <= 0x2B) ||
	  			codePoint == 0x2D || codePoint == 0x2E || codePoint == 0x3F ||
	  			(codePoint >= 0x5B && codePoint <= 0x5E) ||
	  			(codePoint >= 0x7B && codePoint <= 0x7D)
	  		) {
	  			// The code point maps to an unsafe printable ASCII character;
	  			// backslash-escape it. Here’s the list of those symbols:
	  			//
	  			//     $()*+-.?[\]^{|}
	  			//
	  			// See #7 for more info.
	  			string = '\\' + stringFromCharCode(codePoint);
	  		}
	  		else if (codePoint >= 0x20 && codePoint <= 0x7E) {
	  			// The code point maps to one of these printable ASCII symbols
	  			// (including the space character):
	  			//
	  			//      !"#%&',/0123456789:;<=>@ABCDEFGHIJKLMNO
	  			//     PQRSTUVWXYZ_`abcdefghijklmnopqrstuvwxyz~
	  			//
	  			// These can safely be used directly.
	  			string = stringFromCharCode(codePoint);
	  		}
	  		else if (codePoint <= 0xFF) {
	  			// https://mathiasbynens.be/notes/javascript-escapes#hexadecimal
	  			string = '\\x' + pad(hex(codePoint), 2);
	  		}
	  		else { // `codePoint <= 0xFFFF` holds true.
	  			// https://mathiasbynens.be/notes/javascript-escapes#unicode
	  			string = '\\u' + pad(hex(codePoint), 4);
	  		}
	
	  		// There’s no need to account for astral symbols / surrogate pairs here,
	  		// since `codePointToString` is private and only used for BMP code points.
	  		// But if that’s what you need, just add an `else` block with this code:
	  		//
	  		//     string = '\\u' + pad(hex(highSurrogate(codePoint)), 4)
	  		//     	+ '\\u' + pad(hex(lowSurrogate(codePoint)), 4);
	
	  		return string;
	  	};
	
	  	var codePointToStringUnicode = function(codePoint) {
	  		if (codePoint <= 0xFFFF) {
	  			return codePointToString(codePoint);
	  		}
	  		return '\\u{' + codePoint.toString(16).toUpperCase() + '}';
	  	};
	
	  	var symbolToCodePoint = function(symbol) {
	  		var length = symbol.length;
	  		var first = symbol.charCodeAt(0);
	  		var second;
	  		if (
	  			first >= HIGH_SURROGATE_MIN && first <= HIGH_SURROGATE_MAX &&
	  			length > 1 // There is a next code unit.
	  		) {
	  			// `first` is a high surrogate, and there is a next character. Assume
	  			// it’s a low surrogate (else it’s invalid usage of Regenerate anyway).
	  			second = symbol.charCodeAt(1);
	  			// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	  			return (first - HIGH_SURROGATE_MIN) * 0x400 +
	  				second - LOW_SURROGATE_MIN + 0x10000;
	  		}
	  		return first;
	  	};
	
	  	var createBMPCharacterClasses = function(data) {
	  		// Iterate over the data per `(start, end)` pair.
	  		var result = '';
	  		var index = 0;
	  		var start;
	  		var end;
	  		var length = data.length;
	  		if (dataIsSingleton(data)) {
	  			return codePointToString(data[0]);
	  		}
	  		while (index < length) {
	  			start = data[index];
	  			end = data[index + 1] - 1; // Note: the `- 1` makes `end` inclusive.
	  			if (start == end) {
	  				result += codePointToString(start);
	  			} else if (start + 1 == end) {
	  				result += codePointToString(start) + codePointToString(end);
	  			} else {
	  				result += codePointToString(start) + '-' + codePointToString(end);
	  			}
	  			index += 2;
	  		}
	  		return '[' + result + ']';
	  	};
	
	  	var createUnicodeCharacterClasses = function(data) {
	  		// Iterate over the data per `(start, end)` pair.
	  		var result = '';
	  		var index = 0;
	  		var start;
	  		var end;
	  		var length = data.length;
	  		if (dataIsSingleton(data)) {
	  			return codePointToStringUnicode(data[0]);
	  		}
	  		while (index < length) {
	  			start = data[index];
	  			end = data[index + 1] - 1; // Note: the `- 1` makes `end` inclusive.
	  			if (start == end) {
	  				result += codePointToStringUnicode(start);
	  			} else if (start + 1 == end) {
	  				result += codePointToStringUnicode(start) + codePointToStringUnicode(end);
	  			} else {
	  				result += codePointToStringUnicode(start) + '-' + codePointToStringUnicode(end);
	  			}
	  			index += 2;
	  		}
	  		return '[' + result + ']';
	  	};
	
	  	var splitAtBMP = function(data) {
	  		// Iterate over the data per `(start, end)` pair.
	  		var loneHighSurrogates = [];
	  		var loneLowSurrogates = [];
	  		var bmp = [];
	  		var astral = [];
	  		var index = 0;
	  		var start;
	  		var end;
	  		var length = data.length;
	  		while (index < length) {
	  			start = data[index];
	  			end = data[index + 1] - 1; // Note: the `- 1` makes `end` inclusive.
	
	  			if (start < HIGH_SURROGATE_MIN) {
	
	  				// The range starts and ends before the high surrogate range.
	  				// E.g. (0, 0x10).
	  				if (end < HIGH_SURROGATE_MIN) {
	  					bmp.push(start, end + 1);
	  				}
	
	  				// The range starts before the high surrogate range and ends within it.
	  				// E.g. (0, 0xD855).
	  				if (end >= HIGH_SURROGATE_MIN && end <= HIGH_SURROGATE_MAX) {
	  					bmp.push(start, HIGH_SURROGATE_MIN);
	  					loneHighSurrogates.push(HIGH_SURROGATE_MIN, end + 1);
	  				}
	
	  				// The range starts before the high surrogate range and ends in the low
	  				// surrogate range. E.g. (0, 0xDCFF).
	  				if (end >= LOW_SURROGATE_MIN && end <= LOW_SURROGATE_MAX) {
	  					bmp.push(start, HIGH_SURROGATE_MIN);
	  					loneHighSurrogates.push(HIGH_SURROGATE_MIN, HIGH_SURROGATE_MAX + 1);
	  					loneLowSurrogates.push(LOW_SURROGATE_MIN, end + 1);
	  				}
	
	  				// The range starts before the high surrogate range and ends after the
	  				// low surrogate range. E.g. (0, 0x10FFFF).
	  				if (end > LOW_SURROGATE_MAX) {
	  					bmp.push(start, HIGH_SURROGATE_MIN);
	  					loneHighSurrogates.push(HIGH_SURROGATE_MIN, HIGH_SURROGATE_MAX + 1);
	  					loneLowSurrogates.push(LOW_SURROGATE_MIN, LOW_SURROGATE_MAX + 1);
	  					if (end <= 0xFFFF) {
	  						bmp.push(LOW_SURROGATE_MAX + 1, end + 1);
	  					} else {
	  						bmp.push(LOW_SURROGATE_MAX + 1, 0xFFFF + 1);
	  						astral.push(0xFFFF + 1, end + 1);
	  					}
	  				}
	
	  			} else if (start >= HIGH_SURROGATE_MIN && start <= HIGH_SURROGATE_MAX) {
	
	  				// The range starts and ends in the high surrogate range.
	  				// E.g. (0xD855, 0xD866).
	  				if (end >= HIGH_SURROGATE_MIN && end <= HIGH_SURROGATE_MAX) {
	  					loneHighSurrogates.push(start, end + 1);
	  				}
	
	  				// The range starts in the high surrogate range and ends in the low
	  				// surrogate range. E.g. (0xD855, 0xDCFF).
	  				if (end >= LOW_SURROGATE_MIN && end <= LOW_SURROGATE_MAX) {
	  					loneHighSurrogates.push(start, HIGH_SURROGATE_MAX + 1);
	  					loneLowSurrogates.push(LOW_SURROGATE_MIN, end + 1);
	  				}
	
	  				// The range starts in the high surrogate range and ends after the low
	  				// surrogate range. E.g. (0xD855, 0x10FFFF).
	  				if (end > LOW_SURROGATE_MAX) {
	  					loneHighSurrogates.push(start, HIGH_SURROGATE_MAX + 1);
	  					loneLowSurrogates.push(LOW_SURROGATE_MIN, LOW_SURROGATE_MAX + 1);
	  					if (end <= 0xFFFF) {
	  						bmp.push(LOW_SURROGATE_MAX + 1, end + 1);
	  					} else {
	  						bmp.push(LOW_SURROGATE_MAX + 1, 0xFFFF + 1);
	  						astral.push(0xFFFF + 1, end + 1);
	  					}
	  				}
	
	  			} else if (start >= LOW_SURROGATE_MIN && start <= LOW_SURROGATE_MAX) {
	
	  				// The range starts and ends in the low surrogate range.
	  				// E.g. (0xDCFF, 0xDDFF).
	  				if (end >= LOW_SURROGATE_MIN && end <= LOW_SURROGATE_MAX) {
	  					loneLowSurrogates.push(start, end + 1);
	  				}
	
	  				// The range starts in the low surrogate range and ends after the low
	  				// surrogate range. E.g. (0xDCFF, 0x10FFFF).
	  				if (end > LOW_SURROGATE_MAX) {
	  					loneLowSurrogates.push(start, LOW_SURROGATE_MAX + 1);
	  					if (end <= 0xFFFF) {
	  						bmp.push(LOW_SURROGATE_MAX + 1, end + 1);
	  					} else {
	  						bmp.push(LOW_SURROGATE_MAX + 1, 0xFFFF + 1);
	  						astral.push(0xFFFF + 1, end + 1);
	  					}
	  				}
	
	  			} else if (start > LOW_SURROGATE_MAX && start <= 0xFFFF) {
	
	  				// The range starts and ends after the low surrogate range.
	  				// E.g. (0xFFAA, 0x10FFFF).
	  				if (end <= 0xFFFF) {
	  					bmp.push(start, end + 1);
	  				} else {
	  					bmp.push(start, 0xFFFF + 1);
	  					astral.push(0xFFFF + 1, end + 1);
	  				}
	
	  			} else {
	
	  				// The range starts and ends in the astral range.
	  				astral.push(start, end + 1);
	
	  			}
	
	  			index += 2;
	  		}
	  		return {
	  			'loneHighSurrogates': loneHighSurrogates,
	  			'loneLowSurrogates': loneLowSurrogates,
	  			'bmp': bmp,
	  			'astral': astral
	  		};
	  	};
	
	  	var optimizeSurrogateMappings = function(surrogateMappings) {
	  		var result = [];
	  		var tmpLow = [];
	  		var addLow = false;
	  		var mapping;
	  		var nextMapping;
	  		var highSurrogates;
	  		var lowSurrogates;
	  		var nextHighSurrogates;
	  		var nextLowSurrogates;
	  		var index = -1;
	  		var length = surrogateMappings.length;
	  		while (++index < length) {
	  			mapping = surrogateMappings[index];
	  			nextMapping = surrogateMappings[index + 1];
	  			if (!nextMapping) {
	  				result.push(mapping);
	  				continue;
	  			}
	  			highSurrogates = mapping[0];
	  			lowSurrogates = mapping[1];
	  			nextHighSurrogates = nextMapping[0];
	  			nextLowSurrogates = nextMapping[1];
	
	  			// Check for identical high surrogate ranges.
	  			tmpLow = lowSurrogates;
	  			while (
	  				nextHighSurrogates &&
	  				highSurrogates[0] == nextHighSurrogates[0] &&
	  				highSurrogates[1] == nextHighSurrogates[1]
	  			) {
	  				// Merge with the next item.
	  				if (dataIsSingleton(nextLowSurrogates)) {
	  					tmpLow = dataAdd(tmpLow, nextLowSurrogates[0]);
	  				} else {
	  					tmpLow = dataAddRange(
	  						tmpLow,
	  						nextLowSurrogates[0],
	  						nextLowSurrogates[1] - 1
	  					);
	  				}
	  				++index;
	  				mapping = surrogateMappings[index];
	  				highSurrogates = mapping[0];
	  				lowSurrogates = mapping[1];
	  				nextMapping = surrogateMappings[index + 1];
	  				nextHighSurrogates = nextMapping && nextMapping[0];
	  				nextLowSurrogates = nextMapping && nextMapping[1];
	  				addLow = true;
	  			}
	  			result.push([
	  				highSurrogates,
	  				addLow ? tmpLow : lowSurrogates
	  			]);
	  			addLow = false;
	  		}
	  		return optimizeByLowSurrogates(result);
	  	};
	
	  	var optimizeByLowSurrogates = function(surrogateMappings) {
	  		if (surrogateMappings.length == 1) {
	  			return surrogateMappings;
	  		}
	  		var index = -1;
	  		var innerIndex = -1;
	  		while (++index < surrogateMappings.length) {
	  			var mapping = surrogateMappings[index];
	  			var lowSurrogates = mapping[1];
	  			var lowSurrogateStart = lowSurrogates[0];
	  			var lowSurrogateEnd = lowSurrogates[1];
	  			innerIndex = index; // Note: the loop starts at the next index.
	  			while (++innerIndex < surrogateMappings.length) {
	  				var otherMapping = surrogateMappings[innerIndex];
	  				var otherLowSurrogates = otherMapping[1];
	  				var otherLowSurrogateStart = otherLowSurrogates[0];
	  				var otherLowSurrogateEnd = otherLowSurrogates[1];
	  				if (
	  					lowSurrogateStart == otherLowSurrogateStart &&
	  					lowSurrogateEnd == otherLowSurrogateEnd
	  				) {
	  					// Add the code points in the other item to this one.
	  					if (dataIsSingleton(otherMapping[0])) {
	  						mapping[0] = dataAdd(mapping[0], otherMapping[0][0]);
	  					} else {
	  						mapping[0] = dataAddRange(
	  							mapping[0],
	  							otherMapping[0][0],
	  							otherMapping[0][1] - 1
	  						);
	  					}
	  					// Remove the other, now redundant, item.
	  					surrogateMappings.splice(innerIndex, 1);
	  					--innerIndex;
	  				}
	  			}
	  		}
	  		return surrogateMappings;
	  	};
	
	  	var surrogateSet = function(data) {
	  		// Exit early if `data` is an empty set.
	  		if (!data.length) {
	  			return [];
	  		}
	
	  		// Iterate over the data per `(start, end)` pair.
	  		var index = 0;
	  		var start;
	  		var end;
	  		var startHigh;
	  		var startLow;
	  		var prevStartHigh = 0;
	  		var prevEndHigh = 0;
	  		var tmpLow = [];
	  		var endHigh;
	  		var endLow;
	  		var surrogateMappings = [];
	  		var length = data.length;
	  		var dataHigh = [];
	  		while (index < length) {
	  			start = data[index];
	  			end = data[index + 1] - 1;
	
	  			startHigh = highSurrogate(start);
	  			startLow = lowSurrogate(start);
	  			endHigh = highSurrogate(end);
	  			endLow = lowSurrogate(end);
	
	  			var startsWithLowestLowSurrogate = startLow == LOW_SURROGATE_MIN;
	  			var endsWithHighestLowSurrogate = endLow == LOW_SURROGATE_MAX;
	  			var complete = false;
	
	  			// Append the previous high-surrogate-to-low-surrogate mappings.
	  			// Step 1: `(startHigh, startLow)` to `(startHigh, LOW_SURROGATE_MAX)`.
	  			if (
	  				startHigh == endHigh ||
	  				startsWithLowestLowSurrogate && endsWithHighestLowSurrogate
	  			) {
	  				surrogateMappings.push([
	  					[startHigh, endHigh + 1],
	  					[startLow, endLow + 1]
	  				]);
	  				complete = true;
	  			} else {
	  				surrogateMappings.push([
	  					[startHigh, startHigh + 1],
	  					[startLow, LOW_SURROGATE_MAX + 1]
	  				]);
	  			}
	
	  			// Step 2: `(startHigh + 1, LOW_SURROGATE_MIN)` to
	  			// `(endHigh - 1, LOW_SURROGATE_MAX)`.
	  			if (!complete && startHigh + 1 < endHigh) {
	  				if (endsWithHighestLowSurrogate) {
	  					// Combine step 2 and step 3.
	  					surrogateMappings.push([
	  						[startHigh + 1, endHigh + 1],
	  						[LOW_SURROGATE_MIN, endLow + 1]
	  					]);
	  					complete = true;
	  				} else {
	  					surrogateMappings.push([
	  						[startHigh + 1, endHigh],
	  						[LOW_SURROGATE_MIN, LOW_SURROGATE_MAX + 1]
	  					]);
	  				}
	  			}
	
	  			// Step 3. `(endHigh, LOW_SURROGATE_MIN)` to `(endHigh, endLow)`.
	  			if (!complete) {
	  				surrogateMappings.push([
	  					[endHigh, endHigh + 1],
	  					[LOW_SURROGATE_MIN, endLow + 1]
	  				]);
	  			}
	
	  			prevStartHigh = startHigh;
	  			prevEndHigh = endHigh;
	
	  			index += 2;
	  		}
	
	  		// The format of `surrogateMappings` is as follows:
	  		//
	  		//     [ surrogateMapping1, surrogateMapping2 ]
	  		//
	  		// i.e.:
	  		//
	  		//     [
	  		//       [ highSurrogates1, lowSurrogates1 ],
	  		//       [ highSurrogates2, lowSurrogates2 ]
	  		//     ]
	  		return optimizeSurrogateMappings(surrogateMappings);
	  	};
	
	  	var createSurrogateCharacterClasses = function(surrogateMappings) {
	  		var result = [];
	  		forEach(surrogateMappings, function(surrogateMapping) {
	  			var highSurrogates = surrogateMapping[0];
	  			var lowSurrogates = surrogateMapping[1];
	  			result.push(
	  				createBMPCharacterClasses(highSurrogates) +
	  				createBMPCharacterClasses(lowSurrogates)
	  			);
	  		});
	  		return result.join('|');
	  	};
	
	  	var createCharacterClassesFromData = function(data, bmpOnly, hasUnicodeFlag) {
	  		if (hasUnicodeFlag) {
	  			return createUnicodeCharacterClasses(data);
	  		}
	  		var result = [];
	
	  		var parts = splitAtBMP(data);
	  		var loneHighSurrogates = parts.loneHighSurrogates;
	  		var loneLowSurrogates = parts.loneLowSurrogates;
	  		var bmp = parts.bmp;
	  		var astral = parts.astral;
	  		var hasAstral = !dataIsEmpty(parts.astral);
	  		var hasLoneHighSurrogates = !dataIsEmpty(loneHighSurrogates);
	  		var hasLoneLowSurrogates = !dataIsEmpty(loneLowSurrogates);
	
	  		var surrogateMappings = surrogateSet(astral);
	
	  		if (bmpOnly) {
	  			bmp = dataAddData(bmp, loneHighSurrogates);
	  			hasLoneHighSurrogates = false;
	  			bmp = dataAddData(bmp, loneLowSurrogates);
	  			hasLoneLowSurrogates = false;
	  		}
	
	  		if (!dataIsEmpty(bmp)) {
	  			// The data set contains BMP code points that are not high surrogates
	  			// needed for astral code points in the set.
	  			result.push(createBMPCharacterClasses(bmp));
	  		}
	  		if (surrogateMappings.length) {
	  			// The data set contains astral code points; append character classes
	  			// based on their surrogate pairs.
	  			result.push(createSurrogateCharacterClasses(surrogateMappings));
	  		}
	  		// https://gist.github.com/mathiasbynens/bbe7f870208abcfec860
	  		if (hasLoneHighSurrogates) {
	  			result.push(
	  				createBMPCharacterClasses(loneHighSurrogates) +
	  				// Make sure the high surrogates aren’t part of a surrogate pair.
	  				'(?![\\uDC00-\\uDFFF])'
	  			);
	  		}
	  		if (hasLoneLowSurrogates) {
	  			result.push(
	  				// It is not possible to accurately assert the low surrogates aren’t
	  				// part of a surrogate pair, since JavaScript regular expressions do
	  				// not support lookbehind.
	  				'(?:[^\\uD800-\\uDBFF]|^)' +
	  				createBMPCharacterClasses(loneLowSurrogates)
	  			);
	  		}
	  		return result.join('|');
	  	};
	
	  	/*--------------------------------------------------------------------------*/
	
	  	// `regenerate` can be used as a constructor (and new methods can be added to
	  	// its prototype) but also as a regular function, the latter of which is the
	  	// documented and most common usage. For that reason, it’s not capitalized.
	  	var regenerate = function(value) {
	  		if (arguments.length > 1) {
	  			value = slice.call(arguments);
	  		}
	  		if (this instanceof regenerate) {
	  			this.data = [];
	  			return value ? this.add(value) : this;
	  		}
	  		return (new regenerate).add(value);
	  	};
	
	  	regenerate.version = '1.3.1';
	
	  	var proto = regenerate.prototype;
	  	extend(proto, {
	  		'add': function(value) {
	  			var $this = this;
	  			if (value == null) {
	  				return $this;
	  			}
	  			if (value instanceof regenerate) {
	  				// Allow passing other Regenerate instances.
	  				$this.data = dataAddData($this.data, value.data);
	  				return $this;
	  			}
	  			if (arguments.length > 1) {
	  				value = slice.call(arguments);
	  			}
	  			if (isArray(value)) {
	  				forEach(value, function(item) {
	  					$this.add(item);
	  				});
	  				return $this;
	  			}
	  			$this.data = dataAdd(
	  				$this.data,
	  				isNumber(value) ? value : symbolToCodePoint(value)
	  			);
	  			return $this;
	  		},
	  		'remove': function(value) {
	  			var $this = this;
	  			if (value == null) {
	  				return $this;
	  			}
	  			if (value instanceof regenerate) {
	  				// Allow passing other Regenerate instances.
	  				$this.data = dataRemoveData($this.data, value.data);
	  				return $this;
	  			}
	  			if (arguments.length > 1) {
	  				value = slice.call(arguments);
	  			}
	  			if (isArray(value)) {
	  				forEach(value, function(item) {
	  					$this.remove(item);
	  				});
	  				return $this;
	  			}
	  			$this.data = dataRemove(
	  				$this.data,
	  				isNumber(value) ? value : symbolToCodePoint(value)
	  			);
	  			return $this;
	  		},
	  		'addRange': function(start, end) {
	  			var $this = this;
	  			$this.data = dataAddRange($this.data,
	  				isNumber(start) ? start : symbolToCodePoint(start),
	  				isNumber(end) ? end : symbolToCodePoint(end)
	  			);
	  			return $this;
	  		},
	  		'removeRange': function(start, end) {
	  			var $this = this;
	  			var startCodePoint = isNumber(start) ? start : symbolToCodePoint(start);
	  			var endCodePoint = isNumber(end) ? end : symbolToCodePoint(end);
	  			$this.data = dataRemoveRange(
	  				$this.data,
	  				startCodePoint,
	  				endCodePoint
	  			);
	  			return $this;
	  		},
	  		'intersection': function(argument) {
	  			var $this = this;
	  			// Allow passing other Regenerate instances.
	  			// TODO: Optimize this by writing and using `dataIntersectionData()`.
	  			var array = argument instanceof regenerate ?
	  				dataToArray(argument.data) :
	  				argument;
	  			$this.data = dataIntersection($this.data, array);
	  			return $this;
	  		},
	  		'contains': function(codePoint) {
	  			return dataContains(
	  				this.data,
	  				isNumber(codePoint) ? codePoint : symbolToCodePoint(codePoint)
	  			);
	  		},
	  		'clone': function() {
	  			var set = new regenerate;
	  			set.data = this.data.slice(0);
	  			return set;
	  		},
	  		'toString': function(options) {
	  			var result = createCharacterClassesFromData(
	  				this.data,
	  				options ? options.bmpOnly : false,
	  				options ? options.hasUnicodeFlag : false
	  			);
	  			if (!result) {
	  				// For an empty set, return something that can be inserted `/here/` to
	  				// form a valid regular expression. Avoid `(?:)` since that matches the
	  				// empty string.
	  				return '[]';
	  			}
	  			// Use `\0` instead of `\x00` where possible.
	  			return result.replace(regexNull, '\\0$1');
	  		},
	  		'toRegExp': function(flags) {
	  			var pattern = this.toString(
	  				flags && flags.indexOf('u') != -1 ?
	  					{ 'hasUnicodeFlag': true } :
	  					null
	  			);
	  			return RegExp(pattern, flags || '');
	  		},
	  		'valueOf': function() { // Note: `valueOf` is aliased as `toArray`.
	  			return dataToArray(this.data);
	  		}
	  	});
	
	  	proto.toArray = proto.valueOf;
	
	  	// Some AMD build optimizers, like r.js, check for specific condition patterns
	  	// like the following:
	  	if (
	  		true
	  	) {
	  		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	  			return regenerate;
	  		}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  	}	else if (freeExports && !freeExports.nodeType) {
	  		if (freeModule) { // in Node.js, io.js, or RingoJS v0.8.0+
	  			freeModule.exports = regenerate;
	  		} else { // in Narwhal or RingoJS v0.7.0-
	  			freeExports.regenerate = regenerate;
	  		}
	  	} else { // in Rhino or a web browser
	  		root.regenerate = regenerate;
	  	}
	
	  }(__commonjs_global));
	  });
	
	  var require$$0$2 = (regenerate && typeof regenerate === 'object' && 'default' in regenerate ? regenerate['default'] : regenerate);
	
	  var characterClassEscapeSets = __commonjs(function (module, exports) {
	  // Generated by `/scripts/character-class-escape-sets.js`. Do not edit.
	  var regenerate = require$$0$2;
	
	  exports.REGULAR = {
	  	'd': regenerate()
	  		.addRange(0x30, 0x39),
	  	'D': regenerate()
	  		.addRange(0x0, 0x2F)
	  		.addRange(0x3A, 0xFFFF),
	  	's': regenerate(0x20, 0xA0, 0x1680, 0x202F, 0x205F, 0x3000, 0xFEFF)
	  		.addRange(0x9, 0xD)
	  		.addRange(0x2000, 0x200A)
	  		.addRange(0x2028, 0x2029),
	  	'S': regenerate()
	  		.addRange(0x0, 0x8)
	  		.addRange(0xE, 0x1F)
	  		.addRange(0x21, 0x9F)
	  		.addRange(0xA1, 0x167F)
	  		.addRange(0x1681, 0x1FFF)
	  		.addRange(0x200B, 0x2027)
	  		.addRange(0x202A, 0x202E)
	  		.addRange(0x2030, 0x205E)
	  		.addRange(0x2060, 0x2FFF)
	  		.addRange(0x3001, 0xFEFE)
	  		.addRange(0xFF00, 0xFFFF),
	  	'w': regenerate(0x5F)
	  		.addRange(0x30, 0x39)
	  		.addRange(0x41, 0x5A)
	  		.addRange(0x61, 0x7A),
	  	'W': regenerate(0x60)
	  		.addRange(0x0, 0x2F)
	  		.addRange(0x3A, 0x40)
	  		.addRange(0x5B, 0x5E)
	  		.addRange(0x7B, 0xFFFF)
	  };
	
	  exports.UNICODE = {
	  	'd': regenerate()
	  		.addRange(0x30, 0x39),
	  	'D': regenerate()
	  		.addRange(0x0, 0x2F)
	  		.addRange(0x3A, 0x10FFFF),
	  	's': regenerate(0x20, 0xA0, 0x1680, 0x202F, 0x205F, 0x3000, 0xFEFF)
	  		.addRange(0x9, 0xD)
	  		.addRange(0x2000, 0x200A)
	  		.addRange(0x2028, 0x2029),
	  	'S': regenerate()
	  		.addRange(0x0, 0x8)
	  		.addRange(0xE, 0x1F)
	  		.addRange(0x21, 0x9F)
	  		.addRange(0xA1, 0x167F)
	  		.addRange(0x1681, 0x1FFF)
	  		.addRange(0x200B, 0x2027)
	  		.addRange(0x202A, 0x202E)
	  		.addRange(0x2030, 0x205E)
	  		.addRange(0x2060, 0x2FFF)
	  		.addRange(0x3001, 0xFEFE)
	  		.addRange(0xFF00, 0x10FFFF),
	  	'w': regenerate(0x5F)
	  		.addRange(0x30, 0x39)
	  		.addRange(0x41, 0x5A)
	  		.addRange(0x61, 0x7A),
	  	'W': regenerate(0x60)
	  		.addRange(0x0, 0x2F)
	  		.addRange(0x3A, 0x40)
	  		.addRange(0x5B, 0x5E)
	  		.addRange(0x7B, 0x10FFFF)
	  };
	
	  exports.UNICODE_IGNORE_CASE = {
	  	'd': regenerate()
	  		.addRange(0x30, 0x39),
	  	'D': regenerate()
	  		.addRange(0x0, 0x2F)
	  		.addRange(0x3A, 0x10FFFF),
	  	's': regenerate(0x20, 0xA0, 0x1680, 0x202F, 0x205F, 0x3000, 0xFEFF)
	  		.addRange(0x9, 0xD)
	  		.addRange(0x2000, 0x200A)
	  		.addRange(0x2028, 0x2029),
	  	'S': regenerate()
	  		.addRange(0x0, 0x8)
	  		.addRange(0xE, 0x1F)
	  		.addRange(0x21, 0x9F)
	  		.addRange(0xA1, 0x167F)
	  		.addRange(0x1681, 0x1FFF)
	  		.addRange(0x200B, 0x2027)
	  		.addRange(0x202A, 0x202E)
	  		.addRange(0x2030, 0x205E)
	  		.addRange(0x2060, 0x2FFF)
	  		.addRange(0x3001, 0xFEFE)
	  		.addRange(0xFF00, 0x10FFFF),
	  	'w': regenerate(0x5F, 0x17F, 0x212A)
	  		.addRange(0x30, 0x39)
	  		.addRange(0x41, 0x5A)
	  		.addRange(0x61, 0x7A),
	  	'W': regenerate(0x4B, 0x53, 0x60)
	  		.addRange(0x0, 0x2F)
	  		.addRange(0x3A, 0x40)
	  		.addRange(0x5B, 0x5E)
	  		.addRange(0x7B, 0x10FFFF)
	  };
	  });
	
	  var require$$0$1 = (characterClassEscapeSets && typeof characterClassEscapeSets === 'object' && 'default' in characterClassEscapeSets ? characterClassEscapeSets['default'] : characterClassEscapeSets);
	
	  var require$$1 = {
	  	"75": 8490,
	  	"83": 383,
	  	"107": 8490,
	  	"115": 383,
	  	"181": 924,
	  	"197": 8491,
	  	"383": 83,
	  	"452": 453,
	  	"453": 452,
	  	"455": 456,
	  	"456": 455,
	  	"458": 459,
	  	"459": 458,
	  	"497": 498,
	  	"498": 497,
	  	"837": 8126,
	  	"914": 976,
	  	"917": 1013,
	  	"920": 1012,
	  	"921": 8126,
	  	"922": 1008,
	  	"924": 181,
	  	"928": 982,
	  	"929": 1009,
	  	"931": 962,
	  	"934": 981,
	  	"937": 8486,
	  	"962": 931,
	  	"976": 914,
	  	"977": 1012,
	  	"981": 934,
	  	"982": 928,
	  	"1008": 922,
	  	"1009": 929,
	  	"1012": [920,977],
	  	"1013": 917,
	  	"7776": 7835,
	  	"7835": 7776,
	  	"8126": [837,921],
	  	"8486": 937,
	  	"8490": 75,
	  	"8491": 197,
	  	"66560": 66600,
	  	"66561": 66601,
	  	"66562": 66602,
	  	"66563": 66603,
	  	"66564": 66604,
	  	"66565": 66605,
	  	"66566": 66606,
	  	"66567": 66607,
	  	"66568": 66608,
	  	"66569": 66609,
	  	"66570": 66610,
	  	"66571": 66611,
	  	"66572": 66612,
	  	"66573": 66613,
	  	"66574": 66614,
	  	"66575": 66615,
	  	"66576": 66616,
	  	"66577": 66617,
	  	"66578": 66618,
	  	"66579": 66619,
	  	"66580": 66620,
	  	"66581": 66621,
	  	"66582": 66622,
	  	"66583": 66623,
	  	"66584": 66624,
	  	"66585": 66625,
	  	"66586": 66626,
	  	"66587": 66627,
	  	"66588": 66628,
	  	"66589": 66629,
	  	"66590": 66630,
	  	"66591": 66631,
	  	"66592": 66632,
	  	"66593": 66633,
	  	"66594": 66634,
	  	"66595": 66635,
	  	"66596": 66636,
	  	"66597": 66637,
	  	"66598": 66638,
	  	"66599": 66639,
	  	"66600": 66560,
	  	"66601": 66561,
	  	"66602": 66562,
	  	"66603": 66563,
	  	"66604": 66564,
	  	"66605": 66565,
	  	"66606": 66566,
	  	"66607": 66567,
	  	"66608": 66568,
	  	"66609": 66569,
	  	"66610": 66570,
	  	"66611": 66571,
	  	"66612": 66572,
	  	"66613": 66573,
	  	"66614": 66574,
	  	"66615": 66575,
	  	"66616": 66576,
	  	"66617": 66577,
	  	"66618": 66578,
	  	"66619": 66579,
	  	"66620": 66580,
	  	"66621": 66581,
	  	"66622": 66582,
	  	"66623": 66583,
	  	"66624": 66584,
	  	"66625": 66585,
	  	"66626": 66586,
	  	"66627": 66587,
	  	"66628": 66588,
	  	"66629": 66589,
	  	"66630": 66590,
	  	"66631": 66591,
	  	"66632": 66592,
	  	"66633": 66593,
	  	"66634": 66594,
	  	"66635": 66595,
	  	"66636": 66596,
	  	"66637": 66597,
	  	"66638": 66598,
	  	"66639": 66599,
	  	"68736": 68800,
	  	"68737": 68801,
	  	"68738": 68802,
	  	"68739": 68803,
	  	"68740": 68804,
	  	"68741": 68805,
	  	"68742": 68806,
	  	"68743": 68807,
	  	"68744": 68808,
	  	"68745": 68809,
	  	"68746": 68810,
	  	"68747": 68811,
	  	"68748": 68812,
	  	"68749": 68813,
	  	"68750": 68814,
	  	"68751": 68815,
	  	"68752": 68816,
	  	"68753": 68817,
	  	"68754": 68818,
	  	"68755": 68819,
	  	"68756": 68820,
	  	"68757": 68821,
	  	"68758": 68822,
	  	"68759": 68823,
	  	"68760": 68824,
	  	"68761": 68825,
	  	"68762": 68826,
	  	"68763": 68827,
	  	"68764": 68828,
	  	"68765": 68829,
	  	"68766": 68830,
	  	"68767": 68831,
	  	"68768": 68832,
	  	"68769": 68833,
	  	"68770": 68834,
	  	"68771": 68835,
	  	"68772": 68836,
	  	"68773": 68837,
	  	"68774": 68838,
	  	"68775": 68839,
	  	"68776": 68840,
	  	"68777": 68841,
	  	"68778": 68842,
	  	"68779": 68843,
	  	"68780": 68844,
	  	"68781": 68845,
	  	"68782": 68846,
	  	"68783": 68847,
	  	"68784": 68848,
	  	"68785": 68849,
	  	"68786": 68850,
	  	"68800": 68736,
	  	"68801": 68737,
	  	"68802": 68738,
	  	"68803": 68739,
	  	"68804": 68740,
	  	"68805": 68741,
	  	"68806": 68742,
	  	"68807": 68743,
	  	"68808": 68744,
	  	"68809": 68745,
	  	"68810": 68746,
	  	"68811": 68747,
	  	"68812": 68748,
	  	"68813": 68749,
	  	"68814": 68750,
	  	"68815": 68751,
	  	"68816": 68752,
	  	"68817": 68753,
	  	"68818": 68754,
	  	"68819": 68755,
	  	"68820": 68756,
	  	"68821": 68757,
	  	"68822": 68758,
	  	"68823": 68759,
	  	"68824": 68760,
	  	"68825": 68761,
	  	"68826": 68762,
	  	"68827": 68763,
	  	"68828": 68764,
	  	"68829": 68765,
	  	"68830": 68766,
	  	"68831": 68767,
	  	"68832": 68768,
	  	"68833": 68769,
	  	"68834": 68770,
	  	"68835": 68771,
	  	"68836": 68772,
	  	"68837": 68773,
	  	"68838": 68774,
	  	"68839": 68775,
	  	"68840": 68776,
	  	"68841": 68777,
	  	"68842": 68778,
	  	"68843": 68779,
	  	"68844": 68780,
	  	"68845": 68781,
	  	"68846": 68782,
	  	"68847": 68783,
	  	"68848": 68784,
	  	"68849": 68785,
	  	"68850": 68786,
	  	"71840": 71872,
	  	"71841": 71873,
	  	"71842": 71874,
	  	"71843": 71875,
	  	"71844": 71876,
	  	"71845": 71877,
	  	"71846": 71878,
	  	"71847": 71879,
	  	"71848": 71880,
	  	"71849": 71881,
	  	"71850": 71882,
	  	"71851": 71883,
	  	"71852": 71884,
	  	"71853": 71885,
	  	"71854": 71886,
	  	"71855": 71887,
	  	"71856": 71888,
	  	"71857": 71889,
	  	"71858": 71890,
	  	"71859": 71891,
	  	"71860": 71892,
	  	"71861": 71893,
	  	"71862": 71894,
	  	"71863": 71895,
	  	"71864": 71896,
	  	"71865": 71897,
	  	"71866": 71898,
	  	"71867": 71899,
	  	"71868": 71900,
	  	"71869": 71901,
	  	"71870": 71902,
	  	"71871": 71903,
	  	"71872": 71840,
	  	"71873": 71841,
	  	"71874": 71842,
	  	"71875": 71843,
	  	"71876": 71844,
	  	"71877": 71845,
	  	"71878": 71846,
	  	"71879": 71847,
	  	"71880": 71848,
	  	"71881": 71849,
	  	"71882": 71850,
	  	"71883": 71851,
	  	"71884": 71852,
	  	"71885": 71853,
	  	"71886": 71854,
	  	"71887": 71855,
	  	"71888": 71856,
	  	"71889": 71857,
	  	"71890": 71858,
	  	"71891": 71859,
	  	"71892": 71860,
	  	"71893": 71861,
	  	"71894": 71862,
	  	"71895": 71863,
	  	"71896": 71864,
	  	"71897": 71865,
	  	"71898": 71866,
	  	"71899": 71867,
	  	"71900": 71868,
	  	"71901": 71869,
	  	"71902": 71870,
	  	"71903": 71871
	  };
	
	  var parser = __commonjs(function (module) {
	  // regjsparser
	  //
	  // ==================================================================
	  //
	  // See ECMA-262 Standard: 15.10.1
	  //
	  // NOTE: The ECMA-262 standard uses the term "Assertion" for /^/. Here the
	  //   term "Anchor" is used.
	  //
	  // Pattern ::
	  //      Disjunction
	  //
	  // Disjunction ::
	  //      Alternative
	  //      Alternative | Disjunction
	  //
	  // Alternative ::
	  //      [empty]
	  //      Alternative Term
	  //
	  // Term ::
	  //      Anchor
	  //      Atom
	  //      Atom Quantifier
	  //
	  // Anchor ::
	  //      ^
	  //      $
	  //      \ b
	  //      \ B
	  //      ( ? = Disjunction )
	  //      ( ? ! Disjunction )
	  //
	  // Quantifier ::
	  //      QuantifierPrefix
	  //      QuantifierPrefix ?
	  //
	  // QuantifierPrefix ::
	  //      *
	  //      +
	  //      ?
	  //      { DecimalDigits }
	  //      { DecimalDigits , }
	  //      { DecimalDigits , DecimalDigits }
	  //
	  // Atom ::
	  //      PatternCharacter
	  //      .
	  //      \ AtomEscape
	  //      CharacterClass
	  //      ( Disjunction )
	  //      ( ? : Disjunction )
	  //
	  // PatternCharacter ::
	  //      SourceCharacter but not any of: ^ $ \ . * + ? ( ) [ ] { } |
	  //
	  // AtomEscape ::
	  //      DecimalEscape
	  //      CharacterEscape
	  //      CharacterClassEscape
	  //
	  // CharacterEscape[U] ::
	  //      ControlEscape
	  //      c ControlLetter
	  //      HexEscapeSequence
	  //      RegExpUnicodeEscapeSequence[?U] (ES6)
	  //      IdentityEscape[?U]
	  //
	  // ControlEscape ::
	  //      one of f n r t v
	  // ControlLetter ::
	  //      one of
	  //          a b c d e f g h i j k l m n o p q r s t u v w x y z
	  //          A B C D E F G H I J K L M N O P Q R S T U V W X Y Z
	  //
	  // IdentityEscape ::
	  //      SourceCharacter but not IdentifierPart
	  //      <ZWJ>
	  //      <ZWNJ>
	  //
	  // DecimalEscape ::
	  //      DecimalIntegerLiteral [lookahead ∉ DecimalDigit]
	  //
	  // CharacterClassEscape ::
	  //      one of d D s S w W
	  //
	  // CharacterClass ::
	  //      [ [lookahead ∉ {^}] ClassRanges ]
	  //      [ ^ ClassRanges ]
	  //
	  // ClassRanges ::
	  //      [empty]
	  //      NonemptyClassRanges
	  //
	  // NonemptyClassRanges ::
	  //      ClassAtom
	  //      ClassAtom NonemptyClassRangesNoDash
	  //      ClassAtom - ClassAtom ClassRanges
	  //
	  // NonemptyClassRangesNoDash ::
	  //      ClassAtom
	  //      ClassAtomNoDash NonemptyClassRangesNoDash
	  //      ClassAtomNoDash - ClassAtom ClassRanges
	  //
	  // ClassAtom ::
	  //      -
	  //      ClassAtomNoDash
	  //
	  // ClassAtomNoDash ::
	  //      SourceCharacter but not one of \ or ] or -
	  //      \ ClassEscape
	  //
	  // ClassEscape ::
	  //      DecimalEscape
	  //      b
	  //      CharacterEscape
	  //      CharacterClassEscape
	
	  (function() {
	
	    function parse(str, flags) {
	      function addRaw(node) {
	        node.raw = str.substring(node.range[0], node.range[1]);
	        return node;
	      }
	
	      function updateRawStart(node, start) {
	        node.range[0] = start;
	        return addRaw(node);
	      }
	
	      function createAnchor(kind, rawLength) {
	        return addRaw({
	          type: 'anchor',
	          kind: kind,
	          range: [
	            pos - rawLength,
	            pos
	          ]
	        });
	      }
	
	      function createValue(kind, codePoint, from, to) {
	        return addRaw({
	          type: 'value',
	          kind: kind,
	          codePoint: codePoint,
	          range: [from, to]
	        });
	      }
	
	      function createEscaped(kind, codePoint, value, fromOffset) {
	        fromOffset = fromOffset || 0;
	        return createValue(kind, codePoint, pos - (value.length + fromOffset), pos);
	      }
	
	      function createCharacter(matches) {
	        var _char = matches[0];
	        var first = _char.charCodeAt(0);
	        if (hasUnicodeFlag) {
	          var second;
	          if (_char.length === 1 && first >= 0xD800 && first <= 0xDBFF) {
	            second = lookahead().charCodeAt(0);
	            if (second >= 0xDC00 && second <= 0xDFFF) {
	              // Unicode surrogate pair
	              pos++;
	              return createValue(
	                  'symbol',
	                  (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000,
	                  pos - 2, pos);
	            }
	          }
	        }
	        return createValue('symbol', first, pos - 1, pos);
	      }
	
	      function createDisjunction(alternatives, from, to) {
	        return addRaw({
	          type: 'disjunction',
	          body: alternatives,
	          range: [
	            from,
	            to
	          ]
	        });
	      }
	
	      function createDot() {
	        return addRaw({
	          type: 'dot',
	          range: [
	            pos - 1,
	            pos
	          ]
	        });
	      }
	
	      function createCharacterClassEscape(value) {
	        return addRaw({
	          type: 'characterClassEscape',
	          value: value,
	          range: [
	            pos - 2,
	            pos
	          ]
	        });
	      }
	
	      function createReference(matchIndex) {
	        return addRaw({
	          type: 'reference',
	          matchIndex: parseInt(matchIndex, 10),
	          range: [
	            pos - 1 - matchIndex.length,
	            pos
	          ]
	        });
	      }
	
	      function createGroup(behavior, disjunction, from, to) {
	        return addRaw({
	          type: 'group',
	          behavior: behavior,
	          body: disjunction,
	          range: [
	            from,
	            to
	          ]
	        });
	      }
	
	      function createQuantifier(min, max, from, to) {
	        if (to == null) {
	          from = pos - 1;
	          to = pos;
	        }
	
	        return addRaw({
	          type: 'quantifier',
	          min: min,
	          max: max,
	          greedy: true,
	          body: null, // set later on
	          range: [
	            from,
	            to
	          ]
	        });
	      }
	
	      function createAlternative(terms, from, to) {
	        return addRaw({
	          type: 'alternative',
	          body: terms,
	          range: [
	            from,
	            to
	          ]
	        });
	      }
	
	      function createCharacterClass(classRanges, negative, from, to) {
	        return addRaw({
	          type: 'characterClass',
	          body: classRanges,
	          negative: negative,
	          range: [
	            from,
	            to
	          ]
	        });
	      }
	
	      function createClassRange(min, max, from, to) {
	        // See 15.10.2.15:
	        if (min.codePoint > max.codePoint) {
	          bail('invalid range in character class', min.raw + '-' + max.raw, from, to);
	        }
	
	        return addRaw({
	          type: 'characterClassRange',
	          min: min,
	          max: max,
	          range: [
	            from,
	            to
	          ]
	        });
	      }
	
	      function flattenBody(body) {
	        if (body.type === 'alternative') {
	          return body.body;
	        } else {
	          return [body];
	        }
	      }
	
	      function isEmpty(obj) {
	        return obj.type === 'empty';
	      }
	
	      function incr(amount) {
	        amount = (amount || 1);
	        var res = str.substring(pos, pos + amount);
	        pos += (amount || 1);
	        return res;
	      }
	
	      function skip(value) {
	        if (!match(value)) {
	          bail('character', value);
	        }
	      }
	
	      function match(value) {
	        if (str.indexOf(value, pos) === pos) {
	          return incr(value.length);
	        }
	      }
	
	      function lookahead() {
	        return str[pos];
	      }
	
	      function current(value) {
	        return str.indexOf(value, pos) === pos;
	      }
	
	      function next(value) {
	        return str[pos + 1] === value;
	      }
	
	      function matchReg(regExp) {
	        var subStr = str.substring(pos);
	        var res = subStr.match(regExp);
	        if (res) {
	          res.range = [];
	          res.range[0] = pos;
	          incr(res[0].length);
	          res.range[1] = pos;
	        }
	        return res;
	      }
	
	      function parseDisjunction() {
	        // Disjunction ::
	        //      Alternative
	        //      Alternative | Disjunction
	        var res = [], from = pos;
	        res.push(parseAlternative());
	
	        while (match('|')) {
	          res.push(parseAlternative());
	        }
	
	        if (res.length === 1) {
	          return res[0];
	        }
	
	        return createDisjunction(res, from, pos);
	      }
	
	      function parseAlternative() {
	        var res = [], from = pos;
	        var term;
	
	        // Alternative ::
	        //      [empty]
	        //      Alternative Term
	        while (term = parseTerm()) {
	          res.push(term);
	        }
	
	        if (res.length === 1) {
	          return res[0];
	        }
	
	        return createAlternative(res, from, pos);
	      }
	
	      function parseTerm() {
	        // Term ::
	        //      Anchor
	        //      Atom
	        //      Atom Quantifier
	
	        if (pos >= str.length || current('|') || current(')')) {
	          return null; /* Means: The term is empty */
	        }
	
	        var anchor = parseAnchor();
	
	        if (anchor) {
	          return anchor;
	        }
	
	        var atom = parseAtom();
	        if (!atom) {
	          bail('Expected atom');
	        }
	        var quantifier = parseQuantifier() || false;
	        if (quantifier) {
	          quantifier.body = flattenBody(atom);
	          // The quantifier contains the atom. Therefore, the beginning of the
	          // quantifier range is given by the beginning of the atom.
	          updateRawStart(quantifier, atom.range[0]);
	          return quantifier;
	        }
	        return atom;
	      }
	
	      function parseGroup(matchA, typeA, matchB, typeB) {
	        var type = null, from = pos;
	
	        if (match(matchA)) {
	          type = typeA;
	        } else if (match(matchB)) {
	          type = typeB;
	        } else {
	          return false;
	        }
	
	        var body = parseDisjunction();
	        if (!body) {
	          bail('Expected disjunction');
	        }
	        skip(')');
	        var group = createGroup(type, flattenBody(body), from, pos);
	
	        if (type == 'normal') {
	          // Keep track of the number of closed groups. This is required for
	          // parseDecimalEscape(). In case the string is parsed a second time the
	          // value already holds the total count and no incrementation is required.
	          if (firstIteration) {
	            closedCaptureCounter++;
	          }
	        }
	        return group;
	      }
	
	      function parseAnchor() {
	        // Anchor ::
	        //      ^
	        //      $
	        //      \ b
	        //      \ B
	        //      ( ? = Disjunction )
	        //      ( ? ! Disjunction )
	        var res, from = pos;
	
	        if (match('^')) {
	          return createAnchor('start', 1 /* rawLength */);
	        } else if (match('$')) {
	          return createAnchor('end', 1 /* rawLength */);
	        } else if (match('\\b')) {
	          return createAnchor('boundary', 2 /* rawLength */);
	        } else if (match('\\B')) {
	          return createAnchor('not-boundary', 2 /* rawLength */);
	        } else {
	          return parseGroup('(?=', 'lookahead', '(?!', 'negativeLookahead');
	        }
	      }
	
	      function parseQuantifier() {
	        // Quantifier ::
	        //      QuantifierPrefix
	        //      QuantifierPrefix ?
	        //
	        // QuantifierPrefix ::
	        //      *
	        //      +
	        //      ?
	        //      { DecimalDigits }
	        //      { DecimalDigits , }
	        //      { DecimalDigits , DecimalDigits }
	
	        var res, from = pos;
	        var quantifier;
	        var min, max;
	
	        if (match('*')) {
	          quantifier = createQuantifier(0);
	        }
	        else if (match('+')) {
	          quantifier = createQuantifier(1);
	        }
	        else if (match('?')) {
	          quantifier = createQuantifier(0, 1);
	        }
	        else if (res = matchReg(/^\{([0-9]+)\}/)) {
	          min = parseInt(res[1], 10);
	          quantifier = createQuantifier(min, min, res.range[0], res.range[1]);
	        }
	        else if (res = matchReg(/^\{([0-9]+),\}/)) {
	          min = parseInt(res[1], 10);
	          quantifier = createQuantifier(min, undefined, res.range[0], res.range[1]);
	        }
	        else if (res = matchReg(/^\{([0-9]+),([0-9]+)\}/)) {
	          min = parseInt(res[1], 10);
	          max = parseInt(res[2], 10);
	          if (min > max) {
	            bail('numbers out of order in {} quantifier', '', from, pos);
	          }
	          quantifier = createQuantifier(min, max, res.range[0], res.range[1]);
	        }
	
	        if (quantifier) {
	          if (match('?')) {
	            quantifier.greedy = false;
	            quantifier.range[1] += 1;
	          }
	        }
	
	        return quantifier;
	      }
	
	      function parseAtom() {
	        // Atom ::
	        //      PatternCharacter
	        //      .
	        //      \ AtomEscape
	        //      CharacterClass
	        //      ( Disjunction )
	        //      ( ? : Disjunction )
	
	        var res;
	
	        // jviereck: allow ']', '}' here as well to be compatible with browser's
	        //   implementations: ']'.match(/]/);
	        // if (res = matchReg(/^[^^$\\.*+?()[\]{}|]/)) {
	        if (res = matchReg(/^[^^$\\.*+?(){[|]/)) {
	          //      PatternCharacter
	          return createCharacter(res);
	        }
	        else if (match('.')) {
	          //      .
	          return createDot();
	        }
	        else if (match('\\')) {
	          //      \ AtomEscape
	          res = parseAtomEscape();
	          if (!res) {
	            bail('atomEscape');
	          }
	          return res;
	        }
	        else if (res = parseCharacterClass()) {
	          return res;
	        }
	        else {
	          //      ( Disjunction )
	          //      ( ? : Disjunction )
	          return parseGroup('(?:', 'ignore', '(', 'normal');
	        }
	      }
	
	      function parseUnicodeSurrogatePairEscape(firstEscape) {
	        if (hasUnicodeFlag) {
	          var first, second;
	          if (firstEscape.kind == 'unicodeEscape' &&
	            (first = firstEscape.codePoint) >= 0xD800 && first <= 0xDBFF &&
	            current('\\') && next('u') ) {
	            var prevPos = pos;
	            pos++;
	            var secondEscape = parseClassEscape();
	            if (secondEscape.kind == 'unicodeEscape' &&
	              (second = secondEscape.codePoint) >= 0xDC00 && second <= 0xDFFF) {
	              // Unicode surrogate pair
	              firstEscape.range[1] = secondEscape.range[1];
	              firstEscape.codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
	              firstEscape.type = 'value';
	              firstEscape.kind = 'unicodeCodePointEscape';
	              addRaw(firstEscape);
	            }
	            else {
	              pos = prevPos;
	            }
	          }
	        }
	        return firstEscape;
	      }
	
	      function parseClassEscape() {
	        return parseAtomEscape(true);
	      }
	
	      function parseAtomEscape(insideCharacterClass) {
	        // AtomEscape ::
	        //      DecimalEscape
	        //      CharacterEscape
	        //      CharacterClassEscape
	
	        var res, from = pos;
	
	        res = parseDecimalEscape();
	        if (res) {
	          return res;
	        }
	
	        // For ClassEscape
	        if (insideCharacterClass) {
	          if (match('b')) {
	            // 15.10.2.19
	            // The production ClassEscape :: b evaluates by returning the
	            // CharSet containing the one character <BS> (Unicode value 0008).
	            return createEscaped('singleEscape', 0x0008, '\\b');
	          } else if (match('B')) {
	            bail('\\B not possible inside of CharacterClass', '', from);
	          }
	        }
	
	        res = parseCharacterEscape();
	
	        return res;
	      }
	
	
	      function parseDecimalEscape() {
	        // DecimalEscape ::
	        //      DecimalIntegerLiteral [lookahead ∉ DecimalDigit]
	        //      CharacterClassEscape :: one of d D s S w W
	
	        var res, match;
	
	        if (res = matchReg(/^(?!0)\d+/)) {
	          match = res[0];
	          var refIdx = parseInt(res[0], 10);
	          if (refIdx <= closedCaptureCounter) {
	            // If the number is smaller than the normal-groups found so
	            // far, then it is a reference...
	            return createReference(res[0]);
	          } else {
	            // ... otherwise it needs to be interpreted as a octal (if the
	            // number is in an octal format). If it is NOT octal format,
	            // then the slash is ignored and the number is matched later
	            // as normal characters.
	
	            // Recall the negative decision to decide if the input must be parsed
	            // a second time with the total normal-groups.
	            backrefDenied.push(refIdx);
	
	            // Reset the position again, as maybe only parts of the previous
	            // matched numbers are actual octal numbers. E.g. in '019' only
	            // the '01' should be matched.
	            incr(-res[0].length);
	            if (res = matchReg(/^[0-7]{1,3}/)) {
	              return createEscaped('octal', parseInt(res[0], 8), res[0], 1);
	            } else {
	              // If we end up here, we have a case like /\91/. Then the
	              // first slash is to be ignored and the 9 & 1 to be treated
	              // like ordinary characters. Create a character for the
	              // first number only here - other number-characters
	              // (if available) will be matched later.
	              res = createCharacter(matchReg(/^[89]/));
	              return updateRawStart(res, res.range[0] - 1);
	            }
	          }
	        }
	        // Only allow octal numbers in the following. All matched numbers start
	        // with a zero (if the do not, the previous if-branch is executed).
	        // If the number is not octal format and starts with zero (e.g. `091`)
	        // then only the zeros `0` is treated here and the `91` are ordinary
	        // characters.
	        // Example:
	        //   /\091/.exec('\091')[0].length === 3
	        else if (res = matchReg(/^[0-7]{1,3}/)) {
	          match = res[0];
	          if (/^0{1,3}$/.test(match)) {
	            // If they are all zeros, then only take the first one.
	            return createEscaped('null', 0x0000, '0', match.length + 1);
	          } else {
	            return createEscaped('octal', parseInt(match, 8), match, 1);
	          }
	        } else if (res = matchReg(/^[dDsSwW]/)) {
	          return createCharacterClassEscape(res[0]);
	        }
	        return false;
	      }
	
	      function parseCharacterEscape() {
	        // CharacterEscape ::
	        //      ControlEscape
	        //      c ControlLetter
	        //      HexEscapeSequence
	        //      UnicodeEscapeSequence
	        //      IdentityEscape
	
	        var res;
	        if (res = matchReg(/^[fnrtv]/)) {
	          // ControlEscape
	          var codePoint = 0;
	          switch (res[0]) {
	            case 't': codePoint = 0x009; break;
	            case 'n': codePoint = 0x00A; break;
	            case 'v': codePoint = 0x00B; break;
	            case 'f': codePoint = 0x00C; break;
	            case 'r': codePoint = 0x00D; break;
	          }
	          return createEscaped('singleEscape', codePoint, '\\' + res[0]);
	        } else if (res = matchReg(/^c([a-zA-Z])/)) {
	          // c ControlLetter
	          return createEscaped('controlLetter', res[1].charCodeAt(0) % 32, res[1], 2);
	        } else if (res = matchReg(/^x([0-9a-fA-F]{2})/)) {
	          // HexEscapeSequence
	          return createEscaped('hexadecimalEscape', parseInt(res[1], 16), res[1], 2);
	        } else if (res = matchReg(/^u([0-9a-fA-F]{4})/)) {
	          // UnicodeEscapeSequence
	          return parseUnicodeSurrogatePairEscape(
	            createEscaped('unicodeEscape', parseInt(res[1], 16), res[1], 2)
	          );
	        } else if (hasUnicodeFlag && (res = matchReg(/^u\{([0-9a-fA-F]+)\}/))) {
	          // RegExpUnicodeEscapeSequence (ES6 Unicode code point escape)
	          return createEscaped('unicodeCodePointEscape', parseInt(res[1], 16), res[1], 4);
	        } else {
	          // IdentityEscape
	          return parseIdentityEscape();
	        }
	      }
	
	      // Taken from the Esprima parser.
	      function isIdentifierPart(ch) {
	        // Generated by `tools/generate-identifier-regex.js`.
	        var NonAsciiIdentifierPart = new RegExp('[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B2\u08E4-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58\u0C59\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D60-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA69D\uA69F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2D\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]');
	
	        return (ch === 36) || (ch === 95) ||  // $ (dollar) and _ (underscore)
	          (ch >= 65 && ch <= 90) ||         // A..Z
	          (ch >= 97 && ch <= 122) ||        // a..z
	          (ch >= 48 && ch <= 57) ||         // 0..9
	          (ch === 92) ||                    // \ (backslash)
	          ((ch >= 0x80) && NonAsciiIdentifierPart.test(String.fromCharCode(ch)));
	      }
	
	      function parseIdentityEscape() {
	        // IdentityEscape ::
	        //      SourceCharacter but not IdentifierPart
	        //      <ZWJ>
	        //      <ZWNJ>
	
	        var ZWJ = '\u200C';
	        var ZWNJ = '\u200D';
	
	        var tmp;
	
	        if (!isIdentifierPart(lookahead())) {
	          tmp = incr();
	          return createEscaped('identifier', tmp.charCodeAt(0), tmp, 1);
	        }
	
	        if (match(ZWJ)) {
	          // <ZWJ>
	          return createEscaped('identifier', 0x200C, ZWJ);
	        } else if (match(ZWNJ)) {
	          // <ZWNJ>
	          return createEscaped('identifier', 0x200D, ZWNJ);
	        }
	
	        return null;
	      }
	
	      function parseCharacterClass() {
	        // CharacterClass ::
	        //      [ [lookahead ∉ {^}] ClassRanges ]
	        //      [ ^ ClassRanges ]
	
	        var res, from = pos;
	        if (res = matchReg(/^\[\^/)) {
	          res = parseClassRanges();
	          skip(']');
	          return createCharacterClass(res, true, from, pos);
	        } else if (match('[')) {
	          res = parseClassRanges();
	          skip(']');
	          return createCharacterClass(res, false, from, pos);
	        }
	
	        return null;
	      }
	
	      function parseClassRanges() {
	        // ClassRanges ::
	        //      [empty]
	        //      NonemptyClassRanges
	
	        var res;
	        if (current(']')) {
	          // Empty array means nothing insinde of the ClassRange.
	          return [];
	        } else {
	          res = parseNonemptyClassRanges();
	          if (!res) {
	            bail('nonEmptyClassRanges');
	          }
	          return res;
	        }
	      }
	
	      function parseHelperClassRanges(atom) {
	        var from, to, res;
	        if (current('-') && !next(']')) {
	          // ClassAtom - ClassAtom ClassRanges
	          skip('-');
	
	          res = parseClassAtom();
	          if (!res) {
	            bail('classAtom');
	          }
	          to = pos;
	          var classRanges = parseClassRanges();
	          if (!classRanges) {
	            bail('classRanges');
	          }
	          from = atom.range[0];
	          if (classRanges.type === 'empty') {
	            return [createClassRange(atom, res, from, to)];
	          }
	          return [createClassRange(atom, res, from, to)].concat(classRanges);
	        }
	
	        res = parseNonemptyClassRangesNoDash();
	        if (!res) {
	          bail('nonEmptyClassRangesNoDash');
	        }
	
	        return [atom].concat(res);
	      }
	
	      function parseNonemptyClassRanges() {
	        // NonemptyClassRanges ::
	        //      ClassAtom
	        //      ClassAtom NonemptyClassRangesNoDash
	        //      ClassAtom - ClassAtom ClassRanges
	
	        var atom = parseClassAtom();
	        if (!atom) {
	          bail('classAtom');
	        }
	
	        if (current(']')) {
	          // ClassAtom
	          return [atom];
	        }
	
	        // ClassAtom NonemptyClassRangesNoDash
	        // ClassAtom - ClassAtom ClassRanges
	        return parseHelperClassRanges(atom);
	      }
	
	      function parseNonemptyClassRangesNoDash() {
	        // NonemptyClassRangesNoDash ::
	        //      ClassAtom
	        //      ClassAtomNoDash NonemptyClassRangesNoDash
	        //      ClassAtomNoDash - ClassAtom ClassRanges
	
	        var res = parseClassAtom();
	        if (!res) {
	          bail('classAtom');
	        }
	        if (current(']')) {
	          //      ClassAtom
	          return res;
	        }
	
	        // ClassAtomNoDash NonemptyClassRangesNoDash
	        // ClassAtomNoDash - ClassAtom ClassRanges
	        return parseHelperClassRanges(res);
	      }
	
	      function parseClassAtom() {
	        // ClassAtom ::
	        //      -
	        //      ClassAtomNoDash
	        if (match('-')) {
	          return createCharacter('-');
	        } else {
	          return parseClassAtomNoDash();
	        }
	      }
	
	      function parseClassAtomNoDash() {
	        // ClassAtomNoDash ::
	        //      SourceCharacter but not one of \ or ] or -
	        //      \ ClassEscape
	
	        var res;
	        if (res = matchReg(/^[^\\\]-]/)) {
	          return createCharacter(res[0]);
	        } else if (match('\\')) {
	          res = parseClassEscape();
	          if (!res) {
	            bail('classEscape');
	          }
	
	          return parseUnicodeSurrogatePairEscape(res);
	        }
	      }
	
	      function bail(message, details, from, to) {
	        from = from == null ? pos : from;
	        to = to == null ? from : to;
	
	        var contextStart = Math.max(0, from - 10);
	        var contextEnd = Math.min(to + 10, str.length);
	
	        // Output a bit of context and a line pointing to where our error is.
	        //
	        // We are assuming that there are no actual newlines in the content as this is a regular expression.
	        var context = '    ' + str.substring(contextStart, contextEnd);
	        var pointer = '    ' + new Array(from - contextStart + 1).join(' ') + '^';
	
	        throw SyntaxError(message + ' at position ' + from + (details ? ': ' + details : '') + '\n' + context + '\n' + pointer);
	      }
	
	      var backrefDenied = [];
	      var closedCaptureCounter = 0;
	      var firstIteration = true;
	      var hasUnicodeFlag = (flags || "").indexOf("u") !== -1;
	      var pos = 0;
	
	      // Convert the input to a string and treat the empty string special.
	      str = String(str);
	      if (str === '') {
	        str = '(?:)';
	      }
	
	      var result = parseDisjunction();
	
	      if (result.range[1] !== str.length) {
	        bail('Could not parse entire input - got stuck', '', result.range[1]);
	      }
	
	      // The spec requires to interpret the `\2` in `/\2()()/` as backreference.
	      // As the parser collects the number of capture groups as the string is
	      // parsed it is impossible to make these decisions at the point when the
	      // `\2` is handled. In case the local decision turns out to be wrong after
	      // the parsing has finished, the input string is parsed a second time with
	      // the total number of capture groups set.
	      //
	      // SEE: https://github.com/jviereck/regjsparser/issues/70
	      for (var i = 0; i < backrefDenied.length; i++) {
	        if (backrefDenied[i] <= closedCaptureCounter) {
	          // Parse the input a second time.
	          pos = 0;
	          firstIteration = false;
	          return parseDisjunction();
	        }
	      }
	
	      return result;
	    }
	
	    var regjsparser = {
	      parse: parse
	    };
	
	    if (typeof module !== 'undefined' && module.exports) {
	      module.exports = regjsparser;
	    } else {
	      window.regjsparser = regjsparser;
	    }
	
	  }());
	  });
	
	  var require$$3 = (parser && typeof parser === 'object' && 'default' in parser ? parser['default'] : parser);
	
	  var regjsgen = __commonjs(function (module, exports, global) {
	  /*!
	   * RegJSGen
	   * Copyright 2014 Benjamin Tan <https://d10.github.io/>
	   * Available under MIT license <http://d10.mit-license.org/>
	   */
	  ;(function() {
	    'use strict';
	
	    /** Used to determine if values are of the language type `Object` */
	    var objectTypes = {
	      'function': true,
	      'object': true
	    };
	
	    /** Used as a reference to the global object */
	    var root = (objectTypes[typeof window] && window) || this;
	
	    /** Backup possible global object */
	    var oldRoot = root;
	
	    /** Detect free variable `exports` */
	    var freeExports = objectTypes[typeof exports] && exports;
	
	    /** Detect free variable `module` */
	    var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	    /** Detect free variable `global` from Node.js or Browserified code and use it as `root` */
	    var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
	    if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
	      root = freeGlobal;
	    }
	
	    /*--------------------------------------------------------------------------*/
	
	    /*! Based on https://mths.be/fromcodepoint v0.2.0 by @mathias */
	
	    var stringFromCharCode = String.fromCharCode;
	    var floor = Math.floor;
	    function fromCodePoint() {
	      var MAX_SIZE = 0x4000;
	      var codeUnits = [];
	      var highSurrogate;
	      var lowSurrogate;
	      var index = -1;
	      var length = arguments.length;
	      if (!length) {
	        return '';
	      }
	      var result = '';
	      while (++index < length) {
	        var codePoint = Number(arguments[index]);
	        if (
	          !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
	          codePoint < 0 || // not a valid Unicode code point
	          codePoint > 0x10FFFF || // not a valid Unicode code point
	          floor(codePoint) != codePoint // not an integer
	        ) {
	          throw RangeError('Invalid code point: ' + codePoint);
	        }
	        if (codePoint <= 0xFFFF) {
	          // BMP code point
	          codeUnits.push(codePoint);
	        } else {
	          // Astral code point; split in surrogate halves
	          // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	          codePoint -= 0x10000;
	          highSurrogate = (codePoint >> 10) + 0xD800;
	          lowSurrogate = (codePoint % 0x400) + 0xDC00;
	          codeUnits.push(highSurrogate, lowSurrogate);
	        }
	        if (index + 1 == length || codeUnits.length > MAX_SIZE) {
	          result += stringFromCharCode.apply(null, codeUnits);
	          codeUnits.length = 0;
	        }
	      }
	      return result;
	    }
	
	    function assertType(type, expected) {
	      if (expected.indexOf('|') == -1) {
	        if (type == expected) {
	          return;
	        }
	
	        throw Error('Invalid node type: ' + type);
	      }
	
	      expected = assertType.hasOwnProperty(expected)
	        ? assertType[expected]
	        : (assertType[expected] = RegExp('^(?:' + expected + ')$'));
	
	      if (expected.test(type)) {
	        return;
	      }
	
	      throw Error('Invalid node type: ' + type);
	    }
	
	    /*--------------------------------------------------------------------------*/
	
	    function generate(node) {
	      var type = node.type;
	
	      if (generate.hasOwnProperty(type) && typeof generate[type] == 'function') {
	        return generate[type](node);
	      }
	
	      throw Error('Invalid node type: ' + type);
	    }
	
	    /*--------------------------------------------------------------------------*/
	
	    function generateAlternative(node) {
	      assertType(node.type, 'alternative');
	
	      var terms = node.body,
	          length = terms ? terms.length : 0;
	
	      if (length == 1) {
	        return generateTerm(terms[0]);
	      } else {
	        var i = -1,
	            result = '';
	
	        while (++i < length) {
	          result += generateTerm(terms[i]);
	        }
	
	        return result;
	      }
	    }
	
	    function generateAnchor(node) {
	      assertType(node.type, 'anchor');
	
	      switch (node.kind) {
	        case 'start':
	          return '^';
	        case 'end':
	          return '$';
	        case 'boundary':
	          return '\\b';
	        case 'not-boundary':
	          return '\\B';
	        default:
	          throw Error('Invalid assertion');
	      }
	    }
	
	    function generateAtom(node) {
	      assertType(node.type, 'anchor|characterClass|characterClassEscape|dot|group|reference|value');
	
	      return generate(node);
	    }
	
	    function generateCharacterClass(node) {
	      assertType(node.type, 'characterClass');
	
	      var classRanges = node.body,
	          length = classRanges ? classRanges.length : 0;
	
	      var i = -1,
	          result = '[';
	
	      if (node.negative) {
	        result += '^';
	      }
	
	      while (++i < length) {
	        result += generateClassAtom(classRanges[i]);
	      }
	
	      result += ']';
	
	      return result;
	    }
	
	    function generateCharacterClassEscape(node) {
	      assertType(node.type, 'characterClassEscape');
	
	      return '\\' + node.value;
	    }
	
	    function generateCharacterClassRange(node) {
	      assertType(node.type, 'characterClassRange');
	
	      var min = node.min,
	          max = node.max;
	
	      if (min.type == 'characterClassRange' || max.type == 'characterClassRange') {
	        throw Error('Invalid character class range');
	      }
	
	      return generateClassAtom(min) + '-' + generateClassAtom(max);
	    }
	
	    function generateClassAtom(node) {
	      assertType(node.type, 'anchor|characterClassEscape|characterClassRange|dot|value');
	
	      return generate(node);
	    }
	
	    function generateDisjunction(node) {
	      assertType(node.type, 'disjunction');
	
	      var body = node.body,
	          length = body ? body.length : 0;
	
	      if (length == 0) {
	        throw Error('No body');
	      } else if (length == 1) {
	        return generate(body[0]);
	      } else {
	        var i = -1,
	            result = '';
	
	        while (++i < length) {
	          if (i != 0) {
	            result += '|';
	          }
	          result += generate(body[i]);
	        }
	
	        return result;
	      }
	    }
	
	    function generateDot(node) {
	      assertType(node.type, 'dot');
	
	      return '.';
	    }
	
	    function generateGroup(node) {
	      assertType(node.type, 'group');
	
	      var result = '(';
	
	      switch (node.behavior) {
	        case 'normal':
	          break;
	        case 'ignore':
	          result += '?:';
	          break;
	        case 'lookahead':
	          result += '?=';
	          break;
	        case 'negativeLookahead':
	          result += '?!';
	          break;
	        default:
	          throw Error('Invalid behaviour: ' + node.behaviour);
	      }
	
	      var body = node.body,
	          length = body ? body.length : 0;
	
	      if (length == 1) {
	        result += generate(body[0]);
	      } else {
	        var i = -1;
	
	        while (++i < length) {
	          result += generate(body[i]);
	        }
	      }
	
	      result += ')';
	
	      return result;
	    }
	
	    function generateQuantifier(node) {
	      assertType(node.type, 'quantifier');
	
	      var quantifier = '',
	          min = node.min,
	          max = node.max;
	
	      switch (max) {
	        case undefined:
	        case null:
	          switch (min) {
	            case 0:
	              quantifier = '*'
	              break;
	            case 1:
	              quantifier = '+';
	              break;
	            default:
	              quantifier = '{' + min + ',}';
	              break;
	          }
	          break;
	        default:
	          if (min == max) {
	            quantifier = '{' + min + '}';
	          }
	          else if (min == 0 && max == 1) {
	            quantifier = '?';
	          } else {
	            quantifier = '{' + min + ',' + max + '}';
	          }
	          break;
	      }
	
	      if (!node.greedy) {
	        quantifier += '?';
	      }
	
	      return generateAtom(node.body[0]) + quantifier;
	    }
	
	    function generateReference(node) {
	      assertType(node.type, 'reference');
	
	      return '\\' + node.matchIndex;
	    }
	
	    function generateTerm(node) {
	      assertType(node.type, 'anchor|characterClass|characterClassEscape|empty|group|quantifier|reference|value');
	
	      return generate(node);
	    }
	
	    function generateValue(node) {
	      assertType(node.type, 'value');
	
	      var kind = node.kind,
	          codePoint = node.codePoint;
	
	      switch (kind) {
	        case 'controlLetter':
	          return '\\c' + fromCodePoint(codePoint + 64);
	        case 'hexadecimalEscape':
	          return '\\x' + ('00' + codePoint.toString(16).toUpperCase()).slice(-2);
	        case 'identifier':
	          return '\\' + fromCodePoint(codePoint);
	        case 'null':
	          return '\\' + codePoint;
	        case 'octal':
	          return '\\' + codePoint.toString(8);
	        case 'singleEscape':
	          switch (codePoint) {
	            case 0x0008:
	              return '\\b';
	            case 0x009:
	              return '\\t';
	            case 0x00A:
	              return '\\n';
	            case 0x00B:
	              return '\\v';
	            case 0x00C:
	              return '\\f';
	            case 0x00D:
	              return '\\r';
	            default:
	              throw Error('Invalid codepoint: ' + codePoint);
	          }
	        case 'symbol':
	          return fromCodePoint(codePoint);
	        case 'unicodeEscape':
	          return '\\u' + ('0000' + codePoint.toString(16).toUpperCase()).slice(-4);
	        case 'unicodeCodePointEscape':
	          return '\\u{' + codePoint.toString(16).toUpperCase() + '}';
	        default:
	          throw Error('Unsupported node kind: ' + kind);
	      }
	    }
	
	    /*--------------------------------------------------------------------------*/
	
	    generate.alternative = generateAlternative;
	    generate.anchor = generateAnchor;
	    generate.characterClass = generateCharacterClass;
	    generate.characterClassEscape = generateCharacterClassEscape;
	    generate.characterClassRange = generateCharacterClassRange;
	    generate.disjunction = generateDisjunction;
	    generate.dot = generateDot;
	    generate.group = generateGroup;
	    generate.quantifier = generateQuantifier;
	    generate.reference = generateReference;
	    generate.value = generateValue;
	
	    /*--------------------------------------------------------------------------*/
	
	    // export regjsgen
	    // some AMD build optimizers, like r.js, check for condition patterns like the following:
	    if (true) {
	      // define as an anonymous module so, through path mapping, it can be aliased
	      !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return {
	          'generate': generate
	        };
	      }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    // check for `exports` after `define` in case a build optimizer adds an `exports` object
	    else if (freeExports && freeModule) {
	      // in Narwhal, Node.js, Rhino -require, or RingoJS
	      freeExports.generate = generate;
	    }
	    // in a browser or Rhino
	    else {
	      root.regjsgen = {
	        'generate': generate
	      };
	    }
	  }.call(__commonjs_global));
	  });
	
	  var require$$4 = (regjsgen && typeof regjsgen === 'object' && 'default' in regjsgen ? regjsgen['default'] : regjsgen);
	
	  var rewritePattern = __commonjs(function (module) {
	  var generate = require$$4.generate;
	  var parse = require$$3.parse;
	  var regenerate = require$$0$2;
	  var iuMappings = require$$1;
	  var ESCAPE_SETS = require$$0$1;
	
	  function getCharacterClassEscapeSet(character) {
	  	if (unicode) {
	  		if (ignoreCase) {
	  			return ESCAPE_SETS.UNICODE_IGNORE_CASE[character];
	  		}
	  		return ESCAPE_SETS.UNICODE[character];
	  	}
	  	return ESCAPE_SETS.REGULAR[character];
	  }
	
	  var object = {};
	  var hasOwnProperty = object.hasOwnProperty;
	  function has(object, property) {
	  	return hasOwnProperty.call(object, property);
	  }
	
	  // Prepare a Regenerate set containing all code points, used for negative
	  // character classes (if any).
	  var UNICODE_SET = regenerate().addRange(0x0, 0x10FFFF);
	  // Without the `u` flag, the range stops at 0xFFFF.
	  // https://mths.be/es6#sec-pattern-semantics
	  var BMP_SET = regenerate().addRange(0x0, 0xFFFF);
	
	  // Prepare a Regenerate set containing all code points that are supposed to be
	  // matched by `/./u`. https://mths.be/es6#sec-atom
	  var DOT_SET_UNICODE = UNICODE_SET.clone() // all Unicode code points
	  	.remove(
	  		// minus `LineTerminator`s (https://mths.be/es6#sec-line-terminators):
	  		0x000A, // Line Feed <LF>
	  		0x000D, // Carriage Return <CR>
	  		0x2028, // Line Separator <LS>
	  		0x2029  // Paragraph Separator <PS>
	  	);
	  // Prepare a Regenerate set containing all code points that are supposed to be
	  // matched by `/./` (only BMP code points).
	  var DOT_SET = DOT_SET_UNICODE.clone()
	  	.intersection(BMP_SET);
	
	  // Add a range of code points + any case-folded code points in that range to a
	  // set.
	  regenerate.prototype.iuAddRange = function(min, max) {
	  	var $this = this;
	  	do {
	  		var folded = caseFold(min);
	  		if (folded) {
	  			$this.add(folded);
	  		}
	  	} while (++min <= max);
	  	return $this;
	  };
	
	  function assign(target, source) {
	  	for (var key in source) {
	  		// Note: `hasOwnProperty` is not needed here.
	  		target[key] = source[key];
	  	}
	  }
	
	  function update(item, pattern) {
	  	// TODO: Test if memoizing `pattern` here is worth the effort.
	  	if (!pattern) {
	  		return;
	  	}
	  	var tree = parse(pattern, '');
	  	switch (tree.type) {
	  		case 'characterClass':
	  		case 'group':
	  		case 'value':
	  			// No wrapping needed.
	  			break;
	  		default:
	  			// Wrap the pattern in a non-capturing group.
	  			tree = wrap(tree, pattern);
	  	}
	  	assign(item, tree);
	  }
	
	  function wrap(tree, pattern) {
	  	// Wrap the pattern in a non-capturing group.
	  	return {
	  		'type': 'group',
	  		'behavior': 'ignore',
	  		'body': [tree],
	  		'raw': '(?:' + pattern + ')'
	  	};
	  }
	
	  function caseFold(codePoint) {
	  	return has(iuMappings, codePoint) ? iuMappings[codePoint] : false;
	  }
	
	  var ignoreCase = false;
	  var unicode = false;
	  function processCharacterClass(characterClassItem) {
	  	var set = regenerate();
	  	var body = characterClassItem.body.forEach(function(item) {
	  		switch (item.type) {
	  			case 'value':
	  				set.add(item.codePoint);
	  				if (ignoreCase && unicode) {
	  					var folded = caseFold(item.codePoint);
	  					if (folded) {
	  						set.add(folded);
	  					}
	  				}
	  				break;
	  			case 'characterClassRange':
	  				var min = item.min.codePoint;
	  				var max = item.max.codePoint;
	  				set.addRange(min, max);
	  				if (ignoreCase && unicode) {
	  					set.iuAddRange(min, max);
	  				}
	  				break;
	  			case 'characterClassEscape':
	  				set.add(getCharacterClassEscapeSet(item.value));
	  				break;
	  			// The `default` clause is only here as a safeguard; it should never be
	  			// reached. Code coverage tools should ignore it.
	  			/* istanbul ignore next */
	  			default:
	  				throw Error('Unknown term type: ' + item.type);
	  		}
	  	});
	  	if (characterClassItem.negative) {
	  		set = (unicode ? UNICODE_SET : BMP_SET).clone().remove(set);
	  	}
	  	update(characterClassItem, set.toString());
	  	return characterClassItem;
	  }
	
	  function processTerm(item) {
	  	switch (item.type) {
	  		case 'dot':
	  			update(
	  				item,
	  				(unicode ? DOT_SET_UNICODE : DOT_SET).toString()
	  			);
	  			break;
	  		case 'characterClass':
	  			item = processCharacterClass(item);
	  			break;
	  		case 'characterClassEscape':
	  			update(
	  				item,
	  				getCharacterClassEscapeSet(item.value).toString()
	  			);
	  			break;
	  		case 'alternative':
	  		case 'disjunction':
	  		case 'group':
	  		case 'quantifier':
	  			item.body = item.body.map(processTerm);
	  			break;
	  		case 'value':
	  			var codePoint = item.codePoint;
	  			var set = regenerate(codePoint);
	  			if (ignoreCase && unicode) {
	  				var folded = caseFold(codePoint);
	  				if (folded) {
	  					set.add(folded);
	  				}
	  			}
	  			update(item, set.toString());
	  			break;
	  		case 'anchor':
	  		case 'empty':
	  		case 'group':
	  		case 'reference':
	  			// Nothing to do here.
	  			break;
	  		// The `default` clause is only here as a safeguard; it should never be
	  		// reached. Code coverage tools should ignore it.
	  		/* istanbul ignore next */
	  		default:
	  			throw Error('Unknown term type: ' + item.type);
	  	}
	  	return item;
	  };
	
	  module.exports = function(pattern, flags) {
	  	var tree = parse(pattern, flags);
	  	ignoreCase = flags ? flags.indexOf('i') > -1 : false;
	  	unicode = flags ? flags.indexOf('u') > -1 : false;
	  	assign(tree, processTerm(tree));
	  	return generate(tree);
	  };
	  });
	
	  var rewritePattern$1 = (rewritePattern && typeof rewritePattern === 'object' && 'default' in rewritePattern ? rewritePattern['default'] : rewritePattern);
	
	  var Literal = (function (Node) {
	  	function Literal () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) Literal.__proto__ = Node;
	  	Literal.prototype = Object.create( Node && Node.prototype );
	  	Literal.prototype.constructor = Literal;
	
	  	Literal.prototype.initialise = function initialise () {
	  		if ( typeof this.value === 'string' ) {
	  			this.program.indentExclusionElements.push( this );
	  		}
	  	};
	
	  	Literal.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( transforms.numericLiteral ) {
	  			var leading = this.raw.slice( 0, 2 );
	  			if ( leading === '0b' || leading === '0o' ) {
	  				code.overwrite( this.start, this.end, String( this.value ), true );
	  			}
	  		}
	
	  		if ( this.regex ) {
	  			var ref = this.regex;
	  			var pattern = ref.pattern;
	  			var flags = ref.flags;
	
	  			if ( transforms.stickyRegExp && /y/.test( flags ) ) throw new CompileError( this, 'Regular expression sticky flag is not supported' );
	  			if ( transforms.unicodeRegExp && /u/.test( flags ) ) {
	  				code.overwrite( this.start, this.end, ("/" + (rewritePattern$1( pattern, flags )) + "/" + (flags.replace( 'u', '' ))) );
	  			}
	  		}
	  	};
	
	  	return Literal;
	  }(Node));
	
	  var MemberExpression = (function (Node) {
	  	function MemberExpression () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) MemberExpression.__proto__ = Node;
	  	MemberExpression.prototype = Object.create( Node && Node.prototype );
	  	MemberExpression.prototype.constructor = MemberExpression;
	
	  	MemberExpression.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( transforms.reservedProperties && reserved[ this.property.name ] ) {
	  			code.overwrite( this.object.end, this.property.start, "['" );
	  			code.insertLeft( this.property.end, "']" );
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return MemberExpression;
	  }(Node));
	
	  var NewExpression = (function (Node) {
	  	function NewExpression () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) NewExpression.__proto__ = Node;
	  	NewExpression.prototype = Object.create( Node && Node.prototype );
	  	NewExpression.prototype.constructor = NewExpression;
	
	  	NewExpression.prototype.initialise = function initialise ( transforms ) {
	  		var this$1 = this;
	
	  		if ( transforms.spreadRest && this.arguments.length ) {
	  			var lexicalBoundary = this.findLexicalBoundary();
	
	  			var i = this.arguments.length;
	  			while ( i-- ) {
	  				var arg = this$1.arguments[i];
	  				if ( arg.type === 'SpreadElement' && isArguments( arg.argument ) ) {
	  					this$1.argumentsArrayAlias = lexicalBoundary.getArgumentsArrayAlias();
	  					break;
	  				}
	  			}
	  		}
	
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	NewExpression.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( transforms.spreadRest && this.arguments.length ) {
	  			var firstArgument = this.arguments[0];
	  			var isNew = true;
	  			var hasSpreadElements = spread( code, this.arguments, firstArgument.start, this.argumentsArrayAlias, isNew );
	
	  			if ( hasSpreadElements ) {
	  				code.insertRight( this.start + 'new'.length, ' (Function.prototype.bind.apply(' );
	  				code.overwrite( this.callee.end, firstArgument.start, ', [ null ].concat( ' );
	  				code.insertLeft( this.end, ' ))' );
	  			}
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return NewExpression;
	  }(Node));
	
	  var ObjectExpression = (function (Node) {
	  	function ObjectExpression () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) ObjectExpression.__proto__ = Node;
	  	ObjectExpression.prototype = Object.create( Node && Node.prototype );
	  	ObjectExpression.prototype.constructor = ObjectExpression;
	
	  	ObjectExpression.prototype.transpile = function transpile ( code, transforms ) {
	  		var this$1 = this;
	
	  		Node.prototype.transpile.call( this, code, transforms );
	
	  		var firstPropertyStart = this.start + 1;
	  		var regularPropertyCount = 0;
	  		var spreadPropertyCount = 0;
	  		var computedPropertyCount = 0;
	
	  		for ( var i$2 = 0, list = this.properties; i$2 < list.length; i$2 += 1 ) {
	  			var prop = list[i$2];
	
	  			if ( prop.type === 'SpreadProperty' ) {
	  				spreadPropertyCount += 1;
	  			} else if ( prop.computed ) {
	  				computedPropertyCount += 1;
	  			} else if ( prop.type === 'Property' ) {
	  				regularPropertyCount += 1;
	  			}
	  		}
	
	  		if ( spreadPropertyCount ) {
	  			if ( !this.program.options.objectAssign ) {
	  				throw new CompileError( this, 'Object spread operator requires specified objectAssign option with \'Object.assign\' or polyfill helper.' );
	  			}
	  			// enclose run of non-spread properties in curlies
	  			var i = this.properties.length;
	  			if ( regularPropertyCount ) {
	  				while ( i-- ) {
	  					var prop$1 = this$1.properties[i];
	
	  					if ( prop$1.type === 'Property' && !prop$1.computed ) {
	  						var lastProp = this$1.properties[ i - 1 ];
	  						var nextProp = this$1.properties[ i + 1 ];
	
	  						if ( !lastProp || lastProp.type !== 'Property' || lastProp.computed ) {
	  							code.insertRight( prop$1.start, '{' );
	  						}
	
	  						if ( !nextProp || nextProp.type !== 'Property' || nextProp.computed ) {
	  							code.insertLeft( prop$1.end, '}' );
	  						}
	  					}
	  				}
	  			}
	
	  			// wrap the whole thing in Object.assign
	  			firstPropertyStart = this.properties[0].start;
	  			code.overwrite( this.start, firstPropertyStart, ((this.program.options.objectAssign) + "({}, "));
	  			code.overwrite( this.properties[ this.properties.length - 1 ].end, this.end, ')' );
	  		}
	
	  		if ( computedPropertyCount && transforms.computedProperty ) {
	  			var i0 = this.getIndentation();
	
	  			var isSimpleAssignment;
	  			var name;
	
	  			if ( this.parent.type === 'VariableDeclarator' && this.parent.parent.declarations.length === 1 ) {
	  				isSimpleAssignment = true;
	  				name = this.parent.id.alias || this.parent.id.name; // TODO is this right?
	  			} else if ( this.parent.type === 'AssignmentExpression' && this.parent.parent.type === 'ExpressionStatement' && this.parent.left.type === 'Identifier' ) {
	  				isSimpleAssignment = true;
	  				name = this.parent.left.alias || this.parent.left.name; // TODO is this right?
	  			} else if ( this.parent.type === 'AssignmentPattern' && this.parent.left.type === 'Identifier' ) {
	  				isSimpleAssignment = true;
	  				name = this.parent.left.alias || this.parent.left.name; // TODO is this right?
	  			}
	
	  			// handle block scoping
	  			var declaration = this.findScope( false ).findDeclaration( name );
	  			if ( declaration ) name = declaration.name;
	
	  			var start = firstPropertyStart;
	  			var end = this.end;
	
	  			if ( isSimpleAssignment ) {
	  				// ???
	  			} else {
	  				name = this.findScope( true ).createIdentifier( 'obj' );
	
	  				var statement = this.findNearest( /(?:Statement|Declaration)$/ );
	  				code.insertLeft( statement.end, ("\n" + i0 + "var " + name + ";") );
	
	  				code.insertRight( this.start, ("( " + name + " = ") );
	  			}
	
	  			var len = this.properties.length;
	  			var lastComputedProp;
	  			var sawNonComputedProperty = false;
	
	  			for ( var i$1 = 0; i$1 < len; i$1 += 1 ) {
	  				var prop$2 = this$1.properties[i$1];
	
	  				if ( prop$2.computed ) {
	  					lastComputedProp = prop$2;
	  					var moveStart = i$1 > 0 ? this$1.properties[ i$1 - 1 ].end : start;
	
	  					var propId = isSimpleAssignment ? (";\n" + i0 + name) : (", " + name);
	
	  					if (moveStart < prop$2.start) {
	  						code.overwrite( moveStart, prop$2.start, propId );
	  					} else {
	  						code.insertRight( prop$2.start, propId );
	  					}
	
	  					var c = prop$2.key.end;
	  					while ( code.original[c] !== ']' ) c += 1;
	  					c += 1;
	
	  					if ( prop$2.value.start > c ) code.remove( c, prop$2.value.start );
	  					code.insertLeft( c, ' = ' );
	  					code.move( moveStart, prop$2.end, end );
	
	  					if ( i$1 < len - 1 && ! sawNonComputedProperty ) {
	  						// remove trailing comma
	  						c = prop$2.end;
	  						while ( code.original[c] !== ',' ) c += 1;
	
	  						code.remove( prop$2.end, c + 1 );
	  					}
	
	  					if ( prop$2.method && transforms.conciseMethodProperty ) {
	  						code.insertRight( prop$2.value.start, 'function ' );
	  					}
	  				} else {
	  					sawNonComputedProperty = true;
	  				}
	  			}
	
	  			// special case
	  			if ( computedPropertyCount === len ) {
	  				code.remove( this.properties[ len - 1 ].end, this.end - 1 );
	  			}
	
	  			if ( !isSimpleAssignment ) {
	  				code.insertLeft( lastComputedProp.end, (", " + name + " )") );
	  			}
	  		}
	  	};
	
	  	return ObjectExpression;
	  }(Node));
	
	  var Property = (function (Node) {
	  	function Property () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) Property.__proto__ = Node;
	  	Property.prototype = Object.create( Node && Node.prototype );
	  	Property.prototype.constructor = Property;
	
	  	Property.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( transforms.conciseMethodProperty && !this.computed && this.parent.type !== 'ObjectPattern' ) {
	  			if ( this.shorthand ) {
	  				code.insertRight( this.start, ((this.key.name) + ": ") );
	  			} else if ( this.method ) {
	  				var name = '';
	  				if ( this.program.options.namedFunctionExpressions !== false ) {
	  					if ( this.key.type === 'Literal' && typeof this.key.value === 'number' ) {
	  						name = "";
	  					} else if ( this.key.type === 'Identifier' ) {
	  						if ( reserved[ this.key.name ] ||
	  							 ! /^[a-z_$][a-z0-9_$]*$/i.test( this.key.name ) ||
	  						     this.value.body.scope.references[this.key.name] ) {
	  							name = this.findScope( true ).createIdentifier( this.key.name );
	  						} else {
	  							name = this.key.name;
	  						}
	  					} else {
	  						name = this.findScope( true ).createIdentifier( this.key.value );
	  					}
	  					name = ' ' + name;
	  				}
	
	  				if ( this.value.generator ) code.remove( this.start, this.key.start );
	  				code.insertLeft( this.key.end, (": function" + (this.value.generator ? '*' : '') + name) );
	  			}
	  		}
	
	  		if ( transforms.reservedProperties && reserved[ this.key.name ] ) {
	  			code.insertRight( this.key.start, "'" );
	  			code.insertLeft( this.key.end, "'" );
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return Property;
	  }(Node));
	
	  var ReturnStatement = (function (Node) {
	  	function ReturnStatement () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) ReturnStatement.__proto__ = Node;
	  	ReturnStatement.prototype = Object.create( Node && Node.prototype );
	  	ReturnStatement.prototype.constructor = ReturnStatement;
	
	  	ReturnStatement.prototype.initialise = function initialise ( transforms ) {
	  		this.loop = this.findNearest( loopStatement );
	  		this.nearestFunction = this.findNearest( /Function/ );
	
	  		if ( this.loop && ( !this.nearestFunction || this.loop.depth > this.nearestFunction.depth ) ) {
	  			this.loop.canReturn = true;
	  			this.shouldWrap = true;
	  		}
	
	  		if ( this.argument ) this.argument.initialise( transforms );
	  	};
	
	  	ReturnStatement.prototype.transpile = function transpile ( code, transforms ) {
	  		var shouldWrap = this.shouldWrap && this.loop && this.loop.shouldRewriteAsFunction;
	
	  		if ( this.argument ) {
	  			if ( shouldWrap ) code.insertRight( this.argument.start, "{ v: " );
	  			this.argument.transpile( code, transforms );
	  			if ( shouldWrap ) code.insertLeft( this.argument.end, " }" );
	  		} else if ( shouldWrap ) {
	  			code.insertLeft( this.start + 6, ' {}' );
	  		}
	  	};
	
	  	return ReturnStatement;
	  }(Node));
	
	  var SpreadProperty = (function (Node) {
	  	function SpreadProperty () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) SpreadProperty.__proto__ = Node;
	  	SpreadProperty.prototype = Object.create( Node && Node.prototype );
	  	SpreadProperty.prototype.constructor = SpreadProperty;
	
	  	SpreadProperty.prototype.transpile = function transpile ( code, transforms ) {
	  		code.remove( this.start, this.argument.start );
	  		code.remove( this.argument.end, this.end );
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return SpreadProperty;
	  }(Node));
	
	  var Super = (function (Node) {
	  	function Super () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) Super.__proto__ = Node;
	  	Super.prototype = Object.create( Node && Node.prototype );
	  	Super.prototype.constructor = Super;
	
	  	Super.prototype.initialise = function initialise ( transforms ) {
	  		if ( transforms.classes ) {
	  			this.method = this.findNearest( 'MethodDefinition' );
	  			if ( !this.method ) throw new CompileError( this, 'use of super outside class method' );
	
	  			var parentClass = this.findNearest( 'ClassBody' ).parent;
	  			this.superClassName = parentClass.superClass && (parentClass.superClass.name || 'superclass');
	
	  			if ( !this.superClassName ) throw new CompileError( this, 'super used in base class' );
	
	  			this.isCalled = this.parent.type === 'CallExpression' && this === this.parent.callee;
	
	  			if ( this.method.kind !== 'constructor' && this.isCalled ) {
	  				throw new CompileError( this, 'super() not allowed outside class constructor' );
	  			}
	
	  			this.isMember = this.parent.type === 'MemberExpression';
	
	  			if ( !this.isCalled && !this.isMember ) {
	  				throw new CompileError( this, 'Unexpected use of `super` (expected `super(...)` or `super.*`)' );
	  			}
	  		}
	
	  		if ( transforms.arrow ) {
	  			var lexicalBoundary = this.findLexicalBoundary();
	  			var arrowFunction = this.findNearest( 'ArrowFunctionExpression' );
	  			var loop = this.findNearest( loopStatement );
	
	  			if ( arrowFunction && arrowFunction.depth > lexicalBoundary.depth ) {
	  				this.thisAlias = lexicalBoundary.getThisAlias();
	  			}
	
	  			if ( loop && loop.body.contains( this ) && loop.depth > lexicalBoundary.depth ) {
	  				this.thisAlias = lexicalBoundary.getThisAlias();
	  			}
	  		}
	  	};
	
	  	Super.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( transforms.classes ) {
	  			var expression = ( this.isCalled || this.method.static ) ?
	  				this.superClassName :
	  				((this.superClassName) + ".prototype");
	
	  			code.overwrite( this.start, this.end, expression, true );
	
	  			var callExpression = this.isCalled ? this.parent : this.parent.parent;
	
	  			if ( callExpression && callExpression.type === 'CallExpression' ) {
	  				if ( !this.noCall ) { // special case – `super( ...args )`
	  					code.insertLeft( callExpression.callee.end, '.call' );
	  				}
	
	  				var thisAlias = this.thisAlias || 'this';
	
	  				if ( callExpression.arguments.length ) {
	  					code.insertLeft( callExpression.arguments[0].start, (thisAlias + ", ") );
	  				} else {
	  					code.insertLeft( callExpression.end - 1, ("" + thisAlias) );
	  				}
	  			}
	  		}
	  	};
	
	  	return Super;
	  }(Node));
	
	  var TaggedTemplateExpression = (function (Node) {
	  	function TaggedTemplateExpression () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) TaggedTemplateExpression.__proto__ = Node;
	  	TaggedTemplateExpression.prototype = Object.create( Node && Node.prototype );
	  	TaggedTemplateExpression.prototype.constructor = TaggedTemplateExpression;
	
	  	TaggedTemplateExpression.prototype.initialise = function initialise ( transforms ) {
	  		if ( transforms.templateString && !transforms.dangerousTaggedTemplateString ) {
	  			throw new CompileError( this, 'Tagged template strings are not supported. Use `transforms: { templateString: false }` to skip transformation and disable this error, or `transforms: { dangerousTaggedTemplateString: true }` if you know what you\'re doing' );
	  		}
	
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	TaggedTemplateExpression.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( transforms.templateString && transforms.dangerousTaggedTemplateString ) {
	  			var ordered = this.quasi.expressions.concat( this.quasi.quasis ).sort( function ( a, b ) { return a.start - b.start; } );
	
	  			// insert strings at start
	  			var templateStrings = this.quasi.quasis.map( function ( quasi ) { return JSON.stringify( quasi.value.cooked ); } );
	  			code.overwrite( this.tag.end, ordered[0].start, ("([" + (templateStrings.join(', ')) + "]") );
	
	  			var lastIndex = ordered[0].start;
	  			ordered.forEach( function ( node ) {
	  				if ( node.type === 'TemplateElement' ) {
	  					code.remove( lastIndex, node.end );
	  				} else {
	  					code.overwrite( lastIndex, node.start, ', ' );
	  				}
	
	  				lastIndex = node.end;
	  			});
	
	  			code.overwrite( lastIndex, this.end, ')' );
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return TaggedTemplateExpression;
	  }(Node));
	
	  var TemplateElement = (function (Node) {
	  	function TemplateElement () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) TemplateElement.__proto__ = Node;
	  	TemplateElement.prototype = Object.create( Node && Node.prototype );
	  	TemplateElement.prototype.constructor = TemplateElement;
	
	  	TemplateElement.prototype.initialise = function initialise () {
	  		this.program.indentExclusionElements.push( this );
	  	};
	
	  	return TemplateElement;
	  }(Node));
	
	  var TemplateLiteral = (function (Node) {
	  	function TemplateLiteral () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) TemplateLiteral.__proto__ = Node;
	  	TemplateLiteral.prototype = Object.create( Node && Node.prototype );
	  	TemplateLiteral.prototype.constructor = TemplateLiteral;
	
	  	TemplateLiteral.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( transforms.templateString && this.parent.type !== 'TaggedTemplateExpression' ) {
	  			var ordered = this.expressions.concat( this.quasis )
	  				.sort( function ( a, b ) { return a.start - b.start || a.end - b.end; } )
	  				.filter( function ( node, i ) {
	  					// include all expressions
	  					if ( node.type !== 'TemplateElement' ) return true;
	
	  					// include all non-empty strings
	  					if ( node.value.raw ) return true;
	
	  					// exclude all empty strings not at the head
	  					return !i;
	  				});
	
	  			// special case – we may be able to skip the first element,
	  			// if it's the empty string, but only if the second and
	  			// third elements aren't both expressions (since they maybe
	  			// be numeric, and `1 + 2 + '3' === '33'`)
	  			if ( ordered.length >= 3 ) {
	  				var first = ordered[0];
	  				var third = ordered[2];
	  				if ( first.type === 'TemplateElement' && first.value.raw === '' && third.type === 'TemplateElement' ) {
	  					ordered.shift();
	  				}
	  			}
	
	  			var parenthesise = ( this.quasis.length !== 1 || this.expressions.length !== 0 ) &&
	  			                     this.parent.type !== 'AssignmentExpression' &&
	  			                     this.parent.type !== 'AssignmentPattern' &&
	  			                     this.parent.type !== 'VariableDeclarator' &&
	  			                     ( this.parent.type !== 'BinaryExpression' || this.parent.operator !== '+' );
	
	  			if ( parenthesise ) code.insertRight( this.start, '(' );
	
	  			var lastIndex = this.start;
	
	  			ordered.forEach( function ( node, i ) {
	  				if ( node.type === 'TemplateElement' ) {
	  					var replacement = '';
	  					if ( i ) replacement += ' + ';
	  					replacement += JSON.stringify( node.value.cooked );
	
	  					code.overwrite( lastIndex, node.end, replacement );
	  				} else {
	  					var parenthesise = node.type !== 'Identifier'; // TODO other cases where it's safe
	
	  					var replacement$1 = '';
	  					if ( i ) replacement$1 += ' + ';
	  					if ( parenthesise ) replacement$1 += '(';
	
	  					code.overwrite( lastIndex, node.start, replacement$1 );
	
	  					if ( parenthesise ) code.insertLeft( node.end, ')' );
	  				}
	
	  				lastIndex = node.end;
	  			});
	
	  			var close = '';
	  			if ( parenthesise ) close += ')';
	
	  			code.overwrite( lastIndex, this.end, close );
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	  	};
	
	  	return TemplateLiteral;
	  }(Node));
	
	  var ThisExpression = (function (Node) {
	  	function ThisExpression () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) ThisExpression.__proto__ = Node;
	  	ThisExpression.prototype = Object.create( Node && Node.prototype );
	  	ThisExpression.prototype.constructor = ThisExpression;
	
	  	ThisExpression.prototype.initialise = function initialise ( transforms ) {
	  		if ( transforms.arrow ) {
	  			var lexicalBoundary = this.findLexicalBoundary();
	  			var arrowFunction = this.findNearest( 'ArrowFunctionExpression' );
	  			var loop = this.findNearest( loopStatement );
	
	  			if ( ( arrowFunction && arrowFunction.depth > lexicalBoundary.depth )
	  			|| ( loop && loop.body.contains( this ) && loop.depth > lexicalBoundary.depth )
	  			|| ( loop && loop.right && loop.right.contains( this ) ) ) {
	  				this.alias = lexicalBoundary.getThisAlias();
	  			}
	  		}
	  	};
	
	  	ThisExpression.prototype.transpile = function transpile ( code ) {
	  		if ( this.alias ) {
	  			code.overwrite( this.start, this.end, this.alias, true );
	  		}
	  	};
	
	  	return ThisExpression;
	  }(Node));
	
	  var UpdateExpression = (function (Node) {
	  	function UpdateExpression () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) UpdateExpression.__proto__ = Node;
	  	UpdateExpression.prototype = Object.create( Node && Node.prototype );
	  	UpdateExpression.prototype.constructor = UpdateExpression;
	
	  	UpdateExpression.prototype.initialise = function initialise ( transforms ) {
	  		if ( this.argument.type === 'Identifier' ) {
	  			var declaration = this.findScope( false ).findDeclaration( this.argument.name );
	  			if ( declaration && declaration.kind === 'const' ) {
	  				throw new CompileError( this, ((this.argument.name) + " is read-only") );
	  			}
	
	  			// special case – https://gitlab.com/Rich-Harris/buble/issues/150
	  			var statement = declaration && declaration.node.ancestor( 3 );
	  			if ( statement && statement.type === 'ForStatement' && statement.body.contains( this ) ) {
	  				statement.reassigned[ this.argument.name ] = true;
	  			}
	  		}
	
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	return UpdateExpression;
	  }(Node));
	
	  var VariableDeclaration = (function (Node) {
	  	function VariableDeclaration () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) VariableDeclaration.__proto__ = Node;
	  	VariableDeclaration.prototype = Object.create( Node && Node.prototype );
	  	VariableDeclaration.prototype.constructor = VariableDeclaration;
	
	  	VariableDeclaration.prototype.initialise = function initialise ( transforms ) {
	  		this.scope = this.findScope( this.kind === 'var' );
	  		this.declarations.forEach( function ( declarator ) { return declarator.initialise( transforms ); } );
	  	};
	
	  	VariableDeclaration.prototype.transpile = function transpile ( code, transforms ) {
	  		var this$1 = this;
	
	  		var i0 = this.getIndentation();
	  		var kind = this.kind;
	
	  		if ( transforms.letConst && kind !== 'var' ) {
	  			kind = 'var';
	  			code.overwrite( this.start, this.start + this.kind.length, kind, true );
	  		}
	
	  		if ( transforms.destructuring && this.parent.type !== 'ForOfStatement' ) {
	  			var c = this.start;
	  			var lastDeclaratorIsPattern;
	
	  			this.declarations.forEach( function ( declarator, i ) {
	  				if ( declarator.id.type === 'Identifier' ) {
	  					if ( i > 0 && this$1.declarations[ i - 1 ].id.type !== 'Identifier' ) {
	  						code.overwrite( c, declarator.id.start, "var " );
	  					}
	  				} else {
	  					var inline = loopStatement.test( this$1.parent.type );
	
	  					if ( i === 0 ) {
	  						code.remove( c, declarator.id.start );
	  					} else {
	  						code.overwrite( c, declarator.id.start, (";\n" + i0) );
	  					}
	
	  					var simple = declarator.init.type === 'Identifier' && !declarator.init.rewritten;
	
	  					var name = simple ? declarator.init.name : declarator.findScope( true ).createIdentifier( 'ref' );
	
	  					var c$1 = declarator.start;
	
	  					var statementGenerators = [];
	
	  					if ( simple ) {
	  						code.remove( declarator.id.end, declarator.end );
	  					} else {
	  						statementGenerators.push( function ( start, prefix, suffix ) {
	  							code.insertRight( declarator.id.end, ("var " + name) );
	  							code.insertLeft( declarator.init.end, ("" + suffix) );
	  							code.move( declarator.id.end, declarator.end, start );
	  						});
	  					}
	
	  					destructure( code, declarator.findScope( false ), declarator.id, name, inline, statementGenerators );
	
	  					var prefix = inline ? 'var ' : '';
	  					var suffix = inline ? ", " : (";\n" + i0);
	  					statementGenerators.forEach( function ( fn, j ) {
	  						if ( i === this$1.declarations.length - 1 && j === statementGenerators.length - 1 ) {
	  							suffix = inline ? '' : ';';
	  						}
	
	  						fn( declarator.start, j === 0 ? prefix : '', suffix );
	  					});
	  				}
	
	  				declarator.transpile( code, transforms );
	
	  				c = declarator.end;
	  				lastDeclaratorIsPattern = declarator.id.type !== 'Identifier';
	  			});
	
	  			if ( lastDeclaratorIsPattern ) {
	  				code.remove( c, this.end );
	  			}
	  		}
	
	  		else {
	  			this.declarations.forEach( function ( declarator ) {
	  				declarator.transpile( code, transforms );
	  			});
	  		}
	  	};
	
	  	return VariableDeclaration;
	  }(Node));
	
	  var VariableDeclarator = (function (Node) {
	  	function VariableDeclarator () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) VariableDeclarator.__proto__ = Node;
	  	VariableDeclarator.prototype = Object.create( Node && Node.prototype );
	  	VariableDeclarator.prototype.constructor = VariableDeclarator;
	
	  	VariableDeclarator.prototype.initialise = function initialise ( transforms ) {
	  		var kind = this.parent.kind;
	  		if ( kind === 'let' && this.parent.parent.type === 'ForStatement' ) {
	  			kind = 'for.let'; // special case...
	  		}
	
	  		this.parent.scope.addDeclaration( this.id, kind );
	  		Node.prototype.initialise.call( this, transforms );
	  	};
	
	  	VariableDeclarator.prototype.transpile = function transpile ( code, transforms ) {
	  		if ( !this.init && transforms.letConst && this.parent.kind !== 'var' ) {
	  			var inLoop = this.findNearest( /Function|^For(In|Of)?Statement|^(?:Do)?WhileStatement/ );
	  			if ( inLoop && ! /Function/.test( inLoop.type ) && ! this.isLeftDeclaratorOfLoop() ) {
	  				code.insertLeft( this.id.end, ' = (void 0)' );
	  			}
	  		}
	
	  		if ( this.id ) this.id.transpile( code, transforms );
	  		if ( this.init ) this.init.transpile( code, transforms );
	  	};
	
	  	VariableDeclarator.prototype.isLeftDeclaratorOfLoop = function isLeftDeclaratorOfLoop () {
	  		return this.parent
	  			&& this.parent.type === 'VariableDeclaration'
	  			&& this.parent.parent
	  			&& (this.parent.parent.type === 'ForInStatement'
	  				|| this.parent.parent.type === 'ForOfStatement')
	  			&& this.parent.parent.left
	  			&& this.parent.parent.left.declarations[0] === this;
	  	};
	
	  	return VariableDeclarator;
	  }(Node));
	
	  var types = {
	  	ArrayExpression: ArrayExpression,
	  	ArrowFunctionExpression: ArrowFunctionExpression,
	  	AssignmentExpression: AssignmentExpression,
	  	BinaryExpression: BinaryExpression,
	  	BreakStatement: BreakStatement,
	  	CallExpression: CallExpression,
	  	ClassBody: ClassBody,
	  	ClassDeclaration: ClassDeclaration,
	  	ClassExpression: ClassExpression,
	  	ContinueStatement: ContinueStatement,
	  	DoWhileStatement: LoopStatement,
	  	ExportNamedDeclaration: ExportNamedDeclaration,
	  	ExportDefaultDeclaration: ExportDefaultDeclaration,
	  	ForStatement: ForStatement,
	  	ForInStatement: ForInStatement,
	  	ForOfStatement: ForOfStatement,
	  	FunctionDeclaration: FunctionDeclaration,
	  	FunctionExpression: FunctionExpression,
	  	Identifier: Identifier,
	  	IfStatement: IfStatement,
	  	ImportDeclaration: ImportDeclaration,
	  	ImportDefaultSpecifier: ImportDefaultSpecifier,
	  	ImportSpecifier: ImportSpecifier,
	  	JSXAttribute: JSXAttribute,
	  	JSXClosingElement: JSXClosingElement,
	  	JSXElement: JSXElement,
	  	JSXExpressionContainer: JSXExpressionContainer,
	  	JSXOpeningElement: JSXOpeningElement,
	  	JSXSpreadAttribute: JSXSpreadAttribute,
	  	Literal: Literal,
	  	MemberExpression: MemberExpression,
	  	NewExpression: NewExpression,
	  	ObjectExpression: ObjectExpression,
	  	Property: Property,
	  	ReturnStatement: ReturnStatement,
	  	SpreadProperty: SpreadProperty,
	  	Super: Super,
	  	TaggedTemplateExpression: TaggedTemplateExpression,
	  	TemplateElement: TemplateElement,
	  	TemplateLiteral: TemplateLiteral,
	  	ThisExpression: ThisExpression,
	  	UpdateExpression: UpdateExpression,
	  	VariableDeclaration: VariableDeclaration,
	  	VariableDeclarator: VariableDeclarator,
	  	WhileStatement: LoopStatement
	  };
	
	  var statementsWithBlocks = {
	  	IfStatement: 'consequent',
	  	ForStatement: 'body',
	  	ForInStatement: 'body',
	  	ForOfStatement: 'body',
	  	WhileStatement: 'body',
	  	DoWhileStatement: 'body',
	  	ArrowFunctionExpression: 'body'
	  };
	
	  function wrap ( raw, parent ) {
	  	if ( !raw ) return;
	
	  	if ( 'length' in raw ) {
	  		var i = raw.length;
	  		while ( i-- ) wrap( raw[i], parent );
	  		return;
	  	}
	
	  	// with e.g. shorthand properties, key and value are
	  	// the same node. We don't want to wrap an object twice
	  	if ( raw.__wrapped ) return;
	  	raw.__wrapped = true;
	
	  	if ( !keys[ raw.type ] ) {
	  		keys[ raw.type ] = Object.keys( raw ).filter( function ( key ) { return typeof raw[ key ] === 'object'; } );
	  	}
	
	  	// special case – body-less if/for/while statements. TODO others?
	  	var bodyType = statementsWithBlocks[ raw.type ];
	  	if ( bodyType && raw[ bodyType ].type !== 'BlockStatement' ) {
	  		var expression = raw[ bodyType ];
	
	  		// create a synthetic block statement, otherwise all hell
	  		// breaks loose when it comes to block scoping
	  		raw[ bodyType ] = {
	  			start: expression.start,
	  			end: expression.end,
	  			type: 'BlockStatement',
	  			body: [ expression ],
	  			synthetic: true
	  		};
	  	}
	
	  	new Node( raw, parent );
	
	  	var type = ( raw.type === 'BlockStatement' ? BlockStatement : types[ raw.type ] ) || Node;
	  	raw.__proto__ = type.prototype;
	  }
	
	  var letConst = /^(?:let|const)$/;
	
	  function Scope ( options ) {
	  	options = options || {};
	
	  	this.parent = options.parent;
	  	this.isBlockScope = !!options.block;
	
	  	var scope = this;
	  	while ( scope.isBlockScope ) scope = scope.parent;
	  	this.functionScope = scope;
	
	  	this.identifiers = [];
	  	this.declarations = Object.create( null );
	  	this.references = Object.create( null );
	  	this.blockScopedDeclarations = this.isBlockScope ? null : Object.create( null );
	  	this.aliases = this.isBlockScope ? null : Object.create( null );
	  }
	
	  Scope.prototype = {
	  	addDeclaration: function addDeclaration ( node, kind ) {
	  		for ( var i = 0, list = extractNames( node ); i < list.length; i += 1 ) {
	  			var identifier = list[i];
	
	  			var name = identifier.name;
	  			var existingDeclaration = this.declarations[ name ];
	  			if ( existingDeclaration && ( letConst.test( kind ) || letConst.test( existingDeclaration.kind ) ) ) {
	  				// TODO warn about double var declarations?
	  				throw new CompileError( identifier, (name + " is already declared") );
	  			}
	
	  			var declaration = { name: name, node: identifier, kind: kind, instances: [] };
	  			this.declarations[ name ] = declaration;
	
	  			if ( this.isBlockScope ) {
	  				if ( !this.functionScope.blockScopedDeclarations[ name ] ) this.functionScope.blockScopedDeclarations[ name ] = [];
	  				this.functionScope.blockScopedDeclarations[ name ].push( declaration );
	  			}
	  		}
	  	},
	
	  	addReference: function addReference ( identifier ) {
	  		if ( this.consolidated ) {
	  			this.consolidateReference( identifier );
	  		} else {
	  			this.identifiers.push( identifier );
	  		}
	  	},
	
	  	consolidate: function consolidate () {
	  		var this$1 = this;
	
	  		for ( var i = 0; i < this$1.identifiers.length; i += 1 ) { // we might push to the array during consolidation, so don't cache length
	  			var identifier = this$1.identifiers[i];
	  			this$1.consolidateReference( identifier );
	  		}
	
	  		this.consolidated = true; // TODO understand why this is necessary... seems bad
	  	},
	
	  	consolidateReference: function consolidateReference ( identifier ) {
	  		var declaration = this.declarations[ identifier.name ];
	  		if ( declaration ) {
	  			declaration.instances.push( identifier );
	  		} else {
	  			this.references[ identifier.name ] = true;
	  			if ( this.parent ) this.parent.addReference( identifier );
	  		}
	  	},
	
	  	contains: function contains ( name ) {
	  		return this.declarations[ name ] ||
	  		       ( this.parent ? this.parent.contains( name ) : false );
	  	},
	
	  	createIdentifier: function createIdentifier ( base ) {
	  		var this$1 = this;
	
	  		if ( typeof base === 'number' ) base = base.toString();
	
	  		base = base
	  			.replace( /\s/g, '' )
	  			.replace( /\[([^\]]+)\]/g, '_$1' )
	  			.replace( /[^a-zA-Z0-9_$]/g, '_' )
	  			.replace( /_{2,}/, '_' );
	
	  		var name = base;
	  		var counter = 1;
	
	  		while ( this$1.declarations[ name ] || this$1.references[ name ] || this$1.aliases[ name ] || name in reserved ) {
	  			name = base + "$" + (counter++);
	  		}
	
	  		this.aliases[ name ] = true;
	  		return name;
	  	},
	
	  	findDeclaration: function findDeclaration ( name ) {
	  		return this.declarations[ name ] ||
	  		       ( this.parent && this.parent.findDeclaration( name ) );
	  	}
	  };
	
	  function isUseStrict ( node ) {
	  	if ( !node ) return false;
	  	if ( node.type !== 'ExpressionStatement' ) return false;
	  	if ( node.expression.type !== 'Literal' ) return false;
	  	return node.expression.value === 'use strict';
	  }
	
	  var BlockStatement = (function (Node) {
	  	function BlockStatement () {
	  		Node.apply(this, arguments);
	  	}
	
	  	if ( Node ) BlockStatement.__proto__ = Node;
	  	BlockStatement.prototype = Object.create( Node && Node.prototype );
	  	BlockStatement.prototype.constructor = BlockStatement;
	
	  	BlockStatement.prototype.createScope = function createScope () {
	  		var this$1 = this;
	
	  		this.parentIsFunction = /Function/.test( this.parent.type );
	  		this.isFunctionBlock = this.parentIsFunction || this.parent.type === 'Root';
	  		this.scope = new Scope({
	  			block: !this.isFunctionBlock,
	  			parent: this.parent.findScope( false )
	  		});
	
	  		if ( this.parentIsFunction ) {
	  			this.parent.params.forEach( function ( node ) {
	  				this$1.scope.addDeclaration( node, 'param' );
	  			});
	  		}
	  	};
	
	  	BlockStatement.prototype.initialise = function initialise ( transforms ) {
	  		this.thisAlias = null;
	  		this.argumentsAlias = null;
	  		this.defaultParameters = [];
	
	  		// normally the scope gets created here, during initialisation,
	  		// but in some cases (e.g. `for` statements), we need to create
	  		// the scope early, as it pertains to both the init block and
	  		// the body of the statement
	  		if ( !this.scope ) this.createScope();
	
	  		this.body.forEach( function ( node ) { return node.initialise( transforms ); } );
	
	  		this.scope.consolidate();
	  	};
	
	  	BlockStatement.prototype.findLexicalBoundary = function findLexicalBoundary () {
	  		if ( this.type === 'Program' ) return this;
	  		if ( /^Function/.test( this.parent.type ) ) return this;
	
	  		return this.parent.findLexicalBoundary();
	  	};
	
	  	BlockStatement.prototype.findScope = function findScope ( functionScope ) {
	  		if ( functionScope && !this.isFunctionBlock ) return this.parent.findScope( functionScope );
	  		return this.scope;
	  	};
	
	  	BlockStatement.prototype.getArgumentsAlias = function getArgumentsAlias () {
	  		if ( !this.argumentsAlias ) {
	  			this.argumentsAlias = this.scope.createIdentifier( 'arguments' );
	  		}
	
	  		return this.argumentsAlias;
	  	};
	
	  	BlockStatement.prototype.getArgumentsArrayAlias = function getArgumentsArrayAlias () {
	  		if ( !this.argumentsArrayAlias ) {
	  			this.argumentsArrayAlias = this.scope.createIdentifier( 'argsArray' );
	  		}
	
	  		return this.argumentsArrayAlias;
	  	};
	
	  	BlockStatement.prototype.getThisAlias = function getThisAlias () {
	  		if ( !this.thisAlias ) {
	  			this.thisAlias = this.scope.createIdentifier( 'this' );
	  		}
	
	  		return this.thisAlias;
	  	};
	
	  	BlockStatement.prototype.getIndentation = function getIndentation () {
	  		var this$1 = this;
	
	  		if ( this.indentation === undefined ) {
	  			var source = this.program.magicString.original;
	
	  			var useOuter = this.synthetic || !this.body.length;
	  			var c = useOuter ? this.start : this.body[0].start;
	
	  			while ( c && source[c] !== '\n' ) c -= 1;
	
	  			this.indentation = '';
	
	  			while ( true ) { // eslint-disable-line no-constant-condition
	  				c += 1;
	  				var char = source[c];
	
	  				if ( char !== ' ' && char !== '\t' ) break;
	
	  				this$1.indentation += char;
	  			}
	
	  			var indentString = this.program.magicString.getIndentString();
	
	  			// account for dedented class constructors
	  			var parent = this.parent;
	  			while ( parent ) {
	  				if ( parent.kind === 'constructor' && !parent.parent.parent.superClass ) {
	  					this$1.indentation = this$1.indentation.replace( indentString, '' );
	  				}
	
	  				parent = parent.parent;
	  			}
	
	  			if ( useOuter ) this.indentation += indentString;
	  		}
	
	  		return this.indentation;
	  	};
	
	  	BlockStatement.prototype.transpile = function transpile ( code, transforms ) {
	  		var this$1 = this;
	
	  		var indentation = this.getIndentation();
	
	  		var introStatementGenerators = [];
	
	  		if ( this.argumentsAlias ) {
	  			introStatementGenerators.push( function ( start, prefix, suffix ) {
	  				var assignment = prefix + "var " + (this$1.argumentsAlias) + " = arguments" + suffix;
	  				code.insertLeft( start, assignment );
	  			});
	  		}
	
	  		if ( this.thisAlias ) {
	  			introStatementGenerators.push( function ( start, prefix, suffix ) {
	  				var assignment = prefix + "var " + (this$1.thisAlias) + " = this" + suffix;
	  				code.insertLeft( start, assignment );
	  			});
	  		}
	
	  		if ( this.argumentsArrayAlias ) {
	  			introStatementGenerators.push( function ( start, prefix, suffix ) {
	  				var i = this$1.scope.createIdentifier( 'i' );
	  				var assignment = prefix + "var " + i + " = arguments.length, " + (this$1.argumentsArrayAlias) + " = Array(" + i + ");\n" + indentation + "while ( " + i + "-- ) " + (this$1.argumentsArrayAlias) + "[" + i + "] = arguments[" + i + "]" + suffix;
	  				code.insertLeft( start, assignment );
	  			});
	  		}
	
	  		if ( /Function/.test( this.parent.type ) ) {
	  			this.transpileParameters( code, transforms, indentation, introStatementGenerators );
	  		}
	
	  		if ( transforms.letConst && this.isFunctionBlock ) {
	  			this.transpileBlockScopedIdentifiers( code );
	  		}
	
	  		Node.prototype.transpile.call( this, code, transforms );
	
	  		if ( this.synthetic ) {
	  			if ( this.parent.type === 'ArrowFunctionExpression' ) {
	  				var expr = this.body[0];
	
	  				if ( introStatementGenerators.length ) {
	  					code.insertLeft( this.start, "{" ).insertRight( this.end, ((this.parent.getIndentation()) + "}") );
	
	  					code.insertRight( expr.start, ("\n" + indentation + "return ") );
	  					code.insertLeft( expr.end, ";\n" );
	  				} else if ( transforms.arrow ) {
	  					code.insertLeft( expr.start, "{ return " );
	  					code.insertLeft( expr.end, "; }" );
	  				}
	  			}
	
	  			else if ( introStatementGenerators.length ) {
	  				code.insertLeft( this.start, "{" ).insertRight( this.end, "}" );
	  			}
	  		}
	
	  		var start;
	  		if ( isUseStrict( this.body[0] ) ) {
	  			start = this.body[0].end;
	  		} else if ( this.synthetic || this.parent.type === 'Root' ) {
	  			start = this.start;
	  		} else {
	  			start = this.start + 1;
	  		}
	
	  		var prefix = "\n" + indentation;
	  		var suffix = ';';
	  		introStatementGenerators.forEach( function ( fn, i ) {
	  			if ( i === introStatementGenerators.length - 1 ) suffix = ";\n";
	  			fn( start, prefix, suffix );
	  		});
	  	};
	
	  	BlockStatement.prototype.transpileParameters = function transpileParameters ( code, transforms, indentation, introStatementGenerators ) {
	  		var this$1 = this;
	
	  		var params = this.parent.params;
	
	  		params.forEach( function ( param ) {
	  			if ( param.type === 'AssignmentPattern' && param.left.type === 'Identifier' ) {
	  				if ( transforms.defaultParameter ) {
	  					introStatementGenerators.push( function ( start, prefix, suffix ) {
	  						var lhs = prefix + "if ( " + (param.left.name) + " === void 0 ) " + (param.left.name);
	
	  						code
	  							.insertRight( param.left.end, lhs )
	  							.move( param.left.end, param.right.end, start )
	  							.insertLeft( param.right.end, suffix );
	  					});
	  				}
	  			}
	
	  			else if ( param.type === 'RestElement' ) {
	  				if ( transforms.spreadRest ) {
	  					introStatementGenerators.push( function ( start, prefix, suffix ) {
	  						var penultimateParam = params[ params.length - 2 ];
	
	  						if ( penultimateParam ) {
	  							code.remove( penultimateParam ? penultimateParam.end : param.start, param.end );
	  						} else {
	  							var start$1 = param.start, end = param.end; // TODO https://gitlab.com/Rich-Harris/buble/issues/8
	
	  							while ( /\s/.test( code.original[ start$1 - 1 ] ) ) start$1 -= 1;
	  							while ( /\s/.test( code.original[ end ] ) ) end += 1;
	
	  							code.remove( start$1, end );
	  						}
	
	  						var name = param.argument.name;
	  						var len = this$1.scope.createIdentifier( 'len' );
	  						var count = params.length - 1;
	
	  						if ( count ) {
	  							code.insertLeft( start, (prefix + "var " + name + " = [], " + len + " = arguments.length - " + count + ";\n" + indentation + "while ( " + len + "-- > 0 ) " + name + "[ " + len + " ] = arguments[ " + len + " + " + count + " ]" + suffix) );
	  						} else {
	  							code.insertLeft( start, (prefix + "var " + name + " = [], " + len + " = arguments.length;\n" + indentation + "while ( " + len + "-- ) " + name + "[ " + len + " ] = arguments[ " + len + " ]" + suffix) );
	  						}
	  					});
	  				}
	  			}
	
	  			else if ( param.type !== 'Identifier' ) {
	  				if ( transforms.parameterDestructuring ) {
	  					var ref = this$1.scope.createIdentifier( 'ref' );
	  					destructure( code, this$1.scope, param, ref, false, introStatementGenerators );
	  					code.insertLeft( param.start, ref );
	  				}
	  			}
	  		});
	  	};
	
	  	BlockStatement.prototype.transpileBlockScopedIdentifiers = function transpileBlockScopedIdentifiers ( code ) {
	  		var this$1 = this;
	
	  		Object.keys( this.scope.blockScopedDeclarations ).forEach( function ( name ) {
	  			var declarations = this$1.scope.blockScopedDeclarations[ name ];
	
	  			for ( var i = 0, list = declarations; i < list.length; i += 1 ) {
	  				var declaration = list[i];
	
	  				var cont = false; // TODO implement proper continue...
	
	  				if ( declaration.kind === 'for.let' ) {
	  					// special case
	  					var forStatement = declaration.node.findNearest( 'ForStatement' );
	
	  					if ( forStatement.shouldRewriteAsFunction ) {
	  						var outerAlias = this$1.scope.createIdentifier( name );
	  						var innerAlias = forStatement.reassigned[ name ] ?
	  							this$1.scope.createIdentifier( name ) :
	  							name;
	
	  						declaration.name = outerAlias;
	  						code.overwrite( declaration.node.start, declaration.node.end, outerAlias, true );
	
	  						forStatement.aliases[ name ] = {
	  							outer: outerAlias,
	  							inner: innerAlias
	  						};
	
	  						for ( var i$1 = 0, list$1 = declaration.instances; i$1 < list$1.length; i$1 += 1 ) {
	  							var identifier = list$1[i$1];
	
	  							var alias = forStatement.body.contains( identifier ) ?
	  								innerAlias :
	  								outerAlias;
	
	  							if ( name !== alias ) {
	  								code.overwrite( identifier.start, identifier.end, alias, true );
	  							}
	  						}
	
	  						cont = true;
	  					}
	  				}
	
	  				if ( !cont ) {
	  					var alias$1 = this$1.scope.createIdentifier( name );
	
	  					if ( name !== alias$1 ) {
	  						declaration.name = alias$1;
	  						code.overwrite( declaration.node.start, declaration.node.end, alias$1, true );
	
	  						for ( var i$2 = 0, list$2 = declaration.instances; i$2 < list$2.length; i$2 += 1 ) {
	  							var identifier$1 = list$2[i$2];
	
	  							identifier$1.rewritten = true;
	  							code.overwrite( identifier$1.start, identifier$1.end, alias$1, true );
	  						}
	  					}
	  				}
	  			}
	  		});
	  	};
	
	  	return BlockStatement;
	  }(Node));
	
	  function Program ( source, ast, transforms, options ) {
	  	var this$1 = this;
	
	  	this.type = 'Root';
	
	  	// options
	  	this.jsx = options.jsx || 'React.createElement';
	  	this.options = options;
	
	  	this.source = source;
	  	this.magicString = new MagicString( source );
	
	  	this.ast = ast;
	  	this.depth = 0;
	
	  	wrap( this.body = ast, this );
	  	this.body.__proto__ = BlockStatement.prototype;
	
	  	this.indentExclusionElements = [];
	  	this.body.initialise( transforms );
	
	  	this.indentExclusions = Object.create( null );
	  	for ( var i$1 = 0, list = this.indentExclusionElements; i$1 < list.length; i$1 += 1 ) {
	  		var node = list[i$1];
	
	  		for ( var i = node.start; i < node.end; i += 1 ) {
	  			this$1.indentExclusions[ i ] = true;
	  		}
	  	}
	
	  	this.body.transpile( this.magicString, transforms );
	  }
	
	  Program.prototype = {
	  	export: function export$1 ( options ) {
	  		if ( options === void 0 ) options = {};
	
	  		return {
	  			code: this.magicString.toString(),
	  			map: this.magicString.generateMap({
	  				file: options.file,
	  				source: options.source,
	  				includeContent: options.includeContent !== false
	  			})
	  		};
	  	},
	
	  	findNearest: function findNearest () {
	  		return null;
	  	},
	
	  	findScope: function findScope () {
	  		return null;
	  	}
	  };
	
	  var matrix = {
	  	chrome: {
	  		    48: 1333689725,
	  		    49: 1342078975,
	  		    50: 1610514431,
	  		    51: 1610514431,
	  		    52: 2147385343
	  	},
	  	firefox: {
	  		    43: 1207307741,
	  		    44: 1207307741,
	  		    45: 1207307741,
	  		    46: 1476267485,
	  		    47: 1476296671,
	  		    48: 1476296671
	  	},
	  	safari: {
	  		     8: 1073741824,
	  		     9: 1328940894
	  	},
	  	ie: {
	  		     8: 0,
	  		     9: 1073741824,
	  		    10: 1073741824,
	  		    11: 1073770592
	  	},
	  	edge: {
	  		    12: 1591620701,
	  		    13: 1608400479
	  	},
	  	node: {
	  		'0.10': 1075052608,
	  		'0.12': 1091830852,
	  		     4: 1327398527,
	  		     5: 1327398527,
	  		     6: 1610514431
	  	}
	  };
	
	  var features = [
	  	'arrow',
	  	'classes',
	  	'collections',
	  	'computedProperty',
	  	'conciseMethodProperty',
	  	'constLoop',
	  	'constRedef',
	  	'defaultParameter',
	  	'destructuring',
	  	'extendNatives',
	  	'forOf',
	  	'generator',
	  	'letConst',
	  	'letLoop',
	  	'letLoopScope',
	  	'moduleExport',
	  	'moduleImport',
	  	'numericLiteral',
	  	'objectProto',
	  	'objectSuper',
	  	'oldOctalLiteral',
	  	'parameterDestructuring',
	  	'spreadRest',
	  	'stickyRegExp',
	  	'symbol',
	  	'templateString',
	  	'unicodeEscape',
	  	'unicodeIdentifier',
	  	'unicodeRegExp',
	
	  	// ES2016
	  	'exponentiation',
	
	  	// additional transforms, not from
	  	// https://featuretests.io
	  	'reservedProperties'
	  ];
	
	  var version = "0.15.2";
	
	  var ref = [
	  	acornObjectSpread,
	  	acornJsx
	  ].reduce( function ( final, plugin ) { return plugin( final ); }, acorn$1 );
	  var parse = ref.parse;
	
	  var dangerousTransforms = [
	  	'dangerousTaggedTemplateString',
	  	'dangerousForOf'
	  ];
	
	  function target ( target ) {
	  	var targets = Object.keys( target );
	  	var bitmask = targets.length ?
	  		2147483647 :
	  		1073741824;
	
	  	Object.keys( target ).forEach( function ( environment ) {
	  		var versions = matrix[ environment ];
	  		if ( !versions ) throw new Error( ("Unknown environment '" + environment + "'. Please raise an issue at https://gitlab.com/Rich-Harris/buble/issues") );
	
	  		var targetVersion = target[ environment ];
	  		if ( !( targetVersion in versions ) ) throw new Error( ("Support data exists for the following versions of " + environment + ": " + (Object.keys( versions ).join( ', ')) + ". Please raise an issue at https://gitlab.com/Rich-Harris/buble/issues") );
	  		var support = versions[ targetVersion ];
	
	  		bitmask &= support;
	  	});
	
	  	var transforms = Object.create( null );
	  	features.forEach( function ( name, i ) {
	  		transforms[ name ] = !( bitmask & 1 << i );
	  	});
	
	  	dangerousTransforms.forEach( function ( name ) {
	  		transforms[ name ] = false;
	  	});
	
	  	return transforms;
	  }
	
	  function transform ( source, options ) {
	  	if ( options === void 0 ) options = {};
	
	  	var ast;
	
	  	try {
	  		ast = parse( source, {
	  			ecmaVersion: 7,
	  			preserveParens: true,
	  			sourceType: 'module',
	  			plugins: {
	  				jsx: true,
	  				objectSpread: true
	  			}
	  		});
	  	} catch ( err ) {
	  		err.snippet = getSnippet( source, err.loc );
	  		err.toString = function () { return ((err.name) + ": " + (err.message) + "\n" + (err.snippet)); };
	  		throw err;
	  	}
	
	  	var transforms = target( options.target || {} );
	  	Object.keys( options.transforms || {} ).forEach( function ( name ) {
	  		if ( name === 'modules' ) {
	  			if ( !( 'moduleImport' in options.transforms ) ) transforms.moduleImport = options.transforms.modules;
	  			if ( !( 'moduleExport' in options.transforms ) ) transforms.moduleExport = options.transforms.modules;
	  			return;
	  		}
	
	  		if ( !( name in transforms ) ) throw new Error( ("Unknown transform '" + name + "'") );
	  		transforms[ name ] = options.transforms[ name ];
	  	});
	
	  	return new Program( source, ast, transforms, options ).export( options );
	  }
	
	  exports.target = target;
	  exports.transform = transform;
	  exports.VERSION = version;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));
	//# sourceMappingURL=buble.deps.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(219).Buffer))

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(217)
	var ieee754 = __webpack_require__(682)
	var isArray = __webpack_require__(220)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

	/**
	 * Global Names
	 */
	
	var globals = /\b(Array|Date|Object|Math|JSON)\b/g;
	
	/**
	 * Return immediate identifiers parsed from `str`.
	 *
	 * @param {String} str
	 * @param {String|Function} map function or prefix
	 * @return {Array}
	 * @api public
	 */
	
	module.exports = function(str, fn){
	  var p = unique(props(str));
	  if (fn && 'string' == typeof fn) fn = prefixed(fn);
	  if (fn) return map(str, p, fn);
	  return p;
	};
	
	/**
	 * Return immediate identifiers in `str`.
	 *
	 * @param {String} str
	 * @return {Array}
	 * @api private
	 */
	
	function props(str) {
	  return str
	    .replace(/\.\w+|\w+ *\(|"[^"]*"|'[^']*'|\/([^/]+)\//g, '')
	    .replace(globals, '')
	    .match(/[a-zA-Z_]\w*/g)
	    || [];
	}
	
	/**
	 * Return `str` with `props` mapped with `fn`.
	 *
	 * @param {String} str
	 * @param {Array} props
	 * @param {Function} fn
	 * @return {String}
	 * @api private
	 */
	
	function map(str, props, fn) {
	  var re = /\.\w+|\w+ *\(|"[^"]*"|'[^']*'|\/([^/]+)\/|[a-zA-Z_]\w*/g;
	  return str.replace(re, function(_){
	    if ('(' == _[_.length - 1]) return fn(_);
	    if (!~props.indexOf(_)) return _;
	    return fn(_);
	  });
	}
	
	/**
	 * Return unique array.
	 *
	 * @param {Array} arr
	 * @return {Array}
	 * @api private
	 */
	
	function unique(arr) {
	  var ret = [];
	
	  for (var i = 0; i < arr.length; i++) {
	    if (~ret.indexOf(arr[i])) continue;
	    ret.push(arr[i]);
	  }
	
	  return ret;
	}
	
	/**
	 * Map with prefix `str`.
	 */
	
	function prefixed(str) {
	  return function(_){
	    return str + _;
	  };
	}


/***/ }),

/***/ 222:
/***/ (function(module, exports) {

	/**
	 * Expose `xor`
	 */
	
	module.exports = xor;
	
	/**
	 * XOR utility
	 *
	 * T T F
	 * T F T
	 * F T T
	 * F F F
	 *
	 * @param {Boolean} a
	 * @param {Boolean} b
	 * @return {Boolean}
	 */
	
	function xor(a, b) {
	  return !a != !b;
	}


/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module Dependencies
	 */
	
	var xor, props;
	
	try {
	  xor = __webpack_require__(222);
	} catch (e) {
	  xor = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"xor\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	}
	
	try {
	  props = __webpack_require__(221);
	} catch (e) {
	  props = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"props\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	}
	
	/**
	 * Export `Iterator`
	 */
	
	module.exports = Iterator;
	
	/**
	 * Initialize `Iterator`
	 *
	 * @param {Node} node
	 * @param {Node} root
	 * @return {Iterator} self
	 * @api public
	 */
	
	function Iterator(node, root) {
	  if (!(this instanceof Iterator)) return new Iterator(node, root);
	  this.node = this.start = this.peeked = node;
	  this.root = root;
	  this.closingTag = false;
	  this._revisit = true;
	  this._selects = [];
	  this._rejects = [];
	
	  if (node && this.higher(node)) {
	    throw new Error('root must be a parent or ancestor to node');
	  }
	}
	
	/**
	 * Reset the Iterator
	 *
	 * @param {Node} node (optional)
	 * @return {Iterator} self
	 * @api public
	 */
	
	Iterator.prototype.reset = function(node) {
	  this.node = node || this.start;
	  return this;
	};
	
	/**
	 * Revisit element nodes. Defaults to `true`
	 */
	
	Iterator.prototype.revisit = function(revisit) {
	  this._revisit = undefined == revisit ? true : revisit;
	  return this;
	};
	
	/**
	 * Jump to the opening tag
	 */
	
	Iterator.prototype.opening = function() {
	  if (1 == this.node.nodeType) this.closingTag = false;
	  return this;
	};
	
	/**
	 * Jump to the closing tag
	 */
	
	Iterator.prototype.atOpening = function() {
	  return !this.closingTag;
	};
	
	
	/**
	 * Jump to the closing tag
	 */
	
	Iterator.prototype.closing = function() {
	  if (1 == this.node.nodeType) this.closingTag = true;
	  return this;
	};
	
	/**
	 * Jump to the closing tag
	 */
	
	Iterator.prototype.atClosing = function() {
	  return this.closingTag;
	};
	
	/**
	 * Next node
	 *
	 * @param {Number} type
	 * @return {Node|null}
	 * @api public
	 */
	
	Iterator.prototype.next = traverse('nextSibling', 'firstChild');
	
	/**
	 * Previous node
	 *
	 * @param {Number} type
	 * @return {Node|null}
	 * @api public
	 */
	
	Iterator.prototype.previous =
	Iterator.prototype.prev = traverse('previousSibling', 'lastChild');
	
	/**
	 * Make traverse function
	 *
	 * @param {String} dir
	 * @param {String} child
	 * @return {Function}
	 * @api private
	 */
	
	function traverse(dir, child) {
	  var next = dir == 'nextSibling';
	  return function walk(expr, n, peek) {
	    expr = this.compile(expr);
	    n = n && n > 0 ? n : 1;
	    var node = this.node;
	    var closing = this.closingTag;
	    var revisit = this._revisit;
	
	    while (node) {
	      if (xor(next, closing) && node[child]) {
	        // element with children: <em>...</em>
	        node = node[child];
	        closing = !next;
	      } else if (1 == node.nodeType && !node[child] && xor(next, closing)) {
	        // empty element tag: <em></em>
	        closing = next;
	        if (!revisit) continue;
	      } else if (node[dir]) {
	        // element has a neighbor: ...<em></em>...
	        node = node[dir];
	        closing = !next;
	      } else {
	        // done with current layer, move up.
	        node = node.parentNode;
	        closing = next;
	        if (!revisit) continue;
	      }
	
	      if (!node || this.higher(node, this.root)) break;
	
	      if (expr(node) && this.selects(node, peek) && this.rejects(node, peek)) {
	        if (--n) continue;
	        if (!peek) this.node = node;
	        this.closingTag = closing;
	        return node;
	      }
	    }
	
	    return null;
	  };
	}
	
	/**
	 * Select nodes that cause `expr(node)`
	 * to be truthy
	 *
	 * @param {Number|String|Function} expr
	 * @return {Iterator} self
	 * @api public
	 */
	
	Iterator.prototype.select = function(expr) {
	  expr = this.compile(expr);
	  this._selects.push(expr);
	  return this;
	};
	
	/**
	 * Run through the selects ORing each
	 *
	 * @param {Node} node
	 * @param {Boolean} peek
	 * @return {Boolean}
	 * @api private
	 */
	
	Iterator.prototype.selects = function(node, peek) {
	  var exprs = this._selects;
	  var len = exprs.length;
	  if (!len) return true;
	
	  for (var i = 0; i < len; i++) {
	    if (exprs[i].call(this, node, peek)) return true;
	  };
	
	  return false;
	};
	
	/**
	 * Select nodes that cause `expr(node)`
	 * to be falsy
	 *
	 * @param {Number|String|Function} expr
	 * @return {Iterator} self
	 * @api public
	 */
	
	Iterator.prototype.reject = function(expr) {
	  expr = this.compile(expr);
	  this._rejects.push(expr);
	  return this;
	};
	
	/**
	 * Run through the reject expressions ANDing each
	 *
	 * @param {Node} node
	 * @param {Boolean} peek
	 * @return {Boolean}
	 * @api private
	 */
	
	Iterator.prototype.rejects = function(node, peek) {
	  var exprs = this._rejects;
	  var len = exprs.length;
	  if (!len) return true;
	
	  for (var i = 0; i < len; i++) {
	    if (exprs[i].call(this, node, peek)) return false;
	  };
	
	  return true;
	};
	
	/**
	 * Check if node is higher
	 * than root.
	 *
	 * @param {Node} node
	 * @param {Node} root
	 * @return {Boolean}
	 * @api private
	 */
	
	Iterator.prototype.higher = function(node) {
	  var root = this.root;
	  if (!root) return false;
	  node = node.parentNode;
	  while (node && node != root) node = node.parentNode;
	  return node != root;
	};
	
	/**
	 * Compile an expression
	 *
	 * @param {String|Function|Number} expr
	 * @return {Function}
	 */
	
	Iterator.prototype.compile = function(expr) {
	  switch (typeof expr) {
	    case 'number':
	      return function(node) { return expr == node.nodeType; };
	    case 'string':
	      return new Function('node', 'return ' + props(expr, 'node.'));
	    case 'function':
	      return expr;
	    default:
	      return function() { return true; };
	  }
	};
	
	/**
	 * Peek in either direction
	 * `n` nodes. Peek backwards
	 * using negative numbers.
	 *
	 * @param {Number} n (optional)
	 * @return {Node|null}
	 * @api public
	 */
	
	Iterator.prototype.peak =
	Iterator.prototype.peek = function(expr, n) {
	  if (arguments.length == 1) n = expr, expr = true;
	  n = undefined == n ? 1 : n;
	  if (!n) return this.node;
	  else if (n > 0) return this.next(expr, n, true);
	  else return this.prev(expr, Math.abs(n), true);
	};
	
	/**
	 * Add a plugin
	 *
	 * @param {Function} fn
	 * @return {Iterator}
	 * @api public
	 */
	
	Iterator.prototype.use = function(fn) {
	  fn(this);
	  return this;
	};


/***/ }),

/***/ 682:
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),

/***/ 1028:
/***/ (function(module, exports) {

	Prism.languages.clike = {
		'comment': [
			{
				pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
				lookbehind: true,
				greedy: true
			},
			{
				pattern: /(^|[^\\:])\/\/.*/,
				lookbehind: true,
				greedy: true
			}
		],
		'string': {
			pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
			greedy: true
		},
		'class-name': {
			pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
			lookbehind: true,
			inside: {
				'punctuation': /[.\\]/
			}
		},
		'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
		'boolean': /\b(?:false|true)\b/,
		'function': /\b\w+(?=\()/,
		'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
		'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
		'punctuation': /[{}[\];(),.:]/
	};


/***/ }),

/***/ 1029:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/// <reference lib="WebWorker"/>
	
	var _self = (typeof window !== 'undefined')
		? window   // if in browser
		: (
			(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
				? self // if in worker
				: {}   // if in node js
		);
	
	/**
	 * Prism: Lightweight, robust, elegant syntax highlighting
	 *
	 * @license MIT <https://opensource.org/licenses/MIT>
	 * @author Lea Verou <https://lea.verou.me>
	 * @namespace
	 * @public
	 */
	var Prism = (function (_self) {
	
		// Private helper vars
		var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
		var uniqueId = 0;
	
		// The grammar object for plaintext
		var plainTextGrammar = {};
	
	
		var _ = {
			/**
			 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
			 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
			 * additional languages or plugins yourself.
			 *
			 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
			 *
			 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
			 * empty Prism object into the global scope before loading the Prism script like this:
			 *
			 * ```js
			 * window.Prism = window.Prism || {};
			 * Prism.manual = true;
			 * // add a new <script> to load Prism's script
			 * ```
			 *
			 * @default false
			 * @type {boolean}
			 * @memberof Prism
			 * @public
			 */
			manual: _self.Prism && _self.Prism.manual,
			/**
			 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
			 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
			 * own worker, you don't want it to do this.
			 *
			 * By setting this value to `true`, Prism will not add its own listeners to the worker.
			 *
			 * You obviously have to change this value before Prism executes. To do this, you can add an
			 * empty Prism object into the global scope before loading the Prism script like this:
			 *
			 * ```js
			 * window.Prism = window.Prism || {};
			 * Prism.disableWorkerMessageHandler = true;
			 * // Load Prism's script
			 * ```
			 *
			 * @default false
			 * @type {boolean}
			 * @memberof Prism
			 * @public
			 */
			disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
	
			/**
			 * A namespace for utility methods.
			 *
			 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
			 * change or disappear at any time.
			 *
			 * @namespace
			 * @memberof Prism
			 */
			util: {
				encode: function encode(tokens) {
					if (tokens instanceof Token) {
						return new Token(tokens.type, encode(tokens.content), tokens.alias);
					} else if (Array.isArray(tokens)) {
						return tokens.map(encode);
					} else {
						return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
					}
				},
	
				/**
				 * Returns the name of the type of the given value.
				 *
				 * @param {any} o
				 * @returns {string}
				 * @example
				 * type(null)      === 'Null'
				 * type(undefined) === 'Undefined'
				 * type(123)       === 'Number'
				 * type('foo')     === 'String'
				 * type(true)      === 'Boolean'
				 * type([1, 2])    === 'Array'
				 * type({})        === 'Object'
				 * type(String)    === 'Function'
				 * type(/abc+/)    === 'RegExp'
				 */
				type: function (o) {
					return Object.prototype.toString.call(o).slice(8, -1);
				},
	
				/**
				 * Returns a unique number for the given object. Later calls will still return the same number.
				 *
				 * @param {Object} obj
				 * @returns {number}
				 */
				objId: function (obj) {
					if (!obj['__id']) {
						Object.defineProperty(obj, '__id', { value: ++uniqueId });
					}
					return obj['__id'];
				},
	
				/**
				 * Creates a deep clone of the given object.
				 *
				 * The main intended use of this function is to clone language definitions.
				 *
				 * @param {T} o
				 * @param {Record<number, any>} [visited]
				 * @returns {T}
				 * @template T
				 */
				clone: function deepClone(o, visited) {
					visited = visited || {};
	
					var clone; var id;
					switch (_.util.type(o)) {
						case 'Object':
							id = _.util.objId(o);
							if (visited[id]) {
								return visited[id];
							}
							clone = /** @type {Record<string, any>} */ ({});
							visited[id] = clone;
	
							for (var key in o) {
								if (o.hasOwnProperty(key)) {
									clone[key] = deepClone(o[key], visited);
								}
							}
	
							return /** @type {any} */ (clone);
	
						case 'Array':
							id = _.util.objId(o);
							if (visited[id]) {
								return visited[id];
							}
							clone = [];
							visited[id] = clone;
	
							(/** @type {Array} */(/** @type {any} */(o))).forEach(function (v, i) {
								clone[i] = deepClone(v, visited);
							});
	
							return /** @type {any} */ (clone);
	
						default:
							return o;
					}
				},
	
				/**
				 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
				 *
				 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
				 *
				 * @param {Element} element
				 * @returns {string}
				 */
				getLanguage: function (element) {
					while (element) {
						var m = lang.exec(element.className);
						if (m) {
							return m[1].toLowerCase();
						}
						element = element.parentElement;
					}
					return 'none';
				},
	
				/**
				 * Sets the Prism `language-xxxx` class of the given element.
				 *
				 * @param {Element} element
				 * @param {string} language
				 * @returns {void}
				 */
				setLanguage: function (element, language) {
					// remove all `language-xxxx` classes
					// (this might leave behind a leading space)
					element.className = element.className.replace(RegExp(lang, 'gi'), '');
	
					// add the new `language-xxxx` class
					// (using `classList` will automatically clean up spaces for us)
					element.classList.add('language-' + language);
				},
	
				/**
				 * Returns the script element that is currently executing.
				 *
				 * This does __not__ work for line script element.
				 *
				 * @returns {HTMLScriptElement | null}
				 */
				currentScript: function () {
					if (typeof document === 'undefined') {
						return null;
					}
					if (document.currentScript && document.currentScript.tagName === 'SCRIPT' && 1 < 2 /* hack to trip TS' flow analysis */) {
						return /** @type {any} */ (document.currentScript);
					}
	
					// IE11 workaround
					// we'll get the src of the current script by parsing IE11's error stack trace
					// this will not work for inline scripts
	
					try {
						throw new Error();
					} catch (err) {
						// Get file src url from stack. Specifically works with the format of stack traces in IE.
						// A stack will look like this:
						//
						// Error
						//    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
						//    at Global code (http://localhost/components/prism-core.js:606:1)
	
						var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
						if (src) {
							var scripts = document.getElementsByTagName('script');
							for (var i in scripts) {
								if (scripts[i].src == src) {
									return scripts[i];
								}
							}
						}
						return null;
					}
				},
	
				/**
				 * Returns whether a given class is active for `element`.
				 *
				 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
				 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
				 * given class is just the given class with a `no-` prefix.
				 *
				 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
				 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
				 * ancestors have the given class or the negated version of it, then the default activation will be returned.
				 *
				 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
				 * version of it, the class is considered active.
				 *
				 * @param {Element} element
				 * @param {string} className
				 * @param {boolean} [defaultActivation=false]
				 * @returns {boolean}
				 */
				isActive: function (element, className, defaultActivation) {
					var no = 'no-' + className;
	
					while (element) {
						var classList = element.classList;
						if (classList.contains(className)) {
							return true;
						}
						if (classList.contains(no)) {
							return false;
						}
						element = element.parentElement;
					}
					return !!defaultActivation;
				}
			},
	
			/**
			 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
			 *
			 * @namespace
			 * @memberof Prism
			 * @public
			 */
			languages: {
				/**
				 * The grammar for plain, unformatted text.
				 */
				plain: plainTextGrammar,
				plaintext: plainTextGrammar,
				text: plainTextGrammar,
				txt: plainTextGrammar,
	
				/**
				 * Creates a deep copy of the language with the given id and appends the given tokens.
				 *
				 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
				 * will be overwritten at its original position.
				 *
				 * ## Best practices
				 *
				 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
				 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
				 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
				 *
				 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
				 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
				 *
				 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
				 * @param {Grammar} redef The new tokens to append.
				 * @returns {Grammar} The new language created.
				 * @public
				 * @example
				 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
				 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
				 *     // at its original position
				 *     'comment': { ... },
				 *     // CSS doesn't have a 'color' token, so this token will be appended
				 *     'color': /\b(?:red|green|blue)\b/
				 * });
				 */
				extend: function (id, redef) {
					var lang = _.util.clone(_.languages[id]);
	
					for (var key in redef) {
						lang[key] = redef[key];
					}
	
					return lang;
				},
	
				/**
				 * Inserts tokens _before_ another token in a language definition or any other grammar.
				 *
				 * ## Usage
				 *
				 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
				 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
				 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
				 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
				 * this:
				 *
				 * ```js
				 * Prism.languages.markup.style = {
				 *     // token
				 * };
				 * ```
				 *
				 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
				 * before existing tokens. For the CSS example above, you would use it like this:
				 *
				 * ```js
				 * Prism.languages.insertBefore('markup', 'cdata', {
				 *     'style': {
				 *         // token
				 *     }
				 * });
				 * ```
				 *
				 * ## Special cases
				 *
				 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
				 * will be ignored.
				 *
				 * This behavior can be used to insert tokens after `before`:
				 *
				 * ```js
				 * Prism.languages.insertBefore('markup', 'comment', {
				 *     'comment': Prism.languages.markup.comment,
				 *     // tokens after 'comment'
				 * });
				 * ```
				 *
				 * ## Limitations
				 *
				 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
				 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
				 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
				 * deleting properties which is necessary to insert at arbitrary positions.
				 *
				 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
				 * Instead, it will create a new object and replace all references to the target object with the new one. This
				 * can be done without temporarily deleting properties, so the iteration order is well-defined.
				 *
				 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
				 * you hold the target object in a variable, then the value of the variable will not change.
				 *
				 * ```js
				 * var oldMarkup = Prism.languages.markup;
				 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
				 *
				 * assert(oldMarkup !== Prism.languages.markup);
				 * assert(newMarkup === Prism.languages.markup);
				 * ```
				 *
				 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
				 * object to be modified.
				 * @param {string} before The key to insert before.
				 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
				 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
				 * object to be modified.
				 *
				 * Defaults to `Prism.languages`.
				 * @returns {Grammar} The new grammar object.
				 * @public
				 */
				insertBefore: function (inside, before, insert, root) {
					root = root || /** @type {any} */ (_.languages);
					var grammar = root[inside];
					/** @type {Grammar} */
					var ret = {};
	
					for (var token in grammar) {
						if (grammar.hasOwnProperty(token)) {
	
							if (token == before) {
								for (var newToken in insert) {
									if (insert.hasOwnProperty(newToken)) {
										ret[newToken] = insert[newToken];
									}
								}
							}
	
							// Do not insert token which also occur in insert. See #1525
							if (!insert.hasOwnProperty(token)) {
								ret[token] = grammar[token];
							}
						}
					}
	
					var old = root[inside];
					root[inside] = ret;
	
					// Update references in other language definitions
					_.languages.DFS(_.languages, function (key, value) {
						if (value === old && key != inside) {
							this[key] = ret;
						}
					});
	
					return ret;
				},
	
				// Traverse a language definition with Depth First Search
				DFS: function DFS(o, callback, type, visited) {
					visited = visited || {};
	
					var objId = _.util.objId;
	
					for (var i in o) {
						if (o.hasOwnProperty(i)) {
							callback.call(o, i, o[i], type || i);
	
							var property = o[i];
							var propertyType = _.util.type(property);
	
							if (propertyType === 'Object' && !visited[objId(property)]) {
								visited[objId(property)] = true;
								DFS(property, callback, null, visited);
							} else if (propertyType === 'Array' && !visited[objId(property)]) {
								visited[objId(property)] = true;
								DFS(property, callback, i, visited);
							}
						}
					}
				}
			},
	
			plugins: {},
	
			/**
			 * This is the most high-level function in Prism’s API.
			 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
			 * each one of them.
			 *
			 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
			 *
			 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
			 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
			 * @memberof Prism
			 * @public
			 */
			highlightAll: function (async, callback) {
				_.highlightAllUnder(document, async, callback);
			},
	
			/**
			 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
			 * {@link Prism.highlightElement} on each one of them.
			 *
			 * The following hooks will be run:
			 * 1. `before-highlightall`
			 * 2. `before-all-elements-highlight`
			 * 3. All hooks of {@link Prism.highlightElement} for each element.
			 *
			 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
			 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
			 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
			 * @memberof Prism
			 * @public
			 */
			highlightAllUnder: function (container, async, callback) {
				var env = {
					callback: callback,
					container: container,
					selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
				};
	
				_.hooks.run('before-highlightall', env);
	
				env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
	
				_.hooks.run('before-all-elements-highlight', env);
	
				for (var i = 0, element; (element = env.elements[i++]);) {
					_.highlightElement(element, async === true, env.callback);
				}
			},
	
			/**
			 * Highlights the code inside a single element.
			 *
			 * The following hooks will be run:
			 * 1. `before-sanity-check`
			 * 2. `before-highlight`
			 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
			 * 4. `before-insert`
			 * 5. `after-highlight`
			 * 6. `complete`
			 *
			 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
			 * the element's language.
			 *
			 * @param {Element} element The element containing the code.
			 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
			 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
			 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
			 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
			 *
			 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
			 * asynchronous highlighting to work. You can build your own bundle on the
			 * [Download page](https://prismjs.com/download.html).
			 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
			 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
			 * @memberof Prism
			 * @public
			 */
			highlightElement: function (element, async, callback) {
				// Find language
				var language = _.util.getLanguage(element);
				var grammar = _.languages[language];
	
				// Set language on the element, if not present
				_.util.setLanguage(element, language);
	
				// Set language on the parent, for styling
				var parent = element.parentElement;
				if (parent && parent.nodeName.toLowerCase() === 'pre') {
					_.util.setLanguage(parent, language);
				}
	
				var code = element.textContent;
	
				var env = {
					element: element,
					language: language,
					grammar: grammar,
					code: code
				};
	
				function insertHighlightedCode(highlightedCode) {
					env.highlightedCode = highlightedCode;
	
					_.hooks.run('before-insert', env);
	
					env.element.innerHTML = env.highlightedCode;
	
					_.hooks.run('after-highlight', env);
					_.hooks.run('complete', env);
					callback && callback.call(env.element);
				}
	
				_.hooks.run('before-sanity-check', env);
	
				// plugins may change/add the parent/element
				parent = env.element.parentElement;
				if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) {
					parent.setAttribute('tabindex', '0');
				}
	
				if (!env.code) {
					_.hooks.run('complete', env);
					callback && callback.call(env.element);
					return;
				}
	
				_.hooks.run('before-highlight', env);
	
				if (!env.grammar) {
					insertHighlightedCode(_.util.encode(env.code));
					return;
				}
	
				if (async && _self.Worker) {
					var worker = new Worker(_.filename);
	
					worker.onmessage = function (evt) {
						insertHighlightedCode(evt.data);
					};
	
					worker.postMessage(JSON.stringify({
						language: env.language,
						code: env.code,
						immediateClose: true
					}));
				} else {
					insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
				}
			},
	
			/**
			 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
			 * and the language definitions to use, and returns a string with the HTML produced.
			 *
			 * The following hooks will be run:
			 * 1. `before-tokenize`
			 * 2. `after-tokenize`
			 * 3. `wrap`: On each {@link Token}.
			 *
			 * @param {string} text A string with the code to be highlighted.
			 * @param {Grammar} grammar An object containing the tokens to use.
			 *
			 * Usually a language definition like `Prism.languages.markup`.
			 * @param {string} language The name of the language definition passed to `grammar`.
			 * @returns {string} The highlighted HTML.
			 * @memberof Prism
			 * @public
			 * @example
			 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
			 */
			highlight: function (text, grammar, language) {
				var env = {
					code: text,
					grammar: grammar,
					language: language
				};
				_.hooks.run('before-tokenize', env);
				if (!env.grammar) {
					throw new Error('The language "' + env.language + '" has no grammar.');
				}
				env.tokens = _.tokenize(env.code, env.grammar);
				_.hooks.run('after-tokenize', env);
				return Token.stringify(_.util.encode(env.tokens), env.language);
			},
	
			/**
			 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
			 * and the language definitions to use, and returns an array with the tokenized code.
			 *
			 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
			 *
			 * This method could be useful in other contexts as well, as a very crude parser.
			 *
			 * @param {string} text A string with the code to be highlighted.
			 * @param {Grammar} grammar An object containing the tokens to use.
			 *
			 * Usually a language definition like `Prism.languages.markup`.
			 * @returns {TokenStream} An array of strings and tokens, a token stream.
			 * @memberof Prism
			 * @public
			 * @example
			 * let code = `var foo = 0;`;
			 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
			 * tokens.forEach(token => {
			 *     if (token instanceof Prism.Token && token.type === 'number') {
			 *         console.log(`Found numeric literal: ${token.content}`);
			 *     }
			 * });
			 */
			tokenize: function (text, grammar) {
				var rest = grammar.rest;
				if (rest) {
					for (var token in rest) {
						grammar[token] = rest[token];
					}
	
					delete grammar.rest;
				}
	
				var tokenList = new LinkedList();
				addAfter(tokenList, tokenList.head, text);
	
				matchGrammar(text, tokenList, grammar, tokenList.head, 0);
	
				return toArray(tokenList);
			},
	
			/**
			 * @namespace
			 * @memberof Prism
			 * @public
			 */
			hooks: {
				all: {},
	
				/**
				 * Adds the given callback to the list of callbacks for the given hook.
				 *
				 * The callback will be invoked when the hook it is registered for is run.
				 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
				 *
				 * One callback function can be registered to multiple hooks and the same hook multiple times.
				 *
				 * @param {string} name The name of the hook.
				 * @param {HookCallback} callback The callback function which is given environment variables.
				 * @public
				 */
				add: function (name, callback) {
					var hooks = _.hooks.all;
	
					hooks[name] = hooks[name] || [];
	
					hooks[name].push(callback);
				},
	
				/**
				 * Runs a hook invoking all registered callbacks with the given environment variables.
				 *
				 * Callbacks will be invoked synchronously and in the order in which they were registered.
				 *
				 * @param {string} name The name of the hook.
				 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
				 * @public
				 */
				run: function (name, env) {
					var callbacks = _.hooks.all[name];
	
					if (!callbacks || !callbacks.length) {
						return;
					}
	
					for (var i = 0, callback; (callback = callbacks[i++]);) {
						callback(env);
					}
				}
			},
	
			Token: Token
		};
		_self.Prism = _;
	
	
		// Typescript note:
		// The following can be used to import the Token type in JSDoc:
		//
		//   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
	
		/**
		 * Creates a new token.
		 *
		 * @param {string} type See {@link Token#type type}
		 * @param {string | TokenStream} content See {@link Token#content content}
		 * @param {string|string[]} [alias] The alias(es) of the token.
		 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
		 * @class
		 * @global
		 * @public
		 */
		function Token(type, content, alias, matchedStr) {
			/**
			 * The type of the token.
			 *
			 * This is usually the key of a pattern in a {@link Grammar}.
			 *
			 * @type {string}
			 * @see GrammarToken
			 * @public
			 */
			this.type = type;
			/**
			 * The strings or tokens contained by this token.
			 *
			 * This will be a token stream if the pattern matched also defined an `inside` grammar.
			 *
			 * @type {string | TokenStream}
			 * @public
			 */
			this.content = content;
			/**
			 * The alias(es) of the token.
			 *
			 * @type {string|string[]}
			 * @see GrammarToken
			 * @public
			 */
			this.alias = alias;
			// Copy of the full string this token was created from
			this.length = (matchedStr || '').length | 0;
		}
	
		/**
		 * A token stream is an array of strings and {@link Token Token} objects.
		 *
		 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
		 * them.
		 *
		 * 1. No adjacent strings.
		 * 2. No empty strings.
		 *
		 *    The only exception here is the token stream that only contains the empty string and nothing else.
		 *
		 * @typedef {Array<string | Token>} TokenStream
		 * @global
		 * @public
		 */
	
		/**
		 * Converts the given token or token stream to an HTML representation.
		 *
		 * The following hooks will be run:
		 * 1. `wrap`: On each {@link Token}.
		 *
		 * @param {string | Token | TokenStream} o The token or token stream to be converted.
		 * @param {string} language The name of current language.
		 * @returns {string} The HTML representation of the token or token stream.
		 * @memberof Token
		 * @static
		 */
		Token.stringify = function stringify(o, language) {
			if (typeof o == 'string') {
				return o;
			}
			if (Array.isArray(o)) {
				var s = '';
				o.forEach(function (e) {
					s += stringify(e, language);
				});
				return s;
			}
	
			var env = {
				type: o.type,
				content: stringify(o.content, language),
				tag: 'span',
				classes: ['token', o.type],
				attributes: {},
				language: language
			};
	
			var aliases = o.alias;
			if (aliases) {
				if (Array.isArray(aliases)) {
					Array.prototype.push.apply(env.classes, aliases);
				} else {
					env.classes.push(aliases);
				}
			}
	
			_.hooks.run('wrap', env);
	
			var attributes = '';
			for (var name in env.attributes) {
				attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
			}
	
			return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
		};
	
		/**
		 * @param {RegExp} pattern
		 * @param {number} pos
		 * @param {string} text
		 * @param {boolean} lookbehind
		 * @returns {RegExpExecArray | null}
		 */
		function matchPattern(pattern, pos, text, lookbehind) {
			pattern.lastIndex = pos;
			var match = pattern.exec(text);
			if (match && lookbehind && match[1]) {
				// change the match to remove the text matched by the Prism lookbehind group
				var lookbehindLength = match[1].length;
				match.index += lookbehindLength;
				match[0] = match[0].slice(lookbehindLength);
			}
			return match;
		}
	
		/**
		 * @param {string} text
		 * @param {LinkedList<string | Token>} tokenList
		 * @param {any} grammar
		 * @param {LinkedListNode<string | Token>} startNode
		 * @param {number} startPos
		 * @param {RematchOptions} [rematch]
		 * @returns {void}
		 * @private
		 *
		 * @typedef RematchOptions
		 * @property {string} cause
		 * @property {number} reach
		 */
		function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
			for (var token in grammar) {
				if (!grammar.hasOwnProperty(token) || !grammar[token]) {
					continue;
				}
	
				var patterns = grammar[token];
				patterns = Array.isArray(patterns) ? patterns : [patterns];
	
				for (var j = 0; j < patterns.length; ++j) {
					if (rematch && rematch.cause == token + ',' + j) {
						return;
					}
	
					var patternObj = patterns[j];
					var inside = patternObj.inside;
					var lookbehind = !!patternObj.lookbehind;
					var greedy = !!patternObj.greedy;
					var alias = patternObj.alias;
	
					if (greedy && !patternObj.pattern.global) {
						// Without the global flag, lastIndex won't work
						var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
						patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
					}
	
					/** @type {RegExp} */
					var pattern = patternObj.pattern || patternObj;
	
					for ( // iterate the token list and keep track of the current token/string position
						var currentNode = startNode.next, pos = startPos;
						currentNode !== tokenList.tail;
						pos += currentNode.value.length, currentNode = currentNode.next
					) {
	
						if (rematch && pos >= rematch.reach) {
							break;
						}
	
						var str = currentNode.value;
	
						if (tokenList.length > text.length) {
							// Something went terribly wrong, ABORT, ABORT!
							return;
						}
	
						if (str instanceof Token) {
							continue;
						}
	
						var removeCount = 1; // this is the to parameter of removeBetween
						var match;
	
						if (greedy) {
							match = matchPattern(pattern, pos, text, lookbehind);
							if (!match || match.index >= text.length) {
								break;
							}
	
							var from = match.index;
							var to = match.index + match[0].length;
							var p = pos;
	
							// find the node that contains the match
							p += currentNode.value.length;
							while (from >= p) {
								currentNode = currentNode.next;
								p += currentNode.value.length;
							}
							// adjust pos (and p)
							p -= currentNode.value.length;
							pos = p;
	
							// the current node is a Token, then the match starts inside another Token, which is invalid
							if (currentNode.value instanceof Token) {
								continue;
							}
	
							// find the last node which is affected by this match
							for (
								var k = currentNode;
								k !== tokenList.tail && (p < to || typeof k.value === 'string');
								k = k.next
							) {
								removeCount++;
								p += k.value.length;
							}
							removeCount--;
	
							// replace with the new match
							str = text.slice(pos, p);
							match.index -= pos;
						} else {
							match = matchPattern(pattern, 0, str, lookbehind);
							if (!match) {
								continue;
							}
						}
	
						// eslint-disable-next-line no-redeclare
						var from = match.index;
						var matchStr = match[0];
						var before = str.slice(0, from);
						var after = str.slice(from + matchStr.length);
	
						var reach = pos + str.length;
						if (rematch && reach > rematch.reach) {
							rematch.reach = reach;
						}
	
						var removeFrom = currentNode.prev;
	
						if (before) {
							removeFrom = addAfter(tokenList, removeFrom, before);
							pos += before.length;
						}
	
						removeRange(tokenList, removeFrom, removeCount);
	
						var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
						currentNode = addAfter(tokenList, removeFrom, wrapped);
	
						if (after) {
							addAfter(tokenList, currentNode, after);
						}
	
						if (removeCount > 1) {
							// at least one Token object was removed, so we have to do some rematching
							// this can only happen if the current pattern is greedy
	
							/** @type {RematchOptions} */
							var nestedRematch = {
								cause: token + ',' + j,
								reach: reach
							};
							matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
	
							// the reach might have been extended because of the rematching
							if (rematch && nestedRematch.reach > rematch.reach) {
								rematch.reach = nestedRematch.reach;
							}
						}
					}
				}
			}
		}
	
		/**
		 * @typedef LinkedListNode
		 * @property {T} value
		 * @property {LinkedListNode<T> | null} prev The previous node.
		 * @property {LinkedListNode<T> | null} next The next node.
		 * @template T
		 * @private
		 */
	
		/**
		 * @template T
		 * @private
		 */
		function LinkedList() {
			/** @type {LinkedListNode<T>} */
			var head = { value: null, prev: null, next: null };
			/** @type {LinkedListNode<T>} */
			var tail = { value: null, prev: head, next: null };
			head.next = tail;
	
			/** @type {LinkedListNode<T>} */
			this.head = head;
			/** @type {LinkedListNode<T>} */
			this.tail = tail;
			this.length = 0;
		}
	
		/**
		 * Adds a new node with the given value to the list.
		 *
		 * @param {LinkedList<T>} list
		 * @param {LinkedListNode<T>} node
		 * @param {T} value
		 * @returns {LinkedListNode<T>} The added node.
		 * @template T
		 */
		function addAfter(list, node, value) {
			// assumes that node != list.tail && values.length >= 0
			var next = node.next;
	
			var newNode = { value: value, prev: node, next: next };
			node.next = newNode;
			next.prev = newNode;
			list.length++;
	
			return newNode;
		}
		/**
		 * Removes `count` nodes after the given node. The given node will not be removed.
		 *
		 * @param {LinkedList<T>} list
		 * @param {LinkedListNode<T>} node
		 * @param {number} count
		 * @template T
		 */
		function removeRange(list, node, count) {
			var next = node.next;
			for (var i = 0; i < count && next !== list.tail; i++) {
				next = next.next;
			}
			node.next = next;
			next.prev = node;
			list.length -= i;
		}
		/**
		 * @param {LinkedList<T>} list
		 * @returns {T[]}
		 * @template T
		 */
		function toArray(list) {
			var array = [];
			var node = list.head.next;
			while (node !== list.tail) {
				array.push(node.value);
				node = node.next;
			}
			return array;
		}
	
	
		if (!_self.document) {
			if (!_self.addEventListener) {
				// in Node.js
				return _;
			}
	
			if (!_.disableWorkerMessageHandler) {
				// In worker
				_self.addEventListener('message', function (evt) {
					var message = JSON.parse(evt.data);
					var lang = message.language;
					var code = message.code;
					var immediateClose = message.immediateClose;
	
					_self.postMessage(_.highlight(code, _.languages[lang], lang));
					if (immediateClose) {
						_self.close();
					}
				}, false);
			}
	
			return _;
		}
	
		// Get current script and highlight
		var script = _.util.currentScript();
	
		if (script) {
			_.filename = script.src;
	
			if (script.hasAttribute('data-manual')) {
				_.manual = true;
			}
		}
	
		function highlightAutomaticallyCallback() {
			if (!_.manual) {
				_.highlightAll();
			}
		}
	
		if (!_.manual) {
			// If the document state is "loading", then we'll use DOMContentLoaded.
			// If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
			// DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
			// might take longer one animation frame to execute which can create a race condition where only some plugins have
			// been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
			// See https://github.com/PrismJS/prism/issues/2102
			var readyState = document.readyState;
			if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) {
				document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
			} else {
				if (window.requestAnimationFrame) {
					window.requestAnimationFrame(highlightAutomaticallyCallback);
				} else {
					window.setTimeout(highlightAutomaticallyCallback, 16);
				}
			}
		}
	
		return _;
	
	}(_self));
	
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = Prism;
	}
	
	// hack for components to work correctly in node.js
	if (typeof global !== 'undefined') {
		global.Prism = Prism;
	}
	
	// some additional documentation/types
	
	/**
	 * The expansion of a simple `RegExp` literal to support additional properties.
	 *
	 * @typedef GrammarToken
	 * @property {RegExp} pattern The regular expression of the token.
	 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
	 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
	 * @property {boolean} [greedy=false] Whether the token is greedy.
	 * @property {string|string[]} [alias] An optional alias or list of aliases.
	 * @property {Grammar} [inside] The nested grammar of this token.
	 *
	 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
	 *
	 * This can be used to make nested and even recursive language definitions.
	 *
	 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
	 * each another.
	 * @global
	 * @public
	 */
	
	/**
	 * @typedef Grammar
	 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
	 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
	 * @global
	 * @public
	 */
	
	/**
	 * A function which will invoked after an element was successfully highlighted.
	 *
	 * @callback HighlightCallback
	 * @param {Element} element The element successfully highlighted.
	 * @returns {void}
	 * @global
	 * @public
	 */
	
	/**
	 * @callback HookCallback
	 * @param {Object<string, any>} env The environment variables of the hook.
	 * @returns {void}
	 * @global
	 * @public
	 */
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

	Prism.languages.javascript = Prism.languages.extend('clike', {
		'class-name': [
			Prism.languages.clike['class-name'],
			{
				pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
				lookbehind: true
			}
		],
		'keyword': [
			{
				pattern: /((?:^|\})\s*)catch\b/,
				lookbehind: true
			},
			{
				pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
				lookbehind: true
			},
		],
		// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
		'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
		'number': {
			pattern: RegExp(
				/(^|[^\w$])/.source +
				'(?:' +
				(
					// constant
					/NaN|Infinity/.source +
					'|' +
					// binary integer
					/0[bB][01]+(?:_[01]+)*n?/.source +
					'|' +
					// octal integer
					/0[oO][0-7]+(?:_[0-7]+)*n?/.source +
					'|' +
					// hexadecimal integer
					/0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source +
					'|' +
					// decimal bigint
					/\d+(?:_\d+)*n/.source +
					'|' +
					// decimal number (integer or float) but no bigint
					/(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source
				) +
				')' +
				/(?![\w$])/.source
			),
			lookbehind: true
		},
		'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
	});
	
	Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
	
	Prism.languages.insertBefore('javascript', 'keyword', {
		'regex': {
			pattern: RegExp(
				// lookbehind
				// eslint-disable-next-line regexp/no-dupe-characters-character-class
				/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source +
				// Regex pattern:
				// There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
				// classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
				// with the only syntax, so we have to define 2 different regex patterns.
				/\//.source +
				'(?:' +
				/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source +
				'|' +
				// `v` flag syntax. This supports 3 levels of nested character classes.
				/(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source +
				')' +
				// lookahead
				/(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
			),
			lookbehind: true,
			greedy: true,
			inside: {
				'regex-source': {
					pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
					lookbehind: true,
					alias: 'language-regex',
					inside: Prism.languages.regex
				},
				'regex-delimiter': /^\/|\/$/,
				'regex-flags': /^[a-z]+$/,
			}
		},
		// This must be declared before keyword because we use "function" inside the look-forward
		'function-variable': {
			pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
			alias: 'function'
		},
		'parameter': [
			{
				pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
				lookbehind: true,
				inside: Prism.languages.javascript
			},
			{
				pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
				lookbehind: true,
				inside: Prism.languages.javascript
			},
			{
				pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
				lookbehind: true,
				inside: Prism.languages.javascript
			},
			{
				pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
				lookbehind: true,
				inside: Prism.languages.javascript
			}
		],
		'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
	});
	
	Prism.languages.insertBefore('javascript', 'string', {
		'hashbang': {
			pattern: /^#!.*/,
			greedy: true,
			alias: 'comment'
		},
		'template-string': {
			pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
			greedy: true,
			inside: {
				'template-punctuation': {
					pattern: /^`|`$/,
					alias: 'string'
				},
				'interpolation': {
					pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
					lookbehind: true,
					inside: {
						'interpolation-punctuation': {
							pattern: /^\$\{|\}$/,
							alias: 'punctuation'
						},
						rest: Prism.languages.javascript
					}
				},
				'string': /[\s\S]+/
			}
		},
		'string-property': {
			pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
			lookbehind: true,
			greedy: true,
			alias: 'property'
		}
	});
	
	Prism.languages.insertBefore('javascript', 'operator', {
		'literal-property': {
			pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
			lookbehind: true,
			alias: 'property'
		},
	});
	
	if (Prism.languages.markup) {
		Prism.languages.markup.tag.addInlined('script', 'javascript');
	
		// add attribute support for all DOM events.
		// https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
		Prism.languages.markup.tag.addAttribute(
			/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
			'javascript'
		);
	}
	
	Prism.languages.js = Prism.languages.javascript;


/***/ }),

/***/ 1031:
/***/ (function(module, exports) {

	(function (Prism) {
	
		var javascript = Prism.util.clone(Prism.languages.javascript);
	
		var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
		var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
		var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
	
		/**
		 * @param {string} source
		 * @param {string} [flags]
		 */
		function re(source, flags) {
			source = source
				.replace(/<S>/g, function () { return space; })
				.replace(/<BRACES>/g, function () { return braces; })
				.replace(/<SPREAD>/g, function () { return spread; });
			return RegExp(source, flags);
		}
	
		spread = re(spread).source;
	
	
		Prism.languages.jsx = Prism.languages.extend('markup', javascript);
		Prism.languages.jsx.tag.pattern = re(
			/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source
		);
	
		Prism.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/;
		Prism.languages.jsx.tag.inside['attr-value'].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
		Prism.languages.jsx.tag.inside['tag'].inside['class-name'] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
		Prism.languages.jsx.tag.inside['comment'] = javascript['comment'];
	
		Prism.languages.insertBefore('inside', 'attr-name', {
			'spread': {
				pattern: re(/<SPREAD>/.source),
				inside: Prism.languages.jsx
			}
		}, Prism.languages.jsx.tag);
	
		Prism.languages.insertBefore('inside', 'special-attr', {
			'script': {
				// Allow for two levels of nesting
				pattern: re(/=<BRACES>/.source),
				alias: 'language-javascript',
				inside: {
					'script-punctuation': {
						pattern: /^=(?=\{)/,
						alias: 'punctuation'
					},
					rest: Prism.languages.jsx
				},
			}
		}, Prism.languages.jsx.tag);
	
		// The following will handle plain text inside tags
		var stringifyToken = function (token) {
			if (!token) {
				return '';
			}
			if (typeof token === 'string') {
				return token;
			}
			if (typeof token.content === 'string') {
				return token.content;
			}
			return token.content.map(stringifyToken).join('');
		};
	
		var walkTokens = function (tokens) {
			var openedTags = [];
			for (var i = 0; i < tokens.length; i++) {
				var token = tokens[i];
				var notTagNorBrace = false;
	
				if (typeof token !== 'string') {
					if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
						// We found a tag, now find its kind
	
						if (token.content[0].content[0].content === '</') {
							// Closing tag
							if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) {
								// Pop matching opening tag
								openedTags.pop();
							}
						} else {
							if (token.content[token.content.length - 1].content === '/>') {
								// Autoclosed tag, ignore
							} else {
								// Opening tag
								openedTags.push({
									tagName: stringifyToken(token.content[0].content[1]),
									openedBraces: 0
								});
							}
						}
					} else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{') {
	
						// Here we might have entered a JSX context inside a tag
						openedTags[openedTags.length - 1].openedBraces++;
	
					} else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') {
	
						// Here we might have left a JSX context inside a tag
						openedTags[openedTags.length - 1].openedBraces--;
	
					} else {
						notTagNorBrace = true;
					}
				}
				if (notTagNorBrace || typeof token === 'string') {
					if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
						// Here we are inside a tag, and not inside a JSX context.
						// That's plain text: drop any tokens matched.
						var plainText = stringifyToken(token);
	
						// And merge text with adjacent text
						if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
							plainText += stringifyToken(tokens[i + 1]);
							tokens.splice(i + 1, 1);
						}
						if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
							plainText = stringifyToken(tokens[i - 1]) + plainText;
							tokens.splice(i - 1, 1);
							i--;
						}
	
						tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
					}
				}
	
				if (token.content && typeof token.content !== 'string') {
					walkTokens(token.content);
				}
			}
		};
	
		Prism.hooks.add('after-tokenize', function (env) {
			if (env.language !== 'jsx' && env.language !== 'tsx') {
				return;
			}
			walkTokens(env.tokens);
		});
	
	}(Prism));


/***/ }),

/***/ 1032:
/***/ (function(module, exports) {

	Prism.languages.markup = {
		'comment': {
			pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
			greedy: true
		},
		'prolog': {
			pattern: /<\?[\s\S]+?\?>/,
			greedy: true
		},
		'doctype': {
			// https://www.w3.org/TR/xml/#NT-doctypedecl
			pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
			greedy: true,
			inside: {
				'internal-subset': {
					pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
					lookbehind: true,
					greedy: true,
					inside: null // see below
				},
				'string': {
					pattern: /"[^"]*"|'[^']*'/,
					greedy: true
				},
				'punctuation': /^<!|>$|[[\]]/,
				'doctype-tag': /^DOCTYPE/i,
				'name': /[^\s<>'"]+/
			}
		},
		'cdata': {
			pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
			greedy: true
		},
		'tag': {
			pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
			greedy: true,
			inside: {
				'tag': {
					pattern: /^<\/?[^\s>\/]+/,
					inside: {
						'punctuation': /^<\/?/,
						'namespace': /^[^\s>\/:]+:/
					}
				},
				'special-attr': [],
				'attr-value': {
					pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
					inside: {
						'punctuation': [
							{
								pattern: /^=/,
								alias: 'attr-equals'
							},
							{
								pattern: /^(\s*)["']|["']$/,
								lookbehind: true
							}
						]
					}
				},
				'punctuation': /\/?>/,
				'attr-name': {
					pattern: /[^\s>\/]+/,
					inside: {
						'namespace': /^[^\s>\/:]+:/
					}
				}
	
			}
		},
		'entity': [
			{
				pattern: /&[\da-z]{1,8};/i,
				alias: 'named-entity'
			},
			/&#x?[\da-f]{1,8};/i
		]
	};
	
	Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
		Prism.languages.markup['entity'];
	Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;
	
	// Plugin to make entity title show the real entity, idea by Roman Komarov
	Prism.hooks.add('wrap', function (env) {
	
		if (env.type === 'entity') {
			env.attributes['title'] = env.content.replace(/&amp;/, '&');
		}
	});
	
	Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
		/**
		 * Adds an inlined language to markup.
		 *
		 * An example of an inlined language is CSS with `<style>` tags.
		 *
		 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
		 * case insensitive.
		 * @param {string} lang The language key.
		 * @example
		 * addInlined('style', 'css');
		 */
		value: function addInlined(tagName, lang) {
			var includedCdataInside = {};
			includedCdataInside['language-' + lang] = {
				pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
				lookbehind: true,
				inside: Prism.languages[lang]
			};
			includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
	
			var inside = {
				'included-cdata': {
					pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
					inside: includedCdataInside
				}
			};
			inside['language-' + lang] = {
				pattern: /[\s\S]+/,
				inside: Prism.languages[lang]
			};
	
			var def = {};
			def[tagName] = {
				pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function () { return tagName; }), 'i'),
				lookbehind: true,
				greedy: true,
				inside: inside
			};
	
			Prism.languages.insertBefore('markup', 'cdata', def);
		}
	});
	Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
		/**
		 * Adds an pattern to highlight languages embedded in HTML attributes.
		 *
		 * An example of an inlined language is CSS with `style` attributes.
		 *
		 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
		 * case insensitive.
		 * @param {string} lang The language key.
		 * @example
		 * addAttribute('style', 'css');
		 */
		value: function (attrName, lang) {
			Prism.languages.markup.tag.inside['special-attr'].push({
				pattern: RegExp(
					/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
					'i'
				),
				lookbehind: true,
				inside: {
					'attr-name': /^[^\s=]+/,
					'attr-value': {
						pattern: /=[\s\S]+/,
						inside: {
							'value': {
								pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
								lookbehind: true,
								alias: [lang, 'language-' + lang],
								inside: Prism.languages[lang]
							},
							'punctuation': [
								{
									pattern: /^=/,
									alias: 'attr-equals'
								},
								/"|'/
							]
						}
					}
				}
			});
		}
	});
	
	Prism.languages.html = Prism.languages.markup;
	Prism.languages.mathml = Prism.languages.markup;
	Prism.languages.svg = Prism.languages.markup;
	
	Prism.languages.xml = Prism.languages.extend('markup', {});
	Prism.languages.ssml = Prism.languages.xml;
	Prism.languages.atom = Prism.languages.xml;
	Prism.languages.rss = Prism.languages.xml;


/***/ }),

/***/ 1040:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _css = __webpack_require__(1044);
	
	var _css2 = _interopRequireDefault(_css);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prismStyling = _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: _css2.default } });
	
	exports.default = function () {
	  return prismStyling;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cn = __webpack_require__(62);
	
	var _cn2 = _interopRequireDefault(_cn);
	
	var _prism = __webpack_require__(1051);
	
	var _prism2 = _interopRequireDefault(_prism);
	
	var _normalizeCode = __webpack_require__(1049);
	
	var _normalizeCode2 = _interopRequireDefault(_normalizeCode);
	
	var _normalizeHtml = __webpack_require__(1050);
	
	var _normalizeHtml2 = _interopRequireDefault(_normalizeHtml);
	
	var _htmlToPlain = __webpack_require__(1048);
	
	var _htmlToPlain2 = _interopRequireDefault(_htmlToPlain);
	
	var _selectionRange3 = __webpack_require__(1054);
	
	var _selectionRange4 = _interopRequireDefault(_selectionRange3);
	
	var _getIndent = __webpack_require__(1047);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Editor = function (_Component) {
	  _inherits(Editor, _Component);
	
	  function Editor() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Editor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.undoStack = [], _this.undoOffset = 0, _this.undoTimestamp = 0, _this.state = {
	      html: ''
	    }, _this.onRef = function (node) {
	      _this.ref = node;
	    }, _this.getPlain = function () {
	      if (_this._innerHTML === _this.ref.innerHTML) {
	        return _this._plain;
	      }
	
	      var plain = (0, _htmlToPlain2.default)((0, _normalizeHtml2.default)(_this.ref.innerHTML));
	
	      _this._plain = plain;
	      _this._innerHTML = _this.ref.innerHTML;
	
	      return _this._plain;
	    }, _this.recordChange = function (plain, selection) {
	      if (plain === _this.undoStack[_this.undoStack.length - 1]) {
	        return;
	      }
	
	      if (_this.undoOffset > 0) {
	        _this.undoStack = _this.undoStack.slice(0, -_this.undoOffset);
	        _this.undoOffset = 0;
	      }
	
	      var timestamp = Date.now();
	      var record = { plain: plain, selection: selection };
	
	      // Overwrite last record if threshold is not crossed
	      if (timestamp - _this.undoTimestamp < 3000) {
	        _this.undoStack[_this.undoStack.length - 1] = record;
	      } else {
	        _this.undoStack.push(record);
	
	        if (_this.undoStack.length > 50) {
	          _this.undoStack.shift();
	        }
	      }
	
	      _this.undoTimestamp = timestamp;
	    }, _this.updateContent = function (plain) {
	      _this.setState({ html: (0, _prism2.default)(plain) });
	
	      if (_this.props.onChange) {
	        _this.props.onChange(plain);
	      }
	    }, _this.restoreStackState = function (offset) {
	      var _this$undoStack = _this.undoStack[_this.undoStack.length - 1 - offset],
	          plain = _this$undoStack.plain,
	          selection = _this$undoStack.selection;
	
	
	      _this.selection = selection;
	      _this.undoOffset = offset;
	      _this.updateContent(plain);
	    }, _this.undo = function () {
	      var offset = _this.undoOffset + 1;
	      if (offset >= _this.undoStack.length) {
	        return;
	      }
	
	      _this.restoreStackState(offset);
	    }, _this.redo = function () {
	      var offset = _this.undoOffset - 1;
	      if (offset < 0) {
	        return;
	      }
	
	      _this.restoreStackState(offset);
	    }, _this.onKeyDown = function (evt) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(evt);
	      }
	
	      if (evt.keyCode === 9 && !_this.props.ignoreTabKey) {
	        // Tab Key
	        document.execCommand('insertHTML', false, '  ');
	        evt.preventDefault();
	      } else if (evt.keyCode === 8) {
	        // Backspace Key
	        var _selectionRange = (0, _selectionRange4.default)(_this.ref),
	            cursorPos = _selectionRange.start,
	            cursorEndPos = _selectionRange.end;
	
	        if (cursorPos !== cursorEndPos) {
	          return; // Bail on selections
	        }
	
	        var deindent = (0, _getIndent.getDeindentLevel)(_this.getPlain(), cursorPos);
	        if (deindent <= 0) {
	          return; // Bail when deindent level defaults to 0
	        }
	
	        // Delete chars `deindent` times
	        for (var i = 0; i < deindent; i++) {
	          document.execCommand('delete', false);
	        }
	
	        evt.preventDefault();
	      } else if (evt.keyCode === 13) {
	        // Enter Key
	        var _selectionRange2 = (0, _selectionRange4.default)(_this.ref),
	            _cursorPos = _selectionRange2.start;
	
	        var indentation = (0, _getIndent.getIndent)(_this.getPlain(), _cursorPos);
	        document.execCommand('insertHTML', false, '\n' + indentation);
	        evt.preventDefault();
	      } else if (
	      // Undo / Redo
	      evt.keyCode === 90 && evt.metaKey !== evt.ctrlKey && !evt.altKey) {
	        if (evt.shiftKey) {
	          _this.redo();
	        } else {
	          _this.undo();
	        }
	
	        evt.preventDefault();
	      }
	    }, _this.onKeyUp = function (evt) {
	      if (_this.props.onKeyUp) {
	        _this.props.onKeyUp(evt);
	      }
	      if (evt.keyCode === 91 || // left cmd
	      evt.keyCode === 93 || // right cmd
	      evt.ctrlKey || evt.metaKey) {
	        return;
	      }
	
	      // Enter key
	      if (evt.keyCode === 13) {
	        _this.undoTimestamp = 0;
	      }
	
	      _this.selection = (0, _selectionRange4.default)(_this.ref);
	
	      if (evt.keyCode !== 37 && // left
	      evt.keyCode !== 38 && // up
	      evt.keyCode !== 39 && // right
	      evt.keyCode !== 40 // down
	      ) {
	          var plain = _this.getPlain();
	
	          _this.recordChange(plain, _this.selection);
	          _this.updateContent(plain);
	        } else {
	        _this.undoTimestamp = 0;
	      }
	    }, _this.onClick = function (evt) {
	      if (_this.props.onClick) {
	        _this.props.onClick(evt);
	      }
	      _this.undoTimestamp = 0; // Reset timestamp
	      _this.selection = (0, _selectionRange4.default)(_this.ref);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Editor.prototype.componentWillMount = function componentWillMount() {
	    var html = (0, _prism2.default)((0, _normalizeCode2.default)(this.props.code));
	    this.setState({ html: html });
	  };
	
	  Editor.prototype.componentDidMount = function componentDidMount() {
	    this.recordChange(this.getPlain());
	    this.undoTimestamp = 0; // Reset timestamp
	  };
	
	  Editor.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var code = _ref.code;
	
	    if (code !== this.props.code) {
	      var html = (0, _prism2.default)((0, _normalizeCode2.default)(code));
	      this.setState({ html: html });
	    }
	  };
	
	  Editor.prototype.componentDidUpdate = function componentDidUpdate() {
	    var selection = this.selection;
	
	    if (selection) {
	      (0, _selectionRange4.default)(this.ref, selection);
	    }
	  };
	
	  Editor.prototype.render = function render() {
	    var _props = this.props,
	        contentEditable = _props.contentEditable,
	        className = _props.className,
	        style = _props.style,
	        rest = _objectWithoutProperties(_props, ['contentEditable', 'className', 'style']);
	
	    var html = this.state.html;
	
	
	    delete rest.code;
	    delete rest.ignoreTabKey;
	
	    return _react2.default.createElement('pre', _extends({}, rest, {
	      ref: this.onRef,
	      className: (0, _cn2.default)('prism-code', className),
	      style: style,
	      spellCheck: 'false',
	      contentEditable: contentEditable,
	      onKeyDown: contentEditable ? this.onKeyDown : undefined,
	      onKeyUp: contentEditable ? this.onKeyUp : undefined,
	      onClick: contentEditable ? this.onClick : undefined,
	      dangerouslySetInnerHTML: { __html: html }
	    }));
	  };
	
	  return Editor;
	}(_react.Component);
	
	Editor.defaultProps = {
	  contentEditable: true
	};
	exports.default = Editor;
	module.exports = exports['default'];

/***/ }),

/***/ 1041:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LiveProvider = __webpack_require__(44);
	
	var _Editor = __webpack_require__(142);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LiveEditor = function LiveEditor(props, _ref) {
	  var live = _ref.live;
	  return _react2.default.createElement(_Editor2.default, _extends({}, props, {
	    code: live.code,
	    onChange: function onChange(code) {
	      live.onChange(code);
	
	      if (typeof props.onChange === 'function') {
	        props.onChange(code);
	      }
	    }
	  }));
	};
	
	LiveEditor.contextTypes = _LiveProvider.LiveContextTypes;
	LiveEditor.propTypes = { onChange: _propTypes2.default.func };
	
	exports.default = LiveEditor;
	module.exports = exports['default'];

/***/ }),

/***/ 1042:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LiveProvider = __webpack_require__(44);
	
	var _cn = __webpack_require__(62);
	
	var _cn2 = _interopRequireDefault(_cn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LiveError = function LiveError(_ref, _ref2) {
	  var live = _ref2.live;
	
	  var className = _ref.className,
	      rest = _objectWithoutProperties(_ref, ['className']);
	
	  return live.error ? _react2.default.createElement(
	    'div',
	    _extends({}, rest, {
	      className: (0, _cn2.default)('react-live-error', className)
	    }),
	    live.error
	  ) : null;
	};
	
	LiveError.contextTypes = _LiveProvider.LiveContextTypes;
	
	exports.default = LiveError;
	module.exports = exports['default'];

/***/ }),

/***/ 1043:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LiveProvider = __webpack_require__(44);
	
	var _cn = __webpack_require__(62);
	
	var _cn2 = _interopRequireDefault(_cn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LivePreview = function LivePreview(_ref, _ref2) {
	  var element = _ref2.live.element;
	
	  var className = _ref.className,
	      rest = _objectWithoutProperties(_ref, ['className']);
	
	  return _react2.default.createElement(
	    'div',
	    _extends({}, rest, {
	      className: (0, _cn2.default)('react-live-preview', className)
	    }),
	    typeof element === 'function' ? (0, _react.createElement)(element) : element
	  );
	};
	
	LivePreview.contextTypes = _LiveProvider.LiveContextTypes;
	
	exports.default = LivePreview;
	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LiveContextTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transpile = __webpack_require__(143);
	
	var _cn = __webpack_require__(62);
	
	var _cn2 = _interopRequireDefault(_cn);
	
	var _Style = __webpack_require__(1040);
	
	var _Style2 = _interopRequireDefault(_Style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LiveContextTypes = exports.LiveContextTypes = {
	  live: _propTypes2.default.shape({
	    code: _propTypes2.default.string,
	    error: _propTypes2.default.string,
	
	    onError: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	
	    element: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.element, _propTypes2.default.func])
	  })
	};
	
	var LiveProvider = function (_Component) {
	  _inherits(LiveProvider, _Component);
	
	  function LiveProvider() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LiveProvider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onChange = function (code) {
	      var _this$props = _this.props,
	          scope = _this$props.scope,
	          transformCode = _this$props.transformCode,
	          noInline = _this$props.noInline;
	
	      _this.transpile({ code: code, scope: scope, transformCode: transformCode, noInline: noInline });
	    }, _this.onError = function (error) {
	      _this.setState({ error: error.toString() });
	    }, _this.transpile = function (_ref) {
	      var code = _ref.code,
	          scope = _ref.scope,
	          transformCode = _ref.transformCode,
	          _ref$noInline = _ref.noInline,
	          noInline = _ref$noInline === undefined ? false : _ref$noInline;
	
	      // Transpilation arguments
	      var input = {
	        code: transformCode ? transformCode(code) : code,
	        scope: scope
	      };
	      var errorCallback = function errorCallback(err) {
	        return _this.setState({ element: undefined, error: err.toString() });
	      };
	      var renderElement = function renderElement(element) {
	        return _this.setState(_extends({}, state, { element: element }));
	      };
	
	      // State reset object
	      var state = { unsafeWrapperError: undefined, error: undefined };
	
	      try {
	        if (noInline) {
	          _this.setState(_extends({}, state, { element: null })); // Reset output for async (no inline) evaluation
	          (0, _transpile.renderElementAsync)(input, renderElement, errorCallback);
	        } else {
	          renderElement((0, _transpile.generateElement)(input, errorCallback));
	        }
	      } catch (error) {
	        _this.setState(_extends({}, state, { error: error.toString() }));
	      }
	    }, _this.getChildContext = function () {
	      return {
	        live: _extends({}, _this.state, {
	          code: _this.props.code,
	          onError: _this.onError,
	          onChange: _this.onChange
	        })
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  LiveProvider.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        code = _props.code,
	        scope = _props.scope,
	        transformCode = _props.transformCode,
	        noInline = _props.noInline;
	
	
	    this.transpile({ code: code, scope: scope, transformCode: transformCode, noInline: noInline });
	  };
	
	  LiveProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {
	    var code = _ref2.code,
	        scope = _ref2.scope,
	        noInline = _ref2.noInline,
	        transformCode = _ref2.transformCode;
	
	    if (code !== this.props.code || scope !== this.props.scope || noInline !== this.props.noInline || transformCode !== this.props.transformCode) {
	      this.transpile({ code: code, scope: scope, transformCode: transformCode, noInline: noInline });
	    }
	  };
	
	  LiveProvider.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        className = _props2.className,
	        code = _props2.code,
	        mountStylesheet = _props2.mountStylesheet,
	        noInline = _props2.noInline,
	        transformCode = _props2.transformCode,
	        rest = _objectWithoutProperties(_props2, ['children', 'className', 'code', 'mountStylesheet', 'noInline', 'transformCode']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({
	        className: (0, _cn2.default)('react-live', className)
	      }, rest),
	      mountStylesheet && _react2.default.createElement(_Style2.default, null),
	      children
	    );
	  };
	
	  return LiveProvider;
	}(_react.Component);
	
	LiveProvider.childContextTypes = LiveContextTypes;
	LiveProvider.defaultProps = {
	  code: '',
	  mountStylesheet: true,
	  noInline: false
	};
	LiveProvider.propTypes = {
	  className: _propTypes2.default.string,
	  code: _propTypes2.default.string,
	  scope: _propTypes2.default.object,
	  mountStylesheet: _propTypes2.default.bool,
	  noInline: _propTypes2.default.bool,
	  transformCode: _propTypes2.default.func
	};
	exports.default = LiveProvider;

/***/ }),

/***/ 1044:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = "\n.prism-code {\n  display: block;\n  white-space: pre;\n\n  background-color: #1D1F21;\n  color: #C5C8C6;\n\n  padding: 0.5rem;\n  margin: 0;\n\n  box-sizing: border-box;\n  vertical-align: baseline;\n  outline: none;\n  text-shadow: none;\n  -webkit-hyphens: none;\n  -ms-hyphens: none;\n  hyphens: none;\n  word-wrap: normal;\n  word-break: normal;\n  text-align: left;\n  word-spacing: normal;\n  -moz-tab-size: 2;\n  -o-tab-size: 2;\n  tab-size: 2;\n}\n\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n  color: hsl(30, 20%, 50%);\n}\n\n.token.punctuation {\n  opacity: .7;\n}\n\n.namespace {\n  opacity: .7;\n}\n\n.token.property,\n.token.tag,\n.token.boolean,\n.token.number,\n.token.constant,\n.token.symbol {\n  color: hsl(350, 40%, 70%);\n}\n\n.token.selector,\n.token.attr-name,\n.token.string,\n.token.char,\n.token.builtin,\n.token.inserted {\n  color: hsl(75, 70%, 60%);\n}\n\n.token.operator,\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string,\n.token.variable {\n  color: hsl(40, 90%, 60%);\n}\n\n.token.atrule,\n.token.attr-value,\n.token.keyword {\n  color: hsl(350, 40%, 70%);\n}\n\n.token.regex,\n.token.important {\n  color: #e90;\n}\n\n.token.important,\n.token.bold {\n  font-weight: bold;\n}\n.token.italic {\n  font-style: italic;\n}\n\n.token.entity {\n  cursor: help;\n}\n\n.token.deleted {\n  color: red;\n}\n";
	module.exports = exports["default"];

/***/ }),

/***/ 1045:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LiveProvider = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withLive = function withLive(WrappedComponent) {
	  var WithLive = function (_Component) {
	    _inherits(WithLive, _Component);
	
	    function WithLive() {
	      _classCallCheck(this, WithLive);
	
	      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    WithLive.prototype.render = function render() {
	      var live = this.context.live;
	
	      return _react2.default.createElement(WrappedComponent, { live: live });
	    };
	
	    return WithLive;
	  }(_react.Component);
	
	  WithLive.contextTypes = _LiveProvider.LiveContextTypes;
	
	
	  return WithLive;
	};
	
	exports.default = withLive;
	module.exports = exports['default'];

/***/ }),

/***/ 1046:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withLive = exports.LivePreview = exports.LiveError = exports.LiveEditor = exports.LiveProvider = exports.Editor = undefined;
	
	var _transpile = __webpack_require__(143);
	
	Object.keys(_transpile).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _transpile[key];
	    }
	  });
	});
	
	var _Editor = __webpack_require__(142);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _LiveProvider = __webpack_require__(44);
	
	var _LiveProvider2 = _interopRequireDefault(_LiveProvider);
	
	var _LiveEditor = __webpack_require__(1041);
	
	var _LiveEditor2 = _interopRequireDefault(_LiveEditor);
	
	var _LiveError = __webpack_require__(1042);
	
	var _LiveError2 = _interopRequireDefault(_LiveError);
	
	var _LivePreview = __webpack_require__(1043);
	
	var _LivePreview2 = _interopRequireDefault(_LivePreview);
	
	var _withLive = __webpack_require__(1045);
	
	var _withLive2 = _interopRequireDefault(_withLive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Editor = _Editor2.default;
	exports.LiveProvider = _LiveProvider2.default;
	exports.LiveEditor = _LiveEditor2.default;
	exports.LiveError = _LiveError2.default;
	exports.LivePreview = _LivePreview2.default;
	exports.withLive = _withLive2.default;

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var cn = function cn() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return args.filter(Boolean).join(' ');
	};
	
	exports.default = cn;
	module.exports = exports['default'];

/***/ }),

/***/ 1047:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getLine = function getLine(plain, cursorPos) {
	  var startSlice = plain.slice(0, cursorPos);
	  var lastNewline = startSlice.lastIndexOf('\n') + 1;
	  var lineSlice = startSlice.slice(lastNewline);
	  return lineSlice;
	};
	
	var indentRe = /^\s+/;
	
	var getIndent = exports.getIndent = function getIndent(plain, cursorPos) {
	  var line = getLine(plain, cursorPos);
	  var matches = line.match(indentRe);
	  if (matches === null) {
	    return '';
	  }
	
	  return matches[0] || '';
	};
	
	var deindentSpacesRe = /^(\t|  )*  $/;
	
	var getDeindentLevel = exports.getDeindentLevel = function getDeindentLevel(plain, cursorPos) {
	  var line = getLine(plain, cursorPos);
	  if (!deindentSpacesRe.test(line)) {
	    return 0; // Doesn't match regex, so normal behaviour can apply
	  }
	
	  // The line contains only whitespace indentation
	  // thus two characters must be deleted
	  return 2;
	};

/***/ }),

/***/ 1048:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _unescape = __webpack_require__(1136);
	
	var _unescape2 = _interopRequireDefault(_unescape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var htmlToPlain = function htmlToPlain(html) {
	  return (0, _unescape2.default)(html.replace(/<br>/gm, '\n').replace(/<\/?[^>]*>/gm, ''));
	};
	
	exports.default = htmlToPlain;
	module.exports = exports['default'];

/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var indentRe = /^((\t|  )+)/mg;
	var tabRe = /\t/g;
	
	var normalizeCode = function normalizeCode(code) {
	  return code.replace(indentRe, function (_, indentation) {
	    return indentation.replace(tabRe, '  ');
	  });
	};
	
	exports.default = normalizeCode;
	module.exports = exports['default'];

/***/ }),

/***/ 1050:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var normalizeHtml = function normalizeHtml(html) {
	  return html.replace('\n', '<br>');
	};
	
	exports.default = normalizeHtml;
	module.exports = exports['default'];

/***/ }),

/***/ 1051:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _prismCore = __webpack_require__(1029);
	
	__webpack_require__(1028);
	
	__webpack_require__(1030);
	
	__webpack_require__(1032);
	
	__webpack_require__(1031);
	
	var prism = function prism(code) {
	  return (0, _prismCore.highlight)(code, _prismCore.languages.jsx);
	};
	
	exports.default = prism;
	module.exports = exports['default'];

/***/ }),

/***/ 1052:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var errorBoundary = function errorBoundary(element, errorCallback) {
	  var isEvalFunc = typeof element === 'function';
	
	  if (isEvalFunc && _react.Component.isPrototypeOf(element)) {
	    var originalRender = element.prototype.render;
	    element.prototype.render = function render() {
	      try {
	        return originalRender.apply(this, arguments);
	      } catch (err) {
	        setTimeout(function () {
	          errorCallback(err);
	        });
	
	        return null;
	      }
	    };
	  } else if (isEvalFunc) {
	    return function wrappedPFC() {
	      try {
	        return element();
	      } catch (err) {
	        setTimeout(function () {
	          errorCallback(err);
	        });
	
	        return null;
	      }
	    };
	  }
	
	  return element;
	};
	
	exports.default = errorBoundary;
	module.exports = exports['default'];

/***/ }),

/***/ 1053:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transform = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var evalCode = function evalCode(code, scope) {
	  var scopeKeys = Object.keys(scope);
	  var scopeValues = scopeKeys.map(function (key) {
	    return scope[key];
	  });
	  var res = new (Function.prototype.bind.apply(Function, [null].concat(['_poly', 'React'], scopeKeys, [code])))();
	  return res.apply(undefined, [_transform._poly, _react2.default].concat(scopeValues));
	};
	
	exports.default = evalCode;
	module.exports = exports['default'];

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.renderElementAsync = exports.generateElement = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _transform = __webpack_require__(144);
	
	var _transform2 = _interopRequireDefault(_transform);
	
	var _errorBoundary = __webpack_require__(1052);
	
	var _errorBoundary2 = _interopRequireDefault(_errorBoundary);
	
	var _evalCode = __webpack_require__(1053);
	
	var _evalCode2 = _interopRequireDefault(_evalCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var generateElement = exports.generateElement = function generateElement(_ref, errorCallback) {
	  var _ref$code = _ref.code,
	      code = _ref$code === undefined ? '' : _ref$code,
	      _ref$scope = _ref.scope,
	      scope = _ref$scope === undefined ? {} : _ref$scope;
	
	  // NOTE: Workaround for classes, since buble doesn't allow `return` without a function
	  var transformed = (0, _transform2.default)(code).trim().replace(/^var \w+ =/, '').replace(/;$/, '');
	
	  return (0, _errorBoundary2.default)((0, _evalCode2.default)('return (' + transformed + ')', scope), errorCallback);
	};
	
	var renderElementAsync = exports.renderElementAsync = function renderElementAsync(_ref2, resultCallback, errorCallback) {
	  var _ref2$code = _ref2.code,
	      code = _ref2$code === undefined ? '' : _ref2$code,
	      _ref2$scope = _ref2.scope,
	      scope = _ref2$scope === undefined ? {} : _ref2$scope;
	
	  var render = function render(element) {
	    resultCallback((0, _errorBoundary2.default)(element, errorCallback));
	  };
	
	  if (!/render\s*\(/.test(code)) {
	    return errorCallback(new SyntaxError('No-Inline evaluations must call `render`.'));
	  }
	
	  (0, _evalCode2.default)((0, _transform2.default)(code), _extends({}, scope, { render: render }));
	};

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._poly = undefined;
	
	var _buble = __webpack_require__(218);
	
	var _assign = __webpack_require__(223);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _poly = exports._poly = { assign: _assign2.default };
	
	var opts = {
	  objectAssign: '_poly.assign',
	  transforms: {
	    dangerousForOf: true,
	    dangerousTaggedTemplateString: true
	  }
	};
	
	exports.default = function (code) {
	  return (0, _buble.transform)(code, opts).code;
	};

/***/ }),

/***/ 1054:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _domIterator = __webpack_require__(302);
	
	var _domIterator2 = _interopRequireDefault(_domIterator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function position(el, pos) {
	  var selection = window.getSelection();
	
	  if (1 == arguments.length) {
	    if (!selection.rangeCount) return;
	    var indexes = {};
	    var range = selection.getRangeAt(0);
	    var clone = range.cloneRange();
	    clone.selectNodeContents(el);
	    clone.setEnd(range.endContainer, range.endOffset);
	    indexes.end = clone.toString().length;
	    clone.setStart(range.startContainer, range.startOffset);
	    indexes.start = indexes.end - clone.toString().length;
	    indexes.atStart = clone.startOffset === 0;
	    indexes.commonAncestorContainer = clone.commonAncestorContainer;
	    indexes.endContainer = clone.endContainer;
	    indexes.startContainer = clone.startContainer;
	    return indexes;
	  }
	
	  var setSelection = pos.end && pos.end !== pos.start;
	  var length = 0;
	  var range = document.createRange();
	  var it = (0, _domIterator2.default)(el).select(Node.TEXT_NODE).revisit(false);
	  var next;
	  var startindex;
	  var start = pos.start > el.textContent.length ? el.textContent.length : pos.start;
	  var end = pos.end > el.textContent.length ? el.textContent.length : pos.end;
	  var atStart = pos.atStart;
	
	  while (next = it.next()) {
	    var olen = length;
	    length += next.textContent.length;
	
	    // Set start point of selection
	    var atLength = atStart ? length > start : length >= start;
	    if (!startindex && atLength) {
	      startindex = true;
	      range.setStart(next, start - olen);
	      if (!setSelection) {
	        range.collapse(true);
	        makeSelection(el, range);
	        break;
	      }
	    }
	
	    // Set end point of selection
	    if (setSelection && length >= end) {
	      range.setEnd(next, end - olen);
	      makeSelection(el, range);
	      break;
	    }
	  }
	}
	
	function makeSelection(el, range) {
	  var selection = window.getSelection();
	  el.focus();
	  selection.removeAllRanges();
	  selection.addRange(range);
	}
	
	exports.default = position;
	module.exports = exports['default'];

/***/ }),

/***/ 1074:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1081);


/***/ }),

/***/ 150:
/***/ (function(module, exports) {

	// List of valid entities
	//
	// Generate with ./support/entities.js script
	//
	'use strict';
	
	/*eslint quotes:0*/
	module.exports = {
	  "Aacute":"\u00C1",
	  "aacute":"\u00E1",
	  "Abreve":"\u0102",
	  "abreve":"\u0103",
	  "ac":"\u223E",
	  "acd":"\u223F",
	  "acE":"\u223E\u0333",
	  "Acirc":"\u00C2",
	  "acirc":"\u00E2",
	  "acute":"\u00B4",
	  "Acy":"\u0410",
	  "acy":"\u0430",
	  "AElig":"\u00C6",
	  "aelig":"\u00E6",
	  "af":"\u2061",
	  "Afr":"\uD835\uDD04",
	  "afr":"\uD835\uDD1E",
	  "Agrave":"\u00C0",
	  "agrave":"\u00E0",
	  "alefsym":"\u2135",
	  "aleph":"\u2135",
	  "Alpha":"\u0391",
	  "alpha":"\u03B1",
	  "Amacr":"\u0100",
	  "amacr":"\u0101",
	  "amalg":"\u2A3F",
	  "AMP":"\u0026",
	  "amp":"\u0026",
	  "And":"\u2A53",
	  "and":"\u2227",
	  "andand":"\u2A55",
	  "andd":"\u2A5C",
	  "andslope":"\u2A58",
	  "andv":"\u2A5A",
	  "ang":"\u2220",
	  "ange":"\u29A4",
	  "angle":"\u2220",
	  "angmsd":"\u2221",
	  "angmsdaa":"\u29A8",
	  "angmsdab":"\u29A9",
	  "angmsdac":"\u29AA",
	  "angmsdad":"\u29AB",
	  "angmsdae":"\u29AC",
	  "angmsdaf":"\u29AD",
	  "angmsdag":"\u29AE",
	  "angmsdah":"\u29AF",
	  "angrt":"\u221F",
	  "angrtvb":"\u22BE",
	  "angrtvbd":"\u299D",
	  "angsph":"\u2222",
	  "angst":"\u00C5",
	  "angzarr":"\u237C",
	  "Aogon":"\u0104",
	  "aogon":"\u0105",
	  "Aopf":"\uD835\uDD38",
	  "aopf":"\uD835\uDD52",
	  "ap":"\u2248",
	  "apacir":"\u2A6F",
	  "apE":"\u2A70",
	  "ape":"\u224A",
	  "apid":"\u224B",
	  "apos":"\u0027",
	  "ApplyFunction":"\u2061",
	  "approx":"\u2248",
	  "approxeq":"\u224A",
	  "Aring":"\u00C5",
	  "aring":"\u00E5",
	  "Ascr":"\uD835\uDC9C",
	  "ascr":"\uD835\uDCB6",
	  "Assign":"\u2254",
	  "ast":"\u002A",
	  "asymp":"\u2248",
	  "asympeq":"\u224D",
	  "Atilde":"\u00C3",
	  "atilde":"\u00E3",
	  "Auml":"\u00C4",
	  "auml":"\u00E4",
	  "awconint":"\u2233",
	  "awint":"\u2A11",
	  "backcong":"\u224C",
	  "backepsilon":"\u03F6",
	  "backprime":"\u2035",
	  "backsim":"\u223D",
	  "backsimeq":"\u22CD",
	  "Backslash":"\u2216",
	  "Barv":"\u2AE7",
	  "barvee":"\u22BD",
	  "Barwed":"\u2306",
	  "barwed":"\u2305",
	  "barwedge":"\u2305",
	  "bbrk":"\u23B5",
	  "bbrktbrk":"\u23B6",
	  "bcong":"\u224C",
	  "Bcy":"\u0411",
	  "bcy":"\u0431",
	  "bdquo":"\u201E",
	  "becaus":"\u2235",
	  "Because":"\u2235",
	  "because":"\u2235",
	  "bemptyv":"\u29B0",
	  "bepsi":"\u03F6",
	  "bernou":"\u212C",
	  "Bernoullis":"\u212C",
	  "Beta":"\u0392",
	  "beta":"\u03B2",
	  "beth":"\u2136",
	  "between":"\u226C",
	  "Bfr":"\uD835\uDD05",
	  "bfr":"\uD835\uDD1F",
	  "bigcap":"\u22C2",
	  "bigcirc":"\u25EF",
	  "bigcup":"\u22C3",
	  "bigodot":"\u2A00",
	  "bigoplus":"\u2A01",
	  "bigotimes":"\u2A02",
	  "bigsqcup":"\u2A06",
	  "bigstar":"\u2605",
	  "bigtriangledown":"\u25BD",
	  "bigtriangleup":"\u25B3",
	  "biguplus":"\u2A04",
	  "bigvee":"\u22C1",
	  "bigwedge":"\u22C0",
	  "bkarow":"\u290D",
	  "blacklozenge":"\u29EB",
	  "blacksquare":"\u25AA",
	  "blacktriangle":"\u25B4",
	  "blacktriangledown":"\u25BE",
	  "blacktriangleleft":"\u25C2",
	  "blacktriangleright":"\u25B8",
	  "blank":"\u2423",
	  "blk12":"\u2592",
	  "blk14":"\u2591",
	  "blk34":"\u2593",
	  "block":"\u2588",
	  "bne":"\u003D\u20E5",
	  "bnequiv":"\u2261\u20E5",
	  "bNot":"\u2AED",
	  "bnot":"\u2310",
	  "Bopf":"\uD835\uDD39",
	  "bopf":"\uD835\uDD53",
	  "bot":"\u22A5",
	  "bottom":"\u22A5",
	  "bowtie":"\u22C8",
	  "boxbox":"\u29C9",
	  "boxDL":"\u2557",
	  "boxDl":"\u2556",
	  "boxdL":"\u2555",
	  "boxdl":"\u2510",
	  "boxDR":"\u2554",
	  "boxDr":"\u2553",
	  "boxdR":"\u2552",
	  "boxdr":"\u250C",
	  "boxH":"\u2550",
	  "boxh":"\u2500",
	  "boxHD":"\u2566",
	  "boxHd":"\u2564",
	  "boxhD":"\u2565",
	  "boxhd":"\u252C",
	  "boxHU":"\u2569",
	  "boxHu":"\u2567",
	  "boxhU":"\u2568",
	  "boxhu":"\u2534",
	  "boxminus":"\u229F",
	  "boxplus":"\u229E",
	  "boxtimes":"\u22A0",
	  "boxUL":"\u255D",
	  "boxUl":"\u255C",
	  "boxuL":"\u255B",
	  "boxul":"\u2518",
	  "boxUR":"\u255A",
	  "boxUr":"\u2559",
	  "boxuR":"\u2558",
	  "boxur":"\u2514",
	  "boxV":"\u2551",
	  "boxv":"\u2502",
	  "boxVH":"\u256C",
	  "boxVh":"\u256B",
	  "boxvH":"\u256A",
	  "boxvh":"\u253C",
	  "boxVL":"\u2563",
	  "boxVl":"\u2562",
	  "boxvL":"\u2561",
	  "boxvl":"\u2524",
	  "boxVR":"\u2560",
	  "boxVr":"\u255F",
	  "boxvR":"\u255E",
	  "boxvr":"\u251C",
	  "bprime":"\u2035",
	  "Breve":"\u02D8",
	  "breve":"\u02D8",
	  "brvbar":"\u00A6",
	  "Bscr":"\u212C",
	  "bscr":"\uD835\uDCB7",
	  "bsemi":"\u204F",
	  "bsim":"\u223D",
	  "bsime":"\u22CD",
	  "bsol":"\u005C",
	  "bsolb":"\u29C5",
	  "bsolhsub":"\u27C8",
	  "bull":"\u2022",
	  "bullet":"\u2022",
	  "bump":"\u224E",
	  "bumpE":"\u2AAE",
	  "bumpe":"\u224F",
	  "Bumpeq":"\u224E",
	  "bumpeq":"\u224F",
	  "Cacute":"\u0106",
	  "cacute":"\u0107",
	  "Cap":"\u22D2",
	  "cap":"\u2229",
	  "capand":"\u2A44",
	  "capbrcup":"\u2A49",
	  "capcap":"\u2A4B",
	  "capcup":"\u2A47",
	  "capdot":"\u2A40",
	  "CapitalDifferentialD":"\u2145",
	  "caps":"\u2229\uFE00",
	  "caret":"\u2041",
	  "caron":"\u02C7",
	  "Cayleys":"\u212D",
	  "ccaps":"\u2A4D",
	  "Ccaron":"\u010C",
	  "ccaron":"\u010D",
	  "Ccedil":"\u00C7",
	  "ccedil":"\u00E7",
	  "Ccirc":"\u0108",
	  "ccirc":"\u0109",
	  "Cconint":"\u2230",
	  "ccups":"\u2A4C",
	  "ccupssm":"\u2A50",
	  "Cdot":"\u010A",
	  "cdot":"\u010B",
	  "cedil":"\u00B8",
	  "Cedilla":"\u00B8",
	  "cemptyv":"\u29B2",
	  "cent":"\u00A2",
	  "CenterDot":"\u00B7",
	  "centerdot":"\u00B7",
	  "Cfr":"\u212D",
	  "cfr":"\uD835\uDD20",
	  "CHcy":"\u0427",
	  "chcy":"\u0447",
	  "check":"\u2713",
	  "checkmark":"\u2713",
	  "Chi":"\u03A7",
	  "chi":"\u03C7",
	  "cir":"\u25CB",
	  "circ":"\u02C6",
	  "circeq":"\u2257",
	  "circlearrowleft":"\u21BA",
	  "circlearrowright":"\u21BB",
	  "circledast":"\u229B",
	  "circledcirc":"\u229A",
	  "circleddash":"\u229D",
	  "CircleDot":"\u2299",
	  "circledR":"\u00AE",
	  "circledS":"\u24C8",
	  "CircleMinus":"\u2296",
	  "CirclePlus":"\u2295",
	  "CircleTimes":"\u2297",
	  "cirE":"\u29C3",
	  "cire":"\u2257",
	  "cirfnint":"\u2A10",
	  "cirmid":"\u2AEF",
	  "cirscir":"\u29C2",
	  "ClockwiseContourIntegral":"\u2232",
	  "CloseCurlyDoubleQuote":"\u201D",
	  "CloseCurlyQuote":"\u2019",
	  "clubs":"\u2663",
	  "clubsuit":"\u2663",
	  "Colon":"\u2237",
	  "colon":"\u003A",
	  "Colone":"\u2A74",
	  "colone":"\u2254",
	  "coloneq":"\u2254",
	  "comma":"\u002C",
	  "commat":"\u0040",
	  "comp":"\u2201",
	  "compfn":"\u2218",
	  "complement":"\u2201",
	  "complexes":"\u2102",
	  "cong":"\u2245",
	  "congdot":"\u2A6D",
	  "Congruent":"\u2261",
	  "Conint":"\u222F",
	  "conint":"\u222E",
	  "ContourIntegral":"\u222E",
	  "Copf":"\u2102",
	  "copf":"\uD835\uDD54",
	  "coprod":"\u2210",
	  "Coproduct":"\u2210",
	  "COPY":"\u00A9",
	  "copy":"\u00A9",
	  "copysr":"\u2117",
	  "CounterClockwiseContourIntegral":"\u2233",
	  "crarr":"\u21B5",
	  "Cross":"\u2A2F",
	  "cross":"\u2717",
	  "Cscr":"\uD835\uDC9E",
	  "cscr":"\uD835\uDCB8",
	  "csub":"\u2ACF",
	  "csube":"\u2AD1",
	  "csup":"\u2AD0",
	  "csupe":"\u2AD2",
	  "ctdot":"\u22EF",
	  "cudarrl":"\u2938",
	  "cudarrr":"\u2935",
	  "cuepr":"\u22DE",
	  "cuesc":"\u22DF",
	  "cularr":"\u21B6",
	  "cularrp":"\u293D",
	  "Cup":"\u22D3",
	  "cup":"\u222A",
	  "cupbrcap":"\u2A48",
	  "CupCap":"\u224D",
	  "cupcap":"\u2A46",
	  "cupcup":"\u2A4A",
	  "cupdot":"\u228D",
	  "cupor":"\u2A45",
	  "cups":"\u222A\uFE00",
	  "curarr":"\u21B7",
	  "curarrm":"\u293C",
	  "curlyeqprec":"\u22DE",
	  "curlyeqsucc":"\u22DF",
	  "curlyvee":"\u22CE",
	  "curlywedge":"\u22CF",
	  "curren":"\u00A4",
	  "curvearrowleft":"\u21B6",
	  "curvearrowright":"\u21B7",
	  "cuvee":"\u22CE",
	  "cuwed":"\u22CF",
	  "cwconint":"\u2232",
	  "cwint":"\u2231",
	  "cylcty":"\u232D",
	  "Dagger":"\u2021",
	  "dagger":"\u2020",
	  "daleth":"\u2138",
	  "Darr":"\u21A1",
	  "dArr":"\u21D3",
	  "darr":"\u2193",
	  "dash":"\u2010",
	  "Dashv":"\u2AE4",
	  "dashv":"\u22A3",
	  "dbkarow":"\u290F",
	  "dblac":"\u02DD",
	  "Dcaron":"\u010E",
	  "dcaron":"\u010F",
	  "Dcy":"\u0414",
	  "dcy":"\u0434",
	  "DD":"\u2145",
	  "dd":"\u2146",
	  "ddagger":"\u2021",
	  "ddarr":"\u21CA",
	  "DDotrahd":"\u2911",
	  "ddotseq":"\u2A77",
	  "deg":"\u00B0",
	  "Del":"\u2207",
	  "Delta":"\u0394",
	  "delta":"\u03B4",
	  "demptyv":"\u29B1",
	  "dfisht":"\u297F",
	  "Dfr":"\uD835\uDD07",
	  "dfr":"\uD835\uDD21",
	  "dHar":"\u2965",
	  "dharl":"\u21C3",
	  "dharr":"\u21C2",
	  "DiacriticalAcute":"\u00B4",
	  "DiacriticalDot":"\u02D9",
	  "DiacriticalDoubleAcute":"\u02DD",
	  "DiacriticalGrave":"\u0060",
	  "DiacriticalTilde":"\u02DC",
	  "diam":"\u22C4",
	  "Diamond":"\u22C4",
	  "diamond":"\u22C4",
	  "diamondsuit":"\u2666",
	  "diams":"\u2666",
	  "die":"\u00A8",
	  "DifferentialD":"\u2146",
	  "digamma":"\u03DD",
	  "disin":"\u22F2",
	  "div":"\u00F7",
	  "divide":"\u00F7",
	  "divideontimes":"\u22C7",
	  "divonx":"\u22C7",
	  "DJcy":"\u0402",
	  "djcy":"\u0452",
	  "dlcorn":"\u231E",
	  "dlcrop":"\u230D",
	  "dollar":"\u0024",
	  "Dopf":"\uD835\uDD3B",
	  "dopf":"\uD835\uDD55",
	  "Dot":"\u00A8",
	  "dot":"\u02D9",
	  "DotDot":"\u20DC",
	  "doteq":"\u2250",
	  "doteqdot":"\u2251",
	  "DotEqual":"\u2250",
	  "dotminus":"\u2238",
	  "dotplus":"\u2214",
	  "dotsquare":"\u22A1",
	  "doublebarwedge":"\u2306",
	  "DoubleContourIntegral":"\u222F",
	  "DoubleDot":"\u00A8",
	  "DoubleDownArrow":"\u21D3",
	  "DoubleLeftArrow":"\u21D0",
	  "DoubleLeftRightArrow":"\u21D4",
	  "DoubleLeftTee":"\u2AE4",
	  "DoubleLongLeftArrow":"\u27F8",
	  "DoubleLongLeftRightArrow":"\u27FA",
	  "DoubleLongRightArrow":"\u27F9",
	  "DoubleRightArrow":"\u21D2",
	  "DoubleRightTee":"\u22A8",
	  "DoubleUpArrow":"\u21D1",
	  "DoubleUpDownArrow":"\u21D5",
	  "DoubleVerticalBar":"\u2225",
	  "DownArrow":"\u2193",
	  "Downarrow":"\u21D3",
	  "downarrow":"\u2193",
	  "DownArrowBar":"\u2913",
	  "DownArrowUpArrow":"\u21F5",
	  "DownBreve":"\u0311",
	  "downdownarrows":"\u21CA",
	  "downharpoonleft":"\u21C3",
	  "downharpoonright":"\u21C2",
	  "DownLeftRightVector":"\u2950",
	  "DownLeftTeeVector":"\u295E",
	  "DownLeftVector":"\u21BD",
	  "DownLeftVectorBar":"\u2956",
	  "DownRightTeeVector":"\u295F",
	  "DownRightVector":"\u21C1",
	  "DownRightVectorBar":"\u2957",
	  "DownTee":"\u22A4",
	  "DownTeeArrow":"\u21A7",
	  "drbkarow":"\u2910",
	  "drcorn":"\u231F",
	  "drcrop":"\u230C",
	  "Dscr":"\uD835\uDC9F",
	  "dscr":"\uD835\uDCB9",
	  "DScy":"\u0405",
	  "dscy":"\u0455",
	  "dsol":"\u29F6",
	  "Dstrok":"\u0110",
	  "dstrok":"\u0111",
	  "dtdot":"\u22F1",
	  "dtri":"\u25BF",
	  "dtrif":"\u25BE",
	  "duarr":"\u21F5",
	  "duhar":"\u296F",
	  "dwangle":"\u29A6",
	  "DZcy":"\u040F",
	  "dzcy":"\u045F",
	  "dzigrarr":"\u27FF",
	  "Eacute":"\u00C9",
	  "eacute":"\u00E9",
	  "easter":"\u2A6E",
	  "Ecaron":"\u011A",
	  "ecaron":"\u011B",
	  "ecir":"\u2256",
	  "Ecirc":"\u00CA",
	  "ecirc":"\u00EA",
	  "ecolon":"\u2255",
	  "Ecy":"\u042D",
	  "ecy":"\u044D",
	  "eDDot":"\u2A77",
	  "Edot":"\u0116",
	  "eDot":"\u2251",
	  "edot":"\u0117",
	  "ee":"\u2147",
	  "efDot":"\u2252",
	  "Efr":"\uD835\uDD08",
	  "efr":"\uD835\uDD22",
	  "eg":"\u2A9A",
	  "Egrave":"\u00C8",
	  "egrave":"\u00E8",
	  "egs":"\u2A96",
	  "egsdot":"\u2A98",
	  "el":"\u2A99",
	  "Element":"\u2208",
	  "elinters":"\u23E7",
	  "ell":"\u2113",
	  "els":"\u2A95",
	  "elsdot":"\u2A97",
	  "Emacr":"\u0112",
	  "emacr":"\u0113",
	  "empty":"\u2205",
	  "emptyset":"\u2205",
	  "EmptySmallSquare":"\u25FB",
	  "emptyv":"\u2205",
	  "EmptyVerySmallSquare":"\u25AB",
	  "emsp":"\u2003",
	  "emsp13":"\u2004",
	  "emsp14":"\u2005",
	  "ENG":"\u014A",
	  "eng":"\u014B",
	  "ensp":"\u2002",
	  "Eogon":"\u0118",
	  "eogon":"\u0119",
	  "Eopf":"\uD835\uDD3C",
	  "eopf":"\uD835\uDD56",
	  "epar":"\u22D5",
	  "eparsl":"\u29E3",
	  "eplus":"\u2A71",
	  "epsi":"\u03B5",
	  "Epsilon":"\u0395",
	  "epsilon":"\u03B5",
	  "epsiv":"\u03F5",
	  "eqcirc":"\u2256",
	  "eqcolon":"\u2255",
	  "eqsim":"\u2242",
	  "eqslantgtr":"\u2A96",
	  "eqslantless":"\u2A95",
	  "Equal":"\u2A75",
	  "equals":"\u003D",
	  "EqualTilde":"\u2242",
	  "equest":"\u225F",
	  "Equilibrium":"\u21CC",
	  "equiv":"\u2261",
	  "equivDD":"\u2A78",
	  "eqvparsl":"\u29E5",
	  "erarr":"\u2971",
	  "erDot":"\u2253",
	  "Escr":"\u2130",
	  "escr":"\u212F",
	  "esdot":"\u2250",
	  "Esim":"\u2A73",
	  "esim":"\u2242",
	  "Eta":"\u0397",
	  "eta":"\u03B7",
	  "ETH":"\u00D0",
	  "eth":"\u00F0",
	  "Euml":"\u00CB",
	  "euml":"\u00EB",
	  "euro":"\u20AC",
	  "excl":"\u0021",
	  "exist":"\u2203",
	  "Exists":"\u2203",
	  "expectation":"\u2130",
	  "ExponentialE":"\u2147",
	  "exponentiale":"\u2147",
	  "fallingdotseq":"\u2252",
	  "Fcy":"\u0424",
	  "fcy":"\u0444",
	  "female":"\u2640",
	  "ffilig":"\uFB03",
	  "fflig":"\uFB00",
	  "ffllig":"\uFB04",
	  "Ffr":"\uD835\uDD09",
	  "ffr":"\uD835\uDD23",
	  "filig":"\uFB01",
	  "FilledSmallSquare":"\u25FC",
	  "FilledVerySmallSquare":"\u25AA",
	  "fjlig":"\u0066\u006A",
	  "flat":"\u266D",
	  "fllig":"\uFB02",
	  "fltns":"\u25B1",
	  "fnof":"\u0192",
	  "Fopf":"\uD835\uDD3D",
	  "fopf":"\uD835\uDD57",
	  "ForAll":"\u2200",
	  "forall":"\u2200",
	  "fork":"\u22D4",
	  "forkv":"\u2AD9",
	  "Fouriertrf":"\u2131",
	  "fpartint":"\u2A0D",
	  "frac12":"\u00BD",
	  "frac13":"\u2153",
	  "frac14":"\u00BC",
	  "frac15":"\u2155",
	  "frac16":"\u2159",
	  "frac18":"\u215B",
	  "frac23":"\u2154",
	  "frac25":"\u2156",
	  "frac34":"\u00BE",
	  "frac35":"\u2157",
	  "frac38":"\u215C",
	  "frac45":"\u2158",
	  "frac56":"\u215A",
	  "frac58":"\u215D",
	  "frac78":"\u215E",
	  "frasl":"\u2044",
	  "frown":"\u2322",
	  "Fscr":"\u2131",
	  "fscr":"\uD835\uDCBB",
	  "gacute":"\u01F5",
	  "Gamma":"\u0393",
	  "gamma":"\u03B3",
	  "Gammad":"\u03DC",
	  "gammad":"\u03DD",
	  "gap":"\u2A86",
	  "Gbreve":"\u011E",
	  "gbreve":"\u011F",
	  "Gcedil":"\u0122",
	  "Gcirc":"\u011C",
	  "gcirc":"\u011D",
	  "Gcy":"\u0413",
	  "gcy":"\u0433",
	  "Gdot":"\u0120",
	  "gdot":"\u0121",
	  "gE":"\u2267",
	  "ge":"\u2265",
	  "gEl":"\u2A8C",
	  "gel":"\u22DB",
	  "geq":"\u2265",
	  "geqq":"\u2267",
	  "geqslant":"\u2A7E",
	  "ges":"\u2A7E",
	  "gescc":"\u2AA9",
	  "gesdot":"\u2A80",
	  "gesdoto":"\u2A82",
	  "gesdotol":"\u2A84",
	  "gesl":"\u22DB\uFE00",
	  "gesles":"\u2A94",
	  "Gfr":"\uD835\uDD0A",
	  "gfr":"\uD835\uDD24",
	  "Gg":"\u22D9",
	  "gg":"\u226B",
	  "ggg":"\u22D9",
	  "gimel":"\u2137",
	  "GJcy":"\u0403",
	  "gjcy":"\u0453",
	  "gl":"\u2277",
	  "gla":"\u2AA5",
	  "glE":"\u2A92",
	  "glj":"\u2AA4",
	  "gnap":"\u2A8A",
	  "gnapprox":"\u2A8A",
	  "gnE":"\u2269",
	  "gne":"\u2A88",
	  "gneq":"\u2A88",
	  "gneqq":"\u2269",
	  "gnsim":"\u22E7",
	  "Gopf":"\uD835\uDD3E",
	  "gopf":"\uD835\uDD58",
	  "grave":"\u0060",
	  "GreaterEqual":"\u2265",
	  "GreaterEqualLess":"\u22DB",
	  "GreaterFullEqual":"\u2267",
	  "GreaterGreater":"\u2AA2",
	  "GreaterLess":"\u2277",
	  "GreaterSlantEqual":"\u2A7E",
	  "GreaterTilde":"\u2273",
	  "Gscr":"\uD835\uDCA2",
	  "gscr":"\u210A",
	  "gsim":"\u2273",
	  "gsime":"\u2A8E",
	  "gsiml":"\u2A90",
	  "GT":"\u003E",
	  "Gt":"\u226B",
	  "gt":"\u003E",
	  "gtcc":"\u2AA7",
	  "gtcir":"\u2A7A",
	  "gtdot":"\u22D7",
	  "gtlPar":"\u2995",
	  "gtquest":"\u2A7C",
	  "gtrapprox":"\u2A86",
	  "gtrarr":"\u2978",
	  "gtrdot":"\u22D7",
	  "gtreqless":"\u22DB",
	  "gtreqqless":"\u2A8C",
	  "gtrless":"\u2277",
	  "gtrsim":"\u2273",
	  "gvertneqq":"\u2269\uFE00",
	  "gvnE":"\u2269\uFE00",
	  "Hacek":"\u02C7",
	  "hairsp":"\u200A",
	  "half":"\u00BD",
	  "hamilt":"\u210B",
	  "HARDcy":"\u042A",
	  "hardcy":"\u044A",
	  "hArr":"\u21D4",
	  "harr":"\u2194",
	  "harrcir":"\u2948",
	  "harrw":"\u21AD",
	  "Hat":"\u005E",
	  "hbar":"\u210F",
	  "Hcirc":"\u0124",
	  "hcirc":"\u0125",
	  "hearts":"\u2665",
	  "heartsuit":"\u2665",
	  "hellip":"\u2026",
	  "hercon":"\u22B9",
	  "Hfr":"\u210C",
	  "hfr":"\uD835\uDD25",
	  "HilbertSpace":"\u210B",
	  "hksearow":"\u2925",
	  "hkswarow":"\u2926",
	  "hoarr":"\u21FF",
	  "homtht":"\u223B",
	  "hookleftarrow":"\u21A9",
	  "hookrightarrow":"\u21AA",
	  "Hopf":"\u210D",
	  "hopf":"\uD835\uDD59",
	  "horbar":"\u2015",
	  "HorizontalLine":"\u2500",
	  "Hscr":"\u210B",
	  "hscr":"\uD835\uDCBD",
	  "hslash":"\u210F",
	  "Hstrok":"\u0126",
	  "hstrok":"\u0127",
	  "HumpDownHump":"\u224E",
	  "HumpEqual":"\u224F",
	  "hybull":"\u2043",
	  "hyphen":"\u2010",
	  "Iacute":"\u00CD",
	  "iacute":"\u00ED",
	  "ic":"\u2063",
	  "Icirc":"\u00CE",
	  "icirc":"\u00EE",
	  "Icy":"\u0418",
	  "icy":"\u0438",
	  "Idot":"\u0130",
	  "IEcy":"\u0415",
	  "iecy":"\u0435",
	  "iexcl":"\u00A1",
	  "iff":"\u21D4",
	  "Ifr":"\u2111",
	  "ifr":"\uD835\uDD26",
	  "Igrave":"\u00CC",
	  "igrave":"\u00EC",
	  "ii":"\u2148",
	  "iiiint":"\u2A0C",
	  "iiint":"\u222D",
	  "iinfin":"\u29DC",
	  "iiota":"\u2129",
	  "IJlig":"\u0132",
	  "ijlig":"\u0133",
	  "Im":"\u2111",
	  "Imacr":"\u012A",
	  "imacr":"\u012B",
	  "image":"\u2111",
	  "ImaginaryI":"\u2148",
	  "imagline":"\u2110",
	  "imagpart":"\u2111",
	  "imath":"\u0131",
	  "imof":"\u22B7",
	  "imped":"\u01B5",
	  "Implies":"\u21D2",
	  "in":"\u2208",
	  "incare":"\u2105",
	  "infin":"\u221E",
	  "infintie":"\u29DD",
	  "inodot":"\u0131",
	  "Int":"\u222C",
	  "int":"\u222B",
	  "intcal":"\u22BA",
	  "integers":"\u2124",
	  "Integral":"\u222B",
	  "intercal":"\u22BA",
	  "Intersection":"\u22C2",
	  "intlarhk":"\u2A17",
	  "intprod":"\u2A3C",
	  "InvisibleComma":"\u2063",
	  "InvisibleTimes":"\u2062",
	  "IOcy":"\u0401",
	  "iocy":"\u0451",
	  "Iogon":"\u012E",
	  "iogon":"\u012F",
	  "Iopf":"\uD835\uDD40",
	  "iopf":"\uD835\uDD5A",
	  "Iota":"\u0399",
	  "iota":"\u03B9",
	  "iprod":"\u2A3C",
	  "iquest":"\u00BF",
	  "Iscr":"\u2110",
	  "iscr":"\uD835\uDCBE",
	  "isin":"\u2208",
	  "isindot":"\u22F5",
	  "isinE":"\u22F9",
	  "isins":"\u22F4",
	  "isinsv":"\u22F3",
	  "isinv":"\u2208",
	  "it":"\u2062",
	  "Itilde":"\u0128",
	  "itilde":"\u0129",
	  "Iukcy":"\u0406",
	  "iukcy":"\u0456",
	  "Iuml":"\u00CF",
	  "iuml":"\u00EF",
	  "Jcirc":"\u0134",
	  "jcirc":"\u0135",
	  "Jcy":"\u0419",
	  "jcy":"\u0439",
	  "Jfr":"\uD835\uDD0D",
	  "jfr":"\uD835\uDD27",
	  "jmath":"\u0237",
	  "Jopf":"\uD835\uDD41",
	  "jopf":"\uD835\uDD5B",
	  "Jscr":"\uD835\uDCA5",
	  "jscr":"\uD835\uDCBF",
	  "Jsercy":"\u0408",
	  "jsercy":"\u0458",
	  "Jukcy":"\u0404",
	  "jukcy":"\u0454",
	  "Kappa":"\u039A",
	  "kappa":"\u03BA",
	  "kappav":"\u03F0",
	  "Kcedil":"\u0136",
	  "kcedil":"\u0137",
	  "Kcy":"\u041A",
	  "kcy":"\u043A",
	  "Kfr":"\uD835\uDD0E",
	  "kfr":"\uD835\uDD28",
	  "kgreen":"\u0138",
	  "KHcy":"\u0425",
	  "khcy":"\u0445",
	  "KJcy":"\u040C",
	  "kjcy":"\u045C",
	  "Kopf":"\uD835\uDD42",
	  "kopf":"\uD835\uDD5C",
	  "Kscr":"\uD835\uDCA6",
	  "kscr":"\uD835\uDCC0",
	  "lAarr":"\u21DA",
	  "Lacute":"\u0139",
	  "lacute":"\u013A",
	  "laemptyv":"\u29B4",
	  "lagran":"\u2112",
	  "Lambda":"\u039B",
	  "lambda":"\u03BB",
	  "Lang":"\u27EA",
	  "lang":"\u27E8",
	  "langd":"\u2991",
	  "langle":"\u27E8",
	  "lap":"\u2A85",
	  "Laplacetrf":"\u2112",
	  "laquo":"\u00AB",
	  "Larr":"\u219E",
	  "lArr":"\u21D0",
	  "larr":"\u2190",
	  "larrb":"\u21E4",
	  "larrbfs":"\u291F",
	  "larrfs":"\u291D",
	  "larrhk":"\u21A9",
	  "larrlp":"\u21AB",
	  "larrpl":"\u2939",
	  "larrsim":"\u2973",
	  "larrtl":"\u21A2",
	  "lat":"\u2AAB",
	  "lAtail":"\u291B",
	  "latail":"\u2919",
	  "late":"\u2AAD",
	  "lates":"\u2AAD\uFE00",
	  "lBarr":"\u290E",
	  "lbarr":"\u290C",
	  "lbbrk":"\u2772",
	  "lbrace":"\u007B",
	  "lbrack":"\u005B",
	  "lbrke":"\u298B",
	  "lbrksld":"\u298F",
	  "lbrkslu":"\u298D",
	  "Lcaron":"\u013D",
	  "lcaron":"\u013E",
	  "Lcedil":"\u013B",
	  "lcedil":"\u013C",
	  "lceil":"\u2308",
	  "lcub":"\u007B",
	  "Lcy":"\u041B",
	  "lcy":"\u043B",
	  "ldca":"\u2936",
	  "ldquo":"\u201C",
	  "ldquor":"\u201E",
	  "ldrdhar":"\u2967",
	  "ldrushar":"\u294B",
	  "ldsh":"\u21B2",
	  "lE":"\u2266",
	  "le":"\u2264",
	  "LeftAngleBracket":"\u27E8",
	  "LeftArrow":"\u2190",
	  "Leftarrow":"\u21D0",
	  "leftarrow":"\u2190",
	  "LeftArrowBar":"\u21E4",
	  "LeftArrowRightArrow":"\u21C6",
	  "leftarrowtail":"\u21A2",
	  "LeftCeiling":"\u2308",
	  "LeftDoubleBracket":"\u27E6",
	  "LeftDownTeeVector":"\u2961",
	  "LeftDownVector":"\u21C3",
	  "LeftDownVectorBar":"\u2959",
	  "LeftFloor":"\u230A",
	  "leftharpoondown":"\u21BD",
	  "leftharpoonup":"\u21BC",
	  "leftleftarrows":"\u21C7",
	  "LeftRightArrow":"\u2194",
	  "Leftrightarrow":"\u21D4",
	  "leftrightarrow":"\u2194",
	  "leftrightarrows":"\u21C6",
	  "leftrightharpoons":"\u21CB",
	  "leftrightsquigarrow":"\u21AD",
	  "LeftRightVector":"\u294E",
	  "LeftTee":"\u22A3",
	  "LeftTeeArrow":"\u21A4",
	  "LeftTeeVector":"\u295A",
	  "leftthreetimes":"\u22CB",
	  "LeftTriangle":"\u22B2",
	  "LeftTriangleBar":"\u29CF",
	  "LeftTriangleEqual":"\u22B4",
	  "LeftUpDownVector":"\u2951",
	  "LeftUpTeeVector":"\u2960",
	  "LeftUpVector":"\u21BF",
	  "LeftUpVectorBar":"\u2958",
	  "LeftVector":"\u21BC",
	  "LeftVectorBar":"\u2952",
	  "lEg":"\u2A8B",
	  "leg":"\u22DA",
	  "leq":"\u2264",
	  "leqq":"\u2266",
	  "leqslant":"\u2A7D",
	  "les":"\u2A7D",
	  "lescc":"\u2AA8",
	  "lesdot":"\u2A7F",
	  "lesdoto":"\u2A81",
	  "lesdotor":"\u2A83",
	  "lesg":"\u22DA\uFE00",
	  "lesges":"\u2A93",
	  "lessapprox":"\u2A85",
	  "lessdot":"\u22D6",
	  "lesseqgtr":"\u22DA",
	  "lesseqqgtr":"\u2A8B",
	  "LessEqualGreater":"\u22DA",
	  "LessFullEqual":"\u2266",
	  "LessGreater":"\u2276",
	  "lessgtr":"\u2276",
	  "LessLess":"\u2AA1",
	  "lesssim":"\u2272",
	  "LessSlantEqual":"\u2A7D",
	  "LessTilde":"\u2272",
	  "lfisht":"\u297C",
	  "lfloor":"\u230A",
	  "Lfr":"\uD835\uDD0F",
	  "lfr":"\uD835\uDD29",
	  "lg":"\u2276",
	  "lgE":"\u2A91",
	  "lHar":"\u2962",
	  "lhard":"\u21BD",
	  "lharu":"\u21BC",
	  "lharul":"\u296A",
	  "lhblk":"\u2584",
	  "LJcy":"\u0409",
	  "ljcy":"\u0459",
	  "Ll":"\u22D8",
	  "ll":"\u226A",
	  "llarr":"\u21C7",
	  "llcorner":"\u231E",
	  "Lleftarrow":"\u21DA",
	  "llhard":"\u296B",
	  "lltri":"\u25FA",
	  "Lmidot":"\u013F",
	  "lmidot":"\u0140",
	  "lmoust":"\u23B0",
	  "lmoustache":"\u23B0",
	  "lnap":"\u2A89",
	  "lnapprox":"\u2A89",
	  "lnE":"\u2268",
	  "lne":"\u2A87",
	  "lneq":"\u2A87",
	  "lneqq":"\u2268",
	  "lnsim":"\u22E6",
	  "loang":"\u27EC",
	  "loarr":"\u21FD",
	  "lobrk":"\u27E6",
	  "LongLeftArrow":"\u27F5",
	  "Longleftarrow":"\u27F8",
	  "longleftarrow":"\u27F5",
	  "LongLeftRightArrow":"\u27F7",
	  "Longleftrightarrow":"\u27FA",
	  "longleftrightarrow":"\u27F7",
	  "longmapsto":"\u27FC",
	  "LongRightArrow":"\u27F6",
	  "Longrightarrow":"\u27F9",
	  "longrightarrow":"\u27F6",
	  "looparrowleft":"\u21AB",
	  "looparrowright":"\u21AC",
	  "lopar":"\u2985",
	  "Lopf":"\uD835\uDD43",
	  "lopf":"\uD835\uDD5D",
	  "loplus":"\u2A2D",
	  "lotimes":"\u2A34",
	  "lowast":"\u2217",
	  "lowbar":"\u005F",
	  "LowerLeftArrow":"\u2199",
	  "LowerRightArrow":"\u2198",
	  "loz":"\u25CA",
	  "lozenge":"\u25CA",
	  "lozf":"\u29EB",
	  "lpar":"\u0028",
	  "lparlt":"\u2993",
	  "lrarr":"\u21C6",
	  "lrcorner":"\u231F",
	  "lrhar":"\u21CB",
	  "lrhard":"\u296D",
	  "lrm":"\u200E",
	  "lrtri":"\u22BF",
	  "lsaquo":"\u2039",
	  "Lscr":"\u2112",
	  "lscr":"\uD835\uDCC1",
	  "Lsh":"\u21B0",
	  "lsh":"\u21B0",
	  "lsim":"\u2272",
	  "lsime":"\u2A8D",
	  "lsimg":"\u2A8F",
	  "lsqb":"\u005B",
	  "lsquo":"\u2018",
	  "lsquor":"\u201A",
	  "Lstrok":"\u0141",
	  "lstrok":"\u0142",
	  "LT":"\u003C",
	  "Lt":"\u226A",
	  "lt":"\u003C",
	  "ltcc":"\u2AA6",
	  "ltcir":"\u2A79",
	  "ltdot":"\u22D6",
	  "lthree":"\u22CB",
	  "ltimes":"\u22C9",
	  "ltlarr":"\u2976",
	  "ltquest":"\u2A7B",
	  "ltri":"\u25C3",
	  "ltrie":"\u22B4",
	  "ltrif":"\u25C2",
	  "ltrPar":"\u2996",
	  "lurdshar":"\u294A",
	  "luruhar":"\u2966",
	  "lvertneqq":"\u2268\uFE00",
	  "lvnE":"\u2268\uFE00",
	  "macr":"\u00AF",
	  "male":"\u2642",
	  "malt":"\u2720",
	  "maltese":"\u2720",
	  "Map":"\u2905",
	  "map":"\u21A6",
	  "mapsto":"\u21A6",
	  "mapstodown":"\u21A7",
	  "mapstoleft":"\u21A4",
	  "mapstoup":"\u21A5",
	  "marker":"\u25AE",
	  "mcomma":"\u2A29",
	  "Mcy":"\u041C",
	  "mcy":"\u043C",
	  "mdash":"\u2014",
	  "mDDot":"\u223A",
	  "measuredangle":"\u2221",
	  "MediumSpace":"\u205F",
	  "Mellintrf":"\u2133",
	  "Mfr":"\uD835\uDD10",
	  "mfr":"\uD835\uDD2A",
	  "mho":"\u2127",
	  "micro":"\u00B5",
	  "mid":"\u2223",
	  "midast":"\u002A",
	  "midcir":"\u2AF0",
	  "middot":"\u00B7",
	  "minus":"\u2212",
	  "minusb":"\u229F",
	  "minusd":"\u2238",
	  "minusdu":"\u2A2A",
	  "MinusPlus":"\u2213",
	  "mlcp":"\u2ADB",
	  "mldr":"\u2026",
	  "mnplus":"\u2213",
	  "models":"\u22A7",
	  "Mopf":"\uD835\uDD44",
	  "mopf":"\uD835\uDD5E",
	  "mp":"\u2213",
	  "Mscr":"\u2133",
	  "mscr":"\uD835\uDCC2",
	  "mstpos":"\u223E",
	  "Mu":"\u039C",
	  "mu":"\u03BC",
	  "multimap":"\u22B8",
	  "mumap":"\u22B8",
	  "nabla":"\u2207",
	  "Nacute":"\u0143",
	  "nacute":"\u0144",
	  "nang":"\u2220\u20D2",
	  "nap":"\u2249",
	  "napE":"\u2A70\u0338",
	  "napid":"\u224B\u0338",
	  "napos":"\u0149",
	  "napprox":"\u2249",
	  "natur":"\u266E",
	  "natural":"\u266E",
	  "naturals":"\u2115",
	  "nbsp":"\u00A0",
	  "nbump":"\u224E\u0338",
	  "nbumpe":"\u224F\u0338",
	  "ncap":"\u2A43",
	  "Ncaron":"\u0147",
	  "ncaron":"\u0148",
	  "Ncedil":"\u0145",
	  "ncedil":"\u0146",
	  "ncong":"\u2247",
	  "ncongdot":"\u2A6D\u0338",
	  "ncup":"\u2A42",
	  "Ncy":"\u041D",
	  "ncy":"\u043D",
	  "ndash":"\u2013",
	  "ne":"\u2260",
	  "nearhk":"\u2924",
	  "neArr":"\u21D7",
	  "nearr":"\u2197",
	  "nearrow":"\u2197",
	  "nedot":"\u2250\u0338",
	  "NegativeMediumSpace":"\u200B",
	  "NegativeThickSpace":"\u200B",
	  "NegativeThinSpace":"\u200B",
	  "NegativeVeryThinSpace":"\u200B",
	  "nequiv":"\u2262",
	  "nesear":"\u2928",
	  "nesim":"\u2242\u0338",
	  "NestedGreaterGreater":"\u226B",
	  "NestedLessLess":"\u226A",
	  "NewLine":"\u000A",
	  "nexist":"\u2204",
	  "nexists":"\u2204",
	  "Nfr":"\uD835\uDD11",
	  "nfr":"\uD835\uDD2B",
	  "ngE":"\u2267\u0338",
	  "nge":"\u2271",
	  "ngeq":"\u2271",
	  "ngeqq":"\u2267\u0338",
	  "ngeqslant":"\u2A7E\u0338",
	  "nges":"\u2A7E\u0338",
	  "nGg":"\u22D9\u0338",
	  "ngsim":"\u2275",
	  "nGt":"\u226B\u20D2",
	  "ngt":"\u226F",
	  "ngtr":"\u226F",
	  "nGtv":"\u226B\u0338",
	  "nhArr":"\u21CE",
	  "nharr":"\u21AE",
	  "nhpar":"\u2AF2",
	  "ni":"\u220B",
	  "nis":"\u22FC",
	  "nisd":"\u22FA",
	  "niv":"\u220B",
	  "NJcy":"\u040A",
	  "njcy":"\u045A",
	  "nlArr":"\u21CD",
	  "nlarr":"\u219A",
	  "nldr":"\u2025",
	  "nlE":"\u2266\u0338",
	  "nle":"\u2270",
	  "nLeftarrow":"\u21CD",
	  "nleftarrow":"\u219A",
	  "nLeftrightarrow":"\u21CE",
	  "nleftrightarrow":"\u21AE",
	  "nleq":"\u2270",
	  "nleqq":"\u2266\u0338",
	  "nleqslant":"\u2A7D\u0338",
	  "nles":"\u2A7D\u0338",
	  "nless":"\u226E",
	  "nLl":"\u22D8\u0338",
	  "nlsim":"\u2274",
	  "nLt":"\u226A\u20D2",
	  "nlt":"\u226E",
	  "nltri":"\u22EA",
	  "nltrie":"\u22EC",
	  "nLtv":"\u226A\u0338",
	  "nmid":"\u2224",
	  "NoBreak":"\u2060",
	  "NonBreakingSpace":"\u00A0",
	  "Nopf":"\u2115",
	  "nopf":"\uD835\uDD5F",
	  "Not":"\u2AEC",
	  "not":"\u00AC",
	  "NotCongruent":"\u2262",
	  "NotCupCap":"\u226D",
	  "NotDoubleVerticalBar":"\u2226",
	  "NotElement":"\u2209",
	  "NotEqual":"\u2260",
	  "NotEqualTilde":"\u2242\u0338",
	  "NotExists":"\u2204",
	  "NotGreater":"\u226F",
	  "NotGreaterEqual":"\u2271",
	  "NotGreaterFullEqual":"\u2267\u0338",
	  "NotGreaterGreater":"\u226B\u0338",
	  "NotGreaterLess":"\u2279",
	  "NotGreaterSlantEqual":"\u2A7E\u0338",
	  "NotGreaterTilde":"\u2275",
	  "NotHumpDownHump":"\u224E\u0338",
	  "NotHumpEqual":"\u224F\u0338",
	  "notin":"\u2209",
	  "notindot":"\u22F5\u0338",
	  "notinE":"\u22F9\u0338",
	  "notinva":"\u2209",
	  "notinvb":"\u22F7",
	  "notinvc":"\u22F6",
	  "NotLeftTriangle":"\u22EA",
	  "NotLeftTriangleBar":"\u29CF\u0338",
	  "NotLeftTriangleEqual":"\u22EC",
	  "NotLess":"\u226E",
	  "NotLessEqual":"\u2270",
	  "NotLessGreater":"\u2278",
	  "NotLessLess":"\u226A\u0338",
	  "NotLessSlantEqual":"\u2A7D\u0338",
	  "NotLessTilde":"\u2274",
	  "NotNestedGreaterGreater":"\u2AA2\u0338",
	  "NotNestedLessLess":"\u2AA1\u0338",
	  "notni":"\u220C",
	  "notniva":"\u220C",
	  "notnivb":"\u22FE",
	  "notnivc":"\u22FD",
	  "NotPrecedes":"\u2280",
	  "NotPrecedesEqual":"\u2AAF\u0338",
	  "NotPrecedesSlantEqual":"\u22E0",
	  "NotReverseElement":"\u220C",
	  "NotRightTriangle":"\u22EB",
	  "NotRightTriangleBar":"\u29D0\u0338",
	  "NotRightTriangleEqual":"\u22ED",
	  "NotSquareSubset":"\u228F\u0338",
	  "NotSquareSubsetEqual":"\u22E2",
	  "NotSquareSuperset":"\u2290\u0338",
	  "NotSquareSupersetEqual":"\u22E3",
	  "NotSubset":"\u2282\u20D2",
	  "NotSubsetEqual":"\u2288",
	  "NotSucceeds":"\u2281",
	  "NotSucceedsEqual":"\u2AB0\u0338",
	  "NotSucceedsSlantEqual":"\u22E1",
	  "NotSucceedsTilde":"\u227F\u0338",
	  "NotSuperset":"\u2283\u20D2",
	  "NotSupersetEqual":"\u2289",
	  "NotTilde":"\u2241",
	  "NotTildeEqual":"\u2244",
	  "NotTildeFullEqual":"\u2247",
	  "NotTildeTilde":"\u2249",
	  "NotVerticalBar":"\u2224",
	  "npar":"\u2226",
	  "nparallel":"\u2226",
	  "nparsl":"\u2AFD\u20E5",
	  "npart":"\u2202\u0338",
	  "npolint":"\u2A14",
	  "npr":"\u2280",
	  "nprcue":"\u22E0",
	  "npre":"\u2AAF\u0338",
	  "nprec":"\u2280",
	  "npreceq":"\u2AAF\u0338",
	  "nrArr":"\u21CF",
	  "nrarr":"\u219B",
	  "nrarrc":"\u2933\u0338",
	  "nrarrw":"\u219D\u0338",
	  "nRightarrow":"\u21CF",
	  "nrightarrow":"\u219B",
	  "nrtri":"\u22EB",
	  "nrtrie":"\u22ED",
	  "nsc":"\u2281",
	  "nsccue":"\u22E1",
	  "nsce":"\u2AB0\u0338",
	  "Nscr":"\uD835\uDCA9",
	  "nscr":"\uD835\uDCC3",
	  "nshortmid":"\u2224",
	  "nshortparallel":"\u2226",
	  "nsim":"\u2241",
	  "nsime":"\u2244",
	  "nsimeq":"\u2244",
	  "nsmid":"\u2224",
	  "nspar":"\u2226",
	  "nsqsube":"\u22E2",
	  "nsqsupe":"\u22E3",
	  "nsub":"\u2284",
	  "nsubE":"\u2AC5\u0338",
	  "nsube":"\u2288",
	  "nsubset":"\u2282\u20D2",
	  "nsubseteq":"\u2288",
	  "nsubseteqq":"\u2AC5\u0338",
	  "nsucc":"\u2281",
	  "nsucceq":"\u2AB0\u0338",
	  "nsup":"\u2285",
	  "nsupE":"\u2AC6\u0338",
	  "nsupe":"\u2289",
	  "nsupset":"\u2283\u20D2",
	  "nsupseteq":"\u2289",
	  "nsupseteqq":"\u2AC6\u0338",
	  "ntgl":"\u2279",
	  "Ntilde":"\u00D1",
	  "ntilde":"\u00F1",
	  "ntlg":"\u2278",
	  "ntriangleleft":"\u22EA",
	  "ntrianglelefteq":"\u22EC",
	  "ntriangleright":"\u22EB",
	  "ntrianglerighteq":"\u22ED",
	  "Nu":"\u039D",
	  "nu":"\u03BD",
	  "num":"\u0023",
	  "numero":"\u2116",
	  "numsp":"\u2007",
	  "nvap":"\u224D\u20D2",
	  "nVDash":"\u22AF",
	  "nVdash":"\u22AE",
	  "nvDash":"\u22AD",
	  "nvdash":"\u22AC",
	  "nvge":"\u2265\u20D2",
	  "nvgt":"\u003E\u20D2",
	  "nvHarr":"\u2904",
	  "nvinfin":"\u29DE",
	  "nvlArr":"\u2902",
	  "nvle":"\u2264\u20D2",
	  "nvlt":"\u003C\u20D2",
	  "nvltrie":"\u22B4\u20D2",
	  "nvrArr":"\u2903",
	  "nvrtrie":"\u22B5\u20D2",
	  "nvsim":"\u223C\u20D2",
	  "nwarhk":"\u2923",
	  "nwArr":"\u21D6",
	  "nwarr":"\u2196",
	  "nwarrow":"\u2196",
	  "nwnear":"\u2927",
	  "Oacute":"\u00D3",
	  "oacute":"\u00F3",
	  "oast":"\u229B",
	  "ocir":"\u229A",
	  "Ocirc":"\u00D4",
	  "ocirc":"\u00F4",
	  "Ocy":"\u041E",
	  "ocy":"\u043E",
	  "odash":"\u229D",
	  "Odblac":"\u0150",
	  "odblac":"\u0151",
	  "odiv":"\u2A38",
	  "odot":"\u2299",
	  "odsold":"\u29BC",
	  "OElig":"\u0152",
	  "oelig":"\u0153",
	  "ofcir":"\u29BF",
	  "Ofr":"\uD835\uDD12",
	  "ofr":"\uD835\uDD2C",
	  "ogon":"\u02DB",
	  "Ograve":"\u00D2",
	  "ograve":"\u00F2",
	  "ogt":"\u29C1",
	  "ohbar":"\u29B5",
	  "ohm":"\u03A9",
	  "oint":"\u222E",
	  "olarr":"\u21BA",
	  "olcir":"\u29BE",
	  "olcross":"\u29BB",
	  "oline":"\u203E",
	  "olt":"\u29C0",
	  "Omacr":"\u014C",
	  "omacr":"\u014D",
	  "Omega":"\u03A9",
	  "omega":"\u03C9",
	  "Omicron":"\u039F",
	  "omicron":"\u03BF",
	  "omid":"\u29B6",
	  "ominus":"\u2296",
	  "Oopf":"\uD835\uDD46",
	  "oopf":"\uD835\uDD60",
	  "opar":"\u29B7",
	  "OpenCurlyDoubleQuote":"\u201C",
	  "OpenCurlyQuote":"\u2018",
	  "operp":"\u29B9",
	  "oplus":"\u2295",
	  "Or":"\u2A54",
	  "or":"\u2228",
	  "orarr":"\u21BB",
	  "ord":"\u2A5D",
	  "order":"\u2134",
	  "orderof":"\u2134",
	  "ordf":"\u00AA",
	  "ordm":"\u00BA",
	  "origof":"\u22B6",
	  "oror":"\u2A56",
	  "orslope":"\u2A57",
	  "orv":"\u2A5B",
	  "oS":"\u24C8",
	  "Oscr":"\uD835\uDCAA",
	  "oscr":"\u2134",
	  "Oslash":"\u00D8",
	  "oslash":"\u00F8",
	  "osol":"\u2298",
	  "Otilde":"\u00D5",
	  "otilde":"\u00F5",
	  "Otimes":"\u2A37",
	  "otimes":"\u2297",
	  "otimesas":"\u2A36",
	  "Ouml":"\u00D6",
	  "ouml":"\u00F6",
	  "ovbar":"\u233D",
	  "OverBar":"\u203E",
	  "OverBrace":"\u23DE",
	  "OverBracket":"\u23B4",
	  "OverParenthesis":"\u23DC",
	  "par":"\u2225",
	  "para":"\u00B6",
	  "parallel":"\u2225",
	  "parsim":"\u2AF3",
	  "parsl":"\u2AFD",
	  "part":"\u2202",
	  "PartialD":"\u2202",
	  "Pcy":"\u041F",
	  "pcy":"\u043F",
	  "percnt":"\u0025",
	  "period":"\u002E",
	  "permil":"\u2030",
	  "perp":"\u22A5",
	  "pertenk":"\u2031",
	  "Pfr":"\uD835\uDD13",
	  "pfr":"\uD835\uDD2D",
	  "Phi":"\u03A6",
	  "phi":"\u03C6",
	  "phiv":"\u03D5",
	  "phmmat":"\u2133",
	  "phone":"\u260E",
	  "Pi":"\u03A0",
	  "pi":"\u03C0",
	  "pitchfork":"\u22D4",
	  "piv":"\u03D6",
	  "planck":"\u210F",
	  "planckh":"\u210E",
	  "plankv":"\u210F",
	  "plus":"\u002B",
	  "plusacir":"\u2A23",
	  "plusb":"\u229E",
	  "pluscir":"\u2A22",
	  "plusdo":"\u2214",
	  "plusdu":"\u2A25",
	  "pluse":"\u2A72",
	  "PlusMinus":"\u00B1",
	  "plusmn":"\u00B1",
	  "plussim":"\u2A26",
	  "plustwo":"\u2A27",
	  "pm":"\u00B1",
	  "Poincareplane":"\u210C",
	  "pointint":"\u2A15",
	  "Popf":"\u2119",
	  "popf":"\uD835\uDD61",
	  "pound":"\u00A3",
	  "Pr":"\u2ABB",
	  "pr":"\u227A",
	  "prap":"\u2AB7",
	  "prcue":"\u227C",
	  "prE":"\u2AB3",
	  "pre":"\u2AAF",
	  "prec":"\u227A",
	  "precapprox":"\u2AB7",
	  "preccurlyeq":"\u227C",
	  "Precedes":"\u227A",
	  "PrecedesEqual":"\u2AAF",
	  "PrecedesSlantEqual":"\u227C",
	  "PrecedesTilde":"\u227E",
	  "preceq":"\u2AAF",
	  "precnapprox":"\u2AB9",
	  "precneqq":"\u2AB5",
	  "precnsim":"\u22E8",
	  "precsim":"\u227E",
	  "Prime":"\u2033",
	  "prime":"\u2032",
	  "primes":"\u2119",
	  "prnap":"\u2AB9",
	  "prnE":"\u2AB5",
	  "prnsim":"\u22E8",
	  "prod":"\u220F",
	  "Product":"\u220F",
	  "profalar":"\u232E",
	  "profline":"\u2312",
	  "profsurf":"\u2313",
	  "prop":"\u221D",
	  "Proportion":"\u2237",
	  "Proportional":"\u221D",
	  "propto":"\u221D",
	  "prsim":"\u227E",
	  "prurel":"\u22B0",
	  "Pscr":"\uD835\uDCAB",
	  "pscr":"\uD835\uDCC5",
	  "Psi":"\u03A8",
	  "psi":"\u03C8",
	  "puncsp":"\u2008",
	  "Qfr":"\uD835\uDD14",
	  "qfr":"\uD835\uDD2E",
	  "qint":"\u2A0C",
	  "Qopf":"\u211A",
	  "qopf":"\uD835\uDD62",
	  "qprime":"\u2057",
	  "Qscr":"\uD835\uDCAC",
	  "qscr":"\uD835\uDCC6",
	  "quaternions":"\u210D",
	  "quatint":"\u2A16",
	  "quest":"\u003F",
	  "questeq":"\u225F",
	  "QUOT":"\u0022",
	  "quot":"\u0022",
	  "rAarr":"\u21DB",
	  "race":"\u223D\u0331",
	  "Racute":"\u0154",
	  "racute":"\u0155",
	  "radic":"\u221A",
	  "raemptyv":"\u29B3",
	  "Rang":"\u27EB",
	  "rang":"\u27E9",
	  "rangd":"\u2992",
	  "range":"\u29A5",
	  "rangle":"\u27E9",
	  "raquo":"\u00BB",
	  "Rarr":"\u21A0",
	  "rArr":"\u21D2",
	  "rarr":"\u2192",
	  "rarrap":"\u2975",
	  "rarrb":"\u21E5",
	  "rarrbfs":"\u2920",
	  "rarrc":"\u2933",
	  "rarrfs":"\u291E",
	  "rarrhk":"\u21AA",
	  "rarrlp":"\u21AC",
	  "rarrpl":"\u2945",
	  "rarrsim":"\u2974",
	  "Rarrtl":"\u2916",
	  "rarrtl":"\u21A3",
	  "rarrw":"\u219D",
	  "rAtail":"\u291C",
	  "ratail":"\u291A",
	  "ratio":"\u2236",
	  "rationals":"\u211A",
	  "RBarr":"\u2910",
	  "rBarr":"\u290F",
	  "rbarr":"\u290D",
	  "rbbrk":"\u2773",
	  "rbrace":"\u007D",
	  "rbrack":"\u005D",
	  "rbrke":"\u298C",
	  "rbrksld":"\u298E",
	  "rbrkslu":"\u2990",
	  "Rcaron":"\u0158",
	  "rcaron":"\u0159",
	  "Rcedil":"\u0156",
	  "rcedil":"\u0157",
	  "rceil":"\u2309",
	  "rcub":"\u007D",
	  "Rcy":"\u0420",
	  "rcy":"\u0440",
	  "rdca":"\u2937",
	  "rdldhar":"\u2969",
	  "rdquo":"\u201D",
	  "rdquor":"\u201D",
	  "rdsh":"\u21B3",
	  "Re":"\u211C",
	  "real":"\u211C",
	  "realine":"\u211B",
	  "realpart":"\u211C",
	  "reals":"\u211D",
	  "rect":"\u25AD",
	  "REG":"\u00AE",
	  "reg":"\u00AE",
	  "ReverseElement":"\u220B",
	  "ReverseEquilibrium":"\u21CB",
	  "ReverseUpEquilibrium":"\u296F",
	  "rfisht":"\u297D",
	  "rfloor":"\u230B",
	  "Rfr":"\u211C",
	  "rfr":"\uD835\uDD2F",
	  "rHar":"\u2964",
	  "rhard":"\u21C1",
	  "rharu":"\u21C0",
	  "rharul":"\u296C",
	  "Rho":"\u03A1",
	  "rho":"\u03C1",
	  "rhov":"\u03F1",
	  "RightAngleBracket":"\u27E9",
	  "RightArrow":"\u2192",
	  "Rightarrow":"\u21D2",
	  "rightarrow":"\u2192",
	  "RightArrowBar":"\u21E5",
	  "RightArrowLeftArrow":"\u21C4",
	  "rightarrowtail":"\u21A3",
	  "RightCeiling":"\u2309",
	  "RightDoubleBracket":"\u27E7",
	  "RightDownTeeVector":"\u295D",
	  "RightDownVector":"\u21C2",
	  "RightDownVectorBar":"\u2955",
	  "RightFloor":"\u230B",
	  "rightharpoondown":"\u21C1",
	  "rightharpoonup":"\u21C0",
	  "rightleftarrows":"\u21C4",
	  "rightleftharpoons":"\u21CC",
	  "rightrightarrows":"\u21C9",
	  "rightsquigarrow":"\u219D",
	  "RightTee":"\u22A2",
	  "RightTeeArrow":"\u21A6",
	  "RightTeeVector":"\u295B",
	  "rightthreetimes":"\u22CC",
	  "RightTriangle":"\u22B3",
	  "RightTriangleBar":"\u29D0",
	  "RightTriangleEqual":"\u22B5",
	  "RightUpDownVector":"\u294F",
	  "RightUpTeeVector":"\u295C",
	  "RightUpVector":"\u21BE",
	  "RightUpVectorBar":"\u2954",
	  "RightVector":"\u21C0",
	  "RightVectorBar":"\u2953",
	  "ring":"\u02DA",
	  "risingdotseq":"\u2253",
	  "rlarr":"\u21C4",
	  "rlhar":"\u21CC",
	  "rlm":"\u200F",
	  "rmoust":"\u23B1",
	  "rmoustache":"\u23B1",
	  "rnmid":"\u2AEE",
	  "roang":"\u27ED",
	  "roarr":"\u21FE",
	  "robrk":"\u27E7",
	  "ropar":"\u2986",
	  "Ropf":"\u211D",
	  "ropf":"\uD835\uDD63",
	  "roplus":"\u2A2E",
	  "rotimes":"\u2A35",
	  "RoundImplies":"\u2970",
	  "rpar":"\u0029",
	  "rpargt":"\u2994",
	  "rppolint":"\u2A12",
	  "rrarr":"\u21C9",
	  "Rrightarrow":"\u21DB",
	  "rsaquo":"\u203A",
	  "Rscr":"\u211B",
	  "rscr":"\uD835\uDCC7",
	  "Rsh":"\u21B1",
	  "rsh":"\u21B1",
	  "rsqb":"\u005D",
	  "rsquo":"\u2019",
	  "rsquor":"\u2019",
	  "rthree":"\u22CC",
	  "rtimes":"\u22CA",
	  "rtri":"\u25B9",
	  "rtrie":"\u22B5",
	  "rtrif":"\u25B8",
	  "rtriltri":"\u29CE",
	  "RuleDelayed":"\u29F4",
	  "ruluhar":"\u2968",
	  "rx":"\u211E",
	  "Sacute":"\u015A",
	  "sacute":"\u015B",
	  "sbquo":"\u201A",
	  "Sc":"\u2ABC",
	  "sc":"\u227B",
	  "scap":"\u2AB8",
	  "Scaron":"\u0160",
	  "scaron":"\u0161",
	  "sccue":"\u227D",
	  "scE":"\u2AB4",
	  "sce":"\u2AB0",
	  "Scedil":"\u015E",
	  "scedil":"\u015F",
	  "Scirc":"\u015C",
	  "scirc":"\u015D",
	  "scnap":"\u2ABA",
	  "scnE":"\u2AB6",
	  "scnsim":"\u22E9",
	  "scpolint":"\u2A13",
	  "scsim":"\u227F",
	  "Scy":"\u0421",
	  "scy":"\u0441",
	  "sdot":"\u22C5",
	  "sdotb":"\u22A1",
	  "sdote":"\u2A66",
	  "searhk":"\u2925",
	  "seArr":"\u21D8",
	  "searr":"\u2198",
	  "searrow":"\u2198",
	  "sect":"\u00A7",
	  "semi":"\u003B",
	  "seswar":"\u2929",
	  "setminus":"\u2216",
	  "setmn":"\u2216",
	  "sext":"\u2736",
	  "Sfr":"\uD835\uDD16",
	  "sfr":"\uD835\uDD30",
	  "sfrown":"\u2322",
	  "sharp":"\u266F",
	  "SHCHcy":"\u0429",
	  "shchcy":"\u0449",
	  "SHcy":"\u0428",
	  "shcy":"\u0448",
	  "ShortDownArrow":"\u2193",
	  "ShortLeftArrow":"\u2190",
	  "shortmid":"\u2223",
	  "shortparallel":"\u2225",
	  "ShortRightArrow":"\u2192",
	  "ShortUpArrow":"\u2191",
	  "shy":"\u00AD",
	  "Sigma":"\u03A3",
	  "sigma":"\u03C3",
	  "sigmaf":"\u03C2",
	  "sigmav":"\u03C2",
	  "sim":"\u223C",
	  "simdot":"\u2A6A",
	  "sime":"\u2243",
	  "simeq":"\u2243",
	  "simg":"\u2A9E",
	  "simgE":"\u2AA0",
	  "siml":"\u2A9D",
	  "simlE":"\u2A9F",
	  "simne":"\u2246",
	  "simplus":"\u2A24",
	  "simrarr":"\u2972",
	  "slarr":"\u2190",
	  "SmallCircle":"\u2218",
	  "smallsetminus":"\u2216",
	  "smashp":"\u2A33",
	  "smeparsl":"\u29E4",
	  "smid":"\u2223",
	  "smile":"\u2323",
	  "smt":"\u2AAA",
	  "smte":"\u2AAC",
	  "smtes":"\u2AAC\uFE00",
	  "SOFTcy":"\u042C",
	  "softcy":"\u044C",
	  "sol":"\u002F",
	  "solb":"\u29C4",
	  "solbar":"\u233F",
	  "Sopf":"\uD835\uDD4A",
	  "sopf":"\uD835\uDD64",
	  "spades":"\u2660",
	  "spadesuit":"\u2660",
	  "spar":"\u2225",
	  "sqcap":"\u2293",
	  "sqcaps":"\u2293\uFE00",
	  "sqcup":"\u2294",
	  "sqcups":"\u2294\uFE00",
	  "Sqrt":"\u221A",
	  "sqsub":"\u228F",
	  "sqsube":"\u2291",
	  "sqsubset":"\u228F",
	  "sqsubseteq":"\u2291",
	  "sqsup":"\u2290",
	  "sqsupe":"\u2292",
	  "sqsupset":"\u2290",
	  "sqsupseteq":"\u2292",
	  "squ":"\u25A1",
	  "Square":"\u25A1",
	  "square":"\u25A1",
	  "SquareIntersection":"\u2293",
	  "SquareSubset":"\u228F",
	  "SquareSubsetEqual":"\u2291",
	  "SquareSuperset":"\u2290",
	  "SquareSupersetEqual":"\u2292",
	  "SquareUnion":"\u2294",
	  "squarf":"\u25AA",
	  "squf":"\u25AA",
	  "srarr":"\u2192",
	  "Sscr":"\uD835\uDCAE",
	  "sscr":"\uD835\uDCC8",
	  "ssetmn":"\u2216",
	  "ssmile":"\u2323",
	  "sstarf":"\u22C6",
	  "Star":"\u22C6",
	  "star":"\u2606",
	  "starf":"\u2605",
	  "straightepsilon":"\u03F5",
	  "straightphi":"\u03D5",
	  "strns":"\u00AF",
	  "Sub":"\u22D0",
	  "sub":"\u2282",
	  "subdot":"\u2ABD",
	  "subE":"\u2AC5",
	  "sube":"\u2286",
	  "subedot":"\u2AC3",
	  "submult":"\u2AC1",
	  "subnE":"\u2ACB",
	  "subne":"\u228A",
	  "subplus":"\u2ABF",
	  "subrarr":"\u2979",
	  "Subset":"\u22D0",
	  "subset":"\u2282",
	  "subseteq":"\u2286",
	  "subseteqq":"\u2AC5",
	  "SubsetEqual":"\u2286",
	  "subsetneq":"\u228A",
	  "subsetneqq":"\u2ACB",
	  "subsim":"\u2AC7",
	  "subsub":"\u2AD5",
	  "subsup":"\u2AD3",
	  "succ":"\u227B",
	  "succapprox":"\u2AB8",
	  "succcurlyeq":"\u227D",
	  "Succeeds":"\u227B",
	  "SucceedsEqual":"\u2AB0",
	  "SucceedsSlantEqual":"\u227D",
	  "SucceedsTilde":"\u227F",
	  "succeq":"\u2AB0",
	  "succnapprox":"\u2ABA",
	  "succneqq":"\u2AB6",
	  "succnsim":"\u22E9",
	  "succsim":"\u227F",
	  "SuchThat":"\u220B",
	  "Sum":"\u2211",
	  "sum":"\u2211",
	  "sung":"\u266A",
	  "Sup":"\u22D1",
	  "sup":"\u2283",
	  "sup1":"\u00B9",
	  "sup2":"\u00B2",
	  "sup3":"\u00B3",
	  "supdot":"\u2ABE",
	  "supdsub":"\u2AD8",
	  "supE":"\u2AC6",
	  "supe":"\u2287",
	  "supedot":"\u2AC4",
	  "Superset":"\u2283",
	  "SupersetEqual":"\u2287",
	  "suphsol":"\u27C9",
	  "suphsub":"\u2AD7",
	  "suplarr":"\u297B",
	  "supmult":"\u2AC2",
	  "supnE":"\u2ACC",
	  "supne":"\u228B",
	  "supplus":"\u2AC0",
	  "Supset":"\u22D1",
	  "supset":"\u2283",
	  "supseteq":"\u2287",
	  "supseteqq":"\u2AC6",
	  "supsetneq":"\u228B",
	  "supsetneqq":"\u2ACC",
	  "supsim":"\u2AC8",
	  "supsub":"\u2AD4",
	  "supsup":"\u2AD6",
	  "swarhk":"\u2926",
	  "swArr":"\u21D9",
	  "swarr":"\u2199",
	  "swarrow":"\u2199",
	  "swnwar":"\u292A",
	  "szlig":"\u00DF",
	  "Tab":"\u0009",
	  "target":"\u2316",
	  "Tau":"\u03A4",
	  "tau":"\u03C4",
	  "tbrk":"\u23B4",
	  "Tcaron":"\u0164",
	  "tcaron":"\u0165",
	  "Tcedil":"\u0162",
	  "tcedil":"\u0163",
	  "Tcy":"\u0422",
	  "tcy":"\u0442",
	  "tdot":"\u20DB",
	  "telrec":"\u2315",
	  "Tfr":"\uD835\uDD17",
	  "tfr":"\uD835\uDD31",
	  "there4":"\u2234",
	  "Therefore":"\u2234",
	  "therefore":"\u2234",
	  "Theta":"\u0398",
	  "theta":"\u03B8",
	  "thetasym":"\u03D1",
	  "thetav":"\u03D1",
	  "thickapprox":"\u2248",
	  "thicksim":"\u223C",
	  "ThickSpace":"\u205F\u200A",
	  "thinsp":"\u2009",
	  "ThinSpace":"\u2009",
	  "thkap":"\u2248",
	  "thksim":"\u223C",
	  "THORN":"\u00DE",
	  "thorn":"\u00FE",
	  "Tilde":"\u223C",
	  "tilde":"\u02DC",
	  "TildeEqual":"\u2243",
	  "TildeFullEqual":"\u2245",
	  "TildeTilde":"\u2248",
	  "times":"\u00D7",
	  "timesb":"\u22A0",
	  "timesbar":"\u2A31",
	  "timesd":"\u2A30",
	  "tint":"\u222D",
	  "toea":"\u2928",
	  "top":"\u22A4",
	  "topbot":"\u2336",
	  "topcir":"\u2AF1",
	  "Topf":"\uD835\uDD4B",
	  "topf":"\uD835\uDD65",
	  "topfork":"\u2ADA",
	  "tosa":"\u2929",
	  "tprime":"\u2034",
	  "TRADE":"\u2122",
	  "trade":"\u2122",
	  "triangle":"\u25B5",
	  "triangledown":"\u25BF",
	  "triangleleft":"\u25C3",
	  "trianglelefteq":"\u22B4",
	  "triangleq":"\u225C",
	  "triangleright":"\u25B9",
	  "trianglerighteq":"\u22B5",
	  "tridot":"\u25EC",
	  "trie":"\u225C",
	  "triminus":"\u2A3A",
	  "TripleDot":"\u20DB",
	  "triplus":"\u2A39",
	  "trisb":"\u29CD",
	  "tritime":"\u2A3B",
	  "trpezium":"\u23E2",
	  "Tscr":"\uD835\uDCAF",
	  "tscr":"\uD835\uDCC9",
	  "TScy":"\u0426",
	  "tscy":"\u0446",
	  "TSHcy":"\u040B",
	  "tshcy":"\u045B",
	  "Tstrok":"\u0166",
	  "tstrok":"\u0167",
	  "twixt":"\u226C",
	  "twoheadleftarrow":"\u219E",
	  "twoheadrightarrow":"\u21A0",
	  "Uacute":"\u00DA",
	  "uacute":"\u00FA",
	  "Uarr":"\u219F",
	  "uArr":"\u21D1",
	  "uarr":"\u2191",
	  "Uarrocir":"\u2949",
	  "Ubrcy":"\u040E",
	  "ubrcy":"\u045E",
	  "Ubreve":"\u016C",
	  "ubreve":"\u016D",
	  "Ucirc":"\u00DB",
	  "ucirc":"\u00FB",
	  "Ucy":"\u0423",
	  "ucy":"\u0443",
	  "udarr":"\u21C5",
	  "Udblac":"\u0170",
	  "udblac":"\u0171",
	  "udhar":"\u296E",
	  "ufisht":"\u297E",
	  "Ufr":"\uD835\uDD18",
	  "ufr":"\uD835\uDD32",
	  "Ugrave":"\u00D9",
	  "ugrave":"\u00F9",
	  "uHar":"\u2963",
	  "uharl":"\u21BF",
	  "uharr":"\u21BE",
	  "uhblk":"\u2580",
	  "ulcorn":"\u231C",
	  "ulcorner":"\u231C",
	  "ulcrop":"\u230F",
	  "ultri":"\u25F8",
	  "Umacr":"\u016A",
	  "umacr":"\u016B",
	  "uml":"\u00A8",
	  "UnderBar":"\u005F",
	  "UnderBrace":"\u23DF",
	  "UnderBracket":"\u23B5",
	  "UnderParenthesis":"\u23DD",
	  "Union":"\u22C3",
	  "UnionPlus":"\u228E",
	  "Uogon":"\u0172",
	  "uogon":"\u0173",
	  "Uopf":"\uD835\uDD4C",
	  "uopf":"\uD835\uDD66",
	  "UpArrow":"\u2191",
	  "Uparrow":"\u21D1",
	  "uparrow":"\u2191",
	  "UpArrowBar":"\u2912",
	  "UpArrowDownArrow":"\u21C5",
	  "UpDownArrow":"\u2195",
	  "Updownarrow":"\u21D5",
	  "updownarrow":"\u2195",
	  "UpEquilibrium":"\u296E",
	  "upharpoonleft":"\u21BF",
	  "upharpoonright":"\u21BE",
	  "uplus":"\u228E",
	  "UpperLeftArrow":"\u2196",
	  "UpperRightArrow":"\u2197",
	  "Upsi":"\u03D2",
	  "upsi":"\u03C5",
	  "upsih":"\u03D2",
	  "Upsilon":"\u03A5",
	  "upsilon":"\u03C5",
	  "UpTee":"\u22A5",
	  "UpTeeArrow":"\u21A5",
	  "upuparrows":"\u21C8",
	  "urcorn":"\u231D",
	  "urcorner":"\u231D",
	  "urcrop":"\u230E",
	  "Uring":"\u016E",
	  "uring":"\u016F",
	  "urtri":"\u25F9",
	  "Uscr":"\uD835\uDCB0",
	  "uscr":"\uD835\uDCCA",
	  "utdot":"\u22F0",
	  "Utilde":"\u0168",
	  "utilde":"\u0169",
	  "utri":"\u25B5",
	  "utrif":"\u25B4",
	  "uuarr":"\u21C8",
	  "Uuml":"\u00DC",
	  "uuml":"\u00FC",
	  "uwangle":"\u29A7",
	  "vangrt":"\u299C",
	  "varepsilon":"\u03F5",
	  "varkappa":"\u03F0",
	  "varnothing":"\u2205",
	  "varphi":"\u03D5",
	  "varpi":"\u03D6",
	  "varpropto":"\u221D",
	  "vArr":"\u21D5",
	  "varr":"\u2195",
	  "varrho":"\u03F1",
	  "varsigma":"\u03C2",
	  "varsubsetneq":"\u228A\uFE00",
	  "varsubsetneqq":"\u2ACB\uFE00",
	  "varsupsetneq":"\u228B\uFE00",
	  "varsupsetneqq":"\u2ACC\uFE00",
	  "vartheta":"\u03D1",
	  "vartriangleleft":"\u22B2",
	  "vartriangleright":"\u22B3",
	  "Vbar":"\u2AEB",
	  "vBar":"\u2AE8",
	  "vBarv":"\u2AE9",
	  "Vcy":"\u0412",
	  "vcy":"\u0432",
	  "VDash":"\u22AB",
	  "Vdash":"\u22A9",
	  "vDash":"\u22A8",
	  "vdash":"\u22A2",
	  "Vdashl":"\u2AE6",
	  "Vee":"\u22C1",
	  "vee":"\u2228",
	  "veebar":"\u22BB",
	  "veeeq":"\u225A",
	  "vellip":"\u22EE",
	  "Verbar":"\u2016",
	  "verbar":"\u007C",
	  "Vert":"\u2016",
	  "vert":"\u007C",
	  "VerticalBar":"\u2223",
	  "VerticalLine":"\u007C",
	  "VerticalSeparator":"\u2758",
	  "VerticalTilde":"\u2240",
	  "VeryThinSpace":"\u200A",
	  "Vfr":"\uD835\uDD19",
	  "vfr":"\uD835\uDD33",
	  "vltri":"\u22B2",
	  "vnsub":"\u2282\u20D2",
	  "vnsup":"\u2283\u20D2",
	  "Vopf":"\uD835\uDD4D",
	  "vopf":"\uD835\uDD67",
	  "vprop":"\u221D",
	  "vrtri":"\u22B3",
	  "Vscr":"\uD835\uDCB1",
	  "vscr":"\uD835\uDCCB",
	  "vsubnE":"\u2ACB\uFE00",
	  "vsubne":"\u228A\uFE00",
	  "vsupnE":"\u2ACC\uFE00",
	  "vsupne":"\u228B\uFE00",
	  "Vvdash":"\u22AA",
	  "vzigzag":"\u299A",
	  "Wcirc":"\u0174",
	  "wcirc":"\u0175",
	  "wedbar":"\u2A5F",
	  "Wedge":"\u22C0",
	  "wedge":"\u2227",
	  "wedgeq":"\u2259",
	  "weierp":"\u2118",
	  "Wfr":"\uD835\uDD1A",
	  "wfr":"\uD835\uDD34",
	  "Wopf":"\uD835\uDD4E",
	  "wopf":"\uD835\uDD68",
	  "wp":"\u2118",
	  "wr":"\u2240",
	  "wreath":"\u2240",
	  "Wscr":"\uD835\uDCB2",
	  "wscr":"\uD835\uDCCC",
	  "xcap":"\u22C2",
	  "xcirc":"\u25EF",
	  "xcup":"\u22C3",
	  "xdtri":"\u25BD",
	  "Xfr":"\uD835\uDD1B",
	  "xfr":"\uD835\uDD35",
	  "xhArr":"\u27FA",
	  "xharr":"\u27F7",
	  "Xi":"\u039E",
	  "xi":"\u03BE",
	  "xlArr":"\u27F8",
	  "xlarr":"\u27F5",
	  "xmap":"\u27FC",
	  "xnis":"\u22FB",
	  "xodot":"\u2A00",
	  "Xopf":"\uD835\uDD4F",
	  "xopf":"\uD835\uDD69",
	  "xoplus":"\u2A01",
	  "xotime":"\u2A02",
	  "xrArr":"\u27F9",
	  "xrarr":"\u27F6",
	  "Xscr":"\uD835\uDCB3",
	  "xscr":"\uD835\uDCCD",
	  "xsqcup":"\u2A06",
	  "xuplus":"\u2A04",
	  "xutri":"\u25B3",
	  "xvee":"\u22C1",
	  "xwedge":"\u22C0",
	  "Yacute":"\u00DD",
	  "yacute":"\u00FD",
	  "YAcy":"\u042F",
	  "yacy":"\u044F",
	  "Ycirc":"\u0176",
	  "ycirc":"\u0177",
	  "Ycy":"\u042B",
	  "ycy":"\u044B",
	  "yen":"\u00A5",
	  "Yfr":"\uD835\uDD1C",
	  "yfr":"\uD835\uDD36",
	  "YIcy":"\u0407",
	  "yicy":"\u0457",
	  "Yopf":"\uD835\uDD50",
	  "yopf":"\uD835\uDD6A",
	  "Yscr":"\uD835\uDCB4",
	  "yscr":"\uD835\uDCCE",
	  "YUcy":"\u042E",
	  "yucy":"\u044E",
	  "Yuml":"\u0178",
	  "yuml":"\u00FF",
	  "Zacute":"\u0179",
	  "zacute":"\u017A",
	  "Zcaron":"\u017D",
	  "zcaron":"\u017E",
	  "Zcy":"\u0417",
	  "zcy":"\u0437",
	  "Zdot":"\u017B",
	  "zdot":"\u017C",
	  "zeetrf":"\u2128",
	  "ZeroWidthSpace":"\u200B",
	  "Zeta":"\u0396",
	  "zeta":"\u03B6",
	  "Zfr":"\u2128",
	  "zfr":"\uD835\uDD37",
	  "ZHcy":"\u0416",
	  "zhcy":"\u0436",
	  "zigrarr":"\u21DD",
	  "Zopf":"\u2124",
	  "zopf":"\uD835\uDD6B",
	  "Zscr":"\uD835\uDCB5",
	  "zscr":"\uD835\uDCCF",
	  "zwj":"\u200D",
	  "zwnj":"\u200C"
	};


/***/ }),

/***/ 1075:
/***/ (function(module, exports) {

	// List of valid html blocks names, accorting to commonmark spec
	// http://jgm.github.io/CommonMark/spec.html#html-blocks
	
	'use strict';
	
	var html_blocks = {};
	
	[
	  'article',
	  'aside',
	  'button',
	  'blockquote',
	  'body',
	  'canvas',
	  'caption',
	  'col',
	  'colgroup',
	  'dd',
	  'div',
	  'dl',
	  'dt',
	  'embed',
	  'fieldset',
	  'figcaption',
	  'figure',
	  'footer',
	  'form',
	  'h1',
	  'h2',
	  'h3',
	  'h4',
	  'h5',
	  'h6',
	  'header',
	  'hgroup',
	  'hr',
	  'iframe',
	  'li',
	  'map',
	  'object',
	  'ol',
	  'output',
	  'p',
	  'pre',
	  'progress',
	  'script',
	  'section',
	  'style',
	  'table',
	  'tbody',
	  'td',
	  'textarea',
	  'tfoot',
	  'th',
	  'tr',
	  'thead',
	  'ul',
	  'video'
	].forEach(function (name) { html_blocks[name] = true; });
	
	
	module.exports = html_blocks;


/***/ }),

/***/ 1076:
/***/ (function(module, exports) {

	// Regexps to match html elements
	
	'use strict';
	
	
	function replace(regex, options) {
	  regex = regex.source;
	  options = options || '';
	
	  return function self(name, val) {
	    if (!name) {
	      return new RegExp(regex, options);
	    }
	    val = val.source || val;
	    regex = regex.replace(name, val);
	    return self;
	  };
	}
	
	
	var attr_name     = /[a-zA-Z_:][a-zA-Z0-9:._-]*/;
	
	var unquoted      = /[^"'=<>`\x00-\x20]+/;
	var single_quoted = /'[^']*'/;
	var double_quoted = /"[^"]*"/;
	
	/*eslint no-spaced-func:0*/
	var attr_value  = replace(/(?:unquoted|single_quoted|double_quoted)/)
	                    ('unquoted', unquoted)
	                    ('single_quoted', single_quoted)
	                    ('double_quoted', double_quoted)
	                    ();
	
	var attribute   = replace(/(?:\s+attr_name(?:\s*=\s*attr_value)?)/)
	                    ('attr_name', attr_name)
	                    ('attr_value', attr_value)
	                    ();
	
	var open_tag    = replace(/<[A-Za-z][A-Za-z0-9]*attribute*\s*\/?>/)
	                    ('attribute', attribute)
	                    ();
	
	var close_tag   = /<\/[A-Za-z][A-Za-z0-9]*\s*>/;
	var comment     = /<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->/;
	var processing  = /<[?].*?[?]>/;
	var declaration = /<![A-Z]+\s+[^>]*>/;
	var cdata       = /<!\[CDATA\[[\s\S]*?\]\]>/;
	
	var HTML_TAG_RE = replace(/^(?:open_tag|close_tag|comment|processing|declaration|cdata)/)
	  ('open_tag', open_tag)
	  ('close_tag', close_tag)
	  ('comment', comment)
	  ('processing', processing)
	  ('declaration', declaration)
	  ('cdata', cdata)
	  ();
	
	
	module.exports.HTML_TAG_RE = HTML_TAG_RE;


/***/ }),

/***/ 1077:
/***/ (function(module, exports) {

	// List of valid url schemas, accorting to commonmark spec
	// http://jgm.github.io/CommonMark/spec.html#autolinks
	
	'use strict';
	
	
	module.exports = [
	  'coap',
	  'doi',
	  'javascript',
	  'aaa',
	  'aaas',
	  'about',
	  'acap',
	  'cap',
	  'cid',
	  'crid',
	  'data',
	  'dav',
	  'dict',
	  'dns',
	  'file',
	  'ftp',
	  'geo',
	  'go',
	  'gopher',
	  'h323',
	  'http',
	  'https',
	  'iax',
	  'icap',
	  'im',
	  'imap',
	  'info',
	  'ipp',
	  'iris',
	  'iris.beep',
	  'iris.xpc',
	  'iris.xpcs',
	  'iris.lwz',
	  'ldap',
	  'mailto',
	  'mid',
	  'msrp',
	  'msrps',
	  'mtqp',
	  'mupdate',
	  'news',
	  'nfs',
	  'ni',
	  'nih',
	  'nntp',
	  'opaquelocktoken',
	  'pop',
	  'pres',
	  'rtsp',
	  'service',
	  'session',
	  'shttp',
	  'sieve',
	  'sip',
	  'sips',
	  'sms',
	  'snmp',
	  'soap.beep',
	  'soap.beeps',
	  'tag',
	  'tel',
	  'telnet',
	  'tftp',
	  'thismessage',
	  'tn3270',
	  'tip',
	  'tv',
	  'urn',
	  'vemmi',
	  'ws',
	  'wss',
	  'xcon',
	  'xcon-userid',
	  'xmlrpc.beep',
	  'xmlrpc.beeps',
	  'xmpp',
	  'z39.50r',
	  'z39.50s',
	  'adiumxtra',
	  'afp',
	  'afs',
	  'aim',
	  'apt',
	  'attachment',
	  'aw',
	  'beshare',
	  'bitcoin',
	  'bolo',
	  'callto',
	  'chrome',
	  'chrome-extension',
	  'com-eventbrite-attendee',
	  'content',
	  'cvs',
	  'dlna-playsingle',
	  'dlna-playcontainer',
	  'dtn',
	  'dvb',
	  'ed2k',
	  'facetime',
	  'feed',
	  'finger',
	  'fish',
	  'gg',
	  'git',
	  'gizmoproject',
	  'gtalk',
	  'hcp',
	  'icon',
	  'ipn',
	  'irc',
	  'irc6',
	  'ircs',
	  'itms',
	  'jar',
	  'jms',
	  'keyparc',
	  'lastfm',
	  'ldaps',
	  'magnet',
	  'maps',
	  'market',
	  'message',
	  'mms',
	  'ms-help',
	  'msnim',
	  'mumble',
	  'mvn',
	  'notes',
	  'oid',
	  'palm',
	  'paparazzi',
	  'platform',
	  'proxy',
	  'psyc',
	  'query',
	  'res',
	  'resource',
	  'rmi',
	  'rsync',
	  'rtmp',
	  'secondlife',
	  'sftp',
	  'sgn',
	  'skype',
	  'smb',
	  'soldat',
	  'spotify',
	  'ssh',
	  'steam',
	  'svn',
	  'teamspeak',
	  'things',
	  'udp',
	  'unreal',
	  'ut2004',
	  'ventrilo',
	  'view-source',
	  'webcal',
	  'wtai',
	  'wyciwyg',
	  'xfire',
	  'xri',
	  'ymsgr'
	];


/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Utility functions
	 */
	
	function typeOf(obj) {
	  return Object.prototype.toString.call(obj);
	}
	
	function isString(obj) {
	  return typeOf(obj) === '[object String]';
	}
	
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function has(object, key) {
	  return object
	    ? hasOwn.call(object, key)
	    : false;
	}
	
	// Extend objects
	//
	function assign(obj /*from1, from2, from3, ...*/) {
	  var sources = [].slice.call(arguments, 1);
	
	  sources.forEach(function (source) {
	    if (!source) { return; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be object');
	    }
	
	    Object.keys(source).forEach(function (key) {
	      obj[key] = source[key];
	    });
	  });
	
	  return obj;
	}
	
	////////////////////////////////////////////////////////////////////////////////
	
	var UNESCAPE_MD_RE = /\\([\\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
	
	function unescapeMd(str) {
	  if (str.indexOf('\\') < 0) { return str; }
	  return str.replace(UNESCAPE_MD_RE, '$1');
	}
	
	////////////////////////////////////////////////////////////////////////////////
	
	function isValidEntityCode(c) {
	  /*eslint no-bitwise:0*/
	  // broken sequence
	  if (c >= 0xD800 && c <= 0xDFFF) { return false; }
	  // never used
	  if (c >= 0xFDD0 && c <= 0xFDEF) { return false; }
	  if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) { return false; }
	  // control codes
	  if (c >= 0x00 && c <= 0x08) { return false; }
	  if (c === 0x0B) { return false; }
	  if (c >= 0x0E && c <= 0x1F) { return false; }
	  if (c >= 0x7F && c <= 0x9F) { return false; }
	  // out of range
	  if (c > 0x10FFFF) { return false; }
	  return true;
	}
	
	function fromCodePoint(c) {
	  /*eslint no-bitwise:0*/
	  if (c > 0xffff) {
	    c -= 0x10000;
	    var surrogate1 = 0xd800 + (c >> 10),
	        surrogate2 = 0xdc00 + (c & 0x3ff);
	
	    return String.fromCharCode(surrogate1, surrogate2);
	  }
	  return String.fromCharCode(c);
	}
	
	var NAMED_ENTITY_RE   = /&([a-z#][a-z0-9]{1,31});/gi;
	var DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;
	var entities = __webpack_require__(150);
	
	function replaceEntityPattern(match, name) {
	  var code = 0;
	
	  if (has(entities, name)) {
	    return entities[name];
	  } else if (name.charCodeAt(0) === 0x23/* # */ && DIGITAL_ENTITY_TEST_RE.test(name)) {
	    code = name[1].toLowerCase() === 'x' ?
	      parseInt(name.slice(2), 16)
	    :
	      parseInt(name.slice(1), 10);
	    if (isValidEntityCode(code)) {
	      return fromCodePoint(code);
	    }
	  }
	  return match;
	}
	
	function replaceEntities(str) {
	  if (str.indexOf('&') < 0) { return str; }
	
	  return str.replace(NAMED_ENTITY_RE, replaceEntityPattern);
	}
	
	////////////////////////////////////////////////////////////////////////////////
	
	var HTML_ESCAPE_TEST_RE = /[&<>"]/;
	var HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
	var HTML_REPLACEMENTS = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;'
	};
	
	function replaceUnsafeChar(ch) {
	  return HTML_REPLACEMENTS[ch];
	}
	
	function escapeHtml(str) {
	  if (HTML_ESCAPE_TEST_RE.test(str)) {
	    return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
	  }
	  return str;
	}
	
	////////////////////////////////////////////////////////////////////////////////
	
	exports.assign            = assign;
	exports.isString          = isString;
	exports.has               = has;
	exports.unescapeMd        = unescapeMd;
	exports.isValidEntityCode = isValidEntityCode;
	exports.fromCodePoint     = fromCodePoint;
	exports.replaceEntities   = replaceEntities;
	exports.escapeHtml        = escapeHtml;


/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

	// Commonmark default options
	
	'use strict';
	
	
	module.exports = {
	  options: {
	    html:         true,         // Enable HTML tags in source
	    xhtmlOut:     true,         // Use '/' to close single tags (<br />)
	    breaks:       false,        // Convert '\n' in paragraphs into <br>
	    langPrefix:   'language-',  // CSS language prefix for fenced blocks
	    linkify:      false,        // autoconvert URL-like texts to links
	    linkTarget:   '',           // set target to open link in
	
	    // Enable some language-neutral replacements + quotes beautification
	    typographer:  false,
	
	    // Double + single quotes replacement pairs, when typographer enabled,
	    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
	    quotes: '“”‘’',
	
	    // Highlighter function. Should return escaped HTML,
	    // or '' if input not changed
	    //
	    // function (/*str, lang*/) { return ''; }
	    //
	    highlight: null,
	
	    maxNesting:   20            // Internal protection, recursion limit
	  },
	
	  components: {
	
	    core: {
	      rules: [
	        'block',
	        'inline',
	        'references',
	        'abbr2'
	      ]
	    },
	
	    block: {
	      rules: [
	        'blockquote',
	        'code',
	        'fences',
	        'heading',
	        'hr',
	        'htmlblock',
	        'lheading',
	        'list',
	        'paragraph'
	      ]
	    },
	
	    inline: {
	      rules: [
	        'autolink',
	        'backticks',
	        'emphasis',
	        'entity',
	        'escape',
	        'htmltag',
	        'links',
	        'newline',
	        'text'
	      ]
	    }
	  }
	};


/***/ }),

/***/ 1079:
/***/ (function(module, exports) {

	// Remarkable default options
	
	'use strict';
	
	
	module.exports = {
	  options: {
	    html:         false,        // Enable HTML tags in source
	    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
	    breaks:       false,        // Convert '\n' in paragraphs into <br>
	    langPrefix:   'language-',  // CSS language prefix for fenced blocks
	    linkify:      false,        // autoconvert URL-like texts to links
	    linkTarget:   '',           // set target to open link in
	
	    // Enable some language-neutral replacements + quotes beautification
	    typographer:  false,
	
	    // Double + single quotes replacement pairs, when typographer enabled,
	    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
	    quotes: '“”‘’',
	
	    // Highlighter function. Should return escaped HTML,
	    // or '' if input not changed
	    //
	    // function (/*str, lang*/) { return ''; }
	    //
	    highlight: null,
	
	    maxNesting:   20            // Internal protection, recursion limit
	  },
	
	  components: {
	
	    core: {
	      rules: [
	        'block',
	        'inline',
	        'references',
	        'replacements',
	        'linkify',
	        'smartquotes',
	        'references',
	        'abbr2',
	        'footnote_tail'
	      ]
	    },
	
	    block: {
	      rules: [
	        'blockquote',
	        'code',
	        'fences',
	        'footnote',
	        'heading',
	        'hr',
	        'htmlblock',
	        'lheading',
	        'list',
	        'paragraph',
	        'table'
	      ]
	    },
	
	    inline: {
	      rules: [
	        'autolink',
	        'backticks',
	        'del',
	        'emphasis',
	        'entity',
	        'escape',
	        'footnote_ref',
	        'htmltag',
	        'links',
	        'newline',
	        'text'
	      ]
	    }
	  }
	};


/***/ }),

/***/ 1080:
/***/ (function(module, exports) {

	// Remarkable default options
	
	'use strict';
	
	
	module.exports = {
	  options: {
	    html:         false,        // Enable HTML tags in source
	    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
	    breaks:       false,        // Convert '\n' in paragraphs into <br>
	    langPrefix:   'language-',  // CSS language prefix for fenced blocks
	    linkify:      false,        // autoconvert URL-like texts to links
	    linkTarget:   '',           // set target to open link in
	
	    // Enable some language-neutral replacements + quotes beautification
	    typographer:  false,
	
	    // Double + single quotes replacement pairs, when typographer enabled,
	    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
	    quotes:       '“”‘’',
	
	    // Highlighter function. Should return escaped HTML,
	    // or '' if input not changed
	    //
	    // function (/*str, lang*/) { return ''; }
	    //
	    highlight:     null,
	
	    maxNesting:    20            // Internal protection, recursion limit
	  },
	
	  components: {
	    // Don't restrict core/block/inline rules
	    core: {},
	    block: {},
	    inline: {}
	  }
	};


/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var replaceEntities = __webpack_require__(6).replaceEntities;
	
	module.exports = function normalizeLink(url) {
	  var normalized = replaceEntities(url);
	  // We shouldn't care about the result of malformed URIs,
	  // and should not throw an exception.
	  try {
	    normalized = decodeURI(normalized);
	  } catch (err) {}
	  return encodeURI(normalized);
	};


/***/ }),

/***/ 152:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function normalizeReference(str) {
	  // use .toUpperCase() instead of .toLowerCase()
	  // here to avoid a conflict with Object.prototype
	  // members (most notably, `__proto__`)
	  return str.trim().replace(/\s+/g, ' ').toUpperCase();
	};


/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var normalizeLink = __webpack_require__(151);
	var unescapeMd    = __webpack_require__(6).unescapeMd;
	
	/**
	 * Parse link destination
	 *
	 *   - on success it returns a string and updates state.pos;
	 *   - on failure it returns null
	 *
	 * @param  {Object} state
	 * @param  {Number} pos
	 * @api private
	 */
	
	module.exports = function parseLinkDestination(state, pos) {
	  var code, level, link,
	      start = pos,
	      max = state.posMax;
	
	  if (state.src.charCodeAt(pos) === 0x3C /* < */) {
	    pos++;
	    while (pos < max) {
	      code = state.src.charCodeAt(pos);
	      if (code === 0x0A /* \n */) { return false; }
	      if (code === 0x3E /* > */) {
	        link = normalizeLink(unescapeMd(state.src.slice(start + 1, pos)));
	        if (!state.parser.validateLink(link)) { return false; }
	        state.pos = pos + 1;
	        state.linkContent = link;
	        return true;
	      }
	      if (code === 0x5C /* \ */ && pos + 1 < max) {
	        pos += 2;
	        continue;
	      }
	
	      pos++;
	    }
	
	    // no closing '>'
	    return false;
	  }
	
	  // this should be ... } else { ... branch
	
	  level = 0;
	  while (pos < max) {
	    code = state.src.charCodeAt(pos);
	
	    if (code === 0x20) { break; }
	
	    // ascii control chars
	    if (code < 0x20 || code === 0x7F) { break; }
	
	    if (code === 0x5C /* \ */ && pos + 1 < max) {
	      pos += 2;
	      continue;
	    }
	
	    if (code === 0x28 /* ( */) {
	      level++;
	      if (level > 1) { break; }
	    }
	
	    if (code === 0x29 /* ) */) {
	      level--;
	      if (level < 0) { break; }
	    }
	
	    pos++;
	  }
	
	  if (start === pos) { return false; }
	
	  link = unescapeMd(state.src.slice(start, pos));
	  if (!state.parser.validateLink(link)) { return false; }
	
	  state.linkContent = link;
	  state.pos = pos;
	  return true;
	};


/***/ }),

/***/ 64:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Parse link labels
	 *
	 * This function assumes that first character (`[`) already matches;
	 * returns the end of the label.
	 *
	 * @param  {Object} state
	 * @param  {Number} start
	 * @api private
	 */
	
	module.exports = function parseLinkLabel(state, start) {
	  var level, found, marker,
	      labelEnd = -1,
	      max = state.posMax,
	      oldPos = state.pos,
	      oldFlag = state.isInLabel;
	
	  if (state.isInLabel) { return -1; }
	
	  if (state.labelUnmatchedScopes) {
	    state.labelUnmatchedScopes--;
	    return -1;
	  }
	
	  state.pos = start + 1;
	  state.isInLabel = true;
	  level = 1;
	
	  while (state.pos < max) {
	    marker = state.src.charCodeAt(state.pos);
	    if (marker === 0x5B /* [ */) {
	      level++;
	    } else if (marker === 0x5D /* ] */) {
	      level--;
	      if (level === 0) {
	        found = true;
	        break;
	      }
	    }
	
	    state.parser.skipToken(state);
	  }
	
	  if (found) {
	    labelEnd = state.pos;
	    state.labelUnmatchedScopes = 0;
	  } else {
	    state.labelUnmatchedScopes = level - 1;
	  }
	
	  // restore old state
	  state.pos = oldPos;
	  state.isInLabel = oldFlag;
	
	  return labelEnd;
	};


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var unescapeMd = __webpack_require__(6).unescapeMd;
	
	/**
	 * Parse link title
	 *
	 *   - on success it returns a string and updates state.pos;
	 *   - on failure it returns null
	 *
	 * @param  {Object} state
	 * @param  {Number} pos
	 * @api private
	 */
	
	module.exports = function parseLinkTitle(state, pos) {
	  var code,
	      start = pos,
	      max = state.posMax,
	      marker = state.src.charCodeAt(pos);
	
	  if (marker !== 0x22 /* " */ && marker !== 0x27 /* ' */ && marker !== 0x28 /* ( */) { return false; }
	
	  pos++;
	
	  // if opening marker is "(", switch it to closing marker ")"
	  if (marker === 0x28) { marker = 0x29; }
	
	  while (pos < max) {
	    code = state.src.charCodeAt(pos);
	    if (code === marker) {
	      state.pos = pos + 1;
	      state.linkContent = unescapeMd(state.src.slice(start + 1, pos));
	      return true;
	    }
	    if (code === 0x5C /* \ */ && pos + 1 < max) {
	      pos += 2;
	      continue;
	    }
	
	    pos++;
	  }
	
	  return false;
	};


/***/ }),

/***/ 1081:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Local dependencies
	 */
	
	var assign       = __webpack_require__(6).assign;
	var Renderer     = __webpack_require__(1085);
	var ParserCore   = __webpack_require__(1083);
	var ParserBlock  = __webpack_require__(1082);
	var ParserInline = __webpack_require__(1084);
	var Ruler        = __webpack_require__(65);
	
	/**
	 * Preset configs
	 */
	
	var config = {
	  'default':    __webpack_require__(1079),
	  'full':       __webpack_require__(1080),
	  'commonmark': __webpack_require__(1078)
	};
	
	/**
	 * The `StateCore` class manages state.
	 *
	 * @param {Object} `instance` Remarkable instance
	 * @param {String} `str` Markdown string
	 * @param {Object} `env`
	 */
	
	function StateCore(instance, str, env) {
	  this.src = str;
	  this.env = env;
	  this.options = instance.options;
	  this.tokens = [];
	  this.inlineMode = false;
	
	  this.inline = instance.inline;
	  this.block = instance.block;
	  this.renderer = instance.renderer;
	  this.typographer = instance.typographer;
	}
	
	/**
	 * The main `Remarkable` class. Create an instance of
	 * `Remarkable` with a `preset` and/or `options`.
	 *
	 * @param {String} `preset` If no preset is given, `default` is used.
	 * @param {Object} `options`
	 */
	
	function Remarkable(preset, options) {
	  if (typeof preset !== 'string') {
	    options = preset;
	    preset = 'default';
	  }
	
	  this.inline   = new ParserInline();
	  this.block    = new ParserBlock();
	  this.core     = new ParserCore();
	  this.renderer = new Renderer();
	  this.ruler    = new Ruler();
	
	  this.options  = {};
	  this.configure(config[preset]);
	  this.set(options || {});
	}
	
	/**
	 * Set options as an alternative to passing them
	 * to the constructor.
	 *
	 * ```js
	 * md.set({typographer: true});
	 * ```
	 * @param {Object} `options`
	 * @api public
	 */
	
	Remarkable.prototype.set = function (options) {
	  assign(this.options, options);
	};
	
	/**
	 * Batch loader for components rules states, and options
	 *
	 * @param  {Object} `presets`
	 */
	
	Remarkable.prototype.configure = function (presets) {
	  var self = this;
	
	  if (!presets) { throw new Error('Wrong `remarkable` preset, check name/content'); }
	  if (presets.options) { self.set(presets.options); }
	  if (presets.components) {
	    Object.keys(presets.components).forEach(function (name) {
	      if (presets.components[name].rules) {
	        self[name].ruler.enable(presets.components[name].rules, true);
	      }
	    });
	  }
	};
	
	/**
	 * Use a plugin.
	 *
	 * ```js
	 * var md = new Remarkable();
	 *
	 * md.use(plugin1)
	 *   .use(plugin2, opts)
	 *   .use(plugin3);
	 * ```
	 *
	 * @param  {Function} `plugin`
	 * @param  {Object} `options`
	 * @return {Object} `Remarkable` for chaining
	 */
	
	Remarkable.prototype.use = function (plugin, options) {
	  plugin(this, options);
	  return this;
	};
	
	
	/**
	 * Parse the input `string` and return a tokens array.
	 * Modifies `env` with definitions data.
	 *
	 * @param  {String} `string`
	 * @param  {Object} `env`
	 * @return {Array} Array of tokens
	 */
	
	Remarkable.prototype.parse = function (str, env) {
	  var state = new StateCore(this, str, env);
	  this.core.process(state);
	  return state.tokens;
	};
	
	/**
	 * The main `.render()` method that does all the magic :)
	 *
	 * @param  {String} `string`
	 * @param  {Object} `env`
	 * @return {String} Rendered HTML.
	 */
	
	Remarkable.prototype.render = function (str, env) {
	  env = env || {};
	  return this.renderer.render(this.parse(str, env), this.options, env);
	};
	
	/**
	 * Parse the given content `string` as a single string.
	 *
	 * @param  {String} `string`
	 * @param  {Object} `env`
	 * @return {Array} Array of tokens
	 */
	
	Remarkable.prototype.parseInline = function (str, env) {
	  var state = new StateCore(this, str, env);
	  state.inlineMode = true;
	  this.core.process(state);
	  return state.tokens;
	};
	
	/**
	 * Render a single content `string`, without wrapping it
	 * to paragraphs
	 *
	 * @param  {String} `str`
	 * @param  {Object} `env`
	 * @return {String}
	 */
	
	Remarkable.prototype.renderInline = function (str, env) {
	  env = env || {};
	  return this.renderer.render(this.parseInline(str, env), this.options, env);
	};
	
	/**
	 * Expose `Remarkable`
	 */
	
	module.exports = Remarkable;
	
	/**
	 * Expose `utils`, Useful helper functions for custom
	 * rendering.
	 */
	
	module.exports.utils = __webpack_require__(6);


/***/ }),

/***/ 1082:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Local dependencies
	 */
	
	var Ruler      = __webpack_require__(65);
	var StateBlock = __webpack_require__(1098);
	
	/**
	 * Parser rules
	 */
	
	var _rules = [
	  [ 'code',       __webpack_require__(1088) ],
	  [ 'fences',     __webpack_require__(1090),     [ 'paragraph', 'blockquote', 'list' ] ],
	  [ 'blockquote', __webpack_require__(1087), [ 'paragraph', 'blockquote', 'list' ] ],
	  [ 'hr',         __webpack_require__(1093),         [ 'paragraph', 'blockquote', 'list' ] ],
	  [ 'list',       __webpack_require__(1096),       [ 'paragraph', 'blockquote' ] ],
	  [ 'footnote',   __webpack_require__(1091),   [ 'paragraph' ] ],
	  [ 'heading',    __webpack_require__(1092),    [ 'paragraph', 'blockquote' ] ],
	  [ 'lheading',   __webpack_require__(1095) ],
	  [ 'htmlblock',  __webpack_require__(1094),  [ 'paragraph', 'blockquote' ] ],
	  [ 'table',      __webpack_require__(1099),      [ 'paragraph' ] ],
	  [ 'deflist',    __webpack_require__(1089),    [ 'paragraph' ] ],
	  [ 'paragraph',  __webpack_require__(1097) ]
	];
	
	/**
	 * Block Parser class
	 *
	 * @api private
	 */
	
	function ParserBlock() {
	  this.ruler = new Ruler();
	  for (var i = 0; i < _rules.length; i++) {
	    this.ruler.push(_rules[i][0], _rules[i][1], {
	      alt: (_rules[i][2] || []).slice()
	    });
	  }
	}
	
	/**
	 * Generate tokens for the given input range.
	 *
	 * @param  {Object} `state` Has properties like `src`, `parser`, `options` etc
	 * @param  {Number} `startLine`
	 * @param  {Number} `endLine`
	 * @api private
	 */
	
	ParserBlock.prototype.tokenize = function (state, startLine, endLine) {
	  var rules = this.ruler.getRules('');
	  var len = rules.length;
	  var line = startLine;
	  var hasEmptyLines = false;
	  var ok, i;
	
	  while (line < endLine) {
	    state.line = line = state.skipEmptyLines(line);
	    if (line >= endLine) {
	      break;
	    }
	
	    // Termination condition for nested calls.
	    // Nested calls currently used for blockquotes & lists
	    if (state.tShift[line] < state.blkIndent) {
	      break;
	    }
	
	    // Try all possible rules.
	    // On success, rule should:
	    //
	    // - update `state.line`
	    // - update `state.tokens`
	    // - return true
	
	    for (i = 0; i < len; i++) {
	      ok = rules[i](state, line, endLine, false);
	      if (ok) {
	        break;
	      }
	    }
	
	    // set state.tight iff we had an empty line before current tag
	    // i.e. latest empty line should not count
	    state.tight = !hasEmptyLines;
	
	    // paragraph might "eat" one newline after it in nested lists
	    if (state.isEmpty(state.line - 1)) {
	      hasEmptyLines = true;
	    }
	
	    line = state.line;
	
	    if (line < endLine && state.isEmpty(line)) {
	      hasEmptyLines = true;
	      line++;
	
	      // two empty lines should stop the parser in list mode
	      if (line < endLine && state.parentType === 'list' && state.isEmpty(line)) { break; }
	      state.line = line;
	    }
	  }
	};
	
	var TABS_SCAN_RE = /[\n\t]/g;
	var NEWLINES_RE  = /\r[\n\u0085]|[\u2424\u2028\u0085]/g;
	var SPACES_RE    = /\u00a0/g;
	
	/**
	 * Tokenize the given `str`.
	 *
	 * @param  {String} `str` Source string
	 * @param  {Object} `options`
	 * @param  {Object} `env`
	 * @param  {Array} `outTokens`
	 * @api private
	 */
	
	ParserBlock.prototype.parse = function (str, options, env, outTokens) {
	  var state, lineStart = 0, lastTabPos = 0;
	  if (!str) { return []; }
	
	  // Normalize spaces
	  str = str.replace(SPACES_RE, ' ');
	
	  // Normalize newlines
	  str = str.replace(NEWLINES_RE, '\n');
	
	  // Replace tabs with proper number of spaces (1..4)
	  if (str.indexOf('\t') >= 0) {
	    str = str.replace(TABS_SCAN_RE, function (match, offset) {
	      var result;
	      if (str.charCodeAt(offset) === 0x0A) {
	        lineStart = offset + 1;
	        lastTabPos = 0;
	        return match;
	      }
	      result = '    '.slice((offset - lineStart - lastTabPos) % 4);
	      lastTabPos = offset - lineStart + 1;
	      return result;
	    });
	  }
	
	  state = new StateBlock(str, this, options, env, outTokens);
	  this.tokenize(state, state.line, state.lineMax);
	};
	
	/**
	 * Expose `ParserBlock`
	 */
	
	module.exports = ParserBlock;


/***/ }),

/***/ 1083:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Local dependencies
	 */
	
	var Ruler = __webpack_require__(65);
	
	/**
	 * Core parser `rules`
	 */
	
	var _rules = [
	  [ 'block',          __webpack_require__(1102)          ],
	  [ 'abbr',           __webpack_require__(1100)           ],
	  [ 'references',     __webpack_require__(1106)     ],
	  [ 'inline',         __webpack_require__(1104)         ],
	  [ 'footnote_tail',  __webpack_require__(1103)  ],
	  [ 'abbr2',          __webpack_require__(1101)          ],
	  [ 'replacements',   __webpack_require__(1107)   ],
	  [ 'smartquotes',    __webpack_require__(1108)    ],
	  [ 'linkify',        __webpack_require__(1105)        ]
	];
	
	/**
	 * Class for top level (`core`) parser rules
	 *
	 * @api private
	 */
	
	function Core() {
	  this.options = {};
	  this.ruler = new Ruler();
	  for (var i = 0; i < _rules.length; i++) {
	    this.ruler.push(_rules[i][0], _rules[i][1]);
	  }
	}
	
	/**
	 * Process rules with the given `state`
	 *
	 * @param  {Object} `state`
	 * @api private
	 */
	
	Core.prototype.process = function (state) {
	  var i, l, rules;
	  rules = this.ruler.getRules('');
	  for (i = 0, l = rules.length; i < l; i++) {
	    rules[i](state);
	  }
	};
	
	/**
	 * Expose `Core`
	 */
	
	module.exports = Core;


/***/ }),

/***/ 1084:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Local dependencies
	 */
	
	var Ruler       = __webpack_require__(65);
	var StateInline = __webpack_require__(101);
	var utils       = __webpack_require__(6);
	
	/**
	 * Inline Parser `rules`
	 */
	
	var _rules = [
	  [ 'text',            __webpack_require__(1124) ],
	  [ 'newline',         __webpack_require__(1121) ],
	  [ 'escape',          __webpack_require__(1114) ],
	  [ 'backticks',       __webpack_require__(1110) ],
	  [ 'del',             __webpack_require__(1111) ],
	  [ 'ins',             __webpack_require__(1118) ],
	  [ 'mark',            __webpack_require__(1120) ],
	  [ 'emphasis',        __webpack_require__(1112) ],
	  [ 'sub',             __webpack_require__(1122) ],
	  [ 'sup',             __webpack_require__(1123) ],
	  [ 'links',           __webpack_require__(1119) ],
	  [ 'footnote_inline', __webpack_require__(1115) ],
	  [ 'footnote_ref',    __webpack_require__(1116) ],
	  [ 'autolink',        __webpack_require__(1109) ],
	  [ 'htmltag',         __webpack_require__(1117) ],
	  [ 'entity',          __webpack_require__(1113) ]
	];
	
	/**
	 * Inline Parser class. Note that link validation is stricter
	 * in Remarkable than what is specified by CommonMark. If you
	 * want to change this you can use a custom validator.
	 *
	 * @api private
	 */
	
	function ParserInline() {
	  this.ruler = new Ruler();
	  for (var i = 0; i < _rules.length; i++) {
	    this.ruler.push(_rules[i][0], _rules[i][1]);
	  }
	
	  // Can be overridden with a custom validator
	  this.validateLink = validateLink;
	}
	
	/**
	 * Skip a single token by running all rules in validation mode.
	 * Returns `true` if any rule reports success.
	 *
	 * @param  {Object} `state`
	 * @api privage
	 */
	
	ParserInline.prototype.skipToken = function (state) {
	  var rules = this.ruler.getRules('');
	  var len = rules.length;
	  var pos = state.pos;
	  var i, cached_pos;
	
	  if ((cached_pos = state.cacheGet(pos)) > 0) {
	    state.pos = cached_pos;
	    return;
	  }
	
	  for (i = 0; i < len; i++) {
	    if (rules[i](state, true)) {
	      state.cacheSet(pos, state.pos);
	      return;
	    }
	  }
	
	  state.pos++;
	  state.cacheSet(pos, state.pos);
	};
	
	/**
	 * Generate tokens for the given input range.
	 *
	 * @param  {Object} `state`
	 * @api private
	 */
	
	ParserInline.prototype.tokenize = function (state) {
	  var rules = this.ruler.getRules('');
	  var len = rules.length;
	  var end = state.posMax;
	  var ok, i;
	
	  while (state.pos < end) {
	
	    // Try all possible rules.
	    // On success, the rule should:
	    //
	    // - update `state.pos`
	    // - update `state.tokens`
	    // - return true
	    for (i = 0; i < len; i++) {
	      ok = rules[i](state, false);
	
	      if (ok) {
	        break;
	      }
	    }
	
	    if (ok) {
	      if (state.pos >= end) { break; }
	      continue;
	    }
	
	    state.pending += state.src[state.pos++];
	  }
	
	  if (state.pending) {
	    state.pushPending();
	  }
	};
	
	/**
	 * Parse the given input string.
	 *
	 * @param  {String} `str`
	 * @param  {Object} `options`
	 * @param  {Object} `env`
	 * @param  {Array} `outTokens`
	 * @api private
	 */
	
	ParserInline.prototype.parse = function (str, options, env, outTokens) {
	  var state = new StateInline(str, this, options, env, outTokens);
	  this.tokenize(state);
	};
	
	/**
	 * Validate the given `url` by checking for bad protocols.
	 *
	 * @param  {String} `url`
	 * @return {Boolean}
	 */
	
	function validateLink(url) {
	  var BAD_PROTOCOLS = [ 'vbscript', 'javascript', 'file', 'data' ];
	  var str = url.trim().toLowerCase();
	  // Care about digital entities "javascript&#x3A;alert(1)"
	  str = utils.replaceEntities(str);
	  if (str.indexOf(':') !== -1 && BAD_PROTOCOLS.indexOf(str.split(':')[0]) !== -1) {
	    return false;
	  }
	  return true;
	}
	
	/**
	 * Expose `ParserInline`
	 */
	
	module.exports = ParserInline;


/***/ }),

/***/ 1085:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Local dependencies
	 */
	
	var utils = __webpack_require__(6);
	var rules = __webpack_require__(1086);
	
	/**
	 * Expose `Renderer`
	 */
	
	module.exports = Renderer;
	
	/**
	 * Renderer class. Renders HTML and exposes `rules` to allow
	 * local modifications.
	 */
	
	function Renderer() {
	  this.rules = utils.assign({}, rules);
	
	  // exported helper, for custom rules only
	  this.getBreak = rules.getBreak;
	}
	
	/**
	 * Render a string of inline HTML with the given `tokens` and
	 * `options`.
	 *
	 * @param  {Array} `tokens`
	 * @param  {Object} `options`
	 * @param  {Object} `env`
	 * @return {String}
	 * @api public
	 */
	
	Renderer.prototype.renderInline = function (tokens, options, env) {
	  var _rules = this.rules;
	  var len = tokens.length, i = 0;
	  var result = '';
	
	  while (len--) {
	    result += _rules[tokens[i].type](tokens, i++, options, env, this);
	  }
	
	  return result;
	};
	
	/**
	 * Render a string of HTML with the given `tokens` and
	 * `options`.
	 *
	 * @param  {Array} `tokens`
	 * @param  {Object} `options`
	 * @param  {Object} `env`
	 * @return {String}
	 * @api public
	 */
	
	Renderer.prototype.render = function (tokens, options, env) {
	  var _rules = this.rules;
	  var len = tokens.length, i = -1;
	  var result = '';
	
	  while (++i < len) {
	    if (tokens[i].type === 'inline') {
	      result += this.renderInline(tokens[i].children, options, env);
	    } else {
	      result += _rules[tokens[i].type](tokens, i, options, env, this);
	    }
	  }
	  return result;
	};


/***/ }),

/***/ 65:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Ruler is a helper class for building responsibility chains from
	 * parse rules. It allows:
	 *
	 *   - easy stack rules chains
	 *   - getting main chain and named chains content (as arrays of functions)
	 *
	 * Helper methods, should not be used directly.
	 * @api private
	 */
	
	function Ruler() {
	  // List of added rules. Each element is:
	  //
	  // { name: XXX,
	  //   enabled: Boolean,
	  //   fn: Function(),
	  //   alt: [ name2, name3 ] }
	  //
	  this.__rules__ = [];
	
	  // Cached rule chains.
	  //
	  // First level - chain name, '' for default.
	  // Second level - digital anchor for fast filtering by charcodes.
	  //
	  this.__cache__ = null;
	}
	
	/**
	 * Find the index of a rule by `name`.
	 *
	 * @param  {String} `name`
	 * @return {Number} Index of the given `name`
	 * @api private
	 */
	
	Ruler.prototype.__find__ = function (name) {
	  var len = this.__rules__.length;
	  var i = -1;
	
	  while (len--) {
	    if (this.__rules__[++i].name === name) {
	      return i;
	    }
	  }
	  return -1;
	};
	
	/**
	 * Build the rules lookup cache
	 *
	 * @api private
	 */
	
	Ruler.prototype.__compile__ = function () {
	  var self = this;
	  var chains = [ '' ];
	
	  // collect unique names
	  self.__rules__.forEach(function (rule) {
	    if (!rule.enabled) {
	      return;
	    }
	
	    rule.alt.forEach(function (altName) {
	      if (chains.indexOf(altName) < 0) {
	        chains.push(altName);
	      }
	    });
	  });
	
	  self.__cache__ = {};
	
	  chains.forEach(function (chain) {
	    self.__cache__[chain] = [];
	    self.__rules__.forEach(function (rule) {
	      if (!rule.enabled) {
	        return;
	      }
	
	      if (chain && rule.alt.indexOf(chain) < 0) {
	        return;
	      }
	      self.__cache__[chain].push(rule.fn);
	    });
	  });
	};
	
	/**
	 * Ruler public methods
	 * ------------------------------------------------
	 */
	
	/**
	 * Replace rule function
	 *
	 * @param  {String} `name` Rule name
	 * @param  {Function `fn`
	 * @param  {Object} `options`
	 * @api private
	 */
	
	Ruler.prototype.at = function (name, fn, options) {
	  var idx = this.__find__(name);
	  var opt = options || {};
	
	  if (idx === -1) {
	    throw new Error('Parser rule not found: ' + name);
	  }
	
	  this.__rules__[idx].fn = fn;
	  this.__rules__[idx].alt = opt.alt || [];
	  this.__cache__ = null;
	};
	
	/**
	 * Add a rule to the chain before given the `ruleName`.
	 *
	 * @param  {String}   `beforeName`
	 * @param  {String}   `ruleName`
	 * @param  {Function} `fn`
	 * @param  {Object}   `options`
	 * @api private
	 */
	
	Ruler.prototype.before = function (beforeName, ruleName, fn, options) {
	  var idx = this.__find__(beforeName);
	  var opt = options || {};
	
	  if (idx === -1) {
	    throw new Error('Parser rule not found: ' + beforeName);
	  }
	
	  this.__rules__.splice(idx, 0, {
	    name: ruleName,
	    enabled: true,
	    fn: fn,
	    alt: opt.alt || []
	  });
	
	  this.__cache__ = null;
	};
	
	/**
	 * Add a rule to the chain after the given `ruleName`.
	 *
	 * @param  {String}   `afterName`
	 * @param  {String}   `ruleName`
	 * @param  {Function} `fn`
	 * @param  {Object}   `options`
	 * @api private
	 */
	
	Ruler.prototype.after = function (afterName, ruleName, fn, options) {
	  var idx = this.__find__(afterName);
	  var opt = options || {};
	
	  if (idx === -1) {
	    throw new Error('Parser rule not found: ' + afterName);
	  }
	
	  this.__rules__.splice(idx + 1, 0, {
	    name: ruleName,
	    enabled: true,
	    fn: fn,
	    alt: opt.alt || []
	  });
	
	  this.__cache__ = null;
	};
	
	/**
	 * Add a rule to the end of chain.
	 *
	 * @param  {String}   `ruleName`
	 * @param  {Function} `fn`
	 * @param  {Object}   `options`
	 * @return {String}
	 */
	
	Ruler.prototype.push = function (ruleName, fn, options) {
	  var opt = options || {};
	
	  this.__rules__.push({
	    name: ruleName,
	    enabled: true,
	    fn: fn,
	    alt: opt.alt || []
	  });
	
	  this.__cache__ = null;
	};
	
	/**
	 * Enable a rule or list of rules.
	 *
	 * @param  {String|Array} `list` Name or array of rule names to enable
	 * @param  {Boolean} `strict` If `true`, all non listed rules will be disabled.
	 * @api private
	 */
	
	Ruler.prototype.enable = function (list, strict) {
	  list = !Array.isArray(list)
	    ? [ list ]
	    : list;
	
	  // In strict mode disable all existing rules first
	  if (strict) {
	    this.__rules__.forEach(function (rule) {
	      rule.enabled = false;
	    });
	  }
	
	  // Search by name and enable
	  list.forEach(function (name) {
	    var idx = this.__find__(name);
	    if (idx < 0) {
	      throw new Error('Rules manager: invalid rule name ' + name);
	    }
	    this.__rules__[idx].enabled = true;
	  }, this);
	
	  this.__cache__ = null;
	};
	
	
	/**
	 * Disable a rule or list of rules.
	 *
	 * @param  {String|Array} `list` Name or array of rule names to disable
	 * @api private
	 */
	
	Ruler.prototype.disable = function (list) {
	  list = !Array.isArray(list)
	    ? [ list ]
	    : list;
	
	  // Search by name and disable
	  list.forEach(function (name) {
	    var idx = this.__find__(name);
	    if (idx < 0) {
	      throw new Error('Rules manager: invalid rule name ' + name);
	    }
	    this.__rules__[idx].enabled = false;
	  }, this);
	
	  this.__cache__ = null;
	};
	
	/**
	 * Get a rules list as an array of functions.
	 *
	 * @param  {String} `chainName`
	 * @return {Object}
	 * @api private
	 */
	
	Ruler.prototype.getRules = function (chainName) {
	  if (this.__cache__ === null) {
	    this.__compile__();
	  }
	  return this.__cache__[chainName] || [];
	};
	
	/**
	 * Expose `Ruler`
	 */
	
	module.exports = Ruler;


/***/ }),

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Local dependencies
	 */
	
	var has             = __webpack_require__(6).has;
	var unescapeMd      = __webpack_require__(6).unescapeMd;
	var replaceEntities = __webpack_require__(6).replaceEntities;
	var escapeHtml      = __webpack_require__(6).escapeHtml;
	
	/**
	 * Renderer rules cache
	 */
	
	var rules = {};
	
	/**
	 * Blockquotes
	 */
	
	rules.blockquote_open = function(/* tokens, idx, options, env */) {
	  return '<blockquote>\n';
	};
	
	rules.blockquote_close = function(tokens, idx /*, options, env */) {
	  return '</blockquote>' + getBreak(tokens, idx);
	};
	
	/**
	 * Code
	 */
	
	rules.code = function(tokens, idx /*, options, env */) {
	  if (tokens[idx].block) {
	    return '<pre><code>' + escapeHtml(tokens[idx].content) + '</code></pre>' + getBreak(tokens, idx);
	  }
	  return '<code>' + escapeHtml(tokens[idx].content) + '</code>';
	};
	
	/**
	 * Fenced code blocks
	 */
	
	rules.fence = function(tokens, idx, options, env, instance) {
	  var token = tokens[idx];
	  var langClass = '';
	  var langPrefix = options.langPrefix;
	  var langName = '', fences, fenceName;
	  var highlighted;
	
	  if (token.params) {
	
	    //
	    // ```foo bar
	    //
	    // Try custom renderer "foo" first. That will simplify overwrite
	    // for diagrams, latex, and any other fenced block with custom look
	    //
	
	    fences = token.params.split(/\s+/g);
	    fenceName = fences.join(' ');
	
	    if (has(instance.rules.fence_custom, fences[0])) {
	      return instance.rules.fence_custom[fences[0]](tokens, idx, options, env, instance);
	    }
	
	    langName = escapeHtml(replaceEntities(unescapeMd(fenceName)));
	    langClass = ' class="' + langPrefix + langName + '"';
	  }
	
	  if (options.highlight) {
	    highlighted = options.highlight.apply(options.highlight, [ token.content ].concat(fences))
	      || escapeHtml(token.content);
	  } else {
	    highlighted = escapeHtml(token.content);
	  }
	
	  return '<pre><code' + langClass + '>'
	        + highlighted
	        + '</code></pre>'
	        + getBreak(tokens, idx);
	};
	
	rules.fence_custom = {};
	
	/**
	 * Headings
	 */
	
	rules.heading_open = function(tokens, idx /*, options, env */) {
	  return '<h' + tokens[idx].hLevel + '>';
	};
	rules.heading_close = function(tokens, idx /*, options, env */) {
	  return '</h' + tokens[idx].hLevel + '>\n';
	};
	
	/**
	 * Horizontal rules
	 */
	
	rules.hr = function(tokens, idx, options /*, env */) {
	  return (options.xhtmlOut ? '<hr />' : '<hr>') + getBreak(tokens, idx);
	};
	
	/**
	 * Bullets
	 */
	
	rules.bullet_list_open = function(/* tokens, idx, options, env */) {
	  return '<ul>\n';
	};
	rules.bullet_list_close = function(tokens, idx /*, options, env */) {
	  return '</ul>' + getBreak(tokens, idx);
	};
	
	/**
	 * List items
	 */
	
	rules.list_item_open = function(/* tokens, idx, options, env */) {
	  return '<li>';
	};
	rules.list_item_close = function(/* tokens, idx, options, env */) {
	  return '</li>\n';
	};
	
	/**
	 * Ordered list items
	 */
	
	rules.ordered_list_open = function(tokens, idx /*, options, env */) {
	  var token = tokens[idx];
	  var order = token.order > 1 ? ' start="' + token.order + '"' : '';
	  return '<ol' + order + '>\n';
	};
	rules.ordered_list_close = function(tokens, idx /*, options, env */) {
	  return '</ol>' + getBreak(tokens, idx);
	};
	
	/**
	 * Paragraphs
	 */
	
	rules.paragraph_open = function(tokens, idx /*, options, env */) {
	  return tokens[idx].tight ? '' : '<p>';
	};
	rules.paragraph_close = function(tokens, idx /*, options, env */) {
	  var addBreak = !(tokens[idx].tight && idx && tokens[idx - 1].type === 'inline' && !tokens[idx - 1].content);
	  return (tokens[idx].tight ? '' : '</p>') + (addBreak ? getBreak(tokens, idx) : '');
	};
	
	/**
	 * Links
	 */
	
	rules.link_open = function(tokens, idx, options /* env */) {
	  var title = tokens[idx].title ? (' title="' + escapeHtml(replaceEntities(tokens[idx].title)) + '"') : '';
	  var target = options.linkTarget ? (' target="' + options.linkTarget + '"') : '';
	  return '<a href="' + escapeHtml(tokens[idx].href) + '"' + title + target + '>';
	};
	rules.link_close = function(/* tokens, idx, options, env */) {
	  return '</a>';
	};
	
	/**
	 * Images
	 */
	
	rules.image = function(tokens, idx, options /*, env */) {
	  var src = ' src="' + escapeHtml(tokens[idx].src) + '"';
	  var title = tokens[idx].title ? (' title="' + escapeHtml(replaceEntities(tokens[idx].title)) + '"') : '';
	  var alt = ' alt="' + (tokens[idx].alt ? escapeHtml(replaceEntities(unescapeMd(tokens[idx].alt))) : '') + '"';
	  var suffix = options.xhtmlOut ? ' /' : '';
	  return '<img' + src + alt + title + suffix + '>';
	};
	
	/**
	 * Tables
	 */
	
	rules.table_open = function(/* tokens, idx, options, env */) {
	  return '<table>\n';
	};
	rules.table_close = function(/* tokens, idx, options, env */) {
	  return '</table>\n';
	};
	rules.thead_open = function(/* tokens, idx, options, env */) {
	  return '<thead>\n';
	};
	rules.thead_close = function(/* tokens, idx, options, env */) {
	  return '</thead>\n';
	};
	rules.tbody_open = function(/* tokens, idx, options, env */) {
	  return '<tbody>\n';
	};
	rules.tbody_close = function(/* tokens, idx, options, env */) {
	  return '</tbody>\n';
	};
	rules.tr_open = function(/* tokens, idx, options, env */) {
	  return '<tr>';
	};
	rules.tr_close = function(/* tokens, idx, options, env */) {
	  return '</tr>\n';
	};
	rules.th_open = function(tokens, idx /*, options, env */) {
	  var token = tokens[idx];
	  return '<th'
	    + (token.align ? ' style="text-align:' + token.align + '"' : '')
	    + '>';
	};
	rules.th_close = function(/* tokens, idx, options, env */) {
	  return '</th>';
	};
	rules.td_open = function(tokens, idx /*, options, env */) {
	  var token = tokens[idx];
	  return '<td'
	    + (token.align ? ' style="text-align:' + token.align + '"' : '')
	    + '>';
	};
	rules.td_close = function(/* tokens, idx, options, env */) {
	  return '</td>';
	};
	
	/**
	 * Bold
	 */
	
	rules.strong_open = function(/* tokens, idx, options, env */) {
	  return '<strong>';
	};
	rules.strong_close = function(/* tokens, idx, options, env */) {
	  return '</strong>';
	};
	
	/**
	 * Italicize
	 */
	
	rules.em_open = function(/* tokens, idx, options, env */) {
	  return '<em>';
	};
	rules.em_close = function(/* tokens, idx, options, env */) {
	  return '</em>';
	};
	
	/**
	 * Strikethrough
	 */
	
	rules.del_open = function(/* tokens, idx, options, env */) {
	  return '<del>';
	};
	rules.del_close = function(/* tokens, idx, options, env */) {
	  return '</del>';
	};
	
	/**
	 * Insert
	 */
	
	rules.ins_open = function(/* tokens, idx, options, env */) {
	  return '<ins>';
	};
	rules.ins_close = function(/* tokens, idx, options, env */) {
	  return '</ins>';
	};
	
	/**
	 * Highlight
	 */
	
	rules.mark_open = function(/* tokens, idx, options, env */) {
	  return '<mark>';
	};
	rules.mark_close = function(/* tokens, idx, options, env */) {
	  return '</mark>';
	};
	
	/**
	 * Super- and sub-script
	 */
	
	rules.sub = function(tokens, idx /*, options, env */) {
	  return '<sub>' + escapeHtml(tokens[idx].content) + '</sub>';
	};
	rules.sup = function(tokens, idx /*, options, env */) {
	  return '<sup>' + escapeHtml(tokens[idx].content) + '</sup>';
	};
	
	/**
	 * Breaks
	 */
	
	rules.hardbreak = function(tokens, idx, options /*, env */) {
	  return options.xhtmlOut ? '<br />\n' : '<br>\n';
	};
	rules.softbreak = function(tokens, idx, options /*, env */) {
	  return options.breaks ? (options.xhtmlOut ? '<br />\n' : '<br>\n') : '\n';
	};
	
	/**
	 * Text
	 */
	
	rules.text = function(tokens, idx /*, options, env */) {
	  return escapeHtml(tokens[idx].content);
	};
	
	/**
	 * Content
	 */
	
	rules.htmlblock = function(tokens, idx /*, options, env */) {
	  return tokens[idx].content;
	};
	rules.htmltag = function(tokens, idx /*, options, env */) {
	  return tokens[idx].content;
	};
	
	/**
	 * Abbreviations, initialism
	 */
	
	rules.abbr_open = function(tokens, idx /*, options, env */) {
	  return '<abbr title="' + escapeHtml(replaceEntities(tokens[idx].title)) + '">';
	};
	rules.abbr_close = function(/* tokens, idx, options, env */) {
	  return '</abbr>';
	};
	
	/**
	 * Footnotes
	 */
	
	rules.footnote_ref = function(tokens, idx) {
	  var n = Number(tokens[idx].id + 1).toString();
	  var id = 'fnref' + n;
	  if (tokens[idx].subId > 0) {
	    id += ':' + tokens[idx].subId;
	  }
	  return '<sup class="footnote-ref"><a href="#fn' + n + '" id="' + id + '">[' + n + ']</a></sup>';
	};
	rules.footnote_block_open = function(tokens, idx, options) {
	  var hr = options.xhtmlOut
	    ? '<hr class="footnotes-sep" />\n'
	    : '<hr class="footnotes-sep">\n';
	  return hr + '<section class="footnotes">\n<ol class="footnotes-list">\n';
	};
	rules.footnote_block_close = function() {
	  return '</ol>\n</section>\n';
	};
	rules.footnote_open = function(tokens, idx) {
	  var id = Number(tokens[idx].id + 1).toString();
	  return '<li id="fn' + id + '"  class="footnote-item">';
	};
	rules.footnote_close = function() {
	  return '</li>\n';
	};
	rules.footnote_anchor = function(tokens, idx) {
	  var n = Number(tokens[idx].id + 1).toString();
	  var id = 'fnref' + n;
	  if (tokens[idx].subId > 0) {
	    id += ':' + tokens[idx].subId;
	  }
	  return ' <a href="#' + id + '" class="footnote-backref">↩</a>';
	};
	
	/**
	 * Definition lists
	 */
	
	rules.dl_open = function() {
	  return '<dl>\n';
	};
	rules.dt_open = function() {
	  return '<dt>';
	};
	rules.dd_open = function() {
	  return '<dd>';
	};
	rules.dl_close = function() {
	  return '</dl>\n';
	};
	rules.dt_close = function() {
	  return '</dt>\n';
	};
	rules.dd_close = function() {
	  return '</dd>\n';
	};
	
	/**
	 * Helper functions
	 */
	
	function nextToken(tokens, idx) {
	  if (++idx >= tokens.length - 2) {
	    return idx;
	  }
	  if ((tokens[idx].type === 'paragraph_open' && tokens[idx].tight) &&
	      (tokens[idx + 1].type === 'inline' && tokens[idx + 1].content.length === 0) &&
	      (tokens[idx + 2].type === 'paragraph_close' && tokens[idx + 2].tight)) {
	    return nextToken(tokens, idx + 2);
	  }
	  return idx;
	}
	
	/**
	 * Check to see if `\n` is needed before the next token.
	 *
	 * @param  {Array} `tokens`
	 * @param  {Number} `idx`
	 * @return {String} Empty string or newline
	 * @api private
	 */
	
	var getBreak = rules.getBreak = function getBreak(tokens, idx) {
	  idx = nextToken(tokens, idx);
	  if (idx < tokens.length && tokens[idx].type === 'list_item_close') {
	    return '';
	  }
	  return '\n';
	};
	
	/**
	 * Expose `rules`
	 */
	
	module.exports = rules;


/***/ }),

/***/ 1087:
/***/ (function(module, exports) {

	// Block quotes
	
	'use strict';
	
	
	module.exports = function blockquote(state, startLine, endLine, silent) {
	  var nextLine, lastLineEmpty, oldTShift, oldBMarks, oldIndent, oldParentType, lines,
	      terminatorRules,
	      i, l, terminate,
	      pos = state.bMarks[startLine] + state.tShift[startLine],
	      max = state.eMarks[startLine];
	
	  if (pos > max) { return false; }
	
	  // check the block quote marker
	  if (state.src.charCodeAt(pos++) !== 0x3E/* > */) { return false; }
	
	  if (state.level >= state.options.maxNesting) { return false; }
	
	  // we know that it's going to be a valid blockquote,
	  // so no point trying to find the end of it in silent mode
	  if (silent) { return true; }
	
	  // skip one optional space after '>'
	  if (state.src.charCodeAt(pos) === 0x20) { pos++; }
	
	  oldIndent = state.blkIndent;
	  state.blkIndent = 0;
	
	  oldBMarks = [ state.bMarks[startLine] ];
	  state.bMarks[startLine] = pos;
	
	  // check if we have an empty blockquote
	  pos = pos < max ? state.skipSpaces(pos) : pos;
	  lastLineEmpty = pos >= max;
	
	  oldTShift = [ state.tShift[startLine] ];
	  state.tShift[startLine] = pos - state.bMarks[startLine];
	
	  terminatorRules = state.parser.ruler.getRules('blockquote');
	
	  // Search the end of the block
	  //
	  // Block ends with either:
	  //  1. an empty line outside:
	  //     ```
	  //     > test
	  //
	  //     ```
	  //  2. an empty line inside:
	  //     ```
	  //     >
	  //     test
	  //     ```
	  //  3. another tag
	  //     ```
	  //     > test
	  //      - - -
	  //     ```
	  for (nextLine = startLine + 1; nextLine < endLine; nextLine++) {
	    pos = state.bMarks[nextLine] + state.tShift[nextLine];
	    max = state.eMarks[nextLine];
	
	    if (pos >= max) {
	      // Case 1: line is not inside the blockquote, and this line is empty.
	      break;
	    }
	
	    if (state.src.charCodeAt(pos++) === 0x3E/* > */) {
	      // This line is inside the blockquote.
	
	      // skip one optional space after '>'
	      if (state.src.charCodeAt(pos) === 0x20) { pos++; }
	
	      oldBMarks.push(state.bMarks[nextLine]);
	      state.bMarks[nextLine] = pos;
	
	      pos = pos < max ? state.skipSpaces(pos) : pos;
	      lastLineEmpty = pos >= max;
	
	      oldTShift.push(state.tShift[nextLine]);
	      state.tShift[nextLine] = pos - state.bMarks[nextLine];
	      continue;
	    }
	
	    // Case 2: line is not inside the blockquote, and the last line was empty.
	    if (lastLineEmpty) { break; }
	
	    // Case 3: another tag found.
	    terminate = false;
	    for (i = 0, l = terminatorRules.length; i < l; i++) {
	      if (terminatorRules[i](state, nextLine, endLine, true)) {
	        terminate = true;
	        break;
	      }
	    }
	    if (terminate) { break; }
	
	    oldBMarks.push(state.bMarks[nextLine]);
	    oldTShift.push(state.tShift[nextLine]);
	
	    // A negative number means that this is a paragraph continuation;
	    //
	    // Any negative number will do the job here, but it's better for it
	    // to be large enough to make any bugs obvious.
	    state.tShift[nextLine] = -1337;
	  }
	
	  oldParentType = state.parentType;
	  state.parentType = 'blockquote';
	  state.tokens.push({
	    type: 'blockquote_open',
	    lines: lines = [ startLine, 0 ],
	    level: state.level++
	  });
	  state.parser.tokenize(state, startLine, nextLine);
	  state.tokens.push({
	    type: 'blockquote_close',
	    level: --state.level
	  });
	  state.parentType = oldParentType;
	  lines[1] = state.line;
	
	  // Restore original tShift; this might not be necessary since the parser
	  // has already been here, but just to make sure we can do that.
	  for (i = 0; i < oldTShift.length; i++) {
	    state.bMarks[i + startLine] = oldBMarks[i];
	    state.tShift[i + startLine] = oldTShift[i];
	  }
	  state.blkIndent = oldIndent;
	
	  return true;
	};


/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	// Code block (4 spaces padded)
	
	'use strict';
	
	
	module.exports = function code(state, startLine, endLine/*, silent*/) {
	  var nextLine, last;
	
	  if (state.tShift[startLine] - state.blkIndent < 4) { return false; }
	
	  last = nextLine = startLine + 1;
	
	  while (nextLine < endLine) {
	    if (state.isEmpty(nextLine)) {
	      nextLine++;
	      continue;
	    }
	    if (state.tShift[nextLine] - state.blkIndent >= 4) {
	      nextLine++;
	      last = nextLine;
	      continue;
	    }
	    break;
	  }
	
	  state.line = nextLine;
	  state.tokens.push({
	    type: 'code',
	    content: state.getLines(startLine, last, 4 + state.blkIndent, true),
	    block: true,
	    lines: [ startLine, state.line ],
	    level: state.level
	  });
	
	  return true;
	};


/***/ }),

/***/ 1089:
/***/ (function(module, exports) {

	// Definition lists
	
	'use strict';
	
	
	// Search `[:~][\n ]`, returns next pos after marker on success
	// or -1 on fail.
	function skipMarker(state, line) {
	  var pos, marker,
	      start = state.bMarks[line] + state.tShift[line],
	      max = state.eMarks[line];
	
	  if (start >= max) { return -1; }
	
	  // Check bullet
	  marker = state.src.charCodeAt(start++);
	  if (marker !== 0x7E/* ~ */ && marker !== 0x3A/* : */) { return -1; }
	
	  pos = state.skipSpaces(start);
	
	  // require space after ":"
	  if (start === pos) { return -1; }
	
	  // no empty definitions, e.g. "  : "
	  if (pos >= max) { return -1; }
	
	  return pos;
	}
	
	function markTightParagraphs(state, idx) {
	  var i, l,
	      level = state.level + 2;
	
	  for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
	    if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
	      state.tokens[i + 2].tight = true;
	      state.tokens[i].tight = true;
	      i += 2;
	    }
	  }
	}
	
	module.exports = function deflist(state, startLine, endLine, silent) {
	  var contentStart,
	      ddLine,
	      dtLine,
	      itemLines,
	      listLines,
	      listTokIdx,
	      nextLine,
	      oldIndent,
	      oldDDIndent,
	      oldParentType,
	      oldTShift,
	      oldTight,
	      prevEmptyEnd,
	      tight;
	
	  if (silent) {
	    // quirk: validation mode validates a dd block only, not a whole deflist
	    if (state.ddIndent < 0) { return false; }
	    return skipMarker(state, startLine) >= 0;
	  }
	
	  nextLine = startLine + 1;
	  if (state.isEmpty(nextLine)) {
	    if (++nextLine > endLine) { return false; }
	  }
	
	  if (state.tShift[nextLine] < state.blkIndent) { return false; }
	  contentStart = skipMarker(state, nextLine);
	  if (contentStart < 0) { return false; }
	
	  if (state.level >= state.options.maxNesting) { return false; }
	
	  // Start list
	  listTokIdx = state.tokens.length;
	
	  state.tokens.push({
	    type: 'dl_open',
	    lines: listLines = [ startLine, 0 ],
	    level: state.level++
	  });
	
	  //
	  // Iterate list items
	  //
	
	  dtLine = startLine;
	  ddLine = nextLine;
	
	  // One definition list can contain multiple DTs,
	  // and one DT can be followed by multiple DDs.
	  //
	  // Thus, there is two loops here, and label is
	  // needed to break out of the second one
	  //
	  /*eslint no-labels:0,block-scoped-var:0*/
	  OUTER:
	  for (;;) {
	    tight = true;
	    prevEmptyEnd = false;
	
	    state.tokens.push({
	      type: 'dt_open',
	      lines: [ dtLine, dtLine ],
	      level: state.level++
	    });
	    state.tokens.push({
	      type: 'inline',
	      content: state.getLines(dtLine, dtLine + 1, state.blkIndent, false).trim(),
	      level: state.level + 1,
	      lines: [ dtLine, dtLine ],
	      children: []
	    });
	    state.tokens.push({
	      type: 'dt_close',
	      level: --state.level
	    });
	
	    for (;;) {
	      state.tokens.push({
	        type: 'dd_open',
	        lines: itemLines = [ nextLine, 0 ],
	        level: state.level++
	      });
	
	      oldTight = state.tight;
	      oldDDIndent = state.ddIndent;
	      oldIndent = state.blkIndent;
	      oldTShift = state.tShift[ddLine];
	      oldParentType = state.parentType;
	      state.blkIndent = state.ddIndent = state.tShift[ddLine] + 2;
	      state.tShift[ddLine] = contentStart - state.bMarks[ddLine];
	      state.tight = true;
	      state.parentType = 'deflist';
	
	      state.parser.tokenize(state, ddLine, endLine, true);
	
	      // If any of list item is tight, mark list as tight
	      if (!state.tight || prevEmptyEnd) {
	        tight = false;
	      }
	      // Item become loose if finish with empty line,
	      // but we should filter last element, because it means list finish
	      prevEmptyEnd = (state.line - ddLine) > 1 && state.isEmpty(state.line - 1);
	
	      state.tShift[ddLine] = oldTShift;
	      state.tight = oldTight;
	      state.parentType = oldParentType;
	      state.blkIndent = oldIndent;
	      state.ddIndent = oldDDIndent;
	
	      state.tokens.push({
	        type: 'dd_close',
	        level: --state.level
	      });
	
	      itemLines[1] = nextLine = state.line;
	
	      if (nextLine >= endLine) { break OUTER; }
	
	      if (state.tShift[nextLine] < state.blkIndent) { break OUTER; }
	      contentStart = skipMarker(state, nextLine);
	      if (contentStart < 0) { break; }
	
	      ddLine = nextLine;
	
	      // go to the next loop iteration:
	      // insert DD tag and repeat checking
	    }
	
	    if (nextLine >= endLine) { break; }
	    dtLine = nextLine;
	
	    if (state.isEmpty(dtLine)) { break; }
	    if (state.tShift[dtLine] < state.blkIndent) { break; }
	
	    ddLine = dtLine + 1;
	    if (ddLine >= endLine) { break; }
	    if (state.isEmpty(ddLine)) { ddLine++; }
	    if (ddLine >= endLine) { break; }
	
	    if (state.tShift[ddLine] < state.blkIndent) { break; }
	    contentStart = skipMarker(state, ddLine);
	    if (contentStart < 0) { break; }
	
	    // go to the next loop iteration:
	    // insert DT and DD tags and repeat checking
	  }
	
	  // Finilize list
	  state.tokens.push({
	    type: 'dl_close',
	    level: --state.level
	  });
	  listLines[1] = nextLine;
	
	  state.line = nextLine;
	
	  // mark paragraphs tight if needed
	  if (tight) {
	    markTightParagraphs(state, listTokIdx);
	  }
	
	  return true;
	};


/***/ }),

/***/ 1090:
/***/ (function(module, exports) {

	// fences (``` lang, ~~~ lang)
	
	'use strict';
	
	
	module.exports = function fences(state, startLine, endLine, silent) {
	  var marker, len, params, nextLine, mem,
	      haveEndMarker = false,
	      pos = state.bMarks[startLine] + state.tShift[startLine],
	      max = state.eMarks[startLine];
	
	  if (pos + 3 > max) { return false; }
	
	  marker = state.src.charCodeAt(pos);
	
	  if (marker !== 0x7E/* ~ */ && marker !== 0x60 /* ` */) {
	    return false;
	  }
	
	  // scan marker length
	  mem = pos;
	  pos = state.skipChars(pos, marker);
	
	  len = pos - mem;
	
	  if (len < 3) { return false; }
	
	  params = state.src.slice(pos, max).trim();
	
	  if (params.indexOf('`') >= 0) { return false; }
	
	  // Since start is found, we can report success here in validation mode
	  if (silent) { return true; }
	
	  // search end of block
	  nextLine = startLine;
	
	  for (;;) {
	    nextLine++;
	    if (nextLine >= endLine) {
	      // unclosed block should be autoclosed by end of document.
	      // also block seems to be autoclosed by end of parent
	      break;
	    }
	
	    pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
	    max = state.eMarks[nextLine];
	
	    if (pos < max && state.tShift[nextLine] < state.blkIndent) {
	      // non-empty line with negative indent should stop the list:
	      // - ```
	      //  test
	      break;
	    }
	
	    if (state.src.charCodeAt(pos) !== marker) { continue; }
	
	    if (state.tShift[nextLine] - state.blkIndent >= 4) {
	      // closing fence should be indented less than 4 spaces
	      continue;
	    }
	
	    pos = state.skipChars(pos, marker);
	
	    // closing code fence must be at least as long as the opening one
	    if (pos - mem < len) { continue; }
	
	    // make sure tail has spaces only
	    pos = state.skipSpaces(pos);
	
	    if (pos < max) { continue; }
	
	    haveEndMarker = true;
	    // found!
	    break;
	  }
	
	  // If a fence has heading spaces, they should be removed from its inner block
	  len = state.tShift[startLine];
	
	  state.line = nextLine + (haveEndMarker ? 1 : 0);
	  state.tokens.push({
	    type: 'fence',
	    params: params,
	    content: state.getLines(startLine + 1, nextLine, len, true),
	    lines: [ startLine, state.line ],
	    level: state.level
	  });
	
	  return true;
	};


/***/ }),

/***/ 1091:
/***/ (function(module, exports) {

	// Process footnote reference list
	
	'use strict';
	
	
	module.exports = function footnote(state, startLine, endLine, silent) {
	  var oldBMark, oldTShift, oldParentType, pos, label,
	      start = state.bMarks[startLine] + state.tShift[startLine],
	      max = state.eMarks[startLine];
	
	  // line should be at least 5 chars - "[^x]:"
	  if (start + 4 > max) { return false; }
	
	  if (state.src.charCodeAt(start) !== 0x5B/* [ */) { return false; }
	  if (state.src.charCodeAt(start + 1) !== 0x5E/* ^ */) { return false; }
	  if (state.level >= state.options.maxNesting) { return false; }
	
	  for (pos = start + 2; pos < max; pos++) {
	    if (state.src.charCodeAt(pos) === 0x20) { return false; }
	    if (state.src.charCodeAt(pos) === 0x5D /* ] */) {
	      break;
	    }
	  }
	
	  if (pos === start + 2) { return false; } // no empty footnote labels
	  if (pos + 1 >= max || state.src.charCodeAt(++pos) !== 0x3A /* : */) { return false; }
	  if (silent) { return true; }
	  pos++;
	
	  if (!state.env.footnotes) { state.env.footnotes = {}; }
	  if (!state.env.footnotes.refs) { state.env.footnotes.refs = {}; }
	  label = state.src.slice(start + 2, pos - 2);
	  state.env.footnotes.refs[':' + label] = -1;
	
	  state.tokens.push({
	    type: 'footnote_reference_open',
	    label: label,
	    level: state.level++
	  });
	
	  oldBMark = state.bMarks[startLine];
	  oldTShift = state.tShift[startLine];
	  oldParentType = state.parentType;
	  state.tShift[startLine] = state.skipSpaces(pos) - pos;
	  state.bMarks[startLine] = pos;
	  state.blkIndent += 4;
	  state.parentType = 'footnote';
	
	  if (state.tShift[startLine] < state.blkIndent) {
	    state.tShift[startLine] += state.blkIndent;
	    state.bMarks[startLine] -= state.blkIndent;
	  }
	
	  state.parser.tokenize(state, startLine, endLine, true);
	
	  state.parentType = oldParentType;
	  state.blkIndent -= 4;
	  state.tShift[startLine] = oldTShift;
	  state.bMarks[startLine] = oldBMark;
	
	  state.tokens.push({
	    type: 'footnote_reference_close',
	    level: --state.level
	  });
	
	  return true;
	};


/***/ }),

/***/ 1092:
/***/ (function(module, exports) {

	// heading (#, ##, ...)
	
	'use strict';
	
	
	module.exports = function heading(state, startLine, endLine, silent) {
	  var ch, level, tmp,
	      pos = state.bMarks[startLine] + state.tShift[startLine],
	      max = state.eMarks[startLine];
	
	  if (pos >= max) { return false; }
	
	  ch  = state.src.charCodeAt(pos);
	
	  if (ch !== 0x23/* # */ || pos >= max) { return false; }
	
	  // count heading level
	  level = 1;
	  ch = state.src.charCodeAt(++pos);
	  while (ch === 0x23/* # */ && pos < max && level <= 6) {
	    level++;
	    ch = state.src.charCodeAt(++pos);
	  }
	
	  if (level > 6 || (pos < max && ch !== 0x20/* space */)) { return false; }
	
	  if (silent) { return true; }
	
	  // Let's cut tails like '    ###  ' from the end of string
	
	  max = state.skipCharsBack(max, 0x20, pos); // space
	  tmp = state.skipCharsBack(max, 0x23, pos); // #
	  if (tmp > pos && state.src.charCodeAt(tmp - 1) === 0x20/* space */) {
	    max = tmp;
	  }
	
	  state.line = startLine + 1;
	
	  state.tokens.push({ type: 'heading_open',
	    hLevel: level,
	    lines: [ startLine, state.line ],
	    level: state.level
	  });
	
	  // only if header is not empty
	  if (pos < max) {
	    state.tokens.push({
	      type: 'inline',
	      content: state.src.slice(pos, max).trim(),
	      level: state.level + 1,
	      lines: [ startLine, state.line ],
	      children: []
	    });
	  }
	  state.tokens.push({ type: 'heading_close', hLevel: level, level: state.level });
	
	  return true;
	};


/***/ }),

/***/ 1093:
/***/ (function(module, exports) {

	// Horizontal rule
	
	'use strict';
	
	
	module.exports = function hr(state, startLine, endLine, silent) {
	  var marker, cnt, ch,
	      pos = state.bMarks[startLine],
	      max = state.eMarks[startLine];
	
	  pos += state.tShift[startLine];
	
	  if (pos > max) { return false; }
	
	  marker = state.src.charCodeAt(pos++);
	
	  // Check hr marker
	  if (marker !== 0x2A/* * */ &&
	      marker !== 0x2D/* - */ &&
	      marker !== 0x5F/* _ */) {
	    return false;
	  }
	
	  // markers can be mixed with spaces, but there should be at least 3 one
	
	  cnt = 1;
	  while (pos < max) {
	    ch = state.src.charCodeAt(pos++);
	    if (ch !== marker && ch !== 0x20/* space */) { return false; }
	    if (ch === marker) { cnt++; }
	  }
	
	  if (cnt < 3) { return false; }
	
	  if (silent) { return true; }
	
	  state.line = startLine + 1;
	  state.tokens.push({
	    type: 'hr',
	    lines: [ startLine, state.line ],
	    level: state.level
	  });
	
	  return true;
	};


/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {

	// HTML block
	
	'use strict';
	
	
	var block_names = __webpack_require__(1075);
	
	
	var HTML_TAG_OPEN_RE = /^<([a-zA-Z]{1,15})[\s\/>]/;
	var HTML_TAG_CLOSE_RE = /^<\/([a-zA-Z]{1,15})[\s>]/;
	
	function isLetter(ch) {
	  /*eslint no-bitwise:0*/
	  var lc = ch | 0x20; // to lower case
	  return (lc >= 0x61/* a */) && (lc <= 0x7a/* z */);
	}
	
	module.exports = function htmlblock(state, startLine, endLine, silent) {
	  var ch, match, nextLine,
	      pos = state.bMarks[startLine],
	      max = state.eMarks[startLine],
	      shift = state.tShift[startLine];
	
	  pos += shift;
	
	  if (!state.options.html) { return false; }
	
	  if (shift > 3 || pos + 2 >= max) { return false; }
	
	  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }
	
	  ch = state.src.charCodeAt(pos + 1);
	
	  if (ch === 0x21/* ! */ || ch === 0x3F/* ? */) {
	    // Directive start / comment start / processing instruction start
	    if (silent) { return true; }
	
	  } else if (ch === 0x2F/* / */ || isLetter(ch)) {
	
	    // Probably start or end of tag
	    if (ch === 0x2F/* \ */) {
	      // closing tag
	      match = state.src.slice(pos, max).match(HTML_TAG_CLOSE_RE);
	      if (!match) { return false; }
	    } else {
	      // opening tag
	      match = state.src.slice(pos, max).match(HTML_TAG_OPEN_RE);
	      if (!match) { return false; }
	    }
	    // Make sure tag name is valid
	    if (block_names[match[1].toLowerCase()] !== true) { return false; }
	    if (silent) { return true; }
	
	  } else {
	    return false;
	  }
	
	  // If we are here - we detected HTML block.
	  // Let's roll down till empty line (block end).
	  nextLine = startLine + 1;
	  while (nextLine < state.lineMax && !state.isEmpty(nextLine)) {
	    nextLine++;
	  }
	
	  state.line = nextLine;
	  state.tokens.push({
	    type: 'htmlblock',
	    level: state.level,
	    lines: [ startLine, state.line ],
	    content: state.getLines(startLine, nextLine, 0, true)
	  });
	
	  return true;
	};


/***/ }),

/***/ 1095:
/***/ (function(module, exports) {

	// lheading (---, ===)
	
	'use strict';
	
	
	module.exports = function lheading(state, startLine, endLine/*, silent*/) {
	  var marker, pos, max,
	      next = startLine + 1;
	
	  if (next >= endLine) { return false; }
	  if (state.tShift[next] < state.blkIndent) { return false; }
	
	  // Scan next line
	
	  if (state.tShift[next] - state.blkIndent > 3) { return false; }
	
	  pos = state.bMarks[next] + state.tShift[next];
	  max = state.eMarks[next];
	
	  if (pos >= max) { return false; }
	
	  marker = state.src.charCodeAt(pos);
	
	  if (marker !== 0x2D/* - */ && marker !== 0x3D/* = */) { return false; }
	
	  pos = state.skipChars(pos, marker);
	
	  pos = state.skipSpaces(pos);
	
	  if (pos < max) { return false; }
	
	  pos = state.bMarks[startLine] + state.tShift[startLine];
	
	  state.line = next + 1;
	  state.tokens.push({
	    type: 'heading_open',
	    hLevel: marker === 0x3D/* = */ ? 1 : 2,
	    lines: [ startLine, state.line ],
	    level: state.level
	  });
	  state.tokens.push({
	    type: 'inline',
	    content: state.src.slice(pos, state.eMarks[startLine]).trim(),
	    level: state.level + 1,
	    lines: [ startLine, state.line - 1 ],
	    children: []
	  });
	  state.tokens.push({
	    type: 'heading_close',
	    hLevel: marker === 0x3D/* = */ ? 1 : 2,
	    level: state.level
	  });
	
	  return true;
	};


/***/ }),

/***/ 1096:
/***/ (function(module, exports) {

	// Lists
	
	'use strict';
	
	
	// Search `[-+*][\n ]`, returns next pos arter marker on success
	// or -1 on fail.
	function skipBulletListMarker(state, startLine) {
	  var marker, pos, max;
	
	  pos = state.bMarks[startLine] + state.tShift[startLine];
	  max = state.eMarks[startLine];
	
	  if (pos >= max) { return -1; }
	
	  marker = state.src.charCodeAt(pos++);
	  // Check bullet
	  if (marker !== 0x2A/* * */ &&
	      marker !== 0x2D/* - */ &&
	      marker !== 0x2B/* + */) {
	    return -1;
	  }
	
	  if (pos < max && state.src.charCodeAt(pos) !== 0x20) {
	    // " 1.test " - is not a list item
	    return -1;
	  }
	
	  return pos;
	}
	
	// Search `\d+[.)][\n ]`, returns next pos arter marker on success
	// or -1 on fail.
	function skipOrderedListMarker(state, startLine) {
	  var ch,
	      pos = state.bMarks[startLine] + state.tShift[startLine],
	      max = state.eMarks[startLine];
	
	  if (pos + 1 >= max) { return -1; }
	
	  ch = state.src.charCodeAt(pos++);
	
	  if (ch < 0x30/* 0 */ || ch > 0x39/* 9 */) { return -1; }
	
	  for (;;) {
	    // EOL -> fail
	    if (pos >= max) { return -1; }
	
	    ch = state.src.charCodeAt(pos++);
	
	    if (ch >= 0x30/* 0 */ && ch <= 0x39/* 9 */) {
	      continue;
	    }
	
	    // found valid marker
	    if (ch === 0x29/* ) */ || ch === 0x2e/* . */) {
	      break;
	    }
	
	    return -1;
	  }
	
	
	  if (pos < max && state.src.charCodeAt(pos) !== 0x20/* space */) {
	    // " 1.test " - is not a list item
	    return -1;
	  }
	  return pos;
	}
	
	function markTightParagraphs(state, idx) {
	  var i, l,
	      level = state.level + 2;
	
	  for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
	    if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
	      state.tokens[i + 2].tight = true;
	      state.tokens[i].tight = true;
	      i += 2;
	    }
	  }
	}
	
	
	module.exports = function list(state, startLine, endLine, silent) {
	  var nextLine,
	      indent,
	      oldTShift,
	      oldIndent,
	      oldTight,
	      oldParentType,
	      start,
	      posAfterMarker,
	      max,
	      indentAfterMarker,
	      markerValue,
	      markerCharCode,
	      isOrdered,
	      contentStart,
	      listTokIdx,
	      prevEmptyEnd,
	      listLines,
	      itemLines,
	      tight = true,
	      terminatorRules,
	      i, l, terminate;
	
	  // Detect list type and position after marker
	  if ((posAfterMarker = skipOrderedListMarker(state, startLine)) >= 0) {
	    isOrdered = true;
	  } else if ((posAfterMarker = skipBulletListMarker(state, startLine)) >= 0) {
	    isOrdered = false;
	  } else {
	    return false;
	  }
	
	  if (state.level >= state.options.maxNesting) { return false; }
	
	  // We should terminate list on style change. Remember first one to compare.
	  markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
	
	  // For validation mode we can terminate immediately
	  if (silent) { return true; }
	
	  // Start list
	  listTokIdx = state.tokens.length;
	
	  if (isOrdered) {
	    start = state.bMarks[startLine] + state.tShift[startLine];
	    markerValue = Number(state.src.substr(start, posAfterMarker - start - 1));
	
	    state.tokens.push({
	      type: 'ordered_list_open',
	      order: markerValue,
	      lines: listLines = [ startLine, 0 ],
	      level: state.level++
	    });
	
	  } else {
	    state.tokens.push({
	      type: 'bullet_list_open',
	      lines: listLines = [ startLine, 0 ],
	      level: state.level++
	    });
	  }
	
	  //
	  // Iterate list items
	  //
	
	  nextLine = startLine;
	  prevEmptyEnd = false;
	  terminatorRules = state.parser.ruler.getRules('list');
	
	  while (nextLine < endLine) {
	    contentStart = state.skipSpaces(posAfterMarker);
	    max = state.eMarks[nextLine];
	
	    if (contentStart >= max) {
	      // trimming space in "-    \n  3" case, indent is 1 here
	      indentAfterMarker = 1;
	    } else {
	      indentAfterMarker = contentStart - posAfterMarker;
	    }
	
	    // If we have more than 4 spaces, the indent is 1
	    // (the rest is just indented code block)
	    if (indentAfterMarker > 4) { indentAfterMarker = 1; }
	
	    // If indent is less than 1, assume that it's one, example:
	    //  "-\n  test"
	    if (indentAfterMarker < 1) { indentAfterMarker = 1; }
	
	    // "  -  test"
	    //  ^^^^^ - calculating total length of this thing
	    indent = (posAfterMarker - state.bMarks[nextLine]) + indentAfterMarker;
	
	    // Run subparser & write tokens
	    state.tokens.push({
	      type: 'list_item_open',
	      lines: itemLines = [ startLine, 0 ],
	      level: state.level++
	    });
	
	    oldIndent = state.blkIndent;
	    oldTight = state.tight;
	    oldTShift = state.tShift[startLine];
	    oldParentType = state.parentType;
	    state.tShift[startLine] = contentStart - state.bMarks[startLine];
	    state.blkIndent = indent;
	    state.tight = true;
	    state.parentType = 'list';
	
	    state.parser.tokenize(state, startLine, endLine, true);
	
	    // If any of list item is tight, mark list as tight
	    if (!state.tight || prevEmptyEnd) {
	      tight = false;
	    }
	    // Item become loose if finish with empty line,
	    // but we should filter last element, because it means list finish
	    prevEmptyEnd = (state.line - startLine) > 1 && state.isEmpty(state.line - 1);
	
	    state.blkIndent = oldIndent;
	    state.tShift[startLine] = oldTShift;
	    state.tight = oldTight;
	    state.parentType = oldParentType;
	
	    state.tokens.push({
	      type: 'list_item_close',
	      level: --state.level
	    });
	
	    nextLine = startLine = state.line;
	    itemLines[1] = nextLine;
	    contentStart = state.bMarks[startLine];
	
	    if (nextLine >= endLine) { break; }
	
	    if (state.isEmpty(nextLine)) {
	      break;
	    }
	
	    //
	    // Try to check if list is terminated or continued.
	    //
	    if (state.tShift[nextLine] < state.blkIndent) { break; }
	
	    // fail if terminating block found
	    terminate = false;
	    for (i = 0, l = terminatorRules.length; i < l; i++) {
	      if (terminatorRules[i](state, nextLine, endLine, true)) {
	        terminate = true;
	        break;
	      }
	    }
	    if (terminate) { break; }
	
	    // fail if list has another type
	    if (isOrdered) {
	      posAfterMarker = skipOrderedListMarker(state, nextLine);
	      if (posAfterMarker < 0) { break; }
	    } else {
	      posAfterMarker = skipBulletListMarker(state, nextLine);
	      if (posAfterMarker < 0) { break; }
	    }
	
	    if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) { break; }
	  }
	
	  // Finilize list
	  state.tokens.push({
	    type: isOrdered ? 'ordered_list_close' : 'bullet_list_close',
	    level: --state.level
	  });
	  listLines[1] = nextLine;
	
	  state.line = nextLine;
	
	  // mark paragraphs tight if needed
	  if (tight) {
	    markTightParagraphs(state, listTokIdx);
	  }
	
	  return true;
	};


/***/ }),

/***/ 1097:
/***/ (function(module, exports) {

	// Paragraph
	
	'use strict';
	
	
	module.exports = function paragraph(state, startLine/*, endLine*/) {
	  var endLine, content, terminate, i, l,
	      nextLine = startLine + 1,
	      terminatorRules;
	
	  endLine = state.lineMax;
	
	  // jump line-by-line until empty one or EOF
	  if (nextLine < endLine && !state.isEmpty(nextLine)) {
	    terminatorRules = state.parser.ruler.getRules('paragraph');
	
	    for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
	      // this would be a code block normally, but after paragraph
	      // it's considered a lazy continuation regardless of what's there
	      if (state.tShift[nextLine] - state.blkIndent > 3) { continue; }
	
	      // Some tags can terminate paragraph without empty line.
	      terminate = false;
	      for (i = 0, l = terminatorRules.length; i < l; i++) {
	        if (terminatorRules[i](state, nextLine, endLine, true)) {
	          terminate = true;
	          break;
	        }
	      }
	      if (terminate) { break; }
	    }
	  }
	
	  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
	
	  state.line = nextLine;
	  if (content.length) {
	    state.tokens.push({
	      type: 'paragraph_open',
	      tight: false,
	      lines: [ startLine, state.line ],
	      level: state.level
	    });
	    state.tokens.push({
	      type: 'inline',
	      content: content,
	      level: state.level + 1,
	      lines: [ startLine, state.line ],
	      children: []
	    });
	    state.tokens.push({
	      type: 'paragraph_close',
	      tight: false,
	      level: state.level
	    });
	  }
	
	  return true;
	};


/***/ }),

/***/ 1098:
/***/ (function(module, exports) {

	// Parser state class
	
	'use strict';
	
	
	function StateBlock(src, parser, options, env, tokens) {
	  var ch, s, start, pos, len, indent, indent_found;
	
	  this.src = src;
	
	  // Shortcuts to simplify nested calls
	  this.parser = parser;
	
	  this.options = options;
	
	  this.env = env;
	
	  //
	  // Internal state vartiables
	  //
	
	  this.tokens = tokens;
	
	  this.bMarks = [];  // line begin offsets for fast jumps
	  this.eMarks = [];  // line end offsets for fast jumps
	  this.tShift = [];  // indent for each line
	
	  // block parser variables
	  this.blkIndent  = 0; // required block content indent
	                       // (for example, if we are in list)
	  this.line       = 0; // line index in src
	  this.lineMax    = 0; // lines count
	  this.tight      = false;  // loose/tight mode for lists
	  this.parentType = 'root'; // if `list`, block parser stops on two newlines
	  this.ddIndent   = -1; // indent of the current dd block (-1 if there isn't any)
	
	  this.level = 0;
	
	  // renderer
	  this.result = '';
	
	  // Create caches
	  // Generate markers.
	  s = this.src;
	  indent = 0;
	  indent_found = false;
	
	  for (start = pos = indent = 0, len = s.length; pos < len; pos++) {
	    ch = s.charCodeAt(pos);
	
	    if (!indent_found) {
	      if (ch === 0x20/* space */) {
	        indent++;
	        continue;
	      } else {
	        indent_found = true;
	      }
	    }
	
	    if (ch === 0x0A || pos === len - 1) {
	      if (ch !== 0x0A) { pos++; }
	      this.bMarks.push(start);
	      this.eMarks.push(pos);
	      this.tShift.push(indent);
	
	      indent_found = false;
	      indent = 0;
	      start = pos + 1;
	    }
	  }
	
	  // Push fake entry to simplify cache bounds checks
	  this.bMarks.push(s.length);
	  this.eMarks.push(s.length);
	  this.tShift.push(0);
	
	  this.lineMax = this.bMarks.length - 1; // don't count last fake line
	}
	
	StateBlock.prototype.isEmpty = function isEmpty(line) {
	  return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
	};
	
	StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
	  for (var max = this.lineMax; from < max; from++) {
	    if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) {
	      break;
	    }
	  }
	  return from;
	};
	
	// Skip spaces from given position.
	StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
	  for (var max = this.src.length; pos < max; pos++) {
	    if (this.src.charCodeAt(pos) !== 0x20/* space */) { break; }
	  }
	  return pos;
	};
	
	// Skip char codes from given position
	StateBlock.prototype.skipChars = function skipChars(pos, code) {
	  for (var max = this.src.length; pos < max; pos++) {
	    if (this.src.charCodeAt(pos) !== code) { break; }
	  }
	  return pos;
	};
	
	// Skip char codes reverse from given position - 1
	StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
	  if (pos <= min) { return pos; }
	
	  while (pos > min) {
	    if (code !== this.src.charCodeAt(--pos)) { return pos + 1; }
	  }
	  return pos;
	};
	
	// cut lines range from source.
	StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
	  var i, first, last, queue, shift,
	      line = begin;
	
	  if (begin >= end) {
	    return '';
	  }
	
	  // Opt: don't use push queue for single line;
	  if (line + 1 === end) {
	    first = this.bMarks[line] + Math.min(this.tShift[line], indent);
	    last = keepLastLF ? this.eMarks[line] + 1 : this.eMarks[line];
	    return this.src.slice(first, last);
	  }
	
	  queue = new Array(end - begin);
	
	  for (i = 0; line < end; line++, i++) {
	    shift = this.tShift[line];
	    if (shift > indent) { shift = indent; }
	    if (shift < 0) { shift = 0; }
	
	    first = this.bMarks[line] + shift;
	
	    if (line + 1 < end || keepLastLF) {
	      // No need for bounds check because we have fake entry on tail.
	      last = this.eMarks[line] + 1;
	    } else {
	      last = this.eMarks[line];
	    }
	
	    queue[i] = this.src.slice(first, last);
	  }
	
	  return queue.join('');
	};
	
	
	module.exports = StateBlock;


/***/ }),

/***/ 1099:
/***/ (function(module, exports) {

	// GFM table, non-standard
	
	'use strict';
	
	
	function getLine(state, line) {
	  var pos = state.bMarks[line] + state.blkIndent,
	      max = state.eMarks[line];
	
	  return state.src.substr(pos, max - pos);
	}
	
	module.exports = function table(state, startLine, endLine, silent) {
	  var ch, lineText, pos, i, nextLine, rows, cell,
	      aligns, t, tableLines, tbodyLines;
	
	  // should have at least three lines
	  if (startLine + 2 > endLine) { return false; }
	
	  nextLine = startLine + 1;
	
	  if (state.tShift[nextLine] < state.blkIndent) { return false; }
	
	  // first character of the second line should be '|' or '-'
	
	  pos = state.bMarks[nextLine] + state.tShift[nextLine];
	  if (pos >= state.eMarks[nextLine]) { return false; }
	
	  ch = state.src.charCodeAt(pos);
	  if (ch !== 0x7C/* | */ && ch !== 0x2D/* - */ && ch !== 0x3A/* : */) { return false; }
	
	  lineText = getLine(state, startLine + 1);
	  if (!/^[-:| ]+$/.test(lineText)) { return false; }
	
	  rows = lineText.split('|');
	  if (rows <= 2) { return false; }
	  aligns = [];
	  for (i = 0; i < rows.length; i++) {
	    t = rows[i].trim();
	    if (!t) {
	      // allow empty columns before and after table, but not in between columns;
	      // e.g. allow ` |---| `, disallow ` ---||--- `
	      if (i === 0 || i === rows.length - 1) {
	        continue;
	      } else {
	        return false;
	      }
	    }
	
	    if (!/^:?-+:?$/.test(t)) { return false; }
	    if (t.charCodeAt(t.length - 1) === 0x3A/* : */) {
	      aligns.push(t.charCodeAt(0) === 0x3A/* : */ ? 'center' : 'right');
	    } else if (t.charCodeAt(0) === 0x3A/* : */) {
	      aligns.push('left');
	    } else {
	      aligns.push('');
	    }
	  }
	
	  lineText = getLine(state, startLine).trim();
	  if (lineText.indexOf('|') === -1) { return false; }
	  rows = lineText.replace(/^\||\|$/g, '').split('|');
	  if (aligns.length !== rows.length) { return false; }
	  if (silent) { return true; }
	
	  state.tokens.push({
	    type: 'table_open',
	    lines: tableLines = [ startLine, 0 ],
	    level: state.level++
	  });
	  state.tokens.push({
	    type: 'thead_open',
	    lines: [ startLine, startLine + 1 ],
	    level: state.level++
	  });
	
	  state.tokens.push({
	    type: 'tr_open',
	    lines: [ startLine, startLine + 1 ],
	    level: state.level++
	  });
	  for (i = 0; i < rows.length; i++) {
	    state.tokens.push({
	      type: 'th_open',
	      align: aligns[i],
	      lines: [ startLine, startLine + 1 ],
	      level: state.level++
	    });
	    state.tokens.push({
	      type: 'inline',
	      content: rows[i].trim(),
	      lines: [ startLine, startLine + 1 ],
	      level: state.level,
	      children: []
	    });
	    state.tokens.push({ type: 'th_close', level: --state.level });
	  }
	  state.tokens.push({ type: 'tr_close', level: --state.level });
	  state.tokens.push({ type: 'thead_close', level: --state.level });
	
	  state.tokens.push({
	    type: 'tbody_open',
	    lines: tbodyLines = [ startLine + 2, 0 ],
	    level: state.level++
	  });
	
	  for (nextLine = startLine + 2; nextLine < endLine; nextLine++) {
	    if (state.tShift[nextLine] < state.blkIndent) { break; }
	
	    lineText = getLine(state, nextLine).trim();
	    if (lineText.indexOf('|') === -1) { break; }
	    rows = lineText.replace(/^\||\|$/g, '').split('|');
	
	    state.tokens.push({ type: 'tr_open', level: state.level++ });
	    for (i = 0; i < rows.length; i++) {
	      state.tokens.push({ type: 'td_open', align: aligns[i], level: state.level++ });
	      // 0x7c === '|'
	      cell = rows[i].substring(
	          rows[i].charCodeAt(0) === 0x7c ? 1 : 0,
	          rows[i].charCodeAt(rows[i].length - 1) === 0x7c ? rows[i].length - 1 : rows[i].length
	      ).trim();
	      state.tokens.push({
	        type: 'inline',
	        content: cell,
	        level: state.level,
	        children: []
	      });
	      state.tokens.push({ type: 'td_close', level: --state.level });
	    }
	    state.tokens.push({ type: 'tr_close', level: --state.level });
	  }
	  state.tokens.push({ type: 'tbody_close', level: --state.level });
	  state.tokens.push({ type: 'table_close', level: --state.level });
	
	  tableLines[1] = tbodyLines[1] = nextLine;
	  state.line = nextLine;
	  return true;
	};


/***/ }),

/***/ 1100:
/***/ (function(module, exports, __webpack_require__) {

	// Parse abbreviation definitions, i.e. `*[abbr]: description`
	//
	
	'use strict';
	
	
	var StateInline    = __webpack_require__(101);
	var parseLinkLabel = __webpack_require__(64);
	
	
	function parseAbbr(str, parserInline, options, env) {
	  var state, labelEnd, pos, max, label, title;
	
	  if (str.charCodeAt(0) !== 0x2A/* * */) { return -1; }
	  if (str.charCodeAt(1) !== 0x5B/* [ */) { return -1; }
	
	  if (str.indexOf(']:') === -1) { return -1; }
	
	  state = new StateInline(str, parserInline, options, env, []);
	  labelEnd = parseLinkLabel(state, 1);
	
	  if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A/* : */) { return -1; }
	
	  max = state.posMax;
	
	  // abbr title is always one line, so looking for ending "\n" here
	  for (pos = labelEnd + 2; pos < max; pos++) {
	    if (state.src.charCodeAt(pos) === 0x0A) { break; }
	  }
	
	  label = str.slice(2, labelEnd);
	  title = str.slice(labelEnd + 2, pos).trim();
	  if (title.length === 0) { return -1; }
	  if (!env.abbreviations) { env.abbreviations = {}; }
	  // prepend ':' to avoid conflict with Object.prototype members
	  if (typeof env.abbreviations[':' + label] === 'undefined') {
	    env.abbreviations[':' + label] = title;
	  }
	
	  return pos;
	}
	
	module.exports = function abbr(state) {
	  var tokens = state.tokens, i, l, content, pos;
	
	  if (state.inlineMode) {
	    return;
	  }
	
	  // Parse inlines
	  for (i = 1, l = tokens.length - 1; i < l; i++) {
	    if (tokens[i - 1].type === 'paragraph_open' &&
	        tokens[i].type === 'inline' &&
	        tokens[i + 1].type === 'paragraph_close') {
	
	      content = tokens[i].content;
	      while (content.length) {
	        pos = parseAbbr(content, state.inline, state.options, state.env);
	        if (pos < 0) { break; }
	        content = content.slice(pos).trim();
	      }
	
	      tokens[i].content = content;
	      if (!content.length) {
	        tokens[i - 1].tight = true;
	        tokens[i + 1].tight = true;
	      }
	    }
	  }
	};


/***/ }),

/***/ 1101:
/***/ (function(module, exports) {

	// Enclose abbreviations in <abbr> tags
	//
	'use strict';
	
	
	var PUNCT_CHARS = ' \n()[]\'".,!?-';
	
	
	// from Google closure library
	// http://closure-library.googlecode.com/git-history/docs/local_closure_goog_string_string.js.source.html#line1021
	function regEscape(s) {
	  return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1');
	}
	
	
	module.exports = function abbr2(state) {
	  var i, j, l, tokens, token, text, nodes, pos, level, reg, m, regText,
	      blockTokens = state.tokens;
	
	  if (!state.env.abbreviations) { return; }
	  if (!state.env.abbrRegExp) {
	    regText = '(^|[' + PUNCT_CHARS.split('').map(regEscape).join('') + '])'
	            + '(' + Object.keys(state.env.abbreviations).map(function (x) {
	                      return x.substr(1);
	                    }).sort(function (a, b) {
	                      return b.length - a.length;
	                    }).map(regEscape).join('|') + ')'
	            + '($|[' + PUNCT_CHARS.split('').map(regEscape).join('') + '])';
	    state.env.abbrRegExp = new RegExp(regText, 'g');
	  }
	  reg = state.env.abbrRegExp;
	
	  for (j = 0, l = blockTokens.length; j < l; j++) {
	    if (blockTokens[j].type !== 'inline') { continue; }
	    tokens = blockTokens[j].children;
	
	    // We scan from the end, to keep position when new tags added.
	    for (i = tokens.length - 1; i >= 0; i--) {
	      token = tokens[i];
	      if (token.type !== 'text') { continue; }
	
	      pos = 0;
	      text = token.content;
	      reg.lastIndex = 0;
	      level = token.level;
	      nodes = [];
	
	      while ((m = reg.exec(text))) {
	        if (reg.lastIndex > pos) {
	          nodes.push({
	            type: 'text',
	            content: text.slice(pos, m.index + m[1].length),
	            level: level
	          });
	        }
	
	        nodes.push({
	          type: 'abbr_open',
	          title: state.env.abbreviations[':' + m[2]],
	          level: level++
	        });
	        nodes.push({
	          type: 'text',
	          content: m[2],
	          level: level
	        });
	        nodes.push({
	          type: 'abbr_close',
	          level: --level
	        });
	        pos = reg.lastIndex - m[3].length;
	      }
	
	      if (!nodes.length) { continue; }
	
	      if (pos < text.length) {
	        nodes.push({
	          type: 'text',
	          content: text.slice(pos),
	          level: level
	        });
	      }
	
	      // replace current node
	      blockTokens[j].children = tokens = [].concat(tokens.slice(0, i), nodes, tokens.slice(i + 1));
	    }
	  }
	};


/***/ }),

/***/ 1102:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function block(state) {
	
	  if (state.inlineMode) {
	    state.tokens.push({
	      type: 'inline',
	      content: state.src.replace(/\n/g, ' ').trim(),
	      level: 0,
	      lines: [ 0, 1 ],
	      children: []
	    });
	
	  } else {
	    state.block.parse(state.src, state.options, state.env, state.tokens);
	  }
	};


/***/ }),

/***/ 1103:
/***/ (function(module, exports) {

	'use strict';
	
	
	module.exports = function footnote_block(state) {
	  var i, l, j, t, lastParagraph, list, tokens, current, currentLabel,
	      level = 0,
	      insideRef = false,
	      refTokens = {};
	
	  if (!state.env.footnotes) { return; }
	
	  state.tokens = state.tokens.filter(function(tok) {
	    if (tok.type === 'footnote_reference_open') {
	      insideRef = true;
	      current = [];
	      currentLabel = tok.label;
	      return false;
	    }
	    if (tok.type === 'footnote_reference_close') {
	      insideRef = false;
	      // prepend ':' to avoid conflict with Object.prototype members
	      refTokens[':' + currentLabel] = current;
	      return false;
	    }
	    if (insideRef) { current.push(tok); }
	    return !insideRef;
	  });
	
	  if (!state.env.footnotes.list) { return; }
	  list = state.env.footnotes.list;
	
	  state.tokens.push({
	    type: 'footnote_block_open',
	    level: level++
	  });
	  for (i = 0, l = list.length; i < l; i++) {
	    state.tokens.push({
	      type: 'footnote_open',
	      id: i,
	      level: level++
	    });
	
	    if (list[i].tokens) {
	      tokens = [];
	      tokens.push({
	        type: 'paragraph_open',
	        tight: false,
	        level: level++
	      });
	      tokens.push({
	        type: 'inline',
	        content: '',
	        level: level,
	        children: list[i].tokens
	      });
	      tokens.push({
	        type: 'paragraph_close',
	        tight: false,
	        level: --level
	      });
	    } else if (list[i].label) {
	      tokens = refTokens[':' + list[i].label];
	    }
	
	    state.tokens = state.tokens.concat(tokens);
	    if (state.tokens[state.tokens.length - 1].type === 'paragraph_close') {
	      lastParagraph = state.tokens.pop();
	    } else {
	      lastParagraph = null;
	    }
	
	    t = list[i].count > 0 ? list[i].count : 1;
	    for (j = 0; j < t; j++) {
	      state.tokens.push({
	        type: 'footnote_anchor',
	        id: i,
	        subId: j,
	        level: level
	      });
	    }
	
	    if (lastParagraph) {
	      state.tokens.push(lastParagraph);
	    }
	
	    state.tokens.push({
	      type: 'footnote_close',
	      level: --level
	    });
	  }
	  state.tokens.push({
	    type: 'footnote_block_close',
	    level: --level
	  });
	};


/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function inline(state) {
	  var tokens = state.tokens, tok, i, l;
	
	  // Parse inlines
	  for (i = 0, l = tokens.length; i < l; i++) {
	    tok = tokens[i];
	    if (tok.type === 'inline') {
	      state.inline.parse(tok.content, state.options, state.env, tok.children);
	    }
	  }
	};


/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

	// Replace link-like texts with link nodes.
	//
	// Currently restricted by `inline.validateLink()` to http/https/ftp
	//
	'use strict';
	
	
	var Autolinker = __webpack_require__(157);
	
	
	var LINK_SCAN_RE = /www|@|\:\/\//;
	
	
	function isLinkOpen(str) {
	  return /^<a[>\s]/i.test(str);
	}
	function isLinkClose(str) {
	  return /^<\/a\s*>/i.test(str);
	}
	
	// Stupid fabric to avoid singletons, for thread safety.
	// Required for engines like Nashorn.
	//
	function createLinkifier() {
	  var links = [];
	  var autolinker = new Autolinker({
	    stripPrefix: false,
	    url: true,
	    email: true,
	    twitter: false,
	    replaceFn: function (linker, match) {
	      // Only collect matched strings but don't change anything.
	      switch (match.getType()) {
	        /*eslint default-case:0*/
	        case 'url':
	          links.push({
	            text: match.matchedText,
	            url: match.getUrl()
	          });
	          break;
	        case 'email':
	          links.push({
	            text: match.matchedText,
	            // normalize email protocol
	            url: 'mailto:' + match.getEmail().replace(/^mailto:/i, '')
	          });
	          break;
	      }
	      return false;
	    }
	  });
	
	  return {
	    links: links,
	    autolinker: autolinker
	  };
	}
	
	
	module.exports = function linkify(state) {
	  var i, j, l, tokens, token, text, nodes, ln, pos, level, htmlLinkLevel,
	      blockTokens = state.tokens,
	      linkifier = null, links, autolinker;
	
	  if (!state.options.linkify) { return; }
	
	  for (j = 0, l = blockTokens.length; j < l; j++) {
	    if (blockTokens[j].type !== 'inline') { continue; }
	    tokens = blockTokens[j].children;
	
	    htmlLinkLevel = 0;
	
	    // We scan from the end, to keep position when new tags added.
	    // Use reversed logic in links start/end match
	    for (i = tokens.length - 1; i >= 0; i--) {
	      token = tokens[i];
	
	      // Skip content of markdown links
	      if (token.type === 'link_close') {
	        i--;
	        while (tokens[i].level !== token.level && tokens[i].type !== 'link_open') {
	          i--;
	        }
	        continue;
	      }
	
	      // Skip content of html tag links
	      if (token.type === 'htmltag') {
	        if (isLinkOpen(token.content) && htmlLinkLevel > 0) {
	          htmlLinkLevel--;
	        }
	        if (isLinkClose(token.content)) {
	          htmlLinkLevel++;
	        }
	      }
	      if (htmlLinkLevel > 0) { continue; }
	
	      if (token.type === 'text' && LINK_SCAN_RE.test(token.content)) {
	
	        // Init linkifier in lazy manner, only if required.
	        if (!linkifier) {
	          linkifier = createLinkifier();
	          links = linkifier.links;
	          autolinker = linkifier.autolinker;
	        }
	
	        text = token.content;
	        links.length = 0;
	        autolinker.link(text);
	
	        if (!links.length) { continue; }
	
	        // Now split string to nodes
	        nodes = [];
	        level = token.level;
	
	        for (ln = 0; ln < links.length; ln++) {
	
	          if (!state.inline.validateLink(links[ln].url)) { continue; }
	
	          pos = text.indexOf(links[ln].text);
	
	          if (pos) {
	            level = level;
	            nodes.push({
	              type: 'text',
	              content: text.slice(0, pos),
	              level: level
	            });
	          }
	          nodes.push({
	            type: 'link_open',
	            href: links[ln].url,
	            title: '',
	            level: level++
	          });
	          nodes.push({
	            type: 'text',
	            content: links[ln].text,
	            level: level
	          });
	          nodes.push({
	            type: 'link_close',
	            level: --level
	          });
	          text = text.slice(pos + links[ln].text.length);
	        }
	        if (text.length) {
	          nodes.push({
	            type: 'text',
	            content: text,
	            level: level
	          });
	        }
	
	        // replace current node
	        blockTokens[j].children = tokens = [].concat(tokens.slice(0, i), nodes, tokens.slice(i + 1));
	      }
	    }
	  }
	};


/***/ }),

/***/ 1106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var StateInline          = __webpack_require__(101);
	var parseLinkLabel       = __webpack_require__(64);
	var parseLinkDestination = __webpack_require__(153);
	var parseLinkTitle       = __webpack_require__(154);
	var normalizeReference   = __webpack_require__(152);
	
	
	function parseReference(str, parser, options, env) {
	  var state, labelEnd, pos, max, code, start, href, title, label;
	
	  if (str.charCodeAt(0) !== 0x5B/* [ */) { return -1; }
	
	  if (str.indexOf(']:') === -1) { return -1; }
	
	  state = new StateInline(str, parser, options, env, []);
	  labelEnd = parseLinkLabel(state, 0);
	
	  if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A/* : */) { return -1; }
	
	  max = state.posMax;
	
	  // [label]:   destination   'title'
	  //         ^^^ skip optional whitespace here
	  for (pos = labelEnd + 2; pos < max; pos++) {
	    code = state.src.charCodeAt(pos);
	    if (code !== 0x20 && code !== 0x0A) { break; }
	  }
	
	  // [label]:   destination   'title'
	  //            ^^^^^^^^^^^ parse this
	  if (!parseLinkDestination(state, pos)) { return -1; }
	  href = state.linkContent;
	  pos = state.pos;
	
	  // [label]:   destination   'title'
	  //                       ^^^ skipping those spaces
	  start = pos;
	  for (pos = pos + 1; pos < max; pos++) {
	    code = state.src.charCodeAt(pos);
	    if (code !== 0x20 && code !== 0x0A) { break; }
	  }
	
	  // [label]:   destination   'title'
	  //                          ^^^^^^^ parse this
	  if (pos < max && start !== pos && parseLinkTitle(state, pos)) {
	    title = state.linkContent;
	    pos = state.pos;
	  } else {
	    title = '';
	    pos = start;
	  }
	
	  // ensure that the end of the line is empty
	  while (pos < max && state.src.charCodeAt(pos) === 0x20/* space */) { pos++; }
	  if (pos < max && state.src.charCodeAt(pos) !== 0x0A) { return -1; }
	
	  label = normalizeReference(str.slice(1, labelEnd));
	  if (typeof env.references[label] === 'undefined') {
	    env.references[label] = { title: title, href: href };
	  }
	
	  return pos;
	}
	
	
	module.exports = function references(state) {
	  var tokens = state.tokens, i, l, content, pos;
	
	  state.env.references = state.env.references || {};
	
	  if (state.inlineMode) {
	    return;
	  }
	
	  // Scan definitions in paragraph inlines
	  for (i = 1, l = tokens.length - 1; i < l; i++) {
	    if (tokens[i].type === 'inline' &&
	        tokens[i - 1].type === 'paragraph_open' &&
	        tokens[i + 1].type === 'paragraph_close') {
	
	      content = tokens[i].content;
	      while (content.length) {
	        pos = parseReference(content, state.inline, state.options, state.env);
	        if (pos < 0) { break; }
	        content = content.slice(pos).trim();
	      }
	
	      tokens[i].content = content;
	      if (!content.length) {
	        tokens[i - 1].tight = true;
	        tokens[i + 1].tight = true;
	      }
	    }
	  }
	};


/***/ }),

/***/ 1107:
/***/ (function(module, exports) {

	// Simple typographical replacements
	//
	'use strict';
	
	// TODO:
	// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
	// - miltiplication 2 x 4 -> 2 × 4
	
	var RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
	
	var SCOPED_ABBR_RE = /\((c|tm|r|p)\)/ig;
	var SCOPED_ABBR = {
	  'c': '©',
	  'r': '®',
	  'p': '§',
	  'tm': '™'
	};
	
	function replaceScopedAbbr(str) {
	  if (str.indexOf('(') < 0) { return str; }
	
	  return str.replace(SCOPED_ABBR_RE, function(match, name) {
	    return SCOPED_ABBR[name.toLowerCase()];
	  });
	}
	
	
	module.exports = function replace(state) {
	  var i, token, text, inlineTokens, blkIdx;
	
	  if (!state.options.typographer) { return; }
	
	  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {
	
	    if (state.tokens[blkIdx].type !== 'inline') { continue; }
	
	    inlineTokens = state.tokens[blkIdx].children;
	
	    for (i = inlineTokens.length - 1; i >= 0; i--) {
	      token = inlineTokens[i];
	      if (token.type === 'text') {
	        text = token.content;
	
	        text = replaceScopedAbbr(text);
	
	        if (RARE_RE.test(text)) {
	          text = text
	            .replace(/\+-/g, '±')
	            // .., ..., ....... -> …
	            // but ?..... & !..... -> ?.. & !..
	            .replace(/\.{2,}/g, '…').replace(/([?!])…/g, '$1..')
	            .replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')
	            // em-dash
	            .replace(/(^|[^-])---([^-]|$)/mg, '$1\u2014$2')
	            // en-dash
	            .replace(/(^|\s)--(\s|$)/mg, '$1\u2013$2')
	            .replace(/(^|[^-\s])--([^-\s]|$)/mg, '$1\u2013$2');
	        }
	
	        token.content = text;
	      }
	    }
	  }
	};


/***/ }),

/***/ 1108:
/***/ (function(module, exports) {

	// Convert straight quotation marks to typographic ones
	//
	'use strict';
	
	
	var QUOTE_TEST_RE = /['"]/;
	var QUOTE_RE = /['"]/g;
	var PUNCT_RE = /[-\s()\[\]]/;
	var APOSTROPHE = '’';
	
	// This function returns true if the character at `pos`
	// could be inside a word.
	function isLetter(str, pos) {
	  if (pos < 0 || pos >= str.length) { return false; }
	  return !PUNCT_RE.test(str[pos]);
	}
	
	
	function replaceAt(str, index, ch) {
	  return str.substr(0, index) + ch + str.substr(index + 1);
	}
	
	
	module.exports = function smartquotes(state) {
	  /*eslint max-depth:0*/
	  var i, token, text, t, pos, max, thisLevel, lastSpace, nextSpace, item,
	      canOpen, canClose, j, isSingle, blkIdx, tokens,
	      stack;
	
	  if (!state.options.typographer) { return; }
	
	  stack = [];
	
	  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {
	
	    if (state.tokens[blkIdx].type !== 'inline') { continue; }
	
	    tokens = state.tokens[blkIdx].children;
	    stack.length = 0;
	
	    for (i = 0; i < tokens.length; i++) {
	      token = tokens[i];
	
	      if (token.type !== 'text' || QUOTE_TEST_RE.test(token.text)) { continue; }
	
	      thisLevel = tokens[i].level;
	
	      for (j = stack.length - 1; j >= 0; j--) {
	        if (stack[j].level <= thisLevel) { break; }
	      }
	      stack.length = j + 1;
	
	      text = token.content;
	      pos = 0;
	      max = text.length;
	
	      /*eslint no-labels:0,block-scoped-var:0*/
	      OUTER:
	      while (pos < max) {
	        QUOTE_RE.lastIndex = pos;
	        t = QUOTE_RE.exec(text);
	        if (!t) { break; }
	
	        lastSpace = !isLetter(text, t.index - 1);
	        pos = t.index + 1;
	        isSingle = (t[0] === "'");
	        nextSpace = !isLetter(text, pos);
	
	        if (!nextSpace && !lastSpace) {
	          // middle of word
	          if (isSingle) {
	            token.content = replaceAt(token.content, t.index, APOSTROPHE);
	          }
	          continue;
	        }
	
	        canOpen = !nextSpace;
	        canClose = !lastSpace;
	
	        if (canClose) {
	          // this could be a closing quote, rewind the stack to get a match
	          for (j = stack.length - 1; j >= 0; j--) {
	            item = stack[j];
	            if (stack[j].level < thisLevel) { break; }
	            if (item.single === isSingle && stack[j].level === thisLevel) {
	              item = stack[j];
	              if (isSingle) {
	                tokens[item.token].content = replaceAt(tokens[item.token].content, item.pos, state.options.quotes[2]);
	                token.content = replaceAt(token.content, t.index, state.options.quotes[3]);
	              } else {
	                tokens[item.token].content = replaceAt(tokens[item.token].content, item.pos, state.options.quotes[0]);
	                token.content = replaceAt(token.content, t.index, state.options.quotes[1]);
	              }
	              stack.length = j;
	              continue OUTER;
	            }
	          }
	        }
	
	        if (canOpen) {
	          stack.push({
	            token: i,
	            pos: t.index,
	            single: isSingle,
	            level: thisLevel
	          });
	        } else if (canClose && isSingle) {
	          token.content = replaceAt(token.content, t.index, APOSTROPHE);
	        }
	      }
	    }
	  }
	};


/***/ }),

/***/ 1109:
/***/ (function(module, exports, __webpack_require__) {

	// Process autolinks '<protocol:...>'
	
	'use strict';
	
	var url_schemas   = __webpack_require__(1077);
	var normalizeLink = __webpack_require__(151);
	
	
	/*eslint max-len:0*/
	var EMAIL_RE    = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/;
	var AUTOLINK_RE = /^<([a-zA-Z.\-]{1,25}):([^<>\x00-\x20]*)>/;
	
	
	module.exports = function autolink(state, silent) {
	  var tail, linkMatch, emailMatch, url, fullUrl, pos = state.pos;
	
	  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }
	
	  tail = state.src.slice(pos);
	
	  if (tail.indexOf('>') < 0) { return false; }
	
	  linkMatch = tail.match(AUTOLINK_RE);
	
	  if (linkMatch) {
	    if (url_schemas.indexOf(linkMatch[1].toLowerCase()) < 0) { return false; }
	
	    url = linkMatch[0].slice(1, -1);
	    fullUrl = normalizeLink(url);
	    if (!state.parser.validateLink(url)) { return false; }
	
	    if (!silent) {
	      state.push({
	        type: 'link_open',
	        href: fullUrl,
	        level: state.level
	      });
	      state.push({
	        type: 'text',
	        content: url,
	        level: state.level + 1
	      });
	      state.push({ type: 'link_close', level: state.level });
	    }
	
	    state.pos += linkMatch[0].length;
	    return true;
	  }
	
	  emailMatch = tail.match(EMAIL_RE);
	
	  if (emailMatch) {
	
	    url = emailMatch[0].slice(1, -1);
	
	    fullUrl = normalizeLink('mailto:' + url);
	    if (!state.parser.validateLink(fullUrl)) { return false; }
	
	    if (!silent) {
	      state.push({
	        type: 'link_open',
	        href: fullUrl,
	        level: state.level
	      });
	      state.push({
	        type: 'text',
	        content: url,
	        level: state.level + 1
	      });
	      state.push({ type: 'link_close', level: state.level });
	    }
	
	    state.pos += emailMatch[0].length;
	    return true;
	  }
	
	  return false;
	};


/***/ }),

/***/ 1110:
/***/ (function(module, exports) {

	// Parse backticks
	
	'use strict';
	
	module.exports = function backticks(state, silent) {
	  var start, max, marker, matchStart, matchEnd,
	      pos = state.pos,
	      ch = state.src.charCodeAt(pos);
	
	  if (ch !== 0x60/* ` */) { return false; }
	
	  start = pos;
	  pos++;
	  max = state.posMax;
	
	  while (pos < max && state.src.charCodeAt(pos) === 0x60/* ` */) { pos++; }
	
	  marker = state.src.slice(start, pos);
	
	  matchStart = matchEnd = pos;
	
	  while ((matchStart = state.src.indexOf('`', matchEnd)) !== -1) {
	    matchEnd = matchStart + 1;
	
	    while (matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60/* ` */) { matchEnd++; }
	
	    if (matchEnd - matchStart === marker.length) {
	      if (!silent) {
	        state.push({
	          type: 'code',
	          content: state.src.slice(pos, matchStart)
	                              .replace(/[ \n]+/g, ' ')
	                              .trim(),
	          block: false,
	          level: state.level
	        });
	      }
	      state.pos = matchEnd;
	      return true;
	    }
	  }
	
	  if (!silent) { state.pending += marker; }
	  state.pos += marker.length;
	  return true;
	};


/***/ }),

/***/ 1111:
/***/ (function(module, exports) {

	// Process ~~deleted text~~
	
	'use strict';
	
	module.exports = function del(state, silent) {
	  var found,
	      pos,
	      stack,
	      max = state.posMax,
	      start = state.pos,
	      lastChar,
	      nextChar;
	
	  if (state.src.charCodeAt(start) !== 0x7E/* ~ */) { return false; }
	  if (silent) { return false; } // don't run any pairs in validation mode
	  if (start + 4 >= max) { return false; }
	  if (state.src.charCodeAt(start + 1) !== 0x7E/* ~ */) { return false; }
	  if (state.level >= state.options.maxNesting) { return false; }
	
	  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
	  nextChar = state.src.charCodeAt(start + 2);
	
	  if (lastChar === 0x7E/* ~ */) { return false; }
	  if (nextChar === 0x7E/* ~ */) { return false; }
	  if (nextChar === 0x20 || nextChar === 0x0A) { return false; }
	
	  pos = start + 2;
	  while (pos < max && state.src.charCodeAt(pos) === 0x7E/* ~ */) { pos++; }
	  if (pos > start + 3) {
	    // sequence of 4+ markers taking as literal, same as in a emphasis
	    state.pos += pos - start;
	    if (!silent) { state.pending += state.src.slice(start, pos); }
	    return true;
	  }
	
	  state.pos = start + 2;
	  stack = 1;
	
	  while (state.pos + 1 < max) {
	    if (state.src.charCodeAt(state.pos) === 0x7E/* ~ */) {
	      if (state.src.charCodeAt(state.pos + 1) === 0x7E/* ~ */) {
	        lastChar = state.src.charCodeAt(state.pos - 1);
	        nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
	        if (nextChar !== 0x7E/* ~ */ && lastChar !== 0x7E/* ~ */) {
	          if (lastChar !== 0x20 && lastChar !== 0x0A) {
	            // closing '~~'
	            stack--;
	          } else if (nextChar !== 0x20 && nextChar !== 0x0A) {
	            // opening '~~'
	            stack++;
	          } // else {
	            //  // standalone ' ~~ ' indented with spaces
	            // }
	          if (stack <= 0) {
	            found = true;
	            break;
	          }
	        }
	      }
	    }
	
	    state.parser.skipToken(state);
	  }
	
	  if (!found) {
	    // parser failed to find ending tag, so it's not valid emphasis
	    state.pos = start;
	    return false;
	  }
	
	  // found!
	  state.posMax = state.pos;
	  state.pos = start + 2;
	
	  if (!silent) {
	    state.push({ type: 'del_open', level: state.level++ });
	    state.parser.tokenize(state);
	    state.push({ type: 'del_close', level: --state.level });
	  }
	
	  state.pos = state.posMax + 2;
	  state.posMax = max;
	  return true;
	};


/***/ }),

/***/ 1112:
/***/ (function(module, exports) {

	// Process *this* and _that_
	
	'use strict';
	
	
	function isAlphaNum(code) {
	  return (code >= 0x30 /* 0 */ && code <= 0x39 /* 9 */) ||
	         (code >= 0x41 /* A */ && code <= 0x5A /* Z */) ||
	         (code >= 0x61 /* a */ && code <= 0x7A /* z */);
	}
	
	// parse sequence of emphasis markers,
	// "start" should point at a valid marker
	function scanDelims(state, start) {
	  var pos = start, lastChar, nextChar, count,
	      can_open = true,
	      can_close = true,
	      max = state.posMax,
	      marker = state.src.charCodeAt(start);
	
	  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
	
	  while (pos < max && state.src.charCodeAt(pos) === marker) { pos++; }
	  if (pos >= max) { can_open = false; }
	  count = pos - start;
	
	  if (count >= 4) {
	    // sequence of four or more unescaped markers can't start/end an emphasis
	    can_open = can_close = false;
	  } else {
	    nextChar = pos < max ? state.src.charCodeAt(pos) : -1;
	
	    // check whitespace conditions
	    if (nextChar === 0x20 || nextChar === 0x0A) { can_open = false; }
	    if (lastChar === 0x20 || lastChar === 0x0A) { can_close = false; }
	
	    if (marker === 0x5F /* _ */) {
	      // check if we aren't inside the word
	      if (isAlphaNum(lastChar)) { can_open = false; }
	      if (isAlphaNum(nextChar)) { can_close = false; }
	    }
	  }
	
	  return {
	    can_open: can_open,
	    can_close: can_close,
	    delims: count
	  };
	}
	
	module.exports = function emphasis(state, silent) {
	  var startCount,
	      count,
	      found,
	      oldCount,
	      newCount,
	      stack,
	      res,
	      max = state.posMax,
	      start = state.pos,
	      marker = state.src.charCodeAt(start);
	
	  if (marker !== 0x5F/* _ */ && marker !== 0x2A /* * */) { return false; }
	  if (silent) { return false; } // don't run any pairs in validation mode
	
	  res = scanDelims(state, start);
	  startCount = res.delims;
	  if (!res.can_open) {
	    state.pos += startCount;
	    if (!silent) { state.pending += state.src.slice(start, state.pos); }
	    return true;
	  }
	
	  if (state.level >= state.options.maxNesting) { return false; }
	
	  state.pos = start + startCount;
	  stack = [ startCount ];
	
	  while (state.pos < max) {
	    if (state.src.charCodeAt(state.pos) === marker) {
	      res = scanDelims(state, state.pos);
	      count = res.delims;
	      if (res.can_close) {
	        oldCount = stack.pop();
	        newCount = count;
	
	        while (oldCount !== newCount) {
	          if (newCount < oldCount) {
	            stack.push(oldCount - newCount);
	            break;
	          }
	
	          // assert(newCount > oldCount)
	          newCount -= oldCount;
	
	          if (stack.length === 0) { break; }
	          state.pos += oldCount;
	          oldCount = stack.pop();
	        }
	
	        if (stack.length === 0) {
	          startCount = oldCount;
	          found = true;
	          break;
	        }
	        state.pos += count;
	        continue;
	      }
	
	      if (res.can_open) { stack.push(count); }
	      state.pos += count;
	      continue;
	    }
	
	    state.parser.skipToken(state);
	  }
	
	  if (!found) {
	    // parser failed to find ending tag, so it's not valid emphasis
	    state.pos = start;
	    return false;
	  }
	
	  // found!
	  state.posMax = state.pos;
	  state.pos = start + startCount;
	
	  if (!silent) {
	    if (startCount === 2 || startCount === 3) {
	      state.push({ type: 'strong_open', level: state.level++ });
	    }
	    if (startCount === 1 || startCount === 3) {
	      state.push({ type: 'em_open', level: state.level++ });
	    }
	
	    state.parser.tokenize(state);
	
	    if (startCount === 1 || startCount === 3) {
	      state.push({ type: 'em_close', level: --state.level });
	    }
	    if (startCount === 2 || startCount === 3) {
	      state.push({ type: 'strong_close', level: --state.level });
	    }
	  }
	
	  state.pos = state.posMax + startCount;
	  state.posMax = max;
	  return true;
	};


/***/ }),

/***/ 1113:
/***/ (function(module, exports, __webpack_require__) {

	// Process html entity - &#123;, &#xAF;, &quot;, ...
	
	'use strict';
	
	var entities          = __webpack_require__(150);
	var has               = __webpack_require__(6).has;
	var isValidEntityCode = __webpack_require__(6).isValidEntityCode;
	var fromCodePoint     = __webpack_require__(6).fromCodePoint;
	
	
	var DIGITAL_RE = /^&#((?:x[a-f0-9]{1,8}|[0-9]{1,8}));/i;
	var NAMED_RE   = /^&([a-z][a-z0-9]{1,31});/i;
	
	
	module.exports = function entity(state, silent) {
	  var ch, code, match, pos = state.pos, max = state.posMax;
	
	  if (state.src.charCodeAt(pos) !== 0x26/* & */) { return false; }
	
	  if (pos + 1 < max) {
	    ch = state.src.charCodeAt(pos + 1);
	
	    if (ch === 0x23 /* # */) {
	      match = state.src.slice(pos).match(DIGITAL_RE);
	      if (match) {
	        if (!silent) {
	          code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
	          state.pending += isValidEntityCode(code) ? fromCodePoint(code) : fromCodePoint(0xFFFD);
	        }
	        state.pos += match[0].length;
	        return true;
	      }
	    } else {
	      match = state.src.slice(pos).match(NAMED_RE);
	      if (match) {
	        if (has(entities, match[1])) {
	          if (!silent) { state.pending += entities[match[1]]; }
	          state.pos += match[0].length;
	          return true;
	        }
	      }
	    }
	  }
	
	  if (!silent) { state.pending += '&'; }
	  state.pos++;
	  return true;
	};


/***/ }),

/***/ 1114:
/***/ (function(module, exports) {

	// Proceess escaped chars and hardbreaks
	
	'use strict';
	
	var ESCAPED = [];
	
	for (var i = 0; i < 256; i++) { ESCAPED.push(0); }
	
	'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'
	  .split('').forEach(function(ch) { ESCAPED[ch.charCodeAt(0)] = 1; });
	
	
	module.exports = function escape(state, silent) {
	  var ch, pos = state.pos, max = state.posMax;
	
	  if (state.src.charCodeAt(pos) !== 0x5C/* \ */) { return false; }
	
	  pos++;
	
	  if (pos < max) {
	    ch = state.src.charCodeAt(pos);
	
	    if (ch < 256 && ESCAPED[ch] !== 0) {
	      if (!silent) { state.pending += state.src[pos]; }
	      state.pos += 2;
	      return true;
	    }
	
	    if (ch === 0x0A) {
	      if (!silent) {
	        state.push({
	          type: 'hardbreak',
	          level: state.level
	        });
	      }
	
	      pos++;
	      // skip leading whitespaces from next line
	      while (pos < max && state.src.charCodeAt(pos) === 0x20) { pos++; }
	
	      state.pos = pos;
	      return true;
	    }
	  }
	
	  if (!silent) { state.pending += '\\'; }
	  state.pos++;
	  return true;
	};


/***/ }),

/***/ 1115:
/***/ (function(module, exports, __webpack_require__) {

	// Process inline footnotes (^[...])
	
	'use strict';
	
	var parseLinkLabel = __webpack_require__(64);
	
	
	module.exports = function footnote_inline(state, silent) {
	  var labelStart,
	      labelEnd,
	      footnoteId,
	      oldLength,
	      max = state.posMax,
	      start = state.pos;
	
	  if (start + 2 >= max) { return false; }
	  if (state.src.charCodeAt(start) !== 0x5E/* ^ */) { return false; }
	  if (state.src.charCodeAt(start + 1) !== 0x5B/* [ */) { return false; }
	  if (state.level >= state.options.maxNesting) { return false; }
	
	  labelStart = start + 2;
	  labelEnd = parseLinkLabel(state, start + 1);
	
	  // parser failed to find ']', so it's not a valid note
	  if (labelEnd < 0) { return false; }
	
	  // We found the end of the link, and know for a fact it's a valid link;
	  // so all that's left to do is to call tokenizer.
	  //
	  if (!silent) {
	    if (!state.env.footnotes) { state.env.footnotes = {}; }
	    if (!state.env.footnotes.list) { state.env.footnotes.list = []; }
	    footnoteId = state.env.footnotes.list.length;
	
	    state.pos = labelStart;
	    state.posMax = labelEnd;
	
	    state.push({
	      type: 'footnote_ref',
	      id: footnoteId,
	      level: state.level
	    });
	    state.linkLevel++;
	    oldLength = state.tokens.length;
	    state.parser.tokenize(state);
	    state.env.footnotes.list[footnoteId] = { tokens: state.tokens.splice(oldLength) };
	    state.linkLevel--;
	  }
	
	  state.pos = labelEnd + 1;
	  state.posMax = max;
	  return true;
	};


/***/ }),

/***/ 1116:
/***/ (function(module, exports) {

	// Process footnote references ([^...])
	
	'use strict';
	
	
	module.exports = function footnote_ref(state, silent) {
	  var label,
	      pos,
	      footnoteId,
	      footnoteSubId,
	      max = state.posMax,
	      start = state.pos;
	
	  // should be at least 4 chars - "[^x]"
	  if (start + 3 > max) { return false; }
	
	  if (!state.env.footnotes || !state.env.footnotes.refs) { return false; }
	  if (state.src.charCodeAt(start) !== 0x5B/* [ */) { return false; }
	  if (state.src.charCodeAt(start + 1) !== 0x5E/* ^ */) { return false; }
	  if (state.level >= state.options.maxNesting) { return false; }
	
	  for (pos = start + 2; pos < max; pos++) {
	    if (state.src.charCodeAt(pos) === 0x20) { return false; }
	    if (state.src.charCodeAt(pos) === 0x0A) { return false; }
	    if (state.src.charCodeAt(pos) === 0x5D /* ] */) {
	      break;
	    }
	  }
	
	  if (pos === start + 2) { return false; } // no empty footnote labels
	  if (pos >= max) { return false; }
	  pos++;
	
	  label = state.src.slice(start + 2, pos - 1);
	  if (typeof state.env.footnotes.refs[':' + label] === 'undefined') { return false; }
	
	  if (!silent) {
	    if (!state.env.footnotes.list) { state.env.footnotes.list = []; }
	
	    if (state.env.footnotes.refs[':' + label] < 0) {
	      footnoteId = state.env.footnotes.list.length;
	      state.env.footnotes.list[footnoteId] = { label: label, count: 0 };
	      state.env.footnotes.refs[':' + label] = footnoteId;
	    } else {
	      footnoteId = state.env.footnotes.refs[':' + label];
	    }
	
	    footnoteSubId = state.env.footnotes.list[footnoteId].count;
	    state.env.footnotes.list[footnoteId].count++;
	
	    state.push({
	      type: 'footnote_ref',
	      id: footnoteId,
	      subId: footnoteSubId,
	      level: state.level
	    });
	  }
	
	  state.pos = pos;
	  state.posMax = max;
	  return true;
	};


/***/ }),

/***/ 1117:
/***/ (function(module, exports, __webpack_require__) {

	// Process html tags
	
	'use strict';
	
	
	var HTML_TAG_RE = __webpack_require__(1076).HTML_TAG_RE;
	
	
	function isLetter(ch) {
	  /*eslint no-bitwise:0*/
	  var lc = ch | 0x20; // to lower case
	  return (lc >= 0x61/* a */) && (lc <= 0x7a/* z */);
	}
	
	
	module.exports = function htmltag(state, silent) {
	  var ch, match, max, pos = state.pos;
	
	  if (!state.options.html) { return false; }
	
	  // Check start
	  max = state.posMax;
	  if (state.src.charCodeAt(pos) !== 0x3C/* < */ ||
	      pos + 2 >= max) {
	    return false;
	  }
	
	  // Quick fail on second char
	  ch = state.src.charCodeAt(pos + 1);
	  if (ch !== 0x21/* ! */ &&
	      ch !== 0x3F/* ? */ &&
	      ch !== 0x2F/* / */ &&
	      !isLetter(ch)) {
	    return false;
	  }
	
	  match = state.src.slice(pos).match(HTML_TAG_RE);
	  if (!match) { return false; }
	
	  if (!silent) {
	    state.push({
	      type: 'htmltag',
	      content: state.src.slice(pos, pos + match[0].length),
	      level: state.level
	    });
	  }
	  state.pos += match[0].length;
	  return true;
	};


/***/ }),

/***/ 1118:
/***/ (function(module, exports) {

	// Process ++inserted text++
	
	'use strict';
	
	module.exports = function ins(state, silent) {
	  var found,
	      pos,
	      stack,
	      max = state.posMax,
	      start = state.pos,
	      lastChar,
	      nextChar;
	
	  if (state.src.charCodeAt(start) !== 0x2B/* + */) { return false; }
	  if (silent) { return false; } // don't run any pairs in validation mode
	  if (start + 4 >= max) { return false; }
	  if (state.src.charCodeAt(start + 1) !== 0x2B/* + */) { return false; }
	  if (state.level >= state.options.maxNesting) { return false; }
	
	  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
	  nextChar = state.src.charCodeAt(start + 2);
	
	  if (lastChar === 0x2B/* + */) { return false; }
	  if (nextChar === 0x2B/* + */) { return false; }
	  if (nextChar === 0x20 || nextChar === 0x0A) { return false; }
	
	  pos = start + 2;
	  while (pos < max && state.src.charCodeAt(pos) === 0x2B/* + */) { pos++; }
	  if (pos !== start + 2) {
	    // sequence of 3+ markers taking as literal, same as in a emphasis
	    state.pos += pos - start;
	    if (!silent) { state.pending += state.src.slice(start, pos); }
	    return true;
	  }
	
	  state.pos = start + 2;
	  stack = 1;
	
	  while (state.pos + 1 < max) {
	    if (state.src.charCodeAt(state.pos) === 0x2B/* + */) {
	      if (state.src.charCodeAt(state.pos + 1) === 0x2B/* + */) {
	        lastChar = state.src.charCodeAt(state.pos - 1);
	        nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
	        if (nextChar !== 0x2B/* + */ && lastChar !== 0x2B/* + */) {
	          if (lastChar !== 0x20 && lastChar !== 0x0A) {
	            // closing '++'
	            stack--;
	          } else if (nextChar !== 0x20 && nextChar !== 0x0A) {
	            // opening '++'
	            stack++;
	          } // else {
	            //  // standalone ' ++ ' indented with spaces
	            // }
	          if (stack <= 0) {
	            found = true;
	            break;
	          }
	        }
	      }
	    }
	
	    state.parser.skipToken(state);
	  }
	
	  if (!found) {
	    // parser failed to find ending tag, so it's not valid emphasis
	    state.pos = start;
	    return false;
	  }
	
	  // found!
	  state.posMax = state.pos;
	  state.pos = start + 2;
	
	  if (!silent) {
	    state.push({ type: 'ins_open', level: state.level++ });
	    state.parser.tokenize(state);
	    state.push({ type: 'ins_close', level: --state.level });
	  }
	
	  state.pos = state.posMax + 2;
	  state.posMax = max;
	  return true;
	};


/***/ }),

/***/ 1119:
/***/ (function(module, exports, __webpack_require__) {

	// Process [links](<to> "stuff")
	
	'use strict';
	
	var parseLinkLabel       = __webpack_require__(64);
	var parseLinkDestination = __webpack_require__(153);
	var parseLinkTitle       = __webpack_require__(154);
	var normalizeReference   = __webpack_require__(152);
	
	
	module.exports = function links(state, silent) {
	  var labelStart,
	      labelEnd,
	      label,
	      href,
	      title,
	      pos,
	      ref,
	      code,
	      isImage = false,
	      oldPos = state.pos,
	      max = state.posMax,
	      start = state.pos,
	      marker = state.src.charCodeAt(start);
	
	  if (marker === 0x21/* ! */) {
	    isImage = true;
	    marker = state.src.charCodeAt(++start);
	  }
	
	  if (marker !== 0x5B/* [ */) { return false; }
	  if (state.level >= state.options.maxNesting) { return false; }
	
	  labelStart = start + 1;
	  labelEnd = parseLinkLabel(state, start);
	
	  // parser failed to find ']', so it's not a valid link
	  if (labelEnd < 0) { return false; }
	
	  pos = labelEnd + 1;
	  if (pos < max && state.src.charCodeAt(pos) === 0x28/* ( */) {
	    //
	    // Inline link
	    //
	
	    // [link](  <href>  "title"  )
	    //        ^^ skipping these spaces
	    pos++;
	    for (; pos < max; pos++) {
	      code = state.src.charCodeAt(pos);
	      if (code !== 0x20 && code !== 0x0A) { break; }
	    }
	    if (pos >= max) { return false; }
	
	    // [link](  <href>  "title"  )
	    //          ^^^^^^ parsing link destination
	    start = pos;
	    if (parseLinkDestination(state, pos)) {
	      href = state.linkContent;
	      pos = state.pos;
	    } else {
	      href = '';
	    }
	
	    // [link](  <href>  "title"  )
	    //                ^^ skipping these spaces
	    start = pos;
	    for (; pos < max; pos++) {
	      code = state.src.charCodeAt(pos);
	      if (code !== 0x20 && code !== 0x0A) { break; }
	    }
	
	    // [link](  <href>  "title"  )
	    //                  ^^^^^^^ parsing link title
	    if (pos < max && start !== pos && parseLinkTitle(state, pos)) {
	      title = state.linkContent;
	      pos = state.pos;
	
	      // [link](  <href>  "title"  )
	      //                         ^^ skipping these spaces
	      for (; pos < max; pos++) {
	        code = state.src.charCodeAt(pos);
	        if (code !== 0x20 && code !== 0x0A) { break; }
	      }
	    } else {
	      title = '';
	    }
	
	    if (pos >= max || state.src.charCodeAt(pos) !== 0x29/* ) */) {
	      state.pos = oldPos;
	      return false;
	    }
	    pos++;
	  } else {
	    //
	    // Link reference
	    //
	
	    // do not allow nested reference links
	    if (state.linkLevel > 0) { return false; }
	
	    // [foo]  [bar]
	    //      ^^ optional whitespace (can include newlines)
	    for (; pos < max; pos++) {
	      code = state.src.charCodeAt(pos);
	      if (code !== 0x20 && code !== 0x0A) { break; }
	    }
	
	    if (pos < max && state.src.charCodeAt(pos) === 0x5B/* [ */) {
	      start = pos + 1;
	      pos = parseLinkLabel(state, pos);
	      if (pos >= 0) {
	        label = state.src.slice(start, pos++);
	      } else {
	        pos = start - 1;
	      }
	    }
	
	    // covers label === '' and label === undefined
	    // (collapsed reference link and shortcut reference link respectively)
	    if (!label) {
	      if (typeof label === 'undefined') {
	        pos = labelEnd + 1;
	      }
	      label = state.src.slice(labelStart, labelEnd);
	    }
	
	    ref = state.env.references[normalizeReference(label)];
	    if (!ref) {
	      state.pos = oldPos;
	      return false;
	    }
	    href = ref.href;
	    title = ref.title;
	  }
	
	  //
	  // We found the end of the link, and know for a fact it's a valid link;
	  // so all that's left to do is to call tokenizer.
	  //
	  if (!silent) {
	    state.pos = labelStart;
	    state.posMax = labelEnd;
	
	    if (isImage) {
	      state.push({
	        type: 'image',
	        src: href,
	        title: title,
	        alt: state.src.substr(labelStart, labelEnd - labelStart),
	        level: state.level
	      });
	    } else {
	      state.push({
	        type: 'link_open',
	        href: href,
	        title: title,
	        level: state.level++
	      });
	      state.linkLevel++;
	      state.parser.tokenize(state);
	      state.linkLevel--;
	      state.push({ type: 'link_close', level: --state.level });
	    }
	  }
	
	  state.pos = pos;
	  state.posMax = max;
	  return true;
	};


/***/ }),

/***/ 1120:
/***/ (function(module, exports) {

	// Process ==highlighted text==
	
	'use strict';
	
	module.exports = function del(state, silent) {
	  var found,
	      pos,
	      stack,
	      max = state.posMax,
	      start = state.pos,
	      lastChar,
	      nextChar;
	
	  if (state.src.charCodeAt(start) !== 0x3D/* = */) { return false; }
	  if (silent) { return false; } // don't run any pairs in validation mode
	  if (start + 4 >= max) { return false; }
	  if (state.src.charCodeAt(start + 1) !== 0x3D/* = */) { return false; }
	  if (state.level >= state.options.maxNesting) { return false; }
	
	  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
	  nextChar = state.src.charCodeAt(start + 2);
	
	  if (lastChar === 0x3D/* = */) { return false; }
	  if (nextChar === 0x3D/* = */) { return false; }
	  if (nextChar === 0x20 || nextChar === 0x0A) { return false; }
	
	  pos = start + 2;
	  while (pos < max && state.src.charCodeAt(pos) === 0x3D/* = */) { pos++; }
	  if (pos !== start + 2) {
	    // sequence of 3+ markers taking as literal, same as in a emphasis
	    state.pos += pos - start;
	    if (!silent) { state.pending += state.src.slice(start, pos); }
	    return true;
	  }
	
	  state.pos = start + 2;
	  stack = 1;
	
	  while (state.pos + 1 < max) {
	    if (state.src.charCodeAt(state.pos) === 0x3D/* = */) {
	      if (state.src.charCodeAt(state.pos + 1) === 0x3D/* = */) {
	        lastChar = state.src.charCodeAt(state.pos - 1);
	        nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
	        if (nextChar !== 0x3D/* = */ && lastChar !== 0x3D/* = */) {
	          if (lastChar !== 0x20 && lastChar !== 0x0A) {
	            // closing '=='
	            stack--;
	          } else if (nextChar !== 0x20 && nextChar !== 0x0A) {
	            // opening '=='
	            stack++;
	          } // else {
	            //  // standalone ' == ' indented with spaces
	            // }
	          if (stack <= 0) {
	            found = true;
	            break;
	          }
	        }
	      }
	    }
	
	    state.parser.skipToken(state);
	  }
	
	  if (!found) {
	    // parser failed to find ending tag, so it's not valid emphasis
	    state.pos = start;
	    return false;
	  }
	
	  // found!
	  state.posMax = state.pos;
	  state.pos = start + 2;
	
	  if (!silent) {
	    state.push({ type: 'mark_open', level: state.level++ });
	    state.parser.tokenize(state);
	    state.push({ type: 'mark_close', level: --state.level });
	  }
	
	  state.pos = state.posMax + 2;
	  state.posMax = max;
	  return true;
	};


/***/ }),

/***/ 1121:
/***/ (function(module, exports) {

	// Proceess '\n'
	
	'use strict';
	
	module.exports = function newline(state, silent) {
	  var pmax, max, pos = state.pos;
	
	  if (state.src.charCodeAt(pos) !== 0x0A/* \n */) { return false; }
	
	  pmax = state.pending.length - 1;
	  max = state.posMax;
	
	  // '  \n' -> hardbreak
	  // Lookup in pending chars is bad practice! Don't copy to other rules!
	  // Pending string is stored in concat mode, indexed lookups will cause
	  // convertion to flat mode.
	  if (!silent) {
	    if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
	      if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
	        // Strip out all trailing spaces on this line.
	        for (var i = pmax - 2; i >= 0; i--) {
	          if (state.pending.charCodeAt(i) !== 0x20) {
	            state.pending = state.pending.substring(0, i + 1);
	            break;
	          }
	        }
	        state.push({
	          type: 'hardbreak',
	          level: state.level
	        });
	      } else {
	        state.pending = state.pending.slice(0, -1);
	        state.push({
	          type: 'softbreak',
	          level: state.level
	        });
	      }
	
	    } else {
	      state.push({
	        type: 'softbreak',
	        level: state.level
	      });
	    }
	  }
	
	  pos++;
	
	  // skip heading spaces for next line
	  while (pos < max && state.src.charCodeAt(pos) === 0x20) { pos++; }
	
	  state.pos = pos;
	  return true;
	};


/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	// Inline parser state
	
	'use strict';
	
	function StateInline(src, parserInline, options, env, outTokens) {
	  this.src = src;
	  this.env = env;
	  this.options = options;
	  this.parser = parserInline;
	  this.tokens = outTokens;
	  this.pos = 0;
	  this.posMax = this.src.length;
	  this.level = 0;
	  this.pending = '';
	  this.pendingLevel = 0;
	
	  this.cache = [];        // Stores { start: end } pairs. Useful for backtrack
	                          // optimization of pairs parse (emphasis, strikes).
	
	  // Link parser state vars
	
	  this.isInLabel = false; // Set true when seek link label - we should disable
	                          // "paired" rules (emphasis, strikes) to not skip
	                          // tailing `]`
	
	  this.linkLevel = 0;     // Increment for each nesting link. Used to prevent
	                          // nesting in definitions
	
	  this.linkContent = '';  // Temporary storage for link url
	
	  this.labelUnmatchedScopes = 0; // Track unpaired `[` for link labels
	                                 // (backtrack optimization)
	}
	
	// Flush pending text
	//
	StateInline.prototype.pushPending = function () {
	  this.tokens.push({
	    type: 'text',
	    content: this.pending,
	    level: this.pendingLevel
	  });
	  this.pending = '';
	};
	
	// Push new token to "stream".
	// If pending text exists - flush it as text token
	//
	StateInline.prototype.push = function (token) {
	  if (this.pending) {
	    this.pushPending();
	  }
	
	  this.tokens.push(token);
	  this.pendingLevel = this.level;
	};
	
	// Store value to cache.
	// !!! Implementation has parser-specific optimizations
	// !!! keys MUST be integer, >= 0; values MUST be integer, > 0
	//
	StateInline.prototype.cacheSet = function (key, val) {
	  for (var i = this.cache.length; i <= key; i++) {
	    this.cache.push(0);
	  }
	
	  this.cache[key] = val;
	};
	
	// Get cache value
	//
	StateInline.prototype.cacheGet = function (key) {
	  return key < this.cache.length ? this.cache[key] : 0;
	};
	
	module.exports = StateInline;


/***/ }),

/***/ 1122:
/***/ (function(module, exports) {

	// Process ~subscript~
	
	'use strict';
	
	// same as UNESCAPE_MD_RE plus a space
	var UNESCAPE_RE = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
	
	module.exports = function sub(state, silent) {
	  var found,
	      content,
	      max = state.posMax,
	      start = state.pos;
	
	  if (state.src.charCodeAt(start) !== 0x7E/* ~ */) { return false; }
	  if (silent) { return false; } // don't run any pairs in validation mode
	  if (start + 2 >= max) { return false; }
	  if (state.level >= state.options.maxNesting) { return false; }
	
	  state.pos = start + 1;
	
	  while (state.pos < max) {
	    if (state.src.charCodeAt(state.pos) === 0x7E/* ~ */) {
	      found = true;
	      break;
	    }
	
	    state.parser.skipToken(state);
	  }
	
	  if (!found || start + 1 === state.pos) {
	    state.pos = start;
	    return false;
	  }
	
	  content = state.src.slice(start + 1, state.pos);
	
	  // don't allow unescaped spaces/newlines inside
	  if (content.match(/(^|[^\\])(\\\\)*\s/)) {
	    state.pos = start;
	    return false;
	  }
	
	  // found!
	  state.posMax = state.pos;
	  state.pos = start + 1;
	
	  if (!silent) {
	    state.push({
	      type: 'sub',
	      level: state.level,
	      content: content.replace(UNESCAPE_RE, '$1')
	    });
	  }
	
	  state.pos = state.posMax + 1;
	  state.posMax = max;
	  return true;
	};


/***/ }),

/***/ 1123:
/***/ (function(module, exports) {

	// Process ^superscript^
	
	'use strict';
	
	// same as UNESCAPE_MD_RE plus a space
	var UNESCAPE_RE = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
	
	module.exports = function sup(state, silent) {
	  var found,
	      content,
	      max = state.posMax,
	      start = state.pos;
	
	  if (state.src.charCodeAt(start) !== 0x5E/* ^ */) { return false; }
	  if (silent) { return false; } // don't run any pairs in validation mode
	  if (start + 2 >= max) { return false; }
	  if (state.level >= state.options.maxNesting) { return false; }
	
	  state.pos = start + 1;
	
	  while (state.pos < max) {
	    if (state.src.charCodeAt(state.pos) === 0x5E/* ^ */) {
	      found = true;
	      break;
	    }
	
	    state.parser.skipToken(state);
	  }
	
	  if (!found || start + 1 === state.pos) {
	    state.pos = start;
	    return false;
	  }
	
	  content = state.src.slice(start + 1, state.pos);
	
	  // don't allow unescaped spaces/newlines inside
	  if (content.match(/(^|[^\\])(\\\\)*\s/)) {
	    state.pos = start;
	    return false;
	  }
	
	  // found!
	  state.posMax = state.pos;
	  state.pos = start + 1;
	
	  if (!silent) {
	    state.push({
	      type: 'sup',
	      level: state.level,
	      content: content.replace(UNESCAPE_RE, '$1')
	    });
	  }
	
	  state.pos = state.posMax + 1;
	  state.posMax = max;
	  return true;
	};


/***/ }),

/***/ 1124:
/***/ (function(module, exports) {

	// Skip text characters for text token, place those to pending buffer
	// and increment current pos
	
	'use strict';
	
	// Rule to skip pure text
	// '{}$%@~+=:' reserved for extentions
	
	function isTerminatorChar(ch) {
	  switch (ch) {
	    case 0x0A/* \n */:
	    case 0x5C/* \ */:
	    case 0x60/* ` */:
	    case 0x2A/* * */:
	    case 0x5F/* _ */:
	    case 0x5E/* ^ */:
	    case 0x5B/* [ */:
	    case 0x5D/* ] */:
	    case 0x21/* ! */:
	    case 0x26/* & */:
	    case 0x3C/* < */:
	    case 0x3E/* > */:
	    case 0x7B/* { */:
	    case 0x7D/* } */:
	    case 0x24/* $ */:
	    case 0x25/* % */:
	    case 0x40/* @ */:
	    case 0x7E/* ~ */:
	    case 0x2B/* + */:
	    case 0x3D/* = */:
	    case 0x3A/* : */:
	      return true;
	    default:
	      return false;
	  }
	}
	
	module.exports = function text(state, silent) {
	  var pos = state.pos;
	
	  while (pos < state.posMax && !isTerminatorChar(state.src.charCodeAt(pos))) {
	    pos++;
	  }
	
	  if (pos === state.pos) { return false; }
	
	  if (!silent) { state.pending += state.src.slice(state.pos, pos); }
	
	  state.pos = pos;
	
	  return true;
	};


/***/ }),

/***/ 1136:
/***/ (function(module, exports) {

	'use strict';
	
	var cache;
	
	/**
	 * Convert HTML entities to HTML characters.
	 *
	 * @param  {String} `str` String with HTML entities to un-escape.
	 * @return {String}
	 */
	
	var unescape = module.exports = function(str) {
	  if (str == null) return '';
	
	  var re = cache || (cache = new RegExp('(' + Object.keys(chars).join('|') + ')', 'g'));
	  return String(str).replace(re, function(match) {
	    return chars[match];
	  });
	};
	
	var chars = unescape.chars = {
	  '&apos;': '\'',
	  '&#39;': '\'',
	  '&amp;': '&',
	  '&gt;': '>',
	  '&lt;': '<',
	  '&quot;': '"'
	};


/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _style, _primaryStyle;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                              *
	                                                                                                                                                                                                                              * @emails react-core
	                                                                                                                                                                                                                              */
	
	var ArrowSvg = function ArrowSvg(_ref) {
	  var _ref$cssProps = _ref.cssProps,
	      cssProps = _ref$cssProps === undefined ? {} : _ref$cssProps;
	  return Glamor.createElement(
	    'svg',
	    {
	      css: cssProps,
	      height: '12',
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 4.53657 8.69699' },
	    Glamor.createElement('path', {
	      d: '\n        M.18254,8.697a.18149.18149,0,0,1-.12886-.31034L4.09723,4.34126.05369.29954a.18149.18149,\n        0,0,1,.2559-.2559L4.4838,4.21785a.18149.18149,0,0,1,0,.2559L.30958,8.648A.18149.18149,\n        0,0,1,.18254,8.697Z\n      ',
	      fill: 'currentColor'
	    })
	  );
	};
	
	var ButtonLink = function ButtonLink(_ref2) {
	  var children = _ref2.children,
	      type = _ref2.type,
	      rest = _objectWithoutProperties(_ref2, ['children', 'type']);
	
	  var typeStyle = void 0;
	  switch (type) {
	    case 'primary':
	      typeStyle = primaryStyle;
	      break;
	    case 'secondary':
	      typeStyle = secondaryStyle;
	      break;
	  }
	
	  return Glamor.createElement(
	    _gatsbyLink2.default,
	    _extends({}, rest, { css: [style, typeStyle] }),
	    children,
	    type === 'secondary' && Glamor.createElement(ArrowSvg, { cssProps: { marginLeft: 10 } })
	  );
	};
	
	var style = (_style = {
	  display: 'inline-block',
	  fontSize: 16
	
	}, _style[_theme.media.greaterThan('xlarge')] = {
	  fontSize: 20
	}, _style);
	
	var primaryStyle = (_primaryStyle = {
	  backgroundColor: _theme.colors.brand,
	  color: _theme.colors.black,
	  padding: '10px 25px',
	  whiteSpace: 'nowrap',
	  transition: 'background-color 0.2s ease-out'
	
	}, _primaryStyle[_theme.media.greaterThan('xlarge')] = {
	  paddingTop: 15,
	  paddingBottom: 15
	}, _primaryStyle[':hover'] = {
	  backgroundColor: _theme.colors.white
	}, _primaryStyle);
	
	var secondaryStyle = {
	  color: _theme.colors.brand,
	  transition: 'color 0.2s ease-out',
	
	  ':hover': {
	    color: _theme.colors.white
	  }
	};
	
	exports.default = ButtonLink;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ButtonLink = __webpack_require__(165);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ButtonLink2.default; /**
	                                         * Copyright (c) 2013-present, Facebook, Inc.
	                                         *
	                                         * @emails react-core
	                                         */

	module.exports = exports['default'];

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(43);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _remarkable = __webpack_require__(1074);
	
	var _remarkable2 = _interopRequireDefault(_remarkable);
	
	var _reactLive = __webpack_require__(1046);
	
	var _theme = __webpack_require__(4);
	
	var _MetaTitle = __webpack_require__(47);
	
	var _MetaTitle2 = _interopRequireDefault(_MetaTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @emails react-core
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var compileES5 = function compileES5(code) {
	  return (// eslint-disable-next-line no-undef
	    Babel.transform(code, { presets: ['es2015', 'react'] }).code
	  );
	};
	
	// eslint-disable-next-line no-undef
	var compileES6 = function compileES6(code) {
	  return Babel.transform(code, { presets: ['react'] }).code;
	};
	
	var CodeEditor = function (_Component) {
	  _inherits(CodeEditor, _Component);
	
	  function CodeEditor(props, context) {
	    _classCallCheck(this, CodeEditor);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this._setMountRef = function (ref) {
	      _this._mountNode = ref;
	    };
	
	    _this._onChange = function (code) {
	      _this.setState(function (state) {
	        return _this._updateState(code, state.showJSX);
	      });
	    };
	
	    _this.state = _this._updateState(props.code);
	    _this.state.showJSX = true;
	    return _this;
	  }
	
	  CodeEditor.prototype.componentDidMount = function componentDidMount() {
	    // Initial render() will always be a no-op,
	    // Because the mountNode ref won't exist yet.
	    this._render();
	  };
	
	  CodeEditor.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevState.compiled !== this.state.compiled) {
	      this._render();
	    }
	  };
	
	  CodeEditor.prototype.render = function render() {
	    var _ref,
	        _p,
	        _ref2,
	        _ref3,
	        _ref4,
	        _this2 = this,
	        _ref5,
	        _ref6,
	        _ref7;
	
	    var children = this.props.children;
	    var _state = this.state,
	        compiledES6 = _state.compiledES6,
	        code = _state.code,
	        error = _state.error,
	        showBabelErrorMessage = _state.showBabelErrorMessage,
	        showJSX = _state.showJSX;
	
	
	    var errorMessage = void 0;
	    if (showBabelErrorMessage) {
	      errorMessage = Glamor.createElement(
	        'span',
	        null,
	        'Babel could not be loaded.',
	        Glamor.createElement('br', null),
	        Glamor.createElement('br', null),
	        'This can be caused by an ad blocker. If you\'re using one, consider adding reactjs.org to the whitelist so the live code examples will work.'
	      );
	    } else if (error != null) {
	      errorMessage = error.message;
	    }
	
	    return Glamor.createElement(
	      _reactLive.LiveProvider,
	      { code: showJSX ? code : compiledES6, mountStylesheet: false },
	      Glamor.createElement(
	        'div',
	        {
	          css: (_ref = {}, _ref[_theme.media.greaterThan('xlarge')] = {
	            display: 'flex',
	            flexDirection: 'row'
	          }, _ref[_theme.media.lessThan('large')] = {
	            display: 'block'
	          }, _ref) },
	        children && Glamor.createElement(
	          'div',
	          {
	            css: (_ref2 = {
	              flex: '0 0 33%'
	
	            }, _ref2[_theme.media.lessThan('xlarge')] = {
	              marginBottom: 20
	            }, _ref2['& h3'] = {
	              color: _theme.colors.dark,
	              maxWidth: '11em',
	              paddingTop: 0
	            }, _ref2['& p'] = (_p = {
	              marginTop: 15,
	              marginRight: 40,
	              lineHeight: 1.7
	
	            }, _p[_theme.media.greaterThan('xlarge')] = {
	              marginTop: 25
	            }, _p), _ref2) },
	          children
	        ),
	        Glamor.createElement(
	          'div',
	          {
	            css: (_ref3 = {}, _ref3[_theme.media.greaterThan('medium')] = {
	              flex: '0 0 67%',
	              display: 'flex',
	              alignItems: 'stretch',
	              flexDirection: 'row'
	            }, _ref3[_theme.media.lessThan('small')] = {
	              display: 'block'
	            }, _ref3) },
	          Glamor.createElement(
	            'div',
	            {
	              css: (_ref4 = {
	                flex: '0 0 70%',
	                overflow: 'hidden',
	                borderRadius: '10px 0 0 10px'
	
	              }, _ref4[_theme.media.lessThan('medium')] = {
	                borderRadius: '10px 10px 0 0'
	              }, _ref4) },
	            Glamor.createElement(
	              'div',
	              {
	                css: {
	                  padding: '0px 10px',
	                  background: _theme.colors.darker,
	                  color: _theme.colors.white
	                } },
	              Glamor.createElement(
	                _MetaTitle2.default,
	                { onDark: true },
	                'Live JSX Editor',
	                Glamor.createElement(
	                  'label',
	                  {
	                    css: {
	                      fontSize: 14,
	                      float: 'right',
	                      cursor: 'pointer'
	                    } },
	                  Glamor.createElement('input', {
	                    checked: this.state.showJSX,
	                    onChange: function onChange(event) {
	                      return _this2.setState({ showJSX: event.target.checked });
	                    },
	                    type: 'checkbox'
	                  }),
	                  ' ',
	                  'JSX?'
	                )
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              {
	                css: (_ref5 = {
	                  height: '100%',
	                  width: '100%',
	                  borderRadius: '0',
	                  maxHeight: '340px !important',
	                  marginTop: '0 !important',
	                  marginLeft: '0 !important',
	                  paddingLeft: '0 !important',
	                  marginRight: '0 !important',
	                  paddingRight: '0 !important',
	                  marginBottom: '0 !important',
	                  paddingBottom: '20px !important'
	                }, _ref5[_theme.media.lessThan('medium')] = {
	                  marginBottom: '0 !important'
	                }, _ref5['& pre.prism-code[contenteditable]'] = {
	                  outline: 0,
	                  overflow: 'auto',
	                  marginRight: '0 !important',
	                  marginBottom: '0 !important'
	                }, _ref5),
	                className: 'gatsby-highlight' },
	              Glamor.createElement(_reactLive.LiveEditor, { onChange: this._onChange })
	            )
	          ),
	          error && Glamor.createElement(
	            'div',
	            {
	              css: (_ref6 = {
	                flex: '0 0 30%',
	                overflow: 'hidden',
	                border: '1px solid ' + _theme.colors.error,
	                borderRadius: '0 10px 10px 0',
	                fontSize: 12,
	                lineHeight: 1.5
	
	              }, _ref6[_theme.media.lessThan('medium')] = {
	                borderRadius: '0 0 10px 10px'
	              }, _ref6) },
	            Glamor.createElement(
	              'div',
	              {
	                css: {
	                  padding: '0px 10px',
	                  background: _theme.colors.error,
	                  color: _theme.colors.white
	                } },
	              Glamor.createElement(
	                _MetaTitle2.default,
	                {
	                  cssProps: {
	                    color: _theme.colors.white
	                  } },
	                'Error'
	              )
	            ),
	            Glamor.createElement(
	              'pre',
	              {
	                css: {
	                  whiteSpace: 'pre-wrap',
	                  wordBreak: 'break-word',
	                  color: _theme.colors.error,
	                  padding: 10
	                } },
	              errorMessage
	            )
	          ),
	          !error && Glamor.createElement(
	            'div',
	            {
	              css: (_ref7 = {
	                flex: '0 0 30%',
	                overflow: 'hidden',
	                border: '1px solid ' + _theme.colors.divider,
	                borderRadius: '0 10px 10px 0'
	
	              }, _ref7[_theme.media.lessThan('medium')] = {
	                borderRadius: '0 0 10px 10px'
	              }, _ref7) },
	            Glamor.createElement(
	              'div',
	              {
	                css: {
	                  padding: '0 10px',
	                  backgroundColor: _theme.colors.divider
	                } },
	              Glamor.createElement(
	                _MetaTitle2.default,
	                null,
	                'Result'
	              )
	            ),
	            Glamor.createElement('div', {
	              css: {
	                padding: 10,
	                maxHeight: '340px !important',
	                overflow: 'auto',
	
	                '& input': {
	                  width: '100%',
	                  display: 'block',
	                  border: '1px solid #ccc', // TODO
	                  padding: 5
	                },
	
	                '& button': {
	                  marginTop: 10,
	                  padding: '5px 10px'
	                },
	
	                '& textarea': {
	                  width: '100%',
	                  marginTop: 10,
	                  height: 60,
	                  padding: 5
	                }
	              },
	              ref: this._setMountRef
	            })
	          )
	        )
	      )
	    );
	  };
	
	  CodeEditor.prototype._render = function _render() {
	    if (!this._mountNode) {
	      return;
	    }
	
	    var compiled = this.state.compiled;
	
	
	    try {
	      // Example code requires React, ReactDOM, and Remarkable to be within scope.
	      // It also requires a "mountNode" variable for ReactDOM.render()
	      // eslint-disable-next-line no-new-func
	      new Function('React', 'ReactDOM', 'Remarkable', 'mountNode', compiled)(_react2.default, _reactDom2.default, _remarkable2.default, this._mountNode);
	    } catch (error) {
	      console.error(error);
	
	      this.setState({
	        compiled: null,
	        error: error
	      });
	    }
	  };
	
	  CodeEditor.prototype._updateState = function _updateState(code) {
	    var showJSX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    try {
	      var newState = {
	        compiled: compileES5(code),
	        error: null
	      };
	
	      if (showJSX) {
	        newState.code = code;
	        newState.compiledES6 = compileES6(code);
	      } else {
	        newState.compiledES6 = code;
	      }
	
	      return newState;
	    } catch (error) {
	      console.error(error);
	
	      // Certain ad blockers (eg Fair AdBlocker) prevent Babel from loading.
	      // If we suspect this is the case, we can show a more helpful error.
	      var showBabelErrorMessage = !window.Babel;
	
	      return {
	        compiled: null,
	        error: error,
	        showBabelErrorMessage: showBabelErrorMessage
	      };
	    }
	  };
	
	  return CodeEditor;
	}(_react.Component);
	
	exports.default = CodeEditor;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CodeEditor = __webpack_require__(167);
	
	var _CodeEditor2 = _interopRequireDefault(_CodeEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CodeEditor2.default; /**
	                                         * Copyright (c) 2013-present, Facebook, Inc.
	                                         *
	                                         * @emails react-core
	                                         */

	module.exports = exports['default'];

/***/ }),

/***/ 1137:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjZmZmIi8+CiAgPGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _sectionStyles;
	
	var _ButtonLink = __webpack_require__(166);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	var _Container = __webpack_require__(7);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Flex = __webpack_require__(17);
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _mountCodeExample = __webpack_require__(208);
	
	var _mountCodeExample2 = _interopRequireDefault(_mountCodeExample);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TitleAndMetaTags = __webpack_require__(18);
	
	var _TitleAndMetaTags2 = _interopRequireDefault(_TitleAndMetaTags);
	
	var _theme = __webpack_require__(4);
	
	var _createOgUrl = __webpack_require__(108);
	
	var _createOgUrl2 = _interopRequireDefault(_createOgUrl);
	
	var _loadScript = __webpack_require__(207);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _siteConstants = __webpack_require__(34);
	
	var _reactDom = __webpack_require__(43);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _logoWhite = __webpack_require__(1137);
	
	var _logoWhite2 = _interopRequireDefault(_logoWhite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @emails react-core
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Home = function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home(props, context) {
	    _classCallCheck(this, Home);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    var data = props.data;
	
	
	    var code = data.code.edges.reduce(function (map, _ref) {
	      var node = _ref.node;
	
	      map[node.id] = JSON.parse(node.internal.contentDigest);
	
	      return map;
	    }, {});
	
	    var examples = data.examples.edges.map(function (_ref2) {
	      var node = _ref2.node;
	      return {
	        content: node.html,
	        id: node.fields.slug.replace(/^.+\//, '').replace('.html', ''),
	        title: node.frontmatter.title
	      };
	    });
	
	    var marketing = data.marketing.edges.map(function (_ref3) {
	      var node = _ref3.node;
	      return {
	        title: node.frontmatter.title,
	        content: node.html
	      };
	    });
	
	    _this.state = {
	      code: code,
	      examples: examples,
	      marketing: marketing
	    };
	    return _this;
	  }
	
	  Home.prototype.componentDidMount = function componentDidMount() {
	    var _state = this.state,
	        code = _state.code,
	        examples = _state.examples;
	
	
	    examples.forEach(function (_ref4) {
	      var id = _ref4.id;
	
	      renderExamplePlaceholder(id);
	    });
	
	    function mountCodeExamples() {
	      examples.forEach(function (_ref5) {
	        var id = _ref5.id;
	
	        (0, _mountCodeExample2.default)(id, code[id]);
	      });
	    }
	
	    (0, _loadScript2.default)(_siteConstants.babelURL).then(mountCodeExamples, function (error) {
	      console.error('Babel failed to load.');
	
	      mountCodeExamples();
	    });
	  };
	
	  Home.prototype.render = function render() {
	    var _ref6, _ref7, _ref8, _ref9, _ref10, _ref11;
	
	    var _state2 = this.state,
	        examples = _state2.examples,
	        marketing = _state2.marketing;
	
	
	    return Glamor.createElement(
	      'div',
	      { css: { width: '100%' } },
	      Glamor.createElement(_TitleAndMetaTags2.default, {
	        title: 'React \u4E2D\u6587\u6587\u6863 - \u7528\u4E8E\u6784\u5EFA\u7528\u6237\u754C\u9762\u7684 JavaScript \u5E93',
	        ogUrl: (0, _createOgUrl2.default)('index.html')
	      }),
	      Glamor.createElement(
	        'header',
	        {
	          css: {
	            backgroundColor: _theme.colors.dark,
	            color: _theme.colors.white
	          } },
	        Glamor.createElement(
	          'div',
	          {
	            css: (_ref6 = {
	              paddingTop: 45,
	              paddingBottom: 20
	
	            }, _ref6[_theme.media.greaterThan('small')] = {
	              paddingTop: 60,
	              paddingBottom: 70
	            }, _ref6[_theme.media.greaterThan('xlarge')] = {
	              paddingTop: 95,
	              paddingBottom: 85,
	              maxWidth: 1500, // Positioning of background logo
	              marginLeft: 'auto',
	              marginRight: 'auto',
	              position: 'relative',
	              '::before': {
	                content: ' ',
	                position: 'absolute',
	                top: 0,
	                left: 0,
	                bottom: 0,
	                right: 0,
	                backgroundImage: 'url(' + _logoWhite2.default + ')',
	                backgroundRepeat: 'no-repeat',
	                backgroundPosition: '100% 100px',
	                backgroundSize: '50% auto',
	                opacity: 0.05
	              }
	            }, _ref6) },
	          Glamor.createElement(
	            'div',
	            {
	              css: {
	                // Content should be above absolutely-positioned hero image
	                position: 'relative'
	              } },
	            Glamor.createElement(
	              _Container2.default,
	              null,
	              Glamor.createElement(
	                'h1',
	                {
	                  css: (_ref7 = {
	                    color: _theme.colors.brand,
	                    textAlign: 'center',
	                    margin: 0,
	                    fontSize: 45,
	                    letterSpacing: '0.01em'
	                  }, _ref7[_theme.media.size('xsmall')] = {
	                    fontSize: 30
	                  }, _ref7[_theme.media.greaterThan('xlarge')] = {
	                    fontSize: 60
	                  }, _ref7) },
	                'React'
	              ),
	              Glamor.createElement(
	                'p',
	                {
	                  css: (_ref8 = {
	                    paddingTop: 15,
	                    textAlign: 'center',
	                    fontSize: 24,
	                    letterSpacing: '0.01em',
	                    fontWeight: 200
	
	                  }, _ref8[_theme.media.size('xsmall')] = {
	                    fontSize: 16,
	                    maxWidth: '12em',
	                    marginLeft: 'auto',
	                    marginRight: 'auto'
	                  }, _ref8[_theme.media.greaterThan('xlarge')] = {
	                    paddingTop: 20,
	                    fontSize: 30
	                  }, _ref8) },
	                '\u7528\u4E8E\u6784\u5EFA\u7528\u6237\u754C\u9762\u7684 JavaScript \u5E93'
	              ),
	              Glamor.createElement(
	                _Flex2.default,
	                {
	                  valign: 'center',
	                  css: (_ref9 = {
	                    paddingTop: 40
	
	                  }, _ref9[_theme.media.greaterThan('xlarge')] = {
	                    paddingTop: 65
	                  }, _ref9) },
	                Glamor.createElement(
	                  CtaItem,
	                  null,
	                  Glamor.createElement(
	                    _ButtonLink2.default,
	                    { to: '/docs/hello-world.html', type: 'primary' },
	                    '\u5FEB\u901F\u5F00\u59CB'
	                  )
	                ),
	                Glamor.createElement(
	                  CtaItem,
	                  null,
	                  Glamor.createElement(
	                    _ButtonLink2.default,
	                    { to: '/tutorial/tutorial.html', type: 'secondary' },
	                    '\u5165\u95E8\u6559\u7A0B'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      Glamor.createElement(
	        _Container2.default,
	        null,
	        Glamor.createElement(
	          'div',
	          { css: _theme.sharedStyles.markdown },
	          Glamor.createElement(
	            'section',
	            {
	              css: [sectionStyles, (_ref10 = {}, _ref10[_theme.media.lessThan('medium')] = {
	                marginTop: 0,
	                marginBottom: 0,
	                overflowX: 'auto',
	                paddingTop: 30,
	                WebkitOverflowScrolling: 'touch',
	                position: 'relative',
	                maskImage: 'linear-gradient(to right, transparent, white 10px, white 90%, transparent)'
	              }, _ref10)] },
	            Glamor.createElement(
	              'div',
	              {
	                css: (_ref11 = {
	                  display: 'flex',
	                  flexDirection: 'row'
	
	                }, _ref11[_theme.media.lessThan('medium')] = {
	                  display: 'block',
	                  whiteSpace: 'nowrap'
	                }, _ref11) },
	              marketing.map(function (column, index) {
	                var _firstOfType, _ref12, _;
	
	                return Glamor.createElement(
	                  'div',
	                  {
	                    key: index,
	                    css: (_ref12 = {
	                      display: 'flex',
	                      flexDirection: 'column',
	                      flex: '0 1 33%',
	                      marginLeft: 40,
	
	                      '&:first-of-type': (_firstOfType = {
	                        marginLeft: 0
	
	                      }, _firstOfType[_theme.media.lessThan('medium')] = {
	                        marginLeft: 10
	                      }, _firstOfType)
	
	                    }, _ref12[_theme.media.lessThan('medium')] = {
	                      display: 'inline-block',
	                      verticalAlign: 'top',
	                      marginLeft: 0,
	                      whiteSpace: 'normal',
	                      width: '75%',
	                      marginRight: 20,
	                      paddingBottom: 40,
	
	                      '&:first-of-type': {
	                        marginTop: 0
	                      }
	                    }, _ref12) },
	                  Glamor.createElement(
	                    'h3',
	                    {
	                      css: [headingStyles, {
	                        '&&': (_ = {
	                          // Make specificity higher than the site-wide h3 styles.
	                          color: _theme.colors.subtle,
	                          paddingTop: 0,
	                          fontWeight: 300,
	                          fontSize: 20
	
	                        }, _[_theme.media.greaterThan('xlarge')] = {
	                          fontSize: 24,
	                          fontWeight: 200
	                        }, _)
	                      }] },
	                    column.title
	                  ),
	                  Glamor.createElement('div', { dangerouslySetInnerHTML: { __html: column.content } })
	                );
	              })
	            )
	          ),
	          Glamor.createElement('hr', {
	            css: {
	              height: 1,
	              marginBottom: -1,
	              border: 'none',
	              borderBottom: '1 solid ' + _theme.colors.divider
	            }
	          }),
	          Glamor.createElement(
	            'section',
	            { css: sectionStyles },
	            Glamor.createElement(
	              'div',
	              { id: 'examples' },
	              examples.map(function (example, index) {
	                var _ref13;
	
	                return Glamor.createElement(
	                  'div',
	                  {
	                    key: index,
	                    css: (_ref13 = {
	                      marginTop: 40,
	
	                      '&:first-child': {
	                        marginTop: 0
	                      }
	
	                    }, _ref13[_theme.media.greaterThan('xlarge')] = {
	                      marginTop: 80
	                    }, _ref13) },
	                  Glamor.createElement(
	                    'h3',
	                    { css: headingStyles },
	                    example.title
	                  ),
	                  Glamor.createElement('div', { dangerouslySetInnerHTML: { __html: example.content } }),
	                  Glamor.createElement('div', { id: example.id })
	                );
	              })
	            )
	          )
	        )
	      ),
	      Glamor.createElement(
	        'section',
	        {
	          css: {
	            background: _theme.colors.dark,
	            color: _theme.colors.white,
	            paddingTop: 45,
	            paddingBottom: 45
	          } },
	        Glamor.createElement(
	          _Container2.default,
	          null,
	          Glamor.createElement(
	            _Flex2.default,
	            { valign: 'center' },
	            Glamor.createElement(
	              CtaItem,
	              null,
	              Glamor.createElement(
	                _ButtonLink2.default,
	                { to: '/docs/hello-world.html', type: 'primary' },
	                '\u5FEB\u901F\u5F00\u59CB'
	              )
	            ),
	            Glamor.createElement(
	              CtaItem,
	              null,
	              Glamor.createElement(
	                _ButtonLink2.default,
	                { to: '/tutorial/tutorial.html', type: 'secondary' },
	                '\u5165\u95E8\u6559\u7A0B'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Home;
	}(_react.Component);
	
	Home.propTypes = {
	  data: _propTypes2.default.shape({
	    code: _propTypes2.default.object.isRequired,
	    examples: _propTypes2.default.object.isRequired,
	    marketing: _propTypes2.default.object.isRequired
	  }).isRequired,
	  location: _propTypes2.default.object.isRequired
	};
	
	function renderExamplePlaceholder(containerId) {
	  _reactDom2.default.render(Glamor.createElement(
	    'h4',
	    null,
	    'Loading code example...'
	  ), document.getElementById(containerId));
	}
	
	var CtaItem = function CtaItem(_ref14) {
	  var _nthChild, _ref15;
	
	  var children = _ref14.children,
	      _ref14$primary = _ref14.primary,
	      primary = _ref14$primary === undefined ? false : _ref14$primary;
	  return Glamor.createElement(
	    'div',
	    {
	      css: (_ref15 = {
	        width: '50%'
	
	      }, _ref15[_theme.media.between('small', 'large')] = {
	        paddingLeft: 20
	      }, _ref15[_theme.media.greaterThan('xlarge')] = {
	        paddingLeft: 40
	      }, _ref15['&:first-child'] = {
	        textAlign: 'right',
	        paddingRight: 15
	      }, _ref15['&:nth-child(2)'] = (_nthChild = {}, _nthChild[_theme.media.greaterThan('small')] = {
	        paddingLeft: 15
	      }, _nthChild), _ref15) },
	    children
	  );
	};
	
	// eslint-disable-next-line no-undef
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = Home;
	
	
	var sectionStyles = (_sectionStyles = {
	  marginTop: 20,
	  marginBottom: 15
	
	}, _sectionStyles[_theme.media.greaterThan('medium')] = {
	  marginTop: 60,
	  marginBottom: 65
	}, _sectionStyles);
	
	var headingStyles = {
	  '&&': {
	    marginBottom: 20
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @emails react-core
	 */
	
	exports.default = function (url) {
	  return new Promise(function (resolve, reject) {
	    return document.head.appendChild(_extends(document.createElement('script'), {
	      async: true,
	      src: url,
	      onload: resolve,
	      onerror: reject
	    }));
	  });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _CodeEditor = __webpack_require__(168);
	
	var _CodeEditor2 = _interopRequireDefault(_CodeEditor);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(43);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO This is a huge hack.
	// Remark transform this template to split code examples and their targets apart.
	var mountCodeExample = function mountCodeExample(containerId, code) {
	  var container = document.getElementById(containerId);
	  var parent = container.parentElement;
	
	  var children = Array.prototype.filter.call(parent.children, function (child) {
	    return child !== container;
	  });
	  children.forEach(function (child) {
	    return parent.removeChild(child);
	  });
	
	  var description = children.map(function (child) {
	    return child.outerHTML;
	  }).join('').replace(/`([^`]+)`/g, '<code>$1</code>');
	
	  _reactDom2.default.render(Glamor.createElement(
	    _CodeEditor2.default,
	    { code: code },
	    Glamor.createElement('div', { dangerouslySetInnerHTML: { __html: description } })
	  ), container);
	}; /**
	    * Copyright (c) 2013-present, Facebook, Inc.
	    *
	    * @emails react-core
	    */
	
	exports.default = mountCodeExample;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-61ed1e15aee1519dbaa1.js